export const KEYS = {
    "ACCOUNT": {
        "ACCOUNT_ALREADY_EXISTS": "ACCOUNT.ACCOUNT_ALREADY_EXISTS" as "ACCOUNT.ACCOUNT_ALREADY_EXISTS",
        "CREATE_ACCOUNT": "ACCOUNT.CREATE_ACCOUNT" as "ACCOUNT.CREATE_ACCOUNT",
        "DETAILS": {
            "ACCOUNT_DETAILS_UPDATED": "ACCOUNT.DETAILS.ACCOUNT_DETAILS_UPDATED" as "ACCOUNT.DETAILS.ACCOUNT_DETAILS_UPDATED",
            "ADDRESS_LINE_ONE": "ACCOUNT.DETAILS.ADDRESS_LINE_ONE" as "ACCOUNT.DETAILS.ADDRESS_LINE_ONE",
            "ADDRESS_LINE_THREE": "ACCOUNT.DETAILS.ADDRESS_LINE_THREE" as "ACCOUNT.DETAILS.ADDRESS_LINE_THREE",
            "ADDRESS_LINE_TWO": "ACCOUNT.DETAILS.ADDRESS_LINE_TWO" as "ACCOUNT.DETAILS.ADDRESS_LINE_TWO",
            "ATTENTION_TO": "ACCOUNT.DETAILS.ATTENTION_TO" as "ACCOUNT.DETAILS.ATTENTION_TO",
            "BILLING_DETAILS": "ACCOUNT.DETAILS.BILLING_DETAILS" as "ACCOUNT.DETAILS.BILLING_DETAILS",
            "COMPANY_NAME": "ACCOUNT.DETAILS.COMPANY_NAME" as "ACCOUNT.DETAILS.COMPANY_NAME",
            "CONTACT_DETAILS": "ACCOUNT.DETAILS.CONTACT_DETAILS" as "ACCOUNT.DETAILS.CONTACT_DETAILS",
            "COUNTRY": "ACCOUNT.DETAILS.COUNTRY" as "ACCOUNT.DETAILS.COUNTRY",
            "DISPLAY_ADDRESS": "ACCOUNT.DETAILS.DISPLAY_ADDRESS" as "ACCOUNT.DETAILS.DISPLAY_ADDRESS",
            "FAILED_TO_UPDATE_ACCOUNT_DETAILS": "ACCOUNT.DETAILS.FAILED_TO_UPDATE_ACCOUNT_DETAILS" as "ACCOUNT.DETAILS.FAILED_TO_UPDATE_ACCOUNT_DETAILS",
            "IMAGE_MUST_BE_SQUARE_AND_AT_LEAST_MINIMUM_SIZE": "ACCOUNT.DETAILS.IMAGE_MUST_BE_SQUARE_AND_AT_LEAST_MINIMUM_SIZE" as "ACCOUNT.DETAILS.IMAGE_MUST_BE_SQUARE_AND_AT_LEAST_MINIMUM_SIZE",
            "LOCATION_DETAILS": "ACCOUNT.DETAILS.LOCATION_DETAILS" as "ACCOUNT.DETAILS.LOCATION_DETAILS",
            "LOCATION_DETAILS_SAVED": "ACCOUNT.DETAILS.LOCATION_DETAILS_SAVED" as "ACCOUNT.DETAILS.LOCATION_DETAILS_SAVED",
            "LOCATION_EMAIL": "ACCOUNT.DETAILS.LOCATION_EMAIL" as "ACCOUNT.DETAILS.LOCATION_EMAIL",
            "LOCATION_LOGO": "ACCOUNT.DETAILS.LOCATION_LOGO" as "ACCOUNT.DETAILS.LOCATION_LOGO",
            "LOCATION_PHONE_NUMBER": "ACCOUNT.DETAILS.LOCATION_PHONE_NUMBER" as "ACCOUNT.DETAILS.LOCATION_PHONE_NUMBER",
            "MINIMUM_IMAGE_DIMENSION_REQUIREMENT": "ACCOUNT.DETAILS.MINIMUM_IMAGE_DIMENSION_REQUIREMENT" as "ACCOUNT.DETAILS.MINIMUM_IMAGE_DIMENSION_REQUIREMENT",
            "NOTES": "ACCOUNT.DETAILS.NOTES" as "ACCOUNT.DETAILS.NOTES",
            "PHONE": "ACCOUNT.DETAILS.PHONE" as "ACCOUNT.DETAILS.PHONE",
            "POSTCODE": "ACCOUNT.DETAILS.POSTCODE" as "ACCOUNT.DETAILS.POSTCODE",
            "PREFERRED_MEETING_TIMES": "ACCOUNT.DETAILS.PREFERRED_MEETING_TIMES" as "ACCOUNT.DETAILS.PREFERRED_MEETING_TIMES",
            "SAME_AS_CONTACT_DETAILS": "ACCOUNT.DETAILS.SAME_AS_CONTACT_DETAILS" as "ACCOUNT.DETAILS.SAME_AS_CONTACT_DETAILS",
            "SHIPPING_ADDRESS": "ACCOUNT.DETAILS.SHIPPING_ADDRESS" as "ACCOUNT.DETAILS.SHIPPING_ADDRESS",
            "SQUARE_ASPECT_RATIO_REQUIRED": "ACCOUNT.DETAILS.SQUARE_ASPECT_RATIO_REQUIRED" as "ACCOUNT.DETAILS.SQUARE_ASPECT_RATIO_REQUIRED",
            "STATE": "ACCOUNT.DETAILS.STATE" as "ACCOUNT.DETAILS.STATE",
            "SUBURB": "ACCOUNT.DETAILS.SUBURB" as "ACCOUNT.DETAILS.SUBURB",
            "WEBSITE_URL": "ACCOUNT.DETAILS.WEBSITE_URL" as "ACCOUNT.DETAILS.WEBSITE_URL"
        },
        "LOCATION_DETAILS": {
            "CREATE_MAP_LOCATION": "ACCOUNT.LOCATION_DETAILS.CREATE_MAP_LOCATION" as "ACCOUNT.LOCATION_DETAILS.CREATE_MAP_LOCATION",
            "GET_LOCATION_DETAILS": "ACCOUNT.LOCATION_DETAILS.GET_LOCATION_DETAILS" as "ACCOUNT.LOCATION_DETAILS.GET_LOCATION_DETAILS",
            "REMOVE_LOCATION_MAP": "ACCOUNT.LOCATION_DETAILS.REMOVE_LOCATION_MAP" as "ACCOUNT.LOCATION_DETAILS.REMOVE_LOCATION_MAP",
            "SHIPPING_DETAILS_UPDATED": "ACCOUNT.LOCATION_DETAILS.SHIPPING_DETAILS_UPDATED" as "ACCOUNT.LOCATION_DETAILS.SHIPPING_DETAILS_UPDATED",
            "START_MAP_PAYMENT": "ACCOUNT.LOCATION_DETAILS.START_MAP_PAYMENT" as "ACCOUNT.LOCATION_DETAILS.START_MAP_PAYMENT",
            "UPDATE_LOCATION_DETAILS": "ACCOUNT.LOCATION_DETAILS.UPDATE_LOCATION_DETAILS" as "ACCOUNT.LOCATION_DETAILS.UPDATE_LOCATION_DETAILS",
            "UPDATE_SHIPPING_DETAILS": "ACCOUNT.LOCATION_DETAILS.UPDATE_SHIPPING_DETAILS" as "ACCOUNT.LOCATION_DETAILS.UPDATE_SHIPPING_DETAILS"
        },
        "MAP": {
            "CONFIRM_PAYMENT_DETAILS": "ACCOUNT.MAP.CONFIRM_PAYMENT_DETAILS" as "ACCOUNT.MAP.CONFIRM_PAYMENT_DETAILS",
            "CREATE_NEW_MAP": "ACCOUNT.MAP.CREATE_NEW_MAP" as "ACCOUNT.MAP.CREATE_NEW_MAP",
            "CREATE_NEW_MAP_FOR": "ACCOUNT.MAP.CREATE_NEW_MAP_FOR" as "ACCOUNT.MAP.CREATE_NEW_MAP_FOR",
            "EDIT_MAP": "ACCOUNT.MAP.EDIT_MAP" as "ACCOUNT.MAP.EDIT_MAP",
            "GET_MAP_SERVICE_COST": "ACCOUNT.MAP.GET_MAP_SERVICE_COST" as "ACCOUNT.MAP.GET_MAP_SERVICE_COST",
            "MAP_GENERATION_FAILED": "ACCOUNT.MAP.MAP_GENERATION_FAILED" as "ACCOUNT.MAP.MAP_GENERATION_FAILED",
            "MAP_GENERATION_INPROGRESS": "ACCOUNT.MAP.MAP_GENERATION_INPROGRESS" as "ACCOUNT.MAP.MAP_GENERATION_INPROGRESS",
            "PAYMENT_INFORMATION": {
                "PART_1": "ACCOUNT.MAP.PAYMENT_INFORMATION.PART_1" as "ACCOUNT.MAP.PAYMENT_INFORMATION.PART_1",
                "PART_2": "ACCOUNT.MAP.PAYMENT_INFORMATION.PART_2" as "ACCOUNT.MAP.PAYMENT_INFORMATION.PART_2"
            },
            "PROBLEM_RETRIEVING_COST": "ACCOUNT.MAP.PROBLEM_RETRIEVING_COST" as "ACCOUNT.MAP.PROBLEM_RETRIEVING_COST",
            "SEARCH_FOR_ADDRESS": "ACCOUNT.MAP.SEARCH_FOR_ADDRESS" as "ACCOUNT.MAP.SEARCH_FOR_ADDRESS",
            "UNSUPPORTED_CURRENCY": "ACCOUNT.MAP.UNSUPPORTED_CURRENCY" as "ACCOUNT.MAP.UNSUPPORTED_CURRENCY"
        },
        "NOTIFY_UNAUTHENTICATED": "ACCOUNT.NOTIFY_UNAUTHENTICATED" as "ACCOUNT.NOTIFY_UNAUTHENTICATED",
        "NOTIFY_UNAUTHORIZED": "ACCOUNT.NOTIFY_UNAUTHORIZED" as "ACCOUNT.NOTIFY_UNAUTHORIZED"
    },
    "ADMIN": {
        "BANNER": {
            "BANNER_MESSAGE": "ADMIN.BANNER.BANNER_MESSAGE" as "ADMIN.BANNER.BANNER_MESSAGE",
            "BANNER_NOTIFICATION": "ADMIN.BANNER.BANNER_NOTIFICATION" as "ADMIN.BANNER.BANNER_NOTIFICATION",
            "CREATE_BANNER_NOTIFICATION": "ADMIN.BANNER.CREATE_BANNER_NOTIFICATION" as "ADMIN.BANNER.CREATE_BANNER_NOTIFICATION",
            "DELETE_CURRENT_BANNER_NOTIFICATION": "ADMIN.BANNER.DELETE_CURRENT_BANNER_NOTIFICATION" as "ADMIN.BANNER.DELETE_CURRENT_BANNER_NOTIFICATION",
            "DISMISSABLE": "ADMIN.BANNER.DISMISSABLE" as "ADMIN.BANNER.DISMISSABLE",
            "GET_CURRENT_BANNER_NOTIFICATION": "ADMIN.BANNER.GET_CURRENT_BANNER_NOTIFICATION" as "ADMIN.BANNER.GET_CURRENT_BANNER_NOTIFICATION",
            "NOTIFICATION_TYPE": "ADMIN.BANNER.NOTIFICATION_TYPE" as "ADMIN.BANNER.NOTIFICATION_TYPE",
            "NOTIFY_CREATED": "ADMIN.BANNER.NOTIFY_CREATED" as "ADMIN.BANNER.NOTIFY_CREATED",
            "NOTIFY_DELETED": "ADMIN.BANNER.NOTIFY_DELETED" as "ADMIN.BANNER.NOTIFY_DELETED",
            "TIP": "ADMIN.BANNER.TIP" as "ADMIN.BANNER.TIP"
        },
        "BRANDS": {
            "ASSIGN": "ADMIN.BRANDS.ASSIGN" as "ADMIN.BRANDS.ASSIGN",
            "ASSIGN_BRAND": "ADMIN.BRANDS.ASSIGN_BRAND" as "ADMIN.BRANDS.ASSIGN_BRAND",
            "ASSIGN_CLIENTS": "ADMIN.BRANDS.ASSIGN_CLIENTS" as "ADMIN.BRANDS.ASSIGN_CLIENTS",
            "ASSIGN_CLIENTS_TO": "ADMIN.BRANDS.ASSIGN_CLIENTS_TO" as "ADMIN.BRANDS.ASSIGN_CLIENTS_TO",
            "BRAND": "ADMIN.BRANDS.BRAND" as "ADMIN.BRANDS.BRAND",
            "BRANDS": "ADMIN.BRANDS.BRANDS" as "ADMIN.BRANDS.BRANDS",
            "BRAND_COLOR": "ADMIN.BRANDS.BRAND_COLOR" as "ADMIN.BRANDS.BRAND_COLOR",
            "BRAND_NAME": "ADMIN.BRANDS.BRAND_NAME" as "ADMIN.BRANDS.BRAND_NAME",
            "CANNOT_ASSIGN_CLIENT_IF": "ADMIN.BRANDS.CANNOT_ASSIGN_CLIENT_IF" as "ADMIN.BRANDS.CANNOT_ASSIGN_CLIENT_IF",
            "CHECK_CLIENTS_TO_ASSIGN_TO": "ADMIN.BRANDS.CHECK_CLIENTS_TO_ASSIGN_TO" as "ADMIN.BRANDS.CHECK_CLIENTS_TO_ASSIGN_TO",
            "FILTER_BRANDS": "ADMIN.BRANDS.FILTER_BRANDS" as "ADMIN.BRANDS.FILTER_BRANDS",
            "FILTER_CLIENTS": "ADMIN.BRANDS.FILTER_CLIENTS" as "ADMIN.BRANDS.FILTER_CLIENTS",
            "NEW_BRAND": "ADMIN.BRANDS.NEW_BRAND" as "ADMIN.BRANDS.NEW_BRAND",
            "PLEASE_ENTER_NAME_COLOR_LOGO": "ADMIN.BRANDS.PLEASE_ENTER_NAME_COLOR_LOGO" as "ADMIN.BRANDS.PLEASE_ENTER_NAME_COLOR_LOGO",
            "THIS_WILL_PERMANENTLY_DELETE": "ADMIN.BRANDS.THIS_WILL_PERMANENTLY_DELETE" as "ADMIN.BRANDS.THIS_WILL_PERMANENTLY_DELETE",
            "UPDATE_BRAND": "ADMIN.BRANDS.UPDATE_BRAND" as "ADMIN.BRANDS.UPDATE_BRAND",
            "UPLOAD_LOGO": "ADMIN.BRANDS.UPLOAD_LOGO" as "ADMIN.BRANDS.UPLOAD_LOGO",
            "YOU_CAN_ASSIGN_CLIENTS_FROM": "ADMIN.BRANDS.YOU_CAN_ASSIGN_CLIENTS_FROM" as "ADMIN.BRANDS.YOU_CAN_ASSIGN_CLIENTS_FROM"
        },
        "CLUBREADY_CONNECT": {
            "ACTION": "ADMIN.CLUBREADY_CONNECT.ACTION" as "ADMIN.CLUBREADY_CONNECT.ACTION",
            "CHAIN_ID_CONFIGURATION_TITLE": "ADMIN.CLUBREADY_CONNECT.CHAIN_ID_CONFIGURATION_TITLE" as "ADMIN.CLUBREADY_CONNECT.CHAIN_ID_CONFIGURATION_TITLE",
            "CLIENT_TITLE": "ADMIN.CLUBREADY_CONNECT.CLIENT_TITLE" as "ADMIN.CLUBREADY_CONNECT.CLIENT_TITLE",
            "CLUBREADY_DISABLED_FOR_CLIENT_HELP_TEXT": "ADMIN.CLUBREADY_CONNECT.CLUBREADY_DISABLED_FOR_CLIENT_HELP_TEXT" as "ADMIN.CLUBREADY_CONNECT.CLUBREADY_DISABLED_FOR_CLIENT_HELP_TEXT",
            "FILTER_CLIENTS": "ADMIN.CLUBREADY_CONNECT.FILTER_CLIENTS" as "ADMIN.CLUBREADY_CONNECT.FILTER_CLIENTS",
            "NO_INTEGRATION_FOUND_FOR_CLIENT": "ADMIN.CLUBREADY_CONNECT.NO_INTEGRATION_FOUND_FOR_CLIENT" as "ADMIN.CLUBREADY_CONNECT.NO_INTEGRATION_FOUND_FOR_CLIENT"
        },
        "EXTERNAL_AUTH_APPS": {
            "API_KEY": "ADMIN.EXTERNAL_AUTH_APPS.API_KEY" as "ADMIN.EXTERNAL_AUTH_APPS.API_KEY",
            "APP_NAME": "ADMIN.EXTERNAL_AUTH_APPS.APP_NAME" as "ADMIN.EXTERNAL_AUTH_APPS.APP_NAME",
            "CONFIRM_DELETE": "ADMIN.EXTERNAL_AUTH_APPS.CONFIRM_DELETE" as "ADMIN.EXTERNAL_AUTH_APPS.CONFIRM_DELETE",
            "CONNECTIONS": "ADMIN.EXTERNAL_AUTH_APPS.CONNECTIONS" as "ADMIN.EXTERNAL_AUTH_APPS.CONNECTIONS",
            "CONTACT_EMAIL": "ADMIN.EXTERNAL_AUTH_APPS.CONTACT_EMAIL" as "ADMIN.EXTERNAL_AUTH_APPS.CONTACT_EMAIL",
            "CREATE_AUTH_APP": "ADMIN.EXTERNAL_AUTH_APPS.CREATE_AUTH_APP" as "ADMIN.EXTERNAL_AUTH_APPS.CREATE_AUTH_APP",
            "DELETE_APP": "ADMIN.EXTERNAL_AUTH_APPS.DELETE_APP" as "ADMIN.EXTERNAL_AUTH_APPS.DELETE_APP",
            "DELETE_APP_DISCLAIMER": "ADMIN.EXTERNAL_AUTH_APPS.DELETE_APP_DISCLAIMER" as "ADMIN.EXTERNAL_AUTH_APPS.DELETE_APP_DISCLAIMER",
            "DELETE_CONNECTION": "ADMIN.EXTERNAL_AUTH_APPS.DELETE_CONNECTION" as "ADMIN.EXTERNAL_AUTH_APPS.DELETE_CONNECTION",
            "DETAILS": {
                "DS_USER": "ADMIN.EXTERNAL_AUTH_APPS.DETAILS.DS_USER" as "ADMIN.EXTERNAL_AUTH_APPS.DETAILS.DS_USER",
                "EXTERNAL_USER_IDENTIFIER": "ADMIN.EXTERNAL_AUTH_APPS.DETAILS.EXTERNAL_USER_IDENTIFIER" as "ADMIN.EXTERNAL_AUTH_APPS.DETAILS.EXTERNAL_USER_IDENTIFIER",
                "NO_APP_CONNECTIONS": "ADMIN.EXTERNAL_AUTH_APPS.DETAILS.NO_APP_CONNECTIONS" as "ADMIN.EXTERNAL_AUTH_APPS.DETAILS.NO_APP_CONNECTIONS"
            },
            "SECRET": "ADMIN.EXTERNAL_AUTH_APPS.SECRET" as "ADMIN.EXTERNAL_AUTH_APPS.SECRET",
            "SECRET_EDIT_WARNING": "ADMIN.EXTERNAL_AUTH_APPS.SECRET_EDIT_WARNING" as "ADMIN.EXTERNAL_AUTH_APPS.SECRET_EDIT_WARNING",
            "SECRET_TOOLTIP": "ADMIN.EXTERNAL_AUTH_APPS.SECRET_TOOLTIP" as "ADMIN.EXTERNAL_AUTH_APPS.SECRET_TOOLTIP",
            "TITLE": "ADMIN.EXTERNAL_AUTH_APPS.TITLE" as "ADMIN.EXTERNAL_AUTH_APPS.TITLE",
            "TOKEN_ENDPOINT": "ADMIN.EXTERNAL_AUTH_APPS.TOKEN_ENDPOINT" as "ADMIN.EXTERNAL_AUTH_APPS.TOKEN_ENDPOINT",
            "TOKEN_ENDPOINT_TOOLTIP": "ADMIN.EXTERNAL_AUTH_APPS.TOKEN_ENDPOINT_TOOLTIP" as "ADMIN.EXTERNAL_AUTH_APPS.TOKEN_ENDPOINT_TOOLTIP",
            "UPDATE_AUTH_APP": "ADMIN.EXTERNAL_AUTH_APPS.UPDATE_AUTH_APP" as "ADMIN.EXTERNAL_AUTH_APPS.UPDATE_AUTH_APP"
        },
        "MAINTENANCE": {
            "DATE": "ADMIN.MAINTENANCE.DATE" as "ADMIN.MAINTENANCE.DATE",
            "EXPECTED_DOWNTIME": "ADMIN.MAINTENANCE.EXPECTED_DOWNTIME" as "ADMIN.MAINTENANCE.EXPECTED_DOWNTIME",
            "EXPECTED_DOWNTIME_MUST_BE_AT_LEAST_ZERO": "ADMIN.MAINTENANCE.EXPECTED_DOWNTIME_MUST_BE_AT_LEAST_ZERO" as "ADMIN.MAINTENANCE.EXPECTED_DOWNTIME_MUST_BE_AT_LEAST_ZERO",
            "MAINTENANCE_WINDOW": "ADMIN.MAINTENANCE.MAINTENANCE_WINDOW" as "ADMIN.MAINTENANCE.MAINTENANCE_WINDOW",
            "MINUTES": "ADMIN.MAINTENANCE.MINUTES" as "ADMIN.MAINTENANCE.MINUTES",
            "NOTIFY_MAINTENANCE_REMOVED": "ADMIN.MAINTENANCE.NOTIFY_MAINTENANCE_REMOVED" as "ADMIN.MAINTENANCE.NOTIFY_MAINTENANCE_REMOVED",
            "NOTIFY_MAINTENANCE_UPDATED": "ADMIN.MAINTENANCE.NOTIFY_MAINTENANCE_UPDATED" as "ADMIN.MAINTENANCE.NOTIFY_MAINTENANCE_UPDATED",
            "REMOVE_MAINTENANCE_CONFIRM": "ADMIN.MAINTENANCE.REMOVE_MAINTENANCE_CONFIRM" as "ADMIN.MAINTENANCE.REMOVE_MAINTENANCE_CONFIRM",
            "START_DATE_IS_REQUIRED": "ADMIN.MAINTENANCE.START_DATE_IS_REQUIRED" as "ADMIN.MAINTENANCE.START_DATE_IS_REQUIRED",
            "START_DATE_MUST_BE_IN_THE_FUTURE": "ADMIN.MAINTENANCE.START_DATE_MUST_BE_IN_THE_FUTURE" as "ADMIN.MAINTENANCE.START_DATE_MUST_BE_IN_THE_FUTURE",
            "START_TIME": "ADMIN.MAINTENANCE.START_TIME" as "ADMIN.MAINTENANCE.START_TIME",
            "START_TIME_MUST_BE_IN_THE_FUTURE": "ADMIN.MAINTENANCE.START_TIME_MUST_BE_IN_THE_FUTURE" as "ADMIN.MAINTENANCE.START_TIME_MUST_BE_IN_THE_FUTURE"
        },
        "MAPS_REPORT": {
            "AMOUNT_PAID": "ADMIN.MAPS_REPORT.AMOUNT_PAID" as "ADMIN.MAPS_REPORT.AMOUNT_PAID",
            "CLIENT_NAME": "ADMIN.MAPS_REPORT.CLIENT_NAME" as "ADMIN.MAPS_REPORT.CLIENT_NAME",
            "HEADING": "ADMIN.MAPS_REPORT.HEADING" as "ADMIN.MAPS_REPORT.HEADING",
            "LOCATION_NAME": "ADMIN.MAPS_REPORT.LOCATION_NAME" as "ADMIN.MAPS_REPORT.LOCATION_NAME",
            "PURCHASED_DATE": "ADMIN.MAPS_REPORT.PURCHASED_DATE" as "ADMIN.MAPS_REPORT.PURCHASED_DATE"
        },
        "NAV": {
            "AGENCIES": "ADMIN.NAV.AGENCIES" as "ADMIN.NAV.AGENCIES",
            "AUTHENTICATION_APPS": "ADMIN.NAV.AUTHENTICATION_APPS" as "ADMIN.NAV.AUTHENTICATION_APPS",
            "BANNER_NOTIFICATION": "ADMIN.NAV.BANNER_NOTIFICATION" as "ADMIN.NAV.BANNER_NOTIFICATION",
            "BRANDS": "ADMIN.NAV.BRANDS" as "ADMIN.NAV.BRANDS",
            "CALENDAR_ITEMS": "ADMIN.NAV.CALENDAR_ITEMS" as "ADMIN.NAV.CALENDAR_ITEMS",
            "CLUBREADY_CONNECT": "ADMIN.NAV.CLUBREADY_CONNECT" as "ADMIN.NAV.CLUBREADY_CONNECT",
            "MAPS_REPORT": "ADMIN.NAV.MAPS_REPORT" as "ADMIN.NAV.MAPS_REPORT",
            "PAYABLE_SERVICES": "ADMIN.NAV.PAYABLE_SERVICES" as "ADMIN.NAV.PAYABLE_SERVICES",
            "PLATFORMS": "ADMIN.NAV.PLATFORMS" as "ADMIN.NAV.PLATFORMS",
            "SERVICING": "ADMIN.NAV.SERVICING" as "ADMIN.NAV.SERVICING",
            "SITE_MAINTENANCE": "ADMIN.NAV.SITE_MAINTENANCE" as "ADMIN.NAV.SITE_MAINTENANCE",
            "SUBSCRIPTIONS": "ADMIN.NAV.SUBSCRIPTIONS" as "ADMIN.NAV.SUBSCRIPTIONS",
            "TASKS": "ADMIN.NAV.TASKS" as "ADMIN.NAV.TASKS",
            "TEMPLATE_PREVIEWS": "ADMIN.NAV.TEMPLATE_PREVIEWS" as "ADMIN.NAV.TEMPLATE_PREVIEWS"
        },
        "NOTIFY_GENERATE_LOCATION_MAP_STARTED": "ADMIN.NOTIFY_GENERATE_LOCATION_MAP_STARTED" as "ADMIN.NOTIFY_GENERATE_LOCATION_MAP_STARTED",
        "NOTIFY_PURGE_SESSIONS_STARTED": "ADMIN.NOTIFY_PURGE_SESSIONS_STARTED" as "ADMIN.NOTIFY_PURGE_SESSIONS_STARTED",
        "NOTIFY_TEST_IN_APP_NOTIFICATIONS_STARTED": "ADMIN.NOTIFY_TEST_IN_APP_NOTIFICATIONS_STARTED" as "ADMIN.NOTIFY_TEST_IN_APP_NOTIFICATIONS_STARTED",
        "NOTIFY_THUMBNAIL_GENERATION_STARTED": "ADMIN.NOTIFY_THUMBNAIL_GENERATION_STARTED" as "ADMIN.NOTIFY_THUMBNAIL_GENERATION_STARTED",
        "PAYABLE_SERVICE": {
            "CONFIRM_DELETE_COST": "ADMIN.PAYABLE_SERVICE.CONFIRM_DELETE_COST" as "ADMIN.PAYABLE_SERVICE.CONFIRM_DELETE_COST",
            "COST_INVALID_PRECISION": "ADMIN.PAYABLE_SERVICE.COST_INVALID_PRECISION" as "ADMIN.PAYABLE_SERVICE.COST_INVALID_PRECISION",
            "COST_MUST_BE_POSITIVE": "ADMIN.PAYABLE_SERVICE.COST_MUST_BE_POSITIVE" as "ADMIN.PAYABLE_SERVICE.COST_MUST_BE_POSITIVE",
            "CREATE_SERVICE_COST": "ADMIN.PAYABLE_SERVICE.CREATE_SERVICE_COST" as "ADMIN.PAYABLE_SERVICE.CREATE_SERVICE_COST",
            "DELETE_SERVICE_COST": "ADMIN.PAYABLE_SERVICE.DELETE_SERVICE_COST" as "ADMIN.PAYABLE_SERVICE.DELETE_SERVICE_COST",
            "NOTIFY_SERVICE_COSTS_UPDATED": "ADMIN.PAYABLE_SERVICE.NOTIFY_SERVICE_COSTS_UPDATED" as "ADMIN.PAYABLE_SERVICE.NOTIFY_SERVICE_COSTS_UPDATED",
            "UPDATE_SERVICE_COST": "ADMIN.PAYABLE_SERVICE.UPDATE_SERVICE_COST" as "ADMIN.PAYABLE_SERVICE.UPDATE_SERVICE_COST"
        },
        "SERVICING": {
            "BLOCKED_PUBLISHES": {
                "SUBTITLE": "ADMIN.SERVICING.BLOCKED_PUBLISHES.SUBTITLE" as "ADMIN.SERVICING.BLOCKED_PUBLISHES.SUBTITLE",
                "TABLE": {
                    "ACTIONS": {
                        "MARK_FAILED": "ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.ACTIONS.MARK_FAILED" as "ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.ACTIONS.MARK_FAILED",
                        "MARK_SUCCESSFUL": "ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.ACTIONS.MARK_SUCCESSFUL" as "ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.ACTIONS.MARK_SUCCESSFUL",
                        "RETRY_NOW": "ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.ACTIONS.RETRY_NOW" as "ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.ACTIONS.RETRY_NOW"
                    },
                    "CONTENT_LABELS": {
                        "EMAIL_HTML": "ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.CONTENT_LABELS.EMAIL_HTML" as "ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.CONTENT_LABELS.EMAIL_HTML",
                        "RECIPIENTS": "ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.CONTENT_LABELS.RECIPIENTS" as "ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.CONTENT_LABELS.RECIPIENTS",
                        "SUBJECT": "ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.CONTENT_LABELS.SUBJECT" as "ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.CONTENT_LABELS.SUBJECT",
                        "TEMPLATE": "ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.CONTENT_LABELS.TEMPLATE" as "ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.CONTENT_LABELS.TEMPLATE"
                    },
                    "HEADERS": {
                        "CONTENT": "ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.HEADERS.CONTENT" as "ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.HEADERS.CONTENT",
                        "SCHEDULED_FOR": "ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.HEADERS.SCHEDULED_FOR" as "ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.HEADERS.SCHEDULED_FOR",
                        "UPDATED_AT": "ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.HEADERS.UPDATED_AT" as "ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.HEADERS.UPDATED_AT"
                    },
                    "NOT_FOUND_MESSAGE": "ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.NOT_FOUND_MESSAGE" as "ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.NOT_FOUND_MESSAGE"
                },
                "TITLE": "ADMIN.SERVICING.BLOCKED_PUBLISHES.TITLE" as "ADMIN.SERVICING.BLOCKED_PUBLISHES.TITLE"
            },
            "FAILED_PUBLISHES": {
                "SUBTITLE": "ADMIN.SERVICING.FAILED_PUBLISHES.SUBTITLE" as "ADMIN.SERVICING.FAILED_PUBLISHES.SUBTITLE",
                "TABLE": {
                    "CONTENT_LABELS": {
                        "EMAIL_HTML": "ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.CONTENT_LABELS.EMAIL_HTML" as "ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.CONTENT_LABELS.EMAIL_HTML",
                        "RECIPIENTS": "ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.CONTENT_LABELS.RECIPIENTS" as "ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.CONTENT_LABELS.RECIPIENTS",
                        "SUBJECT": "ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.CONTENT_LABELS.SUBJECT" as "ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.CONTENT_LABELS.SUBJECT",
                        "TEMPLATE": "ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.CONTENT_LABELS.TEMPLATE" as "ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.CONTENT_LABELS.TEMPLATE"
                    },
                    "HEADERS": {
                        "CONTENT": "ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.HEADERS.CONTENT" as "ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.HEADERS.CONTENT",
                        "FAILED_AT": "ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.HEADERS.FAILED_AT" as "ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.HEADERS.FAILED_AT",
                        "SCHEDULED_FOR": "ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.HEADERS.SCHEDULED_FOR" as "ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.HEADERS.SCHEDULED_FOR"
                    },
                    "NOT_FOUND_MESSAGE": "ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.NOT_FOUND_MESSAGE" as "ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.NOT_FOUND_MESSAGE"
                },
                "TITLE": "ADMIN.SERVICING.FAILED_PUBLISHES.TITLE" as "ADMIN.SERVICING.FAILED_PUBLISHES.TITLE"
            }
        },
        "SUBSCRIPTIONS": {
            "CLIENT_SUBSCRIPTION": "ADMIN.SUBSCRIPTIONS.CLIENT_SUBSCRIPTION" as "ADMIN.SUBSCRIPTIONS.CLIENT_SUBSCRIPTION",
            "DEFAULT_SUBSCRIPTION": "ADMIN.SUBSCRIPTIONS.DEFAULT_SUBSCRIPTION" as "ADMIN.SUBSCRIPTIONS.DEFAULT_SUBSCRIPTION",
            "DEFAULT_SUBSCRIPTION_UPDATED": "ADMIN.SUBSCRIPTIONS.DEFAULT_SUBSCRIPTION_UPDATED" as "ADMIN.SUBSCRIPTIONS.DEFAULT_SUBSCRIPTION_UPDATED",
            "DEFAULT_SUB_FOR": "ADMIN.SUBSCRIPTIONS.DEFAULT_SUB_FOR" as "ADMIN.SUBSCRIPTIONS.DEFAULT_SUB_FOR",
            "DELETE_RECURRING_CONFIRM": "ADMIN.SUBSCRIPTIONS.DELETE_RECURRING_CONFIRM" as "ADMIN.SUBSCRIPTIONS.DELETE_RECURRING_CONFIRM",
            "LOCATION": {
                "CAN_BE_USED_TO_CANCEL": "ADMIN.SUBSCRIPTIONS.LOCATION.CAN_BE_USED_TO_CANCEL" as "ADMIN.SUBSCRIPTIONS.LOCATION.CAN_BE_USED_TO_CANCEL",
                "DATE_GAP": "ADMIN.SUBSCRIPTIONS.LOCATION.DATE_GAP" as "ADMIN.SUBSCRIPTIONS.LOCATION.DATE_GAP",
                "END_DATE_IS_EXCLUSIVE": "ADMIN.SUBSCRIPTIONS.LOCATION.END_DATE_IS_EXCLUSIVE" as "ADMIN.SUBSCRIPTIONS.LOCATION.END_DATE_IS_EXCLUSIVE",
                "FUTURE": "ADMIN.SUBSCRIPTIONS.LOCATION.FUTURE" as "ADMIN.SUBSCRIPTIONS.LOCATION.FUTURE",
                "INACTIVE": "ADMIN.SUBSCRIPTIONS.LOCATION.INACTIVE" as "ADMIN.SUBSCRIPTIONS.LOCATION.INACTIVE",
                "INACTIVE_SUBSCRIPTION": "ADMIN.SUBSCRIPTIONS.LOCATION.INACTIVE_SUBSCRIPTION" as "ADMIN.SUBSCRIPTIONS.LOCATION.INACTIVE_SUBSCRIPTION",
                "INITIAL_SUBSCRIPTION_FOR": "ADMIN.SUBSCRIPTIONS.LOCATION.INITIAL_SUBSCRIPTION_FOR" as "ADMIN.SUBSCRIPTIONS.LOCATION.INITIAL_SUBSCRIPTION_FOR",
                "LEAVE_IT_BLANK": "ADMIN.SUBSCRIPTIONS.LOCATION.LEAVE_IT_BLANK" as "ADMIN.SUBSCRIPTIONS.LOCATION.LEAVE_IT_BLANK",
                "LEGEND": "ADMIN.SUBSCRIPTIONS.LOCATION.LEGEND" as "ADMIN.SUBSCRIPTIONS.LOCATION.LEGEND",
                "LOCATION_SUBSCRIPTION": "ADMIN.SUBSCRIPTIONS.LOCATION.LOCATION_SUBSCRIPTION" as "ADMIN.SUBSCRIPTIONS.LOCATION.LOCATION_SUBSCRIPTION",
                "LOCATION_SUBSCRIPTION_RECURRING": "ADMIN.SUBSCRIPTIONS.LOCATION.LOCATION_SUBSCRIPTION_RECURRING" as "ADMIN.SUBSCRIPTIONS.LOCATION.LOCATION_SUBSCRIPTION_RECURRING",
                "NEXT": "ADMIN.SUBSCRIPTIONS.LOCATION.NEXT" as "ADMIN.SUBSCRIPTIONS.LOCATION.NEXT",
                "NOTIFY_RECURRING_PAYMENT_DELETED": "ADMIN.SUBSCRIPTIONS.LOCATION.NOTIFY_RECURRING_PAYMENT_DELETED" as "ADMIN.SUBSCRIPTIONS.LOCATION.NOTIFY_RECURRING_PAYMENT_DELETED",
                "NO_RECURRING_PAYMENTS": "ADMIN.SUBSCRIPTIONS.LOCATION.NO_RECURRING_PAYMENTS" as "ADMIN.SUBSCRIPTIONS.LOCATION.NO_RECURRING_PAYMENTS",
                "RECURRING_PAYMENT": "ADMIN.SUBSCRIPTIONS.LOCATION.RECURRING_PAYMENT" as "ADMIN.SUBSCRIPTIONS.LOCATION.RECURRING_PAYMENT",
                "RECURRING_PAYMENT_SCHEDULE": "ADMIN.SUBSCRIPTIONS.LOCATION.RECURRING_PAYMENT_SCHEDULE" as "ADMIN.SUBSCRIPTIONS.LOCATION.RECURRING_PAYMENT_SCHEDULE",
                "SAVE_RECURRING_PAYMENT": "ADMIN.SUBSCRIPTIONS.LOCATION.SAVE_RECURRING_PAYMENT" as "ADMIN.SUBSCRIPTIONS.LOCATION.SAVE_RECURRING_PAYMENT",
                "SUBSCRIPTION_UPDATED": "ADMIN.SUBSCRIPTIONS.LOCATION.SUBSCRIPTION_UPDATED" as "ADMIN.SUBSCRIPTIONS.LOCATION.SUBSCRIPTION_UPDATED",
                "THE_NEXT_DATE_IS_AFTER": "ADMIN.SUBSCRIPTIONS.LOCATION.THE_NEXT_DATE_IS_AFTER" as "ADMIN.SUBSCRIPTIONS.LOCATION.THE_NEXT_DATE_IS_AFTER",
                "THIS_CAN_BE_USED_TEMP_DISCOUNT": "ADMIN.SUBSCRIPTIONS.LOCATION.THIS_CAN_BE_USED_TEMP_DISCOUNT" as "ADMIN.SUBSCRIPTIONS.LOCATION.THIS_CAN_BE_USED_TEMP_DISCOUNT",
                "THIS_CAN_BE_USED_TO_SKIP_PAYMENT": "ADMIN.SUBSCRIPTIONS.LOCATION.THIS_CAN_BE_USED_TO_SKIP_PAYMENT" as "ADMIN.SUBSCRIPTIONS.LOCATION.THIS_CAN_BE_USED_TO_SKIP_PAYMENT",
                "UPDATE_SUBSCRIPTION": "ADMIN.SUBSCRIPTIONS.LOCATION.UPDATE_SUBSCRIPTION" as "ADMIN.SUBSCRIPTIONS.LOCATION.UPDATE_SUBSCRIPTION"
            },
            "NOTIFY_RECURRING_PAYMENT_DELETED": "ADMIN.SUBSCRIPTIONS.NOTIFY_RECURRING_PAYMENT_DELETED" as "ADMIN.SUBSCRIPTIONS.NOTIFY_RECURRING_PAYMENT_DELETED",
            "NOTIFY_RECURRING_PAYMENT_SAVED": "ADMIN.SUBSCRIPTIONS.NOTIFY_RECURRING_PAYMENT_SAVED" as "ADMIN.SUBSCRIPTIONS.NOTIFY_RECURRING_PAYMENT_SAVED",
            "NOTIFY_SUBSCRIPTION_UPDATED": "ADMIN.SUBSCRIPTIONS.NOTIFY_SUBSCRIPTION_UPDATED" as "ADMIN.SUBSCRIPTIONS.NOTIFY_SUBSCRIPTION_UPDATED",
            "NO_CLIENTS": "ADMIN.SUBSCRIPTIONS.NO_CLIENTS" as "ADMIN.SUBSCRIPTIONS.NO_CLIENTS",
            "NO_LOCATIONS": "ADMIN.SUBSCRIPTIONS.NO_LOCATIONS" as "ADMIN.SUBSCRIPTIONS.NO_LOCATIONS",
            "SUBSCRIPTION": "ADMIN.SUBSCRIPTIONS.SUBSCRIPTION" as "ADMIN.SUBSCRIPTIONS.SUBSCRIPTION",
            "UPDATE_DEFAULT_SUBSCRIPTION": "ADMIN.SUBSCRIPTIONS.UPDATE_DEFAULT_SUBSCRIPTION" as "ADMIN.SUBSCRIPTIONS.UPDATE_DEFAULT_SUBSCRIPTION"
        },
        "USERS": {
            "ADD_NEW_USER": "ADMIN.USERS.ADD_NEW_USER" as "ADMIN.USERS.ADD_NEW_USER"
        }
    },
    "AGENCIES": {
        "ADD_NEW_AGENCY": "AGENCIES.ADD_NEW_AGENCY" as "AGENCIES.ADD_NEW_AGENCY",
        "AGENCY": {
            "CONFIRM_DELETE": "AGENCIES.AGENCY.CONFIRM_DELETE" as "AGENCIES.AGENCY.CONFIRM_DELETE",
            "DELETED_CONFIRMATION_MESSAGE": "AGENCIES.AGENCY.DELETED_CONFIRMATION_MESSAGE" as "AGENCIES.AGENCY.DELETED_CONFIRMATION_MESSAGE",
            "DELETE_AGENCY": "AGENCIES.AGENCY.DELETE_AGENCY" as "AGENCIES.AGENCY.DELETE_AGENCY",
            "EDIT_AGENCY": "AGENCIES.AGENCY.EDIT_AGENCY" as "AGENCIES.AGENCY.EDIT_AGENCY",
            "WHITELABEL_LOGO": "AGENCIES.AGENCY.WHITELABEL_LOGO" as "AGENCIES.AGENCY.WHITELABEL_LOGO"
        },
        "AGENCY_CREATED": "AGENCIES.AGENCY_CREATED" as "AGENCIES.AGENCY_CREATED",
        "AGENCY_NAME": "AGENCIES.AGENCY_NAME" as "AGENCIES.AGENCY_NAME",
        "AGENCY_NAME_REQUIRED": "AGENCIES.AGENCY_NAME_REQUIRED" as "AGENCIES.AGENCY_NAME_REQUIRED",
        "AGENCY_UPDATED": "AGENCIES.AGENCY_UPDATED" as "AGENCIES.AGENCY_UPDATED",
        "USER": {
            "ADD_AGENCY_USER": "AGENCIES.USER.ADD_AGENCY_USER" as "AGENCIES.USER.ADD_AGENCY_USER",
            "ADD_NEW_USER_TO": "AGENCIES.USER.ADD_NEW_USER_TO" as "AGENCIES.USER.ADD_NEW_USER_TO",
            "ADMIN": "AGENCIES.USER.ADMIN" as "AGENCIES.USER.ADMIN",
            "EDIT_AGENCY_USER": "AGENCIES.USER.EDIT_AGENCY_USER" as "AGENCIES.USER.EDIT_AGENCY_USER",
            "EDIT_USER": "AGENCIES.USER.EDIT_USER" as "AGENCIES.USER.EDIT_USER",
            "NO_USERS_ASSIGNED": "AGENCIES.USER.NO_USERS_ASSIGNED" as "AGENCIES.USER.NO_USERS_ASSIGNED",
            "REMOVE_USER": "AGENCIES.USER.REMOVE_USER" as "AGENCIES.USER.REMOVE_USER",
            "USER_ADDED_SUCCESS_MESSAGE": "AGENCIES.USER.USER_ADDED_SUCCESS_MESSAGE" as "AGENCIES.USER.USER_ADDED_SUCCESS_MESSAGE",
            "USER_REMOVED_SUCCESS_MESSAGE": "AGENCIES.USER.USER_REMOVED_SUCCESS_MESSAGE" as "AGENCIES.USER.USER_REMOVED_SUCCESS_MESSAGE",
            "USER_UPDATED_SUCCESS_MESSAGE": "AGENCIES.USER.USER_UPDATED_SUCCESS_MESSAGE" as "AGENCIES.USER.USER_UPDATED_SUCCESS_MESSAGE"
        }
    },
    "AGENCY": {
        "ASSIGN_TO_AGENCY_MANAGER": {
            "WARNING_BUTTON_LABEL": "AGENCY.ASSIGN_TO_AGENCY_MANAGER.WARNING_BUTTON_LABEL" as "AGENCY.ASSIGN_TO_AGENCY_MANAGER.WARNING_BUTTON_LABEL",
            "WARNING_MESSAGE": "AGENCY.ASSIGN_TO_AGENCY_MANAGER.WARNING_MESSAGE" as "AGENCY.ASSIGN_TO_AGENCY_MANAGER.WARNING_MESSAGE"
        },
        "CLIENT": {
            "ACTIVITIES": {
                "ACTIVITY_ADDED": "AGENCY.CLIENT.ACTIVITIES.ACTIVITY_ADDED" as "AGENCY.CLIENT.ACTIVITIES.ACTIVITY_ADDED",
                "ACTIVITY_ADDED_ERROR": "AGENCY.CLIENT.ACTIVITIES.ACTIVITY_ADDED_ERROR" as "AGENCY.CLIENT.ACTIVITIES.ACTIVITY_ADDED_ERROR",
                "ACTIVITY_NAME_MUST_BE_UNIQUE": "AGENCY.CLIENT.ACTIVITIES.ACTIVITY_NAME_MUST_BE_UNIQUE" as "AGENCY.CLIENT.ACTIVITIES.ACTIVITY_NAME_MUST_BE_UNIQUE",
                "ADD_ACTIVITY": "AGENCY.CLIENT.ACTIVITIES.ADD_ACTIVITY" as "AGENCY.CLIENT.ACTIVITIES.ADD_ACTIVITY",
                "ADD_CHANNEL": "AGENCY.CLIENT.ACTIVITIES.ADD_CHANNEL" as "AGENCY.CLIENT.ACTIVITIES.ADD_CHANNEL",
                "ADD_CHANNEL_ERROR": "AGENCY.CLIENT.ACTIVITIES.ADD_CHANNEL_ERROR" as "AGENCY.CLIENT.ACTIVITIES.ADD_CHANNEL_ERROR",
                "ADD_PLATFORM": "AGENCY.CLIENT.ACTIVITIES.ADD_PLATFORM" as "AGENCY.CLIENT.ACTIVITIES.ADD_PLATFORM",
                "ADD_PLATFORM_ERROR": "AGENCY.CLIENT.ACTIVITIES.ADD_PLATFORM_ERROR" as "AGENCY.CLIENT.ACTIVITIES.ADD_PLATFORM_ERROR",
                "CHANNEL_NAME": "AGENCY.CLIENT.ACTIVITIES.CHANNEL_NAME" as "AGENCY.CLIENT.ACTIVITIES.CHANNEL_NAME",
                "CHANNEL_NAME_MUST_BE_UNIQUE": "AGENCY.CLIENT.ACTIVITIES.CHANNEL_NAME_MUST_BE_UNIQUE" as "AGENCY.CLIENT.ACTIVITIES.CHANNEL_NAME_MUST_BE_UNIQUE",
                "CHANNEL_TYPE": "AGENCY.CLIENT.ACTIVITIES.CHANNEL_TYPE" as "AGENCY.CLIENT.ACTIVITIES.CHANNEL_TYPE",
                "DELETE_ACTIVITY": "AGENCY.CLIENT.ACTIVITIES.DELETE_ACTIVITY" as "AGENCY.CLIENT.ACTIVITIES.DELETE_ACTIVITY",
                "DELETE_ACTIVITY_DESCRIPTION": "AGENCY.CLIENT.ACTIVITIES.DELETE_ACTIVITY_DESCRIPTION" as "AGENCY.CLIENT.ACTIVITIES.DELETE_ACTIVITY_DESCRIPTION",
                "DELETE_ACTIVITY_ERROR": "AGENCY.CLIENT.ACTIVITIES.DELETE_ACTIVITY_ERROR" as "AGENCY.CLIENT.ACTIVITIES.DELETE_ACTIVITY_ERROR",
                "DELETE_ACTIVITY_SUCCESS": "AGENCY.CLIENT.ACTIVITIES.DELETE_ACTIVITY_SUCCESS" as "AGENCY.CLIENT.ACTIVITIES.DELETE_ACTIVITY_SUCCESS",
                "DELETE_CHANNEL": "AGENCY.CLIENT.ACTIVITIES.DELETE_CHANNEL" as "AGENCY.CLIENT.ACTIVITIES.DELETE_CHANNEL",
                "DELETE_CHANNEL_DESCRIPTION": "AGENCY.CLIENT.ACTIVITIES.DELETE_CHANNEL_DESCRIPTION" as "AGENCY.CLIENT.ACTIVITIES.DELETE_CHANNEL_DESCRIPTION",
                "DELETE_CHANNEL_ERROR": "AGENCY.CLIENT.ACTIVITIES.DELETE_CHANNEL_ERROR" as "AGENCY.CLIENT.ACTIVITIES.DELETE_CHANNEL_ERROR",
                "DELETE_PLATFORM_DESCRIPTION": "AGENCY.CLIENT.ACTIVITIES.DELETE_PLATFORM_DESCRIPTION" as "AGENCY.CLIENT.ACTIVITIES.DELETE_PLATFORM_DESCRIPTION",
                "LINKED_PLATFORM_OPTIONAL": "AGENCY.CLIENT.ACTIVITIES.LINKED_PLATFORM_OPTIONAL" as "AGENCY.CLIENT.ACTIVITIES.LINKED_PLATFORM_OPTIONAL",
                "PLATFORM_NAME": "AGENCY.CLIENT.ACTIVITIES.PLATFORM_NAME" as "AGENCY.CLIENT.ACTIVITIES.PLATFORM_NAME",
                "PLATFORM_TYPE": "AGENCY.CLIENT.ACTIVITIES.PLATFORM_TYPE" as "AGENCY.CLIENT.ACTIVITIES.PLATFORM_TYPE",
                "REFRESH_DATA": "AGENCY.CLIENT.ACTIVITIES.REFRESH_DATA" as "AGENCY.CLIENT.ACTIVITIES.REFRESH_DATA",
                "RETRIEVE_ACTIVITIES": "AGENCY.CLIENT.ACTIVITIES.RETRIEVE_ACTIVITIES" as "AGENCY.CLIENT.ACTIVITIES.RETRIEVE_ACTIVITIES",
                "RETRIEVE_BUILDING_PLATFORMS": "AGENCY.CLIENT.ACTIVITIES.RETRIEVE_BUILDING_PLATFORMS" as "AGENCY.CLIENT.ACTIVITIES.RETRIEVE_BUILDING_PLATFORMS",
                "SAVE_NEW_CHANNEL": "AGENCY.CLIENT.ACTIVITIES.SAVE_NEW_CHANNEL" as "AGENCY.CLIENT.ACTIVITIES.SAVE_NEW_CHANNEL",
                "UPDATE_ACTIVITY_ORDER": "AGENCY.CLIENT.ACTIVITIES.UPDATE_ACTIVITY_ORDER" as "AGENCY.CLIENT.ACTIVITIES.UPDATE_ACTIVITY_ORDER"
            },
            "BRAND_COLORS": "AGENCY.CLIENT.BRAND_COLORS" as "AGENCY.CLIENT.BRAND_COLORS",
            "BRAND_COLOURS": {
                "ADD_NEW_BRAND_COLOUR": "AGENCY.CLIENT.BRAND_COLOURS.ADD_NEW_BRAND_COLOUR" as "AGENCY.CLIENT.BRAND_COLOURS.ADD_NEW_BRAND_COLOUR",
                "COLOUR": "AGENCY.CLIENT.BRAND_COLOURS.COLOUR" as "AGENCY.CLIENT.BRAND_COLOURS.COLOUR",
                "CREATED_BRAND_COLOUR": "AGENCY.CLIENT.BRAND_COLOURS.CREATED_BRAND_COLOUR" as "AGENCY.CLIENT.BRAND_COLOURS.CREATED_BRAND_COLOUR",
                "CREATE_NEW_BRAND_COLOUR": "AGENCY.CLIENT.BRAND_COLOURS.CREATE_NEW_BRAND_COLOUR" as "AGENCY.CLIENT.BRAND_COLOURS.CREATE_NEW_BRAND_COLOUR",
                "DELETED_BRAND_COLOUR": "AGENCY.CLIENT.BRAND_COLOURS.DELETED_BRAND_COLOUR" as "AGENCY.CLIENT.BRAND_COLOURS.DELETED_BRAND_COLOUR",
                "DELETE_BRAND_COLOUR": "AGENCY.CLIENT.BRAND_COLOURS.DELETE_BRAND_COLOUR" as "AGENCY.CLIENT.BRAND_COLOURS.DELETE_BRAND_COLOUR",
                "DELETE_CONFIRMATION": "AGENCY.CLIENT.BRAND_COLOURS.DELETE_CONFIRMATION" as "AGENCY.CLIENT.BRAND_COLOURS.DELETE_CONFIRMATION",
                "SUCCESSFULLY_ADDED_BRAND_COLOUR": "AGENCY.CLIENT.BRAND_COLOURS.SUCCESSFULLY_ADDED_BRAND_COLOUR" as "AGENCY.CLIENT.BRAND_COLOURS.SUCCESSFULLY_ADDED_BRAND_COLOUR",
                "SUCCESSFULLY_RENAMED_BRAND_COLOUR": "AGENCY.CLIENT.BRAND_COLOURS.SUCCESSFULLY_RENAMED_BRAND_COLOUR" as "AGENCY.CLIENT.BRAND_COLOURS.SUCCESSFULLY_RENAMED_BRAND_COLOUR",
                "SUCCESSFULLY_UPDATED_BRAND_COLOUR": "AGENCY.CLIENT.BRAND_COLOURS.SUCCESSFULLY_UPDATED_BRAND_COLOUR" as "AGENCY.CLIENT.BRAND_COLOURS.SUCCESSFULLY_UPDATED_BRAND_COLOUR",
                "UPDATED_BRAND_COLOUR": "AGENCY.CLIENT.BRAND_COLOURS.UPDATED_BRAND_COLOUR" as "AGENCY.CLIENT.BRAND_COLOURS.UPDATED_BRAND_COLOUR",
                "UPDATED_BRAND_COLOUR_ORDER": "AGENCY.CLIENT.BRAND_COLOURS.UPDATED_BRAND_COLOUR_ORDER" as "AGENCY.CLIENT.BRAND_COLOURS.UPDATED_BRAND_COLOUR_ORDER",
                "UPDATE_BRAND_COLOUR": "AGENCY.CLIENT.BRAND_COLOURS.UPDATE_BRAND_COLOUR" as "AGENCY.CLIENT.BRAND_COLOURS.UPDATE_BRAND_COLOUR",
                "UPDATE_COLOUR": "AGENCY.CLIENT.BRAND_COLOURS.UPDATE_COLOUR" as "AGENCY.CLIENT.BRAND_COLOURS.UPDATE_COLOUR",
                "UPDATE_ORDER": "AGENCY.CLIENT.BRAND_COLOURS.UPDATE_ORDER" as "AGENCY.CLIENT.BRAND_COLOURS.UPDATE_ORDER"
            },
            "BUILDER_TEMPLATE_CATEGORIES": {
                "CONFIRM_DELETE": "AGENCY.CLIENT.BUILDER_TEMPLATE_CATEGORIES.CONFIRM_DELETE" as "AGENCY.CLIENT.BUILDER_TEMPLATE_CATEGORIES.CONFIRM_DELETE",
                "EDIT_CATEGORY": "AGENCY.CLIENT.BUILDER_TEMPLATE_CATEGORIES.EDIT_CATEGORY" as "AGENCY.CLIENT.BUILDER_TEMPLATE_CATEGORIES.EDIT_CATEGORY",
                "END_DATE_MUST_BE_AFTER_START_DATE_OR_ABSENT": "AGENCY.CLIENT.BUILDER_TEMPLATE_CATEGORIES.END_DATE_MUST_BE_AFTER_START_DATE_OR_ABSENT" as "AGENCY.CLIENT.BUILDER_TEMPLATE_CATEGORIES.END_DATE_MUST_BE_AFTER_START_DATE_OR_ABSENT",
                "NEW_CATEGORY": "AGENCY.CLIENT.BUILDER_TEMPLATE_CATEGORIES.NEW_CATEGORY" as "AGENCY.CLIENT.BUILDER_TEMPLATE_CATEGORIES.NEW_CATEGORY"
            },
            "CONVERSION_AMOUNT": "AGENCY.CLIENT.CONVERSION_AMOUNT" as "AGENCY.CLIENT.CONVERSION_AMOUNT",
            "CONVERSION_AMOUNT_UPDATED": "AGENCY.CLIENT.CONVERSION_AMOUNT_UPDATED" as "AGENCY.CLIENT.CONVERSION_AMOUNT_UPDATED",
            "CONVERSION_WORTH": "AGENCY.CLIENT.CONVERSION_WORTH" as "AGENCY.CLIENT.CONVERSION_WORTH",
            "FILTER_CLIENTS": "AGENCY.CLIENT.FILTER_CLIENTS" as "AGENCY.CLIENT.FILTER_CLIENTS",
            "LINKS": {
                "ADD_NEW_LINK": "AGENCY.CLIENT.LINKS.ADD_NEW_LINK" as "AGENCY.CLIENT.LINKS.ADD_NEW_LINK",
                "CREATE_NEW_LINK": "AGENCY.CLIENT.LINKS.CREATE_NEW_LINK" as "AGENCY.CLIENT.LINKS.CREATE_NEW_LINK",
                "DELETE_CONFIRMATION": "AGENCY.CLIENT.LINKS.DELETE_CONFIRMATION" as "AGENCY.CLIENT.LINKS.DELETE_CONFIRMATION",
                "DELETE_LINK": "AGENCY.CLIENT.LINKS.DELETE_LINK" as "AGENCY.CLIENT.LINKS.DELETE_LINK",
                "GET_LINKS": "AGENCY.CLIENT.LINKS.GET_LINKS" as "AGENCY.CLIENT.LINKS.GET_LINKS",
                "LINK_PATTERN_REQUIREMENT": "AGENCY.CLIENT.LINKS.LINK_PATTERN_REQUIREMENT" as "AGENCY.CLIENT.LINKS.LINK_PATTERN_REQUIREMENT",
                "TITLE": "AGENCY.CLIENT.LINKS.TITLE" as "AGENCY.CLIENT.LINKS.TITLE",
                "UPDATE_ORDER": "AGENCY.CLIENT.LINKS.UPDATE_ORDER" as "AGENCY.CLIENT.LINKS.UPDATE_ORDER",
                "URL": "AGENCY.CLIENT.LINKS.URL" as "AGENCY.CLIENT.LINKS.URL"
            },
            "LOCATION": {
                "ACTIVITIES": {
                    "ACTIVITY_ADDED": "AGENCY.CLIENT.LOCATION.ACTIVITIES.ACTIVITY_ADDED" as "AGENCY.CLIENT.LOCATION.ACTIVITIES.ACTIVITY_ADDED",
                    "ACTIVITY_NAME": "AGENCY.CLIENT.LOCATION.ACTIVITIES.ACTIVITY_NAME" as "AGENCY.CLIENT.LOCATION.ACTIVITIES.ACTIVITY_NAME",
                    "ACTIVITY_REMOVED": "AGENCY.CLIENT.LOCATION.ACTIVITIES.ACTIVITY_REMOVED" as "AGENCY.CLIENT.LOCATION.ACTIVITIES.ACTIVITY_REMOVED",
                    "ADD_NEW_ACTIVITY": "AGENCY.CLIENT.LOCATION.ACTIVITIES.ADD_NEW_ACTIVITY" as "AGENCY.CLIENT.LOCATION.ACTIVITIES.ADD_NEW_ACTIVITY",
                    "CHANNELS": "AGENCY.CLIENT.LOCATION.ACTIVITIES.CHANNELS" as "AGENCY.CLIENT.LOCATION.ACTIVITIES.CHANNELS",
                    "DELETE_ACTIVITY": "AGENCY.CLIENT.LOCATION.ACTIVITIES.DELETE_ACTIVITY" as "AGENCY.CLIENT.LOCATION.ACTIVITIES.DELETE_ACTIVITY",
                    "MIGRATE_CHANNEL": {
                        "CHANNEL": "AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.CHANNEL" as "AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.CHANNEL",
                        "CHANNEL_ADDED": "AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.CHANNEL_ADDED" as "AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.CHANNEL_ADDED",
                        "CHANNEL_DELETED": "AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.CHANNEL_DELETED" as "AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.CHANNEL_DELETED",
                        "CONFIRM_CLICK_DELETE_CHANNEL": "AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.CONFIRM_CLICK_DELETE_CHANNEL" as "AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.CONFIRM_CLICK_DELETE_CHANNEL",
                        "DELETE_CHANNEL": "AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.DELETE_CHANNEL" as "AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.DELETE_CHANNEL",
                        "MIGRATE": "AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.MIGRATE" as "AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.MIGRATE",
                        "REPLACE_ALL": "AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.REPLACE_ALL" as "AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.REPLACE_ALL"
                    },
                    "MIGRATE_PLATFORM": {
                        "PLATFORM_ADDED": "AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_PLATFORM.PLATFORM_ADDED" as "AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_PLATFORM.PLATFORM_ADDED",
                        "PLATFORM_DELETED": "AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_PLATFORM.PLATFORM_DELETED" as "AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_PLATFORM.PLATFORM_DELETED"
                    },
                    "PLATFORM_LINK": "AGENCY.CLIENT.LOCATION.ACTIVITIES.PLATFORM_LINK" as "AGENCY.CLIENT.LOCATION.ACTIVITIES.PLATFORM_LINK",
                    "TYPE": "AGENCY.CLIENT.LOCATION.ACTIVITIES.TYPE" as "AGENCY.CLIENT.LOCATION.ACTIVITIES.TYPE"
                },
                "BILLING_UPDATE": {
                    "SEND_BILLING_DETAILS_UPDATE_REQUEST": "AGENCY.CLIENT.LOCATION.BILLING_UPDATE.SEND_BILLING_DETAILS_UPDATE_REQUEST" as "AGENCY.CLIENT.LOCATION.BILLING_UPDATE.SEND_BILLING_DETAILS_UPDATE_REQUEST",
                    "SEND_REQUEST": "AGENCY.CLIENT.LOCATION.BILLING_UPDATE.SEND_REQUEST" as "AGENCY.CLIENT.LOCATION.BILLING_UPDATE.SEND_REQUEST",
                    "SIGNATORYS_EMAIL_ADDRESS": "AGENCY.CLIENT.LOCATION.BILLING_UPDATE.SIGNATORYS_EMAIL_ADDRESS" as "AGENCY.CLIENT.LOCATION.BILLING_UPDATE.SIGNATORYS_EMAIL_ADDRESS"
                },
                "CATEGORIES": {
                    "NOTIFY_UPDATED": "AGENCY.CLIENT.LOCATION.CATEGORIES.NOTIFY_UPDATED" as "AGENCY.CLIENT.LOCATION.CATEGORIES.NOTIFY_UPDATED"
                },
                "FEATURED_TEMPLATE_SETS": {
                    "ACTIONS": "AGENCY.CLIENT.LOCATION.FEATURED_TEMPLATE_SETS.ACTIONS" as "AGENCY.CLIENT.LOCATION.FEATURED_TEMPLATE_SETS.ACTIONS",
                    "DELETE_TEMPLATE_TAG": "AGENCY.CLIENT.LOCATION.FEATURED_TEMPLATE_SETS.DELETE_TEMPLATE_TAG" as "AGENCY.CLIENT.LOCATION.FEATURED_TEMPLATE_SETS.DELETE_TEMPLATE_TAG",
                    "EDIT_FEATURED_TEMPLATE_SET": "AGENCY.CLIENT.LOCATION.FEATURED_TEMPLATE_SETS.EDIT_FEATURED_TEMPLATE_SET" as "AGENCY.CLIENT.LOCATION.FEATURED_TEMPLATE_SETS.EDIT_FEATURED_TEMPLATE_SET",
                    "END_DATE": "AGENCY.CLIENT.LOCATION.FEATURED_TEMPLATE_SETS.END_DATE" as "AGENCY.CLIENT.LOCATION.FEATURED_TEMPLATE_SETS.END_DATE",
                    "NEW_FEATURED_TEMPLATE_SET": "AGENCY.CLIENT.LOCATION.FEATURED_TEMPLATE_SETS.NEW_FEATURED_TEMPLATE_SET" as "AGENCY.CLIENT.LOCATION.FEATURED_TEMPLATE_SETS.NEW_FEATURED_TEMPLATE_SET",
                    "START_DATE": "AGENCY.CLIENT.LOCATION.FEATURED_TEMPLATE_SETS.START_DATE" as "AGENCY.CLIENT.LOCATION.FEATURED_TEMPLATE_SETS.START_DATE"
                },
                "FONTS": {
                    "BOLD": "AGENCY.CLIENT.LOCATION.FONTS.BOLD" as "AGENCY.CLIENT.LOCATION.FONTS.BOLD",
                    "BY_CHOOSING_A_FONT": "AGENCY.CLIENT.LOCATION.FONTS.BY_CHOOSING_A_FONT" as "AGENCY.CLIENT.LOCATION.FONTS.BY_CHOOSING_A_FONT",
                    "CHOOSE_FONT": "AGENCY.CLIENT.LOCATION.FONTS.CHOOSE_FONT" as "AGENCY.CLIENT.LOCATION.FONTS.CHOOSE_FONT",
                    "CONDENSED": "AGENCY.CLIENT.LOCATION.FONTS.CONDENSED" as "AGENCY.CLIENT.LOCATION.FONTS.CONDENSED",
                    "CUSTOM": "AGENCY.CLIENT.LOCATION.FONTS.CUSTOM" as "AGENCY.CLIENT.LOCATION.FONTS.CUSTOM",
                    "DO_YOU_HAVE_PERMISSION": "AGENCY.CLIENT.LOCATION.FONTS.DO_YOU_HAVE_PERMISSION" as "AGENCY.CLIENT.LOCATION.FONTS.DO_YOU_HAVE_PERMISSION",
                    "EXPANDED": "AGENCY.CLIENT.LOCATION.FONTS.EXPANDED" as "AGENCY.CLIENT.LOCATION.FONTS.EXPANDED",
                    "EXTRA_CONDENSED": "AGENCY.CLIENT.LOCATION.FONTS.EXTRA_CONDENSED" as "AGENCY.CLIENT.LOCATION.FONTS.EXTRA_CONDENSED",
                    "EXTRA_EXPANDED": "AGENCY.CLIENT.LOCATION.FONTS.EXTRA_EXPANDED" as "AGENCY.CLIENT.LOCATION.FONTS.EXTRA_EXPANDED",
                    "FONTS_SAVED": "AGENCY.CLIENT.LOCATION.FONTS.FONTS_SAVED" as "AGENCY.CLIENT.LOCATION.FONTS.FONTS_SAVED",
                    "FONT_FAMILY": "AGENCY.CLIENT.LOCATION.FONTS.FONT_FAMILY" as "AGENCY.CLIENT.LOCATION.FONTS.FONT_FAMILY",
                    "ITALIC": "AGENCY.CLIENT.LOCATION.FONTS.ITALIC" as "AGENCY.CLIENT.LOCATION.FONTS.ITALIC",
                    "I_CONFIRM_I_HAVE_PERMISSION": "AGENCY.CLIENT.LOCATION.FONTS.I_CONFIRM_I_HAVE_PERMISSION" as "AGENCY.CLIENT.LOCATION.FONTS.I_CONFIRM_I_HAVE_PERMISSION",
                    "LOCAL_FILE": "AGENCY.CLIENT.LOCATION.FONTS.LOCAL_FILE" as "AGENCY.CLIENT.LOCATION.FONTS.LOCAL_FILE",
                    "NORMAL": "AGENCY.CLIENT.LOCATION.FONTS.NORMAL" as "AGENCY.CLIENT.LOCATION.FONTS.NORMAL",
                    "NO_FONTS": "AGENCY.CLIENT.LOCATION.FONTS.NO_FONTS" as "AGENCY.CLIENT.LOCATION.FONTS.NO_FONTS",
                    "OBLIQUE": "AGENCY.CLIENT.LOCATION.FONTS.OBLIQUE" as "AGENCY.CLIENT.LOCATION.FONTS.OBLIQUE",
                    "SELECT_FONT": "AGENCY.CLIENT.LOCATION.FONTS.SELECT_FONT" as "AGENCY.CLIENT.LOCATION.FONTS.SELECT_FONT",
                    "SEMI_CONDENSED": "AGENCY.CLIENT.LOCATION.FONTS.SEMI_CONDENSED" as "AGENCY.CLIENT.LOCATION.FONTS.SEMI_CONDENSED",
                    "SEMI_EXPANDED": "AGENCY.CLIENT.LOCATION.FONTS.SEMI_EXPANDED" as "AGENCY.CLIENT.LOCATION.FONTS.SEMI_EXPANDED",
                    "STRETCH": "AGENCY.CLIENT.LOCATION.FONTS.STRETCH" as "AGENCY.CLIENT.LOCATION.FONTS.STRETCH",
                    "STYLE": "AGENCY.CLIENT.LOCATION.FONTS.STYLE" as "AGENCY.CLIENT.LOCATION.FONTS.STYLE",
                    "ULTRA_CONDENSED": "AGENCY.CLIENT.LOCATION.FONTS.ULTRA_CONDENSED" as "AGENCY.CLIENT.LOCATION.FONTS.ULTRA_CONDENSED",
                    "ULTRA_EXPANDED": "AGENCY.CLIENT.LOCATION.FONTS.ULTRA_EXPANDED" as "AGENCY.CLIENT.LOCATION.FONTS.ULTRA_EXPANDED",
                    "WEIGHT": "AGENCY.CLIENT.LOCATION.FONTS.WEIGHT" as "AGENCY.CLIENT.LOCATION.FONTS.WEIGHT",
                    "YOU_HAVE_CONFIRMED": "AGENCY.CLIENT.LOCATION.FONTS.YOU_HAVE_CONFIRMED" as "AGENCY.CLIENT.LOCATION.FONTS.YOU_HAVE_CONFIRMED"
                },
                "LEARN_MENU": {
                    "ADD_SECTION": "AGENCY.CLIENT.LOCATION.LEARN_MENU.ADD_SECTION" as "AGENCY.CLIENT.LOCATION.LEARN_MENU.ADD_SECTION",
                    "ADD_SUB_SECTION": "AGENCY.CLIENT.LOCATION.LEARN_MENU.ADD_SUB_SECTION" as "AGENCY.CLIENT.LOCATION.LEARN_MENU.ADD_SUB_SECTION",
                    "ADD_SUB_SECTION_TO_SECTION": "AGENCY.CLIENT.LOCATION.LEARN_MENU.ADD_SUB_SECTION_TO_SECTION" as "AGENCY.CLIENT.LOCATION.LEARN_MENU.ADD_SUB_SECTION_TO_SECTION",
                    "COULD_NOT_SAVE_LEARN_MENU": "AGENCY.CLIENT.LOCATION.LEARN_MENU.COULD_NOT_SAVE_LEARN_MENU" as "AGENCY.CLIENT.LOCATION.LEARN_MENU.COULD_NOT_SAVE_LEARN_MENU",
                    "DELETE_SECTION": "AGENCY.CLIENT.LOCATION.LEARN_MENU.DELETE_SECTION" as "AGENCY.CLIENT.LOCATION.LEARN_MENU.DELETE_SECTION",
                    "DELETE_SUB_SECTION": "AGENCY.CLIENT.LOCATION.LEARN_MENU.DELETE_SUB_SECTION" as "AGENCY.CLIENT.LOCATION.LEARN_MENU.DELETE_SUB_SECTION",
                    "LEARN_MENU_SAVED": "AGENCY.CLIENT.LOCATION.LEARN_MENU.LEARN_MENU_SAVED" as "AGENCY.CLIENT.LOCATION.LEARN_MENU.LEARN_MENU_SAVED",
                    "NEW_SUB_SECTION": "AGENCY.CLIENT.LOCATION.LEARN_MENU.NEW_SUB_SECTION" as "AGENCY.CLIENT.LOCATION.LEARN_MENU.NEW_SUB_SECTION",
                    "SUB_SECTIONS": "AGENCY.CLIENT.LOCATION.LEARN_MENU.SUB_SECTIONS" as "AGENCY.CLIENT.LOCATION.LEARN_MENU.SUB_SECTIONS",
                    "SUB_SECTIONS_FOR": "AGENCY.CLIENT.LOCATION.LEARN_MENU.SUB_SECTIONS_FOR" as "AGENCY.CLIENT.LOCATION.LEARN_MENU.SUB_SECTIONS_FOR"
                },
                "LOCATION_DETAILS": {
                    "DELETE_CONFIRMATION": "AGENCY.CLIENT.LOCATION.LOCATION_DETAILS.DELETE_CONFIRMATION" as "AGENCY.CLIENT.LOCATION.LOCATION_DETAILS.DELETE_CONFIRMATION",
                    "DISPLAY_NAME_TOO_LONG": "AGENCY.CLIENT.LOCATION.LOCATION_DETAILS.DISPLAY_NAME_TOO_LONG" as "AGENCY.CLIENT.LOCATION.LOCATION_DETAILS.DISPLAY_NAME_TOO_LONG",
                    "LOCATION_DETAILS": "AGENCY.CLIENT.LOCATION.LOCATION_DETAILS.LOCATION_DETAILS" as "AGENCY.CLIENT.LOCATION.LOCATION_DETAILS.LOCATION_DETAILS",
                    "SUPPORTED_PLANNER_LIMIT": "AGENCY.CLIENT.LOCATION.LOCATION_DETAILS.SUPPORTED_PLANNER_LIMIT" as "AGENCY.CLIENT.LOCATION.LOCATION_DETAILS.SUPPORTED_PLANNER_LIMIT"
                },
                "MANAGE": {
                    "ADD_LOCATION": "AGENCY.CLIENT.LOCATION.MANAGE.ADD_LOCATION" as "AGENCY.CLIENT.LOCATION.MANAGE.ADD_LOCATION",
                    "CREATED_LOCATION_ERROR": "AGENCY.CLIENT.LOCATION.MANAGE.CREATED_LOCATION_ERROR" as "AGENCY.CLIENT.LOCATION.MANAGE.CREATED_LOCATION_ERROR",
                    "CREATED_LOCATION_SUCCESS": "AGENCY.CLIENT.LOCATION.MANAGE.CREATED_LOCATION_SUCCESS" as "AGENCY.CLIENT.LOCATION.MANAGE.CREATED_LOCATION_SUCCESS",
                    "DELETE_LOCATION_DESCRIPTION": "AGENCY.CLIENT.LOCATION.MANAGE.DELETE_LOCATION_DESCRIPTION" as "AGENCY.CLIENT.LOCATION.MANAGE.DELETE_LOCATION_DESCRIPTION",
                    "DELETE_LOCATION_ERROR": "AGENCY.CLIENT.LOCATION.MANAGE.DELETE_LOCATION_ERROR" as "AGENCY.CLIENT.LOCATION.MANAGE.DELETE_LOCATION_ERROR",
                    "DELETE_LOCATION_LABEL": "AGENCY.CLIENT.LOCATION.MANAGE.DELETE_LOCATION_LABEL" as "AGENCY.CLIENT.LOCATION.MANAGE.DELETE_LOCATION_LABEL",
                    "DELETE_LOCATION_SUCCESS": "AGENCY.CLIENT.LOCATION.MANAGE.DELETE_LOCATION_SUCCESS" as "AGENCY.CLIENT.LOCATION.MANAGE.DELETE_LOCATION_SUCCESS",
                    "EDIT_DETAILS": "AGENCY.CLIENT.LOCATION.MANAGE.EDIT_DETAILS" as "AGENCY.CLIENT.LOCATION.MANAGE.EDIT_DETAILS",
                    "ERRORS": {
                        "ERROR_UPDATING_LOCATION": "AGENCY.CLIENT.LOCATION.MANAGE.ERRORS.ERROR_UPDATING_LOCATION" as "AGENCY.CLIENT.LOCATION.MANAGE.ERRORS.ERROR_UPDATING_LOCATION",
                        "NO_CLIENT_ID": "AGENCY.CLIENT.LOCATION.MANAGE.ERRORS.NO_CLIENT_ID" as "AGENCY.CLIENT.LOCATION.MANAGE.ERRORS.NO_CLIENT_ID",
                        "NO_LOCATION_OR_ACCESS_FORBIDDEN": "AGENCY.CLIENT.LOCATION.MANAGE.ERRORS.NO_LOCATION_OR_ACCESS_FORBIDDEN" as "AGENCY.CLIENT.LOCATION.MANAGE.ERRORS.NO_LOCATION_OR_ACCESS_FORBIDDEN"
                    },
                    "FILTER_LOCATIONS": "AGENCY.CLIENT.LOCATION.MANAGE.FILTER_LOCATIONS" as "AGENCY.CLIENT.LOCATION.MANAGE.FILTER_LOCATIONS",
                    "LOCATION_NAME": "AGENCY.CLIENT.LOCATION.MANAGE.LOCATION_NAME" as "AGENCY.CLIENT.LOCATION.MANAGE.LOCATION_NAME",
                    "LOCATION_UPDATE_SUCCESS": "AGENCY.CLIENT.LOCATION.MANAGE.LOCATION_UPDATE_SUCCESS" as "AGENCY.CLIENT.LOCATION.MANAGE.LOCATION_UPDATE_SUCCESS",
                    "NO_FIELD_VALUE": "AGENCY.CLIENT.LOCATION.MANAGE.NO_FIELD_VALUE" as "AGENCY.CLIENT.LOCATION.MANAGE.NO_FIELD_VALUE",
                    "PROPERTIES": "AGENCY.CLIENT.LOCATION.MANAGE.PROPERTIES" as "AGENCY.CLIENT.LOCATION.MANAGE.PROPERTIES",
                    "PUBLIC_DETAILS": "AGENCY.CLIENT.LOCATION.MANAGE.PUBLIC_DETAILS" as "AGENCY.CLIENT.LOCATION.MANAGE.PUBLIC_DETAILS"
                },
                "NAV": {
                    "ACTIVITIES": "AGENCY.CLIENT.LOCATION.NAV.ACTIVITIES" as "AGENCY.CLIENT.LOCATION.NAV.ACTIVITIES",
                    "AGENCY": "AGENCY.CLIENT.LOCATION.NAV.AGENCY" as "AGENCY.CLIENT.LOCATION.NAV.AGENCY",
                    "BRAND_COLOURS": "AGENCY.CLIENT.LOCATION.NAV.BRAND_COLOURS" as "AGENCY.CLIENT.LOCATION.NAV.BRAND_COLOURS",
                    "BUILDER_TEMPLATE_CATEGORIES": "AGENCY.CLIENT.LOCATION.NAV.BUILDER_TEMPLATE_CATEGORIES" as "AGENCY.CLIENT.LOCATION.NAV.BUILDER_TEMPLATE_CATEGORIES",
                    "CLIENTS": "AGENCY.CLIENT.LOCATION.NAV.CLIENTS" as "AGENCY.CLIENT.LOCATION.NAV.CLIENTS",
                    "FEATURED_TEMPLATE_SETS": "AGENCY.CLIENT.LOCATION.NAV.FEATURED_TEMPLATE_SETS" as "AGENCY.CLIENT.LOCATION.NAV.FEATURED_TEMPLATE_SETS",
                    "FONTS": "AGENCY.CLIENT.LOCATION.NAV.FONTS" as "AGENCY.CLIENT.LOCATION.NAV.FONTS",
                    "LEARN_MENU": "AGENCY.CLIENT.LOCATION.NAV.LEARN_MENU" as "AGENCY.CLIENT.LOCATION.NAV.LEARN_MENU",
                    "LINKS": "AGENCY.CLIENT.LOCATION.NAV.LINKS" as "AGENCY.CLIENT.LOCATION.NAV.LINKS",
                    "LOCATIONS": "AGENCY.CLIENT.LOCATION.NAV.LOCATIONS" as "AGENCY.CLIENT.LOCATION.NAV.LOCATIONS",
                    "LOCATION_CATEGORIES": "AGENCY.CLIENT.LOCATION.NAV.LOCATION_CATEGORIES" as "AGENCY.CLIENT.LOCATION.NAV.LOCATION_CATEGORIES",
                    "PLATFORMS": "AGENCY.CLIENT.LOCATION.NAV.PLATFORMS" as "AGENCY.CLIENT.LOCATION.NAV.PLATFORMS",
                    "USERS": "AGENCY.CLIENT.LOCATION.NAV.USERS" as "AGENCY.CLIENT.LOCATION.NAV.USERS"
                },
                "NOTIFY_LOCATION_DELETED": "AGENCY.CLIENT.LOCATION.NOTIFY_LOCATION_DELETED" as "AGENCY.CLIENT.LOCATION.NOTIFY_LOCATION_DELETED",
                "NOTIFY_LOCATION_DELETE_ERROR": "AGENCY.CLIENT.LOCATION.NOTIFY_LOCATION_DELETE_ERROR" as "AGENCY.CLIENT.LOCATION.NOTIFY_LOCATION_DELETE_ERROR",
                "NOTIFY_LOCATION_UPDATED": "AGENCY.CLIENT.LOCATION.NOTIFY_LOCATION_UPDATED" as "AGENCY.CLIENT.LOCATION.NOTIFY_LOCATION_UPDATED",
                "NOTIFY_LOCATION_UPDATE_ERROR": "AGENCY.CLIENT.LOCATION.NOTIFY_LOCATION_UPDATE_ERROR" as "AGENCY.CLIENT.LOCATION.NOTIFY_LOCATION_UPDATE_ERROR",
                "SUMMARY_FIELDS": {
                    "ADD_NEW_FIELD_GROUP": "AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.ADD_NEW_FIELD_GROUP" as "AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.ADD_NEW_FIELD_GROUP",
                    "DELETE_FIELD": "AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.DELETE_FIELD" as "AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.DELETE_FIELD",
                    "DELETE_FIELD_CONFIRM": "AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.DELETE_FIELD_CONFIRM" as "AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.DELETE_FIELD_CONFIRM",
                    "DELETE_GROUP": "AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.DELETE_GROUP" as "AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.DELETE_GROUP",
                    "FIELD_LABEL": "AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.FIELD_LABEL" as "AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.FIELD_LABEL",
                    "GROUP_NAME": "AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.GROUP_NAME" as "AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.GROUP_NAME",
                    "NEW_FIELD": "AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.NEW_FIELD" as "AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.NEW_FIELD"
                },
                "USERS": {
                    "ADD_EXISTING_USER": "AGENCY.CLIENT.LOCATION.USERS.ADD_EXISTING_USER" as "AGENCY.CLIENT.LOCATION.USERS.ADD_EXISTING_USER",
                    "ADD_EXISTING_USER_HELP_TEXT": "AGENCY.CLIENT.LOCATION.USERS.ADD_EXISTING_USER_HELP_TEXT" as "AGENCY.CLIENT.LOCATION.USERS.ADD_EXISTING_USER_HELP_TEXT",
                    "ADD_EXISTING_USER_LABEL": "AGENCY.CLIENT.LOCATION.USERS.ADD_EXISTING_USER_LABEL" as "AGENCY.CLIENT.LOCATION.USERS.ADD_EXISTING_USER_LABEL",
                    "ADD_EXISTING_USER_NO_MATCHES": "AGENCY.CLIENT.LOCATION.USERS.ADD_EXISTING_USER_NO_MATCHES" as "AGENCY.CLIENT.LOCATION.USERS.ADD_EXISTING_USER_NO_MATCHES",
                    "ADD_EXISTING_USER_PLACEHOLDER": "AGENCY.CLIENT.LOCATION.USERS.ADD_EXISTING_USER_PLACEHOLDER" as "AGENCY.CLIENT.LOCATION.USERS.ADD_EXISTING_USER_PLACEHOLDER",
                    "ADD_EXISTING_USER_SELECTED": "AGENCY.CLIENT.LOCATION.USERS.ADD_EXISTING_USER_SELECTED" as "AGENCY.CLIENT.LOCATION.USERS.ADD_EXISTING_USER_SELECTED",
                    "ADD_NEW_USER_TO": "AGENCY.CLIENT.LOCATION.USERS.ADD_NEW_USER_TO" as "AGENCY.CLIENT.LOCATION.USERS.ADD_NEW_USER_TO",
                    "ASSIGN_USER_TO_LOCATIONS": "AGENCY.CLIENT.LOCATION.USERS.ASSIGN_USER_TO_LOCATIONS" as "AGENCY.CLIENT.LOCATION.USERS.ASSIGN_USER_TO_LOCATIONS",
                    "CURRENTLY_SELECTED": "AGENCY.CLIENT.LOCATION.USERS.CURRENTLY_SELECTED" as "AGENCY.CLIENT.LOCATION.USERS.CURRENTLY_SELECTED",
                    "DELETE_CONFIRMATION": "AGENCY.CLIENT.LOCATION.USERS.DELETE_CONFIRMATION" as "AGENCY.CLIENT.LOCATION.USERS.DELETE_CONFIRMATION",
                    "DELETE_USER": "AGENCY.CLIENT.LOCATION.USERS.DELETE_USER" as "AGENCY.CLIENT.LOCATION.USERS.DELETE_USER",
                    "FAILED_TO_ADD_EXISTING_USER": "AGENCY.CLIENT.LOCATION.USERS.FAILED_TO_ADD_EXISTING_USER" as "AGENCY.CLIENT.LOCATION.USERS.FAILED_TO_ADD_EXISTING_USER",
                    "FILTER_FIRST_NAME": "AGENCY.CLIENT.LOCATION.USERS.FILTER_FIRST_NAME" as "AGENCY.CLIENT.LOCATION.USERS.FILTER_FIRST_NAME",
                    "FILTER_LAST_NAME": "AGENCY.CLIENT.LOCATION.USERS.FILTER_LAST_NAME" as "AGENCY.CLIENT.LOCATION.USERS.FILTER_LAST_NAME",
                    "FILTER_USERNAME": "AGENCY.CLIENT.LOCATION.USERS.FILTER_USERNAME" as "AGENCY.CLIENT.LOCATION.USERS.FILTER_USERNAME",
                    "FIRST_NAME": "AGENCY.CLIENT.LOCATION.USERS.FIRST_NAME" as "AGENCY.CLIENT.LOCATION.USERS.FIRST_NAME",
                    "LAST_NAME": "AGENCY.CLIENT.LOCATION.USERS.LAST_NAME" as "AGENCY.CLIENT.LOCATION.USERS.LAST_NAME",
                    "LOCATIONS_UPDATED": "AGENCY.CLIENT.LOCATION.USERS.LOCATIONS_UPDATED" as "AGENCY.CLIENT.LOCATION.USERS.LOCATIONS_UPDATED",
                    "NO_USERS_ASSIGNED_TO_COMPANY": "AGENCY.CLIENT.LOCATION.USERS.NO_USERS_ASSIGNED_TO_COMPANY" as "AGENCY.CLIENT.LOCATION.USERS.NO_USERS_ASSIGNED_TO_COMPANY",
                    "NO_USERS_FOUND": "AGENCY.CLIENT.LOCATION.USERS.NO_USERS_FOUND" as "AGENCY.CLIENT.LOCATION.USERS.NO_USERS_FOUND",
                    "REMOVE_USER_MODAL": {
                        "DELETE_USER": "AGENCY.CLIENT.LOCATION.USERS.REMOVE_USER_MODAL.DELETE_USER" as "AGENCY.CLIENT.LOCATION.USERS.REMOVE_USER_MODAL.DELETE_USER",
                        "REMOVE_FROM_LOCATION": "AGENCY.CLIENT.LOCATION.USERS.REMOVE_USER_MODAL.REMOVE_FROM_LOCATION" as "AGENCY.CLIENT.LOCATION.USERS.REMOVE_USER_MODAL.REMOVE_FROM_LOCATION",
                        "REMOVE_OR_DELETE_USER_MESSAGE": "AGENCY.CLIENT.LOCATION.USERS.REMOVE_USER_MODAL.REMOVE_OR_DELETE_USER_MESSAGE" as "AGENCY.CLIENT.LOCATION.USERS.REMOVE_USER_MODAL.REMOVE_OR_DELETE_USER_MESSAGE",
                        "REMOVE_OR_DELETE_USER_TITLE": "AGENCY.CLIENT.LOCATION.USERS.REMOVE_USER_MODAL.REMOVE_OR_DELETE_USER_TITLE" as "AGENCY.CLIENT.LOCATION.USERS.REMOVE_USER_MODAL.REMOVE_OR_DELETE_USER_TITLE"
                    },
                    "ROLES": "AGENCY.CLIENT.LOCATION.USERS.ROLES" as "AGENCY.CLIENT.LOCATION.USERS.ROLES",
                    "SELECT_USER": "AGENCY.CLIENT.LOCATION.USERS.SELECT_USER" as "AGENCY.CLIENT.LOCATION.USERS.SELECT_USER",
                    "USERNAME_EMAIL": "AGENCY.CLIENT.LOCATION.USERS.USERNAME_EMAIL" as "AGENCY.CLIENT.LOCATION.USERS.USERNAME_EMAIL",
                    "USERS": "AGENCY.CLIENT.LOCATION.USERS.USERS" as "AGENCY.CLIENT.LOCATION.USERS.USERS",
                    "USERS_EXISTING_LOCATIONS": "AGENCY.CLIENT.LOCATION.USERS.USERS_EXISTING_LOCATIONS" as "AGENCY.CLIENT.LOCATION.USERS.USERS_EXISTING_LOCATIONS",
                    "USER_ADDED": "AGENCY.CLIENT.LOCATION.USERS.USER_ADDED" as "AGENCY.CLIENT.LOCATION.USERS.USER_ADDED",
                    "USER_EDIT": {
                        "ANALYST": "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.ANALYST" as "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.ANALYST",
                        "ANALYST_TOOLTIP": "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.ANALYST_TOOLTIP" as "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.ANALYST_TOOLTIP",
                        "BUILDER": "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.BUILDER" as "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.BUILDER",
                        "BUILDER_TOOLTIP": "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.BUILDER_TOOLTIP" as "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.BUILDER_TOOLTIP",
                        "CLIENTS": "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.CLIENTS" as "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.CLIENTS",
                        "CONNECT_TO_ACCESS": "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.CONNECT_TO_ACCESS" as "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.CONNECT_TO_ACCESS",
                        "EDIT_CLIENT_USER": "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.EDIT_CLIENT_USER" as "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.EDIT_CLIENT_USER",
                        "EDIT_USER": "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.EDIT_USER" as "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.EDIT_USER",
                        "EMAIL": "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.EMAIL" as "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.EMAIL",
                        "FIRST_NAME": "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.FIRST_NAME" as "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.FIRST_NAME",
                        "LAST_NAME": "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.LAST_NAME" as "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.LAST_NAME",
                        "MARKETING_UPDATES": "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.MARKETING_UPDATES" as "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.MARKETING_UPDATES",
                        "NOTIFICATIONS": "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.NOTIFICATIONS" as "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.NOTIFICATIONS",
                        "PASSWORD": "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.PASSWORD" as "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.PASSWORD",
                        "PLANNER": "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.PLANNER" as "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.PLANNER",
                        "PLANNER_TOOLTIP": "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.PLANNER_TOOLTIP" as "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.PLANNER_TOOLTIP",
                        "PUBLISHER": "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.PUBLISHER" as "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.PUBLISHER",
                        "PUBLISHER_TOOLTIP": "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.PUBLISHER_TOOLTIP" as "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.PUBLISHER_TOOLTIP",
                        "ROLES": "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.ROLES" as "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.ROLES",
                        "SPECIAL_REQUESTER": "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.SPECIAL_REQUESTER" as "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.SPECIAL_REQUESTER",
                        "SPECIAL_REQUESTER_TOOLTIP": "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.SPECIAL_REQUESTER_TOOLTIP" as "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.SPECIAL_REQUESTER_TOOLTIP",
                        "SPECIAL_REQUESTS": "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.SPECIAL_REQUESTS" as "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.SPECIAL_REQUESTS",
                        "TIMEZONE": "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.TIMEZONE" as "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.TIMEZONE",
                        "UPDATE": "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.UPDATE" as "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.UPDATE",
                        "USER_DELETED": "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.USER_DELETED" as "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.USER_DELETED",
                        "USER_UPDATED": "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.USER_UPDATED" as "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.USER_UPDATED"
                    },
                    "USER_REMOVED": "AGENCY.CLIENT.LOCATION.USERS.USER_REMOVED" as "AGENCY.CLIENT.LOCATION.USERS.USER_REMOVED",
                    "YOUR_INVITE_HAS_BEEN_SENT": "AGENCY.CLIENT.LOCATION.USERS.YOUR_INVITE_HAS_BEEN_SENT" as "AGENCY.CLIENT.LOCATION.USERS.YOUR_INVITE_HAS_BEEN_SENT"
                }
            },
            "LOCATIONS": {
                "ADD_NEW_LOCATION": "AGENCY.CLIENT.LOCATIONS.ADD_NEW_LOCATION" as "AGENCY.CLIENT.LOCATIONS.ADD_NEW_LOCATION",
                "COUNTRY": "AGENCY.CLIENT.LOCATIONS.COUNTRY" as "AGENCY.CLIENT.LOCATIONS.COUNTRY",
                "COUNTRY_UPDATED": "AGENCY.CLIENT.LOCATIONS.COUNTRY_UPDATED" as "AGENCY.CLIENT.LOCATIONS.COUNTRY_UPDATED",
                "CURRENCY": "AGENCY.CLIENT.LOCATIONS.CURRENCY" as "AGENCY.CLIENT.LOCATIONS.CURRENCY",
                "CURRENCY_UPDATED": "AGENCY.CLIENT.LOCATIONS.CURRENCY_UPDATED" as "AGENCY.CLIENT.LOCATIONS.CURRENCY_UPDATED",
                "DEFAULT_SUPPORTED_PLANNER_LIMIT": "AGENCY.CLIENT.LOCATIONS.DEFAULT_SUPPORTED_PLANNER_LIMIT" as "AGENCY.CLIENT.LOCATIONS.DEFAULT_SUPPORTED_PLANNER_LIMIT",
                "DEFAULT_SUPPORTED_PLANNER_LIMIT_UPDATED": "AGENCY.CLIENT.LOCATIONS.DEFAULT_SUPPORTED_PLANNER_LIMIT_UPDATED" as "AGENCY.CLIENT.LOCATIONS.DEFAULT_SUPPORTED_PLANNER_LIMIT_UPDATED",
                "DELETE_CLIENT": "AGENCY.CLIENT.LOCATIONS.DELETE_CLIENT" as "AGENCY.CLIENT.LOCATIONS.DELETE_CLIENT",
                "DELETE_PERMANENTLY": "AGENCY.CLIENT.LOCATIONS.DELETE_PERMANENTLY" as "AGENCY.CLIENT.LOCATIONS.DELETE_PERMANENTLY",
                "EMAILS": {
                    "SIGNED_UP": {
                        "LOCATION_SIGNED_UP": "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGNED_UP.LOCATION_SIGNED_UP" as "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGNED_UP.LOCATION_SIGNED_UP",
                        "NEW_LOCATION_SIGNED_UP": "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGNED_UP.NEW_LOCATION_SIGNED_UP" as "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGNED_UP.NEW_LOCATION_SIGNED_UP",
                        "VISIT_DIGITAL_STACK": "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGNED_UP.VISIT_DIGITAL_STACK" as "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGNED_UP.VISIT_DIGITAL_STACK"
                    },
                    "SIGN_UP": {
                        "ACTIVATE_YOUR_ENHANCED_PACKAGE": "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.ACTIVATE_YOUR_ENHANCED_PACKAGE" as "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.ACTIVATE_YOUR_ENHANCED_PACKAGE",
                        "AGENCY_INVITED_YOU": "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.AGENCY_INVITED_YOU" as "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.AGENCY_INVITED_YOU",
                        "CLICK_BELOW_TO_UPDATE_DETAILS": "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.CLICK_BELOW_TO_UPDATE_DETAILS" as "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.CLICK_BELOW_TO_UPDATE_DETAILS",
                        "CLICK_BUTTON_TO_COMPLETE_SIGN_UP": "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.CLICK_BUTTON_TO_COMPLETE_SIGN_UP" as "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.CLICK_BUTTON_TO_COMPLETE_SIGN_UP",
                        "DEFAULT_EMAIL_SUBJECT": "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.DEFAULT_EMAIL_SUBJECT" as "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.DEFAULT_EMAIL_SUBJECT",
                        "INCLUSIONS_CHANGED_TO_OFFER_BETTER_VALUE": "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.INCLUSIONS_CHANGED_TO_OFFER_BETTER_VALUE" as "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.INCLUSIONS_CHANGED_TO_OFFER_BETTER_VALUE",
                        "SIGN_UP": "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.SIGN_UP" as "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.SIGN_UP",
                        "THESE_DETAILS_ALLOW_SPECIFIC_SERVICES": "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.THESE_DETAILS_ALLOW_SPECIFIC_SERVICES" as "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.THESE_DETAILS_ALLOW_SPECIFIC_SERVICES",
                        "WELCOME_TO_DIGITAL_STACK": "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.WELCOME_TO_DIGITAL_STACK" as "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.WELCOME_TO_DIGITAL_STACK",
                        "WE_REQUIRE_CONFIRMATION_OF_DETAILS": "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.WE_REQUIRE_CONFIRMATION_OF_DETAILS" as "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.WE_REQUIRE_CONFIRMATION_OF_DETAILS",
                        "YOURE_INVITED": "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.YOURE_INVITED" as "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.YOURE_INVITED",
                        "YOU_NEED_TO_FILL_OUT_DETAILS": "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.YOU_NEED_TO_FILL_OUT_DETAILS" as "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.YOU_NEED_TO_FILL_OUT_DETAILS"
                    },
                    "UPDATE_BILLING_DETAILS": {
                        "CLICK_TO_UPDATE_BILLING_DETAILS": "AGENCY.CLIENT.LOCATIONS.EMAILS.UPDATE_BILLING_DETAILS.CLICK_TO_UPDATE_BILLING_DETAILS" as "AGENCY.CLIENT.LOCATIONS.EMAILS.UPDATE_BILLING_DETAILS.CLICK_TO_UPDATE_BILLING_DETAILS",
                        "REQUEST_TO_UPDATE_BILLING_DETAILS": "AGENCY.CLIENT.LOCATIONS.EMAILS.UPDATE_BILLING_DETAILS.REQUEST_TO_UPDATE_BILLING_DETAILS" as "AGENCY.CLIENT.LOCATIONS.EMAILS.UPDATE_BILLING_DETAILS.REQUEST_TO_UPDATE_BILLING_DETAILS",
                        "SUBJECT_LINE": "AGENCY.CLIENT.LOCATIONS.EMAILS.UPDATE_BILLING_DETAILS.SUBJECT_LINE" as "AGENCY.CLIENT.LOCATIONS.EMAILS.UPDATE_BILLING_DETAILS.SUBJECT_LINE",
                        "UPDATE_YOUR_BILLING_DETAILS": "AGENCY.CLIENT.LOCATIONS.EMAILS.UPDATE_BILLING_DETAILS.UPDATE_YOUR_BILLING_DETAILS" as "AGENCY.CLIENT.LOCATIONS.EMAILS.UPDATE_BILLING_DETAILS.UPDATE_YOUR_BILLING_DETAILS",
                        "WE_REQUIRE_YOU_TO_UPDATE_BILLING_DETAILS": "AGENCY.CLIENT.LOCATIONS.EMAILS.UPDATE_BILLING_DETAILS.WE_REQUIRE_YOU_TO_UPDATE_BILLING_DETAILS" as "AGENCY.CLIENT.LOCATIONS.EMAILS.UPDATE_BILLING_DETAILS.WE_REQUIRE_YOU_TO_UPDATE_BILLING_DETAILS"
                    }
                },
                "ERROR_DELETING_CLIENT": "AGENCY.CLIENT.LOCATIONS.ERROR_DELETING_CLIENT" as "AGENCY.CLIENT.LOCATIONS.ERROR_DELETING_CLIENT",
                "HEADERS": {
                    "YOUR_BRANDS": "AGENCY.CLIENT.LOCATIONS.HEADERS.YOUR_BRANDS" as "AGENCY.CLIENT.LOCATIONS.HEADERS.YOUR_BRANDS"
                },
                "INVITATION_SENT": "AGENCY.CLIENT.LOCATIONS.INVITATION_SENT" as "AGENCY.CLIENT.LOCATIONS.INVITATION_SENT",
                "INVITE": "AGENCY.CLIENT.LOCATIONS.INVITE" as "AGENCY.CLIENT.LOCATIONS.INVITE",
                "LOCATION": "AGENCY.CLIENT.LOCATIONS.LOCATION" as "AGENCY.CLIENT.LOCATIONS.LOCATION",
                "LOCATIONS": "AGENCY.CLIENT.LOCATIONS.LOCATIONS" as "AGENCY.CLIENT.LOCATIONS.LOCATIONS",
                "LOCATION_ADDED": "AGENCY.CLIENT.LOCATIONS.LOCATION_ADDED" as "AGENCY.CLIENT.LOCATIONS.LOCATION_ADDED",
                "LOCATION_GROUPS_NO_CATEGORIES_TOOLTIP": "AGENCY.CLIENT.LOCATIONS.LOCATION_GROUPS_NO_CATEGORIES_TOOLTIP" as "AGENCY.CLIENT.LOCATIONS.LOCATION_GROUPS_NO_CATEGORIES_TOOLTIP",
                "NO_LOCATIONS_ASSIGNED": "AGENCY.CLIENT.LOCATIONS.NO_LOCATIONS_ASSIGNED" as "AGENCY.CLIENT.LOCATIONS.NO_LOCATIONS_ASSIGNED",
                "NO_LOCATION_GROUPS": "AGENCY.CLIENT.LOCATIONS.NO_LOCATION_GROUPS" as "AGENCY.CLIENT.LOCATIONS.NO_LOCATION_GROUPS",
                "PERMANENTLY_DELETED_CLIENT": "AGENCY.CLIENT.LOCATIONS.PERMANENTLY_DELETED_CLIENT" as "AGENCY.CLIENT.LOCATIONS.PERMANENTLY_DELETED_CLIENT",
                "REQUEST_UPDATE_BILLING_DETAILS_SENT": "AGENCY.CLIENT.LOCATIONS.REQUEST_UPDATE_BILLING_DETAILS_SENT" as "AGENCY.CLIENT.LOCATIONS.REQUEST_UPDATE_BILLING_DETAILS_SENT",
                "RESEND": "AGENCY.CLIENT.LOCATIONS.RESEND" as "AGENCY.CLIENT.LOCATIONS.RESEND",
                "SIGNED_UP": "AGENCY.CLIENT.LOCATIONS.SIGNED_UP" as "AGENCY.CLIENT.LOCATIONS.SIGNED_UP",
                "SUBSCRIPTION_ACTIVE": "AGENCY.CLIENT.LOCATIONS.SUBSCRIPTION_ACTIVE" as "AGENCY.CLIENT.LOCATIONS.SUBSCRIPTION_ACTIVE",
                "SUBSCRIPTION_AMOUNT": "AGENCY.CLIENT.LOCATIONS.SUBSCRIPTION_AMOUNT" as "AGENCY.CLIENT.LOCATIONS.SUBSCRIPTION_AMOUNT",
                "TIMEZONE": "AGENCY.CLIENT.LOCATIONS.TIMEZONE" as "AGENCY.CLIENT.LOCATIONS.TIMEZONE",
                "UPDATE_BILLING_DETAILS": "AGENCY.CLIENT.LOCATIONS.UPDATE_BILLING_DETAILS" as "AGENCY.CLIENT.LOCATIONS.UPDATE_BILLING_DETAILS"
            },
            "LOCATION_CATEGORIES": {
                "ADD_REGION_OR_GROUP": "AGENCY.CLIENT.LOCATION_CATEGORIES.ADD_REGION_OR_GROUP" as "AGENCY.CLIENT.LOCATION_CATEGORIES.ADD_REGION_OR_GROUP",
                "ADD_TO_GROUP": "AGENCY.CLIENT.LOCATION_CATEGORIES.ADD_TO_GROUP" as "AGENCY.CLIENT.LOCATION_CATEGORIES.ADD_TO_GROUP",
                "ASSOCIATE_COLLECTION_PLACEHOLDER": "AGENCY.CLIENT.LOCATION_CATEGORIES.ASSOCIATE_COLLECTION_PLACEHOLDER" as "AGENCY.CLIENT.LOCATION_CATEGORIES.ASSOCIATE_COLLECTION_PLACEHOLDER",
                "ASSOCIATE_TEMPLATE_CATEGORY_PLACEHOLDER": "AGENCY.CLIENT.LOCATION_CATEGORIES.ASSOCIATE_TEMPLATE_CATEGORY_PLACEHOLDER" as "AGENCY.CLIENT.LOCATION_CATEGORIES.ASSOCIATE_TEMPLATE_CATEGORY_PLACEHOLDER",
                "DELETED_LOCATION_CATEGORY": "AGENCY.CLIENT.LOCATION_CATEGORIES.DELETED_LOCATION_CATEGORY" as "AGENCY.CLIENT.LOCATION_CATEGORIES.DELETED_LOCATION_CATEGORY",
                "DELETE_CONFIRMATION": "AGENCY.CLIENT.LOCATION_CATEGORIES.DELETE_CONFIRMATION" as "AGENCY.CLIENT.LOCATION_CATEGORIES.DELETE_CONFIRMATION",
                "DELETE_GROUP": "AGENCY.CLIENT.LOCATION_CATEGORIES.DELETE_GROUP" as "AGENCY.CLIENT.LOCATION_CATEGORIES.DELETE_GROUP",
                "DELETE_LOCATION_CATEGORY_CONFIRM": "AGENCY.CLIENT.LOCATION_CATEGORIES.DELETE_LOCATION_CATEGORY_CONFIRM" as "AGENCY.CLIENT.LOCATION_CATEGORIES.DELETE_LOCATION_CATEGORY_CONFIRM",
                "ERRORS": {
                    "FAILED_ASSOCIATE_COLLECTIONS": "AGENCY.CLIENT.LOCATION_CATEGORIES.ERRORS.FAILED_ASSOCIATE_COLLECTIONS" as "AGENCY.CLIENT.LOCATION_CATEGORIES.ERRORS.FAILED_ASSOCIATE_COLLECTIONS",
                    "FAILED_ASSOCIATE_TEMPLATE_CATEGORIES": "AGENCY.CLIENT.LOCATION_CATEGORIES.ERRORS.FAILED_ASSOCIATE_TEMPLATE_CATEGORIES" as "AGENCY.CLIENT.LOCATION_CATEGORIES.ERRORS.FAILED_ASSOCIATE_TEMPLATE_CATEGORIES",
                    "MISSING_COLLECTIONS_OR_CATEGORIES": "AGENCY.CLIENT.LOCATION_CATEGORIES.ERRORS.MISSING_COLLECTIONS_OR_CATEGORIES" as "AGENCY.CLIENT.LOCATION_CATEGORIES.ERRORS.MISSING_COLLECTIONS_OR_CATEGORIES"
                },
                "FOLLOWING_LOCATIONS_ALREADY_ASSOCIATED_WITH_REGION": "AGENCY.CLIENT.LOCATION_CATEGORIES.FOLLOWING_LOCATIONS_ALREADY_ASSOCIATED_WITH_REGION" as "AGENCY.CLIENT.LOCATION_CATEGORIES.FOLLOWING_LOCATIONS_ALREADY_ASSOCIATED_WITH_REGION",
                "GROUP": "AGENCY.CLIENT.LOCATION_CATEGORIES.GROUP" as "AGENCY.CLIENT.LOCATION_CATEGORIES.GROUP",
                "LABELS": {
                    "COLLECTIONS": "AGENCY.CLIENT.LOCATION_CATEGORIES.LABELS.COLLECTIONS" as "AGENCY.CLIENT.LOCATION_CATEGORIES.LABELS.COLLECTIONS",
                    "LINK_TEMPLATE_CATEGORIES_AND_COLLECTIONS": "AGENCY.CLIENT.LOCATION_CATEGORIES.LABELS.LINK_TEMPLATE_CATEGORIES_AND_COLLECTIONS" as "AGENCY.CLIENT.LOCATION_CATEGORIES.LABELS.LINK_TEMPLATE_CATEGORIES_AND_COLLECTIONS",
                    "NAME": "AGENCY.CLIENT.LOCATION_CATEGORIES.LABELS.NAME" as "AGENCY.CLIENT.LOCATION_CATEGORIES.LABELS.NAME",
                    "TYPE": "AGENCY.CLIENT.LOCATION_CATEGORIES.LABELS.TYPE" as "AGENCY.CLIENT.LOCATION_CATEGORIES.LABELS.TYPE"
                },
                "LOCATION_CATEGORIES": "AGENCY.CLIENT.LOCATION_CATEGORIES.LOCATION_CATEGORIES" as "AGENCY.CLIENT.LOCATION_CATEGORIES.LOCATION_CATEGORIES",
                "LOCATION_GROUP": "AGENCY.CLIENT.LOCATION_CATEGORIES.LOCATION_GROUP" as "AGENCY.CLIENT.LOCATION_CATEGORIES.LOCATION_GROUP",
                "LOCATION_REGION": "AGENCY.CLIENT.LOCATION_CATEGORIES.LOCATION_REGION" as "AGENCY.CLIENT.LOCATION_CATEGORIES.LOCATION_REGION",
                "NEW_OPTION": "AGENCY.CLIENT.LOCATION_CATEGORIES.NEW_OPTION" as "AGENCY.CLIENT.LOCATION_CATEGORIES.NEW_OPTION",
                "NOTIFY_ENTER_LABEL_FOR_CATEGORY": "AGENCY.CLIENT.LOCATION_CATEGORIES.NOTIFY_ENTER_LABEL_FOR_CATEGORY" as "AGENCY.CLIENT.LOCATION_CATEGORIES.NOTIFY_ENTER_LABEL_FOR_CATEGORY",
                "OPTION_ADDED": "AGENCY.CLIENT.LOCATION_CATEGORIES.OPTION_ADDED" as "AGENCY.CLIENT.LOCATION_CATEGORIES.OPTION_ADDED",
                "OPTION_DELETED": "AGENCY.CLIENT.LOCATION_CATEGORIES.OPTION_DELETED" as "AGENCY.CLIENT.LOCATION_CATEGORIES.OPTION_DELETED",
                "PARTIALLY_ADDED_LOCATION_CATEGORY": "AGENCY.CLIENT.LOCATION_CATEGORIES.PARTIALLY_ADDED_LOCATION_CATEGORY" as "AGENCY.CLIENT.LOCATION_CATEGORIES.PARTIALLY_ADDED_LOCATION_CATEGORY",
                "PARTIALLY_EDITED_LOCATION_CATEGORY": "AGENCY.CLIENT.LOCATION_CATEGORIES.PARTIALLY_EDITED_LOCATION_CATEGORY" as "AGENCY.CLIENT.LOCATION_CATEGORIES.PARTIALLY_EDITED_LOCATION_CATEGORY",
                "RADIO_DISABLED_MESSAGE": "AGENCY.CLIENT.LOCATION_CATEGORIES.RADIO_DISABLED_MESSAGE" as "AGENCY.CLIENT.LOCATION_CATEGORIES.RADIO_DISABLED_MESSAGE",
                "REGION": "AGENCY.CLIENT.LOCATION_CATEGORIES.REGION" as "AGENCY.CLIENT.LOCATION_CATEGORIES.REGION",
                "SELECTED_LOCATIONS": "AGENCY.CLIENT.LOCATION_CATEGORIES.SELECTED_LOCATIONS" as "AGENCY.CLIENT.LOCATION_CATEGORIES.SELECTED_LOCATIONS",
                "SUCCESSFULLY_ADDED_LOCATION_CATEGORY": "AGENCY.CLIENT.LOCATION_CATEGORIES.SUCCESSFULLY_ADDED_LOCATION_CATEGORY" as "AGENCY.CLIENT.LOCATION_CATEGORIES.SUCCESSFULLY_ADDED_LOCATION_CATEGORY",
                "SUCCESSFULLY_EDITED_LOCATION_CATEGORY": "AGENCY.CLIENT.LOCATION_CATEGORIES.SUCCESSFULLY_EDITED_LOCATION_CATEGORY" as "AGENCY.CLIENT.LOCATION_CATEGORIES.SUCCESSFULLY_EDITED_LOCATION_CATEGORY",
                "TOOLTIPS": {
                    "GROUP_MESSAGE": "AGENCY.CLIENT.LOCATION_CATEGORIES.TOOLTIPS.GROUP_MESSAGE" as "AGENCY.CLIENT.LOCATION_CATEGORIES.TOOLTIPS.GROUP_MESSAGE",
                    "LINK_TEMPLATE_CATEGORIES_AND_COLLECTIONS": "AGENCY.CLIENT.LOCATION_CATEGORIES.TOOLTIPS.LINK_TEMPLATE_CATEGORIES_AND_COLLECTIONS" as "AGENCY.CLIENT.LOCATION_CATEGORIES.TOOLTIPS.LINK_TEMPLATE_CATEGORIES_AND_COLLECTIONS",
                    "REGION_MESSAGE": "AGENCY.CLIENT.LOCATION_CATEGORIES.TOOLTIPS.REGION_MESSAGE" as "AGENCY.CLIENT.LOCATION_CATEGORIES.TOOLTIPS.REGION_MESSAGE"
                },
                "UPDATED_LOCATIONS_FOR_CATEGORY": "AGENCY.CLIENT.LOCATION_CATEGORIES.UPDATED_LOCATIONS_FOR_CATEGORY" as "AGENCY.CLIENT.LOCATION_CATEGORIES.UPDATED_LOCATIONS_FOR_CATEGORY"
            },
            "NOTIFICATION_EMAIL_ADDRESSES_UPDATED": "AGENCY.CLIENT.NOTIFICATION_EMAIL_ADDRESSES_UPDATED" as "AGENCY.CLIENT.NOTIFICATION_EMAIL_ADDRESSES_UPDATED",
            "NUMBER_OF_LOCATIONS": "AGENCY.CLIENT.NUMBER_OF_LOCATIONS" as "AGENCY.CLIENT.NUMBER_OF_LOCATIONS",
            "PLATFORMS": {
                "ALL": "AGENCY.CLIENT.PLATFORMS.ALL" as "AGENCY.CLIENT.PLATFORMS.ALL",
                "CANNOT_REMOVE_PLATFORM_LINKED_CHANNELS": "AGENCY.CLIENT.PLATFORMS.CANNOT_REMOVE_PLATFORM_LINKED_CHANNELS" as "AGENCY.CLIENT.PLATFORMS.CANNOT_REMOVE_PLATFORM_LINKED_CHANNELS",
                "CANNOT_REMOVE_PLATFORM_LINKED_TEMPLATES": "AGENCY.CLIENT.PLATFORMS.CANNOT_REMOVE_PLATFORM_LINKED_TEMPLATES" as "AGENCY.CLIENT.PLATFORMS.CANNOT_REMOVE_PLATFORM_LINKED_TEMPLATES",
                "CONFIGURE": "AGENCY.CLIENT.PLATFORMS.CONFIGURE" as "AGENCY.CLIENT.PLATFORMS.CONFIGURE",
                "CONFIRM_REMOVE_PLATFORM": "AGENCY.CLIENT.PLATFORMS.CONFIRM_REMOVE_PLATFORM" as "AGENCY.CLIENT.PLATFORMS.CONFIRM_REMOVE_PLATFORM",
                "CONFIRM_REMOVE_PLATFORM_TITLE": "AGENCY.CLIENT.PLATFORMS.CONFIRM_REMOVE_PLATFORM_TITLE" as "AGENCY.CLIENT.PLATFORMS.CONFIRM_REMOVE_PLATFORM_TITLE",
                "DISABLE_PLATFORM": "AGENCY.CLIENT.PLATFORMS.DISABLE_PLATFORM" as "AGENCY.CLIENT.PLATFORMS.DISABLE_PLATFORM",
                "ENABLED": "AGENCY.CLIENT.PLATFORMS.ENABLED" as "AGENCY.CLIENT.PLATFORMS.ENABLED",
                "ENABLE_PLATFORM": "AGENCY.CLIENT.PLATFORMS.ENABLE_PLATFORM" as "AGENCY.CLIENT.PLATFORMS.ENABLE_PLATFORM",
                "FETCH_CLIENT_PLATFORMS": "AGENCY.CLIENT.PLATFORMS.FETCH_CLIENT_PLATFORMS" as "AGENCY.CLIENT.PLATFORMS.FETCH_CLIENT_PLATFORMS",
                "FILTER_BY_STATUS": "AGENCY.CLIENT.PLATFORMS.FILTER_BY_STATUS" as "AGENCY.CLIENT.PLATFORMS.FILTER_BY_STATUS",
                "FILTER_PLATFORMS": "AGENCY.CLIENT.PLATFORMS.FILTER_PLATFORMS" as "AGENCY.CLIENT.PLATFORMS.FILTER_PLATFORMS",
                "PLATFORM": "AGENCY.CLIENT.PLATFORMS.PLATFORM" as "AGENCY.CLIENT.PLATFORMS.PLATFORM",
                "REQUIRED": "AGENCY.CLIENT.PLATFORMS.REQUIRED" as "AGENCY.CLIENT.PLATFORMS.REQUIRED"
            },
            "UPDATE_CONVERSION_DETAILS": "AGENCY.CLIENT.UPDATE_CONVERSION_DETAILS" as "AGENCY.CLIENT.UPDATE_CONVERSION_DETAILS",
            "UPDATE_NOTIFICATION_EMAIL_ADDRESSES": "AGENCY.CLIENT.UPDATE_NOTIFICATION_EMAIL_ADDRESSES" as "AGENCY.CLIENT.UPDATE_NOTIFICATION_EMAIL_ADDRESSES",
            "USERS": {
                "COUNT_SELECTED": "AGENCY.CLIENT.USERS.COUNT_SELECTED" as "AGENCY.CLIENT.USERS.COUNT_SELECTED",
                "SEARCH_FOR_USERS_OR_EMAIL_ADDRESSES": "AGENCY.CLIENT.USERS.SEARCH_FOR_USERS_OR_EMAIL_ADDRESSES" as "AGENCY.CLIENT.USERS.SEARCH_FOR_USERS_OR_EMAIL_ADDRESSES",
                "SORT_DIRECTION_TIP": "AGENCY.CLIENT.USERS.SORT_DIRECTION_TIP" as "AGENCY.CLIENT.USERS.SORT_DIRECTION_TIP",
                "TITLE": "AGENCY.CLIENT.USERS.TITLE" as "AGENCY.CLIENT.USERS.TITLE"
            }
        },
        "CLIENTS": {
            "ADD_CLIENT": {
                "CHANNEL_LABEL": "AGENCY.CLIENTS.ADD_CLIENT.CHANNEL_LABEL" as "AGENCY.CLIENTS.ADD_CLIENT.CHANNEL_LABEL",
                "CLIENT_ADDED": "AGENCY.CLIENTS.ADD_CLIENT.CLIENT_ADDED" as "AGENCY.CLIENTS.ADD_CLIENT.CLIENT_ADDED",
                "GENERAL": "AGENCY.CLIENTS.ADD_CLIENT.GENERAL" as "AGENCY.CLIENTS.ADD_CLIENT.GENERAL",
                "NEW_CHANNEL": "AGENCY.CLIENTS.ADD_CLIENT.NEW_CHANNEL" as "AGENCY.CLIENTS.ADD_CLIENT.NEW_CHANNEL",
                "SELECT_A_PLATFORM_TO_LINK_THIS_CHANNEL_TO_OPTIONAL": "AGENCY.CLIENTS.ADD_CLIENT.SELECT_A_PLATFORM_TO_LINK_THIS_CHANNEL_TO_OPTIONAL" as "AGENCY.CLIENTS.ADD_CLIENT.SELECT_A_PLATFORM_TO_LINK_THIS_CHANNEL_TO_OPTIONAL",
                "SELF_SERVICE": "AGENCY.CLIENTS.ADD_CLIENT.SELF_SERVICE" as "AGENCY.CLIENTS.ADD_CLIENT.SELF_SERVICE",
                "SUPPORTED": "AGENCY.CLIENTS.ADD_CLIENT.SUPPORTED" as "AGENCY.CLIENTS.ADD_CLIENT.SUPPORTED"
            },
            "ADD_NEW_CLIENT": "AGENCY.CLIENTS.ADD_NEW_CLIENT" as "AGENCY.CLIENTS.ADD_NEW_CLIENT",
            "CLIENT_NAME": "AGENCY.CLIENTS.CLIENT_NAME" as "AGENCY.CLIENTS.CLIENT_NAME",
            "CLIENT_TABLE": {
                "ACTIONS": {
                    "CLIENT_ACTIONS": "AGENCY.CLIENTS.CLIENT_TABLE.ACTIONS.CLIENT_ACTIONS" as "AGENCY.CLIENTS.CLIENT_TABLE.ACTIONS.CLIENT_ACTIONS",
                    "DELETE_CLIENT_DESCRIPTION": "AGENCY.CLIENTS.CLIENT_TABLE.ACTIONS.DELETE_CLIENT_DESCRIPTION" as "AGENCY.CLIENTS.CLIENT_TABLE.ACTIONS.DELETE_CLIENT_DESCRIPTION",
                    "DELETE_CLIENT_LABEL": "AGENCY.CLIENTS.CLIENT_TABLE.ACTIONS.DELETE_CLIENT_LABEL" as "AGENCY.CLIENTS.CLIENT_TABLE.ACTIONS.DELETE_CLIENT_LABEL",
                    "ENTER_NEW_NAME": "AGENCY.CLIENTS.CLIENT_TABLE.ACTIONS.ENTER_NEW_NAME" as "AGENCY.CLIENTS.CLIENT_TABLE.ACTIONS.ENTER_NEW_NAME",
                    "RENAME": "AGENCY.CLIENTS.CLIENT_TABLE.ACTIONS.RENAME" as "AGENCY.CLIENTS.CLIENT_TABLE.ACTIONS.RENAME"
                },
                "HEADERS": {
                    "ACTIONS": "AGENCY.CLIENTS.CLIENT_TABLE.HEADERS.ACTIONS" as "AGENCY.CLIENTS.CLIENT_TABLE.HEADERS.ACTIONS",
                    "AVG_BUILDS": "AGENCY.CLIENTS.CLIENT_TABLE.HEADERS.AVG_BUILDS" as "AGENCY.CLIENTS.CLIENT_TABLE.HEADERS.AVG_BUILDS",
                    "NUM_LOCATIONS": "AGENCY.CLIENTS.CLIENT_TABLE.HEADERS.NUM_LOCATIONS" as "AGENCY.CLIENTS.CLIENT_TABLE.HEADERS.NUM_LOCATIONS",
                    "PERCENTAGE_CONNECTED": "AGENCY.CLIENTS.CLIENT_TABLE.HEADERS.PERCENTAGE_CONNECTED" as "AGENCY.CLIENTS.CLIENT_TABLE.HEADERS.PERCENTAGE_CONNECTED",
                    "TITLE": "AGENCY.CLIENTS.CLIENT_TABLE.HEADERS.TITLE" as "AGENCY.CLIENTS.CLIENT_TABLE.HEADERS.TITLE"
                }
            },
            "YOU_HAVE_NOT_ADDED_ANY": "AGENCY.CLIENTS.YOU_HAVE_NOT_ADDED_ANY" as "AGENCY.CLIENTS.YOU_HAVE_NOT_ADDED_ANY"
        },
        "CONTACT_DETAILS": {
            "ADWORDS_MARKETING": "AGENCY.CONTACT_DETAILS.ADWORDS_MARKETING" as "AGENCY.CONTACT_DETAILS.ADWORDS_MARKETING",
            "AGENCY_CONTACT_DETAILS": "AGENCY.CONTACT_DETAILS.AGENCY_CONTACT_DETAILS" as "AGENCY.CONTACT_DETAILS.AGENCY_CONTACT_DETAILS",
            "CONTACT_DETAILS": "AGENCY.CONTACT_DETAILS.CONTACT_DETAILS" as "AGENCY.CONTACT_DETAILS.CONTACT_DETAILS",
            "SPECIAL_REQUEST_DISCLAIMER": "AGENCY.CONTACT_DETAILS.SPECIAL_REQUEST_DISCLAIMER" as "AGENCY.CONTACT_DETAILS.SPECIAL_REQUEST_DISCLAIMER",
            "UPDATE_CONTACTS": "AGENCY.CONTACT_DETAILS.UPDATE_CONTACTS" as "AGENCY.CONTACT_DETAILS.UPDATE_CONTACTS"
        },
        "HASHTAG_SETS": {
            "ACTIONS": {
                "ADD_HASHTAG_SET": "AGENCY.HASHTAG_SETS.ACTIONS.ADD_HASHTAG_SET" as "AGENCY.HASHTAG_SETS.ACTIONS.ADD_HASHTAG_SET",
                "MESSAGES": {
                    "COULD_NOT_CREATE_SET": "AGENCY.HASHTAG_SETS.ACTIONS.MESSAGES.COULD_NOT_CREATE_SET" as "AGENCY.HASHTAG_SETS.ACTIONS.MESSAGES.COULD_NOT_CREATE_SET",
                    "COULD_NOT_DELETE_SET": "AGENCY.HASHTAG_SETS.ACTIONS.MESSAGES.COULD_NOT_DELETE_SET" as "AGENCY.HASHTAG_SETS.ACTIONS.MESSAGES.COULD_NOT_DELETE_SET",
                    "COULD_NOT_UPDATE_SET": "AGENCY.HASHTAG_SETS.ACTIONS.MESSAGES.COULD_NOT_UPDATE_SET" as "AGENCY.HASHTAG_SETS.ACTIONS.MESSAGES.COULD_NOT_UPDATE_SET",
                    "CREATED_SET": "AGENCY.HASHTAG_SETS.ACTIONS.MESSAGES.CREATED_SET" as "AGENCY.HASHTAG_SETS.ACTIONS.MESSAGES.CREATED_SET",
                    "DELETED_SET": "AGENCY.HASHTAG_SETS.ACTIONS.MESSAGES.DELETED_SET" as "AGENCY.HASHTAG_SETS.ACTIONS.MESSAGES.DELETED_SET",
                    "UPDATED_SET": "AGENCY.HASHTAG_SETS.ACTIONS.MESSAGES.UPDATED_SET" as "AGENCY.HASHTAG_SETS.ACTIONS.MESSAGES.UPDATED_SET"
                },
                "UPDATE_HASHTAG_SET": "AGENCY.HASHTAG_SETS.ACTIONS.UPDATE_HASHTAG_SET" as "AGENCY.HASHTAG_SETS.ACTIONS.UPDATE_HASHTAG_SET"
            },
            "DIALOG": {
                "MINIMUM_ONE": "AGENCY.HASHTAG_SETS.DIALOG.MINIMUM_ONE" as "AGENCY.HASHTAG_SETS.DIALOG.MINIMUM_ONE",
                "REQUIRED_FOR_ALL_POSTS": "AGENCY.HASHTAG_SETS.DIALOG.REQUIRED_FOR_ALL_POSTS" as "AGENCY.HASHTAG_SETS.DIALOG.REQUIRED_FOR_ALL_POSTS",
                "START_BY_TYPING_YOUR_HASHTAGS": "AGENCY.HASHTAG_SETS.DIALOG.START_BY_TYPING_YOUR_HASHTAGS" as "AGENCY.HASHTAG_SETS.DIALOG.START_BY_TYPING_YOUR_HASHTAGS"
            },
            "HASHTAGS": "AGENCY.HASHTAG_SETS.HASHTAGS" as "AGENCY.HASHTAG_SETS.HASHTAGS",
            "HASHTAG_SETS": "AGENCY.HASHTAG_SETS.HASHTAG_SETS" as "AGENCY.HASHTAG_SETS.HASHTAG_SETS",
            "TABLE_HEADERS": {
                "DESCRIPTION": "AGENCY.HASHTAG_SETS.TABLE_HEADERS.DESCRIPTION" as "AGENCY.HASHTAG_SETS.TABLE_HEADERS.DESCRIPTION",
                "NUMBER_HASHTAGS": "AGENCY.HASHTAG_SETS.TABLE_HEADERS.NUMBER_HASHTAGS" as "AGENCY.HASHTAG_SETS.TABLE_HEADERS.NUMBER_HASHTAGS",
                "TITLE": "AGENCY.HASHTAG_SETS.TABLE_HEADERS.TITLE" as "AGENCY.HASHTAG_SETS.TABLE_HEADERS.TITLE"
            }
        },
        "NOTIFICATIONS": {
            "AGENCY_EMAIL_NOTIFICATIONS": "AGENCY.NOTIFICATIONS.AGENCY_EMAIL_NOTIFICATIONS" as "AGENCY.NOTIFICATIONS.AGENCY_EMAIL_NOTIFICATIONS",
            "AGENCY_NOTIFICATIONS": "AGENCY.NOTIFICATIONS.AGENCY_NOTIFICATIONS" as "AGENCY.NOTIFICATIONS.AGENCY_NOTIFICATIONS",
            "CLICKS": "AGENCY.NOTIFICATIONS.CLICKS" as "AGENCY.NOTIFICATIONS.CLICKS",
            "CLICK_RATE": "AGENCY.NOTIFICATIONS.CLICK_RATE" as "AGENCY.NOTIFICATIONS.CLICK_RATE",
            "EMAIL_ADDRESS": "AGENCY.NOTIFICATIONS.EMAIL_ADDRESS" as "AGENCY.NOTIFICATIONS.EMAIL_ADDRESS",
            "FAILED_TO_LOAD": "AGENCY.NOTIFICATIONS.FAILED_TO_LOAD" as "AGENCY.NOTIFICATIONS.FAILED_TO_LOAD",
            "HELP_TEXT": {
                "CLICKS": "AGENCY.NOTIFICATIONS.HELP_TEXT.CLICKS" as "AGENCY.NOTIFICATIONS.HELP_TEXT.CLICKS",
                "SENT": "AGENCY.NOTIFICATIONS.HELP_TEXT.SENT" as "AGENCY.NOTIFICATIONS.HELP_TEXT.SENT"
            },
            "NEW_COMMENTS": "AGENCY.NOTIFICATIONS.NEW_COMMENTS" as "AGENCY.NOTIFICATIONS.NEW_COMMENTS",
            "NEW_SPECIAL_REQUESTS": "AGENCY.NOTIFICATIONS.NEW_SPECIAL_REQUESTS" as "AGENCY.NOTIFICATIONS.NEW_SPECIAL_REQUESTS",
            "NOTIFICATIONS_WILL_BE_SENT": "AGENCY.NOTIFICATIONS.NOTIFICATIONS_WILL_BE_SENT" as "AGENCY.NOTIFICATIONS.NOTIFICATIONS_WILL_BE_SENT",
            "NO_LINK_PROVIDED": "AGENCY.NOTIFICATIONS.NO_LINK_PROVIDED" as "AGENCY.NOTIFICATIONS.NO_LINK_PROVIDED",
            "NO_NOTIFICATIONS_FOUND": "AGENCY.NOTIFICATIONS.NO_NOTIFICATIONS_FOUND" as "AGENCY.NOTIFICATIONS.NO_NOTIFICATIONS_FOUND",
            "OPEN_LINK": "AGENCY.NOTIFICATIONS.OPEN_LINK" as "AGENCY.NOTIFICATIONS.OPEN_LINK",
            "SENDING_INFO": {
                "MOBILE": "AGENCY.NOTIFICATIONS.SENDING_INFO.MOBILE" as "AGENCY.NOTIFICATIONS.SENDING_INFO.MOBILE",
                "TITLE": "AGENCY.NOTIFICATIONS.SENDING_INFO.TITLE" as "AGENCY.NOTIFICATIONS.SENDING_INFO.TITLE",
                "WEBSITE": "AGENCY.NOTIFICATIONS.SENDING_INFO.WEBSITE" as "AGENCY.NOTIFICATIONS.SENDING_INFO.WEBSITE"
            },
            "SEND_CONFIRM": {
                "MESSAGE": "AGENCY.NOTIFICATIONS.SEND_CONFIRM.MESSAGE" as "AGENCY.NOTIFICATIONS.SEND_CONFIRM.MESSAGE",
                "MESSAGE_plural": "AGENCY.NOTIFICATIONS.SEND_CONFIRM.MESSAGE_plural" as "AGENCY.NOTIFICATIONS.SEND_CONFIRM.MESSAGE_plural",
                "TITLE": "AGENCY.NOTIFICATIONS.SEND_CONFIRM.TITLE" as "AGENCY.NOTIFICATIONS.SEND_CONFIRM.TITLE"
            },
            "SEND_NOTIFICATION": "AGENCY.NOTIFICATIONS.SEND_NOTIFICATION" as "AGENCY.NOTIFICATIONS.SEND_NOTIFICATION",
            "SENT": "AGENCY.NOTIFICATIONS.SENT" as "AGENCY.NOTIFICATIONS.SENT",
            "SENT_BY": "AGENCY.NOTIFICATIONS.SENT_BY" as "AGENCY.NOTIFICATIONS.SENT_BY",
            "SENT_NOTIFICATIONS": "AGENCY.NOTIFICATIONS.SENT_NOTIFICATIONS" as "AGENCY.NOTIFICATIONS.SENT_NOTIFICATIONS",
            "SUBJECT": "AGENCY.NOTIFICATIONS.SUBJECT" as "AGENCY.NOTIFICATIONS.SUBJECT"
        },
        "PRINT_SKU_GROUPS": {
            "AGENCY_PRINT_PRODUCTS": "AGENCY.PRINT_SKU_GROUPS.AGENCY_PRINT_PRODUCTS" as "AGENCY.PRINT_SKU_GROUPS.AGENCY_PRINT_PRODUCTS",
            "ATTACHED_PROVIDERS": "AGENCY.PRINT_SKU_GROUPS.ATTACHED_PROVIDERS" as "AGENCY.PRINT_SKU_GROUPS.ATTACHED_PROVIDERS",
            "DEFAULT_CURRENCY": "AGENCY.PRINT_SKU_GROUPS.DEFAULT_CURRENCY" as "AGENCY.PRINT_SKU_GROUPS.DEFAULT_CURRENCY",
            "PRINT_PROVIDER": {
                "ADD_NEW_PRINT_PROVIDER": "AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.ADD_NEW_PRINT_PROVIDER" as "AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.ADD_NEW_PRINT_PROVIDER",
                "ATTACH_TO_SKU_GROUP": "AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.ATTACH_TO_SKU_GROUP" as "AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.ATTACH_TO_SKU_GROUP",
                "AUTH_REQUEST_CONFIRMATION": "AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.AUTH_REQUEST_CONFIRMATION" as "AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.AUTH_REQUEST_CONFIRMATION",
                "NO_AVAILABLE_CLIENTS": "AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.NO_AVAILABLE_CLIENTS" as "AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.NO_AVAILABLE_CLIENTS",
                "PAYMENT_AUTH": "AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.PAYMENT_AUTH" as "AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.PAYMENT_AUTH",
                "PRINT_PROVIDER_ADDED": "AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.PRINT_PROVIDER_ADDED" as "AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.PRINT_PROVIDER_ADDED",
                "PRINT_PROVIDER_ATTACHED": "AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.PRINT_PROVIDER_ATTACHED" as "AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.PRINT_PROVIDER_ATTACHED",
                "PRINT_PROVIDER_DETACHED": "AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.PRINT_PROVIDER_DETACHED" as "AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.PRINT_PROVIDER_DETACHED",
                "SEND_AUTH_REQUEST": "AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.SEND_AUTH_REQUEST" as "AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.SEND_AUTH_REQUEST"
            },
            "PRINT_PROVIDERS": "AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDERS" as "AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDERS",
            "PRINT_SKU_GROUPS": "AGENCY.PRINT_SKU_GROUPS.PRINT_SKU_GROUPS" as "AGENCY.PRINT_SKU_GROUPS.PRINT_SKU_GROUPS",
            "QUANTITY_OPTION": {
                "ADD_NEW_QUANTITY_OPTION": "AGENCY.PRINT_SKU_GROUPS.QUANTITY_OPTION.ADD_NEW_QUANTITY_OPTION" as "AGENCY.PRINT_SKU_GROUPS.QUANTITY_OPTION.ADD_NEW_QUANTITY_OPTION",
                "QUANTITY_ALREADY_EXISTS": "AGENCY.PRINT_SKU_GROUPS.QUANTITY_OPTION.QUANTITY_ALREADY_EXISTS" as "AGENCY.PRINT_SKU_GROUPS.QUANTITY_OPTION.QUANTITY_ALREADY_EXISTS",
                "QUANTITY_OPTION_ADDED": "AGENCY.PRINT_SKU_GROUPS.QUANTITY_OPTION.QUANTITY_OPTION_ADDED" as "AGENCY.PRINT_SKU_GROUPS.QUANTITY_OPTION.QUANTITY_OPTION_ADDED"
            },
            "QUANTITY_OPTIONS": "AGENCY.PRINT_SKU_GROUPS.QUANTITY_OPTIONS" as "AGENCY.PRINT_SKU_GROUPS.QUANTITY_OPTIONS",
            "SKU": {
                "ADD_NEW_SKU": "AGENCY.PRINT_SKU_GROUPS.SKU.ADD_NEW_SKU" as "AGENCY.PRINT_SKU_GROUPS.SKU.ADD_NEW_SKU",
                "CREATE_SKU": "AGENCY.PRINT_SKU_GROUPS.SKU.CREATE_SKU" as "AGENCY.PRINT_SKU_GROUPS.SKU.CREATE_SKU",
                "DELETE_SKU": "AGENCY.PRINT_SKU_GROUPS.SKU.DELETE_SKU" as "AGENCY.PRINT_SKU_GROUPS.SKU.DELETE_SKU",
                "EDIT_SKU": "AGENCY.PRINT_SKU_GROUPS.SKU.EDIT_SKU" as "AGENCY.PRINT_SKU_GROUPS.SKU.EDIT_SKU",
                "EXCLUSIVE": "AGENCY.PRINT_SKU_GROUPS.SKU.EXCLUSIVE" as "AGENCY.PRINT_SKU_GROUPS.SKU.EXCLUSIVE",
                "FORMATS_APPLIED_TO": "AGENCY.PRINT_SKU_GROUPS.SKU.FORMATS_APPLIED_TO" as "AGENCY.PRINT_SKU_GROUPS.SKU.FORMATS_APPLIED_TO",
                "LINEAR_PRICING": "AGENCY.PRINT_SKU_GROUPS.SKU.LINEAR_PRICING" as "AGENCY.PRINT_SKU_GROUPS.SKU.LINEAR_PRICING",
                "SKU": "AGENCY.PRINT_SKU_GROUPS.SKU.SKU" as "AGENCY.PRINT_SKU_GROUPS.SKU.SKU",
                "SKU_ADDED": "AGENCY.PRINT_SKU_GROUPS.SKU.SKU_ADDED" as "AGENCY.PRINT_SKU_GROUPS.SKU.SKU_ADDED",
                "SKU_DELETED": "AGENCY.PRINT_SKU_GROUPS.SKU.SKU_DELETED" as "AGENCY.PRINT_SKU_GROUPS.SKU.SKU_DELETED",
                "SKU_DELETE_CONFIRMATION": "AGENCY.PRINT_SKU_GROUPS.SKU.SKU_DELETE_CONFIRMATION" as "AGENCY.PRINT_SKU_GROUPS.SKU.SKU_DELETE_CONFIRMATION",
                "SKU_GROUP_MISSING": "AGENCY.PRINT_SKU_GROUPS.SKU.SKU_GROUP_MISSING" as "AGENCY.PRINT_SKU_GROUPS.SKU.SKU_GROUP_MISSING",
                "SKU_UPDATED": "AGENCY.PRINT_SKU_GROUPS.SKU.SKU_UPDATED" as "AGENCY.PRINT_SKU_GROUPS.SKU.SKU_UPDATED"
            },
            "SKUS": "AGENCY.PRINT_SKU_GROUPS.SKUS" as "AGENCY.PRINT_SKU_GROUPS.SKUS",
            "SKU_GROUPS": {
                "ADD_NEW_SKU_GROUP": "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.ADD_NEW_SKU_GROUP" as "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.ADD_NEW_SKU_GROUP",
                "DELETE_SKU_GROUP": "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.DELETE_SKU_GROUP" as "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.DELETE_SKU_GROUP",
                "EDIT_SKU_GROUP": "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.EDIT_SKU_GROUP" as "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.EDIT_SKU_GROUP",
                "EDIT_SKU_GROUP_TITLE": "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.EDIT_SKU_GROUP_TITLE" as "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.EDIT_SKU_GROUP_TITLE",
                "ORDER_INFORMATION": "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.ORDER_INFORMATION" as "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.ORDER_INFORMATION",
                "PAYMENT_GATEWAY": "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.PAYMENT_GATEWAY" as "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.PAYMENT_GATEWAY",
                "PAYMENT_URL": "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.PAYMENT_URL" as "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.PAYMENT_URL",
                "SKU_GROUP": "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.SKU_GROUP" as "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.SKU_GROUP",
                "SKU_GROUP_ADDED": "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.SKU_GROUP_ADDED" as "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.SKU_GROUP_ADDED",
                "SKU_GROUP_DELETED": "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.SKU_GROUP_DELETED" as "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.SKU_GROUP_DELETED",
                "SKU_GROUP_DELETE_CONFIRMATION": "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.SKU_GROUP_DELETE_CONFIRMATION" as "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.SKU_GROUP_DELETE_CONFIRMATION",
                "SKU_GROUP_DETAILS": "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.SKU_GROUP_DETAILS" as "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.SKU_GROUP_DETAILS",
                "SKU_GROUP_UPDATED": "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.SKU_GROUP_UPDATED" as "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.SKU_GROUP_UPDATED"
            }
        },
        "SEND_REPORTS": {
            "ACTIONS": {
                "OPEN_REPORT": "AGENCY.SEND_REPORTS.ACTIONS.OPEN_REPORT" as "AGENCY.SEND_REPORTS.ACTIONS.OPEN_REPORT"
            },
            "AGENCY_USER_REPORT_TABLE": {
                "HEADERS": {
                    "CLICKED": "AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.CLICKED" as "AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.CLICKED",
                    "READ": "AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.READ" as "AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.READ",
                    "RECIPIENT_EMAIL": "AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.RECIPIENT_EMAIL" as "AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.RECIPIENT_EMAIL",
                    "RECIPIENT_EMAIL_FILTER_LABEL": "AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.RECIPIENT_EMAIL_FILTER_LABEL" as "AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.RECIPIENT_EMAIL_FILTER_LABEL",
                    "RECIPIENT_EMAIL_FILTER_PLACEHOLDER": "AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.RECIPIENT_EMAIL_FILTER_PLACEHOLDER" as "AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.RECIPIENT_EMAIL_FILTER_PLACEHOLDER",
                    "RECIPIENT_NAME": "AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.RECIPIENT_NAME" as "AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.RECIPIENT_NAME",
                    "RECIPIENT_NAME_FILTER_LABEL": "AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.RECIPIENT_NAME_FILTER_LABEL" as "AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.RECIPIENT_NAME_FILTER_LABEL",
                    "RECIPIENT_NAME_FILTER_PLACEHOLDER": "AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.RECIPIENT_NAME_FILTER_PLACEHOLDER" as "AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.RECIPIENT_NAME_FILTER_PLACEHOLDER",
                    "SENT": "AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.SENT" as "AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.SENT"
                },
                "NO_RECIPIENTS_FOUND": "AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.NO_RECIPIENTS_FOUND" as "AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.NO_RECIPIENTS_FOUND"
            },
            "REPORT": {
                "CLICKED_SUBTITLE": "AGENCY.SEND_REPORTS.REPORT.CLICKED_SUBTITLE" as "AGENCY.SEND_REPORTS.REPORT.CLICKED_SUBTITLE",
                "CLICKED_TITLE": "AGENCY.SEND_REPORTS.REPORT.CLICKED_TITLE" as "AGENCY.SEND_REPORTS.REPORT.CLICKED_TITLE",
                "READ_SUBTITLE": "AGENCY.SEND_REPORTS.REPORT.READ_SUBTITLE" as "AGENCY.SEND_REPORTS.REPORT.READ_SUBTITLE",
                "READ_TITLE": "AGENCY.SEND_REPORTS.REPORT.READ_TITLE" as "AGENCY.SEND_REPORTS.REPORT.READ_TITLE",
                "SENT_FROM": "AGENCY.SEND_REPORTS.REPORT.SENT_FROM" as "AGENCY.SEND_REPORTS.REPORT.SENT_FROM",
                "SENT_SUBTITLE": "AGENCY.SEND_REPORTS.REPORT.SENT_SUBTITLE" as "AGENCY.SEND_REPORTS.REPORT.SENT_SUBTITLE",
                "SENT_TITLE": "AGENCY.SEND_REPORTS.REPORT.SENT_TITLE" as "AGENCY.SEND_REPORTS.REPORT.SENT_TITLE",
                "SENT_TO_PART_1": "AGENCY.SEND_REPORTS.REPORT.SENT_TO_PART_1" as "AGENCY.SEND_REPORTS.REPORT.SENT_TO_PART_1",
                "SENT_TO_PART_2": "AGENCY.SEND_REPORTS.REPORT.SENT_TO_PART_2" as "AGENCY.SEND_REPORTS.REPORT.SENT_TO_PART_2",
                "SENT_TO_PART_2_plural": "AGENCY.SEND_REPORTS.REPORT.SENT_TO_PART_2_plural" as "AGENCY.SEND_REPORTS.REPORT.SENT_TO_PART_2_plural",
                "SENT_TO_PART_3": "AGENCY.SEND_REPORTS.REPORT.SENT_TO_PART_3" as "AGENCY.SEND_REPORTS.REPORT.SENT_TO_PART_3",
                "SENT_TO_USERS_FILTERED_BY_TITLES": "AGENCY.SEND_REPORTS.REPORT.SENT_TO_USERS_FILTERED_BY_TITLES" as "AGENCY.SEND_REPORTS.REPORT.SENT_TO_USERS_FILTERED_BY_TITLES",
                "SUBTITLE_NOT_SENT": "AGENCY.SEND_REPORTS.REPORT.SUBTITLE_NOT_SENT" as "AGENCY.SEND_REPORTS.REPORT.SUBTITLE_NOT_SENT",
                "SUBTITLE_SENT_BY": "AGENCY.SEND_REPORTS.REPORT.SUBTITLE_SENT_BY" as "AGENCY.SEND_REPORTS.REPORT.SUBTITLE_SENT_BY",
                "TYPE_EMAIL_TOOLTIP": "AGENCY.SEND_REPORTS.REPORT.TYPE_EMAIL_TOOLTIP" as "AGENCY.SEND_REPORTS.REPORT.TYPE_EMAIL_TOOLTIP",
                "TYPE_IN_APP_TOOLTIP": "AGENCY.SEND_REPORTS.REPORT.TYPE_IN_APP_TOOLTIP" as "AGENCY.SEND_REPORTS.REPORT.TYPE_IN_APP_TOOLTIP"
            },
            "TITLE": "AGENCY.SEND_REPORTS.TITLE" as "AGENCY.SEND_REPORTS.TITLE"
        },
        "USERS": {
            "CLIENT_USERS": "AGENCY.USERS.CLIENT_USERS" as "AGENCY.USERS.CLIENT_USERS",
            "INTERACTION_DELETE_USER": "AGENCY.USERS.INTERACTION_DELETE_USER" as "AGENCY.USERS.INTERACTION_DELETE_USER",
            "INTERACTION_GET_CLIENT_USERS": "AGENCY.USERS.INTERACTION_GET_CLIENT_USERS" as "AGENCY.USERS.INTERACTION_GET_CLIENT_USERS",
            "ONLY_SHOW_ORPHANS": "AGENCY.USERS.ONLY_SHOW_ORPHANS" as "AGENCY.USERS.ONLY_SHOW_ORPHANS"
        }
    },
    "APPS": {
        "ACCESS_TOKEN_CONFIG_NOT_FOUND_OR_PERMISSION_ERROR": "APPS.ACCESS_TOKEN_CONFIG_NOT_FOUND_OR_PERMISSION_ERROR" as "APPS.ACCESS_TOKEN_CONFIG_NOT_FOUND_OR_PERMISSION_ERROR",
        "ACCOUNT_SUCCESSFULLY_CONNECTED": {
            "MESSAGE": "APPS.ACCOUNT_SUCCESSFULLY_CONNECTED.MESSAGE" as "APPS.ACCOUNT_SUCCESSFULLY_CONNECTED.MESSAGE",
            "TITLE": "APPS.ACCOUNT_SUCCESSFULLY_CONNECTED.TITLE" as "APPS.ACCOUNT_SUCCESSFULLY_CONNECTED.TITLE"
        },
        "ADWORDS_CUSTOMER": "APPS.ADWORDS_CUSTOMER" as "APPS.ADWORDS_CUSTOMER",
        "ANALYTICS_PROFILE": "APPS.ANALYTICS_PROFILE" as "APPS.ANALYTICS_PROFILE",
        "AUTHORISE": "APPS.AUTHORISE" as "APPS.AUTHORISE",
        "AUTHORIZED_ACCOUNT": "APPS.AUTHORIZED_ACCOUNT" as "APPS.AUTHORIZED_ACCOUNT",
        "BUSINESS": "APPS.BUSINESS" as "APPS.BUSINESS",
        "CAMPAIGNS_FOUND_IN_ADWORDS_THAT_MATCH_NAME": "APPS.CAMPAIGNS_FOUND_IN_ADWORDS_THAT_MATCH_NAME" as "APPS.CAMPAIGNS_FOUND_IN_ADWORDS_THAT_MATCH_NAME",
        "CAMPAIGNS_FOUND_IN_ADWORDS_THAT_MATCH_NAME_plural": "APPS.CAMPAIGNS_FOUND_IN_ADWORDS_THAT_MATCH_NAME_plural" as "APPS.CAMPAIGNS_FOUND_IN_ADWORDS_THAT_MATCH_NAME_plural",
        "CHECK_ACCESS_TO_GOOGLE_ADWORDS": "APPS.CHECK_ACCESS_TO_GOOGLE_ADWORDS" as "APPS.CHECK_ACCESS_TO_GOOGLE_ADWORDS",
        "CHECK_MATCHED_CAMPAIGNS_RELATE_TO_LOCATION": "APPS.CHECK_MATCHED_CAMPAIGNS_RELATE_TO_LOCATION" as "APPS.CHECK_MATCHED_CAMPAIGNS_RELATE_TO_LOCATION",
        "COMPANY": "APPS.COMPANY" as "APPS.COMPANY",
        "CONNECTING_VIA_ACCOUNT": "APPS.CONNECTING_VIA_ACCOUNT" as "APPS.CONNECTING_VIA_ACCOUNT",
        "CONNECT_TO_ACCESS_WELCOME_MESSAGE": {
            "CLUB_PILATES": {
                "HEADING": "APPS.CONNECT_TO_ACCESS_WELCOME_MESSAGE.CLUB_PILATES.HEADING" as "APPS.CONNECT_TO_ACCESS_WELCOME_MESSAGE.CLUB_PILATES.HEADING",
                "MESSAGE": "APPS.CONNECT_TO_ACCESS_WELCOME_MESSAGE.CLUB_PILATES.MESSAGE" as "APPS.CONNECT_TO_ACCESS_WELCOME_MESSAGE.CLUB_PILATES.MESSAGE",
                "SUBHEADING": "APPS.CONNECT_TO_ACCESS_WELCOME_MESSAGE.CLUB_PILATES.SUBHEADING" as "APPS.CONNECT_TO_ACCESS_WELCOME_MESSAGE.CLUB_PILATES.SUBHEADING"
            },
            "DEFAULT": {
                "HEADING": "APPS.CONNECT_TO_ACCESS_WELCOME_MESSAGE.DEFAULT.HEADING" as "APPS.CONNECT_TO_ACCESS_WELCOME_MESSAGE.DEFAULT.HEADING",
                "MESSAGE": "APPS.CONNECT_TO_ACCESS_WELCOME_MESSAGE.DEFAULT.MESSAGE" as "APPS.CONNECT_TO_ACCESS_WELCOME_MESSAGE.DEFAULT.MESSAGE",
                "SUBHEADING": "APPS.CONNECT_TO_ACCESS_WELCOME_MESSAGE.DEFAULT.SUBHEADING" as "APPS.CONNECT_TO_ACCESS_WELCOME_MESSAGE.DEFAULT.SUBHEADING"
            }
        },
        "CONNECT_TO_ACCOUNT": "APPS.CONNECT_TO_ACCOUNT" as "APPS.CONNECT_TO_ACCOUNT",
        "CONNECT_TO_NEW_ACCOUNT": "APPS.CONNECT_TO_NEW_ACCOUNT" as "APPS.CONNECT_TO_NEW_ACCOUNT",
        "CUSTOMER_ID": "APPS.CUSTOMER_ID" as "APPS.CUSTOMER_ID",
        "DEAUTHORISE": "APPS.DEAUTHORISE" as "APPS.DEAUTHORISE",
        "DISCONNECT_ACCOUNT": "APPS.DISCONNECT_ACCOUNT" as "APPS.DISCONNECT_ACCOUNT",
        "DISCONNECT_FROM_ACCOUNT": "APPS.DISCONNECT_FROM_ACCOUNT" as "APPS.DISCONNECT_FROM_ACCOUNT",
        "EDIT_CONFIGURATION": "APPS.EDIT_CONFIGURATION" as "APPS.EDIT_CONFIGURATION",
        "ERRORS": {
            "DEBUG_MESSAGE_WRAP": "APPS.ERRORS.DEBUG_MESSAGE_WRAP" as "APPS.ERRORS.DEBUG_MESSAGE_WRAP",
            "FACEBOOK_ACCESS_TOKEN_ISSUE": {
                "EXPLAIN_ISSUE": "APPS.ERRORS.FACEBOOK_ACCESS_TOKEN_ISSUE.EXPLAIN_ISSUE" as "APPS.ERRORS.FACEBOOK_ACCESS_TOKEN_ISSUE.EXPLAIN_ISSUE",
                "PROVIDE_RESOLUTION_CANT_CONFIGURE": "APPS.ERRORS.FACEBOOK_ACCESS_TOKEN_ISSUE.PROVIDE_RESOLUTION_CANT_CONFIGURE" as "APPS.ERRORS.FACEBOOK_ACCESS_TOKEN_ISSUE.PROVIDE_RESOLUTION_CANT_CONFIGURE",
                "PROVIDE_RESOLUTION_CAN_CONFIGURE": "APPS.ERRORS.FACEBOOK_ACCESS_TOKEN_ISSUE.PROVIDE_RESOLUTION_CAN_CONFIGURE" as "APPS.ERRORS.FACEBOOK_ACCESS_TOKEN_ISSUE.PROVIDE_RESOLUTION_CAN_CONFIGURE"
            },
            "FACEBOOK_INVALID_SESSION": {
                "EXPLAIN_ISSUE": "APPS.ERRORS.FACEBOOK_INVALID_SESSION.EXPLAIN_ISSUE" as "APPS.ERRORS.FACEBOOK_INVALID_SESSION.EXPLAIN_ISSUE",
                "PROVIDE_RESOLUTION_CANT_CONFIGURE": "APPS.ERRORS.FACEBOOK_INVALID_SESSION.PROVIDE_RESOLUTION_CANT_CONFIGURE" as "APPS.ERRORS.FACEBOOK_INVALID_SESSION.PROVIDE_RESOLUTION_CANT_CONFIGURE",
                "PROVIDE_RESOLUTION_CAN_CONFIGURE": "APPS.ERRORS.FACEBOOK_INVALID_SESSION.PROVIDE_RESOLUTION_CAN_CONFIGURE" as "APPS.ERRORS.FACEBOOK_INVALID_SESSION.PROVIDE_RESOLUTION_CAN_CONFIGURE"
            },
            "FACEBOOK_PASSWORD_CHANGED": {
                "EXPLAIN_ISSUE": "APPS.ERRORS.FACEBOOK_PASSWORD_CHANGED.EXPLAIN_ISSUE" as "APPS.ERRORS.FACEBOOK_PASSWORD_CHANGED.EXPLAIN_ISSUE",
                "PROVIDE_RESOLUTION_CANT_CONFIGURE": "APPS.ERRORS.FACEBOOK_PASSWORD_CHANGED.PROVIDE_RESOLUTION_CANT_CONFIGURE" as "APPS.ERRORS.FACEBOOK_PASSWORD_CHANGED.PROVIDE_RESOLUTION_CANT_CONFIGURE",
                "PROVIDE_RESOLUTION_CAN_CONFIGURE": "APPS.ERRORS.FACEBOOK_PASSWORD_CHANGED.PROVIDE_RESOLUTION_CAN_CONFIGURE" as "APPS.ERRORS.FACEBOOK_PASSWORD_CHANGED.PROVIDE_RESOLUTION_CAN_CONFIGURE"
            },
            "INVALID_CONFIGURATION": {
                "EXPLAIN_ISSUE": "APPS.ERRORS.INVALID_CONFIGURATION.EXPLAIN_ISSUE" as "APPS.ERRORS.INVALID_CONFIGURATION.EXPLAIN_ISSUE",
                "PROVIDE_RESOLUTION_CANT_CONFIGURE": "APPS.ERRORS.INVALID_CONFIGURATION.PROVIDE_RESOLUTION_CANT_CONFIGURE" as "APPS.ERRORS.INVALID_CONFIGURATION.PROVIDE_RESOLUTION_CANT_CONFIGURE",
                "PROVIDE_RESOLUTION_CAN_CONFIGURE": "APPS.ERRORS.INVALID_CONFIGURATION.PROVIDE_RESOLUTION_CAN_CONFIGURE" as "APPS.ERRORS.INVALID_CONFIGURATION.PROVIDE_RESOLUTION_CAN_CONFIGURE"
            },
            "MISSING_CONFIGURATION": {
                "EXPLAIN_ISSUE": "APPS.ERRORS.MISSING_CONFIGURATION.EXPLAIN_ISSUE" as "APPS.ERRORS.MISSING_CONFIGURATION.EXPLAIN_ISSUE",
                "PROVIDE_RESOLUTION_CANT_CONFIGURE": "APPS.ERRORS.MISSING_CONFIGURATION.PROVIDE_RESOLUTION_CANT_CONFIGURE" as "APPS.ERRORS.MISSING_CONFIGURATION.PROVIDE_RESOLUTION_CANT_CONFIGURE",
                "PROVIDE_RESOLUTION_CAN_CONFIGURE": "APPS.ERRORS.MISSING_CONFIGURATION.PROVIDE_RESOLUTION_CAN_CONFIGURE" as "APPS.ERRORS.MISSING_CONFIGURATION.PROVIDE_RESOLUTION_CAN_CONFIGURE"
            },
            "MISSING_PERMISSIONS": {
                "EXPLAIN_ISSUE": "APPS.ERRORS.MISSING_PERMISSIONS.EXPLAIN_ISSUE" as "APPS.ERRORS.MISSING_PERMISSIONS.EXPLAIN_ISSUE",
                "PROVIDE_RESOLUTION_CANT_CONFIGURE": "APPS.ERRORS.MISSING_PERMISSIONS.PROVIDE_RESOLUTION_CANT_CONFIGURE" as "APPS.ERRORS.MISSING_PERMISSIONS.PROVIDE_RESOLUTION_CANT_CONFIGURE",
                "PROVIDE_RESOLUTION_CANT_CONFIGURE_ALTERNATE": "APPS.ERRORS.MISSING_PERMISSIONS.PROVIDE_RESOLUTION_CANT_CONFIGURE_ALTERNATE" as "APPS.ERRORS.MISSING_PERMISSIONS.PROVIDE_RESOLUTION_CANT_CONFIGURE_ALTERNATE",
                "PROVIDE_RESOLUTION_CAN_CONFIGURE": "APPS.ERRORS.MISSING_PERMISSIONS.PROVIDE_RESOLUTION_CAN_CONFIGURE" as "APPS.ERRORS.MISSING_PERMISSIONS.PROVIDE_RESOLUTION_CAN_CONFIGURE"
            },
            "WEVE_ENCOUNTERED_ISSUES": "APPS.ERRORS.WEVE_ENCOUNTERED_ISSUES" as "APPS.ERRORS.WEVE_ENCOUNTERED_ISSUES"
        },
        "FACEBOOK": {
            "PAGE_ID_AND_NAME_REQUIRED": "APPS.FACEBOOK.PAGE_ID_AND_NAME_REQUIRED" as "APPS.FACEBOOK.PAGE_ID_AND_NAME_REQUIRED",
            "PAGE_UPDATED": "APPS.FACEBOOK.PAGE_UPDATED" as "APPS.FACEBOOK.PAGE_UPDATED"
        },
        "FACEBOOK_MARKETING": {
            "ACCOUNT_NAME": "APPS.FACEBOOK_MARKETING.ACCOUNT_NAME" as "APPS.FACEBOOK_MARKETING.ACCOUNT_NAME",
            "AD_ACCOUNT_CLEARED": "APPS.FACEBOOK_MARKETING.AD_ACCOUNT_CLEARED" as "APPS.FACEBOOK_MARKETING.AD_ACCOUNT_CLEARED",
            "AD_ACCOUNT_SET": "APPS.FACEBOOK_MARKETING.AD_ACCOUNT_SET" as "APPS.FACEBOOK_MARKETING.AD_ACCOUNT_SET",
            "CHECK_AUTHORISATION": "APPS.FACEBOOK_MARKETING.CHECK_AUTHORISATION" as "APPS.FACEBOOK_MARKETING.CHECK_AUTHORISATION",
            "CHECK_CONFIG_ACCESS": "APPS.FACEBOOK_MARKETING.CHECK_CONFIG_ACCESS" as "APPS.FACEBOOK_MARKETING.CHECK_CONFIG_ACCESS",
            "FACEBOOK_AD_ACCOUNT": "APPS.FACEBOOK_MARKETING.FACEBOOK_AD_ACCOUNT" as "APPS.FACEBOOK_MARKETING.FACEBOOK_AD_ACCOUNT",
            "RETRIEVE_AD_ACCOUNTS": "APPS.FACEBOOK_MARKETING.RETRIEVE_AD_ACCOUNTS" as "APPS.FACEBOOK_MARKETING.RETRIEVE_AD_ACCOUNTS",
            "RETRIEVE_CONFIG": "APPS.FACEBOOK_MARKETING.RETRIEVE_CONFIG" as "APPS.FACEBOOK_MARKETING.RETRIEVE_CONFIG",
            "TITLE": "APPS.FACEBOOK_MARKETING.TITLE" as "APPS.FACEBOOK_MARKETING.TITLE",
            "UPDATE_AD_ACCOUNT": "APPS.FACEBOOK_MARKETING.UPDATE_AD_ACCOUNT" as "APPS.FACEBOOK_MARKETING.UPDATE_AD_ACCOUNT"
        },
        "FACEBOOK_PAGE": "APPS.FACEBOOK_PAGE" as "APPS.FACEBOOK_PAGE",
        "FACEBOOK_PAGE_HELP": "APPS.FACEBOOK_PAGE_HELP" as "APPS.FACEBOOK_PAGE_HELP",
        "FACEBOOK_PAGE_NOT_AVAILABLE": "APPS.FACEBOOK_PAGE_NOT_AVAILABLE" as "APPS.FACEBOOK_PAGE_NOT_AVAILABLE",
        "FETCH_SERVICE_CONFIG": "APPS.FETCH_SERVICE_CONFIG" as "APPS.FETCH_SERVICE_CONFIG",
        "FITWARE": "APPS.FITWARE" as "APPS.FITWARE",
        "FITWARE_CLUB": "APPS.FITWARE_CLUB" as "APPS.FITWARE_CLUB",
        "FITWARE_NOTE": "APPS.FITWARE_NOTE" as "APPS.FITWARE_NOTE",
        "FOUR51": {
            "COMPANY": "APPS.FOUR51.COMPANY" as "APPS.FOUR51.COMPANY",
            "COMPANY_UPDATED": "APPS.FOUR51.COMPANY_UPDATED" as "APPS.FOUR51.COMPANY_UPDATED",
            "CREDENTIALS_DELETED": "APPS.FOUR51.CREDENTIALS_DELETED" as "APPS.FOUR51.CREDENTIALS_DELETED",
            "CREDENTIALS_UPDATED": "APPS.FOUR51.CREDENTIALS_UPDATED" as "APPS.FOUR51.CREDENTIALS_UPDATED",
            "DELETE_CREDENTIALS_WARNING": "APPS.FOUR51.DELETE_CREDENTIALS_WARNING" as "APPS.FOUR51.DELETE_CREDENTIALS_WARNING",
            "INVALID_NEW_CREDENTIALS": "APPS.FOUR51.INVALID_NEW_CREDENTIALS" as "APPS.FOUR51.INVALID_NEW_CREDENTIALS",
            "SSO_KEY": "APPS.FOUR51.SSO_KEY" as "APPS.FOUR51.SSO_KEY",
            "STORE": "APPS.FOUR51.STORE" as "APPS.FOUR51.STORE"
        },
        "GOOGLE_ADWORDS": {
            "CAMPAIGN_NAME": "APPS.GOOGLE_ADWORDS.CAMPAIGN_NAME" as "APPS.GOOGLE_ADWORDS.CAMPAIGN_NAME",
            "CAMPAIGN_NAME_DOESNT_MATCH_CONTINUE": "APPS.GOOGLE_ADWORDS.CAMPAIGN_NAME_DOESNT_MATCH_CONTINUE" as "APPS.GOOGLE_ADWORDS.CAMPAIGN_NAME_DOESNT_MATCH_CONTINUE",
            "CAMPAIGN_NAME_MATCHES_COUNT_CONTINUE": "APPS.GOOGLE_ADWORDS.CAMPAIGN_NAME_MATCHES_COUNT_CONTINUE" as "APPS.GOOGLE_ADWORDS.CAMPAIGN_NAME_MATCHES_COUNT_CONTINUE",
            "CUSTOMER": "APPS.GOOGLE_ADWORDS.CUSTOMER" as "APPS.GOOGLE_ADWORDS.CUSTOMER",
            "MULTIPLE_CAMPAIGNS_FOUND": "APPS.GOOGLE_ADWORDS.MULTIPLE_CAMPAIGNS_FOUND" as "APPS.GOOGLE_ADWORDS.MULTIPLE_CAMPAIGNS_FOUND",
            "NO_CAMPAIGNS_FOUND": "APPS.GOOGLE_ADWORDS.NO_CAMPAIGNS_FOUND" as "APPS.GOOGLE_ADWORDS.NO_CAMPAIGNS_FOUND"
        },
        "GOOGLE_ADWORDS_CAMPAIGN_NAME": "APPS.GOOGLE_ADWORDS_CAMPAIGN_NAME" as "APPS.GOOGLE_ADWORDS_CAMPAIGN_NAME",
        "GOOGLE_ADWORDS_CUSTOMER_CLEARED": "APPS.GOOGLE_ADWORDS_CUSTOMER_CLEARED" as "APPS.GOOGLE_ADWORDS_CUSTOMER_CLEARED",
        "GOOGLE_ADWORDS_CUSTOMER_SET": "APPS.GOOGLE_ADWORDS_CUSTOMER_SET" as "APPS.GOOGLE_ADWORDS_CUSTOMER_SET",
        "GOOGLE_ANALYTICS": {
            "PAGE_PATH": "APPS.GOOGLE_ANALYTICS.PAGE_PATH" as "APPS.GOOGLE_ANALYTICS.PAGE_PATH"
        },
        "GOOGLE_ANALYTICS_PAGE_PATH": "APPS.GOOGLE_ANALYTICS_PAGE_PATH" as "APPS.GOOGLE_ANALYTICS_PAGE_PATH",
        "GOOGLE_MY_BUSINESS": {
            "ACCOUNT_NAME": "APPS.GOOGLE_MY_BUSINESS.ACCOUNT_NAME" as "APPS.GOOGLE_MY_BUSINESS.ACCOUNT_NAME",
            "ASYNC_DESCRIPTIONS": {
                "FETCHING_ACCOUNT_NAMES": "APPS.GOOGLE_MY_BUSINESS.ASYNC_DESCRIPTIONS.FETCHING_ACCOUNT_NAMES" as "APPS.GOOGLE_MY_BUSINESS.ASYNC_DESCRIPTIONS.FETCHING_ACCOUNT_NAMES",
                "FETCHING_CAN_CONFIGURE": "APPS.GOOGLE_MY_BUSINESS.ASYNC_DESCRIPTIONS.FETCHING_CAN_CONFIGURE" as "APPS.GOOGLE_MY_BUSINESS.ASYNC_DESCRIPTIONS.FETCHING_CAN_CONFIGURE",
                "FETCHING_LOCATION_NAMES": "APPS.GOOGLE_MY_BUSINESS.ASYNC_DESCRIPTIONS.FETCHING_LOCATION_NAMES" as "APPS.GOOGLE_MY_BUSINESS.ASYNC_DESCRIPTIONS.FETCHING_LOCATION_NAMES",
                "UPDATING_CONFIG": "APPS.GOOGLE_MY_BUSINESS.ASYNC_DESCRIPTIONS.UPDATING_CONFIG" as "APPS.GOOGLE_MY_BUSINESS.ASYNC_DESCRIPTIONS.UPDATING_CONFIG"
            },
            "CONFIG_UPDATED": "APPS.GOOGLE_MY_BUSINESS.CONFIG_UPDATED" as "APPS.GOOGLE_MY_BUSINESS.CONFIG_UPDATED",
            "LOCATION_NAME": "APPS.GOOGLE_MY_BUSINESS.LOCATION_NAME" as "APPS.GOOGLE_MY_BUSINESS.LOCATION_NAME",
            "LOCATION_NOT_ENABLED_HELP_TEXT_EXPLANATION": "APPS.GOOGLE_MY_BUSINESS.LOCATION_NOT_ENABLED_HELP_TEXT_EXPLANATION" as "APPS.GOOGLE_MY_BUSINESS.LOCATION_NOT_ENABLED_HELP_TEXT_EXPLANATION",
            "LOCATION_NOT_ENABLED_HELP_TEXT_TITLE": "APPS.GOOGLE_MY_BUSINESS.LOCATION_NOT_ENABLED_HELP_TEXT_TITLE" as "APPS.GOOGLE_MY_BUSINESS.LOCATION_NOT_ENABLED_HELP_TEXT_TITLE",
            "NO_ADDRESS": "APPS.GOOGLE_MY_BUSINESS.NO_ADDRESS" as "APPS.GOOGLE_MY_BUSINESS.NO_ADDRESS",
            "STATES": {
                "DISABLED": "APPS.GOOGLE_MY_BUSINESS.STATES.DISABLED" as "APPS.GOOGLE_MY_BUSINESS.STATES.DISABLED",
                "DISCONNECTED": "APPS.GOOGLE_MY_BUSINESS.STATES.DISCONNECTED" as "APPS.GOOGLE_MY_BUSINESS.STATES.DISCONNECTED",
                "LOCAL_POST_API_DISABLED": "APPS.GOOGLE_MY_BUSINESS.STATES.LOCAL_POST_API_DISABLED" as "APPS.GOOGLE_MY_BUSINESS.STATES.LOCAL_POST_API_DISABLED",
                "NEEDS_REVERIFICATION": "APPS.GOOGLE_MY_BUSINESS.STATES.NEEDS_REVERIFICATION" as "APPS.GOOGLE_MY_BUSINESS.STATES.NEEDS_REVERIFICATION",
                "NOT_PUBLISHED": "APPS.GOOGLE_MY_BUSINESS.STATES.NOT_PUBLISHED" as "APPS.GOOGLE_MY_BUSINESS.STATES.NOT_PUBLISHED",
                "NOT_VERIFIED": "APPS.GOOGLE_MY_BUSINESS.STATES.NOT_VERIFIED" as "APPS.GOOGLE_MY_BUSINESS.STATES.NOT_VERIFIED",
                "PENDING_REVIEW": "APPS.GOOGLE_MY_BUSINESS.STATES.PENDING_REVIEW" as "APPS.GOOGLE_MY_BUSINESS.STATES.PENDING_REVIEW",
                "PENDING_VERIFICATION": "APPS.GOOGLE_MY_BUSINESS.STATES.PENDING_VERIFICATION" as "APPS.GOOGLE_MY_BUSINESS.STATES.PENDING_VERIFICATION",
                "SUSPENDED": "APPS.GOOGLE_MY_BUSINESS.STATES.SUSPENDED" as "APPS.GOOGLE_MY_BUSINESS.STATES.SUSPENDED",
                "TEMPORARILY_ENABLED": "APPS.GOOGLE_MY_BUSINESS.STATES.TEMPORARILY_ENABLED" as "APPS.GOOGLE_MY_BUSINESS.STATES.TEMPORARILY_ENABLED",
                "VERIFIED": "APPS.GOOGLE_MY_BUSINESS.STATES.VERIFIED" as "APPS.GOOGLE_MY_BUSINESS.STATES.VERIFIED"
            }
        },
        "INSTAGRAM": {
            "ACCOUNT_NOT_LISTED": "APPS.INSTAGRAM.ACCOUNT_NOT_LISTED" as "APPS.INSTAGRAM.ACCOUNT_NOT_LISTED",
            "ACCOUNT_NOT_LISTED_EXPLANATION": "APPS.INSTAGRAM.ACCOUNT_NOT_LISTED_EXPLANATION" as "APPS.INSTAGRAM.ACCOUNT_NOT_LISTED_EXPLANATION",
            "CONFIG_UPDATED_SUCCESS_MESSAGE": "APPS.INSTAGRAM.CONFIG_UPDATED_SUCCESS_MESSAGE" as "APPS.INSTAGRAM.CONFIG_UPDATED_SUCCESS_MESSAGE",
            "CONNECTED_ACCOUNT": "APPS.INSTAGRAM.CONNECTED_ACCOUNT" as "APPS.INSTAGRAM.CONNECTED_ACCOUNT",
            "CONNECTED_ACCOUNT_INFO": "APPS.INSTAGRAM.CONNECTED_ACCOUNT_INFO" as "APPS.INSTAGRAM.CONNECTED_ACCOUNT_INFO",
            "FETCHING_CAN_CONFIGURE": "APPS.INSTAGRAM.FETCHING_CAN_CONFIGURE" as "APPS.INSTAGRAM.FETCHING_CAN_CONFIGURE",
            "FETCH_AVAILABLE_INSTAGRAM_ACCOUNTS": "APPS.INSTAGRAM.FETCH_AVAILABLE_INSTAGRAM_ACCOUNTS" as "APPS.INSTAGRAM.FETCH_AVAILABLE_INSTAGRAM_ACCOUNTS",
            "UPDATE_CONFIG": "APPS.INSTAGRAM.UPDATE_CONFIG" as "APPS.INSTAGRAM.UPDATE_CONFIG"
        },
        "LINKEDIN": {
            "ASYNC_DESCRIPTIONS": {
                "FETCHING_CAN_CONFIGURE": "APPS.LINKEDIN.ASYNC_DESCRIPTIONS.FETCHING_CAN_CONFIGURE" as "APPS.LINKEDIN.ASYNC_DESCRIPTIONS.FETCHING_CAN_CONFIGURE",
                "FETCHING_PAGE_NAMES": "APPS.LINKEDIN.ASYNC_DESCRIPTIONS.FETCHING_PAGE_NAMES" as "APPS.LINKEDIN.ASYNC_DESCRIPTIONS.FETCHING_PAGE_NAMES",
                "UPDATING_CONFIG": "APPS.LINKEDIN.ASYNC_DESCRIPTIONS.UPDATING_CONFIG" as "APPS.LINKEDIN.ASYNC_DESCRIPTIONS.UPDATING_CONFIG"
            },
            "CONFIG_UPDATED": "APPS.LINKEDIN.CONFIG_UPDATED" as "APPS.LINKEDIN.CONFIG_UPDATED",
            "PAGE_NAME": "APPS.LINKEDIN.PAGE_NAME" as "APPS.LINKEDIN.PAGE_NAME",
            "PAGE_NOT_LISTED": "APPS.LINKEDIN.PAGE_NOT_LISTED" as "APPS.LINKEDIN.PAGE_NOT_LISTED",
            "PAGE_NOT_LISTED_EXPLANATION": "APPS.LINKEDIN.PAGE_NOT_LISTED_EXPLANATION" as "APPS.LINKEDIN.PAGE_NOT_LISTED_EXPLANATION"
        },
        "LINK_TO_GOOGLE_ADWORDS": "APPS.LINK_TO_GOOGLE_ADWORDS" as "APPS.LINK_TO_GOOGLE_ADWORDS",
        "MANUAL_ENTRY": "APPS.MANUAL_ENTRY" as "APPS.MANUAL_ENTRY",
        "NO_CAMPAIGNS_FOUND_IN_ADWORDS_THAT_MATCH_NAME": "APPS.NO_CAMPAIGNS_FOUND_IN_ADWORDS_THAT_MATCH_NAME" as "APPS.NO_CAMPAIGNS_FOUND_IN_ADWORDS_THAT_MATCH_NAME",
        "NO_FACEBOOK_PAGE_ACCESS_HEADING": "APPS.NO_FACEBOOK_PAGE_ACCESS_HEADING" as "APPS.NO_FACEBOOK_PAGE_ACCESS_HEADING",
        "PAGE_ID": "APPS.PAGE_ID" as "APPS.PAGE_ID",
        "PAGE_NAME": "APPS.PAGE_NAME" as "APPS.PAGE_NAME",
        "PLEASE_SELECT_AN_ADWORDS_CUSTOMER": "APPS.PLEASE_SELECT_AN_ADWORDS_CUSTOMER" as "APPS.PLEASE_SELECT_AN_ADWORDS_CUSTOMER",
        "PRINT_PROVIDER": "APPS.PRINT_PROVIDER" as "APPS.PRINT_PROVIDER",
        "PRINT_PROVIDER_SKU_GROUP_ATTACHED": "APPS.PRINT_PROVIDER_SKU_GROUP_ATTACHED" as "APPS.PRINT_PROVIDER_SKU_GROUP_ATTACHED",
        "PROPERTY_ID": "APPS.PROPERTY_ID" as "APPS.PROPERTY_ID",
        "REFRESH_MATCHING_CAMPAIGNS": "APPS.REFRESH_MATCHING_CAMPAIGNS" as "APPS.REFRESH_MATCHING_CAMPAIGNS",
        "THIS_WILL_MATCH_CAMPAIGNS_WITH_NAME_CONTAINING_TEXT": "APPS.THIS_WILL_MATCH_CAMPAIGNS_WITH_NAME_CONTAINING_TEXT" as "APPS.THIS_WILL_MATCH_CAMPAIGNS_WITH_NAME_CONTAINING_TEXT",
        "UPDATED_GOOGLE_ADWORDS_CAMPAIGN_NAME": "APPS.UPDATED_GOOGLE_ADWORDS_CAMPAIGN_NAME" as "APPS.UPDATED_GOOGLE_ADWORDS_CAMPAIGN_NAME",
        "UPDATE_GOOGLE_ADWORDS_CUSTOMER": "APPS.UPDATE_GOOGLE_ADWORDS_CUSTOMER" as "APPS.UPDATE_GOOGLE_ADWORDS_CUSTOMER"
    },
    "ASSET_LIBRARY": {
        "AUTOMATICALLY_EXPIRE_THESE_ASSETS": "ASSET_LIBRARY.AUTOMATICALLY_EXPIRE_THESE_ASSETS" as "ASSET_LIBRARY.AUTOMATICALLY_EXPIRE_THESE_ASSETS",
        "BIN": "ASSET_LIBRARY.BIN" as "ASSET_LIBRARY.BIN",
        "BIN_ASSETS": "ASSET_LIBRARY.BIN_ASSETS" as "ASSET_LIBRARY.BIN_ASSETS",
        "CHOOSE_COLLECTION": "ASSET_LIBRARY.CHOOSE_COLLECTION" as "ASSET_LIBRARY.CHOOSE_COLLECTION",
        "CHOOSE_COLLECTION_REQUEST": "ASSET_LIBRARY.CHOOSE_COLLECTION_REQUEST" as "ASSET_LIBRARY.CHOOSE_COLLECTION_REQUEST",
        "COLLECTION_LIMIT_REACHED": "ASSET_LIBRARY.COLLECTION_LIMIT_REACHED" as "ASSET_LIBRARY.COLLECTION_LIMIT_REACHED",
        "COPY_ASSET_URL": "ASSET_LIBRARY.COPY_ASSET_URL" as "ASSET_LIBRARY.COPY_ASSET_URL",
        "CREATE_FOLDER_MODAL_TITLE": "ASSET_LIBRARY.CREATE_FOLDER_MODAL_TITLE" as "ASSET_LIBRARY.CREATE_FOLDER_MODAL_TITLE",
        "DELETE_COLLECTION_NOTE": "ASSET_LIBRARY.DELETE_COLLECTION_NOTE" as "ASSET_LIBRARY.DELETE_COLLECTION_NOTE",
        "DIFFERENT_EXPIRY_DATE_ALERT": "ASSET_LIBRARY.DIFFERENT_EXPIRY_DATE_ALERT" as "ASSET_LIBRARY.DIFFERENT_EXPIRY_DATE_ALERT",
        "DIFFERENT_EXPIRY_DATE_INFO": "ASSET_LIBRARY.DIFFERENT_EXPIRY_DATE_INFO" as "ASSET_LIBRARY.DIFFERENT_EXPIRY_DATE_INFO",
        "EDIT_FOLDER": "ASSET_LIBRARY.EDIT_FOLDER" as "ASSET_LIBRARY.EDIT_FOLDER",
        "EXPIRED_ASSETS": "ASSET_LIBRARY.EXPIRED_ASSETS" as "ASSET_LIBRARY.EXPIRED_ASSETS",
        "EXPLAIN": "ASSET_LIBRARY.EXPLAIN" as "ASSET_LIBRARY.EXPLAIN",
        "HIDE_BIN": "ASSET_LIBRARY.HIDE_BIN" as "ASSET_LIBRARY.HIDE_BIN",
        "LIST": "ASSET_LIBRARY.LIST" as "ASSET_LIBRARY.LIST",
        "MOVE_ASSETS_TO_FOLDER": "ASSET_LIBRARY.MOVE_ASSETS_TO_FOLDER" as "ASSET_LIBRARY.MOVE_ASSETS_TO_FOLDER",
        "MOVING_ASSETS": "ASSET_LIBRARY.MOVING_ASSETS" as "ASSET_LIBRARY.MOVING_ASSETS",
        "NEW_FOLDER": "ASSET_LIBRARY.NEW_FOLDER" as "ASSET_LIBRARY.NEW_FOLDER",
        "NO_ASSETS_IN_FOLDER": "ASSET_LIBRARY.NO_ASSETS_IN_FOLDER" as "ASSET_LIBRARY.NO_ASSETS_IN_FOLDER",
        "NO_COLLECTIONS_FOUND": "ASSET_LIBRARY.NO_COLLECTIONS_FOUND" as "ASSET_LIBRARY.NO_COLLECTIONS_FOUND",
        "PLEASE_SELECT_COLLECTION": "ASSET_LIBRARY.PLEASE_SELECT_COLLECTION" as "ASSET_LIBRARY.PLEASE_SELECT_COLLECTION",
        "REMOVE_EXPIRATION_DATE": "ASSET_LIBRARY.REMOVE_EXPIRATION_DATE" as "ASSET_LIBRARY.REMOVE_EXPIRATION_DATE",
        "RESTORE": "ASSET_LIBRARY.RESTORE" as "ASSET_LIBRARY.RESTORE",
        "SAVING_ASSETS": "ASSET_LIBRARY.SAVING_ASSETS" as "ASSET_LIBRARY.SAVING_ASSETS",
        "SEARCH_COLLECTIONS": "ASSET_LIBRARY.SEARCH_COLLECTIONS" as "ASSET_LIBRARY.SEARCH_COLLECTIONS",
        "SECURITY_WARNING": "ASSET_LIBRARY.SECURITY_WARNING" as "ASSET_LIBRARY.SECURITY_WARNING",
        "SECURITY_WARNING_DESCRIPTION": "ASSET_LIBRARY.SECURITY_WARNING_DESCRIPTION" as "ASSET_LIBRARY.SECURITY_WARNING_DESCRIPTION",
        "SELECTED_CLIENTS": "ASSET_LIBRARY.SELECTED_CLIENTS" as "ASSET_LIBRARY.SELECTED_CLIENTS",
        "SELECTED_LOCATIONS": "ASSET_LIBRARY.SELECTED_LOCATIONS" as "ASSET_LIBRARY.SELECTED_LOCATIONS",
        "SHARED_WITH": "ASSET_LIBRARY.SHARED_WITH" as "ASSET_LIBRARY.SHARED_WITH",
        "SHOW_BIN": "ASSET_LIBRARY.SHOW_BIN" as "ASSET_LIBRARY.SHOW_BIN",
        "THUMBNAIL": "ASSET_LIBRARY.THUMBNAIL" as "ASSET_LIBRARY.THUMBNAIL",
        "UNABLE_TO_LOAD": "ASSET_LIBRARY.UNABLE_TO_LOAD" as "ASSET_LIBRARY.UNABLE_TO_LOAD",
        "UPLOADING_ASSETS": "ASSET_LIBRARY.UPLOADING_ASSETS" as "ASSET_LIBRARY.UPLOADING_ASSETS",
        "UPLOAD_ASSET": "ASSET_LIBRARY.UPLOAD_ASSET" as "ASSET_LIBRARY.UPLOAD_ASSET"
    },
    "BUILD": {
        "ACTUAL": "BUILD.ACTUAL" as "BUILD.ACTUAL",
        "ADDRESS_NOT_SET": "BUILD.ADDRESS_NOT_SET" as "BUILD.ADDRESS_NOT_SET",
        "AGENCY_FILTERS": {
            "HIDE_MOBILE": "BUILD.AGENCY_FILTERS.HIDE_MOBILE" as "BUILD.AGENCY_FILTERS.HIDE_MOBILE",
            "HIDE_PUBLISHED": "BUILD.AGENCY_FILTERS.HIDE_PUBLISHED" as "BUILD.AGENCY_FILTERS.HIDE_PUBLISHED",
            "HIDE_UNPUBLISHED": "BUILD.AGENCY_FILTERS.HIDE_UNPUBLISHED" as "BUILD.AGENCY_FILTERS.HIDE_UNPUBLISHED",
            "IS_MULTI_IMAGE": "BUILD.AGENCY_FILTERS.IS_MULTI_IMAGE" as "BUILD.AGENCY_FILTERS.IS_MULTI_IMAGE",
            "ONLY_LOCATION_DRAFTS": "BUILD.AGENCY_FILTERS.ONLY_LOCATION_DRAFTS" as "BUILD.AGENCY_FILTERS.ONLY_LOCATION_DRAFTS",
            "ONLY_LOCATION_DRAFTS_BUTTON": "BUILD.AGENCY_FILTERS.ONLY_LOCATION_DRAFTS_BUTTON" as "BUILD.AGENCY_FILTERS.ONLY_LOCATION_DRAFTS_BUTTON",
            "ONLY_MOBILE": "BUILD.AGENCY_FILTERS.ONLY_MOBILE" as "BUILD.AGENCY_FILTERS.ONLY_MOBILE",
            "TITLE": "BUILD.AGENCY_FILTERS.TITLE" as "BUILD.AGENCY_FILTERS.TITLE"
        },
        "ALL_CLIENTS": "BUILD.ALL_CLIENTS" as "BUILD.ALL_CLIENTS",
        "ALL_EDITABLE_ELEMENTS": "BUILD.ALL_EDITABLE_ELEMENTS" as "BUILD.ALL_EDITABLE_ELEMENTS",
        "ALL_FORMATS": "BUILD.ALL_FORMATS" as "BUILD.ALL_FORMATS",
        "ANIMATION": {
            "ADD_FRAME_AFTER": "BUILD.ANIMATION.ADD_FRAME_AFTER" as "BUILD.ANIMATION.ADD_FRAME_AFTER",
            "ADD_FRAME_BEFORE": "BUILD.ANIMATION.ADD_FRAME_BEFORE" as "BUILD.ANIMATION.ADD_FRAME_BEFORE",
            "ANIMATION": "BUILD.ANIMATION.ANIMATION" as "BUILD.ANIMATION.ANIMATION",
            "CONFIRM_DELETE_FRAME": "BUILD.ANIMATION.CONFIRM_DELETE_FRAME" as "BUILD.ANIMATION.CONFIRM_DELETE_FRAME",
            "DELETE_FRAME": "BUILD.ANIMATION.DELETE_FRAME" as "BUILD.ANIMATION.DELETE_FRAME",
            "DURATION": "BUILD.ANIMATION.DURATION" as "BUILD.ANIMATION.DURATION",
            "FRAME_NUMBER_OF_COUNT": "BUILD.ANIMATION.FRAME_NUMBER_OF_COUNT" as "BUILD.ANIMATION.FRAME_NUMBER_OF_COUNT",
            "PLAY": "BUILD.ANIMATION.PLAY" as "BUILD.ANIMATION.PLAY",
            "STOP": "BUILD.ANIMATION.STOP" as "BUILD.ANIMATION.STOP",
            "TOGGLE_ANIMATION_CONFIRM": "BUILD.ANIMATION.TOGGLE_ANIMATION_CONFIRM" as "BUILD.ANIMATION.TOGGLE_ANIMATION_CONFIRM"
        },
        "AT_LEAST_ONE_FORMAT_REQUIRED": "BUILD.AT_LEAST_ONE_FORMAT_REQUIRED" as "BUILD.AT_LEAST_ONE_FORMAT_REQUIRED",
        "BACKGROUND": "BUILD.BACKGROUND" as "BUILD.BACKGROUND",
        "BACK_TO_GALLERY": "BUILD.BACK_TO_GALLERY" as "BUILD.BACK_TO_GALLERY",
        "BLEND_MODE": {
            "COLOR": "BUILD.BLEND_MODE.COLOR" as "BUILD.BLEND_MODE.COLOR",
            "DIFFERENCE": "BUILD.BLEND_MODE.DIFFERENCE" as "BUILD.BLEND_MODE.DIFFERENCE",
            "HARD_LIGHT": "BUILD.BLEND_MODE.HARD_LIGHT" as "BUILD.BLEND_MODE.HARD_LIGHT",
            "HUE": "BUILD.BLEND_MODE.HUE" as "BUILD.BLEND_MODE.HUE",
            "MULTIPLY": "BUILD.BLEND_MODE.MULTIPLY" as "BUILD.BLEND_MODE.MULTIPLY",
            "NORMAL": "BUILD.BLEND_MODE.NORMAL" as "BUILD.BLEND_MODE.NORMAL",
            "OVERLAY": "BUILD.BLEND_MODE.OVERLAY" as "BUILD.BLEND_MODE.OVERLAY",
            "SATURATION": "BUILD.BLEND_MODE.SATURATION" as "BUILD.BLEND_MODE.SATURATION",
            "SCREEN": "BUILD.BLEND_MODE.SCREEN" as "BUILD.BLEND_MODE.SCREEN",
            "SOFT_LIGHT": "BUILD.BLEND_MODE.SOFT_LIGHT" as "BUILD.BLEND_MODE.SOFT_LIGHT"
        },
        "BUILDER_MODE": {
            "ADVANCED": "BUILD.BUILDER_MODE.ADVANCED" as "BUILD.BUILDER_MODE.ADVANCED",
            "SIMPLE": "BUILD.BUILDER_MODE.SIMPLE" as "BUILD.BUILDER_MODE.SIMPLE"
        },
        "BUILDER_TEMPLATE_DELETE_CONFIRMATION_MODAL": {
            "CONFIRMATION_MESSAGE": "BUILD.BUILDER_TEMPLATE_DELETE_CONFIRMATION_MODAL.CONFIRMATION_MESSAGE" as "BUILD.BUILDER_TEMPLATE_DELETE_CONFIRMATION_MODAL.CONFIRMATION_MESSAGE",
            "CONFIRMATION_MESSAGE_plural": "BUILD.BUILDER_TEMPLATE_DELETE_CONFIRMATION_MODAL.CONFIRMATION_MESSAGE_plural" as "BUILD.BUILDER_TEMPLATE_DELETE_CONFIRMATION_MODAL.CONFIRMATION_MESSAGE_plural",
            "TITLE": "BUILD.BUILDER_TEMPLATE_DELETE_CONFIRMATION_MODAL.TITLE" as "BUILD.BUILDER_TEMPLATE_DELETE_CONFIRMATION_MODAL.TITLE"
        },
        "BUILDER_TEMPLATE_UPDATE_CONFIRMATION_MODAL": {
            "AFFECTED_LOCATIONS": "BUILD.BUILDER_TEMPLATE_UPDATE_CONFIRMATION_MODAL.AFFECTED_LOCATIONS" as "BUILD.BUILDER_TEMPLATE_UPDATE_CONFIRMATION_MODAL.AFFECTED_LOCATIONS",
            "CONFIRMATION_MESSAGE": "BUILD.BUILDER_TEMPLATE_UPDATE_CONFIRMATION_MODAL.CONFIRMATION_MESSAGE" as "BUILD.BUILDER_TEMPLATE_UPDATE_CONFIRMATION_MODAL.CONFIRMATION_MESSAGE",
            "CONFIRMATION_MESSAGE_plural": "BUILD.BUILDER_TEMPLATE_UPDATE_CONFIRMATION_MODAL.CONFIRMATION_MESSAGE_plural" as "BUILD.BUILDER_TEMPLATE_UPDATE_CONFIRMATION_MODAL.CONFIRMATION_MESSAGE_plural",
            "DELETE_LOCATION_DRAFTS": "BUILD.BUILDER_TEMPLATE_UPDATE_CONFIRMATION_MODAL.DELETE_LOCATION_DRAFTS" as "BUILD.BUILDER_TEMPLATE_UPDATE_CONFIRMATION_MODAL.DELETE_LOCATION_DRAFTS",
            "KEEP_LOCATION_DRAFTS": "BUILD.BUILDER_TEMPLATE_UPDATE_CONFIRMATION_MODAL.KEEP_LOCATION_DRAFTS" as "BUILD.BUILDER_TEMPLATE_UPDATE_CONFIRMATION_MODAL.KEEP_LOCATION_DRAFTS",
            "TITLE": "BUILD.BUILDER_TEMPLATE_UPDATE_CONFIRMATION_MODAL.TITLE" as "BUILD.BUILDER_TEMPLATE_UPDATE_CONFIRMATION_MODAL.TITLE"
        },
        "CANT_FIND_WHAT_YOU_ARE_LOOKING_FOR": "BUILD.CANT_FIND_WHAT_YOU_ARE_LOOKING_FOR" as "BUILD.CANT_FIND_WHAT_YOU_ARE_LOOKING_FOR",
        "CHANNEL_DATA": "BUILD.CHANNEL_DATA" as "BUILD.CHANNEL_DATA",
        "CMYK_COLOR_DISCLAIMER": "BUILD.CMYK_COLOR_DISCLAIMER" as "BUILD.CMYK_COLOR_DISCLAIMER",
        "COLOR_PICKER": {
            "BLACK": "BUILD.COLOR_PICKER.BLACK" as "BUILD.COLOR_PICKER.BLACK",
            "BLUE": "BUILD.COLOR_PICKER.BLUE" as "BUILD.COLOR_PICKER.BLUE",
            "CMYK": "BUILD.COLOR_PICKER.CMYK" as "BUILD.COLOR_PICKER.CMYK",
            "CMYK_HEADER": "BUILD.COLOR_PICKER.CMYK_HEADER" as "BUILD.COLOR_PICKER.CMYK_HEADER",
            "CYAN": "BUILD.COLOR_PICKER.CYAN" as "BUILD.COLOR_PICKER.CYAN",
            "GREEN": "BUILD.COLOR_PICKER.GREEN" as "BUILD.COLOR_PICKER.GREEN",
            "HSL": "BUILD.COLOR_PICKER.HSL" as "BUILD.COLOR_PICKER.HSL",
            "HUE": "BUILD.COLOR_PICKER.HUE" as "BUILD.COLOR_PICKER.HUE",
            "LUM": "BUILD.COLOR_PICKER.LUM" as "BUILD.COLOR_PICKER.LUM",
            "MAGENTA": "BUILD.COLOR_PICKER.MAGENTA" as "BUILD.COLOR_PICKER.MAGENTA",
            "NAME": "BUILD.COLOR_PICKER.NAME" as "BUILD.COLOR_PICKER.NAME",
            "OPACITY": "BUILD.COLOR_PICKER.OPACITY" as "BUILD.COLOR_PICKER.OPACITY",
            "RED": "BUILD.COLOR_PICKER.RED" as "BUILD.COLOR_PICKER.RED",
            "RGB": "BUILD.COLOR_PICKER.RGB" as "BUILD.COLOR_PICKER.RGB",
            "RGB_HEADER": "BUILD.COLOR_PICKER.RGB_HEADER" as "BUILD.COLOR_PICKER.RGB_HEADER",
            "SAT": "BUILD.COLOR_PICKER.SAT" as "BUILD.COLOR_PICKER.SAT",
            "YELLOW": "BUILD.COLOR_PICKER.YELLOW" as "BUILD.COLOR_PICKER.YELLOW"
        },
        "COMPLETE": "BUILD.COMPLETE" as "BUILD.COMPLETE",
        "CONFIRM_BUILDER_TEMPLATE_UPDATE": "BUILD.CONFIRM_BUILDER_TEMPLATE_UPDATE" as "BUILD.CONFIRM_BUILDER_TEMPLATE_UPDATE",
        "CONFIRM_BUILDER_TEMPLATE_UPDATE_MESSAGE": "BUILD.CONFIRM_BUILDER_TEMPLATE_UPDATE_MESSAGE" as "BUILD.CONFIRM_BUILDER_TEMPLATE_UPDATE_MESSAGE",
        "CONFIRM_DELETE_ALL_CHANNEL_DATA": "BUILD.CONFIRM_DELETE_ALL_CHANNEL_DATA" as "BUILD.CONFIRM_DELETE_ALL_CHANNEL_DATA",
        "CUSTOM_IMAGE_REQUIRED": "BUILD.CUSTOM_IMAGE_REQUIRED" as "BUILD.CUSTOM_IMAGE_REQUIRED",
        "CUSTOM_TEXT_REQUIRED": "BUILD.CUSTOM_TEXT_REQUIRED" as "BUILD.CUSTOM_TEXT_REQUIRED",
        "DELETE_CONFIRMATION": "BUILD.DELETE_CONFIRMATION" as "BUILD.DELETE_CONFIRMATION",
        "DELETE_TEMPLATE": "BUILD.DELETE_TEMPLATE" as "BUILD.DELETE_TEMPLATE",
        "DESKTOP_VIEW": "BUILD.DESKTOP_VIEW" as "BUILD.DESKTOP_VIEW",
        "DIMENSIONS": "BUILD.DIMENSIONS" as "BUILD.DIMENSIONS",
        "DUPLICATE": "BUILD.DUPLICATE" as "BUILD.DUPLICATE",
        "DUPLICATE_LAYER": "BUILD.DUPLICATE_LAYER" as "BUILD.DUPLICATE_LAYER",
        "EDITABLE_ELEMENTS": "BUILD.EDITABLE_ELEMENTS" as "BUILD.EDITABLE_ELEMENTS",
        "ELLIPSE": "BUILD.ELLIPSE" as "BUILD.ELLIPSE",
        "EMAIL": {
            "AUTHORIZE_ON_APPS_PAGE": "BUILD.EMAIL.AUTHORIZE_ON_APPS_PAGE" as "BUILD.EMAIL.AUTHORIZE_ON_APPS_PAGE",
            "BLACK_TEXT_EDITOR_BACKGROUND": "BUILD.EMAIL.BLACK_TEXT_EDITOR_BACKGROUND" as "BUILD.EMAIL.BLACK_TEXT_EDITOR_BACKGROUND",
            "CANT_ADD_IMAGE_ELEMENT": "BUILD.EMAIL.CANT_ADD_IMAGE_ELEMENT" as "BUILD.EMAIL.CANT_ADD_IMAGE_ELEMENT",
            "DEFAULT_INSTRUCTIONS": "BUILD.EMAIL.DEFAULT_INSTRUCTIONS" as "BUILD.EMAIL.DEFAULT_INSTRUCTIONS",
            "EDIT_SOURCE": "BUILD.EMAIL.EDIT_SOURCE" as "BUILD.EMAIL.EDIT_SOURCE",
            "EDIT_SOURCE_WARNING": "BUILD.EMAIL.EDIT_SOURCE_WARNING" as "BUILD.EMAIL.EDIT_SOURCE_WARNING",
            "EMAIL_BUILDER": "BUILD.EMAIL.EMAIL_BUILDER" as "BUILD.EMAIL.EMAIL_BUILDER",
            "EMAIL_PREVIEW": "BUILD.EMAIL.EMAIL_PREVIEW" as "BUILD.EMAIL.EMAIL_PREVIEW",
            "FAILED_TO_PARSE_HTML": "BUILD.EMAIL.FAILED_TO_PARSE_HTML" as "BUILD.EMAIL.FAILED_TO_PARSE_HTML",
            "FAILED_TO_PROCESS_ZIP_FILE": "BUILD.EMAIL.FAILED_TO_PROCESS_ZIP_FILE" as "BUILD.EMAIL.FAILED_TO_PROCESS_ZIP_FILE",
            "FAILED_TO_READ_ZIP_FILE": "BUILD.EMAIL.FAILED_TO_READ_ZIP_FILE" as "BUILD.EMAIL.FAILED_TO_READ_ZIP_FILE",
            "FAILED_TO_VALIDATE_ZIP_FILE": "BUILD.EMAIL.FAILED_TO_VALIDATE_ZIP_FILE" as "BUILD.EMAIL.FAILED_TO_VALIDATE_ZIP_FILE",
            "IMAGE_EXCEEDS_RECOMMENDED_SIZE_WARNING": "BUILD.EMAIL.IMAGE_EXCEEDS_RECOMMENDED_SIZE_WARNING" as "BUILD.EMAIL.IMAGE_EXCEEDS_RECOMMENDED_SIZE_WARNING",
            "IMAGE_TIMEOUT": "BUILD.EMAIL.IMAGE_TIMEOUT" as "BUILD.EMAIL.IMAGE_TIMEOUT",
            "LOCATION_NOT_AUTHORIZED": "BUILD.EMAIL.LOCATION_NOT_AUTHORIZED" as "BUILD.EMAIL.LOCATION_NOT_AUTHORIZED",
            "MAIL_MERGE": "BUILD.EMAIL.MAIL_MERGE" as "BUILD.EMAIL.MAIL_MERGE",
            "NO_CAMPAGIN_MONITOR_SETUP_FOR_LOCATION": "BUILD.EMAIL.NO_CAMPAGIN_MONITOR_SETUP_FOR_LOCATION" as "BUILD.EMAIL.NO_CAMPAGIN_MONITOR_SETUP_FOR_LOCATION",
            "PLEASE_ADDRESS_ISSUES_WITH_ZIP_FILE": "BUILD.EMAIL.PLEASE_ADDRESS_ISSUES_WITH_ZIP_FILE" as "BUILD.EMAIL.PLEASE_ADDRESS_ISSUES_WITH_ZIP_FILE",
            "SELECT_ZIP_FILE": "BUILD.EMAIL.SELECT_ZIP_FILE" as "BUILD.EMAIL.SELECT_ZIP_FILE",
            "UPDATE_PLANNER_STATUS": "BUILD.EMAIL.UPDATE_PLANNER_STATUS" as "BUILD.EMAIL.UPDATE_PLANNER_STATUS",
            "UPLOAD_ONLY_ONE_PREVIEW": "BUILD.EMAIL.UPLOAD_ONLY_ONE_PREVIEW" as "BUILD.EMAIL.UPLOAD_ONLY_ONE_PREVIEW",
            "UPLOAD_ONLY_ONE_ZIP_FILE": "BUILD.EMAIL.UPLOAD_ONLY_ONE_ZIP_FILE" as "BUILD.EMAIL.UPLOAD_ONLY_ONE_ZIP_FILE",
            "VISIBILITY": "BUILD.EMAIL.VISIBILITY" as "BUILD.EMAIL.VISIBILITY",
            "VISIBLE": "BUILD.EMAIL.VISIBLE" as "BUILD.EMAIL.VISIBLE",
            "ZIP_FILE": "BUILD.EMAIL.ZIP_FILE" as "BUILD.EMAIL.ZIP_FILE",
            "ZIP_VALIDATION": {
                "HTML_MISSING": "BUILD.EMAIL.ZIP_VALIDATION.HTML_MISSING" as "BUILD.EMAIL.ZIP_VALIDATION.HTML_MISSING",
                "HTML_MULTIPLE": "BUILD.EMAIL.ZIP_VALIDATION.HTML_MULTIPLE" as "BUILD.EMAIL.ZIP_VALIDATION.HTML_MULTIPLE",
                "IMAGE_MISSING": "BUILD.EMAIL.ZIP_VALIDATION.IMAGE_MISSING" as "BUILD.EMAIL.ZIP_VALIDATION.IMAGE_MISSING",
                "IMAGE_UNREFERENCED": "BUILD.EMAIL.ZIP_VALIDATION.IMAGE_UNREFERENCED" as "BUILD.EMAIL.ZIP_VALIDATION.IMAGE_UNREFERENCED",
                "PREVIEW_IMAGE_MISSING": "BUILD.EMAIL.ZIP_VALIDATION.PREVIEW_IMAGE_MISSING" as "BUILD.EMAIL.ZIP_VALIDATION.PREVIEW_IMAGE_MISSING",
                "PREVIEW_IMAGE_MULTIPLE": "BUILD.EMAIL.ZIP_VALIDATION.PREVIEW_IMAGE_MULTIPLE" as "BUILD.EMAIL.ZIP_VALIDATION.PREVIEW_IMAGE_MULTIPLE"
            }
        },
        "ERROR": {
            "DIMENSIONS_FOR_PNG_IN_PRINT_TEMPLATES_LIMITED": "BUILD.ERROR.DIMENSIONS_FOR_PNG_IN_PRINT_TEMPLATES_LIMITED" as "BUILD.ERROR.DIMENSIONS_FOR_PNG_IN_PRINT_TEMPLATES_LIMITED",
            "FAILED_TO_CREATE_TAG": "BUILD.ERROR.FAILED_TO_CREATE_TAG" as "BUILD.ERROR.FAILED_TO_CREATE_TAG",
            "FAILED_TO_DELETE_TEMPLATE": "BUILD.ERROR.FAILED_TO_DELETE_TEMPLATE" as "BUILD.ERROR.FAILED_TO_DELETE_TEMPLATE",
            "FAILED_TO_GET_CLIENTS": "BUILD.ERROR.FAILED_TO_GET_CLIENTS" as "BUILD.ERROR.FAILED_TO_GET_CLIENTS",
            "FAILED_TO_GET_LOCATION": "BUILD.ERROR.FAILED_TO_GET_LOCATION" as "BUILD.ERROR.FAILED_TO_GET_LOCATION",
            "FAILED_TO_RETRIEVE_BUILDER_TEMPLATE_FORMATS": "BUILD.ERROR.FAILED_TO_RETRIEVE_BUILDER_TEMPLATE_FORMATS" as "BUILD.ERROR.FAILED_TO_RETRIEVE_BUILDER_TEMPLATE_FORMATS",
            "FAILED_TO_RETRIEVE_TEMPLATE": "BUILD.ERROR.FAILED_TO_RETRIEVE_TEMPLATE" as "BUILD.ERROR.FAILED_TO_RETRIEVE_TEMPLATE",
            "FAILED_TO_SAVE_TEMPLATE": "BUILD.ERROR.FAILED_TO_SAVE_TEMPLATE" as "BUILD.ERROR.FAILED_TO_SAVE_TEMPLATE",
            "FAILED_TO_UPLOAD_IMAGES": "BUILD.ERROR.FAILED_TO_UPLOAD_IMAGES" as "BUILD.ERROR.FAILED_TO_UPLOAD_IMAGES",
            "FAILED_TO_UPLOAD_THUMBNAIL": "BUILD.ERROR.FAILED_TO_UPLOAD_THUMBNAIL" as "BUILD.ERROR.FAILED_TO_UPLOAD_THUMBNAIL"
        },
        "FEATURED_TEMPLATE_SETS": "BUILD.FEATURED_TEMPLATE_SETS" as "BUILD.FEATURED_TEMPLATE_SETS",
        "FETCHING_BUILDER_TEMPLATE_INFO": "BUILD.FETCHING_BUILDER_TEMPLATE_INFO" as "BUILD.FETCHING_BUILDER_TEMPLATE_INFO",
        "FIRST_COMMENT": "BUILD.FIRST_COMMENT" as "BUILD.FIRST_COMMENT",
        "FIT": "BUILD.FIT" as "BUILD.FIT",
        "FONTS": {
            "ADD_FONT": "BUILD.FONTS.ADD_FONT" as "BUILD.FONTS.ADD_FONT",
            "ADD_FONT_FOR_CLIENT": "BUILD.FONTS.ADD_FONT_FOR_CLIENT" as "BUILD.FONTS.ADD_FONT_FOR_CLIENT",
            "ARE_YOU_SURE_DELETE_FAMILY": "BUILD.FONTS.ARE_YOU_SURE_DELETE_FAMILY" as "BUILD.FONTS.ARE_YOU_SURE_DELETE_FAMILY",
            "CHECK_YOU_ARE_VIEWING_CORRECT_CLIENT": "BUILD.FONTS.CHECK_YOU_ARE_VIEWING_CORRECT_CLIENT" as "BUILD.FONTS.CHECK_YOU_ARE_VIEWING_CORRECT_CLIENT",
            "CONTEXT_ACTIONS": "BUILD.FONTS.CONTEXT_ACTIONS" as "BUILD.FONTS.CONTEXT_ACTIONS",
            "CREATE_FONT_INSTRUCTIONS": "BUILD.FONTS.CREATE_FONT_INSTRUCTIONS" as "BUILD.FONTS.CREATE_FONT_INSTRUCTIONS",
            "DELETE_FONT_FAMILY": "BUILD.FONTS.DELETE_FONT_FAMILY" as "BUILD.FONTS.DELETE_FONT_FAMILY",
            "ENTER_NEW_FONT_FAMILY": "BUILD.FONTS.ENTER_NEW_FONT_FAMILY" as "BUILD.FONTS.ENTER_NEW_FONT_FAMILY",
            "ERRORS": {
                "COULD_NOT_DELETE_FONT": "BUILD.FONTS.ERRORS.COULD_NOT_DELETE_FONT" as "BUILD.FONTS.ERRORS.COULD_NOT_DELETE_FONT",
                "ERROR_RENAMING": "BUILD.FONTS.ERRORS.ERROR_RENAMING" as "BUILD.FONTS.ERRORS.ERROR_RENAMING",
                "ISSUE_UPLOADING_FONT": "BUILD.FONTS.ERRORS.ISSUE_UPLOADING_FONT" as "BUILD.FONTS.ERRORS.ISSUE_UPLOADING_FONT"
            },
            "ERROR_LOADING_FONTS": "BUILD.FONTS.ERROR_LOADING_FONTS" as "BUILD.FONTS.ERROR_LOADING_FONTS",
            "FILTER_FONTS": "BUILD.FONTS.FILTER_FONTS" as "BUILD.FONTS.FILTER_FONTS",
            "FONTS_MISSING": "BUILD.FONTS.FONTS_MISSING" as "BUILD.FONTS.FONTS_MISSING",
            "FONT_ACTIONS": "BUILD.FONTS.FONT_ACTIONS" as "BUILD.FONTS.FONT_ACTIONS",
            "FONT_DELETED": "BUILD.FONTS.FONT_DELETED" as "BUILD.FONTS.FONT_DELETED",
            "FONT_FAMILY": "BUILD.FONTS.FONT_FAMILY" as "BUILD.FONTS.FONT_FAMILY",
            "FONT_TYPE": "BUILD.FONTS.FONT_TYPE" as "BUILD.FONTS.FONT_TYPE",
            "FONT_UPLOADED": "BUILD.FONTS.FONT_UPLOADED" as "BUILD.FONTS.FONT_UPLOADED",
            "PLEASE_CONTACT_AGENCY_TO_FIX": "BUILD.FONTS.PLEASE_CONTACT_AGENCY_TO_FIX" as "BUILD.FONTS.PLEASE_CONTACT_AGENCY_TO_FIX",
            "RENAMED_FONT": "BUILD.FONTS.RENAMED_FONT" as "BUILD.FONTS.RENAMED_FONT",
            "SOME_FONTS_COULD_NOT_BE_LOADED": "BUILD.FONTS.SOME_FONTS_COULD_NOT_BE_LOADED" as "BUILD.FONTS.SOME_FONTS_COULD_NOT_BE_LOADED",
            "TEMPLATE_USES_MISSING_FONTS": "BUILD.FONTS.TEMPLATE_USES_MISSING_FONTS" as "BUILD.FONTS.TEMPLATE_USES_MISSING_FONTS"
        },
        "FORMATS_SELECTED": "BUILD.FORMATS_SELECTED" as "BUILD.FORMATS_SELECTED",
        "FORMATS_SELECTED_plural": "BUILD.FORMATS_SELECTED_plural" as "BUILD.FORMATS_SELECTED_plural",
        "FOUR51": {
            "NO_ACCESS_MODAL_MESSAGE": "BUILD.FOUR51.NO_ACCESS_MODAL_MESSAGE" as "BUILD.FOUR51.NO_ACCESS_MODAL_MESSAGE",
            "NO_ACCESS_MODAL_TITLE": "BUILD.FOUR51.NO_ACCESS_MODAL_TITLE" as "BUILD.FOUR51.NO_ACCESS_MODAL_TITLE"
        },
        "GALLERY": "BUILD.GALLERY" as "BUILD.GALLERY",
        "HIDE_DETAILS": "BUILD.HIDE_DETAILS" as "BUILD.HIDE_DETAILS",
        "IMAGE": {
            "UNSUPPORTED_FORMAT": "BUILD.IMAGE.UNSUPPORTED_FORMAT" as "BUILD.IMAGE.UNSUPPORTED_FORMAT"
        },
        "IMAGE_CHOOSER": {
            "CONFIRM_ACKNOWLEDGED": "BUILD.IMAGE_CHOOSER.CONFIRM_ACKNOWLEDGED" as "BUILD.IMAGE_CHOOSER.CONFIRM_ACKNOWLEDGED",
            "CONFIRM_PERMISSION": "BUILD.IMAGE_CHOOSER.CONFIRM_PERMISSION" as "BUILD.IMAGE_CHOOSER.CONFIRM_PERMISSION",
            "IMAGE_SOURCE": "BUILD.IMAGE_CHOOSER.IMAGE_SOURCE" as "BUILD.IMAGE_CHOOSER.IMAGE_SOURCE",
            "LOCAL_FILE": "BUILD.IMAGE_CHOOSER.LOCAL_FILE" as "BUILD.IMAGE_CHOOSER.LOCAL_FILE",
            "LOCATION_LOGO": "BUILD.IMAGE_CHOOSER.LOCATION_LOGO" as "BUILD.IMAGE_CHOOSER.LOCATION_LOGO",
            "MAX_UPLOAD_ERROR": "BUILD.IMAGE_CHOOSER.MAX_UPLOAD_ERROR" as "BUILD.IMAGE_CHOOSER.MAX_UPLOAD_ERROR",
            "PERMISSION_DISCLAIMER": "BUILD.IMAGE_CHOOSER.PERMISSION_DISCLAIMER" as "BUILD.IMAGE_CHOOSER.PERMISSION_DISCLAIMER",
            "PERMISSION_DISCLAIMER_STRONG": "BUILD.IMAGE_CHOOSER.PERMISSION_DISCLAIMER_STRONG" as "BUILD.IMAGE_CHOOSER.PERMISSION_DISCLAIMER_STRONG",
            "PERMISSION_ERROR": "BUILD.IMAGE_CHOOSER.PERMISSION_ERROR" as "BUILD.IMAGE_CHOOSER.PERMISSION_ERROR",
            "SELECT_IMAGE": "BUILD.IMAGE_CHOOSER.SELECT_IMAGE" as "BUILD.IMAGE_CHOOSER.SELECT_IMAGE",
            "SELECT_IMAGE_FROM_YOUR_LIBRARY": "BUILD.IMAGE_CHOOSER.SELECT_IMAGE_FROM_YOUR_LIBRARY" as "BUILD.IMAGE_CHOOSER.SELECT_IMAGE_FROM_YOUR_LIBRARY",
            "SUGGESTED_COLLECTION": "BUILD.IMAGE_CHOOSER.SUGGESTED_COLLECTION" as "BUILD.IMAGE_CHOOSER.SUGGESTED_COLLECTION",
            "UPLOADED_ASSET_IMAGE": "BUILD.IMAGE_CHOOSER.UPLOADED_ASSET_IMAGE" as "BUILD.IMAGE_CHOOSER.UPLOADED_ASSET_IMAGE",
            "UPLOADED_PLANNER_IMAGE": "BUILD.IMAGE_CHOOSER.UPLOADED_PLANNER_IMAGE" as "BUILD.IMAGE_CHOOSER.UPLOADED_PLANNER_IMAGE",
            "UPLOAD_IMAGE_FROM_YOUR_DEVICE": "BUILD.IMAGE_CHOOSER.UPLOAD_IMAGE_FROM_YOUR_DEVICE" as "BUILD.IMAGE_CHOOSER.UPLOAD_IMAGE_FROM_YOUR_DEVICE"
        },
        "IMAGE_CROPPER": {
            "CLEAR": "BUILD.IMAGE_CROPPER.CLEAR" as "BUILD.IMAGE_CROPPER.CLEAR",
            "CROP_IMAGE": "BUILD.IMAGE_CROPPER.CROP_IMAGE" as "BUILD.IMAGE_CROPPER.CROP_IMAGE",
            "ROTATE": "BUILD.IMAGE_CROPPER.ROTATE" as "BUILD.IMAGE_CROPPER.ROTATE"
        },
        "IMAGE_CROPPER_PROMPT_MESSAGE": "BUILD.IMAGE_CROPPER_PROMPT_MESSAGE" as "BUILD.IMAGE_CROPPER_PROMPT_MESSAGE",
        "IMAGE_FORMAT_NAME": {
            "JPG_LIMITED_FILE_SIZE": "BUILD.IMAGE_FORMAT_NAME.JPG_LIMITED_FILE_SIZE" as "BUILD.IMAGE_FORMAT_NAME.JPG_LIMITED_FILE_SIZE"
        },
        "IMAGE_MUST_BE_EDITABLE": "BUILD.IMAGE_MUST_BE_EDITABLE" as "BUILD.IMAGE_MUST_BE_EDITABLE",
        "IMAGE_RESOLUTION_PICKER": {
            "CONFIRM_DPI": "BUILD.IMAGE_RESOLUTION_PICKER.CONFIRM_DPI" as "BUILD.IMAGE_RESOLUTION_PICKER.CONFIRM_DPI",
            "DPI": "BUILD.IMAGE_RESOLUTION_PICKER.DPI" as "BUILD.IMAGE_RESOLUTION_PICKER.DPI",
            "DPI_IS_REQUIRED": "BUILD.IMAGE_RESOLUTION_PICKER.DPI_IS_REQUIRED" as "BUILD.IMAGE_RESOLUTION_PICKER.DPI_IS_REQUIRED",
            "IMAGE_RESOLUTION": "BUILD.IMAGE_RESOLUTION_PICKER.IMAGE_RESOLUTION" as "BUILD.IMAGE_RESOLUTION_PICKER.IMAGE_RESOLUTION"
        },
        "IMAGE_SELECTED": "BUILD.IMAGE_SELECTED" as "BUILD.IMAGE_SELECTED",
        "KEYBOARD_SHORTCUTS_REFERENCE": "BUILD.KEYBOARD_SHORTCUTS_REFERENCE" as "BUILD.KEYBOARD_SHORTCUTS_REFERENCE",
        "KEYWORD_SEARCH": "BUILD.KEYWORD_SEARCH" as "BUILD.KEYWORD_SEARCH",
        "LANDSCAPE": "BUILD.LANDSCAPE" as "BUILD.LANDSCAPE",
        "LAYERS": "BUILD.LAYERS" as "BUILD.LAYERS",
        "LEAVE_PAGE_PROMPT": {
            "CONFIRM": "BUILD.LEAVE_PAGE_PROMPT.CONFIRM" as "BUILD.LEAVE_PAGE_PROMPT.CONFIRM",
            "TITLE": "BUILD.LEAVE_PAGE_PROMPT.TITLE" as "BUILD.LEAVE_PAGE_PROMPT.TITLE"
        },
        "LOCATION_DETAILS_MISSING_MESSAGE": "BUILD.LOCATION_DETAILS_MISSING_MESSAGE" as "BUILD.LOCATION_DETAILS_MISSING_MESSAGE",
        "LOCATION_DRAFT": {
            "ARE_YOU_SURE_YOU_WANT_TO_OVERRIDE_TEMPLATE_REVISION_WITH_TITLE": "BUILD.LOCATION_DRAFT.ARE_YOU_SURE_YOU_WANT_TO_OVERRIDE_TEMPLATE_REVISION_WITH_TITLE" as "BUILD.LOCATION_DRAFT.ARE_YOU_SURE_YOU_WANT_TO_OVERRIDE_TEMPLATE_REVISION_WITH_TITLE",
            "CONFIRM_DELETE": "BUILD.LOCATION_DRAFT.CONFIRM_DELETE" as "BUILD.LOCATION_DRAFT.CONFIRM_DELETE",
            "CONFIRM_DELETE_TITLE": "BUILD.LOCATION_DRAFT.CONFIRM_DELETE_TITLE" as "BUILD.LOCATION_DRAFT.CONFIRM_DELETE_TITLE",
            "CREATED_LOCATION_DRAFT": "BUILD.LOCATION_DRAFT.CREATED_LOCATION_DRAFT" as "BUILD.LOCATION_DRAFT.CREATED_LOCATION_DRAFT",
            "ENTER_NAME_FOR_NEW_TEMPLATE_REVISION": "BUILD.LOCATION_DRAFT.ENTER_NAME_FOR_NEW_TEMPLATE_REVISION" as "BUILD.LOCATION_DRAFT.ENTER_NAME_FOR_NEW_TEMPLATE_REVISION",
            "LOAD_A_PREVIOUS_REVISION": "BUILD.LOCATION_DRAFT.LOAD_A_PREVIOUS_REVISION" as "BUILD.LOCATION_DRAFT.LOAD_A_PREVIOUS_REVISION",
            "LOAD_A_PREVIOUS_TEMPLATE_REVISION": "BUILD.LOCATION_DRAFT.LOAD_A_PREVIOUS_TEMPLATE_REVISION" as "BUILD.LOCATION_DRAFT.LOAD_A_PREVIOUS_TEMPLATE_REVISION",
            "PLEASE_CONFIRM_LOCATION_REVISION_SAVE": "BUILD.LOCATION_DRAFT.PLEASE_CONFIRM_LOCATION_REVISION_SAVE" as "BUILD.LOCATION_DRAFT.PLEASE_CONFIRM_LOCATION_REVISION_SAVE",
            "SAVE_AS_A_NEW_REVISION": "BUILD.LOCATION_DRAFT.SAVE_AS_A_NEW_REVISION" as "BUILD.LOCATION_DRAFT.SAVE_AS_A_NEW_REVISION",
            "SAVE_LOCATION_REVISION": "BUILD.LOCATION_DRAFT.SAVE_LOCATION_REVISION" as "BUILD.LOCATION_DRAFT.SAVE_LOCATION_REVISION",
            "SAVE_LOCATION_REVISION_WITH_TITLE": "BUILD.LOCATION_DRAFT.SAVE_LOCATION_REVISION_WITH_TITLE" as "BUILD.LOCATION_DRAFT.SAVE_LOCATION_REVISION_WITH_TITLE",
            "SAVE_OVER_CURRENT_REVISION_WITH_TITLE": "BUILD.LOCATION_DRAFT.SAVE_OVER_CURRENT_REVISION_WITH_TITLE" as "BUILD.LOCATION_DRAFT.SAVE_OVER_CURRENT_REVISION_WITH_TITLE",
            "TEMPLATE_HAS_DRAFT_TOOLTIP": "BUILD.LOCATION_DRAFT.TEMPLATE_HAS_DRAFT_TOOLTIP" as "BUILD.LOCATION_DRAFT.TEMPLATE_HAS_DRAFT_TOOLTIP",
            "UPDATED_AT": "BUILD.LOCATION_DRAFT.UPDATED_AT" as "BUILD.LOCATION_DRAFT.UPDATED_AT",
            "UPDATED_LOCATION_DRAFT": "BUILD.LOCATION_DRAFT.UPDATED_LOCATION_DRAFT" as "BUILD.LOCATION_DRAFT.UPDATED_LOCATION_DRAFT"
        },
        "LOCATION_EMAIL_NOT_SET": "BUILD.LOCATION_EMAIL_NOT_SET" as "BUILD.LOCATION_EMAIL_NOT_SET",
        "LOCATION_LOGO_NOT_SET": "BUILD.LOCATION_LOGO_NOT_SET" as "BUILD.LOCATION_LOGO_NOT_SET",
        "LOCATION_MAP_NOT_CREATED": "BUILD.LOCATION_MAP_NOT_CREATED" as "BUILD.LOCATION_MAP_NOT_CREATED",
        "LOOPING": "BUILD.LOOPING" as "BUILD.LOOPING",
        "LOOP_FOREVER": "BUILD.LOOP_FOREVER" as "BUILD.LOOP_FOREVER",
        "LOWERCASE": "BUILD.LOWERCASE" as "BUILD.LOWERCASE",
        "MAKE_TEMPLATE_ONLY_AVAILABLE_FOR_MOBILE_APP": "BUILD.MAKE_TEMPLATE_ONLY_AVAILABLE_FOR_MOBILE_APP" as "BUILD.MAKE_TEMPLATE_ONLY_AVAILABLE_FOR_MOBILE_APP",
        "MAP": {
            "PIN": "BUILD.MAP.PIN" as "BUILD.MAP.PIN"
        },
        "MAXIMUM_FILE_SIZE_KB": "BUILD.MAXIMUM_FILE_SIZE_KB" as "BUILD.MAXIMUM_FILE_SIZE_KB",
        "MEMBER_ENGAGER": {
            "ASSIGN_TO_MULTIPLE_LOCATIONS": "BUILD.MEMBER_ENGAGER.ASSIGN_TO_MULTIPLE_LOCATIONS" as "BUILD.MEMBER_ENGAGER.ASSIGN_TO_MULTIPLE_LOCATIONS",
            "AUTOMATED_EMAIL": "BUILD.MEMBER_ENGAGER.AUTOMATED_EMAIL" as "BUILD.MEMBER_ENGAGER.AUTOMATED_EMAIL",
            "AUTOMATED_EMAILS": "BUILD.MEMBER_ENGAGER.AUTOMATED_EMAILS" as "BUILD.MEMBER_ENGAGER.AUTOMATED_EMAILS",
            "DIRECT_EMAIL_TITLE": "BUILD.MEMBER_ENGAGER.DIRECT_EMAIL_TITLE" as "BUILD.MEMBER_ENGAGER.DIRECT_EMAIL_TITLE",
            "EDIT_CONTENT": "BUILD.MEMBER_ENGAGER.EDIT_CONTENT" as "BUILD.MEMBER_ENGAGER.EDIT_CONTENT",
            "EDIT_SUBJECT": "BUILD.MEMBER_ENGAGER.EDIT_SUBJECT" as "BUILD.MEMBER_ENGAGER.EDIT_SUBJECT",
            "FAILED_TO_LOAD_AUTOMATED_EMAIL": "BUILD.MEMBER_ENGAGER.FAILED_TO_LOAD_AUTOMATED_EMAIL" as "BUILD.MEMBER_ENGAGER.FAILED_TO_LOAD_AUTOMATED_EMAIL",
            "FAILED_TO_LOAD_AUTOMATED_EMAILS": "BUILD.MEMBER_ENGAGER.FAILED_TO_LOAD_AUTOMATED_EMAILS" as "BUILD.MEMBER_ENGAGER.FAILED_TO_LOAD_AUTOMATED_EMAILS",
            "FIND_NEW_TEMPLATE": "BUILD.MEMBER_ENGAGER.FIND_NEW_TEMPLATE" as "BUILD.MEMBER_ENGAGER.FIND_NEW_TEMPLATE",
            "NO_DIRECT_EMAIL_TEMPLATES_FOUND": "BUILD.MEMBER_ENGAGER.NO_DIRECT_EMAIL_TEMPLATES_FOUND" as "BUILD.MEMBER_ENGAGER.NO_DIRECT_EMAIL_TEMPLATES_FOUND",
            "SCHEDULED_EMAIL": "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAIL" as "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAIL",
            "SCHEDULED_EMAILS": "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS" as "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS",
            "SCHEDULED_EMAILS_WELL": {
                "DELETE_MESSAGE_LINE_1": "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.DELETE_MESSAGE_LINE_1" as "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.DELETE_MESSAGE_LINE_1",
                "DELETE_MESSAGE_LINE_2": "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.DELETE_MESSAGE_LINE_2" as "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.DELETE_MESSAGE_LINE_2",
                "DELETE_SCHEDULED_EMAIL_API_ERROR": "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.DELETE_SCHEDULED_EMAIL_API_ERROR" as "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.DELETE_SCHEDULED_EMAIL_API_ERROR",
                "NO_SCHEDULED_EMAILS": "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.NO_SCHEDULED_EMAILS" as "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.NO_SCHEDULED_EMAILS",
                "PREVIEW": "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.PREVIEW" as "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.PREVIEW",
                "SCHEDULED_EMAIL_ALREADY_DELETED": "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.SCHEDULED_EMAIL_ALREADY_DELETED" as "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.SCHEDULED_EMAIL_ALREADY_DELETED",
                "SCHEDULED_EMAIL_DELETED": "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.SCHEDULED_EMAIL_DELETED" as "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.SCHEDULED_EMAIL_DELETED",
                "SCHEDULED_EMAIL_NOT_FOUND": "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.SCHEDULED_EMAIL_NOT_FOUND" as "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.SCHEDULED_EMAIL_NOT_FOUND",
                "TABLE": {
                    "LISTS": "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.TABLE.LISTS" as "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.TABLE.LISTS",
                    "SCHEDULED": "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.TABLE.SCHEDULED" as "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.TABLE.SCHEDULED",
                    "SUBJECT": "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.TABLE.SUBJECT" as "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.TABLE.SUBJECT"
                }
            },
            "TITLE": "BUILD.MEMBER_ENGAGER.TITLE" as "BUILD.MEMBER_ENGAGER.TITLE"
        },
        "METRICS": {
            "EM": "BUILD.METRICS.EM" as "BUILD.METRICS.EM",
            "POINTS": "BUILD.METRICS.POINTS" as "BUILD.METRICS.POINTS",
            "POINTS_SHORT": "BUILD.METRICS.POINTS_SHORT" as "BUILD.METRICS.POINTS_SHORT"
        },
        "MILLISECONDS_SHORT": "BUILD.MILLISECONDS_SHORT" as "BUILD.MILLISECONDS_SHORT",
        "MOBILE_APP_TEMPLATE": "BUILD.MOBILE_APP_TEMPLATE" as "BUILD.MOBILE_APP_TEMPLATE",
        "MOBILE_APP_TEMPLATE_VALIDATION": {
            "ANIMATION_PRESENT": "BUILD.MOBILE_APP_TEMPLATE_VALIDATION.ANIMATION_PRESENT" as "BUILD.MOBILE_APP_TEMPLATE_VALIDATION.ANIMATION_PRESENT",
            "MAP_LAYER_PRESENT": "BUILD.MOBILE_APP_TEMPLATE_VALIDATION.MAP_LAYER_PRESENT" as "BUILD.MOBILE_APP_TEMPLATE_VALIDATION.MAP_LAYER_PRESENT",
            "NOT_MOBILE_COMPATIBLE": "BUILD.MOBILE_APP_TEMPLATE_VALIDATION.NOT_MOBILE_COMPATIBLE" as "BUILD.MOBILE_APP_TEMPLATE_VALIDATION.NOT_MOBILE_COMPATIBLE",
            "UNSUPPORTED_BUILDER_TEMPLATE_FORMAT": "BUILD.MOBILE_APP_TEMPLATE_VALIDATION.UNSUPPORTED_BUILDER_TEMPLATE_FORMAT" as "BUILD.MOBILE_APP_TEMPLATE_VALIDATION.UNSUPPORTED_BUILDER_TEMPLATE_FORMAT",
            "UNSUPPORTED_DOCUMENT_FORMAT": "BUILD.MOBILE_APP_TEMPLATE_VALIDATION.UNSUPPORTED_DOCUMENT_FORMAT" as "BUILD.MOBILE_APP_TEMPLATE_VALIDATION.UNSUPPORTED_DOCUMENT_FORMAT",
            "UNSUPPORTED_EDITABLE_FIELDS": "BUILD.MOBILE_APP_TEMPLATE_VALIDATION.UNSUPPORTED_EDITABLE_FIELDS" as "BUILD.MOBILE_APP_TEMPLATE_VALIDATION.UNSUPPORTED_EDITABLE_FIELDS"
        },
        "MOBILE_INFO": "BUILD.MOBILE_INFO" as "BUILD.MOBILE_INFO",
        "MOBILE_VIEW": "BUILD.MOBILE_VIEW" as "BUILD.MOBILE_VIEW",
        "MOVE_DOWN": "BUILD.MOVE_DOWN" as "BUILD.MOVE_DOWN",
        "MOVE_UP": "BUILD.MOVE_UP" as "BUILD.MOVE_UP",
        "MULTI_IMAGE": {
            "MULI_IMAGE_COUNTER_TOOLTIP": "BUILD.MULTI_IMAGE.MULI_IMAGE_COUNTER_TOOLTIP" as "BUILD.MULTI_IMAGE.MULI_IMAGE_COUNTER_TOOLTIP",
            "MULI_IMAGE_COUNTER_TOOLTIP_plural": "BUILD.MULTI_IMAGE.MULI_IMAGE_COUNTER_TOOLTIP_plural" as "BUILD.MULTI_IMAGE.MULI_IMAGE_COUNTER_TOOLTIP_plural",
            "MULTI_IMAGE": "BUILD.MULTI_IMAGE.MULTI_IMAGE" as "BUILD.MULTI_IMAGE.MULTI_IMAGE",
            "MULTI_IMAGE_TEMPLATE": "BUILD.MULTI_IMAGE.MULTI_IMAGE_TEMPLATE" as "BUILD.MULTI_IMAGE.MULTI_IMAGE_TEMPLATE",
            "NOTIFIER_EXPLANATION": "BUILD.MULTI_IMAGE.NOTIFIER_EXPLANATION" as "BUILD.MULTI_IMAGE.NOTIFIER_EXPLANATION",
            "REMOVE_IMAGE": {
                "MESSAGE": "BUILD.MULTI_IMAGE.REMOVE_IMAGE.MESSAGE" as "BUILD.MULTI_IMAGE.REMOVE_IMAGE.MESSAGE",
                "TITLE": "BUILD.MULTI_IMAGE.REMOVE_IMAGE.TITLE" as "BUILD.MULTI_IMAGE.REMOVE_IMAGE.TITLE"
            }
        },
        "MUST_VIEW_ALL_FRAMES": "BUILD.MUST_VIEW_ALL_FRAMES" as "BUILD.MUST_VIEW_ALL_FRAMES",
        "MUST_VIEW_ALL_IMAGES": "BUILD.MUST_VIEW_ALL_IMAGES" as "BUILD.MUST_VIEW_ALL_IMAGES",
        "MUST_VIEW_ALL_PAGES": "BUILD.MUST_VIEW_ALL_PAGES" as "BUILD.MUST_VIEW_ALL_PAGES",
        "NEW_TEMPLATE": "BUILD.NEW_TEMPLATE" as "BUILD.NEW_TEMPLATE",
        "NEW_TEMPLATE_EMAIL": "BUILD.NEW_TEMPLATE_EMAIL" as "BUILD.NEW_TEMPLATE_EMAIL",
        "NEW_TEMPLATE_IMAGE": "BUILD.NEW_TEMPLATE_IMAGE" as "BUILD.NEW_TEMPLATE_IMAGE",
        "NEW_TEMPLATE_PRINT": "BUILD.NEW_TEMPLATE_PRINT" as "BUILD.NEW_TEMPLATE_PRINT",
        "NEW_TEMPLATE_VIDEO": "BUILD.NEW_TEMPLATE_VIDEO" as "BUILD.NEW_TEMPLATE_VIDEO",
        "NOTIFY_TEXT_PLACEHOLDER_EXISTS": "BUILD.NOTIFY_TEXT_PLACEHOLDER_EXISTS" as "BUILD.NOTIFY_TEXT_PLACEHOLDER_EXISTS",
        "NO_CONTENT": "BUILD.NO_CONTENT" as "BUILD.NO_CONTENT",
        "OPTIMIZING_IMAGE": "BUILD.OPTIMIZING_IMAGE" as "BUILD.OPTIMIZING_IMAGE",
        "ORIGINAL_TEMPLATE": "BUILD.ORIGINAL_TEMPLATE" as "BUILD.ORIGINAL_TEMPLATE",
        "OVERLAYS": {
            "IMAGE_LAYER": "BUILD.OVERLAYS.IMAGE_LAYER" as "BUILD.OVERLAYS.IMAGE_LAYER",
            "MAP_LAYER": "BUILD.OVERLAYS.MAP_LAYER" as "BUILD.OVERLAYS.MAP_LAYER",
            "VIDEO_LAYER": "BUILD.OVERLAYS.VIDEO_LAYER" as "BUILD.OVERLAYS.VIDEO_LAYER"
        },
        "PHONE_NUMBER_NOT_SET": "BUILD.PHONE_NUMBER_NOT_SET" as "BUILD.PHONE_NUMBER_NOT_SET",
        "PLACEHOLDER": "BUILD.PLACEHOLDER" as "BUILD.PLACEHOLDER",
        "PLACEHOLDERS": "BUILD.PLACEHOLDERS" as "BUILD.PLACEHOLDERS",
        "PLANNER_DETAILS": "BUILD.PLANNER_DETAILS" as "BUILD.PLANNER_DETAILS",
        "PLATFORM": "BUILD.PLATFORM" as "BUILD.PLATFORM",
        "PORTRAIT": "BUILD.PORTRAIT" as "BUILD.PORTRAIT",
        "POSITION_X": "BUILD.POSITION_X" as "BUILD.POSITION_X",
        "POSITION_Y": "BUILD.POSITION_Y" as "BUILD.POSITION_Y",
        "PREVIEW_IMAGE": "BUILD.PREVIEW_IMAGE" as "BUILD.PREVIEW_IMAGE",
        "PRINT": {
            "ADD_PAGE_AFTER": "BUILD.PRINT.ADD_PAGE_AFTER" as "BUILD.PRINT.ADD_PAGE_AFTER",
            "ADD_PAGE_BEFORE": "BUILD.PRINT.ADD_PAGE_BEFORE" as "BUILD.PRINT.ADD_PAGE_BEFORE",
            "BLEED": "BUILD.PRINT.BLEED" as "BUILD.PRINT.BLEED",
            "CONFIRM_DELETE_PAGE": "BUILD.PRINT.CONFIRM_DELETE_PAGE" as "BUILD.PRINT.CONFIRM_DELETE_PAGE",
            "DELETE_PAGE": "BUILD.PRINT.DELETE_PAGE" as "BUILD.PRINT.DELETE_PAGE",
            "EXTRA_INFO": "BUILD.PRINT.EXTRA_INFO" as "BUILD.PRINT.EXTRA_INFO",
            "PAGE_NUMBER": "BUILD.PRINT.PAGE_NUMBER" as "BUILD.PRINT.PAGE_NUMBER",
            "PAGE_NUMBER_OF_COUNT": "BUILD.PRINT.PAGE_NUMBER_OF_COUNT" as "BUILD.PRINT.PAGE_NUMBER_OF_COUNT",
            "PLEASE_ENTER_PAGE_NUMBER_BETWEEN": "BUILD.PRINT.PLEASE_ENTER_PAGE_NUMBER_BETWEEN" as "BUILD.PRINT.PLEASE_ENTER_PAGE_NUMBER_BETWEEN",
            "SELECT_AT_LEAST_ONE_FORMAT": "BUILD.PRINT.SELECT_AT_LEAST_ONE_FORMAT" as "BUILD.PRINT.SELECT_AT_LEAST_ONE_FORMAT",
            "WHICH_PAGE_TO_COPY_LAYER_TO": "BUILD.PRINT.WHICH_PAGE_TO_COPY_LAYER_TO" as "BUILD.PRINT.WHICH_PAGE_TO_COPY_LAYER_TO"
        },
        "PROPERTIES": "BUILD.PROPERTIES" as "BUILD.PROPERTIES",
        "PUBLISH": {
            "ALREADY_SCHEDULED": "BUILD.PUBLISH.ALREADY_SCHEDULED" as "BUILD.PUBLISH.ALREADY_SCHEDULED",
            "CAMPAIGN_MONITOR": {
                "CAMPAIGN_NAME": "BUILD.PUBLISH.CAMPAIGN_MONITOR.CAMPAIGN_NAME" as "BUILD.PUBLISH.CAMPAIGN_MONITOR.CAMPAIGN_NAME",
                "CONFIRMATION_EMAIL_ADDRESS": "BUILD.PUBLISH.CAMPAIGN_MONITOR.CONFIRMATION_EMAIL_ADDRESS" as "BUILD.PUBLISH.CAMPAIGN_MONITOR.CONFIRMATION_EMAIL_ADDRESS",
                "FROM_EMAIL": "BUILD.PUBLISH.CAMPAIGN_MONITOR.FROM_EMAIL" as "BUILD.PUBLISH.CAMPAIGN_MONITOR.FROM_EMAIL",
                "FROM_NAME": "BUILD.PUBLISH.CAMPAIGN_MONITOR.FROM_NAME" as "BUILD.PUBLISH.CAMPAIGN_MONITOR.FROM_NAME",
                "IN_CAMPAIGN_MONITOR_ACCOUNTS_TIMEZONE": "BUILD.PUBLISH.CAMPAIGN_MONITOR.IN_CAMPAIGN_MONITOR_ACCOUNTS_TIMEZONE" as "BUILD.PUBLISH.CAMPAIGN_MONITOR.IN_CAMPAIGN_MONITOR_ACCOUNTS_TIMEZONE",
                "LISTS": "BUILD.PUBLISH.CAMPAIGN_MONITOR.LISTS" as "BUILD.PUBLISH.CAMPAIGN_MONITOR.LISTS",
                "NOTIFY_PUBLISH_SUCCESS": "BUILD.PUBLISH.CAMPAIGN_MONITOR.NOTIFY_PUBLISH_SUCCESS" as "BUILD.PUBLISH.CAMPAIGN_MONITOR.NOTIFY_PUBLISH_SUCCESS",
                "NO_LISTS_FOUND_SET_UP_YOUR_MAILING_LISTS": "BUILD.PUBLISH.CAMPAIGN_MONITOR.NO_LISTS_FOUND_SET_UP_YOUR_MAILING_LISTS" as "BUILD.PUBLISH.CAMPAIGN_MONITOR.NO_LISTS_FOUND_SET_UP_YOUR_MAILING_LISTS",
                "NO_SEGMENTS_FOUND": "BUILD.PUBLISH.CAMPAIGN_MONITOR.NO_SEGMENTS_FOUND" as "BUILD.PUBLISH.CAMPAIGN_MONITOR.NO_SEGMENTS_FOUND",
                "PREVIEW": "BUILD.PUBLISH.CAMPAIGN_MONITOR.PREVIEW" as "BUILD.PUBLISH.CAMPAIGN_MONITOR.PREVIEW",
                "PREVIEW_SEND": "BUILD.PUBLISH.CAMPAIGN_MONITOR.PREVIEW_SEND" as "BUILD.PUBLISH.CAMPAIGN_MONITOR.PREVIEW_SEND",
                "PREVIEW_SKIP": "BUILD.PUBLISH.CAMPAIGN_MONITOR.PREVIEW_SKIP" as "BUILD.PUBLISH.CAMPAIGN_MONITOR.PREVIEW_SKIP",
                "PUBLISH_TO_CAMPAIGN_MONITOR": "BUILD.PUBLISH.CAMPAIGN_MONITOR.PUBLISH_TO_CAMPAIGN_MONITOR" as "BUILD.PUBLISH.CAMPAIGN_MONITOR.PUBLISH_TO_CAMPAIGN_MONITOR",
                "RECIPIENTS": "BUILD.PUBLISH.CAMPAIGN_MONITOR.RECIPIENTS" as "BUILD.PUBLISH.CAMPAIGN_MONITOR.RECIPIENTS",
                "REPLY_TO": "BUILD.PUBLISH.CAMPAIGN_MONITOR.REPLY_TO" as "BUILD.PUBLISH.CAMPAIGN_MONITOR.REPLY_TO",
                "SAVE_DRAFT": "BUILD.PUBLISH.CAMPAIGN_MONITOR.SAVE_DRAFT" as "BUILD.PUBLISH.CAMPAIGN_MONITOR.SAVE_DRAFT",
                "SEGMENTS": "BUILD.PUBLISH.CAMPAIGN_MONITOR.SEGMENTS" as "BUILD.PUBLISH.CAMPAIGN_MONITOR.SEGMENTS",
                "SEND": "BUILD.PUBLISH.CAMPAIGN_MONITOR.SEND" as "BUILD.PUBLISH.CAMPAIGN_MONITOR.SEND",
                "SUBJECT": "BUILD.PUBLISH.CAMPAIGN_MONITOR.SUBJECT" as "BUILD.PUBLISH.CAMPAIGN_MONITOR.SUBJECT"
            },
            "CLUB_READY": {
                "ACTIVE": "BUILD.PUBLISH.CLUB_READY.ACTIVE" as "BUILD.PUBLISH.CLUB_READY.ACTIVE",
                "ACTIVE_MEMBERS": "BUILD.PUBLISH.CLUB_READY.ACTIVE_MEMBERS" as "BUILD.PUBLISH.CLUB_READY.ACTIVE_MEMBERS",
                "ADDED_AT_ANY_TIME": "BUILD.PUBLISH.CLUB_READY.ADDED_AT_ANY_TIME" as "BUILD.PUBLISH.CLUB_READY.ADDED_AT_ANY_TIME",
                "ADDED_BETWEEN": "BUILD.PUBLISH.CLUB_READY.ADDED_BETWEEN" as "BUILD.PUBLISH.CLUB_READY.ADDED_BETWEEN",
                "AFTER": "BUILD.PUBLISH.CLUB_READY.AFTER" as "BUILD.PUBLISH.CLUB_READY.AFTER",
                "ALL_ACTIVE_MEMBERS": "BUILD.PUBLISH.CLUB_READY.ALL_ACTIVE_MEMBERS" as "BUILD.PUBLISH.CLUB_READY.ALL_ACTIVE_MEMBERS",
                "ALL_INACTIVE_MEMBERS": "BUILD.PUBLISH.CLUB_READY.ALL_INACTIVE_MEMBERS" as "BUILD.PUBLISH.CLUB_READY.ALL_INACTIVE_MEMBERS",
                "AT_LEAST_ONE_LIST_MUST_BE_SELECTED": "BUILD.PUBLISH.CLUB_READY.AT_LEAST_ONE_LIST_MUST_BE_SELECTED" as "BUILD.PUBLISH.CLUB_READY.AT_LEAST_ONE_LIST_MUST_BE_SELECTED",
                "BEFORE": "BUILD.PUBLISH.CLUB_READY.BEFORE" as "BUILD.PUBLISH.CLUB_READY.BEFORE",
                "CLUB": "BUILD.PUBLISH.CLUB_READY.CLUB" as "BUILD.PUBLISH.CLUB_READY.CLUB",
                "COOLED_OFF_PROSPECTS": "BUILD.PUBLISH.CLUB_READY.COOLED_OFF_PROSPECTS" as "BUILD.PUBLISH.CLUB_READY.COOLED_OFF_PROSPECTS",
                "CUSTOM": "BUILD.PUBLISH.CLUB_READY.CUSTOM" as "BUILD.PUBLISH.CLUB_READY.CUSTOM",
                "CUSTOM_LIST_DESCRIPTION_PLACEHOLDER": "BUILD.PUBLISH.CLUB_READY.CUSTOM_LIST_DESCRIPTION_PLACEHOLDER" as "BUILD.PUBLISH.CLUB_READY.CUSTOM_LIST_DESCRIPTION_PLACEHOLDER",
                "CUSTOM_LIST_DESCRIPTION_WARNING": "BUILD.PUBLISH.CLUB_READY.CUSTOM_LIST_DESCRIPTION_WARNING" as "BUILD.PUBLISH.CLUB_READY.CUSTOM_LIST_DESCRIPTION_WARNING",
                "CUSTOM_LIST_MATCHES": "BUILD.PUBLISH.CLUB_READY.CUSTOM_LIST_MATCHES" as "BUILD.PUBLISH.CLUB_READY.CUSTOM_LIST_MATCHES",
                "CUSTOM_LIST_OF_EMAIL_ADDRESSES": "BUILD.PUBLISH.CLUB_READY.CUSTOM_LIST_OF_EMAIL_ADDRESSES" as "BUILD.PUBLISH.CLUB_READY.CUSTOM_LIST_OF_EMAIL_ADDRESSES",
                "CUSTOM_LIST_OF_EMAIL_ADDRESSES_WARNING": "BUILD.PUBLISH.CLUB_READY.CUSTOM_LIST_OF_EMAIL_ADDRESSES_WARNING" as "BUILD.PUBLISH.CLUB_READY.CUSTOM_LIST_OF_EMAIL_ADDRESSES_WARNING",
                "DISABLED_PUBLISH_HELP_TEXT": "BUILD.PUBLISH.CLUB_READY.DISABLED_PUBLISH_HELP_TEXT" as "BUILD.PUBLISH.CLUB_READY.DISABLED_PUBLISH_HELP_TEXT",
                "DUPLICATE_EMAILS": "BUILD.PUBLISH.CLUB_READY.DUPLICATE_EMAILS" as "BUILD.PUBLISH.CLUB_READY.DUPLICATE_EMAILS",
                "EMAIL_LIST_MUST_HAVE_VALUES": "BUILD.PUBLISH.CLUB_READY.EMAIL_LIST_MUST_HAVE_VALUES" as "BUILD.PUBLISH.CLUB_READY.EMAIL_LIST_MUST_HAVE_VALUES",
                "EMAIL_SUBJECT_AND_SCHEDULE": "BUILD.PUBLISH.CLUB_READY.EMAIL_SUBJECT_AND_SCHEDULE" as "BUILD.PUBLISH.CLUB_READY.EMAIL_SUBJECT_AND_SCHEDULE",
                "EXPORT_INFO": "BUILD.PUBLISH.CLUB_READY.EXPORT_INFO" as "BUILD.PUBLISH.CLUB_READY.EXPORT_INFO",
                "EXPORT_TITLE": "BUILD.PUBLISH.CLUB_READY.EXPORT_TITLE" as "BUILD.PUBLISH.CLUB_READY.EXPORT_TITLE",
                "FILTERED": "BUILD.PUBLISH.CLUB_READY.FILTERED" as "BUILD.PUBLISH.CLUB_READY.FILTERED",
                "INACTIVE": "BUILD.PUBLISH.CLUB_READY.INACTIVE" as "BUILD.PUBLISH.CLUB_READY.INACTIVE",
                "INACTIVE_MEMBERS": "BUILD.PUBLISH.CLUB_READY.INACTIVE_MEMBERS" as "BUILD.PUBLISH.CLUB_READY.INACTIVE_MEMBERS",
                "INVALID": "BUILD.PUBLISH.CLUB_READY.INVALID" as "BUILD.PUBLISH.CLUB_READY.INVALID",
                "I_CONFIRM_THAT_THE_ABOVE_DETAILS_ARE_CORRECT": "BUILD.PUBLISH.CLUB_READY.I_CONFIRM_THAT_THE_ABOVE_DETAILS_ARE_CORRECT" as "BUILD.PUBLISH.CLUB_READY.I_CONFIRM_THAT_THE_ABOVE_DETAILS_ARE_CORRECT",
                "MATCHED_OUT_OF": "BUILD.PUBLISH.CLUB_READY.MATCHED_OUT_OF" as "BUILD.PUBLISH.CLUB_READY.MATCHED_OUT_OF",
                "MEMBER_LIST_NOTICE": "BUILD.PUBLISH.CLUB_READY.MEMBER_LIST_NOTICE" as "BUILD.PUBLISH.CLUB_READY.MEMBER_LIST_NOTICE",
                "MORE_CLUB_COUNT": "BUILD.PUBLISH.CLUB_READY.MORE_CLUB_COUNT" as "BUILD.PUBLISH.CLUB_READY.MORE_CLUB_COUNT",
                "MORE_CLUB_COUNT_plural": "BUILD.PUBLISH.CLUB_READY.MORE_CLUB_COUNT_plural" as "BUILD.PUBLISH.CLUB_READY.MORE_CLUB_COUNT_plural",
                "NOT_INTERESTED": "BUILD.PUBLISH.CLUB_READY.NOT_INTERESTED" as "BUILD.PUBLISH.CLUB_READY.NOT_INTERESTED",
                "NO_SENDER_INFO_FOR_ONE_OR_MORE_LOCATIONS": "BUILD.PUBLISH.CLUB_READY.NO_SENDER_INFO_FOR_ONE_OR_MORE_LOCATIONS" as "BUILD.PUBLISH.CLUB_READY.NO_SENDER_INFO_FOR_ONE_OR_MORE_LOCATIONS",
                "NO_SENDER_INFO_HAS_BEEN_SET_FOR_LOCATION": "BUILD.PUBLISH.CLUB_READY.NO_SENDER_INFO_HAS_BEEN_SET_FOR_LOCATION" as "BUILD.PUBLISH.CLUB_READY.NO_SENDER_INFO_HAS_BEEN_SET_FOR_LOCATION",
                "ONE_OR_MORE_LISTS_DISABLED_MESSAGE": "BUILD.PUBLISH.CLUB_READY.ONE_OR_MORE_LISTS_DISABLED_MESSAGE" as "BUILD.PUBLISH.CLUB_READY.ONE_OR_MORE_LISTS_DISABLED_MESSAGE",
                "OPTOUT": "BUILD.PUBLISH.CLUB_READY.OPTOUT" as "BUILD.PUBLISH.CLUB_READY.OPTOUT",
                "PASTE_EMAIL_ADDRESSES_BELOW": "BUILD.PUBLISH.CLUB_READY.PASTE_EMAIL_ADDRESSES_BELOW" as "BUILD.PUBLISH.CLUB_READY.PASTE_EMAIL_ADDRESSES_BELOW",
                "PREVIEW_EMAIL_FAILED": "BUILD.PUBLISH.CLUB_READY.PREVIEW_EMAIL_FAILED" as "BUILD.PUBLISH.CLUB_READY.PREVIEW_EMAIL_FAILED",
                "PREVIEW_EMAIL_SENT": "BUILD.PUBLISH.CLUB_READY.PREVIEW_EMAIL_SENT" as "BUILD.PUBLISH.CLUB_READY.PREVIEW_EMAIL_SENT",
                "PROSPECTS": "BUILD.PUBLISH.CLUB_READY.PROSPECTS" as "BUILD.PUBLISH.CLUB_READY.PROSPECTS",
                "PROSPECTS_PAST_30_DAYS": "BUILD.PUBLISH.CLUB_READY.PROSPECTS_PAST_30_DAYS" as "BUILD.PUBLISH.CLUB_READY.PROSPECTS_PAST_30_DAYS",
                "PUBLISH_DELAY_WARNING_MESSAGE": "BUILD.PUBLISH.CLUB_READY.PUBLISH_DELAY_WARNING_MESSAGE" as "BUILD.PUBLISH.CLUB_READY.PUBLISH_DELAY_WARNING_MESSAGE",
                "REFETCH_VERIFY": "BUILD.PUBLISH.CLUB_READY.REFETCH_VERIFY" as "BUILD.PUBLISH.CLUB_READY.REFETCH_VERIFY",
                "SELECTED_LISTS_DOES_NOT_CONTAIN_ENOUGH_USERS_TO_SEND_TO": "BUILD.PUBLISH.CLUB_READY.SELECTED_LISTS_DOES_NOT_CONTAIN_ENOUGH_USERS_TO_SEND_TO" as "BUILD.PUBLISH.CLUB_READY.SELECTED_LISTS_DOES_NOT_CONTAIN_ENOUGH_USERS_TO_SEND_TO",
                "SELECTED_LISTS_DOES_NOT_CONTAIN_ENOUGH_USERS_TO_SEND_TO_plural": "BUILD.PUBLISH.CLUB_READY.SELECTED_LISTS_DOES_NOT_CONTAIN_ENOUGH_USERS_TO_SEND_TO_plural" as "BUILD.PUBLISH.CLUB_READY.SELECTED_LISTS_DOES_NOT_CONTAIN_ENOUGH_USERS_TO_SEND_TO_plural",
                "SELECTED_LISTS_SUMMARY": "BUILD.PUBLISH.CLUB_READY.SELECTED_LISTS_SUMMARY" as "BUILD.PUBLISH.CLUB_READY.SELECTED_LISTS_SUMMARY",
                "SELECTED_MEMBERS_AND_OR_PROSPECTS": "BUILD.PUBLISH.CLUB_READY.SELECTED_MEMBERS_AND_OR_PROSPECTS" as "BUILD.PUBLISH.CLUB_READY.SELECTED_MEMBERS_AND_OR_PROSPECTS",
                "SELECT_YOUR_CLUB_READY_LISTS": "BUILD.PUBLISH.CLUB_READY.SELECT_YOUR_CLUB_READY_LISTS" as "BUILD.PUBLISH.CLUB_READY.SELECT_YOUR_CLUB_READY_LISTS",
                "SENDER": "BUILD.PUBLISH.CLUB_READY.SENDER" as "BUILD.PUBLISH.CLUB_READY.SENDER",
                "SENDER_NOT_VERIFIED_MESSAGE": "BUILD.PUBLISH.CLUB_READY.SENDER_NOT_VERIFIED_MESSAGE" as "BUILD.PUBLISH.CLUB_READY.SENDER_NOT_VERIFIED_MESSAGE",
                "SENDER_NOT_VERIFIED_TOOLTIP": "BUILD.PUBLISH.CLUB_READY.SENDER_NOT_VERIFIED_TOOLTIP" as "BUILD.PUBLISH.CLUB_READY.SENDER_NOT_VERIFIED_TOOLTIP",
                "SENDER_VERIFIED_TOOLTIP": "BUILD.PUBLISH.CLUB_READY.SENDER_VERIFIED_TOOLTIP" as "BUILD.PUBLISH.CLUB_READY.SENDER_VERIFIED_TOOLTIP",
                "SEND_A_TEST_EMAIL": "BUILD.PUBLISH.CLUB_READY.SEND_A_TEST_EMAIL" as "BUILD.PUBLISH.CLUB_READY.SEND_A_TEST_EMAIL",
                "SEND_TO": "BUILD.PUBLISH.CLUB_READY.SEND_TO" as "BUILD.PUBLISH.CLUB_READY.SEND_TO",
                "SEND_TO_CLUB_READY_LIST": "BUILD.PUBLISH.CLUB_READY.SEND_TO_CLUB_READY_LIST" as "BUILD.PUBLISH.CLUB_READY.SEND_TO_CLUB_READY_LIST",
                "SEND_TO_INFO": "BUILD.PUBLISH.CLUB_READY.SEND_TO_INFO" as "BUILD.PUBLISH.CLUB_READY.SEND_TO_INFO",
                "SUBJECT": "BUILD.PUBLISH.CLUB_READY.SUBJECT" as "BUILD.PUBLISH.CLUB_READY.SUBJECT",
                "SUPPRESSED_LIST_INFO": "BUILD.PUBLISH.CLUB_READY.SUPPRESSED_LIST_INFO" as "BUILD.PUBLISH.CLUB_READY.SUPPRESSED_LIST_INFO",
                "TOTAL": "BUILD.PUBLISH.CLUB_READY.TOTAL" as "BUILD.PUBLISH.CLUB_READY.TOTAL",
                "VALID_DATE_REQUIRED_ACTIVITY_AFTER_OPTION": "BUILD.PUBLISH.CLUB_READY.VALID_DATE_REQUIRED_ACTIVITY_AFTER_OPTION" as "BUILD.PUBLISH.CLUB_READY.VALID_DATE_REQUIRED_ACTIVITY_AFTER_OPTION",
                "VALID_DATE_REQUIRED_ACTIVITY_BEFORE_OPTION": "BUILD.PUBLISH.CLUB_READY.VALID_DATE_REQUIRED_ACTIVITY_BEFORE_OPTION" as "BUILD.PUBLISH.CLUB_READY.VALID_DATE_REQUIRED_ACTIVITY_BEFORE_OPTION",
                "VALID_DATE_REQUIRED_ACTIVITY_BETWEEN_OPTION": "BUILD.PUBLISH.CLUB_READY.VALID_DATE_REQUIRED_ACTIVITY_BETWEEN_OPTION" as "BUILD.PUBLISH.CLUB_READY.VALID_DATE_REQUIRED_ACTIVITY_BETWEEN_OPTION",
                "WARN_PUBLISH_TOO_LARGE": "BUILD.PUBLISH.CLUB_READY.WARN_PUBLISH_TOO_LARGE" as "BUILD.PUBLISH.CLUB_READY.WARN_PUBLISH_TOO_LARGE",
                "WHEN_WOULD_YOU_LIKE_TO_SEND_THIS_EMAIL": "BUILD.PUBLISH.CLUB_READY.WHEN_WOULD_YOU_LIKE_TO_SEND_THIS_EMAIL" as "BUILD.PUBLISH.CLUB_READY.WHEN_WOULD_YOU_LIKE_TO_SEND_THIS_EMAIL",
                "WITH_ACTIVITY_AFTER": "BUILD.PUBLISH.CLUB_READY.WITH_ACTIVITY_AFTER" as "BUILD.PUBLISH.CLUB_READY.WITH_ACTIVITY_AFTER",
                "WITH_ACTIVITY_BEFORE": "BUILD.PUBLISH.CLUB_READY.WITH_ACTIVITY_BEFORE" as "BUILD.PUBLISH.CLUB_READY.WITH_ACTIVITY_BEFORE"
            },
            "CONGRATULATIONS": "BUILD.PUBLISH.CONGRATULATIONS" as "BUILD.PUBLISH.CONGRATULATIONS",
            "CURRENTLY_SELECTED": "BUILD.PUBLISH.CURRENTLY_SELECTED" as "BUILD.PUBLISH.CURRENTLY_SELECTED",
            "DOWNLOAD_TO_YOUR_COMPUTER": "BUILD.PUBLISH.DOWNLOAD_TO_YOUR_COMPUTER" as "BUILD.PUBLISH.DOWNLOAD_TO_YOUR_COMPUTER",
            "EXPORT_OPTIONS": "BUILD.PUBLISH.EXPORT_OPTIONS" as "BUILD.PUBLISH.EXPORT_OPTIONS",
            "FACEBOOK": {
                "ACCESS_CHECK_FAILURE": "BUILD.PUBLISH.FACEBOOK.ACCESS_CHECK_FAILURE" as "BUILD.PUBLISH.FACEBOOK.ACCESS_CHECK_FAILURE",
                "CAPTION": "BUILD.PUBLISH.FACEBOOK.CAPTION" as "BUILD.PUBLISH.FACEBOOK.CAPTION",
                "CAPTION_HELP_TEXT": "BUILD.PUBLISH.FACEBOOK.CAPTION_HELP_TEXT" as "BUILD.PUBLISH.FACEBOOK.CAPTION_HELP_TEXT",
                "FACEBOOK_PAGE": "BUILD.PUBLISH.FACEBOOK.FACEBOOK_PAGE" as "BUILD.PUBLISH.FACEBOOK.FACEBOOK_PAGE",
                "HASHTAGS_HELP_TEXT_CAPTION": "BUILD.PUBLISH.FACEBOOK.HASHTAGS_HELP_TEXT_CAPTION" as "BUILD.PUBLISH.FACEBOOK.HASHTAGS_HELP_TEXT_CAPTION",
                "HASHTAGS_HELP_TEXT_FIRST_COMMENT": "BUILD.PUBLISH.FACEBOOK.HASHTAGS_HELP_TEXT_FIRST_COMMENT" as "BUILD.PUBLISH.FACEBOOK.HASHTAGS_HELP_TEXT_FIRST_COMMENT",
                "HEADERS": {
                    "POST_DETAILS": "BUILD.PUBLISH.FACEBOOK.HEADERS.POST_DETAILS" as "BUILD.PUBLISH.FACEBOOK.HEADERS.POST_DETAILS",
                    "POST_SCHEDULE": "BUILD.PUBLISH.FACEBOOK.HEADERS.POST_SCHEDULE" as "BUILD.PUBLISH.FACEBOOK.HEADERS.POST_SCHEDULE"
                },
                "INPUT_LABELS": {
                    "DISPLAY_HASHTAGS_IN": "BUILD.PUBLISH.FACEBOOK.INPUT_LABELS.DISPLAY_HASHTAGS_IN" as "BUILD.PUBLISH.FACEBOOK.INPUT_LABELS.DISPLAY_HASHTAGS_IN",
                    "DISPLAY_HASHTAGS_IN_CAPTION": "BUILD.PUBLISH.FACEBOOK.INPUT_LABELS.DISPLAY_HASHTAGS_IN_CAPTION" as "BUILD.PUBLISH.FACEBOOK.INPUT_LABELS.DISPLAY_HASHTAGS_IN_CAPTION",
                    "DISPLAY_HASHTAGS_IN_FIRST_COMMENT": "BUILD.PUBLISH.FACEBOOK.INPUT_LABELS.DISPLAY_HASHTAGS_IN_FIRST_COMMENT" as "BUILD.PUBLISH.FACEBOOK.INPUT_LABELS.DISPLAY_HASHTAGS_IN_FIRST_COMMENT",
                    "HASHTAGS": "BUILD.PUBLISH.FACEBOOK.INPUT_LABELS.HASHTAGS" as "BUILD.PUBLISH.FACEBOOK.INPUT_LABELS.HASHTAGS"
                },
                "PAGES_COUNT": "BUILD.PUBLISH.FACEBOOK.PAGES_COUNT" as "BUILD.PUBLISH.FACEBOOK.PAGES_COUNT",
                "PAGES_COUNT_plural": "BUILD.PUBLISH.FACEBOOK.PAGES_COUNT_plural" as "BUILD.PUBLISH.FACEBOOK.PAGES_COUNT_plural",
                "PAGE_LIST_REMAINING": "BUILD.PUBLISH.FACEBOOK.PAGE_LIST_REMAINING" as "BUILD.PUBLISH.FACEBOOK.PAGE_LIST_REMAINING",
                "PAGE_LIST_REMAINING_plural": "BUILD.PUBLISH.FACEBOOK.PAGE_LIST_REMAINING_plural" as "BUILD.PUBLISH.FACEBOOK.PAGE_LIST_REMAINING_plural",
                "PUBLISH_TO_FACEBOOK": "BUILD.PUBLISH.FACEBOOK.PUBLISH_TO_FACEBOOK" as "BUILD.PUBLISH.FACEBOOK.PUBLISH_TO_FACEBOOK",
                "PUBLISH_VIDEO_TO_FACEBOOK": "BUILD.PUBLISH.FACEBOOK.PUBLISH_VIDEO_TO_FACEBOOK" as "BUILD.PUBLISH.FACEBOOK.PUBLISH_VIDEO_TO_FACEBOOK",
                "SCHEDULED_FACEBOOK_POST_MUST_BE_NO_MORE_THAN_28_DAYS_IN_FUTURE": "BUILD.PUBLISH.FACEBOOK.SCHEDULED_FACEBOOK_POST_MUST_BE_NO_MORE_THAN_28_DAYS_IN_FUTURE" as "BUILD.PUBLISH.FACEBOOK.SCHEDULED_FACEBOOK_POST_MUST_BE_NO_MORE_THAN_28_DAYS_IN_FUTURE",
                "SUGGESTED_CAPTION": "BUILD.PUBLISH.FACEBOOK.SUGGESTED_CAPTION" as "BUILD.PUBLISH.FACEBOOK.SUGGESTED_CAPTION"
            },
            "FETCH_FILE_SIZE_OPTIONS": "BUILD.PUBLISH.FETCH_FILE_SIZE_OPTIONS" as "BUILD.PUBLISH.FETCH_FILE_SIZE_OPTIONS",
            "FINAL_CONFIRMATION": "BUILD.PUBLISH.FINAL_CONFIRMATION" as "BUILD.PUBLISH.FINAL_CONFIRMATION",
            "FITWARE": {
                "AUTOMATED_EMAIL_CATEGORIES_FAILED_TO_LOAD": "BUILD.PUBLISH.FITWARE.AUTOMATED_EMAIL_CATEGORIES_FAILED_TO_LOAD" as "BUILD.PUBLISH.FITWARE.AUTOMATED_EMAIL_CATEGORIES_FAILED_TO_LOAD",
                "AUTOMATED_EMAIL_CATEGORY": "BUILD.PUBLISH.FITWARE.AUTOMATED_EMAIL_CATEGORY" as "BUILD.PUBLISH.FITWARE.AUTOMATED_EMAIL_CATEGORY",
                "AUTOMATED_EMAIL_CATEGORY_MISSING_IN_SOME_LOCATIONS_HELP_TEXT": "BUILD.PUBLISH.FITWARE.AUTOMATED_EMAIL_CATEGORY_MISSING_IN_SOME_LOCATIONS_HELP_TEXT" as "BUILD.PUBLISH.FITWARE.AUTOMATED_EMAIL_CATEGORY_MISSING_IN_SOME_LOCATIONS_HELP_TEXT",
                "AUTOMATED_EMAIL_UPDATED_DESCRIPTION": "BUILD.PUBLISH.FITWARE.AUTOMATED_EMAIL_UPDATED_DESCRIPTION" as "BUILD.PUBLISH.FITWARE.AUTOMATED_EMAIL_UPDATED_DESCRIPTION",
                "AUTOMATED_EMAIL_UPDATED_TITLE": "BUILD.PUBLISH.FITWARE.AUTOMATED_EMAIL_UPDATED_TITLE" as "BUILD.PUBLISH.FITWARE.AUTOMATED_EMAIL_UPDATED_TITLE",
                "CONFIRM_DECLARATION": "BUILD.PUBLISH.FITWARE.CONFIRM_DECLARATION" as "BUILD.PUBLISH.FITWARE.CONFIRM_DECLARATION",
                "DIRECT_EMAIL_PLATFORM_HELP_TEXT": "BUILD.PUBLISH.FITWARE.DIRECT_EMAIL_PLATFORM_HELP_TEXT" as "BUILD.PUBLISH.FITWARE.DIRECT_EMAIL_PLATFORM_HELP_TEXT",
                "DIRECT_EMAIL_PLATFORM_LABEL": "BUILD.PUBLISH.FITWARE.DIRECT_EMAIL_PLATFORM_LABEL" as "BUILD.PUBLISH.FITWARE.DIRECT_EMAIL_PLATFORM_LABEL",
                "FITWARE_AUTOMATED_EMAIL": "BUILD.PUBLISH.FITWARE.FITWARE_AUTOMATED_EMAIL" as "BUILD.PUBLISH.FITWARE.FITWARE_AUTOMATED_EMAIL",
                "FITWARE_AUTOMATED_EMAIL_HELP_TEXT": "BUILD.PUBLISH.FITWARE.FITWARE_AUTOMATED_EMAIL_HELP_TEXT" as "BUILD.PUBLISH.FITWARE.FITWARE_AUTOMATED_EMAIL_HELP_TEXT",
                "MEMBER_LISTS": "BUILD.PUBLISH.FITWARE.MEMBER_LISTS" as "BUILD.PUBLISH.FITWARE.MEMBER_LISTS",
                "MEMBER_LISTS_FAILED_TO_LOAD": "BUILD.PUBLISH.FITWARE.MEMBER_LISTS_FAILED_TO_LOAD" as "BUILD.PUBLISH.FITWARE.MEMBER_LISTS_FAILED_TO_LOAD",
                "NO_MEMBER_LISTS_FOUND": "BUILD.PUBLISH.FITWARE.NO_MEMBER_LISTS_FOUND" as "BUILD.PUBLISH.FITWARE.NO_MEMBER_LISTS_FOUND",
                "PLATFORMS_HEADING": "BUILD.PUBLISH.FITWARE.PLATFORMS_HEADING" as "BUILD.PUBLISH.FITWARE.PLATFORMS_HEADING",
                "PREVIEW": "BUILD.PUBLISH.FITWARE.PREVIEW" as "BUILD.PUBLISH.FITWARE.PREVIEW",
                "PREVIEW_EMAIL_ADDRESS": "BUILD.PUBLISH.FITWARE.PREVIEW_EMAIL_ADDRESS" as "BUILD.PUBLISH.FITWARE.PREVIEW_EMAIL_ADDRESS",
                "PREVIEW_SEND": "BUILD.PUBLISH.FITWARE.PREVIEW_SEND" as "BUILD.PUBLISH.FITWARE.PREVIEW_SEND",
                "PREVIEW_SKIP": "BUILD.PUBLISH.FITWARE.PREVIEW_SKIP" as "BUILD.PUBLISH.FITWARE.PREVIEW_SKIP",
                "PUBLISH_TO_FITWARE": "BUILD.PUBLISH.FITWARE.PUBLISH_TO_FITWARE" as "BUILD.PUBLISH.FITWARE.PUBLISH_TO_FITWARE",
                "RETURN_TO_MEMBER_ENGAGER": "BUILD.PUBLISH.FITWARE.RETURN_TO_MEMBER_ENGAGER" as "BUILD.PUBLISH.FITWARE.RETURN_TO_MEMBER_ENGAGER",
                "SCHEDULED_TIME": "BUILD.PUBLISH.FITWARE.SCHEDULED_TIME" as "BUILD.PUBLISH.FITWARE.SCHEDULED_TIME",
                "SEND": "BUILD.PUBLISH.FITWARE.SEND" as "BUILD.PUBLISH.FITWARE.SEND",
                "SENDER": "BUILD.PUBLISH.FITWARE.SENDER" as "BUILD.PUBLISH.FITWARE.SENDER",
                "SENDER_plural": "BUILD.PUBLISH.FITWARE.SENDER_plural" as "BUILD.PUBLISH.FITWARE.SENDER_plural",
                "STEP_TITLES": {
                    "AUTOMATED_EMAIL_CATEGORY": "BUILD.PUBLISH.FITWARE.STEP_TITLES.AUTOMATED_EMAIL_CATEGORY" as "BUILD.PUBLISH.FITWARE.STEP_TITLES.AUTOMATED_EMAIL_CATEGORY",
                    "MEMBER_LISTS": "BUILD.PUBLISH.FITWARE.STEP_TITLES.MEMBER_LISTS" as "BUILD.PUBLISH.FITWARE.STEP_TITLES.MEMBER_LISTS",
                    "PUBLISHING": "BUILD.PUBLISH.FITWARE.STEP_TITLES.PUBLISHING" as "BUILD.PUBLISH.FITWARE.STEP_TITLES.PUBLISHING",
                    "SCHEDULED_TIME": "BUILD.PUBLISH.FITWARE.STEP_TITLES.SCHEDULED_TIME" as "BUILD.PUBLISH.FITWARE.STEP_TITLES.SCHEDULED_TIME",
                    "SEND_PREVIEW": "BUILD.PUBLISH.FITWARE.STEP_TITLES.SEND_PREVIEW" as "BUILD.PUBLISH.FITWARE.STEP_TITLES.SEND_PREVIEW",
                    "SUBJECT": "BUILD.PUBLISH.FITWARE.STEP_TITLES.SUBJECT" as "BUILD.PUBLISH.FITWARE.STEP_TITLES.SUBJECT",
                    "SUMMARY": "BUILD.PUBLISH.FITWARE.STEP_TITLES.SUMMARY" as "BUILD.PUBLISH.FITWARE.STEP_TITLES.SUMMARY"
                },
                "SUBJECT": "BUILD.PUBLISH.FITWARE.SUBJECT" as "BUILD.PUBLISH.FITWARE.SUBJECT"
            },
            "GOOGLE_MY_BUSINESS": {
                "ACCESS_CHECK_FAILURE": "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.ACCESS_CHECK_FAILURE" as "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.ACCESS_CHECK_FAILURE",
                "BUSINESS_LOCATION": "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUSINESS_LOCATION" as "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUSINESS_LOCATION",
                "BUTTON_LINK": "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_LINK" as "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_LINK",
                "BUTTON_TYPE": "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_TYPE" as "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_TYPE",
                "BUTTON_TYPES": {
                    "BOOK": "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_TYPES.BOOK" as "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_TYPES.BOOK",
                    "CALL": "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_TYPES.CALL" as "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_TYPES.CALL",
                    "LEARN_MORE": "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_TYPES.LEARN_MORE" as "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_TYPES.LEARN_MORE",
                    "ORDER": "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_TYPES.ORDER" as "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_TYPES.ORDER",
                    "SHOP": "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_TYPES.SHOP" as "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_TYPES.SHOP",
                    "SIGN_UP": "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_TYPES.SIGN_UP" as "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_TYPES.SIGN_UP"
                },
                "CALL_TO_ACTION": "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.CALL_TO_ACTION" as "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.CALL_TO_ACTION",
                "CANNOT_START_EVENT_BEFORE_SCHEDULED_TIME": "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.CANNOT_START_EVENT_BEFORE_SCHEDULED_TIME" as "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.CANNOT_START_EVENT_BEFORE_SCHEDULED_TIME",
                "CANNOT_START_OFFER_BEFORE_SCHEDULED_TIME": "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.CANNOT_START_OFFER_BEFORE_SCHEDULED_TIME" as "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.CANNOT_START_OFFER_BEFORE_SCHEDULED_TIME",
                "CHARACTER_LIMIT_REACHED": "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.CHARACTER_LIMIT_REACHED" as "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.CHARACTER_LIMIT_REACHED",
                "EVENT_DESCRIPTION": "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.EVENT_DESCRIPTION" as "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.EVENT_DESCRIPTION",
                "EVENT_TITLE": "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.EVENT_TITLE" as "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.EVENT_TITLE",
                "OFFER_CODE": "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.OFFER_CODE" as "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.OFFER_CODE",
                "OFFER_DESCRIPTION": "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.OFFER_DESCRIPTION" as "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.OFFER_DESCRIPTION",
                "OFFER_LINK": "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.OFFER_LINK" as "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.OFFER_LINK",
                "OFFER_TITLE": "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.OFFER_TITLE" as "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.OFFER_TITLE",
                "POST_BODY": "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.POST_BODY" as "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.POST_BODY",
                "POST_TYPE": "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.POST_TYPE" as "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.POST_TYPE",
                "POST_TYPES": {
                    "EVENT": "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.POST_TYPES.EVENT" as "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.POST_TYPES.EVENT",
                    "OFFER": "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.POST_TYPES.OFFER" as "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.POST_TYPES.OFFER",
                    "PRODUCT": "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.POST_TYPES.PRODUCT" as "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.POST_TYPES.PRODUCT",
                    "STANDARD": "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.POST_TYPES.STANDARD" as "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.POST_TYPES.STANDARD"
                },
                "PUBLISH_TO_GOOGLE_MY_BUSINESS": "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.PUBLISH_TO_GOOGLE_MY_BUSINESS" as "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.PUBLISH_TO_GOOGLE_MY_BUSINESS",
                "TERMS_AND_CONDITIONS": "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.TERMS_AND_CONDITIONS" as "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.TERMS_AND_CONDITIONS"
            },
            "GO_BACK_CONFIRM_MESSAGE": "BUILD.PUBLISH.GO_BACK_CONFIRM_MESSAGE" as "BUILD.PUBLISH.GO_BACK_CONFIRM_MESSAGE",
            "GO_BACK_CONFIRM_TITLE": "BUILD.PUBLISH.GO_BACK_CONFIRM_TITLE" as "BUILD.PUBLISH.GO_BACK_CONFIRM_TITLE",
            "HASHTAGS": {
                "CLIENT_HASHTAGS": "BUILD.PUBLISH.HASHTAGS.CLIENT_HASHTAGS" as "BUILD.PUBLISH.HASHTAGS.CLIENT_HASHTAGS",
                "ERROR_LIMIT_HASHTAG_COUNT": "BUILD.PUBLISH.HASHTAGS.ERROR_LIMIT_HASHTAG_COUNT" as "BUILD.PUBLISH.HASHTAGS.ERROR_LIMIT_HASHTAG_COUNT",
                "ERROR_LIMIT_HASHTAG_COUNT_plural": "BUILD.PUBLISH.HASHTAGS.ERROR_LIMIT_HASHTAG_COUNT_plural" as "BUILD.PUBLISH.HASHTAGS.ERROR_LIMIT_HASHTAG_COUNT_plural",
                "ERROR_LIMIT_HASHTAG_LENGTH": "BUILD.PUBLISH.HASHTAGS.ERROR_LIMIT_HASHTAG_LENGTH" as "BUILD.PUBLISH.HASHTAGS.ERROR_LIMIT_HASHTAG_LENGTH",
                "ERROR_LIMIT_HASHTAG_SET": "BUILD.PUBLISH.HASHTAGS.ERROR_LIMIT_HASHTAG_SET" as "BUILD.PUBLISH.HASHTAGS.ERROR_LIMIT_HASHTAG_SET",
                "HASHTAG_CHARACTER_COUNT": "BUILD.PUBLISH.HASHTAGS.HASHTAG_CHARACTER_COUNT" as "BUILD.PUBLISH.HASHTAGS.HASHTAG_CHARACTER_COUNT",
                "HASHTAG_SET_ALREADY_ADDED": "BUILD.PUBLISH.HASHTAGS.HASHTAG_SET_ALREADY_ADDED" as "BUILD.PUBLISH.HASHTAGS.HASHTAG_SET_ALREADY_ADDED",
                "HASHTAG_TAG_COUNT": "BUILD.PUBLISH.HASHTAGS.HASHTAG_TAG_COUNT" as "BUILD.PUBLISH.HASHTAGS.HASHTAG_TAG_COUNT",
                "LOCATION_HASHTAGS": "BUILD.PUBLISH.HASHTAGS.LOCATION_HASHTAGS" as "BUILD.PUBLISH.HASHTAGS.LOCATION_HASHTAGS",
                "NO_HASHTAG_SETS": "BUILD.PUBLISH.HASHTAGS.NO_HASHTAG_SETS" as "BUILD.PUBLISH.HASHTAGS.NO_HASHTAG_SETS",
                "USE_HASHTAG_SETS": "BUILD.PUBLISH.HASHTAGS.USE_HASHTAG_SETS" as "BUILD.PUBLISH.HASHTAGS.USE_HASHTAG_SETS"
            },
            "IMAGE_FORMAT": "BUILD.PUBLISH.IMAGE_FORMAT" as "BUILD.PUBLISH.IMAGE_FORMAT",
            "INCLUDE_BLEED_AND_TRIM_MARKS": "BUILD.PUBLISH.INCLUDE_BLEED_AND_TRIM_MARKS" as "BUILD.PUBLISH.INCLUDE_BLEED_AND_TRIM_MARKS",
            "INCLUDE_BLEED_AND_TRIM_MARKS_DISCLAIMER": "BUILD.PUBLISH.INCLUDE_BLEED_AND_TRIM_MARKS_DISCLAIMER" as "BUILD.PUBLISH.INCLUDE_BLEED_AND_TRIM_MARKS_DISCLAIMER",
            "INCLUDE_BLEED_AND_TRIM_MARKS_HELP": "BUILD.PUBLISH.INCLUDE_BLEED_AND_TRIM_MARKS_HELP" as "BUILD.PUBLISH.INCLUDE_BLEED_AND_TRIM_MARKS_HELP",
            "INSTAGRAM": {
                "ACCESS_CHECK_FAILURE": "BUILD.PUBLISH.INSTAGRAM.ACCESS_CHECK_FAILURE" as "BUILD.PUBLISH.INSTAGRAM.ACCESS_CHECK_FAILURE",
                "APP_NOTIFICATIONS_DISABLED": "BUILD.PUBLISH.INSTAGRAM.APP_NOTIFICATIONS_DISABLED" as "BUILD.PUBLISH.INSTAGRAM.APP_NOTIFICATIONS_DISABLED",
                "APP_NOT_INSTALLED": "BUILD.PUBLISH.INSTAGRAM.APP_NOT_INSTALLED" as "BUILD.PUBLISH.INSTAGRAM.APP_NOT_INSTALLED",
                "APP_SETUP_PROPERLY": "BUILD.PUBLISH.INSTAGRAM.APP_SETUP_PROPERLY" as "BUILD.PUBLISH.INSTAGRAM.APP_SETUP_PROPERLY",
                "APP_USER_REQUIRED": "BUILD.PUBLISH.INSTAGRAM.APP_USER_REQUIRED" as "BUILD.PUBLISH.INSTAGRAM.APP_USER_REQUIRED",
                "ASPECT_RATIO_HELP_TEXT": "BUILD.PUBLISH.INSTAGRAM.ASPECT_RATIO_HELP_TEXT" as "BUILD.PUBLISH.INSTAGRAM.ASPECT_RATIO_HELP_TEXT",
                "ASPECT_RATIO_STORY_HELP_TEXT": "BUILD.PUBLISH.INSTAGRAM.ASPECT_RATIO_STORY_HELP_TEXT" as "BUILD.PUBLISH.INSTAGRAM.ASPECT_RATIO_STORY_HELP_TEXT",
                "ASPECT_RATIO_VIDEO_HELP_TEXT": "BUILD.PUBLISH.INSTAGRAM.ASPECT_RATIO_VIDEO_HELP_TEXT" as "BUILD.PUBLISH.INSTAGRAM.ASPECT_RATIO_VIDEO_HELP_TEXT",
                "ASSIGN_USER_TO_POST": "BUILD.PUBLISH.INSTAGRAM.ASSIGN_USER_TO_POST" as "BUILD.PUBLISH.INSTAGRAM.ASSIGN_USER_TO_POST",
                "AS_THE_FIRST_COMMENT_ON_THE_POST": "BUILD.PUBLISH.INSTAGRAM.AS_THE_FIRST_COMMENT_ON_THE_POST" as "BUILD.PUBLISH.INSTAGRAM.AS_THE_FIRST_COMMENT_ON_THE_POST",
                "AT_THE_BOTTOM_ON_THE_POST_CAPTION": "BUILD.PUBLISH.INSTAGRAM.AT_THE_BOTTOM_ON_THE_POST_CAPTION" as "BUILD.PUBLISH.INSTAGRAM.AT_THE_BOTTOM_ON_THE_POST_CAPTION",
                "CAPTION": "BUILD.PUBLISH.INSTAGRAM.CAPTION" as "BUILD.PUBLISH.INSTAGRAM.CAPTION",
                "CAPTION_HELP_TEXT": "BUILD.PUBLISH.INSTAGRAM.CAPTION_HELP_TEXT" as "BUILD.PUBLISH.INSTAGRAM.CAPTION_HELP_TEXT",
                "ENTER_VALID_MOBILE_NUMBER": "BUILD.PUBLISH.INSTAGRAM.ENTER_VALID_MOBILE_NUMBER" as "BUILD.PUBLISH.INSTAGRAM.ENTER_VALID_MOBILE_NUMBER",
                "EXCEEDED_MAX_IMAGE_COUNT_HELP_TEXT": "BUILD.PUBLISH.INSTAGRAM.EXCEEDED_MAX_IMAGE_COUNT_HELP_TEXT" as "BUILD.PUBLISH.INSTAGRAM.EXCEEDED_MAX_IMAGE_COUNT_HELP_TEXT",
                "HASHTAGS_HELP_TEXT_CAPTION": "BUILD.PUBLISH.INSTAGRAM.HASHTAGS_HELP_TEXT_CAPTION" as "BUILD.PUBLISH.INSTAGRAM.HASHTAGS_HELP_TEXT_CAPTION",
                "HASHTAGS_HELP_TEXT_FIRST_COMMENT": "BUILD.PUBLISH.INSTAGRAM.HASHTAGS_HELP_TEXT_FIRST_COMMENT" as "BUILD.PUBLISH.INSTAGRAM.HASHTAGS_HELP_TEXT_FIRST_COMMENT",
                "HEADERS": {
                    "POST_DETAILS": "BUILD.PUBLISH.INSTAGRAM.HEADERS.POST_DETAILS" as "BUILD.PUBLISH.INSTAGRAM.HEADERS.POST_DETAILS",
                    "POST_SCHEDULE": "BUILD.PUBLISH.INSTAGRAM.HEADERS.POST_SCHEDULE" as "BUILD.PUBLISH.INSTAGRAM.HEADERS.POST_SCHEDULE"
                },
                "INPUT_LABELS": {
                    "DISPLAY_HASHTAGS_IN": "BUILD.PUBLISH.INSTAGRAM.INPUT_LABELS.DISPLAY_HASHTAGS_IN" as "BUILD.PUBLISH.INSTAGRAM.INPUT_LABELS.DISPLAY_HASHTAGS_IN",
                    "DISPLAY_HASHTAGS_IN_CAPTION": "BUILD.PUBLISH.INSTAGRAM.INPUT_LABELS.DISPLAY_HASHTAGS_IN_CAPTION" as "BUILD.PUBLISH.INSTAGRAM.INPUT_LABELS.DISPLAY_HASHTAGS_IN_CAPTION",
                    "DISPLAY_HASHTAGS_IN_FIRST_COMMENT": "BUILD.PUBLISH.INSTAGRAM.INPUT_LABELS.DISPLAY_HASHTAGS_IN_FIRST_COMMENT" as "BUILD.PUBLISH.INSTAGRAM.INPUT_LABELS.DISPLAY_HASHTAGS_IN_FIRST_COMMENT",
                    "HASHTAGS": "BUILD.PUBLISH.INSTAGRAM.INPUT_LABELS.HASHTAGS" as "BUILD.PUBLISH.INSTAGRAM.INPUT_LABELS.HASHTAGS"
                },
                "INSTAGRAM_PAGE": "BUILD.PUBLISH.INSTAGRAM.INSTAGRAM_PAGE" as "BUILD.PUBLISH.INSTAGRAM.INSTAGRAM_PAGE",
                "INVALID_DIMENSIONS_HEIGHT_HELP_TEXT": "BUILD.PUBLISH.INSTAGRAM.INVALID_DIMENSIONS_HEIGHT_HELP_TEXT" as "BUILD.PUBLISH.INSTAGRAM.INVALID_DIMENSIONS_HEIGHT_HELP_TEXT",
                "INVALID_DIMENSIONS_WIDTH_HELP_TEXT": "BUILD.PUBLISH.INSTAGRAM.INVALID_DIMENSIONS_WIDTH_HELP_TEXT" as "BUILD.PUBLISH.INSTAGRAM.INVALID_DIMENSIONS_WIDTH_HELP_TEXT",
                "MISSING_PERMISSIONS_HELP_TEXT": "BUILD.PUBLISH.INSTAGRAM.MISSING_PERMISSIONS_HELP_TEXT" as "BUILD.PUBLISH.INSTAGRAM.MISSING_PERMISSIONS_HELP_TEXT",
                "MOBILE_NUMBER": "BUILD.PUBLISH.INSTAGRAM.MOBILE_NUMBER" as "BUILD.PUBLISH.INSTAGRAM.MOBILE_NUMBER",
                "MOBILE_NUMBER_INFO": "BUILD.PUBLISH.INSTAGRAM.MOBILE_NUMBER_INFO" as "BUILD.PUBLISH.INSTAGRAM.MOBILE_NUMBER_INFO",
                "NOTIFICATION_FOR_INSTAGRAM": "BUILD.PUBLISH.INSTAGRAM.NOTIFICATION_FOR_INSTAGRAM" as "BUILD.PUBLISH.INSTAGRAM.NOTIFICATION_FOR_INSTAGRAM",
                "NOTIFICATION_SCHEDULE": "BUILD.PUBLISH.INSTAGRAM.NOTIFICATION_SCHEDULE" as "BUILD.PUBLISH.INSTAGRAM.NOTIFICATION_SCHEDULE",
                "POSTS_FROM_MOBILE_HINT": "BUILD.PUBLISH.INSTAGRAM.POSTS_FROM_MOBILE_HINT" as "BUILD.PUBLISH.INSTAGRAM.POSTS_FROM_MOBILE_HINT",
                "POSTS_WILL_EXPIRE": "BUILD.PUBLISH.INSTAGRAM.POSTS_WILL_EXPIRE" as "BUILD.PUBLISH.INSTAGRAM.POSTS_WILL_EXPIRE",
                "POSTS_WILL_EXPIRE_plural": "BUILD.PUBLISH.INSTAGRAM.POSTS_WILL_EXPIRE_plural" as "BUILD.PUBLISH.INSTAGRAM.POSTS_WILL_EXPIRE_plural",
                "PUBLISH_IMAGE_TO_INSTAGRAM": "BUILD.PUBLISH.INSTAGRAM.PUBLISH_IMAGE_TO_INSTAGRAM" as "BUILD.PUBLISH.INSTAGRAM.PUBLISH_IMAGE_TO_INSTAGRAM",
                "PUBLISH_STORY_TO_INSTAGRAM": "BUILD.PUBLISH.INSTAGRAM.PUBLISH_STORY_TO_INSTAGRAM" as "BUILD.PUBLISH.INSTAGRAM.PUBLISH_STORY_TO_INSTAGRAM",
                "PUBLISH_VIDEO_TO_INSTAGRAM": "BUILD.PUBLISH.INSTAGRAM.PUBLISH_VIDEO_TO_INSTAGRAM" as "BUILD.PUBLISH.INSTAGRAM.PUBLISH_VIDEO_TO_INSTAGRAM",
                "SCHEDULED_INSTAGRAM_POST_MUST_BE_NO_MORE_THAN_75_DAYS_IN_FUTURE": "BUILD.PUBLISH.INSTAGRAM.SCHEDULED_INSTAGRAM_POST_MUST_BE_NO_MORE_THAN_75_DAYS_IN_FUTURE" as "BUILD.PUBLISH.INSTAGRAM.SCHEDULED_INSTAGRAM_POST_MUST_BE_NO_MORE_THAN_75_DAYS_IN_FUTURE",
                "SCHEDULED_POST_MUST_BE_AT_LEAST_MINS_IN_FUTURE": "BUILD.PUBLISH.INSTAGRAM.SCHEDULED_POST_MUST_BE_AT_LEAST_MINS_IN_FUTURE" as "BUILD.PUBLISH.INSTAGRAM.SCHEDULED_POST_MUST_BE_AT_LEAST_MINS_IN_FUTURE",
                "SCHEDULE_FOR_INSTAGRAM": "BUILD.PUBLISH.INSTAGRAM.SCHEDULE_FOR_INSTAGRAM" as "BUILD.PUBLISH.INSTAGRAM.SCHEDULE_FOR_INSTAGRAM",
                "SCHEDULE_FOR_INSTAGRAM_STORY": "BUILD.PUBLISH.INSTAGRAM.SCHEDULE_FOR_INSTAGRAM_STORY" as "BUILD.PUBLISH.INSTAGRAM.SCHEDULE_FOR_INSTAGRAM_STORY",
                "SCHEDULE_IMAGE_VIA_API": "BUILD.PUBLISH.INSTAGRAM.SCHEDULE_IMAGE_VIA_API" as "BUILD.PUBLISH.INSTAGRAM.SCHEDULE_IMAGE_VIA_API",
                "SCHEDULE_NOTIFICATION_FOR_INSTAGRAM": "BUILD.PUBLISH.INSTAGRAM.SCHEDULE_NOTIFICATION_FOR_INSTAGRAM" as "BUILD.PUBLISH.INSTAGRAM.SCHEDULE_NOTIFICATION_FOR_INSTAGRAM",
                "SCHEDULE_STORY_VIA_API": "BUILD.PUBLISH.INSTAGRAM.SCHEDULE_STORY_VIA_API" as "BUILD.PUBLISH.INSTAGRAM.SCHEDULE_STORY_VIA_API",
                "SCHEDULE_VIA_MOBILE_APP": "BUILD.PUBLISH.INSTAGRAM.SCHEDULE_VIA_MOBILE_APP" as "BUILD.PUBLISH.INSTAGRAM.SCHEDULE_VIA_MOBILE_APP",
                "SCHEDULE_VIDEO_VIA_API": "BUILD.PUBLISH.INSTAGRAM.SCHEDULE_VIDEO_VIA_API" as "BUILD.PUBLISH.INSTAGRAM.SCHEDULE_VIDEO_VIA_API",
                "SEARCH_FOR_USER": "BUILD.PUBLISH.INSTAGRAM.SEARCH_FOR_USER" as "BUILD.PUBLISH.INSTAGRAM.SEARCH_FOR_USER",
                "SELECT_RELEVANT_COUNTRY_CODE": "BUILD.PUBLISH.INSTAGRAM.SELECT_RELEVANT_COUNTRY_CODE" as "BUILD.PUBLISH.INSTAGRAM.SELECT_RELEVANT_COUNTRY_CODE",
                "SEND_POST_DETAILS": "BUILD.PUBLISH.INSTAGRAM.SEND_POST_DETAILS" as "BUILD.PUBLISH.INSTAGRAM.SEND_POST_DETAILS",
                "SEND_SMS_AS_WELL": "BUILD.PUBLISH.INSTAGRAM.SEND_SMS_AS_WELL" as "BUILD.PUBLISH.INSTAGRAM.SEND_SMS_AS_WELL",
                "STORY_MULTI_IMAGE_HELP_TEXT": "BUILD.PUBLISH.INSTAGRAM.STORY_MULTI_IMAGE_HELP_TEXT" as "BUILD.PUBLISH.INSTAGRAM.STORY_MULTI_IMAGE_HELP_TEXT",
                "STORY_VIDEO_DURATION_HELP_TEXT": "BUILD.PUBLISH.INSTAGRAM.STORY_VIDEO_DURATION_HELP_TEXT" as "BUILD.PUBLISH.INSTAGRAM.STORY_VIDEO_DURATION_HELP_TEXT",
                "SUGGESTED_CAPTION": "BUILD.PUBLISH.INSTAGRAM.SUGGESTED_CAPTION" as "BUILD.PUBLISH.INSTAGRAM.SUGGESTED_CAPTION",
                "VIDEO_DURATION_HELP_TEXT": "BUILD.PUBLISH.INSTAGRAM.VIDEO_DURATION_HELP_TEXT" as "BUILD.PUBLISH.INSTAGRAM.VIDEO_DURATION_HELP_TEXT"
            },
            "LINKEDIN": {
                "ACCESS_CHECK_FAILURE": "BUILD.PUBLISH.LINKEDIN.ACCESS_CHECK_FAILURE" as "BUILD.PUBLISH.LINKEDIN.ACCESS_CHECK_FAILURE",
                "CAPTION": "BUILD.PUBLISH.LINKEDIN.CAPTION" as "BUILD.PUBLISH.LINKEDIN.CAPTION",
                "CAPTION_HELP_TEXT": "BUILD.PUBLISH.LINKEDIN.CAPTION_HELP_TEXT" as "BUILD.PUBLISH.LINKEDIN.CAPTION_HELP_TEXT",
                "LINKEDIN_PAGE": "BUILD.PUBLISH.LINKEDIN.LINKEDIN_PAGE" as "BUILD.PUBLISH.LINKEDIN.LINKEDIN_PAGE",
                "PUBLISH_TO_LINKEDIN": "BUILD.PUBLISH.LINKEDIN.PUBLISH_TO_LINKEDIN" as "BUILD.PUBLISH.LINKEDIN.PUBLISH_TO_LINKEDIN"
            },
            "LOCAL": {
                "PUBLISH_VIDEO_TO_LOCAL": "BUILD.PUBLISH.LOCAL.PUBLISH_VIDEO_TO_LOCAL" as "BUILD.PUBLISH.LOCAL.PUBLISH_VIDEO_TO_LOCAL"
            },
            "MAILCHIMP": {
                "CAMPAIGN_NAME": "BUILD.PUBLISH.MAILCHIMP.CAMPAIGN_NAME" as "BUILD.PUBLISH.MAILCHIMP.CAMPAIGN_NAME",
                "CONFIRMATION_EMAIL_ADDRESS": "BUILD.PUBLISH.MAILCHIMP.CONFIRMATION_EMAIL_ADDRESS" as "BUILD.PUBLISH.MAILCHIMP.CONFIRMATION_EMAIL_ADDRESS",
                "FROM_EMAIL": "BUILD.PUBLISH.MAILCHIMP.FROM_EMAIL" as "BUILD.PUBLISH.MAILCHIMP.FROM_EMAIL",
                "FROM_NAME": "BUILD.PUBLISH.MAILCHIMP.FROM_NAME" as "BUILD.PUBLISH.MAILCHIMP.FROM_NAME",
                "LISTS": "BUILD.PUBLISH.MAILCHIMP.LISTS" as "BUILD.PUBLISH.MAILCHIMP.LISTS",
                "NO_LISTS_FOUND_SET_UP_YOUR_MAILING_LISTS": "BUILD.PUBLISH.MAILCHIMP.NO_LISTS_FOUND_SET_UP_YOUR_MAILING_LISTS" as "BUILD.PUBLISH.MAILCHIMP.NO_LISTS_FOUND_SET_UP_YOUR_MAILING_LISTS",
                "NO_SEGMENTS_FOUND": "BUILD.PUBLISH.MAILCHIMP.NO_SEGMENTS_FOUND" as "BUILD.PUBLISH.MAILCHIMP.NO_SEGMENTS_FOUND",
                "PREVIEW": "BUILD.PUBLISH.MAILCHIMP.PREVIEW" as "BUILD.PUBLISH.MAILCHIMP.PREVIEW",
                "PREVIEW_SEND": "BUILD.PUBLISH.MAILCHIMP.PREVIEW_SEND" as "BUILD.PUBLISH.MAILCHIMP.PREVIEW_SEND",
                "PREVIEW_SKIP": "BUILD.PUBLISH.MAILCHIMP.PREVIEW_SKIP" as "BUILD.PUBLISH.MAILCHIMP.PREVIEW_SKIP",
                "PUBLISH_TO_MAILCHIMP": "BUILD.PUBLISH.MAILCHIMP.PUBLISH_TO_MAILCHIMP" as "BUILD.PUBLISH.MAILCHIMP.PUBLISH_TO_MAILCHIMP",
                "RECIPIENT": "BUILD.PUBLISH.MAILCHIMP.RECIPIENT" as "BUILD.PUBLISH.MAILCHIMP.RECIPIENT",
                "REPLY_TO": "BUILD.PUBLISH.MAILCHIMP.REPLY_TO" as "BUILD.PUBLISH.MAILCHIMP.REPLY_TO",
                "SAVE_DRAFT": "BUILD.PUBLISH.MAILCHIMP.SAVE_DRAFT" as "BUILD.PUBLISH.MAILCHIMP.SAVE_DRAFT",
                "SCHEDULING_UNAVAILABLE": "BUILD.PUBLISH.MAILCHIMP.SCHEDULING_UNAVAILABLE" as "BUILD.PUBLISH.MAILCHIMP.SCHEDULING_UNAVAILABLE",
                "SEGMENTS": "BUILD.PUBLISH.MAILCHIMP.SEGMENTS" as "BUILD.PUBLISH.MAILCHIMP.SEGMENTS",
                "SEND": "BUILD.PUBLISH.MAILCHIMP.SEND" as "BUILD.PUBLISH.MAILCHIMP.SEND",
                "SUBJECT": "BUILD.PUBLISH.MAILCHIMP.SUBJECT" as "BUILD.PUBLISH.MAILCHIMP.SUBJECT"
            },
            "MULTIPLE_LOCATIONS": {
                "CURRENTLY_PUBLISHING": "BUILD.PUBLISH.MULTIPLE_LOCATIONS.CURRENTLY_PUBLISHING" as "BUILD.PUBLISH.MULTIPLE_LOCATIONS.CURRENTLY_PUBLISHING",
                "EDIT_UNDO_ALERT_MESSAGE": {
                    "PART_1": "BUILD.PUBLISH.MULTIPLE_LOCATIONS.EDIT_UNDO_ALERT_MESSAGE.PART_1" as "BUILD.PUBLISH.MULTIPLE_LOCATIONS.EDIT_UNDO_ALERT_MESSAGE.PART_1",
                    "PART_2": "BUILD.PUBLISH.MULTIPLE_LOCATIONS.EDIT_UNDO_ALERT_MESSAGE.PART_2" as "BUILD.PUBLISH.MULTIPLE_LOCATIONS.EDIT_UNDO_ALERT_MESSAGE.PART_2",
                    "PART_3": "BUILD.PUBLISH.MULTIPLE_LOCATIONS.EDIT_UNDO_ALERT_MESSAGE.PART_3" as "BUILD.PUBLISH.MULTIPLE_LOCATIONS.EDIT_UNDO_ALERT_MESSAGE.PART_3"
                },
                "NO_ACCESS_HELP": "BUILD.PUBLISH.MULTIPLE_LOCATIONS.NO_ACCESS_HELP" as "BUILD.PUBLISH.MULTIPLE_LOCATIONS.NO_ACCESS_HELP",
                "PUBLISHED_VIDEOS_SUCCESSFULLY": "BUILD.PUBLISH.MULTIPLE_LOCATIONS.PUBLISHED_VIDEOS_SUCCESSFULLY" as "BUILD.PUBLISH.MULTIPLE_LOCATIONS.PUBLISHED_VIDEOS_SUCCESSFULLY",
                "PUBLISHING_TO_THESE_LOCATIONS": "BUILD.PUBLISH.MULTIPLE_LOCATIONS.PUBLISHING_TO_THESE_LOCATIONS" as "BUILD.PUBLISH.MULTIPLE_LOCATIONS.PUBLISHING_TO_THESE_LOCATIONS",
                "REFRESH_LOCATIONS": "BUILD.PUBLISH.MULTIPLE_LOCATIONS.REFRESH_LOCATIONS" as "BUILD.PUBLISH.MULTIPLE_LOCATIONS.REFRESH_LOCATIONS",
                "SCHEDULED_VIDEOS_SUCCESSFULLY": "BUILD.PUBLISH.MULTIPLE_LOCATIONS.SCHEDULED_VIDEOS_SUCCESSFULLY" as "BUILD.PUBLISH.MULTIPLE_LOCATIONS.SCHEDULED_VIDEOS_SUCCESSFULLY",
                "SOME_LOCATIONS_FAILED_TO_PUBLISH": "BUILD.PUBLISH.MULTIPLE_LOCATIONS.SOME_LOCATIONS_FAILED_TO_PUBLISH" as "BUILD.PUBLISH.MULTIPLE_LOCATIONS.SOME_LOCATIONS_FAILED_TO_PUBLISH",
                "TOTAL_PUBLISHING_PROGRESS": "BUILD.PUBLISH.MULTIPLE_LOCATIONS.TOTAL_PUBLISHING_PROGRESS" as "BUILD.PUBLISH.MULTIPLE_LOCATIONS.TOTAL_PUBLISHING_PROGRESS",
                "WOULD_YOU_LIKE_TO_RETRY_FOR_FAILED_LOCATIONS": "BUILD.PUBLISH.MULTIPLE_LOCATIONS.WOULD_YOU_LIKE_TO_RETRY_FOR_FAILED_LOCATIONS" as "BUILD.PUBLISH.MULTIPLE_LOCATIONS.WOULD_YOU_LIKE_TO_RETRY_FOR_FAILED_LOCATIONS"
            },
            "MULTIPLE_PLATFORMS": {
                "FACEBOOK_AND_INSTAGRAM_IMAGE": "BUILD.PUBLISH.MULTIPLE_PLATFORMS.FACEBOOK_AND_INSTAGRAM_IMAGE" as "BUILD.PUBLISH.MULTIPLE_PLATFORMS.FACEBOOK_AND_INSTAGRAM_IMAGE",
                "FACEBOOK_AND_INSTAGRAM_VIDEO": "BUILD.PUBLISH.MULTIPLE_PLATFORMS.FACEBOOK_AND_INSTAGRAM_VIDEO" as "BUILD.PUBLISH.MULTIPLE_PLATFORMS.FACEBOOK_AND_INSTAGRAM_VIDEO",
                "HASHTAGS_HELP_TEXT_CAPTION": "BUILD.PUBLISH.MULTIPLE_PLATFORMS.HASHTAGS_HELP_TEXT_CAPTION" as "BUILD.PUBLISH.MULTIPLE_PLATFORMS.HASHTAGS_HELP_TEXT_CAPTION",
                "HASHTAGS_HELP_TEXT_FIRST_COMMENT": "BUILD.PUBLISH.MULTIPLE_PLATFORMS.HASHTAGS_HELP_TEXT_FIRST_COMMENT" as "BUILD.PUBLISH.MULTIPLE_PLATFORMS.HASHTAGS_HELP_TEXT_FIRST_COMMENT",
                "HEADERS": {
                    "POST_DETAILS": "BUILD.PUBLISH.MULTIPLE_PLATFORMS.HEADERS.POST_DETAILS" as "BUILD.PUBLISH.MULTIPLE_PLATFORMS.HEADERS.POST_DETAILS",
                    "POST_SCHEDULE": "BUILD.PUBLISH.MULTIPLE_PLATFORMS.HEADERS.POST_SCHEDULE" as "BUILD.PUBLISH.MULTIPLE_PLATFORMS.HEADERS.POST_SCHEDULE"
                },
                "INPUT_LABELS": {
                    "DISPLAY_HASHTAGS_IN": "BUILD.PUBLISH.MULTIPLE_PLATFORMS.INPUT_LABELS.DISPLAY_HASHTAGS_IN" as "BUILD.PUBLISH.MULTIPLE_PLATFORMS.INPUT_LABELS.DISPLAY_HASHTAGS_IN",
                    "DISPLAY_HASHTAGS_IN_CAPTION": "BUILD.PUBLISH.MULTIPLE_PLATFORMS.INPUT_LABELS.DISPLAY_HASHTAGS_IN_CAPTION" as "BUILD.PUBLISH.MULTIPLE_PLATFORMS.INPUT_LABELS.DISPLAY_HASHTAGS_IN_CAPTION",
                    "DISPLAY_HASHTAGS_IN_FIRST_COMMENT": "BUILD.PUBLISH.MULTIPLE_PLATFORMS.INPUT_LABELS.DISPLAY_HASHTAGS_IN_FIRST_COMMENT" as "BUILD.PUBLISH.MULTIPLE_PLATFORMS.INPUT_LABELS.DISPLAY_HASHTAGS_IN_FIRST_COMMENT",
                    "HASHTAGS": "BUILD.PUBLISH.MULTIPLE_PLATFORMS.INPUT_LABELS.HASHTAGS" as "BUILD.PUBLISH.MULTIPLE_PLATFORMS.INPUT_LABELS.HASHTAGS"
                },
                "PUBLISHED_TO_PLATFORM": "BUILD.PUBLISH.MULTIPLE_PLATFORMS.PUBLISHED_TO_PLATFORM" as "BUILD.PUBLISH.MULTIPLE_PLATFORMS.PUBLISHED_TO_PLATFORM",
                "PUBLISHING_TO_PLATFORM": "BUILD.PUBLISH.MULTIPLE_PLATFORMS.PUBLISHING_TO_PLATFORM" as "BUILD.PUBLISH.MULTIPLE_PLATFORMS.PUBLISHING_TO_PLATFORM",
                "PUBLISH_IMAGE_TO_FACEBOOK_AND_INSTAGRAM": "BUILD.PUBLISH.MULTIPLE_PLATFORMS.PUBLISH_IMAGE_TO_FACEBOOK_AND_INSTAGRAM" as "BUILD.PUBLISH.MULTIPLE_PLATFORMS.PUBLISH_IMAGE_TO_FACEBOOK_AND_INSTAGRAM",
                "PUBLISH_VIDEO_TO_FACEBOOK_AND_INSTAGRAM": "BUILD.PUBLISH.MULTIPLE_PLATFORMS.PUBLISH_VIDEO_TO_FACEBOOK_AND_INSTAGRAM" as "BUILD.PUBLISH.MULTIPLE_PLATFORMS.PUBLISH_VIDEO_TO_FACEBOOK_AND_INSTAGRAM"
            },
            "NO_ACCESS_HELP": "BUILD.PUBLISH.NO_ACCESS_HELP" as "BUILD.PUBLISH.NO_ACCESS_HELP",
            "NO_PLATFORMS_AVAILABLE": "BUILD.PUBLISH.NO_PLATFORMS_AVAILABLE" as "BUILD.PUBLISH.NO_PLATFORMS_AVAILABLE",
            "NO_PLATFORM_SELECTED": "BUILD.PUBLISH.NO_PLATFORM_SELECTED" as "BUILD.PUBLISH.NO_PLATFORM_SELECTED",
            "NO_THANKS": "BUILD.PUBLISH.NO_THANKS" as "BUILD.PUBLISH.NO_THANKS",
            "NO_THANKS_IM_DONE": "BUILD.PUBLISH.NO_THANKS_IM_DONE" as "BUILD.PUBLISH.NO_THANKS_IM_DONE",
            "ONCE_AUTHORIZED_HELP": "BUILD.PUBLISH.ONCE_AUTHORIZED_HELP" as "BUILD.PUBLISH.ONCE_AUTHORIZED_HELP",
            "ORIGINAL_SIZE": "BUILD.PUBLISH.ORIGINAL_SIZE" as "BUILD.PUBLISH.ORIGINAL_SIZE",
            "PRINT": {
                "ARTWORK_REVIEW_SUGGESTED": "BUILD.PUBLISH.PRINT.ARTWORK_REVIEW_SUGGESTED" as "BUILD.PUBLISH.PRINT.ARTWORK_REVIEW_SUGGESTED",
                "BEGIN_PAYMENT": "BUILD.PUBLISH.PRINT.BEGIN_PAYMENT" as "BUILD.PUBLISH.PRINT.BEGIN_PAYMENT",
                "CAN_ONLY_SEND_TO_PRINT_PROVIDER": "BUILD.PUBLISH.PRINT.CAN_ONLY_SEND_TO_PRINT_PROVIDER" as "BUILD.PUBLISH.PRINT.CAN_ONLY_SEND_TO_PRINT_PROVIDER",
                "CONFIRM_ARTWORK_REVIEW": "BUILD.PUBLISH.PRINT.CONFIRM_ARTWORK_REVIEW" as "BUILD.PUBLISH.PRINT.CONFIRM_ARTWORK_REVIEW",
                "HOLD_UP": "BUILD.PUBLISH.PRINT.HOLD_UP" as "BUILD.PUBLISH.PRINT.HOLD_UP",
                "INCLUDES_FALLBACK_FONT_MESSAGE": "BUILD.PUBLISH.PRINT.INCLUDES_FALLBACK_FONT_MESSAGE" as "BUILD.PUBLISH.PRINT.INCLUDES_FALLBACK_FONT_MESSAGE",
                "INCLUDES_FALLBACK_FONT_MESSAGE_SOLUTION": "BUILD.PUBLISH.PRINT.INCLUDES_FALLBACK_FONT_MESSAGE_SOLUTION" as "BUILD.PUBLISH.PRINT.INCLUDES_FALLBACK_FONT_MESSAGE_SOLUTION",
                "INSTRUCTIONS_PLACEHOLDER": "BUILD.PUBLISH.PRINT.INSTRUCTIONS_PLACEHOLDER" as "BUILD.PUBLISH.PRINT.INSTRUCTIONS_PLACEHOLDER",
                "INSTRUCTIONS_PLACEHOLDER_FOR_SKU": "BUILD.PUBLISH.PRINT.INSTRUCTIONS_PLACEHOLDER_FOR_SKU" as "BUILD.PUBLISH.PRINT.INSTRUCTIONS_PLACEHOLDER_FOR_SKU",
                "PAYMENT": "BUILD.PUBLISH.PRINT.PAYMENT" as "BUILD.PUBLISH.PRINT.PAYMENT",
                "PAYMENT_DUE": "BUILD.PUBLISH.PRINT.PAYMENT_DUE" as "BUILD.PUBLISH.PRINT.PAYMENT_DUE",
                "PRINT_PROVIDER": "BUILD.PUBLISH.PRINT.PRINT_PROVIDER" as "BUILD.PUBLISH.PRINT.PRINT_PROVIDER",
                "PRINT_REQUEST_DETAILS": "BUILD.PUBLISH.PRINT.PRINT_REQUEST_DETAILS" as "BUILD.PUBLISH.PRINT.PRINT_REQUEST_DETAILS",
                "REPLY_EMAIL": "BUILD.PUBLISH.PRINT.REPLY_EMAIL" as "BUILD.PUBLISH.PRINT.REPLY_EMAIL",
                "REPLY_EMAIL_SUBHEADING": "BUILD.PUBLISH.PRINT.REPLY_EMAIL_SUBHEADING" as "BUILD.PUBLISH.PRINT.REPLY_EMAIL_SUBHEADING",
                "REQUEST_DETAILS_IS_MISSING_DATA": "BUILD.PUBLISH.PRINT.REQUEST_DETAILS_IS_MISSING_DATA" as "BUILD.PUBLISH.PRINT.REQUEST_DETAILS_IS_MISSING_DATA",
                "REVIEW_ARTWORK_BEFORE_SENDING": "BUILD.PUBLISH.PRINT.REVIEW_ARTWORK_BEFORE_SENDING" as "BUILD.PUBLISH.PRINT.REVIEW_ARTWORK_BEFORE_SENDING",
                "REVIEW_CONFIRMATION": "BUILD.PUBLISH.PRINT.REVIEW_CONFIRMATION" as "BUILD.PUBLISH.PRINT.REVIEW_CONFIRMATION",
                "REVIEW_DOCUMENT": "BUILD.PUBLISH.PRINT.REVIEW_DOCUMENT" as "BUILD.PUBLISH.PRINT.REVIEW_DOCUMENT",
                "SAVE_AS_LOCATION_PRINT_PROVIDER": "BUILD.PUBLISH.PRINT.SAVE_AS_LOCATION_PRINT_PROVIDER" as "BUILD.PUBLISH.PRINT.SAVE_AS_LOCATION_PRINT_PROVIDER",
                "SELECT_PRINT_PROVIDER": "BUILD.PUBLISH.PRINT.SELECT_PRINT_PROVIDER" as "BUILD.PUBLISH.PRINT.SELECT_PRINT_PROVIDER",
                "SENDING_ARTWORK": "BUILD.PUBLISH.PRINT.SENDING_ARTWORK" as "BUILD.PUBLISH.PRINT.SENDING_ARTWORK",
                "SEND_AND_COMPLETE_PAYMENT": "BUILD.PUBLISH.PRINT.SEND_AND_COMPLETE_PAYMENT" as "BUILD.PUBLISH.PRINT.SEND_AND_COMPLETE_PAYMENT",
                "SEND_ORDER": "BUILD.PUBLISH.PRINT.SEND_ORDER" as "BUILD.PUBLISH.PRINT.SEND_ORDER",
                "SEND_TO_PRINT_PROVIDER": "BUILD.PUBLISH.PRINT.SEND_TO_PRINT_PROVIDER" as "BUILD.PUBLISH.PRINT.SEND_TO_PRINT_PROVIDER",
                "SUCCESSFULLY_SENT": "BUILD.PUBLISH.PRINT.SUCCESSFULLY_SENT" as "BUILD.PUBLISH.PRINT.SUCCESSFULLY_SENT",
                "YOUR_PRINT_PROVIDER": "BUILD.PUBLISH.PRINT.YOUR_PRINT_PROVIDER" as "BUILD.PUBLISH.PRINT.YOUR_PRINT_PROVIDER"
            },
            "PUBLISH": "BUILD.PUBLISH.PUBLISH" as "BUILD.PUBLISH.PUBLISH",
            "PUBLISHED": "BUILD.PUBLISH.PUBLISHED" as "BUILD.PUBLISH.PUBLISHED",
            "PUBLISHED_SUCCESSFULLY": "BUILD.PUBLISH.PUBLISHED_SUCCESSFULLY" as "BUILD.PUBLISH.PUBLISHED_SUCCESSFULLY",
            "PUBLISHED_TO_SOME_LOCATIONS": "BUILD.PUBLISH.PUBLISHED_TO_SOME_LOCATIONS" as "BUILD.PUBLISH.PUBLISHED_TO_SOME_LOCATIONS",
            "PUBLISHING_FAILED": "BUILD.PUBLISH.PUBLISHING_FAILED" as "BUILD.PUBLISH.PUBLISHING_FAILED",
            "PUBLISH_IMMEDIATELY": "BUILD.PUBLISH.PUBLISH_IMMEDIATELY" as "BUILD.PUBLISH.PUBLISH_IMMEDIATELY",
            "PUBLISH_VIDEO_ACTION": "BUILD.PUBLISH.PUBLISH_VIDEO_ACTION" as "BUILD.PUBLISH.PUBLISH_VIDEO_ACTION",
            "REFRESH_PLATFORMS": "BUILD.PUBLISH.REFRESH_PLATFORMS" as "BUILD.PUBLISH.REFRESH_PLATFORMS",
            "RELATIVE_TO_LOCATION": "BUILD.PUBLISH.RELATIVE_TO_LOCATION" as "BUILD.PUBLISH.RELATIVE_TO_LOCATION",
            "RESCHEDULE": {
                "NEW_TIME": "BUILD.PUBLISH.RESCHEDULE.NEW_TIME" as "BUILD.PUBLISH.RESCHEDULE.NEW_TIME",
                "RESCHEDULE_ITEM": "BUILD.PUBLISH.RESCHEDULE.RESCHEDULE_ITEM" as "BUILD.PUBLISH.RESCHEDULE.RESCHEDULE_ITEM"
            },
            "SAVED_SUCCESSFULLY": "BUILD.PUBLISH.SAVED_SUCCESSFULLY" as "BUILD.PUBLISH.SAVED_SUCCESSFULLY",
            "SCHEDULED_POST_MUST_BE_AT_LEAST_10_MINS_IN_FUTURE": "BUILD.PUBLISH.SCHEDULED_POST_MUST_BE_AT_LEAST_10_MINS_IN_FUTURE" as "BUILD.PUBLISH.SCHEDULED_POST_MUST_BE_AT_LEAST_10_MINS_IN_FUTURE",
            "SCHEDULED_POST_TIME_PICKER_WARNING": "BUILD.PUBLISH.SCHEDULED_POST_TIME_PICKER_WARNING" as "BUILD.PUBLISH.SCHEDULED_POST_TIME_PICKER_WARNING",
            "SCHEDULED_SUCCESSFULLY": "BUILD.PUBLISH.SCHEDULED_SUCCESSFULLY" as "BUILD.PUBLISH.SCHEDULED_SUCCESSFULLY",
            "SCHEDULE_FOR_LATER": "BUILD.PUBLISH.SCHEDULE_FOR_LATER" as "BUILD.PUBLISH.SCHEDULE_FOR_LATER",
            "SEND_IMMEDIATELY": "BUILD.PUBLISH.SEND_IMMEDIATELY" as "BUILD.PUBLISH.SEND_IMMEDIATELY",
            "TERMS_AND_CONDITIONS_HELP_TEXT": "BUILD.PUBLISH.TERMS_AND_CONDITIONS_HELP_TEXT" as "BUILD.PUBLISH.TERMS_AND_CONDITIONS_HELP_TEXT",
            "TWITTER": {
                "ACCESS_CHECK_FAILURE": "BUILD.PUBLISH.TWITTER.ACCESS_CHECK_FAILURE" as "BUILD.PUBLISH.TWITTER.ACCESS_CHECK_FAILURE",
                "CANNOT_PUBLISH_MULTI_IMAGE_HELP_TEXT": "BUILD.PUBLISH.TWITTER.CANNOT_PUBLISH_MULTI_IMAGE_HELP_TEXT" as "BUILD.PUBLISH.TWITTER.CANNOT_PUBLISH_MULTI_IMAGE_HELP_TEXT",
                "CANNOT_STOP_SCHEDULED_POST": "BUILD.PUBLISH.TWITTER.CANNOT_STOP_SCHEDULED_POST" as "BUILD.PUBLISH.TWITTER.CANNOT_STOP_SCHEDULED_POST",
                "PUBLISH_TO_TWITTER": "BUILD.PUBLISH.TWITTER.PUBLISH_TO_TWITTER" as "BUILD.PUBLISH.TWITTER.PUBLISH_TO_TWITTER",
                "TWEET": "BUILD.PUBLISH.TWITTER.TWEET" as "BUILD.PUBLISH.TWITTER.TWEET"
            },
            "UPLOADING": "BUILD.PUBLISH.UPLOADING" as "BUILD.PUBLISH.UPLOADING",
            "WILL_RECEIVE_NOTIFICATION": "BUILD.PUBLISH.WILL_RECEIVE_NOTIFICATION" as "BUILD.PUBLISH.WILL_RECEIVE_NOTIFICATION",
            "WILL_RECEIVE_SCHEDULED_NOTIFICATION": "BUILD.PUBLISH.WILL_RECEIVE_SCHEDULED_NOTIFICATION" as "BUILD.PUBLISH.WILL_RECEIVE_SCHEDULED_NOTIFICATION",
            "WILL_RECIEVE_SMS_DETAILS": "BUILD.PUBLISH.WILL_RECIEVE_SMS_DETAILS" as "BUILD.PUBLISH.WILL_RECIEVE_SMS_DETAILS",
            "WILL_RECIEVE_SMS_REMINDER": "BUILD.PUBLISH.WILL_RECIEVE_SMS_REMINDER" as "BUILD.PUBLISH.WILL_RECIEVE_SMS_REMINDER",
            "WOULD_YOU_LIKE_TO_SCHEDULE_POST_ON_ANOTHER_PLATFORM": "BUILD.PUBLISH.WOULD_YOU_LIKE_TO_SCHEDULE_POST_ON_ANOTHER_PLATFORM" as "BUILD.PUBLISH.WOULD_YOU_LIKE_TO_SCHEDULE_POST_ON_ANOTHER_PLATFORM",
            "WOULD_YOU_LIKE_TO_SCHEDULE_THIS_POST_AGAIN": "BUILD.PUBLISH.WOULD_YOU_LIKE_TO_SCHEDULE_THIS_POST_AGAIN" as "BUILD.PUBLISH.WOULD_YOU_LIKE_TO_SCHEDULE_THIS_POST_AGAIN",
            "YES_PLEASE": "BUILD.PUBLISH.YES_PLEASE" as "BUILD.PUBLISH.YES_PLEASE",
            "YES_PLEASE_BUT_DIFFERENT_TEMPLATE": "BUILD.PUBLISH.YES_PLEASE_BUT_DIFFERENT_TEMPLATE" as "BUILD.PUBLISH.YES_PLEASE_BUT_DIFFERENT_TEMPLATE",
            "YES_PLEASE_BUT_LATER": "BUILD.PUBLISH.YES_PLEASE_BUT_LATER" as "BUILD.PUBLISH.YES_PLEASE_BUT_LATER"
        },
        "PUBLISHING_FAILED": "BUILD.PUBLISHING_FAILED" as "BUILD.PUBLISHING_FAILED",
        "PUBLISH_TO_MULTIPLE_LOCATIONS": "BUILD.PUBLISH_TO_MULTIPLE_LOCATIONS" as "BUILD.PUBLISH_TO_MULTIPLE_LOCATIONS",
        "RECENTLY_ADDED": "BUILD.RECENTLY_ADDED" as "BUILD.RECENTLY_ADDED",
        "RECTANGLE": "BUILD.RECTANGLE" as "BUILD.RECTANGLE",
        "REPETITIONS": "BUILD.REPETITIONS" as "BUILD.REPETITIONS",
        "REQUEST_SUPPORT": "BUILD.REQUEST_SUPPORT" as "BUILD.REQUEST_SUPPORT",
        "RESOURCES_LOADED": "BUILD.RESOURCES_LOADED" as "BUILD.RESOURCES_LOADED",
        "RESOURCES_LOADED_plural": "BUILD.RESOURCES_LOADED_plural" as "BUILD.RESOURCES_LOADED_plural",
        "RETURN_TO_BUILDER": "BUILD.RETURN_TO_BUILDER" as "BUILD.RETURN_TO_BUILDER",
        "SAVING_TEMPLATE": "BUILD.SAVING_TEMPLATE" as "BUILD.SAVING_TEMPLATE",
        "SCHEDULED_TIME": "BUILD.SCHEDULED_TIME" as "BUILD.SCHEDULED_TIME",
        "SELECT_PREVIEW_IMAGE": "BUILD.SELECT_PREVIEW_IMAGE" as "BUILD.SELECT_PREVIEW_IMAGE",
        "SEPARATE_TAGS_WITH_SPACES": "BUILD.SEPARATE_TAGS_WITH_SPACES" as "BUILD.SEPARATE_TAGS_WITH_SPACES",
        "SHOW_DETAILS": "BUILD.SHOW_DETAILS" as "BUILD.SHOW_DETAILS",
        "SHOW_OLD_EMAIL_TEMPLATES": "BUILD.SHOW_OLD_EMAIL_TEMPLATES" as "BUILD.SHOW_OLD_EMAIL_TEMPLATES",
        "SUMMARY_HIDDEN_MESSAGE": "BUILD.SUMMARY_HIDDEN_MESSAGE" as "BUILD.SUMMARY_HIDDEN_MESSAGE",
        "TEMPLATE": "BUILD.TEMPLATE" as "BUILD.TEMPLATE",
        "TEMPLATE_ADMIN": {
            "COPY_AS_UNPUBLISHED": "BUILD.TEMPLATE_ADMIN.COPY_AS_UNPUBLISHED" as "BUILD.TEMPLATE_ADMIN.COPY_AS_UNPUBLISHED",
            "COPY_AS_UNPUBLISHED_TOOLTIP": "BUILD.TEMPLATE_ADMIN.COPY_AS_UNPUBLISHED_TOOLTIP" as "BUILD.TEMPLATE_ADMIN.COPY_AS_UNPUBLISHED_TOOLTIP",
            "COPY_ERROR": "BUILD.TEMPLATE_ADMIN.COPY_ERROR" as "BUILD.TEMPLATE_ADMIN.COPY_ERROR",
            "COPY_NO_CLIENTS": "BUILD.TEMPLATE_ADMIN.COPY_NO_CLIENTS" as "BUILD.TEMPLATE_ADMIN.COPY_NO_CLIENTS",
            "COPY_SUCCESS": "BUILD.TEMPLATE_ADMIN.COPY_SUCCESS" as "BUILD.TEMPLATE_ADMIN.COPY_SUCCESS",
            "COPY_SUCCESS_EXTENDED": "BUILD.TEMPLATE_ADMIN.COPY_SUCCESS_EXTENDED" as "BUILD.TEMPLATE_ADMIN.COPY_SUCCESS_EXTENDED",
            "COPY_TO": "BUILD.TEMPLATE_ADMIN.COPY_TO" as "BUILD.TEMPLATE_ADMIN.COPY_TO",
            "DELETE_TEMPLATE": "BUILD.TEMPLATE_ADMIN.DELETE_TEMPLATE" as "BUILD.TEMPLATE_ADMIN.DELETE_TEMPLATE",
            "DELETE_TEMPLATE_SUCCESS": "BUILD.TEMPLATE_ADMIN.DELETE_TEMPLATE_SUCCESS" as "BUILD.TEMPLATE_ADMIN.DELETE_TEMPLATE_SUCCESS",
            "DUPLICATE_TEMPLATE": "BUILD.TEMPLATE_ADMIN.DUPLICATE_TEMPLATE" as "BUILD.TEMPLATE_ADMIN.DUPLICATE_TEMPLATE",
            "DUPLICATE_TEMPLATE_SUCCESS": "BUILD.TEMPLATE_ADMIN.DUPLICATE_TEMPLATE_SUCCESS" as "BUILD.TEMPLATE_ADMIN.DUPLICATE_TEMPLATE_SUCCESS",
            "EDIT_ATTRIBUTES": "BUILD.TEMPLATE_ADMIN.EDIT_ATTRIBUTES" as "BUILD.TEMPLATE_ADMIN.EDIT_ATTRIBUTES",
            "INCLUDE_ASSIGNED_CATEGORIES": "BUILD.TEMPLATE_ADMIN.INCLUDE_ASSIGNED_CATEGORIES" as "BUILD.TEMPLATE_ADMIN.INCLUDE_ASSIGNED_CATEGORIES",
            "INCLUDE_ASSIGNED_CATEGORIES_TOOLTIP": "BUILD.TEMPLATE_ADMIN.INCLUDE_ASSIGNED_CATEGORIES_TOOLTIP" as "BUILD.TEMPLATE_ADMIN.INCLUDE_ASSIGNED_CATEGORIES_TOOLTIP",
            "MANAGE_BUILDABLE_TEMPLATE": "BUILD.TEMPLATE_ADMIN.MANAGE_BUILDABLE_TEMPLATE" as "BUILD.TEMPLATE_ADMIN.MANAGE_BUILDABLE_TEMPLATE",
            "TEMPLATE_UPDATED": "BUILD.TEMPLATE_ADMIN.TEMPLATE_UPDATED" as "BUILD.TEMPLATE_ADMIN.TEMPLATE_UPDATED",
            "TOGGLE_TEMPLATE_STATUS_PUBLISHED": "BUILD.TEMPLATE_ADMIN.TOGGLE_TEMPLATE_STATUS_PUBLISHED" as "BUILD.TEMPLATE_ADMIN.TOGGLE_TEMPLATE_STATUS_PUBLISHED",
            "TOGGLE_TEMPLATE_STATUS_PUBLISHED_SUCCESS": "BUILD.TEMPLATE_ADMIN.TOGGLE_TEMPLATE_STATUS_PUBLISHED_SUCCESS" as "BUILD.TEMPLATE_ADMIN.TOGGLE_TEMPLATE_STATUS_PUBLISHED_SUCCESS",
            "TOGGLE_TEMPLATE_STATUS_UNPUBLISHED": "BUILD.TEMPLATE_ADMIN.TOGGLE_TEMPLATE_STATUS_UNPUBLISHED" as "BUILD.TEMPLATE_ADMIN.TOGGLE_TEMPLATE_STATUS_UNPUBLISHED",
            "TOGGLE_TEMPLATE_STATUS_UNPUBLISHED_SUCCESS": "BUILD.TEMPLATE_ADMIN.TOGGLE_TEMPLATE_STATUS_UNPUBLISHED_SUCCESS" as "BUILD.TEMPLATE_ADMIN.TOGGLE_TEMPLATE_STATUS_UNPUBLISHED_SUCCESS"
        },
        "TEMPLATE_COULD_NOT_BE_EXPORTED_UNDER_THE_FILE_SIZE_LIMIT": "BUILD.TEMPLATE_COULD_NOT_BE_EXPORTED_UNDER_THE_FILE_SIZE_LIMIT" as "BUILD.TEMPLATE_COULD_NOT_BE_EXPORTED_UNDER_THE_FILE_SIZE_LIMIT",
        "TEMPLATE_DELETED": "BUILD.TEMPLATE_DELETED" as "BUILD.TEMPLATE_DELETED",
        "TEMPLATE_GALLERY": "BUILD.TEMPLATE_GALLERY" as "BUILD.TEMPLATE_GALLERY",
        "TEMPLATE_NOT_FOUND_OR_UNAUTHORIZED": "BUILD.TEMPLATE_NOT_FOUND_OR_UNAUTHORIZED" as "BUILD.TEMPLATE_NOT_FOUND_OR_UNAUTHORIZED",
        "TEMPLATE_SAVED": "BUILD.TEMPLATE_SAVED" as "BUILD.TEMPLATE_SAVED",
        "TEXT_ALIGNMENT_HORIZONTAL": {
            "CENTER": "BUILD.TEXT_ALIGNMENT_HORIZONTAL.CENTER" as "BUILD.TEXT_ALIGNMENT_HORIZONTAL.CENTER",
            "JUSTIFY": "BUILD.TEXT_ALIGNMENT_HORIZONTAL.JUSTIFY" as "BUILD.TEXT_ALIGNMENT_HORIZONTAL.JUSTIFY",
            "LEFT": "BUILD.TEXT_ALIGNMENT_HORIZONTAL.LEFT" as "BUILD.TEXT_ALIGNMENT_HORIZONTAL.LEFT",
            "RIGHT": "BUILD.TEXT_ALIGNMENT_HORIZONTAL.RIGHT" as "BUILD.TEXT_ALIGNMENT_HORIZONTAL.RIGHT"
        },
        "TEXT_ALIGNMENT_VERTICAL": {
            "BOTTOM": "BUILD.TEXT_ALIGNMENT_VERTICAL.BOTTOM" as "BUILD.TEXT_ALIGNMENT_VERTICAL.BOTTOM",
            "CENTER": "BUILD.TEXT_ALIGNMENT_VERTICAL.CENTER" as "BUILD.TEXT_ALIGNMENT_VERTICAL.CENTER",
            "TOP": "BUILD.TEXT_ALIGNMENT_VERTICAL.TOP" as "BUILD.TEXT_ALIGNMENT_VERTICAL.TOP"
        },
        "TEXT_CLIPPING": "BUILD.TEXT_CLIPPING" as "BUILD.TEXT_CLIPPING",
        "TEXT_FORMATTING_WORKAROUND": "BUILD.TEXT_FORMATTING_WORKAROUND" as "BUILD.TEXT_FORMATTING_WORKAROUND",
        "TEXT_LINE_HEIGHT_FIX": "BUILD.TEXT_LINE_HEIGHT_FIX" as "BUILD.TEXT_LINE_HEIGHT_FIX",
        "TEXT_MUST_BE_EDITABLE": "BUILD.TEXT_MUST_BE_EDITABLE" as "BUILD.TEXT_MUST_BE_EDITABLE",
        "TIME_UNITS_AGO": {
            "DAY_AGO": "BUILD.TIME_UNITS_AGO.DAY_AGO" as "BUILD.TIME_UNITS_AGO.DAY_AGO",
            "DAY_AGO_plural": "BUILD.TIME_UNITS_AGO.DAY_AGO_plural" as "BUILD.TIME_UNITS_AGO.DAY_AGO_plural",
            "HOUR_AGO": "BUILD.TIME_UNITS_AGO.HOUR_AGO" as "BUILD.TIME_UNITS_AGO.HOUR_AGO",
            "HOUR_AGO_plural": "BUILD.TIME_UNITS_AGO.HOUR_AGO_plural" as "BUILD.TIME_UNITS_AGO.HOUR_AGO_plural",
            "MINUTE_AGO": "BUILD.TIME_UNITS_AGO.MINUTE_AGO" as "BUILD.TIME_UNITS_AGO.MINUTE_AGO",
            "MINUTE_AGO_plural": "BUILD.TIME_UNITS_AGO.MINUTE_AGO_plural" as "BUILD.TIME_UNITS_AGO.MINUTE_AGO_plural",
            "MONTH_AGO": "BUILD.TIME_UNITS_AGO.MONTH_AGO" as "BUILD.TIME_UNITS_AGO.MONTH_AGO",
            "MONTH_AGO_plural": "BUILD.TIME_UNITS_AGO.MONTH_AGO_plural" as "BUILD.TIME_UNITS_AGO.MONTH_AGO_plural",
            "SECOND_AGO": "BUILD.TIME_UNITS_AGO.SECOND_AGO" as "BUILD.TIME_UNITS_AGO.SECOND_AGO",
            "SECOND_AGO_plural": "BUILD.TIME_UNITS_AGO.SECOND_AGO_plural" as "BUILD.TIME_UNITS_AGO.SECOND_AGO_plural",
            "WEEK_AGO": "BUILD.TIME_UNITS_AGO.WEEK_AGO" as "BUILD.TIME_UNITS_AGO.WEEK_AGO",
            "WEEK_AGO_plural": "BUILD.TIME_UNITS_AGO.WEEK_AGO_plural" as "BUILD.TIME_UNITS_AGO.WEEK_AGO_plural",
            "YEAR_AGO": "BUILD.TIME_UNITS_AGO.YEAR_AGO" as "BUILD.TIME_UNITS_AGO.YEAR_AGO",
            "YEAR_AGO_plural": "BUILD.TIME_UNITS_AGO.YEAR_AGO_plural" as "BUILD.TIME_UNITS_AGO.YEAR_AGO_plural"
        },
        "TOGGLE_UNPUBLISHED": "BUILD.TOGGLE_UNPUBLISHED" as "BUILD.TOGGLE_UNPUBLISHED",
        "TRANSFORM": "BUILD.TRANSFORM" as "BUILD.TRANSFORM",
        "UNPUBLISHED_INFO": "BUILD.UNPUBLISHED_INFO" as "BUILD.UNPUBLISHED_INFO",
        "UNPUBLISHED_TEMPLATE": "BUILD.UNPUBLISHED_TEMPLATE" as "BUILD.UNPUBLISHED_TEMPLATE",
        "UNPUBLISHED_TEMPLATE_PUBLISH_WARNING": "BUILD.UNPUBLISHED_TEMPLATE_PUBLISH_WARNING" as "BUILD.UNPUBLISHED_TEMPLATE_PUBLISH_WARNING",
        "UPDATE_TEMPLATE": "BUILD.UPDATE_TEMPLATE" as "BUILD.UPDATE_TEMPLATE",
        "UPPERCASE": "BUILD.UPPERCASE" as "BUILD.UPPERCASE",
        "VIDEO": {
            "CHECKING_ACCESS": "BUILD.VIDEO.CHECKING_ACCESS" as "BUILD.VIDEO.CHECKING_ACCESS",
            "DOWNLOAD_VIDEO": "BUILD.VIDEO.DOWNLOAD_VIDEO" as "BUILD.VIDEO.DOWNLOAD_VIDEO",
            "FAILED_TO_PUBLISH_VIDEO": "BUILD.VIDEO.FAILED_TO_PUBLISH_VIDEO" as "BUILD.VIDEO.FAILED_TO_PUBLISH_VIDEO",
            "FINALIZING_VIDEO": "BUILD.VIDEO.FINALIZING_VIDEO" as "BUILD.VIDEO.FINALIZING_VIDEO",
            "NETWORK_ERROR": "BUILD.VIDEO.NETWORK_ERROR" as "BUILD.VIDEO.NETWORK_ERROR",
            "NO_VIDEO_LAYERS": "BUILD.VIDEO.NO_VIDEO_LAYERS" as "BUILD.VIDEO.NO_VIDEO_LAYERS",
            "NO_VIDEO_UPLOADED": "BUILD.VIDEO.NO_VIDEO_UPLOADED" as "BUILD.VIDEO.NO_VIDEO_UPLOADED",
            "PLEASE_WAIT": "BUILD.VIDEO.PLEASE_WAIT" as "BUILD.VIDEO.PLEASE_WAIT",
            "PREPARING_VIDEO": "BUILD.VIDEO.PREPARING_VIDEO" as "BUILD.VIDEO.PREPARING_VIDEO",
            "PROCESSING_TIME_DISCLAIMER": "BUILD.VIDEO.PROCESSING_TIME_DISCLAIMER" as "BUILD.VIDEO.PROCESSING_TIME_DISCLAIMER",
            "PROCESSING_VIDEO": "BUILD.VIDEO.PROCESSING_VIDEO" as "BUILD.VIDEO.PROCESSING_VIDEO",
            "PUBLISHING_FAILED_MESSAGE": "BUILD.VIDEO.PUBLISHING_FAILED_MESSAGE" as "BUILD.VIDEO.PUBLISHING_FAILED_MESSAGE",
            "READY_TO_DOWNLOAD": "BUILD.VIDEO.READY_TO_DOWNLOAD" as "BUILD.VIDEO.READY_TO_DOWNLOAD",
            "REMOVE_AUDIO": "BUILD.VIDEO.REMOVE_AUDIO" as "BUILD.VIDEO.REMOVE_AUDIO",
            "RENDERING_VIDEO": "BUILD.VIDEO.RENDERING_VIDEO" as "BUILD.VIDEO.RENDERING_VIDEO",
            "RETY_WITHOUT_AUDIO": "BUILD.VIDEO.RETY_WITHOUT_AUDIO" as "BUILD.VIDEO.RETY_WITHOUT_AUDIO",
            "UNSUPPORTED_FORMAT": "BUILD.VIDEO.UNSUPPORTED_FORMAT" as "BUILD.VIDEO.UNSUPPORTED_FORMAT",
            "UPLOADING": "BUILD.VIDEO.UPLOADING" as "BUILD.VIDEO.UPLOADING",
            "VIDEO_IS_READY": "BUILD.VIDEO.VIDEO_IS_READY" as "BUILD.VIDEO.VIDEO_IS_READY",
            "VIDEO_IS_READY_TO_DOWNLOAD": "BUILD.VIDEO.VIDEO_IS_READY_TO_DOWNLOAD" as "BUILD.VIDEO.VIDEO_IS_READY_TO_DOWNLOAD"
        },
        "VIDEO_CHOOSER": {
            "CONFIRM_ACKNOWLEDGED": "BUILD.VIDEO_CHOOSER.CONFIRM_ACKNOWLEDGED" as "BUILD.VIDEO_CHOOSER.CONFIRM_ACKNOWLEDGED",
            "CONFIRM_PERMISSION": "BUILD.VIDEO_CHOOSER.CONFIRM_PERMISSION" as "BUILD.VIDEO_CHOOSER.CONFIRM_PERMISSION",
            "LOCAL_FILE": "BUILD.VIDEO_CHOOSER.LOCAL_FILE" as "BUILD.VIDEO_CHOOSER.LOCAL_FILE",
            "MAX_UPLOAD_ERROR": "BUILD.VIDEO_CHOOSER.MAX_UPLOAD_ERROR" as "BUILD.VIDEO_CHOOSER.MAX_UPLOAD_ERROR",
            "PERMISSION_DISCLAIMER": "BUILD.VIDEO_CHOOSER.PERMISSION_DISCLAIMER" as "BUILD.VIDEO_CHOOSER.PERMISSION_DISCLAIMER",
            "PERMISSION_DISCLAIMER_STRONG": "BUILD.VIDEO_CHOOSER.PERMISSION_DISCLAIMER_STRONG" as "BUILD.VIDEO_CHOOSER.PERMISSION_DISCLAIMER_STRONG",
            "PERMISSION_ERROR": "BUILD.VIDEO_CHOOSER.PERMISSION_ERROR" as "BUILD.VIDEO_CHOOSER.PERMISSION_ERROR",
            "SELECT_VIDEO": "BUILD.VIDEO_CHOOSER.SELECT_VIDEO" as "BUILD.VIDEO_CHOOSER.SELECT_VIDEO",
            "SELECT_VIDEO_FROM_YOUR_LIBRARY": "BUILD.VIDEO_CHOOSER.SELECT_VIDEO_FROM_YOUR_LIBRARY" as "BUILD.VIDEO_CHOOSER.SELECT_VIDEO_FROM_YOUR_LIBRARY",
            "SUGGESTED_COLLECTION": "BUILD.VIDEO_CHOOSER.SUGGESTED_COLLECTION" as "BUILD.VIDEO_CHOOSER.SUGGESTED_COLLECTION",
            "UPLOADED_ASSET_VIDEO": "BUILD.VIDEO_CHOOSER.UPLOADED_ASSET_VIDEO" as "BUILD.VIDEO_CHOOSER.UPLOADED_ASSET_VIDEO",
            "UPLOADED_PLANNER_VIDEO": "BUILD.VIDEO_CHOOSER.UPLOADED_PLANNER_VIDEO" as "BUILD.VIDEO_CHOOSER.UPLOADED_PLANNER_VIDEO",
            "UPLOAD_VIDEO_FROM_YOUR_DEVICE": "BUILD.VIDEO_CHOOSER.UPLOAD_VIDEO_FROM_YOUR_DEVICE" as "BUILD.VIDEO_CHOOSER.UPLOAD_VIDEO_FROM_YOUR_DEVICE",
            "VIDEO_SOURCE": "BUILD.VIDEO_CHOOSER.VIDEO_SOURCE" as "BUILD.VIDEO_CHOOSER.VIDEO_SOURCE"
        },
        "WEBSITE_URL_NOT_SET": "BUILD.WEBSITE_URL_NOT_SET" as "BUILD.WEBSITE_URL_NOT_SET",
        "YOU_ARE_CURRENTLY_BUILDING": "BUILD.YOU_ARE_CURRENTLY_BUILDING" as "BUILD.YOU_ARE_CURRENTLY_BUILDING",
        "YOU_HAVE_N_ITEMS_TO_BUILD_AND_SCHEDULE": "BUILD.YOU_HAVE_N_ITEMS_TO_BUILD_AND_SCHEDULE" as "BUILD.YOU_HAVE_N_ITEMS_TO_BUILD_AND_SCHEDULE",
        "YOU_HAVE_N_ITEMS_TO_BUILD_AND_SCHEDULE_plural": "BUILD.YOU_HAVE_N_ITEMS_TO_BUILD_AND_SCHEDULE_plural" as "BUILD.YOU_HAVE_N_ITEMS_TO_BUILD_AND_SCHEDULE_plural",
        "YOU_HAVE_N_ITEMS_TO_CHECKOUT": "BUILD.YOU_HAVE_N_ITEMS_TO_CHECKOUT" as "BUILD.YOU_HAVE_N_ITEMS_TO_CHECKOUT",
        "YOU_HAVE_N_ITEMS_TO_CHECKOUT_plural": "BUILD.YOU_HAVE_N_ITEMS_TO_CHECKOUT_plural" as "BUILD.YOU_HAVE_N_ITEMS_TO_CHECKOUT_plural"
    },
    "CLIENT": {
        "CLIENT_LOCATION_ENGAGEMENT_TABLE": {
            "HEADERS": {
                "BUILT_ITEMS": "CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.HEADERS.BUILT_ITEMS" as "CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.HEADERS.BUILT_ITEMS",
                "FACEBOOK_ADS": "CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.HEADERS.FACEBOOK_ADS" as "CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.HEADERS.FACEBOOK_ADS",
                "GOOGLE_ADS": "CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.HEADERS.GOOGLE_ADS" as "CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.HEADERS.GOOGLE_ADS",
                "GROUPS": "CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.HEADERS.GROUPS" as "CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.HEADERS.GROUPS",
                "LEADS": "CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.HEADERS.LEADS" as "CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.HEADERS.LEADS",
                "LOCATION": "CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.HEADERS.LOCATION" as "CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.HEADERS.LOCATION",
                "REGION": "CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.HEADERS.REGION" as "CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.HEADERS.REGION"
            },
            "LABEL_FILTER_LOCATIONS": "CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.LABEL_FILTER_LOCATIONS" as "CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.LABEL_FILTER_LOCATIONS",
            "NO_GROUPS": "CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.NO_GROUPS" as "CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.NO_GROUPS",
            "NO_LOCATIONS_FOUND": "CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.NO_LOCATIONS_FOUND" as "CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.NO_LOCATIONS_FOUND",
            "NO_REGION": "CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.NO_REGION" as "CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.NO_REGION"
        },
        "CLIENT_TEMPLATE_CATEGORIES": {
            "ADD_TEMPLATE_CATEGORY": "CLIENT.CLIENT_TEMPLATE_CATEGORIES.ADD_TEMPLATE_CATEGORY" as "CLIENT.CLIENT_TEMPLATE_CATEGORIES.ADD_TEMPLATE_CATEGORY",
            "DELETE_TEMPLATE_CATEGORY": "CLIENT.CLIENT_TEMPLATE_CATEGORIES.DELETE_TEMPLATE_CATEGORY" as "CLIENT.CLIENT_TEMPLATE_CATEGORIES.DELETE_TEMPLATE_CATEGORY",
            "DELETE_TEXT": "CLIENT.CLIENT_TEMPLATE_CATEGORIES.DELETE_TEXT" as "CLIENT.CLIENT_TEMPLATE_CATEGORIES.DELETE_TEXT",
            "EDIT_TEMPLATE_CATEGORY": "CLIENT.CLIENT_TEMPLATE_CATEGORIES.EDIT_TEMPLATE_CATEGORY" as "CLIENT.CLIENT_TEMPLATE_CATEGORIES.EDIT_TEMPLATE_CATEGORY",
            "ERROR": {
                "CREATE": "CLIENT.CLIENT_TEMPLATE_CATEGORIES.ERROR.CREATE" as "CLIENT.CLIENT_TEMPLATE_CATEGORIES.ERROR.CREATE",
                "EMPTY_CATEGORY_LABEL": "CLIENT.CLIENT_TEMPLATE_CATEGORIES.ERROR.EMPTY_CATEGORY_LABEL" as "CLIENT.CLIENT_TEMPLATE_CATEGORIES.ERROR.EMPTY_CATEGORY_LABEL",
                "END_DATE_BEFORE_START_DATE": "CLIENT.CLIENT_TEMPLATE_CATEGORIES.ERROR.END_DATE_BEFORE_START_DATE" as "CLIENT.CLIENT_TEMPLATE_CATEGORIES.ERROR.END_DATE_BEFORE_START_DATE",
                "INVALID_END_DATE": "CLIENT.CLIENT_TEMPLATE_CATEGORIES.ERROR.INVALID_END_DATE" as "CLIENT.CLIENT_TEMPLATE_CATEGORIES.ERROR.INVALID_END_DATE",
                "INVALID_START_DATE": "CLIENT.CLIENT_TEMPLATE_CATEGORIES.ERROR.INVALID_START_DATE" as "CLIENT.CLIENT_TEMPLATE_CATEGORIES.ERROR.INVALID_START_DATE",
                "MODIFY": "CLIENT.CLIENT_TEMPLATE_CATEGORIES.ERROR.MODIFY" as "CLIENT.CLIENT_TEMPLATE_CATEGORIES.ERROR.MODIFY"
            },
            "FORM_LABELS": {
                "END_DATE_OPTIONAL": "CLIENT.CLIENT_TEMPLATE_CATEGORIES.FORM_LABELS.END_DATE_OPTIONAL" as "CLIENT.CLIENT_TEMPLATE_CATEGORIES.FORM_LABELS.END_DATE_OPTIONAL",
                "START_DATE": "CLIENT.CLIENT_TEMPLATE_CATEGORIES.FORM_LABELS.START_DATE" as "CLIENT.CLIENT_TEMPLATE_CATEGORIES.FORM_LABELS.START_DATE"
            },
            "LABEL": "CLIENT.CLIENT_TEMPLATE_CATEGORIES.LABEL" as "CLIENT.CLIENT_TEMPLATE_CATEGORIES.LABEL",
            "SUCCESS": {
                "CREATE": "CLIENT.CLIENT_TEMPLATE_CATEGORIES.SUCCESS.CREATE" as "CLIENT.CLIENT_TEMPLATE_CATEGORIES.SUCCESS.CREATE",
                "MODIFY": "CLIENT.CLIENT_TEMPLATE_CATEGORIES.SUCCESS.MODIFY" as "CLIENT.CLIENT_TEMPLATE_CATEGORIES.SUCCESS.MODIFY"
            },
            "TITLE": "CLIENT.CLIENT_TEMPLATE_CATEGORIES.TITLE" as "CLIENT.CLIENT_TEMPLATE_CATEGORIES.TITLE"
        },
        "CLIENT_USERS_LOCATION": {
            "ADD_USER": "CLIENT.CLIENT_USERS_LOCATION.ADD_USER" as "CLIENT.CLIENT_USERS_LOCATION.ADD_USER",
            "ASSIGN_USER_TO_LOCATIONS": "CLIENT.CLIENT_USERS_LOCATION.ASSIGN_USER_TO_LOCATIONS" as "CLIENT.CLIENT_USERS_LOCATION.ASSIGN_USER_TO_LOCATIONS",
            "BUTTONS": {
                "SEND_INVITE": "CLIENT.CLIENT_USERS_LOCATION.BUTTONS.SEND_INVITE" as "CLIENT.CLIENT_USERS_LOCATION.BUTTONS.SEND_INVITE"
            },
            "CREATE_NEW_USER": "CLIENT.CLIENT_USERS_LOCATION.CREATE_NEW_USER" as "CLIENT.CLIENT_USERS_LOCATION.CREATE_NEW_USER",
            "DELETE_ORPHANED_USER": "CLIENT.CLIENT_USERS_LOCATION.DELETE_ORPHANED_USER" as "CLIENT.CLIENT_USERS_LOCATION.DELETE_ORPHANED_USER",
            "FILTER_USER_PLACEHOLDER": "CLIENT.CLIENT_USERS_LOCATION.FILTER_USER_PLACEHOLDER" as "CLIENT.CLIENT_USERS_LOCATION.FILTER_USER_PLACEHOLDER",
            "INVALID_EMAIL_HELPER_TEXT": "CLIENT.CLIENT_USERS_LOCATION.INVALID_EMAIL_HELPER_TEXT" as "CLIENT.CLIENT_USERS_LOCATION.INVALID_EMAIL_HELPER_TEXT",
            "INVITE_NEW_USER": "CLIENT.CLIENT_USERS_LOCATION.INVITE_NEW_USER" as "CLIENT.CLIENT_USERS_LOCATION.INVITE_NEW_USER",
            "INVITE_USER": "CLIENT.CLIENT_USERS_LOCATION.INVITE_USER" as "CLIENT.CLIENT_USERS_LOCATION.INVITE_USER",
            "LABELS": {
                "EMAIL_ADDRESS": "CLIENT.CLIENT_USERS_LOCATION.LABELS.EMAIL_ADDRESS" as "CLIENT.CLIENT_USERS_LOCATION.LABELS.EMAIL_ADDRESS",
                "GIVE_ACCESS_TO": "CLIENT.CLIENT_USERS_LOCATION.LABELS.GIVE_ACCESS_TO" as "CLIENT.CLIENT_USERS_LOCATION.LABELS.GIVE_ACCESS_TO",
                "USER_DETAILS": "CLIENT.CLIENT_USERS_LOCATION.LABELS.USER_DETAILS" as "CLIENT.CLIENT_USERS_LOCATION.LABELS.USER_DETAILS",
                "USER_ROLES": "CLIENT.CLIENT_USERS_LOCATION.LABELS.USER_ROLES" as "CLIENT.CLIENT_USERS_LOCATION.LABELS.USER_ROLES"
            },
            "LOCATION_ACCESS": "CLIENT.CLIENT_USERS_LOCATION.LOCATION_ACCESS" as "CLIENT.CLIENT_USERS_LOCATION.LOCATION_ACCESS",
            "MATCHING_USERS_FOUND": "CLIENT.CLIENT_USERS_LOCATION.MATCHING_USERS_FOUND" as "CLIENT.CLIENT_USERS_LOCATION.MATCHING_USERS_FOUND",
            "MATCHING_USER_FOUND": "CLIENT.CLIENT_USERS_LOCATION.MATCHING_USER_FOUND" as "CLIENT.CLIENT_USERS_LOCATION.MATCHING_USER_FOUND",
            "MODAL_TITLE": "CLIENT.CLIENT_USERS_LOCATION.MODAL_TITLE" as "CLIENT.CLIENT_USERS_LOCATION.MODAL_TITLE",
            "PLACEHOLDERS": {
                "EMAIL_ADDRESS": "CLIENT.CLIENT_USERS_LOCATION.PLACEHOLDERS.EMAIL_ADDRESS" as "CLIENT.CLIENT_USERS_LOCATION.PLACEHOLDERS.EMAIL_ADDRESS",
                "SELECT_ROLES": "CLIENT.CLIENT_USERS_LOCATION.PLACEHOLDERS.SELECT_ROLES" as "CLIENT.CLIENT_USERS_LOCATION.PLACEHOLDERS.SELECT_ROLES"
            },
            "UPDATE_LOCATIONS": "CLIENT.CLIENT_USERS_LOCATION.UPDATE_LOCATIONS" as "CLIENT.CLIENT_USERS_LOCATION.UPDATE_LOCATIONS"
        },
        "CLIENT_USERS_TABLE": {
            "BULK_ACTIONS": {
                "DELETE": "CLIENT.CLIENT_USERS_TABLE.BULK_ACTIONS.DELETE" as "CLIENT.CLIENT_USERS_TABLE.BULK_ACTIONS.DELETE",
                "RESEND_USER_INVITES": "CLIENT.CLIENT_USERS_TABLE.BULK_ACTIONS.RESEND_USER_INVITES" as "CLIENT.CLIENT_USERS_TABLE.BULK_ACTIONS.RESEND_USER_INVITES",
                "RESET_PASSWORD": "CLIENT.CLIENT_USERS_TABLE.BULK_ACTIONS.RESET_PASSWORD" as "CLIENT.CLIENT_USERS_TABLE.BULK_ACTIONS.RESET_PASSWORD",
                "UPDATE_LOCATIONS": "CLIENT.CLIENT_USERS_TABLE.BULK_ACTIONS.UPDATE_LOCATIONS" as "CLIENT.CLIENT_USERS_TABLE.BULK_ACTIONS.UPDATE_LOCATIONS",
                "UPDATE_ROLES": "CLIENT.CLIENT_USERS_TABLE.BULK_ACTIONS.UPDATE_ROLES" as "CLIENT.CLIENT_USERS_TABLE.BULK_ACTIONS.UPDATE_ROLES"
            },
            "BUTTON_BULK_ACTIONS_PRIMARY": "CLIENT.CLIENT_USERS_TABLE.BUTTON_BULK_ACTIONS_PRIMARY" as "CLIENT.CLIENT_USERS_TABLE.BUTTON_BULK_ACTIONS_PRIMARY",
            "BUTTON_BULK_ACTIONS_SECONDARY": "CLIENT.CLIENT_USERS_TABLE.BUTTON_BULK_ACTIONS_SECONDARY" as "CLIENT.CLIENT_USERS_TABLE.BUTTON_BULK_ACTIONS_SECONDARY",
            "MOBILE_TOOLTIP": "CLIENT.CLIENT_USERS_TABLE.MOBILE_TOOLTIP" as "CLIENT.CLIENT_USERS_TABLE.MOBILE_TOOLTIP",
            "TITLE": "CLIENT.CLIENT_USERS_TABLE.TITLE" as "CLIENT.CLIENT_USERS_TABLE.TITLE"
        },
        "EDIT_CLIENT_USER_MODAL": {
            "LABELS": {
                "EMAIL_ADDRESS": "CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.EMAIL_ADDRESS" as "CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.EMAIL_ADDRESS",
                "FIRST_NAME": "CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.FIRST_NAME" as "CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.FIRST_NAME",
                "GENERAL_DETAILS": "CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.GENERAL_DETAILS" as "CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.GENERAL_DETAILS",
                "GUIDED_TOUR": "CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.GUIDED_TOUR" as "CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.GUIDED_TOUR",
                "LAST_NAME": "CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.LAST_NAME" as "CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.LAST_NAME",
                "LOCATIONS_ACCESS": "CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.LOCATIONS_ACCESS" as "CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.LOCATIONS_ACCESS",
                "PREFERENCES": "CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.PREFERENCES" as "CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.PREFERENCES",
                "TITLE": "CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.TITLE" as "CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.TITLE",
                "USER_ROLES": "CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.USER_ROLES" as "CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.USER_ROLES"
            }
        },
        "ENGAGEMENT_HELP_TEXT": {
            "ACTIVITY": "CLIENT.ENGAGEMENT_HELP_TEXT.ACTIVITY" as "CLIENT.ENGAGEMENT_HELP_TEXT.ACTIVITY",
            "BUILT_ITEMS": "CLIENT.ENGAGEMENT_HELP_TEXT.BUILT_ITEMS" as "CLIENT.ENGAGEMENT_HELP_TEXT.BUILT_ITEMS",
            "CONNECTIONS": {
                "CURRENTLY_REQUIRED_PLATFORMS": "CLIENT.ENGAGEMENT_HELP_TEXT.CONNECTIONS.CURRENTLY_REQUIRED_PLATFORMS" as "CLIENT.ENGAGEMENT_HELP_TEXT.CONNECTIONS.CURRENTLY_REQUIRED_PLATFORMS",
                "DATA_NOT_IMPACTED_BY_DATE_SELECTION": "CLIENT.ENGAGEMENT_HELP_TEXT.CONNECTIONS.DATA_NOT_IMPACTED_BY_DATE_SELECTION" as "CLIENT.ENGAGEMENT_HELP_TEXT.CONNECTIONS.DATA_NOT_IMPACTED_BY_DATE_SELECTION",
                "HOW_TO_SET_REQUIRED_PLATFORMS": "CLIENT.ENGAGEMENT_HELP_TEXT.CONNECTIONS.HOW_TO_SET_REQUIRED_PLATFORMS" as "CLIENT.ENGAGEMENT_HELP_TEXT.CONNECTIONS.HOW_TO_SET_REQUIRED_PLATFORMS",
                "REQUIRED_CONNECTIONS_EXPLANATION": "CLIENT.ENGAGEMENT_HELP_TEXT.CONNECTIONS.REQUIRED_CONNECTIONS_EXPLANATION" as "CLIENT.ENGAGEMENT_HELP_TEXT.CONNECTIONS.REQUIRED_CONNECTIONS_EXPLANATION",
                "TOTAL_CONNECTIONS_EXPLANATION": "CLIENT.ENGAGEMENT_HELP_TEXT.CONNECTIONS.TOTAL_CONNECTIONS_EXPLANATION" as "CLIENT.ENGAGEMENT_HELP_TEXT.CONNECTIONS.TOTAL_CONNECTIONS_EXPLANATION"
            }
        },
        "ERRORS": {
            "NO_CLIENT_ID": "CLIENT.ERRORS.NO_CLIENT_ID" as "CLIENT.ERRORS.NO_CLIENT_ID",
            "NO_CLIENT_SELECTED": "CLIENT.ERRORS.NO_CLIENT_SELECTED" as "CLIENT.ERRORS.NO_CLIENT_SELECTED",
            "NO_DATE_RANGE": "CLIENT.ERRORS.NO_DATE_RANGE" as "CLIENT.ERRORS.NO_DATE_RANGE",
            "UNEXPECTED_ERROR": "CLIENT.ERRORS.UNEXPECTED_ERROR" as "CLIENT.ERRORS.UNEXPECTED_ERROR"
        },
        "ERROR_STYLE_GUIDE_DELETE": "CLIENT.ERROR_STYLE_GUIDE_DELETE" as "CLIENT.ERROR_STYLE_GUIDE_DELETE",
        "ERROR_STYLE_GUIDE_REPLACE": "CLIENT.ERROR_STYLE_GUIDE_REPLACE" as "CLIENT.ERROR_STYLE_GUIDE_REPLACE",
        "ERROR_STYLE_GUIDE_UPLOAD": "CLIENT.ERROR_STYLE_GUIDE_UPLOAD" as "CLIENT.ERROR_STYLE_GUIDE_UPLOAD",
        "LOCATION_ACTIVITY": {
            "BUILT_ITEMS_COUNT": "CLIENT.LOCATION_ACTIVITY.BUILT_ITEMS_COUNT" as "CLIENT.LOCATION_ACTIVITY.BUILT_ITEMS_COUNT",
            "HEADERS": {
                "ACTIVITY": "CLIENT.LOCATION_ACTIVITY.HEADERS.ACTIVITY" as "CLIENT.LOCATION_ACTIVITY.HEADERS.ACTIVITY",
                "BUILT_ITEMS": "CLIENT.LOCATION_ACTIVITY.HEADERS.BUILT_ITEMS" as "CLIENT.LOCATION_ACTIVITY.HEADERS.BUILT_ITEMS",
                "CONNECTIONS": "CLIENT.LOCATION_ACTIVITY.HEADERS.CONNECTIONS" as "CLIENT.LOCATION_ACTIVITY.HEADERS.CONNECTIONS",
                "MOST_ENGAGED_LOCATIONS": "CLIENT.LOCATION_ACTIVITY.HEADERS.MOST_ENGAGED_LOCATIONS" as "CLIENT.LOCATION_ACTIVITY.HEADERS.MOST_ENGAGED_LOCATIONS"
            },
            "LABEL_BUILT_ITEMS_CUMULATIVE": "CLIENT.LOCATION_ACTIVITY.LABEL_BUILT_ITEMS_CUMULATIVE" as "CLIENT.LOCATION_ACTIVITY.LABEL_BUILT_ITEMS_CUMULATIVE",
            "LOCATIONS_ACTIVE": "CLIENT.LOCATION_ACTIVITY.LOCATIONS_ACTIVE" as "CLIENT.LOCATION_ACTIVITY.LOCATIONS_ACTIVE",
            "LOCATIONS_USING_MOBILE_APP": "CLIENT.LOCATION_ACTIVITY.LOCATIONS_USING_MOBILE_APP" as "CLIENT.LOCATION_ACTIVITY.LOCATIONS_USING_MOBILE_APP",
            "REQUIRED_PLATFORMS_CONNECTED": "CLIENT.LOCATION_ACTIVITY.REQUIRED_PLATFORMS_CONNECTED" as "CLIENT.LOCATION_ACTIVITY.REQUIRED_PLATFORMS_CONNECTED",
            "SORT_BUILT_ITEMS": "CLIENT.LOCATION_ACTIVITY.SORT_BUILT_ITEMS" as "CLIENT.LOCATION_ACTIVITY.SORT_BUILT_ITEMS",
            "SORT_LOCATION": "CLIENT.LOCATION_ACTIVITY.SORT_LOCATION" as "CLIENT.LOCATION_ACTIVITY.SORT_LOCATION",
            "SORT_TITLE": "CLIENT.LOCATION_ACTIVITY.SORT_TITLE" as "CLIENT.LOCATION_ACTIVITY.SORT_TITLE",
            "TEMPLATES_BUILT": "CLIENT.LOCATION_ACTIVITY.TEMPLATES_BUILT" as "CLIENT.LOCATION_ACTIVITY.TEMPLATES_BUILT",
            "TOTAL_PLATFORMS_CONNECTED": "CLIENT.LOCATION_ACTIVITY.TOTAL_PLATFORMS_CONNECTED" as "CLIENT.LOCATION_ACTIVITY.TOTAL_PLATFORMS_CONNECTED"
        },
        "OVERVIEW": {
            "ERRORS": {
                "FAIL_TO_LOAD": "CLIENT.OVERVIEW.ERRORS.FAIL_TO_LOAD" as "CLIENT.OVERVIEW.ERRORS.FAIL_TO_LOAD"
            },
            "HEADERS": {
                "TEMPLATES_BUILT": "CLIENT.OVERVIEW.HEADERS.TEMPLATES_BUILT" as "CLIENT.OVERVIEW.HEADERS.TEMPLATES_BUILT",
                "TEMPLATE_CATEGORIES": "CLIENT.OVERVIEW.HEADERS.TEMPLATE_CATEGORIES" as "CLIENT.OVERVIEW.HEADERS.TEMPLATE_CATEGORIES"
            },
            "SOCIAL_TEMPLATE_REPORTING": {
                "BODY": "CLIENT.OVERVIEW.SOCIAL_TEMPLATE_REPORTING.BODY" as "CLIENT.OVERVIEW.SOCIAL_TEMPLATE_REPORTING.BODY",
                "BUTTON": "CLIENT.OVERVIEW.SOCIAL_TEMPLATE_REPORTING.BUTTON" as "CLIENT.OVERVIEW.SOCIAL_TEMPLATE_REPORTING.BUTTON",
                "TITLE": "CLIENT.OVERVIEW.SOCIAL_TEMPLATE_REPORTING.TITLE" as "CLIENT.OVERVIEW.SOCIAL_TEMPLATE_REPORTING.TITLE"
            },
            "TEMPLATES_BUILT_BY_LOCATION_CATEGORY": "CLIENT.OVERVIEW.TEMPLATES_BUILT_BY_LOCATION_CATEGORY" as "CLIENT.OVERVIEW.TEMPLATES_BUILT_BY_LOCATION_CATEGORY",
            "TEMPLATE_CATEGORIES": {
                "ASSETS_USED": "CLIENT.OVERVIEW.TEMPLATE_CATEGORIES.ASSETS_USED" as "CLIENT.OVERVIEW.TEMPLATE_CATEGORIES.ASSETS_USED",
                "ASSETS_USED_plural": "CLIENT.OVERVIEW.TEMPLATE_CATEGORIES.ASSETS_USED_plural" as "CLIENT.OVERVIEW.TEMPLATE_CATEGORIES.ASSETS_USED_plural",
                "DIGITAL": "CLIENT.OVERVIEW.TEMPLATE_CATEGORIES.DIGITAL" as "CLIENT.OVERVIEW.TEMPLATE_CATEGORIES.DIGITAL",
                "EMAIL": "CLIENT.OVERVIEW.TEMPLATE_CATEGORIES.EMAIL" as "CLIENT.OVERVIEW.TEMPLATE_CATEGORIES.EMAIL",
                "PRINT": "CLIENT.OVERVIEW.TEMPLATE_CATEGORIES.PRINT" as "CLIENT.OVERVIEW.TEMPLATE_CATEGORIES.PRINT"
            }
        },
        "REGION_ACTIVITY": {
            "CATEGORIES_TABLE": {
                "AVERAGE_BUILT_ITEMS_PER_LOCATION": "CLIENT.REGION_ACTIVITY.CATEGORIES_TABLE.AVERAGE_BUILT_ITEMS_PER_LOCATION" as "CLIENT.REGION_ACTIVITY.CATEGORIES_TABLE.AVERAGE_BUILT_ITEMS_PER_LOCATION",
                "ERRORS": {
                    "FAIL_TO_LOAD": "CLIENT.REGION_ACTIVITY.CATEGORIES_TABLE.ERRORS.FAIL_TO_LOAD" as "CLIENT.REGION_ACTIVITY.CATEGORIES_TABLE.ERRORS.FAIL_TO_LOAD"
                }
            },
            "FILTER_NAME": "CLIENT.REGION_ACTIVITY.FILTER_NAME" as "CLIENT.REGION_ACTIVITY.FILTER_NAME",
            "HEADERS": {
                "BUILT_ITEMS": "CLIENT.REGION_ACTIVITY.HEADERS.BUILT_ITEMS" as "CLIENT.REGION_ACTIVITY.HEADERS.BUILT_ITEMS"
            }
        },
        "STYLE_GUIDE_PAGE_TITLE": "CLIENT.STYLE_GUIDE_PAGE_TITLE" as "CLIENT.STYLE_GUIDE_PAGE_TITLE",
        "SUCCESS_STYLE_GUIDE_DELETE": "CLIENT.SUCCESS_STYLE_GUIDE_DELETE" as "CLIENT.SUCCESS_STYLE_GUIDE_DELETE",
        "SUCCESS_STYLE_GUIDE_REPLACE": "CLIENT.SUCCESS_STYLE_GUIDE_REPLACE" as "CLIENT.SUCCESS_STYLE_GUIDE_REPLACE",
        "SUCCESS_STYLE_GUIDE_UPLOAD": "CLIENT.SUCCESS_STYLE_GUIDE_UPLOAD" as "CLIENT.SUCCESS_STYLE_GUIDE_UPLOAD"
    },
    "COMMON": {
        "ACTIONS": "COMMON.ACTIONS" as "COMMON.ACTIONS",
        "ACTIVE": "COMMON.ACTIVE" as "COMMON.ACTIVE",
        "ADD": "COMMON.ADD" as "COMMON.ADD",
        "ADDRESS": "COMMON.ADDRESS" as "COMMON.ADDRESS",
        "ADD_NEW_TAG": "COMMON.ADD_NEW_TAG" as "COMMON.ADD_NEW_TAG",
        "ADD_TAG": "COMMON.ADD_TAG" as "COMMON.ADD_TAG",
        "ADMIN": "COMMON.ADMIN" as "COMMON.ADMIN",
        "AFTER": "COMMON.AFTER" as "COMMON.AFTER",
        "AGENCIES": "COMMON.AGENCIES" as "COMMON.AGENCIES",
        "AGENCY": "COMMON.AGENCY" as "COMMON.AGENCY",
        "ALL": "COMMON.ALL" as "COMMON.ALL",
        "ALL_ASSETS": "COMMON.ALL_ASSETS" as "COMMON.ALL_ASSETS",
        "ALL_LOCATIONS": "COMMON.ALL_LOCATIONS" as "COMMON.ALL_LOCATIONS",
        "AMOUNT": "COMMON.AMOUNT" as "COMMON.AMOUNT",
        "AND": "COMMON.AND" as "COMMON.AND",
        "AND_X_OTHER_LOCATIONS": "COMMON.AND_X_OTHER_LOCATIONS" as "COMMON.AND_X_OTHER_LOCATIONS",
        "AND_X_OTHER_LOCATIONS_plural": "COMMON.AND_X_OTHER_LOCATIONS_plural" as "COMMON.AND_X_OTHER_LOCATIONS_plural",
        "ANYBODY": "COMMON.ANYBODY" as "COMMON.ANYBODY",
        "APPS": "COMMON.APPS" as "COMMON.APPS",
        "ARE_YOU_SURE": "COMMON.ARE_YOU_SURE" as "COMMON.ARE_YOU_SURE",
        "ARE_YOU_SURE_YOU_WANT_TO_DELETE_NUM_ASSETS": "COMMON.ARE_YOU_SURE_YOU_WANT_TO_DELETE_NUM_ASSETS" as "COMMON.ARE_YOU_SURE_YOU_WANT_TO_DELETE_NUM_ASSETS",
        "ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ASSET": "COMMON.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ASSET" as "COMMON.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ASSET",
        "ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_COLLECTION": "COMMON.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_COLLECTION" as "COMMON.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_COLLECTION",
        "ASSET_COLLECTION": "COMMON.ASSET_COLLECTION" as "COMMON.ASSET_COLLECTION",
        "ASSET_LIBRARY": "COMMON.ASSET_LIBRARY" as "COMMON.ASSET_LIBRARY",
        "ASSIGNED_TO": "COMMON.ASSIGNED_TO" as "COMMON.ASSIGNED_TO",
        "ATTACH": "COMMON.ATTACH" as "COMMON.ATTACH",
        "ATTACHMENTS": "COMMON.ATTACHMENTS" as "COMMON.ATTACHMENTS",
        "ATTACH_FILE": "COMMON.ATTACH_FILE" as "COMMON.ATTACH_FILE",
        "BACK": "COMMON.BACK" as "COMMON.BACK",
        "BETA": "COMMON.BETA" as "COMMON.BETA",
        "BROWSE": "COMMON.BROWSE" as "COMMON.BROWSE",
        "BUILD": "COMMON.BUILD" as "COMMON.BUILD",
        "BUILT": "COMMON.BUILT" as "COMMON.BUILT",
        "BUSINESS_NAME": "COMMON.BUSINESS_NAME" as "COMMON.BUSINESS_NAME",
        "CANCEL": "COMMON.CANCEL" as "COMMON.CANCEL",
        "CANCELLED_WHILE_IN_QUEUE": "COMMON.CANCELLED_WHILE_IN_QUEUE" as "COMMON.CANCELLED_WHILE_IN_QUEUE",
        "CANCELLED_WHILE_PROCESSING": "COMMON.CANCELLED_WHILE_PROCESSING" as "COMMON.CANCELLED_WHILE_PROCESSING",
        "CANNOT_FIND_ASSET": "COMMON.CANNOT_FIND_ASSET" as "COMMON.CANNOT_FIND_ASSET",
        "CATEGORIES": "COMMON.CATEGORIES" as "COMMON.CATEGORIES",
        "CATEGORY": "COMMON.CATEGORY" as "COMMON.CATEGORY",
        "CHANGE": "COMMON.CHANGE" as "COMMON.CHANGE",
        "CHANGES_SAVED": "COMMON.CHANGES_SAVED" as "COMMON.CHANGES_SAVED",
        "CHANNEL": "COMMON.CHANNEL" as "COMMON.CHANNEL",
        "CHANNELS": "COMMON.CHANNELS" as "COMMON.CHANNELS",
        "CHECK_CONNECTION": "COMMON.CHECK_CONNECTION" as "COMMON.CHECK_CONNECTION",
        "CLEAR": "COMMON.CLEAR" as "COMMON.CLEAR",
        "CLIENT": "COMMON.CLIENT" as "COMMON.CLIENT",
        "CLIENTS": "COMMON.CLIENTS" as "COMMON.CLIENTS",
        "CLIENT_USED_MAX_COLLECTIONS": "COMMON.CLIENT_USED_MAX_COLLECTIONS" as "COMMON.CLIENT_USED_MAX_COLLECTIONS",
        "CLIENT_WITH_LOCATION": "COMMON.CLIENT_WITH_LOCATION" as "COMMON.CLIENT_WITH_LOCATION",
        "CLOSE": "COMMON.CLOSE" as "COMMON.CLOSE",
        "COLLECTION": "COMMON.COLLECTION" as "COMMON.COLLECTION",
        "COLOUR": "COMMON.COLOUR" as "COMMON.COLOUR",
        "COLUMNS": "COMMON.COLUMNS" as "COMMON.COLUMNS",
        "COMMENTS": {
            "ADD_COMMENT": "COMMON.COMMENTS.ADD_COMMENT" as "COMMON.COMMENTS.ADD_COMMENT",
            "ARE_YOU_SURE_DELETE_COMMENT": "COMMON.COMMENTS.ARE_YOU_SURE_DELETE_COMMENT" as "COMMON.COMMENTS.ARE_YOU_SURE_DELETE_COMMENT",
            "CANNOT_DELETE_COMMENTS": "COMMON.COMMENTS.CANNOT_DELETE_COMMENTS" as "COMMON.COMMENTS.CANNOT_DELETE_COMMENTS",
            "COMMENT": "COMMON.COMMENTS.COMMENT" as "COMMON.COMMENTS.COMMENT",
            "COMMENTS": "COMMON.COMMENTS.COMMENTS" as "COMMON.COMMENTS.COMMENTS",
            "COMMENTS_HEADING_DEFAULT": "COMMON.COMMENTS.COMMENTS_HEADING_DEFAULT" as "COMMON.COMMENTS.COMMENTS_HEADING_DEFAULT",
            "DELETE_COMMENT": "COMMON.COMMENTS.DELETE_COMMENT" as "COMMON.COMMENTS.DELETE_COMMENT",
            "ENTER_COMMENT": "COMMON.COMMENTS.ENTER_COMMENT" as "COMMON.COMMENTS.ENTER_COMMENT",
            "UNKNOWN_PARENT": "COMMON.COMMENTS.UNKNOWN_PARENT" as "COMMON.COMMENTS.UNKNOWN_PARENT"
        },
        "COMPANIES": {
            "LT_NETWORK": "COMMON.COMPANIES.LT_NETWORK" as "COMMON.COMPANIES.LT_NETWORK"
        },
        "CONFIRM": "COMMON.CONFIRM" as "COMMON.CONFIRM",
        "CONFIRMATION": "COMMON.CONFIRMATION" as "COMMON.CONFIRMATION",
        "CONFIRM_MODAL_INPUT": "COMMON.CONFIRM_MODAL_INPUT" as "COMMON.CONFIRM_MODAL_INPUT",
        "CONNECTION_ISSUES": "COMMON.CONNECTION_ISSUES" as "COMMON.CONNECTION_ISSUES",
        "CONNECT_PAGE": {
            "CONNECT_PAGE": "COMMON.CONNECT_PAGE.CONNECT_PAGE" as "COMMON.CONNECT_PAGE.CONNECT_PAGE",
            "FILTER": {
                "ACCOUNT_NAME": "COMMON.CONNECT_PAGE.FILTER.ACCOUNT_NAME" as "COMMON.CONNECT_PAGE.FILTER.ACCOUNT_NAME",
                "CLEAR_LOCATION_ID": "COMMON.CONNECT_PAGE.FILTER.CLEAR_LOCATION_ID" as "COMMON.CONNECT_PAGE.FILTER.CLEAR_LOCATION_ID",
                "CLIENT": "COMMON.CONNECT_PAGE.FILTER.CLIENT" as "COMMON.CONNECT_PAGE.FILTER.CLIENT",
                "LOCATION": "COMMON.CONNECT_PAGE.FILTER.LOCATION" as "COMMON.CONNECT_PAGE.FILTER.LOCATION",
                "PAGE_NAME": "COMMON.CONNECT_PAGE.FILTER.PAGE_NAME" as "COMMON.CONNECT_PAGE.FILTER.PAGE_NAME",
                "STATUS": "COMMON.CONNECT_PAGE.FILTER.STATUS" as "COMMON.CONNECT_PAGE.FILTER.STATUS"
            },
            "STATUS_DROPDOWN": {
                "CONNECT": "COMMON.CONNECT_PAGE.STATUS_DROPDOWN.CONNECT" as "COMMON.CONNECT_PAGE.STATUS_DROPDOWN.CONNECT",
                "CONNECTED": "COMMON.CONNECT_PAGE.STATUS_DROPDOWN.CONNECTED" as "COMMON.CONNECT_PAGE.STATUS_DROPDOWN.CONNECTED",
                "ERROR": "COMMON.CONNECT_PAGE.STATUS_DROPDOWN.ERROR" as "COMMON.CONNECT_PAGE.STATUS_DROPDOWN.ERROR",
                "EXPIRED": "COMMON.CONNECT_PAGE.STATUS_DROPDOWN.EXPIRED" as "COMMON.CONNECT_PAGE.STATUS_DROPDOWN.EXPIRED",
                "INCOMPLETE": "COMMON.CONNECT_PAGE.STATUS_DROPDOWN.INCOMPLETE" as "COMMON.CONNECT_PAGE.STATUS_DROPDOWN.INCOMPLETE"
            },
            "TABLE_HEADERS": {
                "ACCOUNT_MAPPING": "COMMON.CONNECT_PAGE.TABLE_HEADERS.ACCOUNT_MAPPING" as "COMMON.CONNECT_PAGE.TABLE_HEADERS.ACCOUNT_MAPPING",
                "ACCOUNT_NAME": "COMMON.CONNECT_PAGE.TABLE_HEADERS.ACCOUNT_NAME" as "COMMON.CONNECT_PAGE.TABLE_HEADERS.ACCOUNT_NAME"
            }
        },
        "CONTINUE": "COMMON.CONTINUE" as "COMMON.CONTINUE",
        "COPIED_TO_CLIPBOARD": "COMMON.COPIED_TO_CLIPBOARD" as "COMMON.COPIED_TO_CLIPBOARD",
        "COPIED_TO_CLIPBOARD_FAILED": "COMMON.COPIED_TO_CLIPBOARD_FAILED" as "COMMON.COPIED_TO_CLIPBOARD_FAILED",
        "COPY": "COMMON.COPY" as "COMMON.COPY",
        "COSTS": "COMMON.COSTS" as "COMMON.COSTS",
        "COULD_NOT_DETERMINE_BOOTSTRAP_BREAKPOINT": "COMMON.COULD_NOT_DETERMINE_BOOTSTRAP_BREAKPOINT" as "COMMON.COULD_NOT_DETERMINE_BOOTSTRAP_BREAKPOINT",
        "COUNTRIES": {
            "AUSTRALIA": "COMMON.COUNTRIES.AUSTRALIA" as "COMMON.COUNTRIES.AUSTRALIA",
            "AUSTRIA": "COMMON.COUNTRIES.AUSTRIA" as "COMMON.COUNTRIES.AUSTRIA",
            "BELGIUM": "COMMON.COUNTRIES.BELGIUM" as "COMMON.COUNTRIES.BELGIUM",
            "CANADA": "COMMON.COUNTRIES.CANADA" as "COMMON.COUNTRIES.CANADA",
            "CZECHIA": "COMMON.COUNTRIES.CZECHIA" as "COMMON.COUNTRIES.CZECHIA",
            "DENMARK": "COMMON.COUNTRIES.DENMARK" as "COMMON.COUNTRIES.DENMARK",
            "DOMINICAN_REPUBLIC": "COMMON.COUNTRIES.DOMINICAN_REPUBLIC" as "COMMON.COUNTRIES.DOMINICAN_REPUBLIC",
            "EGYPT": "COMMON.COUNTRIES.EGYPT" as "COMMON.COUNTRIES.EGYPT",
            "FINLAND": "COMMON.COUNTRIES.FINLAND" as "COMMON.COUNTRIES.FINLAND",
            "FRANCE": "COMMON.COUNTRIES.FRANCE" as "COMMON.COUNTRIES.FRANCE",
            "GEORGIA": "COMMON.COUNTRIES.GEORGIA" as "COMMON.COUNTRIES.GEORGIA",
            "GERMANY": "COMMON.COUNTRIES.GERMANY" as "COMMON.COUNTRIES.GERMANY",
            "HONG_KONG": "COMMON.COUNTRIES.HONG_KONG" as "COMMON.COUNTRIES.HONG_KONG",
            "HUNGARY": "COMMON.COUNTRIES.HUNGARY" as "COMMON.COUNTRIES.HUNGARY",
            "INDIA": "COMMON.COUNTRIES.INDIA" as "COMMON.COUNTRIES.INDIA",
            "INDONESIA": "COMMON.COUNTRIES.INDONESIA" as "COMMON.COUNTRIES.INDONESIA",
            "IRELAND": "COMMON.COUNTRIES.IRELAND" as "COMMON.COUNTRIES.IRELAND",
            "ITALY": "COMMON.COUNTRIES.ITALY" as "COMMON.COUNTRIES.ITALY",
            "JAPAN": "COMMON.COUNTRIES.JAPAN" as "COMMON.COUNTRIES.JAPAN",
            "LATVIA": "COMMON.COUNTRIES.LATVIA" as "COMMON.COUNTRIES.LATVIA",
            "LITHUANIA": "COMMON.COUNTRIES.LITHUANIA" as "COMMON.COUNTRIES.LITHUANIA",
            "MALAYSIA": "COMMON.COUNTRIES.MALAYSIA" as "COMMON.COUNTRIES.MALAYSIA",
            "MAURITIUS": "COMMON.COUNTRIES.MAURITIUS" as "COMMON.COUNTRIES.MAURITIUS",
            "MEXICO": "COMMON.COUNTRIES.MEXICO" as "COMMON.COUNTRIES.MEXICO",
            "MYANMAR": "COMMON.COUNTRIES.MYANMAR" as "COMMON.COUNTRIES.MYANMAR",
            "NETHERLANDS": "COMMON.COUNTRIES.NETHERLANDS" as "COMMON.COUNTRIES.NETHERLANDS",
            "NEW_ZEALAND": "COMMON.COUNTRIES.NEW_ZEALAND" as "COMMON.COUNTRIES.NEW_ZEALAND",
            "NORWAY": "COMMON.COUNTRIES.NORWAY" as "COMMON.COUNTRIES.NORWAY",
            "PERU": "COMMON.COUNTRIES.PERU" as "COMMON.COUNTRIES.PERU",
            "PHILIPPINES": "COMMON.COUNTRIES.PHILIPPINES" as "COMMON.COUNTRIES.PHILIPPINES",
            "PORTUGAL": "COMMON.COUNTRIES.PORTUGAL" as "COMMON.COUNTRIES.PORTUGAL",
            "SAUDI_ARABIA": "COMMON.COUNTRIES.SAUDI_ARABIA" as "COMMON.COUNTRIES.SAUDI_ARABIA",
            "SINGAPORE": "COMMON.COUNTRIES.SINGAPORE" as "COMMON.COUNTRIES.SINGAPORE",
            "SOUTH_AFRICA": "COMMON.COUNTRIES.SOUTH_AFRICA" as "COMMON.COUNTRIES.SOUTH_AFRICA",
            "SOUTH_KOREA": "COMMON.COUNTRIES.SOUTH_KOREA" as "COMMON.COUNTRIES.SOUTH_KOREA",
            "SPAIN": "COMMON.COUNTRIES.SPAIN" as "COMMON.COUNTRIES.SPAIN",
            "SWEDEN": "COMMON.COUNTRIES.SWEDEN" as "COMMON.COUNTRIES.SWEDEN",
            "SWITZERLAND": "COMMON.COUNTRIES.SWITZERLAND" as "COMMON.COUNTRIES.SWITZERLAND",
            "TAIWAN": "COMMON.COUNTRIES.TAIWAN" as "COMMON.COUNTRIES.TAIWAN",
            "THAILAND": "COMMON.COUNTRIES.THAILAND" as "COMMON.COUNTRIES.THAILAND",
            "TURKEY": "COMMON.COUNTRIES.TURKEY" as "COMMON.COUNTRIES.TURKEY",
            "UNITED_ARAB_EMIRATES": "COMMON.COUNTRIES.UNITED_ARAB_EMIRATES" as "COMMON.COUNTRIES.UNITED_ARAB_EMIRATES",
            "UNITED_KINGDOM": "COMMON.COUNTRIES.UNITED_KINGDOM" as "COMMON.COUNTRIES.UNITED_KINGDOM",
            "UNITED_STATES_OF_AMERICA": "COMMON.COUNTRIES.UNITED_STATES_OF_AMERICA" as "COMMON.COUNTRIES.UNITED_STATES_OF_AMERICA",
            "VIETNAM": "COMMON.COUNTRIES.VIETNAM" as "COMMON.COUNTRIES.VIETNAM"
        },
        "COUNTRY": "COMMON.COUNTRY" as "COMMON.COUNTRY",
        "CREATE": "COMMON.CREATE" as "COMMON.CREATE",
        "CREATED": "COMMON.CREATED" as "COMMON.CREATED",
        "CREATED_AT": "COMMON.CREATED_AT" as "COMMON.CREATED_AT",
        "CURRENCY": "COMMON.CURRENCY" as "COMMON.CURRENCY",
        "CURRENTLY_SELECTED_COUNT": "COMMON.CURRENTLY_SELECTED_COUNT" as "COMMON.CURRENTLY_SELECTED_COUNT",
        "CURRENT_LOCATION_USED_MAX_COLLECTIONS": "COMMON.CURRENT_LOCATION_USED_MAX_COLLECTIONS" as "COMMON.CURRENT_LOCATION_USED_MAX_COLLECTIONS",
        "CUSTOMIZE": "COMMON.CUSTOMIZE" as "COMMON.CUSTOMIZE",
        "DATE": "COMMON.DATE" as "COMMON.DATE",
        "DATE_ADDED": "COMMON.DATE_ADDED" as "COMMON.DATE_ADDED",
        "DAY": "COMMON.DAY" as "COMMON.DAY",
        "DAYS": "COMMON.DAYS" as "COMMON.DAYS",
        "DAYS_OF_THE_WEEK_LONG": {
            "FRIDAY": "COMMON.DAYS_OF_THE_WEEK_LONG.FRIDAY" as "COMMON.DAYS_OF_THE_WEEK_LONG.FRIDAY",
            "MONDAY": "COMMON.DAYS_OF_THE_WEEK_LONG.MONDAY" as "COMMON.DAYS_OF_THE_WEEK_LONG.MONDAY",
            "SATURDAY": "COMMON.DAYS_OF_THE_WEEK_LONG.SATURDAY" as "COMMON.DAYS_OF_THE_WEEK_LONG.SATURDAY",
            "SUNDAY": "COMMON.DAYS_OF_THE_WEEK_LONG.SUNDAY" as "COMMON.DAYS_OF_THE_WEEK_LONG.SUNDAY",
            "THURSDAY": "COMMON.DAYS_OF_THE_WEEK_LONG.THURSDAY" as "COMMON.DAYS_OF_THE_WEEK_LONG.THURSDAY",
            "TUESDAY": "COMMON.DAYS_OF_THE_WEEK_LONG.TUESDAY" as "COMMON.DAYS_OF_THE_WEEK_LONG.TUESDAY",
            "WEDNESDAY": "COMMON.DAYS_OF_THE_WEEK_LONG.WEDNESDAY" as "COMMON.DAYS_OF_THE_WEEK_LONG.WEDNESDAY"
        },
        "DELETE": "COMMON.DELETE" as "COMMON.DELETE",
        "DELETED": "COMMON.DELETED" as "COMMON.DELETED",
        "DELETE_ASSET": "COMMON.DELETE_ASSET" as "COMMON.DELETE_ASSET",
        "DELETE_CHECKED_TAGS": "COMMON.DELETE_CHECKED_TAGS" as "COMMON.DELETE_CHECKED_TAGS",
        "DELETE_CHECKED_TAGS_CONFIRM": "COMMON.DELETE_CHECKED_TAGS_CONFIRM" as "COMMON.DELETE_CHECKED_TAGS_CONFIRM",
        "DELETE_PERMANENTLY": "COMMON.DELETE_PERMANENTLY" as "COMMON.DELETE_PERMANENTLY",
        "DELETE_SOMETHING": "COMMON.DELETE_SOMETHING" as "COMMON.DELETE_SOMETHING",
        "DESCRIPTION": "COMMON.DESCRIPTION" as "COMMON.DESCRIPTION",
        "DESELECT_ALL": "COMMON.DESELECT_ALL" as "COMMON.DESELECT_ALL",
        "DESKTOP": "COMMON.DESKTOP" as "COMMON.DESKTOP",
        "DETACH": "COMMON.DETACH" as "COMMON.DETACH",
        "DETAILS": "COMMON.DETAILS" as "COMMON.DETAILS",
        "DISABLE": "COMMON.DISABLE" as "COMMON.DISABLE",
        "DISABLED": "COMMON.DISABLED" as "COMMON.DISABLED",
        "DISMISS": "COMMON.DISMISS" as "COMMON.DISMISS",
        "DISPLAY_NAME": "COMMON.DISPLAY_NAME" as "COMMON.DISPLAY_NAME",
        "DONE": "COMMON.DONE" as "COMMON.DONE",
        "DOWNLOAD": "COMMON.DOWNLOAD" as "COMMON.DOWNLOAD",
        "EDIT": "COMMON.EDIT" as "COMMON.EDIT",
        "EDIT_ASSET": "COMMON.EDIT_ASSET" as "COMMON.EDIT_ASSET",
        "EDIT_ASSETS": "COMMON.EDIT_ASSETS" as "COMMON.EDIT_ASSETS",
        "EDIT_COLLECTION": "COMMON.EDIT_COLLECTION" as "COMMON.EDIT_COLLECTION",
        "EDIT_MULTIPLE_ASSETS": "COMMON.EDIT_MULTIPLE_ASSETS" as "COMMON.EDIT_MULTIPLE_ASSETS",
        "EMAIL": "COMMON.EMAIL" as "COMMON.EMAIL",
        "EMAIL_ADDRESS": "COMMON.EMAIL_ADDRESS" as "COMMON.EMAIL_ADDRESS",
        "ENABLE": "COMMON.ENABLE" as "COMMON.ENABLE",
        "ENABLED": "COMMON.ENABLED" as "COMMON.ENABLED",
        "END_DATE": "COMMON.END_DATE" as "COMMON.END_DATE",
        "ENTER_NEW_NAME": "COMMON.ENTER_NEW_NAME" as "COMMON.ENTER_NEW_NAME",
        "ERROR": "COMMON.ERROR" as "COMMON.ERROR",
        "EXAMPLE": "COMMON.EXAMPLE" as "COMMON.EXAMPLE",
        "EXCEEDED_SIZE_LIMIT_COLLECTION": "COMMON.EXCEEDED_SIZE_LIMIT_COLLECTION" as "COMMON.EXCEEDED_SIZE_LIMIT_COLLECTION",
        "EXPIRED": "COMMON.EXPIRED" as "COMMON.EXPIRED",
        "EXPIRE_ON_DATE": "COMMON.EXPIRE_ON_DATE" as "COMMON.EXPIRE_ON_DATE",
        "EXPIRY": "COMMON.EXPIRY" as "COMMON.EXPIRY",
        "FAILED_TO": "COMMON.FAILED_TO" as "COMMON.FAILED_TO",
        "FAILED_TO_LOAD_IMAGE": "COMMON.FAILED_TO_LOAD_IMAGE" as "COMMON.FAILED_TO_LOAD_IMAGE",
        "FAILED_TO_RETRIEVE_LOCATIONS": "COMMON.FAILED_TO_RETRIEVE_LOCATIONS" as "COMMON.FAILED_TO_RETRIEVE_LOCATIONS",
        "FETCH_DATA": "COMMON.FETCH_DATA" as "COMMON.FETCH_DATA",
        "FILE": "COMMON.FILE" as "COMMON.FILE",
        "FILES": "COMMON.FILES" as "COMMON.FILES",
        "FILE_SIZE": "COMMON.FILE_SIZE" as "COMMON.FILE_SIZE",
        "FILE_UPLOADED": "COMMON.FILE_UPLOADED" as "COMMON.FILE_UPLOADED",
        "FILTER": "COMMON.FILTER" as "COMMON.FILTER",
        "FILTERS": "COMMON.FILTERS" as "COMMON.FILTERS",
        "FILTER_COLLECTIONS": "COMMON.FILTER_COLLECTIONS" as "COMMON.FILTER_COLLECTIONS",
        "FINISH": "COMMON.FINISH" as "COMMON.FINISH",
        "FIRST_NAME": "COMMON.FIRST_NAME" as "COMMON.FIRST_NAME",
        "FORMAT": "COMMON.FORMAT" as "COMMON.FORMAT",
        "FORMATS": "COMMON.FORMATS" as "COMMON.FORMATS",
        "FROM": "COMMON.FROM" as "COMMON.FROM",
        "FULL_SCREEN": "COMMON.FULL_SCREEN" as "COMMON.FULL_SCREEN",
        "GMT": "COMMON.GMT" as "COMMON.GMT",
        "GOOGLE_ADS_DISCLAIMER": "COMMON.GOOGLE_ADS_DISCLAIMER" as "COMMON.GOOGLE_ADS_DISCLAIMER",
        "GOOGLE_ADS_DISCLAIMER_CONVERSION_DATA": "COMMON.GOOGLE_ADS_DISCLAIMER_CONVERSION_DATA" as "COMMON.GOOGLE_ADS_DISCLAIMER_CONVERSION_DATA",
        "GROUPS": "COMMON.GROUPS" as "COMMON.GROUPS",
        "HEIGHT": "COMMON.HEIGHT" as "COMMON.HEIGHT",
        "HIDE": "COMMON.HIDE" as "COMMON.HIDE",
        "IMAGE": "COMMON.IMAGE" as "COMMON.IMAGE",
        "INFO": "COMMON.INFO" as "COMMON.INFO",
        "INSTRUCTIONS": "COMMON.INSTRUCTIONS" as "COMMON.INSTRUCTIONS",
        "INVITE": "COMMON.INVITE" as "COMMON.INVITE",
        "ITEM": "COMMON.ITEM" as "COMMON.ITEM",
        "JOB_TITLE": "COMMON.JOB_TITLE" as "COMMON.JOB_TITLE",
        "LABEL": "COMMON.LABEL" as "COMMON.LABEL",
        "LAST_ACTIVITY": "COMMON.LAST_ACTIVITY" as "COMMON.LAST_ACTIVITY",
        "LAST_MONTH": "COMMON.LAST_MONTH" as "COMMON.LAST_MONTH",
        "LAST_NAME": "COMMON.LAST_NAME" as "COMMON.LAST_NAME",
        "LAST_UPDATED": "COMMON.LAST_UPDATED" as "COMMON.LAST_UPDATED",
        "LEARN_MORE": "COMMON.LEARN_MORE" as "COMMON.LEARN_MORE",
        "LEAVE_PAGE_CONFIRMATION": "COMMON.LEAVE_PAGE_CONFIRMATION" as "COMMON.LEAVE_PAGE_CONFIRMATION",
        "LEAVE_PAGE_CONFIRMATION_LONG": "COMMON.LEAVE_PAGE_CONFIRMATION_LONG" as "COMMON.LEAVE_PAGE_CONFIRMATION_LONG",
        "LEAVE_PAGE_PROMPT": {
            "CONFIRM": "COMMON.LEAVE_PAGE_PROMPT.CONFIRM" as "COMMON.LEAVE_PAGE_PROMPT.CONFIRM",
            "TITLE": "COMMON.LEAVE_PAGE_PROMPT.TITLE" as "COMMON.LEAVE_PAGE_PROMPT.TITLE"
        },
        "LEGEND": "COMMON.LEGEND" as "COMMON.LEGEND",
        "LESS": "COMMON.LESS" as "COMMON.LESS",
        "LINK": "COMMON.LINK" as "COMMON.LINK",
        "LOADING": "COMMON.LOADING" as "COMMON.LOADING",
        "LOAD_MORE": "COMMON.LOAD_MORE" as "COMMON.LOAD_MORE",
        "LOCALE": "COMMON.LOCALE" as "COMMON.LOCALE",
        "LOCALE_REQUIRED": "COMMON.LOCALE_REQUIRED" as "COMMON.LOCALE_REQUIRED",
        "LOCATION": "COMMON.LOCATION" as "COMMON.LOCATION",
        "LOCATIONS": "COMMON.LOCATIONS" as "COMMON.LOCATIONS",
        "LOCATION_USED_MAX_COLLECTIONS": "COMMON.LOCATION_USED_MAX_COLLECTIONS" as "COMMON.LOCATION_USED_MAX_COLLECTIONS",
        "LOGIN": "COMMON.LOGIN" as "COMMON.LOGIN",
        "MANAGER": "COMMON.MANAGER" as "COMMON.MANAGER",
        "MAP": "COMMON.MAP" as "COMMON.MAP",
        "MARKETING": "COMMON.MARKETING" as "COMMON.MARKETING",
        "MESSAGE": "COMMON.MESSAGE" as "COMMON.MESSAGE",
        "MOBILE": "COMMON.MOBILE" as "COMMON.MOBILE",
        "MORE": "COMMON.MORE" as "COMMON.MORE",
        "MORE_CHARS_FOR_SEARCH": "COMMON.MORE_CHARS_FOR_SEARCH" as "COMMON.MORE_CHARS_FOR_SEARCH",
        "MOST": "COMMON.MOST" as "COMMON.MOST",
        "MOVE_TO_FOLDER": "COMMON.MOVE_TO_FOLDER" as "COMMON.MOVE_TO_FOLDER",
        "MUST_BE_X_OR_MORE": "COMMON.MUST_BE_X_OR_MORE" as "COMMON.MUST_BE_X_OR_MORE",
        "NAME": "COMMON.NAME" as "COMMON.NAME",
        "NEVER": "COMMON.NEVER" as "COMMON.NEVER",
        "NEW": "COMMON.NEW" as "COMMON.NEW",
        "NEW_COLLECTION": "COMMON.NEW_COLLECTION" as "COMMON.NEW_COLLECTION",
        "NEXT": "COMMON.NEXT" as "COMMON.NEXT",
        "NEXT_AMOUNT": "COMMON.NEXT_AMOUNT" as "COMMON.NEXT_AMOUNT",
        "NEXT_DATE": "COMMON.NEXT_DATE" as "COMMON.NEXT_DATE",
        "NO": "COMMON.NO" as "COMMON.NO",
        "NOBODY": "COMMON.NOBODY" as "COMMON.NOBODY",
        "NONE": "COMMON.NONE" as "COMMON.NONE",
        "NOTE": "COMMON.NOTE" as "COMMON.NOTE",
        "NOTHING_FOUND": "COMMON.NOTHING_FOUND" as "COMMON.NOTHING_FOUND",
        "NOTIFICATION": "COMMON.NOTIFICATION" as "COMMON.NOTIFICATION",
        "NOTIFICATIONS": "COMMON.NOTIFICATIONS" as "COMMON.NOTIFICATIONS",
        "NOT_LOGGED_IN": "COMMON.NOT_LOGGED_IN" as "COMMON.NOT_LOGGED_IN",
        "NOT_SEEING_WHAT_EXPECTED": "COMMON.NOT_SEEING_WHAT_EXPECTED" as "COMMON.NOT_SEEING_WHAT_EXPECTED",
        "NO_ASSETS_ARE_CURRENTLY_AVALIABLE_FOR": "COMMON.NO_ASSETS_ARE_CURRENTLY_AVALIABLE_FOR" as "COMMON.NO_ASSETS_ARE_CURRENTLY_AVALIABLE_FOR",
        "NO_ASSETS_FOUND": "COMMON.NO_ASSETS_FOUND" as "COMMON.NO_ASSETS_FOUND",
        "NO_ASSET_COLLECTIONS_FOUND": "COMMON.NO_ASSET_COLLECTIONS_FOUND" as "COMMON.NO_ASSET_COLLECTIONS_FOUND",
        "NO_MATCHING_COLLECTIONS_FOUND": "COMMON.NO_MATCHING_COLLECTIONS_FOUND" as "COMMON.NO_MATCHING_COLLECTIONS_FOUND",
        "NO_RESULTS": "COMMON.NO_RESULTS" as "COMMON.NO_RESULTS",
        "NO_THANKS": "COMMON.NO_THANKS" as "COMMON.NO_THANKS",
        "NUM_OF_TOTAL": "COMMON.NUM_OF_TOTAL" as "COMMON.NUM_OF_TOTAL",
        "OK": "COMMON.OK" as "COMMON.OK",
        "ON": "COMMON.ON" as "COMMON.ON",
        "OPEN": "COMMON.OPEN" as "COMMON.OPEN",
        "OPEN_CALENDAR": "COMMON.OPEN_CALENDAR" as "COMMON.OPEN_CALENDAR",
        "OPEN_YOUR_FILE": "COMMON.OPEN_YOUR_FILE" as "COMMON.OPEN_YOUR_FILE",
        "OPTIONAL": "COMMON.OPTIONAL" as "COMMON.OPTIONAL",
        "OPTIONS": "COMMON.OPTIONS" as "COMMON.OPTIONS",
        "OP_ADD_ASSET": "COMMON.OP_ADD_ASSET" as "COMMON.OP_ADD_ASSET",
        "OP_CREATE_COLLECTION": "COMMON.OP_CREATE_COLLECTION" as "COMMON.OP_CREATE_COLLECTION",
        "OP_DELETE_ASSETS": "COMMON.OP_DELETE_ASSETS" as "COMMON.OP_DELETE_ASSETS",
        "OP_DELETE_COLLECTION": "COMMON.OP_DELETE_COLLECTION" as "COMMON.OP_DELETE_COLLECTION",
        "OP_EDIT_ASSETS": "COMMON.OP_EDIT_ASSETS" as "COMMON.OP_EDIT_ASSETS",
        "OP_EDIT_COLLECTION": "COMMON.OP_EDIT_COLLECTION" as "COMMON.OP_EDIT_COLLECTION",
        "OP_GET_ASSETS": "COMMON.OP_GET_ASSETS" as "COMMON.OP_GET_ASSETS",
        "OP_GET_COLLECTION": "COMMON.OP_GET_COLLECTION" as "COMMON.OP_GET_COLLECTION",
        "OP_GET_COLLECTIONS": "COMMON.OP_GET_COLLECTIONS" as "COMMON.OP_GET_COLLECTIONS",
        "OP_GET_LOCATIONS": "COMMON.OP_GET_LOCATIONS" as "COMMON.OP_GET_LOCATIONS",
        "OP_GET_NUM_COLLECTIONS": "COMMON.OP_GET_NUM_COLLECTIONS" as "COMMON.OP_GET_NUM_COLLECTIONS",
        "OP_GET_PERMISSIONS": "COMMON.OP_GET_PERMISSIONS" as "COMMON.OP_GET_PERMISSIONS",
        "OR": "COMMON.OR" as "COMMON.OR",
        "OTHER": "COMMON.OTHER" as "COMMON.OTHER",
        "OUT_OF_RANGE": "COMMON.OUT_OF_RANGE" as "COMMON.OUT_OF_RANGE",
        "PASSWORD": "COMMON.PASSWORD" as "COMMON.PASSWORD",
        "PAY": "COMMON.PAY" as "COMMON.PAY",
        "PER_PAGE": "COMMON.PER_PAGE" as "COMMON.PER_PAGE",
        "PHONE_NUMBER": "COMMON.PHONE_NUMBER" as "COMMON.PHONE_NUMBER",
        "PLANNED": "COMMON.PLANNED" as "COMMON.PLANNED",
        "PLATFORM": "COMMON.PLATFORM" as "COMMON.PLATFORM",
        "PLATFORMS": "COMMON.PLATFORMS" as "COMMON.PLATFORMS",
        "PLEASE_CONTACT_YOUR_AGENCY_FOR_FURTHER_INFORMATION": "COMMON.PLEASE_CONTACT_YOUR_AGENCY_FOR_FURTHER_INFORMATION" as "COMMON.PLEASE_CONTACT_YOUR_AGENCY_FOR_FURTHER_INFORMATION",
        "PREVIEW": "COMMON.PREVIEW" as "COMMON.PREVIEW",
        "PREVIOUS": "COMMON.PREVIOUS" as "COMMON.PREVIOUS",
        "PRICE": "COMMON.PRICE" as "COMMON.PRICE",
        "PRIMARY": "COMMON.PRIMARY" as "COMMON.PRIMARY",
        "PRINT": "COMMON.PRINT" as "COMMON.PRINT",
        "PRIVATE": "COMMON.PRIVATE" as "COMMON.PRIVATE",
        "PROCESSING": "COMMON.PROCESSING" as "COMMON.PROCESSING",
        "PRODUCTS": {
            "CAMPAIGN_MONITOR": "COMMON.PRODUCTS.CAMPAIGN_MONITOR" as "COMMON.PRODUCTS.CAMPAIGN_MONITOR",
            "CLUBREADY": "COMMON.PRODUCTS.CLUBREADY" as "COMMON.PRODUCTS.CLUBREADY",
            "DIGITAL_STACK": "COMMON.PRODUCTS.DIGITAL_STACK" as "COMMON.PRODUCTS.DIGITAL_STACK",
            "FACEBOOK": "COMMON.PRODUCTS.FACEBOOK" as "COMMON.PRODUCTS.FACEBOOK",
            "FACEBOOK_ADS": "COMMON.PRODUCTS.FACEBOOK_ADS" as "COMMON.PRODUCTS.FACEBOOK_ADS",
            "FACEBOOK_AND_INSTAGRAM_ADS": "COMMON.PRODUCTS.FACEBOOK_AND_INSTAGRAM_ADS" as "COMMON.PRODUCTS.FACEBOOK_AND_INSTAGRAM_ADS",
            "FITWARE": "COMMON.PRODUCTS.FITWARE" as "COMMON.PRODUCTS.FITWARE",
            "FOUR51": "COMMON.PRODUCTS.FOUR51" as "COMMON.PRODUCTS.FOUR51",
            "GLOFOX": "COMMON.PRODUCTS.GLOFOX" as "COMMON.PRODUCTS.GLOFOX",
            "GOOGLE": "COMMON.PRODUCTS.GOOGLE" as "COMMON.PRODUCTS.GOOGLE",
            "GOOGLE_ADWORDS": "COMMON.PRODUCTS.GOOGLE_ADWORDS" as "COMMON.PRODUCTS.GOOGLE_ADWORDS",
            "GOOGLE_ANALYTICS": "COMMON.PRODUCTS.GOOGLE_ANALYTICS" as "COMMON.PRODUCTS.GOOGLE_ANALYTICS",
            "GOOGLE_MY_BUSINESS": "COMMON.PRODUCTS.GOOGLE_MY_BUSINESS" as "COMMON.PRODUCTS.GOOGLE_MY_BUSINESS",
            "INSTAGRAM": "COMMON.PRODUCTS.INSTAGRAM" as "COMMON.PRODUCTS.INSTAGRAM",
            "INSTAGRAM_VIA_FACEBOOK": "COMMON.PRODUCTS.INSTAGRAM_VIA_FACEBOOK" as "COMMON.PRODUCTS.INSTAGRAM_VIA_FACEBOOK",
            "LINKEDIN": "COMMON.PRODUCTS.LINKEDIN" as "COMMON.PRODUCTS.LINKEDIN",
            "MAILCHIMP": "COMMON.PRODUCTS.MAILCHIMP" as "COMMON.PRODUCTS.MAILCHIMP",
            "SENDGRID": "COMMON.PRODUCTS.SENDGRID" as "COMMON.PRODUCTS.SENDGRID",
            "TWITTER": "COMMON.PRODUCTS.TWITTER" as "COMMON.PRODUCTS.TWITTER"
        },
        "PROGRESS_MODAL": {
            "STATUS_MESSAGE": "COMMON.PROGRESS_MODAL.STATUS_MESSAGE" as "COMMON.PROGRESS_MODAL.STATUS_MESSAGE"
        },
        "PUBLIC": "COMMON.PUBLIC" as "COMMON.PUBLIC",
        "QUANTITY": "COMMON.QUANTITY" as "COMMON.QUANTITY",
        "REFRESH": "COMMON.REFRESH" as "COMMON.REFRESH",
        "REGION": "COMMON.REGION" as "COMMON.REGION",
        "RELOAD": "COMMON.RELOAD" as "COMMON.RELOAD",
        "REMOVE": "COMMON.REMOVE" as "COMMON.REMOVE",
        "RENAME": "COMMON.RENAME" as "COMMON.RENAME",
        "RENAME_SOMETHING": "COMMON.RENAME_SOMETHING" as "COMMON.RENAME_SOMETHING",
        "REPLACE_PDF": "COMMON.REPLACE_PDF" as "COMMON.REPLACE_PDF",
        "REQUIRED": "COMMON.REQUIRED" as "COMMON.REQUIRED",
        "REQUIRED_FIELD_HELP": "COMMON.REQUIRED_FIELD_HELP" as "COMMON.REQUIRED_FIELD_HELP",
        "REQUIRED_FIELD_MESSAGE": "COMMON.REQUIRED_FIELD_MESSAGE" as "COMMON.REQUIRED_FIELD_MESSAGE",
        "RETRY": "COMMON.RETRY" as "COMMON.RETRY",
        "REVIEW": "COMMON.REVIEW" as "COMMON.REVIEW",
        "ROLE": "COMMON.ROLE" as "COMMON.ROLE",
        "SAVE": "COMMON.SAVE" as "COMMON.SAVE",
        "SAVE_NEW": "COMMON.SAVE_NEW" as "COMMON.SAVE_NEW",
        "SCHEDULE": "COMMON.SCHEDULE" as "COMMON.SCHEDULE",
        "SCHEDULED": "COMMON.SCHEDULED" as "COMMON.SCHEDULED",
        "SEARCH": "COMMON.SEARCH" as "COMMON.SEARCH",
        "SEARCH_ASSETS": "COMMON.SEARCH_ASSETS" as "COMMON.SEARCH_ASSETS",
        "SEARCH_COLLECTIONS": "COMMON.SEARCH_COLLECTIONS" as "COMMON.SEARCH_COLLECTIONS",
        "SEARCH_EVERYTHING": "COMMON.SEARCH_EVERYTHING" as "COMMON.SEARCH_EVERYTHING",
        "SEARCH_RESULTS": "COMMON.SEARCH_RESULTS" as "COMMON.SEARCH_RESULTS",
        "SEARCH_WITHIN": "COMMON.SEARCH_WITHIN" as "COMMON.SEARCH_WITHIN",
        "SELECTED": "COMMON.SELECTED" as "COMMON.SELECTED",
        "SELECTED_CLIENTS": "COMMON.SELECTED_CLIENTS" as "COMMON.SELECTED_CLIENTS",
        "SELECT_ALL": "COMMON.SELECT_ALL" as "COMMON.SELECT_ALL",
        "SELECT_AN_OPTION": "COMMON.SELECT_AN_OPTION" as "COMMON.SELECT_AN_OPTION",
        "SELECT_A_CLIENT": "COMMON.SELECT_A_CLIENT" as "COMMON.SELECT_A_CLIENT",
        "SELECT_START_AND_END_DATES": "COMMON.SELECT_START_AND_END_DATES" as "COMMON.SELECT_START_AND_END_DATES",
        "SEND": "COMMON.SEND" as "COMMON.SEND",
        "SENDING": "COMMON.SENDING" as "COMMON.SENDING",
        "SEND_QUOTE": "COMMON.SEND_QUOTE" as "COMMON.SEND_QUOTE",
        "SETTINGS": "COMMON.SETTINGS" as "COMMON.SETTINGS",
        "SHIPPING": "COMMON.SHIPPING" as "COMMON.SHIPPING",
        "SHIPPING_FEE": "COMMON.SHIPPING_FEE" as "COMMON.SHIPPING_FEE",
        "SHOW_ALL": "COMMON.SHOW_ALL" as "COMMON.SHOW_ALL",
        "SHOW_LESS": "COMMON.SHOW_LESS" as "COMMON.SHOW_LESS",
        "SKIP": "COMMON.SKIP" as "COMMON.SKIP",
        "SOME_ASSETS": "COMMON.SOME_ASSETS" as "COMMON.SOME_ASSETS",
        "SORT": "COMMON.SORT" as "COMMON.SORT",
        "SORT_BY": "COMMON.SORT_BY" as "COMMON.SORT_BY",
        "SORT_DIRECTION_TIP": "COMMON.SORT_DIRECTION_TIP" as "COMMON.SORT_DIRECTION_TIP",
        "SORT_DIRECTION_TIP_ASC": "COMMON.SORT_DIRECTION_TIP_ASC" as "COMMON.SORT_DIRECTION_TIP_ASC",
        "SORT_DIRECTION_TIP_DESC": "COMMON.SORT_DIRECTION_TIP_DESC" as "COMMON.SORT_DIRECTION_TIP_DESC",
        "START_DATE": "COMMON.START_DATE" as "COMMON.START_DATE",
        "STATUS": "COMMON.STATUS" as "COMMON.STATUS",
        "STEP_N_OF_COUNT": "COMMON.STEP_N_OF_COUNT" as "COMMON.STEP_N_OF_COUNT",
        "SUBJECT": "COMMON.SUBJECT" as "COMMON.SUBJECT",
        "SUBMIT": "COMMON.SUBMIT" as "COMMON.SUBMIT",
        "TAG": "COMMON.TAG" as "COMMON.TAG",
        "TAGS": "COMMON.TAGS" as "COMMON.TAGS",
        "TEMPLATE_CATEGORY": "COMMON.TEMPLATE_CATEGORY" as "COMMON.TEMPLATE_CATEGORY",
        "TERMS_AND_CONDITIONS": "COMMON.TERMS_AND_CONDITIONS" as "COMMON.TERMS_AND_CONDITIONS",
        "TERMS_AND_CONDITIONS_WITH_SYMBOL": "COMMON.TERMS_AND_CONDITIONS_WITH_SYMBOL" as "COMMON.TERMS_AND_CONDITIONS_WITH_SYMBOL",
        "TEXT": "COMMON.TEXT" as "COMMON.TEXT",
        "THIS_DOCUMENT_CANNOT_BE_PREVIEWED": "COMMON.THIS_DOCUMENT_CANNOT_BE_PREVIEWED" as "COMMON.THIS_DOCUMENT_CANNOT_BE_PREVIEWED",
        "THIS_MONTH": "COMMON.THIS_MONTH" as "COMMON.THIS_MONTH",
        "TIMEZONE": "COMMON.TIMEZONE" as "COMMON.TIMEZONE",
        "TIME_PERIOD": {
            "AFTERNOON": "COMMON.TIME_PERIOD.AFTERNOON" as "COMMON.TIME_PERIOD.AFTERNOON",
            "MORNING": "COMMON.TIME_PERIOD.MORNING" as "COMMON.TIME_PERIOD.MORNING"
        },
        "TITLE": "COMMON.TITLE" as "COMMON.TITLE",
        "TITLES": {
            "DR": "COMMON.TITLES.DR" as "COMMON.TITLES.DR",
            "MISS": "COMMON.TITLES.MISS" as "COMMON.TITLES.MISS",
            "MR": "COMMON.TITLES.MR" as "COMMON.TITLES.MR",
            "MRS": "COMMON.TITLES.MRS" as "COMMON.TITLES.MRS",
            "MS": "COMMON.TITLES.MS" as "COMMON.TITLES.MS",
            "PROF": "COMMON.TITLES.PROF" as "COMMON.TITLES.PROF",
            "SIR": "COMMON.TITLES.SIR" as "COMMON.TITLES.SIR"
        },
        "TODAY": "COMMON.TODAY" as "COMMON.TODAY",
        "TOGGLE_NAVIGATION": "COMMON.TOGGLE_NAVIGATION" as "COMMON.TOGGLE_NAVIGATION",
        "TOMORROW": "COMMON.TOMORROW" as "COMMON.TOMORROW",
        "TOOLTIPS": {
            "SELECT_ALL": "COMMON.TOOLTIPS.SELECT_ALL" as "COMMON.TOOLTIPS.SELECT_ALL"
        },
        "TOTAL": "COMMON.TOTAL" as "COMMON.TOTAL",
        "TYPE": "COMMON.TYPE" as "COMMON.TYPE",
        "UNITS": {
            "INCHES": "COMMON.UNITS.INCHES" as "COMMON.UNITS.INCHES",
            "MILLIMETERS": "COMMON.UNITS.MILLIMETERS" as "COMMON.UNITS.MILLIMETERS"
        },
        "UNKNOWN": "COMMON.UNKNOWN" as "COMMON.UNKNOWN",
        "UNPUBLISHED": "COMMON.UNPUBLISHED" as "COMMON.UNPUBLISHED",
        "UNSUPPORTED_IMAGE_FILE_TYPE": "COMMON.UNSUPPORTED_IMAGE_FILE_TYPE" as "COMMON.UNSUPPORTED_IMAGE_FILE_TYPE",
        "UPDATE": "COMMON.UPDATE" as "COMMON.UPDATE",
        "UPDATING": "COMMON.UPDATING" as "COMMON.UPDATING",
        "UPLOAD": "COMMON.UPLOAD" as "COMMON.UPLOAD",
        "UPLOAD_A_FILE": "COMMON.UPLOAD_A_FILE" as "COMMON.UPLOAD_A_FILE",
        "UPLOAD_A_LOGO": "COMMON.UPLOAD_A_LOGO" as "COMMON.UPLOAD_A_LOGO",
        "UPLOAD_A_PDF": "COMMON.UPLOAD_A_PDF" as "COMMON.UPLOAD_A_PDF",
        "UPLOAD_DELETE_CONFIRM": "COMMON.UPLOAD_DELETE_CONFIRM" as "COMMON.UPLOAD_DELETE_CONFIRM",
        "UPLOAD_FILES": "COMMON.UPLOAD_FILES" as "COMMON.UPLOAD_FILES",
        "URL": "COMMON.URL" as "COMMON.URL",
        "USER": "COMMON.USER" as "COMMON.USER",
        "USERNAME": "COMMON.USERNAME" as "COMMON.USERNAME",
        "USERS": "COMMON.USERS" as "COMMON.USERS",
        "USE_DISPLAY_NAME": "COMMON.USE_DISPLAY_NAME" as "COMMON.USE_DISPLAY_NAME",
        "VALIDATION": {
            "INVALID_DATE": "COMMON.VALIDATION.INVALID_DATE" as "COMMON.VALIDATION.INVALID_DATE",
            "INVALID_EMAIL": "COMMON.VALIDATION.INVALID_EMAIL" as "COMMON.VALIDATION.INVALID_EMAIL",
            "MUST_CONFIRM_DETAILS_TO_CONTINUE": "COMMON.VALIDATION.MUST_CONFIRM_DETAILS_TO_CONTINUE" as "COMMON.VALIDATION.MUST_CONFIRM_DETAILS_TO_CONTINUE",
            "REQUIRED": "COMMON.VALIDATION.REQUIRED" as "COMMON.VALIDATION.REQUIRED",
            "STRING_TOO_LONG": "COMMON.VALIDATION.STRING_TOO_LONG" as "COMMON.VALIDATION.STRING_TOO_LONG"
        },
        "VIDEO": "COMMON.VIDEO" as "COMMON.VIDEO",
        "VIEW": "COMMON.VIEW" as "COMMON.VIEW",
        "VIEW_MORE": "COMMON.VIEW_MORE" as "COMMON.VIEW_MORE",
        "VISIBLE_TO_WHICH": "COMMON.VISIBLE_TO_WHICH" as "COMMON.VISIBLE_TO_WHICH",
        "WEB": "COMMON.WEB" as "COMMON.WEB",
        "WIDTH": "COMMON.WIDTH" as "COMMON.WIDTH",
        "YEP": "COMMON.YEP" as "COMMON.YEP",
        "YES": "COMMON.YES" as "COMMON.YES",
        "YESTERDAY": "COMMON.YESTERDAY" as "COMMON.YESTERDAY",
        "YOUR_BROWSER_DOES_NOT_SUPPORT_EMBEDDED_VIDEOS": "COMMON.YOUR_BROWSER_DOES_NOT_SUPPORT_EMBEDDED_VIDEOS" as "COMMON.YOUR_BROWSER_DOES_NOT_SUPPORT_EMBEDDED_VIDEOS",
        "YOU_CURRENTLY_HAVE_NO_COLLECTIONS": "COMMON.YOU_CURRENTLY_HAVE_NO_COLLECTIONS" as "COMMON.YOU_CURRENTLY_HAVE_NO_COLLECTIONS"
    },
    "COMPONENTS": {
        "TOGGLE_COLLAPSE_CHECKBOX": "COMPONENTS.TOGGLE_COLLAPSE_CHECKBOX" as "COMPONENTS.TOGGLE_COLLAPSE_CHECKBOX"
    },
    "DASHBOARD": {
        "BRANDS_DASHBOARD": {
            "MENU_ITEMS": {
                "ACTIVITIES": "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.ACTIVITIES" as "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.ACTIVITIES",
                "AGENCY": "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.AGENCY" as "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.AGENCY",
                "AGENCY_BRANDS": "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.AGENCY_BRANDS" as "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.AGENCY_BRANDS",
                "COMMUNICATE": "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.COMMUNICATE" as "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.COMMUNICATE",
                "COMMUNICATE_SEND": "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.COMMUNICATE_SEND" as "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.COMMUNICATE_SEND",
                "COMMUNICATE_SEND_REPORTS": "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.COMMUNICATE_SEND_REPORTS" as "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.COMMUNICATE_SEND_REPORTS",
                "CONNECTIONS": "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.CONNECTIONS" as "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.CONNECTIONS",
                "CONNECTIONS_PLATFORMS": "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.CONNECTIONS_PLATFORMS" as "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.CONNECTIONS_PLATFORMS",
                "DASHBOARD": "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.DASHBOARD" as "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.DASHBOARD",
                "ENGAGEMENT": "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.ENGAGEMENT" as "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.ENGAGEMENT",
                "ENGAGEMENT_LOCATION_ACTIVITY": "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.ENGAGEMENT_LOCATION_ACTIVITY" as "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.ENGAGEMENT_LOCATION_ACTIVITY",
                "ENGAGEMENT_OVERVIEW": "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.ENGAGEMENT_OVERVIEW" as "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.ENGAGEMENT_OVERVIEW",
                "ENGAGEMENT_REGION_GROUP_ACTIVITY": "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.ENGAGEMENT_REGION_GROUP_ACTIVITY" as "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.ENGAGEMENT_REGION_GROUP_ACTIVITY",
                "ENGAGEMENT_TEMPLATE_USE": "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.ENGAGEMENT_TEMPLATE_USE" as "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.ENGAGEMENT_TEMPLATE_USE",
                "LEARN_MENU": "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.LEARN_MENU" as "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.LEARN_MENU",
                "MANAGE": "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.MANAGE" as "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.MANAGE",
                "MANAGE_HASHTAG_SETS": "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.MANAGE_HASHTAG_SETS" as "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.MANAGE_HASHTAG_SETS",
                "MANAGE_LEARN_MENU": "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.MANAGE_LEARN_MENU" as "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.MANAGE_LEARN_MENU",
                "MANAGE_LOCATIONS": "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.MANAGE_LOCATIONS" as "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.MANAGE_LOCATIONS",
                "MANAGE_REGIONS_GROUPS": "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.MANAGE_REGIONS_GROUPS" as "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.MANAGE_REGIONS_GROUPS",
                "MANAGE_USERS": "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.MANAGE_USERS" as "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.MANAGE_USERS",
                "ROADMAP": "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.ROADMAP" as "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.ROADMAP",
                "STYLE": "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.STYLE" as "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.STYLE",
                "STYLE_COLORS": "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.STYLE_COLORS" as "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.STYLE_COLORS",
                "STYLE_FONTS": "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.STYLE_FONTS" as "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.STYLE_FONTS",
                "STYLE_STYLE_GUIDE": "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.STYLE_STYLE_GUIDE" as "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.STYLE_STYLE_GUIDE",
                "TEMPLATES": "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.TEMPLATES" as "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.TEMPLATES",
                "TEMPLATE_CATEGORIES": "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.TEMPLATE_CATEGORIES" as "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.TEMPLATE_CATEGORIES"
            }
        },
        "BUILT_POSTS": "DASHBOARD.BUILT_POSTS" as "DASHBOARD.BUILT_POSTS",
        "DUE_IN_N_DAYS": "DASHBOARD.DUE_IN_N_DAYS" as "DASHBOARD.DUE_IN_N_DAYS",
        "DUE_IN_N_DAYS_plural": "DASHBOARD.DUE_IN_N_DAYS_plural" as "DASHBOARD.DUE_IN_N_DAYS_plural",
        "DUE_IN_N_WEEKS": "DASHBOARD.DUE_IN_N_WEEKS" as "DASHBOARD.DUE_IN_N_WEEKS",
        "DUE_IN_N_WEEKS_plural": "DASHBOARD.DUE_IN_N_WEEKS_plural" as "DASHBOARD.DUE_IN_N_WEEKS_plural",
        "DUE_TODAY": "DASHBOARD.DUE_TODAY" as "DASHBOARD.DUE_TODAY",
        "DUE_TOMORROW": "DASHBOARD.DUE_TOMORROW" as "DASHBOARD.DUE_TOMORROW",
        "FAILED_TO_SET_YOUR_LOCATION": "DASHBOARD.FAILED_TO_SET_YOUR_LOCATION" as "DASHBOARD.FAILED_TO_SET_YOUR_LOCATION",
        "FETCH_DASHBOARD_DETAILS": "DASHBOARD.FETCH_DASHBOARD_DETAILS" as "DASHBOARD.FETCH_DASHBOARD_DETAILS",
        "FETCH_LATEST_WEBINAR": "DASHBOARD.FETCH_LATEST_WEBINAR" as "DASHBOARD.FETCH_LATEST_WEBINAR",
        "FETCH_UPCOMING_EVENTS": "DASHBOARD.FETCH_UPCOMING_EVENTS" as "DASHBOARD.FETCH_UPCOMING_EVENTS",
        "HERO_MESSAGE": "DASHBOARD.HERO_MESSAGE" as "DASHBOARD.HERO_MESSAGE",
        "HOW_ARE_YOU_TRACKING": "DASHBOARD.HOW_ARE_YOU_TRACKING" as "DASHBOARD.HOW_ARE_YOU_TRACKING",
        "IN_N_WEEKS": "DASHBOARD.IN_N_WEEKS" as "DASHBOARD.IN_N_WEEKS",
        "IN_N_WEEKS_plural": "DASHBOARD.IN_N_WEEKS_plural" as "DASHBOARD.IN_N_WEEKS_plural",
        "LATEST_WEBINAR": {
            "AGENCY_ADVICE_FOR_SHOWING_WEBINAR": "DASHBOARD.LATEST_WEBINAR.AGENCY_ADVICE_FOR_SHOWING_WEBINAR" as "DASHBOARD.LATEST_WEBINAR.AGENCY_ADVICE_FOR_SHOWING_WEBINAR",
            "MORE_WEBINARS": "DASHBOARD.LATEST_WEBINAR.MORE_WEBINARS" as "DASHBOARD.LATEST_WEBINAR.MORE_WEBINARS",
            "WEBINAR": "DASHBOARD.LATEST_WEBINAR.WEBINAR" as "DASHBOARD.LATEST_WEBINAR.WEBINAR"
        },
        "LEARN_MORE": "DASHBOARD.LEARN_MORE" as "DASHBOARD.LEARN_MORE",
        "LOCATION": "DASHBOARD.LOCATION" as "DASHBOARD.LOCATION",
        "NO_UPCOMING_EVENTS": "DASHBOARD.NO_UPCOMING_EVENTS" as "DASHBOARD.NO_UPCOMING_EVENTS",
        "PERFORMANCE_SUMMARY": {
            "AVERAGE_SHORT": "DASHBOARD.PERFORMANCE_SUMMARY.AVERAGE_SHORT" as "DASHBOARD.PERFORMANCE_SUMMARY.AVERAGE_SHORT",
            "CONNECT_APPS_TO_SEE_PERFORMANCE": "DASHBOARD.PERFORMANCE_SUMMARY.CONNECT_APPS_TO_SEE_PERFORMANCE" as "DASHBOARD.PERFORMANCE_SUMMARY.CONNECT_APPS_TO_SEE_PERFORMANCE",
            "DIFFERENCE": "DASHBOARD.PERFORMANCE_SUMMARY.DIFFERENCE" as "DASHBOARD.PERFORMANCE_SUMMARY.DIFFERENCE",
            "FAILED_TO_GET_PERFORMANCE_METRIC": "DASHBOARD.PERFORMANCE_SUMMARY.FAILED_TO_GET_PERFORMANCE_METRIC" as "DASHBOARD.PERFORMANCE_SUMMARY.FAILED_TO_GET_PERFORMANCE_METRIC",
            "FETCH_PERFORMANCE_METRICS": "DASHBOARD.PERFORMANCE_SUMMARY.FETCH_PERFORMANCE_METRICS" as "DASHBOARD.PERFORMANCE_SUMMARY.FETCH_PERFORMANCE_METRICS",
            "FULL_PERFORMANCE_REPORT": "DASHBOARD.PERFORMANCE_SUMMARY.FULL_PERFORMANCE_REPORT" as "DASHBOARD.PERFORMANCE_SUMMARY.FULL_PERFORMANCE_REPORT",
            "INSUFFICIENT_DATA_RECORDED": "DASHBOARD.PERFORMANCE_SUMMARY.INSUFFICIENT_DATA_RECORDED" as "DASHBOARD.PERFORMANCE_SUMMARY.INSUFFICIENT_DATA_RECORDED",
            "INSUFFICIENT_DATA_RECORDED_plural": "DASHBOARD.PERFORMANCE_SUMMARY.INSUFFICIENT_DATA_RECORDED_plural" as "DASHBOARD.PERFORMANCE_SUMMARY.INSUFFICIENT_DATA_RECORDED_plural",
            "METRICS": {
                "ADWORDS_CONVERSIONS": "DASHBOARD.PERFORMANCE_SUMMARY.METRICS.ADWORDS_CONVERSIONS" as "DASHBOARD.PERFORMANCE_SUMMARY.METRICS.ADWORDS_CONVERSIONS",
                "ADWORDS_CONVERSION_VALUE": "DASHBOARD.PERFORMANCE_SUMMARY.METRICS.ADWORDS_CONVERSION_VALUE" as "DASHBOARD.PERFORMANCE_SUMMARY.METRICS.ADWORDS_CONVERSION_VALUE",
                "FACEBOOK_ENGAGEMENT_CLICKS": "DASHBOARD.PERFORMANCE_SUMMARY.METRICS.FACEBOOK_ENGAGEMENT_CLICKS" as "DASHBOARD.PERFORMANCE_SUMMARY.METRICS.FACEBOOK_ENGAGEMENT_CLICKS",
                "FACEBOOK_ENGAGEMENT_REACH": "DASHBOARD.PERFORMANCE_SUMMARY.METRICS.FACEBOOK_ENGAGEMENT_REACH" as "DASHBOARD.PERFORMANCE_SUMMARY.METRICS.FACEBOOK_ENGAGEMENT_REACH",
                "INSTAGRAM_FOLLOWERS": "DASHBOARD.PERFORMANCE_SUMMARY.METRICS.INSTAGRAM_FOLLOWERS" as "DASHBOARD.PERFORMANCE_SUMMARY.METRICS.INSTAGRAM_FOLLOWERS",
                "SPEND": "DASHBOARD.PERFORMANCE_SUMMARY.METRICS.SPEND" as "DASHBOARD.PERFORMANCE_SUMMARY.METRICS.SPEND",
                "TWITTER_LIKES": "DASHBOARD.PERFORMANCE_SUMMARY.METRICS.TWITTER_LIKES" as "DASHBOARD.PERFORMANCE_SUMMARY.METRICS.TWITTER_LIKES"
            },
            "PERFORMANCE_HEADING": "DASHBOARD.PERFORMANCE_SUMMARY.PERFORMANCE_HEADING" as "DASHBOARD.PERFORMANCE_SUMMARY.PERFORMANCE_HEADING",
            "SERVICE_NOT_AUTHORISED": "DASHBOARD.PERFORMANCE_SUMMARY.SERVICE_NOT_AUTHORISED" as "DASHBOARD.PERFORMANCE_SUMMARY.SERVICE_NOT_AUTHORISED"
        },
        "READY_TO_BUILD_THESE": "DASHBOARD.READY_TO_BUILD_THESE" as "DASHBOARD.READY_TO_BUILD_THESE",
        "SUGGESTED_TEMPLATES": {
            "AGENCY_ADVICE_FOR_FEATURING_TEMPLATES": "DASHBOARD.SUGGESTED_TEMPLATES.AGENCY_ADVICE_FOR_FEATURING_TEMPLATES" as "DASHBOARD.SUGGESTED_TEMPLATES.AGENCY_ADVICE_FOR_FEATURING_TEMPLATES",
            "BUILD_AND_SCHEDULE_GALLERY": "DASHBOARD.SUGGESTED_TEMPLATES.BUILD_AND_SCHEDULE_GALLERY" as "DASHBOARD.SUGGESTED_TEMPLATES.BUILD_AND_SCHEDULE_GALLERY",
            "FETCH_SUGGESTED_TEMPLATES": "DASHBOARD.SUGGESTED_TEMPLATES.FETCH_SUGGESTED_TEMPLATES" as "DASHBOARD.SUGGESTED_TEMPLATES.FETCH_SUGGESTED_TEMPLATES",
            "SUGGESTED_TEMPLATES": "DASHBOARD.SUGGESTED_TEMPLATES.SUGGESTED_TEMPLATES" as "DASHBOARD.SUGGESTED_TEMPLATES.SUGGESTED_TEMPLATES"
        },
        "UPCOMING_EVENTS": {
            "PLAN_CALENDAR": "DASHBOARD.UPCOMING_EVENTS.PLAN_CALENDAR" as "DASHBOARD.UPCOMING_EVENTS.PLAN_CALENDAR",
            "UPCOMING": "DASHBOARD.UPCOMING_EVENTS.UPCOMING" as "DASHBOARD.UPCOMING_EVENTS.UPCOMING"
        },
        "UPCOMING_GENERAL_EVENTS": "DASHBOARD.UPCOMING_GENERAL_EVENTS" as "DASHBOARD.UPCOMING_GENERAL_EVENTS",
        "WATCH_VIDEO": "DASHBOARD.WATCH_VIDEO" as "DASHBOARD.WATCH_VIDEO",
        "WELCOME_MESSAGE": "DASHBOARD.WELCOME_MESSAGE" as "DASHBOARD.WELCOME_MESSAGE",
        "WELCOME_PAGE": {
            "DID_YOU_KNOW": "DASHBOARD.WELCOME_PAGE.DID_YOU_KNOW" as "DASHBOARD.WELCOME_PAGE.DID_YOU_KNOW",
            "NUM_COUNTRIES": "DASHBOARD.WELCOME_PAGE.NUM_COUNTRIES" as "DASHBOARD.WELCOME_PAGE.NUM_COUNTRIES",
            "NUM_LOCATIONS": "DASHBOARD.WELCOME_PAGE.NUM_LOCATIONS" as "DASHBOARD.WELCOME_PAGE.NUM_LOCATIONS",
            "WELCOME_BACK": "DASHBOARD.WELCOME_PAGE.WELCOME_BACK" as "DASHBOARD.WELCOME_PAGE.WELCOME_BACK",
            "WHATS_NEW": "DASHBOARD.WELCOME_PAGE.WHATS_NEW" as "DASHBOARD.WELCOME_PAGE.WHATS_NEW"
        }
    },
    "EMAIL": {
        "AUTOMATED_EMAIL_DO_NOT_REPLY": "EMAIL.AUTOMATED_EMAIL_DO_NOT_REPLY" as "EMAIL.AUTOMATED_EMAIL_DO_NOT_REPLY",
        "IF_YOU_WISH_TO_UNSUBSCRIBE": "EMAIL.IF_YOU_WISH_TO_UNSUBSCRIBE" as "EMAIL.IF_YOU_WISH_TO_UNSUBSCRIBE",
        "INVITE_EMAIL": {
            "BUTTON_TEXT": "EMAIL.INVITE_EMAIL.BUTTON_TEXT" as "EMAIL.INVITE_EMAIL.BUTTON_TEXT",
            "DOWNLOAD_THE_APP": "EMAIL.INVITE_EMAIL.DOWNLOAD_THE_APP" as "EMAIL.INVITE_EMAIL.DOWNLOAD_THE_APP",
            "IF_THIS_EMAIL_SHOULD_NOT_HAVE_BEEN_SENT_TO_YOU": "EMAIL.INVITE_EMAIL.IF_THIS_EMAIL_SHOULD_NOT_HAVE_BEEN_SENT_TO_YOU" as "EMAIL.INVITE_EMAIL.IF_THIS_EMAIL_SHOULD_NOT_HAVE_BEEN_SENT_TO_YOU",
            "INSTRUCTIONS": "EMAIL.INVITE_EMAIL.INSTRUCTIONS" as "EMAIL.INVITE_EMAIL.INSTRUCTIONS",
            "SUBJECT": "EMAIL.INVITE_EMAIL.SUBJECT" as "EMAIL.INVITE_EMAIL.SUBJECT",
            "WELCOME": "EMAIL.INVITE_EMAIL.WELCOME" as "EMAIL.INVITE_EMAIL.WELCOME",
            "WHERE_TO_GET_HELP": "EMAIL.INVITE_EMAIL.WHERE_TO_GET_HELP" as "EMAIL.INVITE_EMAIL.WHERE_TO_GET_HELP"
        },
        "LINK_WILL_EXPIRE": "EMAIL.LINK_WILL_EXPIRE" as "EMAIL.LINK_WILL_EXPIRE",
        "LINK_WILL_EXPIRE_HOUR": "EMAIL.LINK_WILL_EXPIRE_HOUR" as "EMAIL.LINK_WILL_EXPIRE_HOUR",
        "LINK_WILL_EXPIRE_HOUR_plural": "EMAIL.LINK_WILL_EXPIRE_HOUR_plural" as "EMAIL.LINK_WILL_EXPIRE_HOUR_plural",
        "LINK_WILL_EXPIRE_plural": "EMAIL.LINK_WILL_EXPIRE_plural" as "EMAIL.LINK_WILL_EXPIRE_plural",
        "LOG_IN_TO_CHANGE_PROFILE_SETTINGS": "EMAIL.LOG_IN_TO_CHANGE_PROFILE_SETTINGS" as "EMAIL.LOG_IN_TO_CHANGE_PROFILE_SETTINGS",
        "LOG_IN_TO_RESPOND": "EMAIL.LOG_IN_TO_RESPOND" as "EMAIL.LOG_IN_TO_RESPOND",
        "LOG_IN_TO_RESPOND_OR_VIEW_ATTACHMENTS": "EMAIL.LOG_IN_TO_RESPOND_OR_VIEW_ATTACHMENTS" as "EMAIL.LOG_IN_TO_RESPOND_OR_VIEW_ATTACHMENTS",
        "SEND_TO_PRINT": {
            "ARTWORK_HAS_BEEN_SENT_TO": "EMAIL.SEND_TO_PRINT.ARTWORK_HAS_BEEN_SENT_TO" as "EMAIL.SEND_TO_PRINT.ARTWORK_HAS_BEEN_SENT_TO",
            "DOWNLOAD_ARTWORK": "EMAIL.SEND_TO_PRINT.DOWNLOAD_ARTWORK" as "EMAIL.SEND_TO_PRINT.DOWNLOAD_ARTWORK",
            "INSTRUCTIONS": "EMAIL.SEND_TO_PRINT.INSTRUCTIONS" as "EMAIL.SEND_TO_PRINT.INSTRUCTIONS",
            "ORDER_NUMBER": "EMAIL.SEND_TO_PRINT.ORDER_NUMBER" as "EMAIL.SEND_TO_PRINT.ORDER_NUMBER",
            "PRINT_PROVIDER_DETAILS": "EMAIL.SEND_TO_PRINT.PRINT_PROVIDER_DETAILS" as "EMAIL.SEND_TO_PRINT.PRINT_PROVIDER_DETAILS",
            "PROVIDER_WILL_BE_IN_TOUCH": "EMAIL.SEND_TO_PRINT.PROVIDER_WILL_BE_IN_TOUCH" as "EMAIL.SEND_TO_PRINT.PROVIDER_WILL_BE_IN_TOUCH",
            "QUANTITY": "EMAIL.SEND_TO_PRINT.QUANTITY" as "EMAIL.SEND_TO_PRINT.QUANTITY",
            "SKU": "EMAIL.SEND_TO_PRINT.SKU" as "EMAIL.SEND_TO_PRINT.SKU",
            "SKUNAME": "EMAIL.SEND_TO_PRINT.SKUNAME" as "EMAIL.SEND_TO_PRINT.SKUNAME",
            "SUBJECT": "EMAIL.SEND_TO_PRINT.SUBJECT" as "EMAIL.SEND_TO_PRINT.SUBJECT",
            "SUBJECT_ORDER_NUMBER": "EMAIL.SEND_TO_PRINT.SUBJECT_ORDER_NUMBER" as "EMAIL.SEND_TO_PRINT.SUBJECT_ORDER_NUMBER",
            "USER_INVOICE_SUBJECT": "EMAIL.SEND_TO_PRINT.USER_INVOICE_SUBJECT" as "EMAIL.SEND_TO_PRINT.USER_INVOICE_SUBJECT"
        }
    },
    "ERRORS": {
        "ASSET_LIBRARY": {
            "ASSETS": {
                "FETCH_FAILED": "ERRORS.ASSET_LIBRARY.ASSETS.FETCH_FAILED" as "ERRORS.ASSET_LIBRARY.ASSETS.FETCH_FAILED"
            },
            "COLLECTIONS": {
                "FETCH_FAILED": "ERRORS.ASSET_LIBRARY.COLLECTIONS.FETCH_FAILED" as "ERRORS.ASSET_LIBRARY.COLLECTIONS.FETCH_FAILED"
            }
        },
        "BAD_REQUEST_ERRORS": {
            "BILLING_DETAILS_UPDATE_ALREADY_FINALISED": "ERRORS.BAD_REQUEST_ERRORS.BILLING_DETAILS_UPDATE_ALREADY_FINALISED" as "ERRORS.BAD_REQUEST_ERRORS.BILLING_DETAILS_UPDATE_ALREADY_FINALISED",
            "BILLING_DETAILS_UPDATE_ALREADY_RECEIVED": "ERRORS.BAD_REQUEST_ERRORS.BILLING_DETAILS_UPDATE_ALREADY_RECEIVED" as "ERRORS.BAD_REQUEST_ERRORS.BILLING_DETAILS_UPDATE_ALREADY_RECEIVED",
            "CANNOT_CHANGE_COLLECTION_TYPE": "ERRORS.BAD_REQUEST_ERRORS.CANNOT_CHANGE_COLLECTION_TYPE" as "ERRORS.BAD_REQUEST_ERRORS.CANNOT_CHANGE_COLLECTION_TYPE",
            "CANNOT_CREATE_PRIVATE_COMMENT": "ERRORS.BAD_REQUEST_ERRORS.CANNOT_CREATE_PRIVATE_COMMENT" as "ERRORS.BAD_REQUEST_ERRORS.CANNOT_CREATE_PRIVATE_COMMENT",
            "CANNOT_LINK_ACCESS_TOKEN": "ERRORS.BAD_REQUEST_ERRORS.CANNOT_LINK_ACCESS_TOKEN" as "ERRORS.BAD_REQUEST_ERRORS.CANNOT_LINK_ACCESS_TOKEN",
            "CANNOT_OVERRIDE_CUSTOM_FONT_FILE": "ERRORS.BAD_REQUEST_ERRORS.CANNOT_OVERRIDE_CUSTOM_FONT_FILE" as "ERRORS.BAD_REQUEST_ERRORS.CANNOT_OVERRIDE_CUSTOM_FONT_FILE",
            "CLIENT_DOES_NOT_EXIST": "ERRORS.BAD_REQUEST_ERRORS.CLIENT_DOES_NOT_EXIST" as "ERRORS.BAD_REQUEST_ERRORS.CLIENT_DOES_NOT_EXIST",
            "CLIENT_IDS_DO_NOT_MATCH": "ERRORS.BAD_REQUEST_ERRORS.CLIENT_IDS_DO_NOT_MATCH" as "ERRORS.BAD_REQUEST_ERRORS.CLIENT_IDS_DO_NOT_MATCH",
            "END_DATE_MUST_BE_BEFORE_START_DATE_OR_ABSENT": "ERRORS.BAD_REQUEST_ERRORS.END_DATE_MUST_BE_BEFORE_START_DATE_OR_ABSENT" as "ERRORS.BAD_REQUEST_ERRORS.END_DATE_MUST_BE_BEFORE_START_DATE_OR_ABSENT",
            "FACEBOOK_MARKETING_AD_ACCOUNT_INVALID_CRITERIA": "ERRORS.BAD_REQUEST_ERRORS.FACEBOOK_MARKETING_AD_ACCOUNT_INVALID_CRITERIA" as "ERRORS.BAD_REQUEST_ERRORS.FACEBOOK_MARKETING_AD_ACCOUNT_INVALID_CRITERIA",
            "FILE_NAME_CANNOT_START_WITH_PIPE": "ERRORS.BAD_REQUEST_ERRORS.FILE_NAME_CANNOT_START_WITH_PIPE" as "ERRORS.BAD_REQUEST_ERRORS.FILE_NAME_CANNOT_START_WITH_PIPE",
            "INVALID_DOCUMENT": "ERRORS.BAD_REQUEST_ERRORS.INVALID_DOCUMENT" as "ERRORS.BAD_REQUEST_ERRORS.INVALID_DOCUMENT",
            "INVALID_ID": "ERRORS.BAD_REQUEST_ERRORS.INVALID_ID" as "ERRORS.BAD_REQUEST_ERRORS.INVALID_ID",
            "INVALID_SESSION": "ERRORS.BAD_REQUEST_ERRORS.INVALID_SESSION" as "ERRORS.BAD_REQUEST_ERRORS.INVALID_SESSION",
            "INVALID_URL_TO_SIGN": "ERRORS.BAD_REQUEST_ERRORS.INVALID_URL_TO_SIGN" as "ERRORS.BAD_REQUEST_ERRORS.INVALID_URL_TO_SIGN",
            "LOCATION_ALREADY_SIGNED_UP": "ERRORS.BAD_REQUEST_ERRORS.LOCATION_ALREADY_SIGNED_UP" as "ERRORS.BAD_REQUEST_ERRORS.LOCATION_ALREADY_SIGNED_UP",
            "LOCATION_SUBSCRIPTION_EXPIRED": "ERRORS.BAD_REQUEST_ERRORS.LOCATION_SUBSCRIPTION_EXPIRED" as "ERRORS.BAD_REQUEST_ERRORS.LOCATION_SUBSCRIPTION_EXPIRED",
            "OPERATION_RESTRICTED_TO_SELF": "ERRORS.BAD_REQUEST_ERRORS.OPERATION_RESTRICTED_TO_SELF" as "ERRORS.BAD_REQUEST_ERRORS.OPERATION_RESTRICTED_TO_SELF",
            "PAYMENT_ALREADY_FINALISED": "ERRORS.BAD_REQUEST_ERRORS.PAYMENT_ALREADY_FINALISED" as "ERRORS.BAD_REQUEST_ERRORS.PAYMENT_ALREADY_FINALISED",
            "PLANNER_ACTION_DATE_BELOW_THRESHOLD": "ERRORS.BAD_REQUEST_ERRORS.PLANNER_ACTION_DATE_BELOW_THRESHOLD" as "ERRORS.BAD_REQUEST_ERRORS.PLANNER_ACTION_DATE_BELOW_THRESHOLD",
            "PLANNER_ACTION_DATE_BELOW_THRESHOLD_plural": "ERRORS.BAD_REQUEST_ERRORS.PLANNER_ACTION_DATE_BELOW_THRESHOLD_plural" as "ERRORS.BAD_REQUEST_ERRORS.PLANNER_ACTION_DATE_BELOW_THRESHOLD_plural",
            "PLANNER_CANNOT_SPECIFY_ALL_OR_FUTURE": "ERRORS.BAD_REQUEST_ERRORS.PLANNER_CANNOT_SPECIFY_ALL_OR_FUTURE" as "ERRORS.BAD_REQUEST_ERRORS.PLANNER_CANNOT_SPECIFY_ALL_OR_FUTURE",
            "RECURRING_PAYMENT_CANNOT_BE_DELETED": "ERRORS.BAD_REQUEST_ERRORS.RECURRING_PAYMENT_CANNOT_BE_DELETED" as "ERRORS.BAD_REQUEST_ERRORS.RECURRING_PAYMENT_CANNOT_BE_DELETED",
            "RECURRING_PAYMENT_DATES_OVERLAP_WITH_EXISTING": "ERRORS.BAD_REQUEST_ERRORS.RECURRING_PAYMENT_DATES_OVERLAP_WITH_EXISTING" as "ERRORS.BAD_REQUEST_ERRORS.RECURRING_PAYMENT_DATES_OVERLAP_WITH_EXISTING",
            "RECURRING_PAYMENT_LAST_CANNOT_BE_DELETED": "ERRORS.BAD_REQUEST_ERRORS.RECURRING_PAYMENT_LAST_CANNOT_BE_DELETED" as "ERRORS.BAD_REQUEST_ERRORS.RECURRING_PAYMENT_LAST_CANNOT_BE_DELETED",
            "REPORT_SUMMARY_ID_INVALID": "ERRORS.BAD_REQUEST_ERRORS.REPORT_SUMMARY_ID_INVALID" as "ERRORS.BAD_REQUEST_ERRORS.REPORT_SUMMARY_ID_INVALID",
            "REQUEST_RETURNED_NO_RESPONSE_DATA": "ERRORS.BAD_REQUEST_ERRORS.REQUEST_RETURNED_NO_RESPONSE_DATA" as "ERRORS.BAD_REQUEST_ERRORS.REQUEST_RETURNED_NO_RESPONSE_DATA",
            "SCHEDULED_DATE_CANNOT_BE_MORE_THAN_ONE_YEAR_IN_THE_FUTURE": "ERRORS.BAD_REQUEST_ERRORS.SCHEDULED_DATE_CANNOT_BE_MORE_THAN_ONE_YEAR_IN_THE_FUTURE" as "ERRORS.BAD_REQUEST_ERRORS.SCHEDULED_DATE_CANNOT_BE_MORE_THAN_ONE_YEAR_IN_THE_FUTURE",
            "SEND_TO_FOUR51_MISSING_DATA": "ERRORS.BAD_REQUEST_ERRORS.SEND_TO_FOUR51_MISSING_DATA" as "ERRORS.BAD_REQUEST_ERRORS.SEND_TO_FOUR51_MISSING_DATA",
            "SKU_HAS_BOTH_PRICE_AND_QUANTITY_OPTIONS": "ERRORS.BAD_REQUEST_ERRORS.SKU_HAS_BOTH_PRICE_AND_QUANTITY_OPTIONS" as "ERRORS.BAD_REQUEST_ERRORS.SKU_HAS_BOTH_PRICE_AND_QUANTITY_OPTIONS",
            "SKU_HAS_NO_PRICING_DATA": "ERRORS.BAD_REQUEST_ERRORS.SKU_HAS_NO_PRICING_DATA" as "ERRORS.BAD_REQUEST_ERRORS.SKU_HAS_NO_PRICING_DATA",
            "SPECIAL_REQUEST_INVALID_DATE": "ERRORS.BAD_REQUEST_ERRORS.SPECIAL_REQUEST_INVALID_DATE" as "ERRORS.BAD_REQUEST_ERRORS.SPECIAL_REQUEST_INVALID_DATE",
            "USER_BELONGS_TO_MULTIPLE_AGENCIES": "ERRORS.BAD_REQUEST_ERRORS.USER_BELONGS_TO_MULTIPLE_AGENCIES" as "ERRORS.BAD_REQUEST_ERRORS.USER_BELONGS_TO_MULTIPLE_AGENCIES",
            "USER_NOT_FOUND": "ERRORS.BAD_REQUEST_ERRORS.USER_NOT_FOUND" as "ERRORS.BAD_REQUEST_ERRORS.USER_NOT_FOUND",
            "VALIDATION_ERROR": "ERRORS.BAD_REQUEST_ERRORS.VALIDATION_ERROR" as "ERRORS.BAD_REQUEST_ERRORS.VALIDATION_ERROR",
            "VIDEO_ID_NOT_FOUND": "ERRORS.BAD_REQUEST_ERRORS.VIDEO_ID_NOT_FOUND" as "ERRORS.BAD_REQUEST_ERRORS.VIDEO_ID_NOT_FOUND"
        },
        "BRAND": {
            "BRAND_COLOURS": {
                "ERROR_ADDING_BRAND_COLOUR": "ERRORS.BRAND.BRAND_COLOURS.ERROR_ADDING_BRAND_COLOUR" as "ERRORS.BRAND.BRAND_COLOURS.ERROR_ADDING_BRAND_COLOUR",
                "ERROR_DELETING_BRAND_COLOUR": "ERRORS.BRAND.BRAND_COLOURS.ERROR_DELETING_BRAND_COLOUR" as "ERRORS.BRAND.BRAND_COLOURS.ERROR_DELETING_BRAND_COLOUR",
                "ERROR_RENAMING_BRAND_COLOUR": "ERRORS.BRAND.BRAND_COLOURS.ERROR_RENAMING_BRAND_COLOUR" as "ERRORS.BRAND.BRAND_COLOURS.ERROR_RENAMING_BRAND_COLOUR",
                "ERROR_UPDATING_BRAND_COLOUR": "ERRORS.BRAND.BRAND_COLOURS.ERROR_UPDATING_BRAND_COLOUR" as "ERRORS.BRAND.BRAND_COLOURS.ERROR_UPDATING_BRAND_COLOUR",
                "ERROR_UPDATING_BRAND_COLOUR_ORDER": "ERRORS.BRAND.BRAND_COLOURS.ERROR_UPDATING_BRAND_COLOUR_ORDER" as "ERRORS.BRAND.BRAND_COLOURS.ERROR_UPDATING_BRAND_COLOUR_ORDER"
            },
            "LOCATION_CATEGORIES": {
                "CATEGORY_LABEL_REQUIRED": "ERRORS.BRAND.LOCATION_CATEGORIES.CATEGORY_LABEL_REQUIRED" as "ERRORS.BRAND.LOCATION_CATEGORIES.CATEGORY_LABEL_REQUIRED",
                "ERROR_ADDING_LOCATION_CATEGORY": "ERRORS.BRAND.LOCATION_CATEGORIES.ERROR_ADDING_LOCATION_CATEGORY" as "ERRORS.BRAND.LOCATION_CATEGORIES.ERROR_ADDING_LOCATION_CATEGORY",
                "ERROR_DELETING_LOCATION_CATEGORY": "ERRORS.BRAND.LOCATION_CATEGORIES.ERROR_DELETING_LOCATION_CATEGORY" as "ERRORS.BRAND.LOCATION_CATEGORIES.ERROR_DELETING_LOCATION_CATEGORY",
                "ERROR_RENAMING_LOCATION_CATEGORY": "ERRORS.BRAND.LOCATION_CATEGORIES.ERROR_RENAMING_LOCATION_CATEGORY" as "ERRORS.BRAND.LOCATION_CATEGORIES.ERROR_RENAMING_LOCATION_CATEGORY",
                "ERROR_UPDATING_LOCATIONS_FOR_CATEGORY": "ERRORS.BRAND.LOCATION_CATEGORIES.ERROR_UPDATING_LOCATIONS_FOR_CATEGORY" as "ERRORS.BRAND.LOCATION_CATEGORIES.ERROR_UPDATING_LOCATIONS_FOR_CATEGORY"
            },
            "NO_CLIENT_SELECTED": "ERRORS.BRAND.NO_CLIENT_SELECTED" as "ERRORS.BRAND.NO_CLIENT_SELECTED"
        },
        "EXCEPTION_ID": "ERRORS.EXCEPTION_ID" as "ERRORS.EXCEPTION_ID",
        "EXTERNAL_SERVICE_ERRORS": {
            "ACR_CLOUD": "ERRORS.EXTERNAL_SERVICE_ERRORS.ACR_CLOUD" as "ERRORS.EXTERNAL_SERVICE_ERRORS.ACR_CLOUD",
            "ACR_CLOUD_EMPTY_RESPONSE": "ERRORS.EXTERNAL_SERVICE_ERRORS.ACR_CLOUD_EMPTY_RESPONSE" as "ERRORS.EXTERNAL_SERVICE_ERRORS.ACR_CLOUD_EMPTY_RESPONSE",
            "EMAIL_FAILURE": "ERRORS.EXTERNAL_SERVICE_ERRORS.EMAIL_FAILURE" as "ERRORS.EXTERNAL_SERVICE_ERRORS.EMAIL_FAILURE",
            "EWAY_ERROR": "ERRORS.EXTERNAL_SERVICE_ERRORS.EWAY_ERROR" as "ERRORS.EXTERNAL_SERVICE_ERRORS.EWAY_ERROR",
            "FITWARE_ERROR": "ERRORS.EXTERNAL_SERVICE_ERRORS.FITWARE_ERROR" as "ERRORS.EXTERNAL_SERVICE_ERRORS.FITWARE_ERROR",
            "FITWARE_UNRECOGNISED_RESPONSE": "ERRORS.EXTERNAL_SERVICE_ERRORS.FITWARE_UNRECOGNISED_RESPONSE" as "ERRORS.EXTERNAL_SERVICE_ERRORS.FITWARE_UNRECOGNISED_RESPONSE",
            "PASSTHROUGH": "ERRORS.EXTERNAL_SERVICE_ERRORS.PASSTHROUGH" as "ERRORS.EXTERNAL_SERVICE_ERRORS.PASSTHROUGH",
            "TWITTER_ERROR": "ERRORS.EXTERNAL_SERVICE_ERRORS.TWITTER_ERROR" as "ERRORS.EXTERNAL_SERVICE_ERRORS.TWITTER_ERROR",
            "TWITTER_UNKNOWN_ERROR": "ERRORS.EXTERNAL_SERVICE_ERRORS.TWITTER_UNKNOWN_ERROR" as "ERRORS.EXTERNAL_SERVICE_ERRORS.TWITTER_UNKNOWN_ERROR"
        },
        "FACEBOOK_ERRORS": {
            "MAX_CHARACTER_LIMIT_FOR_CAPTION_REACHED": "ERRORS.FACEBOOK_ERRORS.MAX_CHARACTER_LIMIT_FOR_CAPTION_REACHED" as "ERRORS.FACEBOOK_ERRORS.MAX_CHARACTER_LIMIT_FOR_CAPTION_REACHED",
            "MISSING_FIRST_COMMENT_HASHTAGS_PERMISSION": "ERRORS.FACEBOOK_ERRORS.MISSING_FIRST_COMMENT_HASHTAGS_PERMISSION" as "ERRORS.FACEBOOK_ERRORS.MISSING_FIRST_COMMENT_HASHTAGS_PERMISSION",
            "SOME_LOCATIONS_ARE_MISSING_FIRST_COMMENT_HASHTAGS_PERMISSION": "ERRORS.FACEBOOK_ERRORS.SOME_LOCATIONS_ARE_MISSING_FIRST_COMMENT_HASHTAGS_PERMISSION" as "ERRORS.FACEBOOK_ERRORS.SOME_LOCATIONS_ARE_MISSING_FIRST_COMMENT_HASHTAGS_PERMISSION",
            "UNTRANSLATED_ERROR_MESSAGE": "ERRORS.FACEBOOK_ERRORS.UNTRANSLATED_ERROR_MESSAGE" as "ERRORS.FACEBOOK_ERRORS.UNTRANSLATED_ERROR_MESSAGE"
        },
        "FACEBOOK_MARKETING_ERRORS": {
            "PERMISSIONS_NOT_GRANTED": "ERRORS.FACEBOOK_MARKETING_ERRORS.PERMISSIONS_NOT_GRANTED" as "ERRORS.FACEBOOK_MARKETING_ERRORS.PERMISSIONS_NOT_GRANTED"
        },
        "FINALISE_BILLING_DETAILS_UPDATE_ERROR": "ERRORS.FINALISE_BILLING_DETAILS_UPDATE_ERROR" as "ERRORS.FINALISE_BILLING_DETAILS_UPDATE_ERROR",
        "FITWARE_MEMBER_ENGAGER": {
            "UNRECOGNISED_RESPONSE": "ERRORS.FITWARE_MEMBER_ENGAGER.UNRECOGNISED_RESPONSE" as "ERRORS.FITWARE_MEMBER_ENGAGER.UNRECOGNISED_RESPONSE",
            "UNTRANSLATED_ERROR_MESSAGE": "ERRORS.FITWARE_MEMBER_ENGAGER.UNTRANSLATED_ERROR_MESSAGE" as "ERRORS.FITWARE_MEMBER_ENGAGER.UNTRANSLATED_ERROR_MESSAGE"
        },
        "FORBIDDEN_ERRORS": {
            "ACCESS_FORBIDDEN": "ERRORS.FORBIDDEN_ERRORS.ACCESS_FORBIDDEN" as "ERRORS.FORBIDDEN_ERRORS.ACCESS_FORBIDDEN",
            "CANNOT_ACCESS_CLIENT": "ERRORS.FORBIDDEN_ERRORS.CANNOT_ACCESS_CLIENT" as "ERRORS.FORBIDDEN_ERRORS.CANNOT_ACCESS_CLIENT",
            "CANNOT_ACCESS_LOCATION": "ERRORS.FORBIDDEN_ERRORS.CANNOT_ACCESS_LOCATION" as "ERRORS.FORBIDDEN_ERRORS.CANNOT_ACCESS_LOCATION",
            "NO_PERMISSION_TO_VIEW_CLIENT": "ERRORS.FORBIDDEN_ERRORS.NO_PERMISSION_TO_VIEW_CLIENT" as "ERRORS.FORBIDDEN_ERRORS.NO_PERMISSION_TO_VIEW_CLIENT",
            "TRY_THIS_MUST_BE_ASSIGNED_TO_A_CLIENT": "ERRORS.FORBIDDEN_ERRORS.TRY_THIS_MUST_BE_ASSIGNED_TO_A_CLIENT" as "ERRORS.FORBIDDEN_ERRORS.TRY_THIS_MUST_BE_ASSIGNED_TO_A_CLIENT"
        },
        "FOUR51": {
            "INVALID_QUANTITY": "ERRORS.FOUR51.INVALID_QUANTITY" as "ERRORS.FOUR51.INVALID_QUANTITY",
            "INVALID_USERNAME_OR_PASSWORD": "ERRORS.FOUR51.INVALID_USERNAME_OR_PASSWORD" as "ERRORS.FOUR51.INVALID_USERNAME_OR_PASSWORD",
            "PRODUCT_MISCONFIGURED": "ERRORS.FOUR51.PRODUCT_MISCONFIGURED" as "ERRORS.FOUR51.PRODUCT_MISCONFIGURED",
            "UNRECOGNISED_RESPONSE": "ERRORS.FOUR51.UNRECOGNISED_RESPONSE" as "ERRORS.FOUR51.UNRECOGNISED_RESPONSE",
            "UNTRANSLATED_ERROR_MESSAGE": "ERRORS.FOUR51.UNTRANSLATED_ERROR_MESSAGE" as "ERRORS.FOUR51.UNTRANSLATED_ERROR_MESSAGE"
        },
        "GENERATE_MAP_ERRORS": {
            "FAILED": "ERRORS.GENERATE_MAP_ERRORS.FAILED" as "ERRORS.GENERATE_MAP_ERRORS.FAILED",
            "MAP_ALREADY_EXISTS": "ERRORS.GENERATE_MAP_ERRORS.MAP_ALREADY_EXISTS" as "ERRORS.GENERATE_MAP_ERRORS.MAP_ALREADY_EXISTS",
            "NO_MAP_FOR_LOCATION": "ERRORS.GENERATE_MAP_ERRORS.NO_MAP_FOR_LOCATION" as "ERRORS.GENERATE_MAP_ERRORS.NO_MAP_FOR_LOCATION",
            "PAYMENT_FAILED": "ERRORS.GENERATE_MAP_ERRORS.PAYMENT_FAILED" as "ERRORS.GENERATE_MAP_ERRORS.PAYMENT_FAILED"
        },
        "GENERIC": "ERRORS.GENERIC" as "ERRORS.GENERIC",
        "GOOGLE_ADS": {
            "PERMISSIONS": "ERRORS.GOOGLE_ADS.PERMISSIONS" as "ERRORS.GOOGLE_ADS.PERMISSIONS",
            "PERMISSIONS_LOCATION_REPORT": "ERRORS.GOOGLE_ADS.PERMISSIONS_LOCATION_REPORT" as "ERRORS.GOOGLE_ADS.PERMISSIONS_LOCATION_REPORT",
            "UNKNOWN": "ERRORS.GOOGLE_ADS.UNKNOWN" as "ERRORS.GOOGLE_ADS.UNKNOWN"
        },
        "GOOGLE_ANALYTICS": {
            "DATA_PARSE_ERROR": "ERRORS.GOOGLE_ANALYTICS.DATA_PARSE_ERROR" as "ERRORS.GOOGLE_ANALYTICS.DATA_PARSE_ERROR",
            "DATA_RESPONSE_ERROR": "ERRORS.GOOGLE_ANALYTICS.DATA_RESPONSE_ERROR" as "ERRORS.GOOGLE_ANALYTICS.DATA_RESPONSE_ERROR",
            "PERMISSIONS": "ERRORS.GOOGLE_ANALYTICS.PERMISSIONS" as "ERRORS.GOOGLE_ANALYTICS.PERMISSIONS"
        },
        "GOOGLE_MY_BUSINESS": {
            "FAILED_TO_POST": "ERRORS.GOOGLE_MY_BUSINESS.FAILED_TO_POST" as "ERRORS.GOOGLE_MY_BUSINESS.FAILED_TO_POST",
            "FAILED_TO_RETRIEVE_LOCATION_NAME": "ERRORS.GOOGLE_MY_BUSINESS.FAILED_TO_RETRIEVE_LOCATION_NAME" as "ERRORS.GOOGLE_MY_BUSINESS.FAILED_TO_RETRIEVE_LOCATION_NAME",
            "SERVICE_NOT_CONFIGURED": "ERRORS.GOOGLE_MY_BUSINESS.SERVICE_NOT_CONFIGURED" as "ERRORS.GOOGLE_MY_BUSINESS.SERVICE_NOT_CONFIGURED"
        },
        "GOOGLE_OAUTH_ERRORS": {
            "INVALID_GRANT": "ERRORS.GOOGLE_OAUTH_ERRORS.INVALID_GRANT" as "ERRORS.GOOGLE_OAUTH_ERRORS.INVALID_GRANT"
        },
        "INSTAGRAM_ERRORS": {
            "API_RATE_LIMITED": "ERRORS.INSTAGRAM_ERRORS.API_RATE_LIMITED" as "ERRORS.INSTAGRAM_ERRORS.API_RATE_LIMITED",
            "API_RATE_LIMITED_CONTINUE_POSTING": "ERRORS.INSTAGRAM_ERRORS.API_RATE_LIMITED_CONTINUE_POSTING" as "ERRORS.INSTAGRAM_ERRORS.API_RATE_LIMITED_CONTINUE_POSTING",
            "API_RATE_LIMIT_NOT_FOUND": "ERRORS.INSTAGRAM_ERRORS.API_RATE_LIMIT_NOT_FOUND" as "ERRORS.INSTAGRAM_ERRORS.API_RATE_LIMIT_NOT_FOUND",
            "FAILED_TO_POST": "ERRORS.INSTAGRAM_ERRORS.FAILED_TO_POST" as "ERRORS.INSTAGRAM_ERRORS.FAILED_TO_POST",
            "MAX_CHARACTER_LIMIT_FOR_CAPTION_REACHED": "ERRORS.INSTAGRAM_ERRORS.MAX_CHARACTER_LIMIT_FOR_CAPTION_REACHED" as "ERRORS.INSTAGRAM_ERRORS.MAX_CHARACTER_LIMIT_FOR_CAPTION_REACHED",
            "MISSING_FIRST_COMMENT_HASHTAGS_PERMISSION": "ERRORS.INSTAGRAM_ERRORS.MISSING_FIRST_COMMENT_HASHTAGS_PERMISSION" as "ERRORS.INSTAGRAM_ERRORS.MISSING_FIRST_COMMENT_HASHTAGS_PERMISSION",
            "SOME_LOCATIONS_ARE_MISSING_FIRST_COMMENT_HASHTAGS_PERMISSION": "ERRORS.INSTAGRAM_ERRORS.SOME_LOCATIONS_ARE_MISSING_FIRST_COMMENT_HASHTAGS_PERMISSION" as "ERRORS.INSTAGRAM_ERRORS.SOME_LOCATIONS_ARE_MISSING_FIRST_COMMENT_HASHTAGS_PERMISSION",
            "UNTRANSLATED_ERROR_MESSAGE": "ERRORS.INSTAGRAM_ERRORS.UNTRANSLATED_ERROR_MESSAGE" as "ERRORS.INSTAGRAM_ERRORS.UNTRANSLATED_ERROR_MESSAGE"
        },
        "INVALID_INPUT_ERRORS": {
            "BASE64_STRING_MISSING_MIME_TYPE": "ERRORS.INVALID_INPUT_ERRORS.BASE64_STRING_MISSING_MIME_TYPE" as "ERRORS.INVALID_INPUT_ERRORS.BASE64_STRING_MISSING_MIME_TYPE",
            "COLOUR": "ERRORS.INVALID_INPUT_ERRORS.COLOUR" as "ERRORS.INVALID_INPUT_ERRORS.COLOUR",
            "EWAY_MULTIPLE_PAYMENT_TRANSACTIONS": "ERRORS.INVALID_INPUT_ERRORS.EWAY_MULTIPLE_PAYMENT_TRANSACTIONS" as "ERRORS.INVALID_INPUT_ERRORS.EWAY_MULTIPLE_PAYMENT_TRANSACTIONS",
            "EWAY_MULTIPLE_TOKENISATION_TRANSACTIONS": "ERRORS.INVALID_INPUT_ERRORS.EWAY_MULTIPLE_TOKENISATION_TRANSACTIONS" as "ERRORS.INVALID_INPUT_ERRORS.EWAY_MULTIPLE_TOKENISATION_TRANSACTIONS",
            "EWAY_MULTIPLE_TRANSACTIONS": "ERRORS.INVALID_INPUT_ERRORS.EWAY_MULTIPLE_TRANSACTIONS" as "ERRORS.INVALID_INPUT_ERRORS.EWAY_MULTIPLE_TRANSACTIONS",
            "EWAY_ZERO_PAYMENT_TRANSACTIONS": "ERRORS.INVALID_INPUT_ERRORS.EWAY_ZERO_PAYMENT_TRANSACTIONS" as "ERRORS.INVALID_INPUT_ERRORS.EWAY_ZERO_PAYMENT_TRANSACTIONS",
            "EWAY_ZERO_TRANSACTIONS": "ERRORS.INVALID_INPUT_ERRORS.EWAY_ZERO_TRANSACTIONS" as "ERRORS.INVALID_INPUT_ERRORS.EWAY_ZERO_TRANSACTIONS",
            "FACEBOOK_PAGE_ID_MIGRATION": "ERRORS.INVALID_INPUT_ERRORS.FACEBOOK_PAGE_ID_MIGRATION" as "ERRORS.INVALID_INPUT_ERRORS.FACEBOOK_PAGE_ID_MIGRATION",
            "FILE_TOO_LARGE": "ERRORS.INVALID_INPUT_ERRORS.FILE_TOO_LARGE" as "ERRORS.INVALID_INPUT_ERRORS.FILE_TOO_LARGE",
            "GRAPHQL_INPUT": "ERRORS.INVALID_INPUT_ERRORS.GRAPHQL_INPUT" as "ERRORS.INVALID_INPUT_ERRORS.GRAPHQL_INPUT",
            "INVALID_URL": "ERRORS.INVALID_INPUT_ERRORS.INVALID_URL" as "ERRORS.INVALID_INPUT_ERRORS.INVALID_URL",
            "MISSING_FILE": "ERRORS.INVALID_INPUT_ERRORS.MISSING_FILE" as "ERRORS.INVALID_INPUT_ERRORS.MISSING_FILE",
            "REPOSITORY_HAS_NULL_MODEL": "ERRORS.INVALID_INPUT_ERRORS.REPOSITORY_HAS_NULL_MODEL" as "ERRORS.INVALID_INPUT_ERRORS.REPOSITORY_HAS_NULL_MODEL",
            "UPLOAD_ID_MISSING": "ERRORS.INVALID_INPUT_ERRORS.UPLOAD_ID_MISSING" as "ERRORS.INVALID_INPUT_ERRORS.UPLOAD_ID_MISSING",
            "ZERO_WIDTH_OR_HEIGHT_VIDEO": "ERRORS.INVALID_INPUT_ERRORS.ZERO_WIDTH_OR_HEIGHT_VIDEO" as "ERRORS.INVALID_INPUT_ERRORS.ZERO_WIDTH_OR_HEIGHT_VIDEO"
        },
        "LINKEDIN": {
            "FAILED_TO_POST": "ERRORS.LINKEDIN.FAILED_TO_POST" as "ERRORS.LINKEDIN.FAILED_TO_POST",
            "INVALID_GRANT": "ERRORS.LINKEDIN.INVALID_GRANT" as "ERRORS.LINKEDIN.INVALID_GRANT",
            "SERVICE_NOT_CONFIGURED": "ERRORS.LINKEDIN.SERVICE_NOT_CONFIGURED" as "ERRORS.LINKEDIN.SERVICE_NOT_CONFIGURED"
        },
        "LOCATION_DRAFT": {
            "CANNOT_SAVE_LOCATION_REVISION_WITHOUT_A_TITLE": "ERRORS.LOCATION_DRAFT.CANNOT_SAVE_LOCATION_REVISION_WITHOUT_A_TITLE" as "ERRORS.LOCATION_DRAFT.CANNOT_SAVE_LOCATION_REVISION_WITHOUT_A_TITLE",
            "FAILED_TO_SAVE": "ERRORS.LOCATION_DRAFT.FAILED_TO_SAVE" as "ERRORS.LOCATION_DRAFT.FAILED_TO_SAVE"
        },
        "LOGIN_TOKEN_ERRORS": {
            "API_KEY_INVALID": "ERRORS.LOGIN_TOKEN_ERRORS.API_KEY_INVALID" as "ERRORS.LOGIN_TOKEN_ERRORS.API_KEY_INVALID",
            "API_KEY_MISSING": "ERRORS.LOGIN_TOKEN_ERRORS.API_KEY_MISSING" as "ERRORS.LOGIN_TOKEN_ERRORS.API_KEY_MISSING",
            "TOKEN_KEYS_MISMATCH": "ERRORS.LOGIN_TOKEN_ERRORS.TOKEN_KEYS_MISMATCH" as "ERRORS.LOGIN_TOKEN_ERRORS.TOKEN_KEYS_MISMATCH",
            "TOKEN_REFERENCE_NOT_FOUND": "ERRORS.LOGIN_TOKEN_ERRORS.TOKEN_REFERENCE_NOT_FOUND" as "ERRORS.LOGIN_TOKEN_ERRORS.TOKEN_REFERENCE_NOT_FOUND",
            "USERNAME_NOT_SPECIFIED": "ERRORS.LOGIN_TOKEN_ERRORS.USERNAME_NOT_SPECIFIED" as "ERRORS.LOGIN_TOKEN_ERRORS.USERNAME_NOT_SPECIFIED",
            "USER_NOT_FOUND": "ERRORS.LOGIN_TOKEN_ERRORS.USER_NOT_FOUND" as "ERRORS.LOGIN_TOKEN_ERRORS.USER_NOT_FOUND"
        },
        "MISSING_VALUE_ERRORS": {
            "FACEBOOK_AD_SET_MISSING_END_DATE": "ERRORS.MISSING_VALUE_ERRORS.FACEBOOK_AD_SET_MISSING_END_DATE" as "ERRORS.MISSING_VALUE_ERRORS.FACEBOOK_AD_SET_MISSING_END_DATE",
            "FACEBOOK_AD_SET_MISSING_START_DATE": "ERRORS.MISSING_VALUE_ERRORS.FACEBOOK_AD_SET_MISSING_START_DATE" as "ERRORS.MISSING_VALUE_ERRORS.FACEBOOK_AD_SET_MISSING_START_DATE",
            "GATHER_STATS_ERROR_HANDLER_MISSING_LOCATION_ID": "ERRORS.MISSING_VALUE_ERRORS.GATHER_STATS_ERROR_HANDLER_MISSING_LOCATION_ID" as "ERRORS.MISSING_VALUE_ERRORS.GATHER_STATS_ERROR_HANDLER_MISSING_LOCATION_ID",
            "REPLACEMENT_VALUE_FOR_LOCAL_RESOURCE": "ERRORS.MISSING_VALUE_ERRORS.REPLACEMENT_VALUE_FOR_LOCAL_RESOURCE" as "ERRORS.MISSING_VALUE_ERRORS.REPLACEMENT_VALUE_FOR_LOCAL_RESOURCE"
        },
        "MULTIPLE_ERRORS": "ERRORS.MULTIPLE_ERRORS" as "ERRORS.MULTIPLE_ERRORS",
        "NOT_FOUND_ERRORS": {
            "AGENCY_LOCALE_NOT_FOUND_WITH_ID": "ERRORS.NOT_FOUND_ERRORS.AGENCY_LOCALE_NOT_FOUND_WITH_ID" as "ERRORS.NOT_FOUND_ERRORS.AGENCY_LOCALE_NOT_FOUND_WITH_ID",
            "ENTITY_NOT_FOUND": "ERRORS.NOT_FOUND_ERRORS.ENTITY_NOT_FOUND" as "ERRORS.NOT_FOUND_ERRORS.ENTITY_NOT_FOUND",
            "ENTITY_NOT_FOUND_WITH_ID": "ERRORS.NOT_FOUND_ERRORS.ENTITY_NOT_FOUND_WITH_ID" as "ERRORS.NOT_FOUND_ERRORS.ENTITY_NOT_FOUND_WITH_ID",
            "ENTITY_NOT_FOUND_WITH_TOKEN": "ERRORS.NOT_FOUND_ERRORS.ENTITY_NOT_FOUND_WITH_TOKEN" as "ERRORS.NOT_FOUND_ERRORS.ENTITY_NOT_FOUND_WITH_TOKEN",
            "ENTITY_TO_DELETE_NOT_FOUND": "ERRORS.NOT_FOUND_ERRORS.ENTITY_TO_DELETE_NOT_FOUND" as "ERRORS.NOT_FOUND_ERRORS.ENTITY_TO_DELETE_NOT_FOUND",
            "ENTITY_TO_UPDATE_NOT_FOUND": "ERRORS.NOT_FOUND_ERRORS.ENTITY_TO_UPDATE_NOT_FOUND" as "ERRORS.NOT_FOUND_ERRORS.ENTITY_TO_UPDATE_NOT_FOUND",
            "GOOGLE_ADWORDS_GET_REPORT_DEFINITION_NO_ACCESS_TOKEN": "ERRORS.NOT_FOUND_ERRORS.GOOGLE_ADWORDS_GET_REPORT_DEFINITION_NO_ACCESS_TOKEN" as "ERRORS.NOT_FOUND_ERRORS.GOOGLE_ADWORDS_GET_REPORT_DEFINITION_NO_ACCESS_TOKEN",
            "NO_FACEBOOK_ACCESS_TOKEN_FOR_LOCATION": "ERRORS.NOT_FOUND_ERRORS.NO_FACEBOOK_ACCESS_TOKEN_FOR_LOCATION" as "ERRORS.NOT_FOUND_ERRORS.NO_FACEBOOK_ACCESS_TOKEN_FOR_LOCATION",
            "NO_MATCHING_EMAIL": "ERRORS.NOT_FOUND_ERRORS.NO_MATCHING_EMAIL" as "ERRORS.NOT_FOUND_ERRORS.NO_MATCHING_EMAIL",
            "RESOURCE_NOT_FOUND": "ERRORS.NOT_FOUND_ERRORS.RESOURCE_NOT_FOUND" as "ERRORS.NOT_FOUND_ERRORS.RESOURCE_NOT_FOUND",
            "USER_DOES_NOT_BELONG_TO_ANY_AGENCIES": "ERRORS.NOT_FOUND_ERRORS.USER_DOES_NOT_BELONG_TO_ANY_AGENCIES" as "ERRORS.NOT_FOUND_ERRORS.USER_DOES_NOT_BELONG_TO_ANY_AGENCIES",
            "USER_NOT_FOUND": "ERRORS.NOT_FOUND_ERRORS.USER_NOT_FOUND" as "ERRORS.NOT_FOUND_ERRORS.USER_NOT_FOUND",
            "USER_NOT_FOUND_WITH_ID": "ERRORS.NOT_FOUND_ERRORS.USER_NOT_FOUND_WITH_ID" as "ERRORS.NOT_FOUND_ERRORS.USER_NOT_FOUND_WITH_ID"
        },
        "NO_NETWORK_CONNECTION_ERROR": "ERRORS.NO_NETWORK_CONNECTION_ERROR" as "ERRORS.NO_NETWORK_CONNECTION_ERROR",
        "NO_STATS_DATA_ERRORS": {
            "GOOGLE_ADWORDS_ZERO_VALUES": "ERRORS.NO_STATS_DATA_ERRORS.GOOGLE_ADWORDS_ZERO_VALUES" as "ERRORS.NO_STATS_DATA_ERRORS.GOOGLE_ADWORDS_ZERO_VALUES",
            "NO_STATS_FOR_DATE_RANGE": "ERRORS.NO_STATS_DATA_ERRORS.NO_STATS_FOR_DATE_RANGE" as "ERRORS.NO_STATS_DATA_ERRORS.NO_STATS_FOR_DATE_RANGE",
            "NO_STATS_FOR_GIVEN_PERIOD": "ERRORS.NO_STATS_DATA_ERRORS.NO_STATS_FOR_GIVEN_PERIOD" as "ERRORS.NO_STATS_DATA_ERRORS.NO_STATS_FOR_GIVEN_PERIOD"
        },
        "OAUTH_ERRORS": {
            "AUTHORISATION_DENIED": "ERRORS.OAUTH_ERRORS.AUTHORISATION_DENIED" as "ERRORS.OAUTH_ERRORS.AUTHORISATION_DENIED",
            "CALLBACK_CONFIRMATION_FAILED": "ERRORS.OAUTH_ERRORS.CALLBACK_CONFIRMATION_FAILED" as "ERRORS.OAUTH_ERRORS.CALLBACK_CONFIRMATION_FAILED",
            "NO_OAUTH_TOKEN": "ERRORS.OAUTH_ERRORS.NO_OAUTH_TOKEN" as "ERRORS.OAUTH_ERRORS.NO_OAUTH_TOKEN",
            "TOKEN_DOES_NOT_MATCH": "ERRORS.OAUTH_ERRORS.TOKEN_DOES_NOT_MATCH" as "ERRORS.OAUTH_ERRORS.TOKEN_DOES_NOT_MATCH",
            "UNKNOWN_GRANT_TYPE": "ERRORS.OAUTH_ERRORS.UNKNOWN_GRANT_TYPE" as "ERRORS.OAUTH_ERRORS.UNKNOWN_GRANT_TYPE"
        },
        "PARSING_ERRORS": {
            "FOUR51_AUTH_TOKEN": "ERRORS.PARSING_ERRORS.FOUR51_AUTH_TOKEN" as "ERRORS.PARSING_ERRORS.FOUR51_AUTH_TOKEN",
            "PARSING_ERROR": "ERRORS.PARSING_ERRORS.PARSING_ERROR" as "ERRORS.PARSING_ERRORS.PARSING_ERROR"
        },
        "PUBLISH": {
            "ERRORS": {
                "ACCESS_TOKEN_HAS_EXPIRED": "ERRORS.PUBLISH.ERRORS.ACCESS_TOKEN_HAS_EXPIRED" as "ERRORS.PUBLISH.ERRORS.ACCESS_TOKEN_HAS_EXPIRED",
                "DUPLICATE_POSTS_DETECTED": "ERRORS.PUBLISH.ERRORS.DUPLICATE_POSTS_DETECTED" as "ERRORS.PUBLISH.ERRORS.DUPLICATE_POSTS_DETECTED",
                "FAILED_TO_PUBLISH_TO_LOCATION": "ERRORS.PUBLISH.ERRORS.FAILED_TO_PUBLISH_TO_LOCATION" as "ERRORS.PUBLISH.ERRORS.FAILED_TO_PUBLISH_TO_LOCATION",
                "GENERIC_ERROR_MESSAGE": "ERRORS.PUBLISH.ERRORS.GENERIC_ERROR_MESSAGE" as "ERRORS.PUBLISH.ERRORS.GENERIC_ERROR_MESSAGE",
                "INSTAGRAM_CAROUSEL_POST_REQUIREMENTS_NOT_MET": "ERRORS.PUBLISH.ERRORS.INSTAGRAM_CAROUSEL_POST_REQUIREMENTS_NOT_MET" as "ERRORS.PUBLISH.ERRORS.INSTAGRAM_CAROUSEL_POST_REQUIREMENTS_NOT_MET",
                "INSTAGRAM_MEDIA_DOWNLOAD_TIMEOUT": "ERRORS.PUBLISH.ERRORS.INSTAGRAM_MEDIA_DOWNLOAD_TIMEOUT" as "ERRORS.PUBLISH.ERRORS.INSTAGRAM_MEDIA_DOWNLOAD_TIMEOUT",
                "INSTAGRAM_SUSPECTED_SPAM": "ERRORS.PUBLISH.ERRORS.INSTAGRAM_SUSPECTED_SPAM" as "ERRORS.PUBLISH.ERRORS.INSTAGRAM_SUSPECTED_SPAM",
                "INSTAGRAM_TAG_COUNT_REACHED": "ERRORS.PUBLISH.ERRORS.INSTAGRAM_TAG_COUNT_REACHED" as "ERRORS.PUBLISH.ERRORS.INSTAGRAM_TAG_COUNT_REACHED",
                "NOT_SHOWN_MISSING_FROM_LIST": "ERRORS.PUBLISH.ERRORS.NOT_SHOWN_MISSING_FROM_LIST" as "ERRORS.PUBLISH.ERRORS.NOT_SHOWN_MISSING_FROM_LIST",
                "PERMISSIONS_NOT_GRANTED": "ERRORS.PUBLISH.ERRORS.PERMISSIONS_NOT_GRANTED" as "ERRORS.PUBLISH.ERRORS.PERMISSIONS_NOT_GRANTED",
                "SERVICE_INVALID_ASPECT_RATIO": "ERRORS.PUBLISH.ERRORS.SERVICE_INVALID_ASPECT_RATIO" as "ERRORS.PUBLISH.ERRORS.SERVICE_INVALID_ASPECT_RATIO",
                "SERVICE_INVALID_SCHEDULE_DATE": "ERRORS.PUBLISH.ERRORS.SERVICE_INVALID_SCHEDULE_DATE" as "ERRORS.PUBLISH.ERRORS.SERVICE_INVALID_SCHEDULE_DATE",
                "SERVICE_MAXIMUM_CAPTION_LENGTH_EXCEEDED": "ERRORS.PUBLISH.ERRORS.SERVICE_MAXIMUM_CAPTION_LENGTH_EXCEEDED" as "ERRORS.PUBLISH.ERRORS.SERVICE_MAXIMUM_CAPTION_LENGTH_EXCEEDED",
                "SERVICE_MAXIMUM_MEDIA_SIZE_EXCEEDED": "ERRORS.PUBLISH.ERRORS.SERVICE_MAXIMUM_MEDIA_SIZE_EXCEEDED" as "ERRORS.PUBLISH.ERRORS.SERVICE_MAXIMUM_MEDIA_SIZE_EXCEEDED",
                "SERVICE_MAXIMUM_PUBLISH_COUNT_REACHED": "ERRORS.PUBLISH.ERRORS.SERVICE_MAXIMUM_PUBLISH_COUNT_REACHED" as "ERRORS.PUBLISH.ERRORS.SERVICE_MAXIMUM_PUBLISH_COUNT_REACHED",
                "UNSUPPORTED_FILE_FORMAT": "ERRORS.PUBLISH.ERRORS.UNSUPPORTED_FILE_FORMAT" as "ERRORS.PUBLISH.ERRORS.UNSUPPORTED_FILE_FORMAT",
                "USER_CREDENTIALS_CHANGED": "ERRORS.PUBLISH.ERRORS.USER_CREDENTIALS_CHANGED" as "ERRORS.PUBLISH.ERRORS.USER_CREDENTIALS_CHANGED",
                "USER_INTERVENTION_REQUIRED": "ERRORS.PUBLISH.ERRORS.USER_INTERVENTION_REQUIRED" as "ERRORS.PUBLISH.ERRORS.USER_INTERVENTION_REQUIRED"
            },
            "INVALID_LOCATION_NODE_ID": "ERRORS.PUBLISH.INVALID_LOCATION_NODE_ID" as "ERRORS.PUBLISH.INVALID_LOCATION_NODE_ID",
            "ONE_OR_MORE_ARTIFACT_IDS_ARE_INVALID": "ERRORS.PUBLISH.ONE_OR_MORE_ARTIFACT_IDS_ARE_INVALID" as "ERRORS.PUBLISH.ONE_OR_MORE_ARTIFACT_IDS_ARE_INVALID",
            "SCHEDULING_STATUS_ERRORS": {
                "UNKNOWN": "ERRORS.PUBLISH.SCHEDULING_STATUS_ERRORS.UNKNOWN" as "ERRORS.PUBLISH.SCHEDULING_STATUS_ERRORS.UNKNOWN"
            }
        },
        "REQUEST_TOKEN_ERRORS": {
            "API_KEY_INVALID": "ERRORS.REQUEST_TOKEN_ERRORS.API_KEY_INVALID" as "ERRORS.REQUEST_TOKEN_ERRORS.API_KEY_INVALID",
            "API_KEY_NOT_SPECIFIED": "ERRORS.REQUEST_TOKEN_ERRORS.API_KEY_NOT_SPECIFIED" as "ERRORS.REQUEST_TOKEN_ERRORS.API_KEY_NOT_SPECIFIED",
            "ISSUER_NOT_SPECIFIED": "ERRORS.REQUEST_TOKEN_ERRORS.ISSUER_NOT_SPECIFIED" as "ERRORS.REQUEST_TOKEN_ERRORS.ISSUER_NOT_SPECIFIED",
            "TOKEN_INVALID": "ERRORS.REQUEST_TOKEN_ERRORS.TOKEN_INVALID" as "ERRORS.REQUEST_TOKEN_ERRORS.TOKEN_INVALID"
        },
        "SCHEDULING": {
            "DELETE": {
                "TOO_CLOSE_TO_SCHEDULED_TIME": "ERRORS.SCHEDULING.DELETE.TOO_CLOSE_TO_SCHEDULED_TIME" as "ERRORS.SCHEDULING.DELETE.TOO_CLOSE_TO_SCHEDULED_TIME",
                "UNKNOWN": "ERRORS.SCHEDULING.DELETE.UNKNOWN" as "ERRORS.SCHEDULING.DELETE.UNKNOWN"
            },
            "RESCHEDULE": {
                "TOO_CLOSE_TO_SCHEDULED_TIME": "ERRORS.SCHEDULING.RESCHEDULE.TOO_CLOSE_TO_SCHEDULED_TIME" as "ERRORS.SCHEDULING.RESCHEDULE.TOO_CLOSE_TO_SCHEDULED_TIME",
                "UNKNOWN": "ERRORS.SCHEDULING.RESCHEDULE.UNKNOWN" as "ERRORS.SCHEDULING.RESCHEDULE.UNKNOWN"
            }
        },
        "SENDGRID": {
            "COULD_NOT_FIND_UNSUB_GROUP": "ERRORS.SENDGRID.COULD_NOT_FIND_UNSUB_GROUP" as "ERRORS.SENDGRID.COULD_NOT_FIND_UNSUB_GROUP",
            "DELETE_EMAIL_ERROR": "ERRORS.SENDGRID.DELETE_EMAIL_ERROR" as "ERRORS.SENDGRID.DELETE_EMAIL_ERROR",
            "RESCHEDULE_EMAIL_ERROR": "ERRORS.SENDGRID.RESCHEDULE_EMAIL_ERROR" as "ERRORS.SENDGRID.RESCHEDULE_EMAIL_ERROR",
            "SINGLE_SEND_FAILED": "ERRORS.SENDGRID.SINGLE_SEND_FAILED" as "ERRORS.SENDGRID.SINGLE_SEND_FAILED",
            "SINGLE_SEND_FAILED_NO_ID": "ERRORS.SENDGRID.SINGLE_SEND_FAILED_NO_ID" as "ERRORS.SENDGRID.SINGLE_SEND_FAILED_NO_ID",
            "WAIT_30_MINS": "ERRORS.SENDGRID.WAIT_30_MINS" as "ERRORS.SENDGRID.WAIT_30_MINS"
        },
        "SERVICE_ACCESS_ERRORS": {
            "ACCESS_EXPIRED_OR_FORBIDDEN": "ERRORS.SERVICE_ACCESS_ERRORS.ACCESS_EXPIRED_OR_FORBIDDEN" as "ERRORS.SERVICE_ACCESS_ERRORS.ACCESS_EXPIRED_OR_FORBIDDEN",
            "ACCESS_EXPIRED_OR_FORBIDDEN_WITH_DETAILS": "ERRORS.SERVICE_ACCESS_ERRORS.ACCESS_EXPIRED_OR_FORBIDDEN_WITH_DETAILS" as "ERRORS.SERVICE_ACCESS_ERRORS.ACCESS_EXPIRED_OR_FORBIDDEN_WITH_DETAILS",
            "FACEBOOK_ACCOUNT_CANNOT_ACCESS_PAGE": "ERRORS.SERVICE_ACCESS_ERRORS.FACEBOOK_ACCOUNT_CANNOT_ACCESS_PAGE" as "ERRORS.SERVICE_ACCESS_ERRORS.FACEBOOK_ACCOUNT_CANNOT_ACCESS_PAGE",
            "FACEBOOK_PAGE_TOKEN_NOT_RETURNED": "ERRORS.SERVICE_ACCESS_ERRORS.FACEBOOK_PAGE_TOKEN_NOT_RETURNED" as "ERRORS.SERVICE_ACCESS_ERRORS.FACEBOOK_PAGE_TOKEN_NOT_RETURNED"
        },
        "SERVICE_AUTHENTICATION_ERRORS": {
            "FAILED_TO_AUTHORISE": "ERRORS.SERVICE_AUTHENTICATION_ERRORS.FAILED_TO_AUTHORISE" as "ERRORS.SERVICE_AUTHENTICATION_ERRORS.FAILED_TO_AUTHORISE"
        },
        "SERVICE_CONFIGURATION_ERRORS": {
            "CLIENT_MISSING_FITWARE_BUSINESS": "ERRORS.SERVICE_CONFIGURATION_ERRORS.CLIENT_MISSING_FITWARE_BUSINESS" as "ERRORS.SERVICE_CONFIGURATION_ERRORS.CLIENT_MISSING_FITWARE_BUSINESS",
            "FACEBOOK_PAGE_NOT_CONFIGURED": "ERRORS.SERVICE_CONFIGURATION_ERRORS.FACEBOOK_PAGE_NOT_CONFIGURED" as "ERRORS.SERVICE_CONFIGURATION_ERRORS.FACEBOOK_PAGE_NOT_CONFIGURED",
            "FITWARE_CLIENT_CONFIG_MISSING": "ERRORS.SERVICE_CONFIGURATION_ERRORS.FITWARE_CLIENT_CONFIG_MISSING" as "ERRORS.SERVICE_CONFIGURATION_ERRORS.FITWARE_CLIENT_CONFIG_MISSING",
            "FITWARE_MEMBER_ENGAGER_CLUB_MISSING": "ERRORS.SERVICE_CONFIGURATION_ERRORS.FITWARE_MEMBER_ENGAGER_CLUB_MISSING" as "ERRORS.SERVICE_CONFIGURATION_ERRORS.FITWARE_MEMBER_ENGAGER_CLUB_MISSING",
            "FITWARE_MISSING_DATA": "ERRORS.SERVICE_CONFIGURATION_ERRORS.FITWARE_MISSING_DATA" as "ERRORS.SERVICE_CONFIGURATION_ERRORS.FITWARE_MISSING_DATA",
            "FOUR51_CREDENTIALS_MISSING": "ERRORS.SERVICE_CONFIGURATION_ERRORS.FOUR51_CREDENTIALS_MISSING" as "ERRORS.SERVICE_CONFIGURATION_ERRORS.FOUR51_CREDENTIALS_MISSING",
            "FOUR51_STORE_COMPANY_OR_SSO_KEY_MISSING": "ERRORS.SERVICE_CONFIGURATION_ERRORS.FOUR51_STORE_COMPANY_OR_SSO_KEY_MISSING" as "ERRORS.SERVICE_CONFIGURATION_ERRORS.FOUR51_STORE_COMPANY_OR_SSO_KEY_MISSING",
            "GOOGLE_ADWORDS_CAMPAIGN_NAME_NOT_CONFIGURED": "ERRORS.SERVICE_CONFIGURATION_ERRORS.GOOGLE_ADWORDS_CAMPAIGN_NAME_NOT_CONFIGURED" as "ERRORS.SERVICE_CONFIGURATION_ERRORS.GOOGLE_ADWORDS_CAMPAIGN_NAME_NOT_CONFIGURED",
            "GOOGLE_ADWORDS_CUSTOMER_NOT_CONFIGURED": "ERRORS.SERVICE_CONFIGURATION_ERRORS.GOOGLE_ADWORDS_CUSTOMER_NOT_CONFIGURED" as "ERRORS.SERVICE_CONFIGURATION_ERRORS.GOOGLE_ADWORDS_CUSTOMER_NOT_CONFIGURED",
            "GOOGLE_ADWORDS_NOT_CONNECTED": "ERRORS.SERVICE_CONFIGURATION_ERRORS.GOOGLE_ADWORDS_NOT_CONNECTED" as "ERRORS.SERVICE_CONFIGURATION_ERRORS.GOOGLE_ADWORDS_NOT_CONNECTED",
            "GOOGLE_ANALYTICS_PAGE_PATH_MISSING": "ERRORS.SERVICE_CONFIGURATION_ERRORS.GOOGLE_ANALYTICS_PAGE_PATH_MISSING" as "ERRORS.SERVICE_CONFIGURATION_ERRORS.GOOGLE_ANALYTICS_PAGE_PATH_MISSING",
            "GOOGLE_ANALYTICS_VIEW_ID_MISSING": "ERRORS.SERVICE_CONFIGURATION_ERRORS.GOOGLE_ANALYTICS_VIEW_ID_MISSING" as "ERRORS.SERVICE_CONFIGURATION_ERRORS.GOOGLE_ANALYTICS_VIEW_ID_MISSING",
            "LOCATION_MISSING_FACEBOOK_PAGE_ID": "ERRORS.SERVICE_CONFIGURATION_ERRORS.LOCATION_MISSING_FACEBOOK_PAGE_ID" as "ERRORS.SERVICE_CONFIGURATION_ERRORS.LOCATION_MISSING_FACEBOOK_PAGE_ID",
            "LOCATION_MISSING_FITWARE_CLUB_NUMBER": "ERRORS.SERVICE_CONFIGURATION_ERRORS.LOCATION_MISSING_FITWARE_CLUB_NUMBER" as "ERRORS.SERVICE_CONFIGURATION_ERRORS.LOCATION_MISSING_FITWARE_CLUB_NUMBER",
            "LOCATION_MISSING_INSTAGRAM_PAGE_ID": "ERRORS.SERVICE_CONFIGURATION_ERRORS.LOCATION_MISSING_INSTAGRAM_PAGE_ID" as "ERRORS.SERVICE_CONFIGURATION_ERRORS.LOCATION_MISSING_INSTAGRAM_PAGE_ID",
            "SERVICE_NOT_CONFIGURED": "ERRORS.SERVICE_CONFIGURATION_ERRORS.SERVICE_NOT_CONFIGURED" as "ERRORS.SERVICE_CONFIGURATION_ERRORS.SERVICE_NOT_CONFIGURED"
        },
        "SERVICE_CREDENTIALS_MISSING_ERRORS": {
            "NO_AUTHENTICATION_FOR_SERVICE": "ERRORS.SERVICE_CREDENTIALS_MISSING_ERRORS.NO_AUTHENTICATION_FOR_SERVICE" as "ERRORS.SERVICE_CREDENTIALS_MISSING_ERRORS.NO_AUTHENTICATION_FOR_SERVICE"
        },
        "SERVICE_DISABLED_FOR_CLIENT": "ERRORS.SERVICE_DISABLED_FOR_CLIENT" as "ERRORS.SERVICE_DISABLED_FOR_CLIENT",
        "SERVICE_RATE_LIMIT_ERROR": "ERRORS.SERVICE_RATE_LIMIT_ERROR" as "ERRORS.SERVICE_RATE_LIMIT_ERROR",
        "STRIPE": {
            "UNRECOGNISED_RESPONSE": "ERRORS.STRIPE.UNRECOGNISED_RESPONSE" as "ERRORS.STRIPE.UNRECOGNISED_RESPONSE",
            "UNTRANSLATED_ERROR_MESSAGE": "ERRORS.STRIPE.UNTRANSLATED_ERROR_MESSAGE" as "ERRORS.STRIPE.UNTRANSLATED_ERROR_MESSAGE"
        },
        "TEMPLATE_CANNOT_BE_DOWNLOADED_NO_PERMISSION": "ERRORS.TEMPLATE_CANNOT_BE_DOWNLOADED_NO_PERMISSION" as "ERRORS.TEMPLATE_CANNOT_BE_DOWNLOADED_NO_PERMISSION",
        "UNAUTHORIZED_ERRORS": {
            "PLEASE_LOGIN": "ERRORS.UNAUTHORIZED_ERRORS.PLEASE_LOGIN" as "ERRORS.UNAUTHORIZED_ERRORS.PLEASE_LOGIN",
            "RESOURCE": "ERRORS.UNAUTHORIZED_ERRORS.RESOURCE" as "ERRORS.UNAUTHORIZED_ERRORS.RESOURCE"
        },
        "UNEXPECTED_ERROR": "ERRORS.UNEXPECTED_ERROR" as "ERRORS.UNEXPECTED_ERROR",
        "UNEXPECTED_INPUT_ERRORS": {
            "FACEBOOK_PAGE_MIGRATION_IDS_NOT_FOUND": "ERRORS.UNEXPECTED_INPUT_ERRORS.FACEBOOK_PAGE_MIGRATION_IDS_NOT_FOUND" as "ERRORS.UNEXPECTED_INPUT_ERRORS.FACEBOOK_PAGE_MIGRATION_IDS_NOT_FOUND"
        },
        "UNSUPPORTED_CURRENCY": "ERRORS.UNSUPPORTED_CURRENCY" as "ERRORS.UNSUPPORTED_CURRENCY",
        "UNSUPPORTED_OPERATION_ERRORS": {
            "ACCESS_TOKEN_CANNOT_DETERMINE_AFFECTED_TARGET_NAME": "ERRORS.UNSUPPORTED_OPERATION_ERRORS.ACCESS_TOKEN_CANNOT_DETERMINE_AFFECTED_TARGET_NAME" as "ERRORS.UNSUPPORTED_OPERATION_ERRORS.ACCESS_TOKEN_CANNOT_DETERMINE_AFFECTED_TARGET_NAME",
            "ASSIGNED_LOCATION_MAPPER_GIVEN_MULTIPLE_LOCATIONS": "ERRORS.UNSUPPORTED_OPERATION_ERRORS.ASSIGNED_LOCATION_MAPPER_GIVEN_MULTIPLE_LOCATIONS" as "ERRORS.UNSUPPORTED_OPERATION_ERRORS.ASSIGNED_LOCATION_MAPPER_GIVEN_MULTIPLE_LOCATIONS",
            "BANNER_NOTIFICATION_ALREADY_EXISTS": "ERRORS.UNSUPPORTED_OPERATION_ERRORS.BANNER_NOTIFICATION_ALREADY_EXISTS" as "ERRORS.UNSUPPORTED_OPERATION_ERRORS.BANNER_NOTIFICATION_ALREADY_EXISTS",
            "CONTROLLER_MISSING_VALIDATION": "ERRORS.UNSUPPORTED_OPERATION_ERRORS.CONTROLLER_MISSING_VALIDATION" as "ERRORS.UNSUPPORTED_OPERATION_ERRORS.CONTROLLER_MISSING_VALIDATION",
            "FACEBOOK_API_CLIENT_INSTANITATED_WITHOUT_A_FACEBOOK_PAGE_ID": "ERRORS.UNSUPPORTED_OPERATION_ERRORS.FACEBOOK_API_CLIENT_INSTANITATED_WITHOUT_A_FACEBOOK_PAGE_ID" as "ERRORS.UNSUPPORTED_OPERATION_ERRORS.FACEBOOK_API_CLIENT_INSTANITATED_WITHOUT_A_FACEBOOK_PAGE_ID",
            "FACEBOOK_MARKETING_API_CLIENT_INSTANITATED_WITHOUT_A_FACEBOOK_PAGE_ID": "ERRORS.UNSUPPORTED_OPERATION_ERRORS.FACEBOOK_MARKETING_API_CLIENT_INSTANITATED_WITHOUT_A_FACEBOOK_PAGE_ID" as "ERRORS.UNSUPPORTED_OPERATION_ERRORS.FACEBOOK_MARKETING_API_CLIENT_INSTANITATED_WITHOUT_A_FACEBOOK_PAGE_ID",
            "IMAGE_FORMAT_CONVERSION": "ERRORS.UNSUPPORTED_OPERATION_ERRORS.IMAGE_FORMAT_CONVERSION" as "ERRORS.UNSUPPORTED_OPERATION_ERRORS.IMAGE_FORMAT_CONVERSION",
            "MONTHLY_RECURRING_EVENTS_ONLY": "ERRORS.UNSUPPORTED_OPERATION_ERRORS.MONTHLY_RECURRING_EVENTS_ONLY" as "ERRORS.UNSUPPORTED_OPERATION_ERRORS.MONTHLY_RECURRING_EVENTS_ONLY",
            "PLANNER_OPERATION_NOT_SUPPORTED": "ERRORS.UNSUPPORTED_OPERATION_ERRORS.PLANNER_OPERATION_NOT_SUPPORTED" as "ERRORS.UNSUPPORTED_OPERATION_ERRORS.PLANNER_OPERATION_NOT_SUPPORTED",
            "PRINT_PROVIDER_SKU_MISSING_QUANTITY_OPTIONS": "ERRORS.UNSUPPORTED_OPERATION_ERRORS.PRINT_PROVIDER_SKU_MISSING_QUANTITY_OPTIONS" as "ERRORS.UNSUPPORTED_OPERATION_ERRORS.PRINT_PROVIDER_SKU_MISSING_QUANTITY_OPTIONS",
            "SOCKET_SERVER_ALREADY_READY": "ERRORS.UNSUPPORTED_OPERATION_ERRORS.SOCKET_SERVER_ALREADY_READY" as "ERRORS.UNSUPPORTED_OPERATION_ERRORS.SOCKET_SERVER_ALREADY_READY",
            "UNSUPPORTED_WINDOWS_TIMEZONE": "ERRORS.UNSUPPORTED_OPERATION_ERRORS.UNSUPPORTED_WINDOWS_TIMEZONE" as "ERRORS.UNSUPPORTED_OPERATION_ERRORS.UNSUPPORTED_WINDOWS_TIMEZONE"
        },
        "VIDEO_IMPORT": {
            "NETWORK_ERROR": "ERRORS.VIDEO_IMPORT.NETWORK_ERROR" as "ERRORS.VIDEO_IMPORT.NETWORK_ERROR",
            "UNKNOWN_ERROR": "ERRORS.VIDEO_IMPORT.UNKNOWN_ERROR" as "ERRORS.VIDEO_IMPORT.UNKNOWN_ERROR",
            "UNSUPPORTED_FILE_TYPE": "ERRORS.VIDEO_IMPORT.UNSUPPORTED_FILE_TYPE" as "ERRORS.VIDEO_IMPORT.UNSUPPORTED_FILE_TYPE",
            "UNSUPPORTED_VIDEO_TYPE": "ERRORS.VIDEO_IMPORT.UNSUPPORTED_VIDEO_TYPE" as "ERRORS.VIDEO_IMPORT.UNSUPPORTED_VIDEO_TYPE"
        },
        "VIDEO_PREVIEW_UNSUPPORTED": "ERRORS.VIDEO_PREVIEW_UNSUPPORTED" as "ERRORS.VIDEO_PREVIEW_UNSUPPORTED"
    },
    "FOOTER": {
        "PRIVACY_POLICY": "FOOTER.PRIVACY_POLICY" as "FOOTER.PRIVACY_POLICY",
        "TERMS_AND_CONDITIONS": "FOOTER.TERMS_AND_CONDITIONS" as "FOOTER.TERMS_AND_CONDITIONS"
    },
    "HELP": {
        "BUILDER_KEYBOARD_SHORTCUTS": {
            "ALIGNMENT": {
                "MULTIPLE_CENTER_HORIZONTAL": {
                    "DESCRIPTION": "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_CENTER_HORIZONTAL.DESCRIPTION" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_CENTER_HORIZONTAL.DESCRIPTION",
                    "MAC": "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_CENTER_HORIZONTAL.MAC" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_CENTER_HORIZONTAL.MAC",
                    "WINDOWS": "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_CENTER_HORIZONTAL.WINDOWS" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_CENTER_HORIZONTAL.WINDOWS"
                },
                "MULTIPLE_CENTER_VERTICAL": {
                    "DESCRIPTION": "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_CENTER_VERTICAL.DESCRIPTION" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_CENTER_VERTICAL.DESCRIPTION",
                    "MAC": "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_CENTER_VERTICAL.MAC" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_CENTER_VERTICAL.MAC",
                    "WINDOWS": "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_CENTER_VERTICAL.WINDOWS" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_CENTER_VERTICAL.WINDOWS"
                },
                "MULTIPLE_LEFT_RIGHT": {
                    "DESCRIPTION": "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_LEFT_RIGHT.DESCRIPTION" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_LEFT_RIGHT.DESCRIPTION",
                    "MAC": "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_LEFT_RIGHT.MAC" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_LEFT_RIGHT.MAC",
                    "WINDOWS": "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_LEFT_RIGHT.WINDOWS" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_LEFT_RIGHT.WINDOWS"
                },
                "MULTIPLE_TOP_BOTTOM": {
                    "DESCRIPTION": "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_TOP_BOTTOM.DESCRIPTION" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_TOP_BOTTOM.DESCRIPTION",
                    "MAC": "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_TOP_BOTTOM.MAC" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_TOP_BOTTOM.MAC",
                    "WINDOWS": "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_TOP_BOTTOM.WINDOWS" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_TOP_BOTTOM.WINDOWS"
                },
                "SINGLE_CENTER_HORIZONTAL": {
                    "DESCRIPTION": "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_CENTER_HORIZONTAL.DESCRIPTION" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_CENTER_HORIZONTAL.DESCRIPTION",
                    "MAC": "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_CENTER_HORIZONTAL.MAC" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_CENTER_HORIZONTAL.MAC",
                    "WINDOWS": "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_CENTER_HORIZONTAL.WINDOWS" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_CENTER_HORIZONTAL.WINDOWS"
                },
                "SINGLE_CENTER_VERTICAL": {
                    "DESCRIPTION": "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_CENTER_VERTICAL.DESCRIPTION" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_CENTER_VERTICAL.DESCRIPTION",
                    "MAC": "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_CENTER_VERTICAL.MAC" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_CENTER_VERTICAL.MAC",
                    "WINDOWS": "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_CENTER_VERTICAL.WINDOWS" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_CENTER_VERTICAL.WINDOWS"
                },
                "SINGLE_LEFT_RIGHT": {
                    "DESCRIPTION": "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_LEFT_RIGHT.DESCRIPTION" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_LEFT_RIGHT.DESCRIPTION",
                    "MAC": "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_LEFT_RIGHT.MAC" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_LEFT_RIGHT.MAC",
                    "WINDOWS": "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_LEFT_RIGHT.WINDOWS" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_LEFT_RIGHT.WINDOWS"
                },
                "SINGLE_TOP_BOTTOM": {
                    "DESCRIPTION": "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_TOP_BOTTOM.DESCRIPTION" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_TOP_BOTTOM.DESCRIPTION",
                    "MAC": "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_TOP_BOTTOM.MAC" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_TOP_BOTTOM.MAC",
                    "WINDOWS": "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_TOP_BOTTOM.WINDOWS" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_TOP_BOTTOM.WINDOWS"
                },
                "TITLE": "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.TITLE" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.TITLE"
            },
            "GENERAL": {
                "DELETE": {
                    "DESCRIPTION": "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.DELETE.DESCRIPTION" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.DELETE.DESCRIPTION",
                    "MAC": "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.DELETE.MAC" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.DELETE.MAC",
                    "WINDOWS": "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.DELETE.WINDOWS" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.DELETE.WINDOWS"
                },
                "DUPLICATE": {
                    "DESCRIPTION": "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.DUPLICATE.DESCRIPTION" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.DUPLICATE.DESCRIPTION",
                    "MAC": "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.DUPLICATE.MAC" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.DUPLICATE.MAC",
                    "WINDOWS": "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.DUPLICATE.WINDOWS" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.DUPLICATE.WINDOWS"
                },
                "MULTI_SELECT": {
                    "DESCRIPTION": "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.MULTI_SELECT.DESCRIPTION" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.MULTI_SELECT.DESCRIPTION",
                    "MAC": "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.MULTI_SELECT.MAC" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.MULTI_SELECT.MAC",
                    "WINDOWS": "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.MULTI_SELECT.WINDOWS" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.MULTI_SELECT.WINDOWS"
                },
                "REDO": {
                    "DESCRIPTION": "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.REDO.DESCRIPTION" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.REDO.DESCRIPTION",
                    "MAC": "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.REDO.MAC" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.REDO.MAC",
                    "WINDOWS": "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.REDO.WINDOWS" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.REDO.WINDOWS"
                },
                "TITLE": "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.TITLE" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.TITLE",
                "UNDO": {
                    "DESCRIPTION": "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.UNDO.DESCRIPTION" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.UNDO.DESCRIPTION",
                    "MAC": "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.UNDO.MAC" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.UNDO.MAC",
                    "WINDOWS": "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.UNDO.WINDOWS" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.UNDO.WINDOWS"
                }
            },
            "MOVEMENT": {
                "ARROW_LEFT_RIGHT": {
                    "DESCRIPTION": "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_LEFT_RIGHT.DESCRIPTION" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_LEFT_RIGHT.DESCRIPTION",
                    "MAC": "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_LEFT_RIGHT.MAC" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_LEFT_RIGHT.MAC",
                    "WINDOWS": "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_LEFT_RIGHT.WINDOWS" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_LEFT_RIGHT.WINDOWS"
                },
                "ARROW_LEFT_RIGHT_MODIFIER": {
                    "DESCRIPTION": "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_LEFT_RIGHT_MODIFIER.DESCRIPTION" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_LEFT_RIGHT_MODIFIER.DESCRIPTION",
                    "MAC": "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_LEFT_RIGHT_MODIFIER.MAC" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_LEFT_RIGHT_MODIFIER.MAC",
                    "WINDOWS": "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_LEFT_RIGHT_MODIFIER.WINDOWS" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_LEFT_RIGHT_MODIFIER.WINDOWS"
                },
                "ARROW_UP_DOWN": {
                    "DESCRIPTION": "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_UP_DOWN.DESCRIPTION" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_UP_DOWN.DESCRIPTION",
                    "MAC": "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_UP_DOWN.MAC" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_UP_DOWN.MAC",
                    "WINDOWS": "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_UP_DOWN.WINDOWS" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_UP_DOWN.WINDOWS"
                },
                "ARROW_UP_DOWN_MODIFIER": {
                    "DESCRIPTION": "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_UP_DOWN_MODIFIER.DESCRIPTION" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_UP_DOWN_MODIFIER.DESCRIPTION",
                    "MAC": "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_UP_DOWN_MODIFIER.MAC" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_UP_DOWN_MODIFIER.MAC",
                    "WINDOWS": "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_UP_DOWN_MODIFIER.WINDOWS" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_UP_DOWN_MODIFIER.WINDOWS"
                },
                "HORIZONTAL_LOCK": {
                    "DESCRIPTION": "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.HORIZONTAL_LOCK.DESCRIPTION" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.HORIZONTAL_LOCK.DESCRIPTION",
                    "MAC": "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.HORIZONTAL_LOCK.MAC" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.HORIZONTAL_LOCK.MAC",
                    "WINDOWS": "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.HORIZONTAL_LOCK.WINDOWS" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.HORIZONTAL_LOCK.WINDOWS"
                },
                "TITLE": "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.TITLE" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.TITLE",
                "VERTICAL_LOCK": {
                    "DESCRIPTION": "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.VERTICAL_LOCK.DESCRIPTION" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.VERTICAL_LOCK.DESCRIPTION",
                    "MAC": "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.VERTICAL_LOCK.MAC" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.VERTICAL_LOCK.MAC",
                    "WINDOWS": "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.VERTICAL_LOCK.WINDOWS" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.VERTICAL_LOCK.WINDOWS"
                }
            },
            "MULTIPLE_LAYERS_SELECTED": "HELP.BUILDER_KEYBOARD_SHORTCUTS.MULTIPLE_LAYERS_SELECTED" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.MULTIPLE_LAYERS_SELECTED",
            "SHORTCUT_MAC": "HELP.BUILDER_KEYBOARD_SHORTCUTS.SHORTCUT_MAC" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.SHORTCUT_MAC",
            "SHORTCUT_WINDOWS": "HELP.BUILDER_KEYBOARD_SHORTCUTS.SHORTCUT_WINDOWS" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.SHORTCUT_WINDOWS",
            "TITLE": "HELP.BUILDER_KEYBOARD_SHORTCUTS.TITLE" as "HELP.BUILDER_KEYBOARD_SHORTCUTS.TITLE"
        },
        "COMMON": {
            "WHAT_CAN_I_DO": "HELP.COMMON.WHAT_CAN_I_DO" as "HELP.COMMON.WHAT_CAN_I_DO",
            "WHAT_DOES_THIS_MEAN": "HELP.COMMON.WHAT_DOES_THIS_MEAN" as "HELP.COMMON.WHAT_DOES_THIS_MEAN",
            "WHY_AM_I_SEEING_THIS": "HELP.COMMON.WHY_AM_I_SEEING_THIS" as "HELP.COMMON.WHY_AM_I_SEEING_THIS"
        },
        "HELP": "HELP.HELP" as "HELP.HELP",
        "NO_ASSIGNED_LOCATIONS": {
            "CANT_USE_DIGITAL_STACK": "HELP.NO_ASSIGNED_LOCATIONS.CANT_USE_DIGITAL_STACK" as "HELP.NO_ASSIGNED_LOCATIONS.CANT_USE_DIGITAL_STACK",
            "CONTACT_YOUR_AGENCY": "HELP.NO_ASSIGNED_LOCATIONS.CONTACT_YOUR_AGENCY" as "HELP.NO_ASSIGNED_LOCATIONS.CONTACT_YOUR_AGENCY",
            "DONT_HAVE_LOCATIONS_ASSIGNED": "HELP.NO_ASSIGNED_LOCATIONS.DONT_HAVE_LOCATIONS_ASSIGNED" as "HELP.NO_ASSIGNED_LOCATIONS.DONT_HAVE_LOCATIONS_ASSIGNED",
            "TITLE": "HELP.NO_ASSIGNED_LOCATIONS.TITLE" as "HELP.NO_ASSIGNED_LOCATIONS.TITLE"
        }
    },
    "INTEGRATION": {
        "AUTH": {
            "API_KEY": {
                "API_KEY": "INTEGRATION.AUTH.API_KEY.API_KEY" as "INTEGRATION.AUTH.API_KEY.API_KEY",
                "API_KEY_REQUIRED": "INTEGRATION.AUTH.API_KEY.API_KEY_REQUIRED" as "INTEGRATION.AUTH.API_KEY.API_KEY_REQUIRED",
                "API_KEY_REQUIRED_EXPLAIN": "INTEGRATION.AUTH.API_KEY.API_KEY_REQUIRED_EXPLAIN" as "INTEGRATION.AUTH.API_KEY.API_KEY_REQUIRED_EXPLAIN",
                "PREVIOUS_KEY": "INTEGRATION.AUTH.API_KEY.PREVIOUS_KEY" as "INTEGRATION.AUTH.API_KEY.PREVIOUS_KEY",
                "PREVIOUS_KEY_EXPLAIN": "INTEGRATION.AUTH.API_KEY.PREVIOUS_KEY_EXPLAIN" as "INTEGRATION.AUTH.API_KEY.PREVIOUS_KEY_EXPLAIN"
            }
        },
        "CLIENT": {
            "CLUB_READY": {
                "CHAIN_ID": "INTEGRATION.CLIENT.CLUB_READY.CHAIN_ID" as "INTEGRATION.CLIENT.CLUB_READY.CHAIN_ID",
                "ENTER_CHAIN_ID": "INTEGRATION.CLIENT.CLUB_READY.ENTER_CHAIN_ID" as "INTEGRATION.CLIENT.CLUB_READY.ENTER_CHAIN_ID",
                "ENTER_CHAIN_ID_EXPLAIN": "INTEGRATION.CLIENT.CLUB_READY.ENTER_CHAIN_ID_EXPLAIN" as "INTEGRATION.CLIENT.CLUB_READY.ENTER_CHAIN_ID_EXPLAIN",
                "ENTER_CHAIN_ID_WITH_CLIENT_TITLE": "INTEGRATION.CLIENT.CLUB_READY.ENTER_CHAIN_ID_WITH_CLIENT_TITLE" as "INTEGRATION.CLIENT.CLUB_READY.ENTER_CHAIN_ID_WITH_CLIENT_TITLE",
                "MULTIPLE_CHAIN_EXPLAIN": "INTEGRATION.CLIENT.CLUB_READY.MULTIPLE_CHAIN_EXPLAIN" as "INTEGRATION.CLIENT.CLUB_READY.MULTIPLE_CHAIN_EXPLAIN"
            },
            "NOTIFIER": {
                "ISSUE_WITH_ACCOUNT": "INTEGRATION.CLIENT.NOTIFIER.ISSUE_WITH_ACCOUNT" as "INTEGRATION.CLIENT.NOTIFIER.ISSUE_WITH_ACCOUNT",
                "RESOLUTION_1": "INTEGRATION.CLIENT.NOTIFIER.RESOLUTION_1" as "INTEGRATION.CLIENT.NOTIFIER.RESOLUTION_1",
                "RESOLUTION_2": "INTEGRATION.CLIENT.NOTIFIER.RESOLUTION_2" as "INTEGRATION.CLIENT.NOTIFIER.RESOLUTION_2"
            },
            "STATUS_TIP": {
                "DISABLE": "INTEGRATION.CLIENT.STATUS_TIP.DISABLE" as "INTEGRATION.CLIENT.STATUS_TIP.DISABLE",
                "EDIT": "INTEGRATION.CLIENT.STATUS_TIP.EDIT" as "INTEGRATION.CLIENT.STATUS_TIP.EDIT",
                "ENABLE": "INTEGRATION.CLIENT.STATUS_TIP.ENABLE" as "INTEGRATION.CLIENT.STATUS_TIP.ENABLE"
            }
        },
        "CONFIGURE_INTEGRATION": "INTEGRATION.CONFIGURE_INTEGRATION" as "INTEGRATION.CONFIGURE_INTEGRATION",
        "DISABLED_INTEGRATION": "INTEGRATION.DISABLED_INTEGRATION" as "INTEGRATION.DISABLED_INTEGRATION",
        "DISABLE_FOR": "INTEGRATION.DISABLE_FOR" as "INTEGRATION.DISABLE_FOR",
        "EDIT_ACCOUNT_CONFIGURATION": "INTEGRATION.EDIT_ACCOUNT_CONFIGURATION" as "INTEGRATION.EDIT_ACCOUNT_CONFIGURATION",
        "ENABLED_INTEGRATION": "INTEGRATION.ENABLED_INTEGRATION" as "INTEGRATION.ENABLED_INTEGRATION",
        "ENABLE_FOR": "INTEGRATION.ENABLE_FOR" as "INTEGRATION.ENABLE_FOR",
        "ERRORS": {
            "GENERIC_ENABLE_ERROR": "INTEGRATION.ERRORS.GENERIC_ENABLE_ERROR" as "INTEGRATION.ERRORS.GENERIC_ENABLE_ERROR"
        },
        "FITWARE": {
            "NOTIFY_BUSINESS_CLEARED": "INTEGRATION.FITWARE.NOTIFY_BUSINESS_CLEARED" as "INTEGRATION.FITWARE.NOTIFY_BUSINESS_CLEARED",
            "NOTIFY_BUSINESS_SET": "INTEGRATION.FITWARE.NOTIFY_BUSINESS_SET" as "INTEGRATION.FITWARE.NOTIFY_BUSINESS_SET",
            "NOTIFY_CLUB_UPDATED": "INTEGRATION.FITWARE.NOTIFY_CLUB_UPDATED" as "INTEGRATION.FITWARE.NOTIFY_CLUB_UPDATED"
        },
        "INTEGRATIONS": "INTEGRATION.INTEGRATIONS" as "INTEGRATION.INTEGRATIONS",
        "INTEGRATION_CONFIGURATION": "INTEGRATION.INTEGRATION_CONFIGURATION" as "INTEGRATION.INTEGRATION_CONFIGURATION",
        "LOCATION": {
            "CLUB_READY": {
                "CLUB_ID": "INTEGRATION.LOCATION.CLUB_READY.CLUB_ID" as "INTEGRATION.LOCATION.CLUB_READY.CLUB_ID",
                "CLUB_READY_CONFIGURATION": "INTEGRATION.LOCATION.CLUB_READY.CLUB_READY_CONFIGURATION" as "INTEGRATION.LOCATION.CLUB_READY.CLUB_READY_CONFIGURATION",
                "CONFIGURE_SUCCESS": "INTEGRATION.LOCATION.CLUB_READY.CONFIGURE_SUCCESS" as "INTEGRATION.LOCATION.CLUB_READY.CONFIGURE_SUCCESS",
                "ENTER_CLUB_ID": "INTEGRATION.LOCATION.CLUB_READY.ENTER_CLUB_ID" as "INTEGRATION.LOCATION.CLUB_READY.ENTER_CLUB_ID"
            },
            "NO_INTEGRATIONS_TO_CONFIGURE": {
                "EXPLAIN": "INTEGRATION.LOCATION.NO_INTEGRATIONS_TO_CONFIGURE.EXPLAIN" as "INTEGRATION.LOCATION.NO_INTEGRATIONS_TO_CONFIGURE.EXPLAIN",
                "RESOLVE": "INTEGRATION.LOCATION.NO_INTEGRATIONS_TO_CONFIGURE.RESOLVE" as "INTEGRATION.LOCATION.NO_INTEGRATIONS_TO_CONFIGURE.RESOLVE"
            }
        },
        "NOTIFY_ACCESS_CHECK_FAILED": "INTEGRATION.NOTIFY_ACCESS_CHECK_FAILED" as "INTEGRATION.NOTIFY_ACCESS_CHECK_FAILED",
        "NOTIFY_COULD_NOT_AUTHORIZE_SERVICE": "INTEGRATION.NOTIFY_COULD_NOT_AUTHORIZE_SERVICE" as "INTEGRATION.NOTIFY_COULD_NOT_AUTHORIZE_SERVICE",
        "NOTIFY_COULD_NOT_DEAUTHORIZE_SERVICE": "INTEGRATION.NOTIFY_COULD_NOT_DEAUTHORIZE_SERVICE" as "INTEGRATION.NOTIFY_COULD_NOT_DEAUTHORIZE_SERVICE",
        "NOTIFY_SERVICE_DEAUTHORIZED": "INTEGRATION.NOTIFY_SERVICE_DEAUTHORIZED" as "INTEGRATION.NOTIFY_SERVICE_DEAUTHORIZED",
        "PROMPT_CONNECT_TO_GOOGLE_ADS_DIALOG": {
            "PROMPT_TEXT": "INTEGRATION.PROMPT_CONNECT_TO_GOOGLE_ADS_DIALOG.PROMPT_TEXT" as "INTEGRATION.PROMPT_CONNECT_TO_GOOGLE_ADS_DIALOG.PROMPT_TEXT",
            "SIGN_IN_TEXT": "INTEGRATION.PROMPT_CONNECT_TO_GOOGLE_ADS_DIALOG.SIGN_IN_TEXT" as "INTEGRATION.PROMPT_CONNECT_TO_GOOGLE_ADS_DIALOG.SIGN_IN_TEXT",
            "TITLE": "INTEGRATION.PROMPT_CONNECT_TO_GOOGLE_ADS_DIALOG.TITLE" as "INTEGRATION.PROMPT_CONNECT_TO_GOOGLE_ADS_DIALOG.TITLE"
        },
        "SETUP_INTEGRATIONS_FOR": "INTEGRATION.SETUP_INTEGRATIONS_FOR" as "INTEGRATION.SETUP_INTEGRATIONS_FOR"
    },
    "INTRO": {
        "ACCOUNT": {
            "COMPLETE": {
                "HEADING": "INTRO.ACCOUNT.COMPLETE.HEADING" as "INTRO.ACCOUNT.COMPLETE.HEADING",
                "SUBHEADING": "INTRO.ACCOUNT.COMPLETE.SUBHEADING" as "INTRO.ACCOUNT.COMPLETE.SUBHEADING",
                "TIP": "INTRO.ACCOUNT.COMPLETE.TIP" as "INTRO.ACCOUNT.COMPLETE.TIP"
            },
            "PAGE": {
                "ONE": {
                    "DONE_LABEL": "INTRO.ACCOUNT.PAGE.ONE.DONE_LABEL" as "INTRO.ACCOUNT.PAGE.ONE.DONE_LABEL",
                    "STEP": {
                        "ONE": "INTRO.ACCOUNT.PAGE.ONE.STEP.ONE" as "INTRO.ACCOUNT.PAGE.ONE.STEP.ONE"
                    }
                },
                "TWO": {
                    "DONE_LABEL": "INTRO.ACCOUNT.PAGE.TWO.DONE_LABEL" as "INTRO.ACCOUNT.PAGE.TWO.DONE_LABEL",
                    "STEP": {
                        "ONE": "INTRO.ACCOUNT.PAGE.TWO.STEP.ONE" as "INTRO.ACCOUNT.PAGE.TWO.STEP.ONE"
                    }
                }
            },
            "TITLE": "INTRO.ACCOUNT.TITLE" as "INTRO.ACCOUNT.TITLE"
        },
        "ALREADY_KNOW_HOW_THIS_WORKS": "INTRO.ALREADY_KNOW_HOW_THIS_WORKS" as "INTRO.ALREADY_KNOW_HOW_THIS_WORKS",
        "APPS": {
            "COMPLETE": {
                "HEADING": "INTRO.APPS.COMPLETE.HEADING" as "INTRO.APPS.COMPLETE.HEADING",
                "SUBHEADING": "INTRO.APPS.COMPLETE.SUBHEADING" as "INTRO.APPS.COMPLETE.SUBHEADING",
                "TIP": "INTRO.APPS.COMPLETE.TIP" as "INTRO.APPS.COMPLETE.TIP"
            },
            "PAGE": {
                "ONE": {
                    "DONE_LABEL": "INTRO.APPS.PAGE.ONE.DONE_LABEL" as "INTRO.APPS.PAGE.ONE.DONE_LABEL",
                    "STEP": {
                        "ONE": "INTRO.APPS.PAGE.ONE.STEP.ONE" as "INTRO.APPS.PAGE.ONE.STEP.ONE"
                    }
                },
                "TWO": {
                    "DONE_LABEL": "INTRO.APPS.PAGE.TWO.DONE_LABEL" as "INTRO.APPS.PAGE.TWO.DONE_LABEL",
                    "STEP": {
                        "ONE": "INTRO.APPS.PAGE.TWO.STEP.ONE" as "INTRO.APPS.PAGE.TWO.STEP.ONE",
                        "TWO": "INTRO.APPS.PAGE.TWO.STEP.TWO" as "INTRO.APPS.PAGE.TWO.STEP.TWO"
                    }
                }
            },
            "TITLE": "INTRO.APPS.TITLE" as "INTRO.APPS.TITLE"
        },
        "BUILD": {
            "COMPLETE": {
                "HEADING": "INTRO.BUILD.COMPLETE.HEADING" as "INTRO.BUILD.COMPLETE.HEADING",
                "SUBHEADING": "INTRO.BUILD.COMPLETE.SUBHEADING" as "INTRO.BUILD.COMPLETE.SUBHEADING",
                "TIP": "INTRO.BUILD.COMPLETE.TIP" as "INTRO.BUILD.COMPLETE.TIP"
            },
            "PAGE": {
                "FIVE": {
                    "DONE_LABEL": "INTRO.BUILD.PAGE.FIVE.DONE_LABEL" as "INTRO.BUILD.PAGE.FIVE.DONE_LABEL",
                    "STEP": {
                        "ONE": "INTRO.BUILD.PAGE.FIVE.STEP.ONE" as "INTRO.BUILD.PAGE.FIVE.STEP.ONE",
                        "THREE": "INTRO.BUILD.PAGE.FIVE.STEP.THREE" as "INTRO.BUILD.PAGE.FIVE.STEP.THREE",
                        "TWO": "INTRO.BUILD.PAGE.FIVE.STEP.TWO" as "INTRO.BUILD.PAGE.FIVE.STEP.TWO"
                    }
                },
                "FOUR": {
                    "DONE_LABEL": "INTRO.BUILD.PAGE.FOUR.DONE_LABEL" as "INTRO.BUILD.PAGE.FOUR.DONE_LABEL",
                    "STEP": {
                        "ONE": "INTRO.BUILD.PAGE.FOUR.STEP.ONE" as "INTRO.BUILD.PAGE.FOUR.STEP.ONE",
                        "THREE": "INTRO.BUILD.PAGE.FOUR.STEP.THREE" as "INTRO.BUILD.PAGE.FOUR.STEP.THREE",
                        "TWO": "INTRO.BUILD.PAGE.FOUR.STEP.TWO" as "INTRO.BUILD.PAGE.FOUR.STEP.TWO"
                    }
                },
                "ONE": {
                    "DONE_LABEL": "INTRO.BUILD.PAGE.ONE.DONE_LABEL" as "INTRO.BUILD.PAGE.ONE.DONE_LABEL",
                    "STEP": {
                        "ONE": "INTRO.BUILD.PAGE.ONE.STEP.ONE" as "INTRO.BUILD.PAGE.ONE.STEP.ONE",
                        "TWO": "INTRO.BUILD.PAGE.ONE.STEP.TWO" as "INTRO.BUILD.PAGE.ONE.STEP.TWO"
                    }
                },
                "THREE": {
                    "DONE_LABEL": "INTRO.BUILD.PAGE.THREE.DONE_LABEL" as "INTRO.BUILD.PAGE.THREE.DONE_LABEL",
                    "STEP": {
                        "ONE": "INTRO.BUILD.PAGE.THREE.STEP.ONE" as "INTRO.BUILD.PAGE.THREE.STEP.ONE"
                    }
                },
                "TWO": {
                    "DONE_LABEL": "INTRO.BUILD.PAGE.TWO.DONE_LABEL" as "INTRO.BUILD.PAGE.TWO.DONE_LABEL",
                    "STEP": {
                        "ONE": "INTRO.BUILD.PAGE.TWO.STEP.ONE" as "INTRO.BUILD.PAGE.TWO.STEP.ONE",
                        "TWO": "INTRO.BUILD.PAGE.TWO.STEP.TWO" as "INTRO.BUILD.PAGE.TWO.STEP.TWO"
                    }
                }
            },
            "TITLE": "INTRO.BUILD.TITLE" as "INTRO.BUILD.TITLE"
        },
        "CANCEL_TOUR_MESSAGE": "INTRO.CANCEL_TOUR_MESSAGE" as "INTRO.CANCEL_TOUR_MESSAGE",
        "CANCEL_TOUR_TITLE": "INTRO.CANCEL_TOUR_TITLE" as "INTRO.CANCEL_TOUR_TITLE",
        "COMPLETED_ALL_THE_ITEMS": "INTRO.COMPLETED_ALL_THE_ITEMS" as "INTRO.COMPLETED_ALL_THE_ITEMS",
        "COMPLETE_THESE_ITEMS_LATER": "INTRO.COMPLETE_THESE_ITEMS_LATER" as "INTRO.COMPLETE_THESE_ITEMS_LATER",
        "COMPLETE_THE_TOUR": "INTRO.COMPLETE_THE_TOUR" as "INTRO.COMPLETE_THE_TOUR",
        "CONGRATULATIONS": "INTRO.CONGRATULATIONS" as "INTRO.CONGRATULATIONS",
        "DONE_LABEL": "INTRO.DONE_LABEL" as "INTRO.DONE_LABEL",
        "EXAMPLE_PLANNER_TITLE": "INTRO.EXAMPLE_PLANNER_TITLE" as "INTRO.EXAMPLE_PLANNER_TITLE",
        "EXAMPLE_TEMPLATE_TITLE": "INTRO.EXAMPLE_TEMPLATE_TITLE" as "INTRO.EXAMPLE_TEMPLATE_TITLE",
        "FIND_OUT_WHAT": "INTRO.FIND_OUT_WHAT" as "INTRO.FIND_OUT_WHAT",
        "HELP_US_MAKE": "INTRO.HELP_US_MAKE" as "INTRO.HELP_US_MAKE",
        "IM_READY": "INTRO.IM_READY" as "INTRO.IM_READY",
        "IT_LOOKS_LIKE_YOURE_NEW": "INTRO.IT_LOOKS_LIKE_YOURE_NEW" as "INTRO.IT_LOOKS_LIKE_YOURE_NEW",
        "LEARN": {
            "COMPLETE": {
                "HEADING": "INTRO.LEARN.COMPLETE.HEADING" as "INTRO.LEARN.COMPLETE.HEADING",
                "SUBHEADING": "INTRO.LEARN.COMPLETE.SUBHEADING" as "INTRO.LEARN.COMPLETE.SUBHEADING",
                "TIP": "INTRO.LEARN.COMPLETE.TIP" as "INTRO.LEARN.COMPLETE.TIP"
            },
            "PAGE": {
                "ONE": {
                    "DONE_LABEL": "INTRO.LEARN.PAGE.ONE.DONE_LABEL" as "INTRO.LEARN.PAGE.ONE.DONE_LABEL",
                    "STEP": {
                        "ONE": "INTRO.LEARN.PAGE.ONE.STEP.ONE" as "INTRO.LEARN.PAGE.ONE.STEP.ONE"
                    }
                },
                "TWO": {
                    "DONE_LABEL": "INTRO.LEARN.PAGE.TWO.DONE_LABEL" as "INTRO.LEARN.PAGE.TWO.DONE_LABEL",
                    "STEP": {
                        "ONE": "INTRO.LEARN.PAGE.TWO.STEP.ONE" as "INTRO.LEARN.PAGE.TWO.STEP.ONE",
                        "TWO": "INTRO.LEARN.PAGE.TWO.STEP.TWO" as "INTRO.LEARN.PAGE.TWO.STEP.TWO"
                    }
                }
            },
            "TITLE": "INTRO.LEARN.TITLE" as "INTRO.LEARN.TITLE"
        },
        "LETS_CONTINUE": "INTRO.LETS_CONTINUE" as "INTRO.LETS_CONTINUE",
        "LET_ME_DO_IT_SOME_MORE": "INTRO.LET_ME_DO_IT_SOME_MORE" as "INTRO.LET_ME_DO_IT_SOME_MORE",
        "MOST_PEOPLE_ARE_SURPRISED": "INTRO.MOST_PEOPLE_ARE_SURPRISED" as "INTRO.MOST_PEOPLE_ARE_SURPRISED",
        "NOTIFY_POSTPONE_TOUR": "INTRO.NOTIFY_POSTPONE_TOUR" as "INTRO.NOTIFY_POSTPONE_TOUR",
        "NOTIFY_STOP_TOUR": "INTRO.NOTIFY_STOP_TOUR" as "INTRO.NOTIFY_STOP_TOUR",
        "OK_THAT_MAKES_SENSE": "INTRO.OK_THAT_MAKES_SENSE" as "INTRO.OK_THAT_MAKES_SENSE",
        "PLAN": {
            "COMPLETE": {
                "HEADING": "INTRO.PLAN.COMPLETE.HEADING" as "INTRO.PLAN.COMPLETE.HEADING",
                "SUBHEADING": "INTRO.PLAN.COMPLETE.SUBHEADING" as "INTRO.PLAN.COMPLETE.SUBHEADING",
                "TIP": "INTRO.PLAN.COMPLETE.TIP" as "INTRO.PLAN.COMPLETE.TIP"
            },
            "PAGE": {
                "ONE": {
                    "DONE_LABEL": "INTRO.PLAN.PAGE.ONE.DONE_LABEL" as "INTRO.PLAN.PAGE.ONE.DONE_LABEL",
                    "STEP": {
                        "ONE": "INTRO.PLAN.PAGE.ONE.STEP.ONE" as "INTRO.PLAN.PAGE.ONE.STEP.ONE"
                    }
                },
                "THREE": {
                    "DONE_LABEL": "INTRO.PLAN.PAGE.THREE.DONE_LABEL" as "INTRO.PLAN.PAGE.THREE.DONE_LABEL",
                    "STEP": {
                        "FIVE": "INTRO.PLAN.PAGE.THREE.STEP.FIVE" as "INTRO.PLAN.PAGE.THREE.STEP.FIVE",
                        "FOUR": "INTRO.PLAN.PAGE.THREE.STEP.FOUR" as "INTRO.PLAN.PAGE.THREE.STEP.FOUR",
                        "ONE": "INTRO.PLAN.PAGE.THREE.STEP.ONE" as "INTRO.PLAN.PAGE.THREE.STEP.ONE",
                        "SEVEN": "INTRO.PLAN.PAGE.THREE.STEP.SEVEN" as "INTRO.PLAN.PAGE.THREE.STEP.SEVEN",
                        "SIX": "INTRO.PLAN.PAGE.THREE.STEP.SIX" as "INTRO.PLAN.PAGE.THREE.STEP.SIX",
                        "THREE": "INTRO.PLAN.PAGE.THREE.STEP.THREE" as "INTRO.PLAN.PAGE.THREE.STEP.THREE",
                        "TWO": "INTRO.PLAN.PAGE.THREE.STEP.TWO" as "INTRO.PLAN.PAGE.THREE.STEP.TWO"
                    }
                },
                "TWO": {
                    "DONE_LABEL": "INTRO.PLAN.PAGE.TWO.DONE_LABEL" as "INTRO.PLAN.PAGE.TWO.DONE_LABEL",
                    "STEP": {
                        "EIGHT": "INTRO.PLAN.PAGE.TWO.STEP.EIGHT" as "INTRO.PLAN.PAGE.TWO.STEP.EIGHT",
                        "FIVE": "INTRO.PLAN.PAGE.TWO.STEP.FIVE" as "INTRO.PLAN.PAGE.TWO.STEP.FIVE",
                        "FOUR": "INTRO.PLAN.PAGE.TWO.STEP.FOUR" as "INTRO.PLAN.PAGE.TWO.STEP.FOUR",
                        "ONE": "INTRO.PLAN.PAGE.TWO.STEP.ONE" as "INTRO.PLAN.PAGE.TWO.STEP.ONE",
                        "SEVEN": "INTRO.PLAN.PAGE.TWO.STEP.SEVEN" as "INTRO.PLAN.PAGE.TWO.STEP.SEVEN",
                        "SIX": "INTRO.PLAN.PAGE.TWO.STEP.SIX" as "INTRO.PLAN.PAGE.TWO.STEP.SIX",
                        "THREE": "INTRO.PLAN.PAGE.TWO.STEP.THREE" as "INTRO.PLAN.PAGE.TWO.STEP.THREE",
                        "TWO": "INTRO.PLAN.PAGE.TWO.STEP.TWO" as "INTRO.PLAN.PAGE.TWO.STEP.TWO"
                    }
                }
            },
            "TITLE": "INTRO.PLAN.TITLE" as "INTRO.PLAN.TITLE"
        },
        "PLEASE_ACCEPT_THIS": "INTRO.PLEASE_ACCEPT_THIS" as "INTRO.PLEASE_ACCEPT_THIS",
        "QUICK_TIP": "INTRO.QUICK_TIP" as "INTRO.QUICK_TIP",
        "REPORT": {
            "COMPLETE": {
                "HEADING": "INTRO.REPORT.COMPLETE.HEADING" as "INTRO.REPORT.COMPLETE.HEADING",
                "SUBHEADING": "INTRO.REPORT.COMPLETE.SUBHEADING" as "INTRO.REPORT.COMPLETE.SUBHEADING",
                "TIP": "INTRO.REPORT.COMPLETE.TIP" as "INTRO.REPORT.COMPLETE.TIP"
            },
            "PAGE": {
                "ONE": {
                    "DONE_LABEL": "INTRO.REPORT.PAGE.ONE.DONE_LABEL" as "INTRO.REPORT.PAGE.ONE.DONE_LABEL",
                    "STEP": {
                        "ONE": "INTRO.REPORT.PAGE.ONE.STEP.ONE" as "INTRO.REPORT.PAGE.ONE.STEP.ONE"
                    }
                },
                "TWO": {
                    "DONE_LABEL": "INTRO.REPORT.PAGE.TWO.DONE_LABEL" as "INTRO.REPORT.PAGE.TWO.DONE_LABEL",
                    "STEP": {
                        "FOUR": "INTRO.REPORT.PAGE.TWO.STEP.FOUR" as "INTRO.REPORT.PAGE.TWO.STEP.FOUR",
                        "ONE": "INTRO.REPORT.PAGE.TWO.STEP.ONE" as "INTRO.REPORT.PAGE.TWO.STEP.ONE",
                        "THREE": "INTRO.REPORT.PAGE.TWO.STEP.THREE" as "INTRO.REPORT.PAGE.TWO.STEP.THREE",
                        "TWO": "INTRO.REPORT.PAGE.TWO.STEP.TWO" as "INTRO.REPORT.PAGE.TWO.STEP.TWO"
                    }
                }
            },
            "TITLE": "INTRO.REPORT.TITLE" as "INTRO.REPORT.TITLE"
        },
        "RESET_ALL": "INTRO.RESET_ALL" as "INTRO.RESET_ALL",
        "SHOW_ME": "INTRO.SHOW_ME" as "INTRO.SHOW_ME",
        "SHOW_ME_COMPLETED": "INTRO.SHOW_ME_COMPLETED" as "INTRO.SHOW_ME_COMPLETED",
        "SKIP_LABEL": "INTRO.SKIP_LABEL" as "INTRO.SKIP_LABEL",
        "TICK_OFF_THE_ITEMS_BELOW": "INTRO.TICK_OFF_THE_ITEMS_BELOW" as "INTRO.TICK_OFF_THE_ITEMS_BELOW",
        "VIDEO": {
            "TITLE": "INTRO.VIDEO.TITLE" as "INTRO.VIDEO.TITLE"
        },
        "WELCOME_TO_DIGITAL_STACK": "INTRO.WELCOME_TO_DIGITAL_STACK" as "INTRO.WELCOME_TO_DIGITAL_STACK",
        "YOURE_READY_FOR_THE_STACK": "INTRO.YOURE_READY_FOR_THE_STACK" as "INTRO.YOURE_READY_FOR_THE_STACK",
        "YOUVE_GOT_THROUGH_THEM_ALL": "INTRO.YOUVE_GOT_THROUGH_THEM_ALL" as "INTRO.YOUVE_GOT_THROUGH_THEM_ALL"
    },
    "LEARN": {
        "ADD_NEW_ITEM": "LEARN.ADD_NEW_ITEM" as "LEARN.ADD_NEW_ITEM",
        "ADD_NEW_LEARN_ITEM": "LEARN.ADD_NEW_LEARN_ITEM" as "LEARN.ADD_NEW_LEARN_ITEM",
        "APPLICATION_WIDE": "LEARN.APPLICATION_WIDE" as "LEARN.APPLICATION_WIDE",
        "DELETE_CONFIRM": "LEARN.DELETE_CONFIRM" as "LEARN.DELETE_CONFIRM",
        "EDIT_ITEM": "LEARN.EDIT_ITEM" as "LEARN.EDIT_ITEM",
        "EDIT_LEARN_ITEM": "LEARN.EDIT_LEARN_ITEM" as "LEARN.EDIT_LEARN_ITEM",
        "EMAIL": {
            "COMMENT_ADDED_TO_LEARN_ARTICLE": "LEARN.EMAIL.COMMENT_ADDED_TO_LEARN_ARTICLE" as "LEARN.EMAIL.COMMENT_ADDED_TO_LEARN_ARTICLE",
            "VIEW_LEARN_ARTICLE": "LEARN.EMAIL.VIEW_LEARN_ARTICLE" as "LEARN.EMAIL.VIEW_LEARN_ARTICLE"
        },
        "HELPFUL": "LEARN.HELPFUL" as "LEARN.HELPFUL",
        "LOADING": "LEARN.LOADING" as "LEARN.LOADING",
        "MAX_UPLOAD_ERROR": "LEARN.MAX_UPLOAD_ERROR" as "LEARN.MAX_UPLOAD_ERROR",
        "NOTIFY_LEARN_CREATED": "LEARN.NOTIFY_LEARN_CREATED" as "LEARN.NOTIFY_LEARN_CREATED",
        "NOTIFY_LEARN_UPDATED": "LEARN.NOTIFY_LEARN_UPDATED" as "LEARN.NOTIFY_LEARN_UPDATED",
        "NO_ARTICLES": "LEARN.NO_ARTICLES" as "LEARN.NO_ARTICLES",
        "NO_LEARN_AVAILABLE": "LEARN.NO_LEARN_AVAILABLE" as "LEARN.NO_LEARN_AVAILABLE",
        "RECENT_ARTICLES": "LEARN.RECENT_ARTICLES" as "LEARN.RECENT_ARTICLES",
        "RETRIEVE_ALL_LEARN_ARTICLES": "LEARN.RETRIEVE_ALL_LEARN_ARTICLES" as "LEARN.RETRIEVE_ALL_LEARN_ARTICLES",
        "RETRIEVE_MORE_LEARN_ARTICLES": "LEARN.RETRIEVE_MORE_LEARN_ARTICLES" as "LEARN.RETRIEVE_MORE_LEARN_ARTICLES",
        "TAG_NAME": "LEARN.TAG_NAME" as "LEARN.TAG_NAME",
        "THANKS_FEEDBACK": "LEARN.THANKS_FEEDBACK" as "LEARN.THANKS_FEEDBACK",
        "THUMBNAIL": {
            "CREATE_VIDEO_THUMBNAIL": "LEARN.THUMBNAIL.CREATE_VIDEO_THUMBNAIL" as "LEARN.THUMBNAIL.CREATE_VIDEO_THUMBNAIL",
            "GENERATE_FROM_VIDEO": "LEARN.THUMBNAIL.GENERATE_FROM_VIDEO" as "LEARN.THUMBNAIL.GENERATE_FROM_VIDEO",
            "SLIDER_HELP": "LEARN.THUMBNAIL.SLIDER_HELP" as "LEARN.THUMBNAIL.SLIDER_HELP",
            "UPLOAD_CUSTOM": "LEARN.THUMBNAIL.UPLOAD_CUSTOM" as "LEARN.THUMBNAIL.UPLOAD_CUSTOM",
            "UPLOAD_NEW_THUMBNAIL": "LEARN.THUMBNAIL.UPLOAD_NEW_THUMBNAIL" as "LEARN.THUMBNAIL.UPLOAD_NEW_THUMBNAIL"
        },
        "TRY_THIS_DELETED": "LEARN.TRY_THIS_DELETED" as "LEARN.TRY_THIS_DELETED"
    },
    "LOGIN": {
        "EMAIL": {
            "INVITE": {
                "CLICK_BUTTON_TO_LOG_IN": "LOGIN.EMAIL.INVITE.CLICK_BUTTON_TO_LOG_IN" as "LOGIN.EMAIL.INVITE.CLICK_BUTTON_TO_LOG_IN",
                "LOG_INTO_DIGITAL_STACK": "LOGIN.EMAIL.INVITE.LOG_INTO_DIGITAL_STACK" as "LOGIN.EMAIL.INVITE.LOG_INTO_DIGITAL_STACK",
                "YOU_HAVE_BEEN_INVITED": "LOGIN.EMAIL.INVITE.YOU_HAVE_BEEN_INVITED" as "LOGIN.EMAIL.INVITE.YOU_HAVE_BEEN_INVITED"
            },
            "RESET_PASSWORD": {
                "IF_YOU_DID_NOT_REQUEST_THIS": "LOGIN.EMAIL.RESET_PASSWORD.IF_YOU_DID_NOT_REQUEST_THIS" as "LOGIN.EMAIL.RESET_PASSWORD.IF_YOU_DID_NOT_REQUEST_THIS",
                "PASSWORD_RESET_INSTRUCTIONS": "LOGIN.EMAIL.RESET_PASSWORD.PASSWORD_RESET_INSTRUCTIONS" as "LOGIN.EMAIL.RESET_PASSWORD.PASSWORD_RESET_INSTRUCTIONS",
                "RESET_MY_PASSWORD": "LOGIN.EMAIL.RESET_PASSWORD.RESET_MY_PASSWORD" as "LOGIN.EMAIL.RESET_PASSWORD.RESET_MY_PASSWORD",
                "SOMEONE_REQUESTED_TO_RESET_PASSWORD": "LOGIN.EMAIL.RESET_PASSWORD.SOMEONE_REQUESTED_TO_RESET_PASSWORD" as "LOGIN.EMAIL.RESET_PASSWORD.SOMEONE_REQUESTED_TO_RESET_PASSWORD",
                "TO_RESET_CLICK_LINK": "LOGIN.EMAIL.RESET_PASSWORD.TO_RESET_CLICK_LINK" as "LOGIN.EMAIL.RESET_PASSWORD.TO_RESET_CLICK_LINK"
            },
            "WELCOME_TO_DIGITAL_STACK": "LOGIN.EMAIL.WELCOME_TO_DIGITAL_STACK" as "LOGIN.EMAIL.WELCOME_TO_DIGITAL_STACK"
        },
        "ERROR_SENDING_PASSWORD_RESET_INSTRUCTIONS": "LOGIN.ERROR_SENDING_PASSWORD_RESET_INSTRUCTIONS" as "LOGIN.ERROR_SENDING_PASSWORD_RESET_INSTRUCTIONS",
        "FORGOTTEN_PASSWORD": "LOGIN.FORGOTTEN_PASSWORD" as "LOGIN.FORGOTTEN_PASSWORD",
        "FORGOT_PASSWORD": "LOGIN.FORGOT_PASSWORD" as "LOGIN.FORGOT_PASSWORD",
        "INVALID_EMAIL_ADDRESS": "LOGIN.INVALID_EMAIL_ADDRESS" as "LOGIN.INVALID_EMAIL_ADDRESS",
        "LOGIN": "LOGIN.LOGIN" as "LOGIN.LOGIN",
        "LOGIN_CONFIRM_IDENTITY": "LOGIN.LOGIN_CONFIRM_IDENTITY" as "LOGIN.LOGIN_CONFIRM_IDENTITY",
        "LOGIN_TO_LINK_ACCOUNTS": "LOGIN.LOGIN_TO_LINK_ACCOUNTS" as "LOGIN.LOGIN_TO_LINK_ACCOUNTS",
        "PASSWORD": "LOGIN.PASSWORD" as "LOGIN.PASSWORD",
        "PASSWORDS_DONT_MATCH": "LOGIN.PASSWORDS_DONT_MATCH" as "LOGIN.PASSWORDS_DONT_MATCH",
        "PASSWORD_AGAIN": "LOGIN.PASSWORD_AGAIN" as "LOGIN.PASSWORD_AGAIN",
        "PASSWORD_RESET_FAILED": "LOGIN.PASSWORD_RESET_FAILED" as "LOGIN.PASSWORD_RESET_FAILED",
        "PASSWORD_RESET_INSTRUCTIONS": "LOGIN.PASSWORD_RESET_INSTRUCTIONS" as "LOGIN.PASSWORD_RESET_INSTRUCTIONS",
        "PASSWORD_RESET_INSTRUCTIONS_SENT": "LOGIN.PASSWORD_RESET_INSTRUCTIONS_SENT" as "LOGIN.PASSWORD_RESET_INSTRUCTIONS_SENT",
        "PASSWORD_RESET_PLEASE_LOGIN": "LOGIN.PASSWORD_RESET_PLEASE_LOGIN" as "LOGIN.PASSWORD_RESET_PLEASE_LOGIN",
        "PASSWORD_TOO_SHORT": "LOGIN.PASSWORD_TOO_SHORT" as "LOGIN.PASSWORD_TOO_SHORT",
        "PASSWORD_TOO_SHORT_plural": "LOGIN.PASSWORD_TOO_SHORT_plural" as "LOGIN.PASSWORD_TOO_SHORT_plural",
        "PROBLEM_WITH_INVITE_LINK": "LOGIN.PROBLEM_WITH_INVITE_LINK" as "LOGIN.PROBLEM_WITH_INVITE_LINK",
        "PROBLEM_WITH_LINK": "LOGIN.PROBLEM_WITH_LINK" as "LOGIN.PROBLEM_WITH_LINK",
        "REQUEST_PASSWORD_RESET": "LOGIN.REQUEST_PASSWORD_RESET" as "LOGIN.REQUEST_PASSWORD_RESET",
        "RESET_PASSWORD": "LOGIN.RESET_PASSWORD" as "LOGIN.RESET_PASSWORD",
        "SEND_PASSWORD_RESET": "LOGIN.SEND_PASSWORD_RESET" as "LOGIN.SEND_PASSWORD_RESET",
        "SEND_PASSWORD_RESET_EMAIL_CONFIRMATION_MODAL": {
            "BODY": "LOGIN.SEND_PASSWORD_RESET_EMAIL_CONFIRMATION_MODAL.BODY" as "LOGIN.SEND_PASSWORD_RESET_EMAIL_CONFIRMATION_MODAL.BODY"
        },
        "SIGNED_IN_AS": "LOGIN.SIGNED_IN_AS" as "LOGIN.SIGNED_IN_AS",
        "SIGNED_OUT": "LOGIN.SIGNED_OUT" as "LOGIN.SIGNED_OUT",
        "USERNAME": "LOGIN.USERNAME" as "LOGIN.USERNAME",
        "USERNAME_PASSWORD_INCORRECT_ERROR": "LOGIN.USERNAME_PASSWORD_INCORRECT_ERROR" as "LOGIN.USERNAME_PASSWORD_INCORRECT_ERROR",
        "WELCOME_TO_DIGITAL_STACK": "LOGIN.WELCOME_TO_DIGITAL_STACK" as "LOGIN.WELCOME_TO_DIGITAL_STACK",
        "YOU_WILL_RECEIVE_PASSWORD_RESET_INSTRUCTIONS_SHORTLY": "LOGIN.YOU_WILL_RECEIVE_PASSWORD_RESET_INSTRUCTIONS_SHORTLY" as "LOGIN.YOU_WILL_RECEIVE_PASSWORD_RESET_INSTRUCTIONS_SHORTLY"
    },
    "MARKETING": {
        "EMAILS": {
            "WEEKLY_MARKETING_UPDATE": {
                "COMPLETE_MY_MONTH_PLANNER": "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.COMPLETE_MY_MONTH_PLANNER" as "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.COMPLETE_MY_MONTH_PLANNER",
                "COUNT_ACTIVITIES_AWAITING_CONTENT": "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.COUNT_ACTIVITIES_AWAITING_CONTENT" as "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.COUNT_ACTIVITIES_AWAITING_CONTENT",
                "COUNT_ACTIVITIES_AWAITING_CONTENT_plural": "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.COUNT_ACTIVITIES_AWAITING_CONTENT_plural" as "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.COUNT_ACTIVITIES_AWAITING_CONTENT_plural",
                "COUNT_ACTIVITIES_PLANNED": "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.COUNT_ACTIVITIES_PLANNED" as "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.COUNT_ACTIVITIES_PLANNED",
                "COUNT_ACTIVITIES_PLANNED_plural": "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.COUNT_ACTIVITIES_PLANNED_plural" as "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.COUNT_ACTIVITIES_PLANNED_plural",
                "FIND_YOUR_UPDATE_BELOW": "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.FIND_YOUR_UPDATE_BELOW" as "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.FIND_YOUR_UPDATE_BELOW",
                "FIND_YOUR_UPDATE_BELOW_MULTIPLE_LOCATIONS": "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.FIND_YOUR_UPDATE_BELOW_MULTIPLE_LOCATIONS" as "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.FIND_YOUR_UPDATE_BELOW_MULTIPLE_LOCATIONS",
                "GET_ON_TOP_OF_YOUR_PLANNING_FOR_MONTH": "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.GET_ON_TOP_OF_YOUR_PLANNING_FOR_MONTH" as "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.GET_ON_TOP_OF_YOUR_PLANNING_FOR_MONTH",
                "LOCATION_FOR_MONTH": "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.LOCATION_FOR_MONTH" as "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.LOCATION_FOR_MONTH",
                "NO_ACTIVITIES_PLANNED": "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.NO_ACTIVITIES_PLANNED" as "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.NO_ACTIVITIES_PLANNED",
                "VIEW_MY_MONTH_PLANNER": "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.VIEW_MY_MONTH_PLANNER" as "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.VIEW_MY_MONTH_PLANNER",
                "WEEKLY_MARKETING_UPDATE": "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.WEEKLY_MARKETING_UPDATE" as "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.WEEKLY_MARKETING_UPDATE",
                "WHATS_ON_THIS_WEEK_AT_LOCATION": "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.WHATS_ON_THIS_WEEK_AT_LOCATION" as "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.WHATS_ON_THIS_WEEK_AT_LOCATION",
                "YOUR_WEEKLY_UPDATE": "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.YOUR_WEEKLY_UPDATE" as "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.YOUR_WEEKLY_UPDATE"
            }
        }
    },
    "MENU": {
        "ACCOUNT": "MENU.ACCOUNT" as "MENU.ACCOUNT",
        "ADMIN": "MENU.ADMIN" as "MENU.ADMIN",
        "AGENCIES": "MENU.AGENCIES" as "MENU.AGENCIES",
        "AGENCY": "MENU.AGENCY" as "MENU.AGENCY",
        "ASSETS": "MENU.ASSETS" as "MENU.ASSETS",
        "BRAND": "MENU.BRAND" as "MENU.BRAND",
        "BRANDS": "MENU.BRANDS" as "MENU.BRANDS",
        "BRAND_SETTINGS": "MENU.BRAND_SETTINGS" as "MENU.BRAND_SETTINGS",
        "BUILD": "MENU.BUILD" as "MENU.BUILD",
        "CALENDAR": "MENU.CALENDAR" as "MENU.CALENDAR",
        "CALENDAR_ACTIVITIES": "MENU.CALENDAR_ACTIVITIES" as "MENU.CALENDAR_ACTIVITIES",
        "CLIENTS": "MENU.CLIENTS" as "MENU.CLIENTS",
        "CLOSE_NAVIGATION": "MENU.CLOSE_NAVIGATION" as "MENU.CLOSE_NAVIGATION",
        "COLORS": "MENU.COLORS" as "MENU.COLORS",
        "COMMUNICATE": "MENU.COMMUNICATE" as "MENU.COMMUNICATE",
        "CONNECT": "MENU.CONNECT" as "MENU.CONNECT",
        "CONNECTIONS": "MENU.CONNECTIONS" as "MENU.CONNECTIONS",
        "FONTS": "MENU.FONTS" as "MENU.FONTS",
        "HASHTAG_SETS": "MENU.HASHTAG_SETS" as "MENU.HASHTAG_SETS",
        "HELP": "MENU.HELP" as "MENU.HELP",
        "INTEGRATIONS": "MENU.INTEGRATIONS" as "MENU.INTEGRATIONS",
        "LEARN": "MENU.LEARN" as "MENU.LEARN",
        "LEARN_MENU": "MENU.LEARN_MENU" as "MENU.LEARN_MENU",
        "LOCATION": "MENU.LOCATION" as "MENU.LOCATION",
        "LOCATIONS": "MENU.LOCATIONS" as "MENU.LOCATIONS",
        "LOCATION_ACTIVITY": "MENU.LOCATION_ACTIVITY" as "MENU.LOCATION_ACTIVITY",
        "LOCATION_DETAILS": "MENU.LOCATION_DETAILS" as "MENU.LOCATION_DETAILS",
        "LOCATION_USERS": "MENU.LOCATION_USERS" as "MENU.LOCATION_USERS",
        "MAIN_NAVIGATION": "MENU.MAIN_NAVIGATION" as "MENU.MAIN_NAVIGATION",
        "MARK_ALL_AS_READ": "MENU.MARK_ALL_AS_READ" as "MENU.MARK_ALL_AS_READ",
        "MORE": "MENU.MORE" as "MENU.MORE",
        "NOTIFICATIONS": "MENU.NOTIFICATIONS" as "MENU.NOTIFICATIONS",
        "NOTIFICATION_COULD_NOT_BE_MARKED_AS_READ": "MENU.NOTIFICATION_COULD_NOT_BE_MARKED_AS_READ" as "MENU.NOTIFICATION_COULD_NOT_BE_MARKED_AS_READ",
        "OPEN_NAVIGATION": "MENU.OPEN_NAVIGATION" as "MENU.OPEN_NAVIGATION",
        "OVERVIEW": "MENU.OVERVIEW" as "MENU.OVERVIEW",
        "PAYMENTS": "MENU.PAYMENTS" as "MENU.PAYMENTS",
        "PERFORMANCE": "MENU.PERFORMANCE" as "MENU.PERFORMANCE",
        "PLAN": "MENU.PLAN" as "MENU.PLAN",
        "PLATFORMS": "MENU.PLATFORMS" as "MENU.PLATFORMS",
        "PROFILE": "MENU.PROFILE" as "MENU.PROFILE",
        "REGIONS_GROUPS": "MENU.REGIONS_GROUPS" as "MENU.REGIONS_GROUPS",
        "REGION_GROUP_ACTIVITY": "MENU.REGION_GROUP_ACTIVITY" as "MENU.REGION_GROUP_ACTIVITY",
        "REPORT": "MENU.REPORT" as "MENU.REPORT",
        "REPORTING": "MENU.REPORTING" as "MENU.REPORTING",
        "REQUESTS": "MENU.REQUESTS" as "MENU.REQUESTS",
        "ROADMAP": "MENU.ROADMAP" as "MENU.ROADMAP",
        "SCHEDULED": "MENU.SCHEDULED" as "MENU.SCHEDULED",
        "SEND": "MENU.SEND" as "MENU.SEND",
        "SIGN_OUT": "MENU.SIGN_OUT" as "MENU.SIGN_OUT",
        "SPECIAL_REQUESTS": "MENU.SPECIAL_REQUESTS" as "MENU.SPECIAL_REQUESTS",
        "STYLES": "MENU.STYLES" as "MENU.STYLES",
        "STYLE_GUIDE": "MENU.STYLE_GUIDE" as "MENU.STYLE_GUIDE",
        "TEMPLATES": "MENU.TEMPLATES" as "MENU.TEMPLATES",
        "TEMPLATE_CATEGORIES": "MENU.TEMPLATE_CATEGORIES" as "MENU.TEMPLATE_CATEGORIES",
        "TEMPLATE_USE": "MENU.TEMPLATE_USE" as "MENU.TEMPLATE_USE",
        "VIEW_ALL_NOTIFICATIONS": "MENU.VIEW_ALL_NOTIFICATIONS" as "MENU.VIEW_ALL_NOTIFICATIONS",
        "YOU_HAVE_NO_UNREAD_NOTIFICATIONS": "MENU.YOU_HAVE_NO_UNREAD_NOTIFICATIONS" as "MENU.YOU_HAVE_NO_UNREAD_NOTIFICATIONS"
    },
    "NOTIFICATIONS": {
        "BADGER": {
            "MARK_ALL_AS_READ": "NOTIFICATIONS.BADGER.MARK_ALL_AS_READ" as "NOTIFICATIONS.BADGER.MARK_ALL_AS_READ",
            "NO_UNREAD_NOTIFICATIONS": "NOTIFICATIONS.BADGER.NO_UNREAD_NOTIFICATIONS" as "NOTIFICATIONS.BADGER.NO_UNREAD_NOTIFICATIONS",
            "VIEW_ALL": "NOTIFICATIONS.BADGER.VIEW_ALL" as "NOTIFICATIONS.BADGER.VIEW_ALL"
        },
        "CALL_TO_ACTION_BUTTON_LABELS": {
            "OPEN_LINK": "NOTIFICATIONS.CALL_TO_ACTION_BUTTON_LABELS.OPEN_LINK" as "NOTIFICATIONS.CALL_TO_ACTION_BUTTON_LABELS.OPEN_LINK"
        },
        "LIST": {
            "NO_NOTIFICATIONS": "NOTIFICATIONS.LIST.NO_NOTIFICATIONS" as "NOTIFICATIONS.LIST.NO_NOTIFICATIONS"
        },
        "MESSAGES": {
            "CUSTOM_AGENCY_MESSAGE": "NOTIFICATIONS.MESSAGES.CUSTOM_AGENCY_MESSAGE" as "NOTIFICATIONS.MESSAGES.CUSTOM_AGENCY_MESSAGE",
            "EMAIL_SCHEDULED": "NOTIFICATIONS.MESSAGES.EMAIL_SCHEDULED" as "NOTIFICATIONS.MESSAGES.EMAIL_SCHEDULED",
            "EMAIL_SCHEDULE_FAILED": "NOTIFICATIONS.MESSAGES.EMAIL_SCHEDULE_FAILED" as "NOTIFICATIONS.MESSAGES.EMAIL_SCHEDULE_FAILED",
            "IMAGE_PUBLISH_FAILED": "NOTIFICATIONS.MESSAGES.IMAGE_PUBLISH_FAILED" as "NOTIFICATIONS.MESSAGES.IMAGE_PUBLISH_FAILED",
            "IMAGE_PUBLISH_FAILED_NO_ERROR": "NOTIFICATIONS.MESSAGES.IMAGE_PUBLISH_FAILED_NO_ERROR" as "NOTIFICATIONS.MESSAGES.IMAGE_PUBLISH_FAILED_NO_ERROR",
            "INTEGRATION_CONFIGURATION_MISCONFIGURED": "NOTIFICATIONS.MESSAGES.INTEGRATION_CONFIGURATION_MISCONFIGURED" as "NOTIFICATIONS.MESSAGES.INTEGRATION_CONFIGURATION_MISCONFIGURED",
            "INTEGRATION_CONNECTIVITY_FAILURE": "NOTIFICATIONS.MESSAGES.INTEGRATION_CONNECTIVITY_FAILURE" as "NOTIFICATIONS.MESSAGES.INTEGRATION_CONNECTIVITY_FAILURE",
            "LOCATION_MAP_GENERATED": "NOTIFICATIONS.MESSAGES.LOCATION_MAP_GENERATED" as "NOTIFICATIONS.MESSAGES.LOCATION_MAP_GENERATED",
            "LOCATION_MAP_GENERATION_FAILED": "NOTIFICATIONS.MESSAGES.LOCATION_MAP_GENERATION_FAILED" as "NOTIFICATIONS.MESSAGES.LOCATION_MAP_GENERATION_FAILED",
            "MEDIA_TEMPLATE_READY_FOR_DOWNLOAD": "NOTIFICATIONS.MESSAGES.MEDIA_TEMPLATE_READY_FOR_DOWNLOAD" as "NOTIFICATIONS.MESSAGES.MEDIA_TEMPLATE_READY_FOR_DOWNLOAD",
            "MEDIA_TEMPLATE_TIME_TO_SCHEDULE": "NOTIFICATIONS.MESSAGES.MEDIA_TEMPLATE_TIME_TO_SCHEDULE" as "NOTIFICATIONS.MESSAGES.MEDIA_TEMPLATE_TIME_TO_SCHEDULE",
            "SCHEDULED_POSTS": {
                "NO_NOTIFIABLE_DEVICES": "NOTIFICATIONS.MESSAGES.SCHEDULED_POSTS.NO_NOTIFIABLE_DEVICES" as "NOTIFICATIONS.MESSAGES.SCHEDULED_POSTS.NO_NOTIFIABLE_DEVICES"
            },
            "TEST": "NOTIFICATIONS.MESSAGES.TEST" as "NOTIFICATIONS.MESSAGES.TEST",
            "VIDEO_PUBLISHED_EXTERNALLY": "NOTIFICATIONS.MESSAGES.VIDEO_PUBLISHED_EXTERNALLY" as "NOTIFICATIONS.MESSAGES.VIDEO_PUBLISHED_EXTERNALLY",
            "VIDEO_PUBLISHED_EXTERNALLY_V2": "NOTIFICATIONS.MESSAGES.VIDEO_PUBLISHED_EXTERNALLY_V2" as "NOTIFICATIONS.MESSAGES.VIDEO_PUBLISHED_EXTERNALLY_V2",
            "VIDEO_PUBLISHED_LOCALLY": "NOTIFICATIONS.MESSAGES.VIDEO_PUBLISHED_LOCALLY" as "NOTIFICATIONS.MESSAGES.VIDEO_PUBLISHED_LOCALLY",
            "VIDEO_PUBLISH_FAILED": "NOTIFICATIONS.MESSAGES.VIDEO_PUBLISH_FAILED" as "NOTIFICATIONS.MESSAGES.VIDEO_PUBLISH_FAILED",
            "VIDEO_SCHEDULED_EXTERNALLY": "NOTIFICATIONS.MESSAGES.VIDEO_SCHEDULED_EXTERNALLY" as "NOTIFICATIONS.MESSAGES.VIDEO_SCHEDULED_EXTERNALLY",
            "VIDEO_SCHEDULED_EXTERNALLY_V2": "NOTIFICATIONS.MESSAGES.VIDEO_SCHEDULED_EXTERNALLY_V2" as "NOTIFICATIONS.MESSAGES.VIDEO_SCHEDULED_EXTERNALLY_V2"
        },
        "SEND_NOTIFICATION_WIZARD": {
            "COMMON": {
                "EMAIL_NOTIFICATION": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMMON.EMAIL_NOTIFICATION" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMMON.EMAIL_NOTIFICATION",
                "NOTIFICATION_TYPE": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMMON.NOTIFICATION_TYPE" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMMON.NOTIFICATION_TYPE",
                "PUSH_NOTIFICATION": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMMON.PUSH_NOTIFICATION" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMMON.PUSH_NOTIFICATION"
            },
            "COMPOSE": {
                "EMAIL": {
                    "CTA_BUTTON": {
                        "LABEL": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.CTA_BUTTON.LABEL" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.CTA_BUTTON.LABEL",
                        "LINK": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.CTA_BUTTON.LINK" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.CTA_BUTTON.LINK"
                    },
                    "EDITOR_BUTTONS": {
                        "ALIGN_CENTER": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.ALIGN_CENTER" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.ALIGN_CENTER",
                        "ALIGN_LEFT": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.ALIGN_LEFT" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.ALIGN_LEFT",
                        "ALIGN_RIGHT": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.ALIGN_RIGHT" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.ALIGN_RIGHT",
                        "BOLD": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.BOLD" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.BOLD",
                        "BULLETED_LIST": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.BULLETED_LIST" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.BULLETED_LIST",
                        "HEADING_NUM": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.HEADING_NUM" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.HEADING_NUM",
                        "IMAGE": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.IMAGE" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.IMAGE",
                        "ITALICS": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.ITALICS" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.ITALICS",
                        "NUMBERED_LIST": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.NUMBERED_LIST" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.NUMBERED_LIST"
                    },
                    "EMAIL_CONTENT": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EMAIL_CONTENT" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EMAIL_CONTENT",
                    "ERRORS": {
                        "BANNER_IMAGE_REQUIRED": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.BANNER_IMAGE_REQUIRED" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.BANNER_IMAGE_REQUIRED",
                        "CTA_LABEL_REQUIRED": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.CTA_LABEL_REQUIRED" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.CTA_LABEL_REQUIRED",
                        "CTA_LINK_REQUIRED": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.CTA_LINK_REQUIRED" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.CTA_LINK_REQUIRED",
                        "FROM_EMAIL_ADDRESS_REQUIRED": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.FROM_EMAIL_ADDRESS_REQUIRED" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.FROM_EMAIL_ADDRESS_REQUIRED",
                        "FROM_NAME_REQUIRED": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.FROM_NAME_REQUIRED" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.FROM_NAME_REQUIRED",
                        "SHOULD_SAVE_BANNER_SECTION_NAME_REQUIRED": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.SHOULD_SAVE_BANNER_SECTION_NAME_REQUIRED" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.SHOULD_SAVE_BANNER_SECTION_NAME_REQUIRED",
                        "SHOULD_SAVE_FOOTER_SECTION_NAME_REQUIRED": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.SHOULD_SAVE_FOOTER_SECTION_NAME_REQUIRED" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.SHOULD_SAVE_FOOTER_SECTION_NAME_REQUIRED",
                        "SUBJECT_REQUIRED": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.SUBJECT_REQUIRED" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.SUBJECT_REQUIRED"
                    },
                    "INPUT_LABELS": {
                        "BANNER_IMAGE_SWITCH": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.BANNER_IMAGE_SWITCH" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.BANNER_IMAGE_SWITCH",
                        "BANNER_IMAGE_SWITCH_IMAGE": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.BANNER_IMAGE_SWITCH_IMAGE" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.BANNER_IMAGE_SWITCH_IMAGE",
                        "BANNER_IMAGE_SWITCH_LOGO": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.BANNER_IMAGE_SWITCH_LOGO" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.BANNER_IMAGE_SWITCH_LOGO",
                        "BANNER_IMAGE_SWITCH_NONE": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.BANNER_IMAGE_SWITCH_NONE" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.BANNER_IMAGE_SWITCH_NONE",
                        "BANNER_IMAGE_SWITCH_SAVED": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.BANNER_IMAGE_SWITCH_SAVED" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.BANNER_IMAGE_SWITCH_SAVED",
                        "FOOTER_CONTENT": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FOOTER_CONTENT" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FOOTER_CONTENT",
                        "FOOTER_SWITCH": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FOOTER_SWITCH" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FOOTER_SWITCH",
                        "FOOTER_SWITCH_EXISTING": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FOOTER_SWITCH_EXISTING" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FOOTER_SWITCH_EXISTING",
                        "FOOTER_SWITCH_NEW": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FOOTER_SWITCH_NEW" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FOOTER_SWITCH_NEW",
                        "FOOTER_SWITCH_NONE": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FOOTER_SWITCH_NONE" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FOOTER_SWITCH_NONE",
                        "FROM_ADDRESS": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FROM_ADDRESS" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FROM_ADDRESS",
                        "FROM_ADDRESS_SWITCH_CUSTOM": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FROM_ADDRESS_SWITCH_CUSTOM" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FROM_ADDRESS_SWITCH_CUSTOM",
                        "FROM_ADDRESS_SWITCH_DEFAULT": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FROM_ADDRESS_SWITCH_DEFAULT" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FROM_ADDRESS_SWITCH_DEFAULT",
                        "FROM_EMAIL_ADDRESS": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FROM_EMAIL_ADDRESS" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FROM_EMAIL_ADDRESS",
                        "FROM_NAME": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FROM_NAME" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FROM_NAME",
                        "LOGO": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.LOGO" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.LOGO",
                        "SAVED_EMAIL_PART_BANNER_SELECT": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.SAVED_EMAIL_PART_BANNER_SELECT" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.SAVED_EMAIL_PART_BANNER_SELECT",
                        "SAVED_EMAIL_PART_FOOTER_SELECT": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.SAVED_EMAIL_PART_FOOTER_SELECT" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.SAVED_EMAIL_PART_FOOTER_SELECT",
                        "SHOULD_SAVE_BANNER_SECTION": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.SHOULD_SAVE_BANNER_SECTION" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.SHOULD_SAVE_BANNER_SECTION",
                        "SHOULD_SAVE_BANNER_SECTION_NAME": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.SHOULD_SAVE_BANNER_SECTION_NAME" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.SHOULD_SAVE_BANNER_SECTION_NAME",
                        "SHOULD_SAVE_FOOTER_SECTION": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.SHOULD_SAVE_FOOTER_SECTION" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.SHOULD_SAVE_FOOTER_SECTION",
                        "SHOULD_SAVE_FOOTER_SECTION_NAME": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.SHOULD_SAVE_FOOTER_SECTION_NAME" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.SHOULD_SAVE_FOOTER_SECTION_NAME"
                    },
                    "PLACEHOLDERS": {
                        "SHOULD_SAVE_BANNER_SECTION_NAME": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.PLACEHOLDERS.SHOULD_SAVE_BANNER_SECTION_NAME" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.PLACEHOLDERS.SHOULD_SAVE_BANNER_SECTION_NAME",
                        "SHOULD_SAVE_FOOTER_SECTION_NAME": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.PLACEHOLDERS.SHOULD_SAVE_FOOTER_SECTION_NAME" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.PLACEHOLDERS.SHOULD_SAVE_FOOTER_SECTION_NAME"
                    },
                    "SECTION_SAVE_AGENCY_NOTE": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.SECTION_SAVE_AGENCY_NOTE" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.SECTION_SAVE_AGENCY_NOTE",
                    "SECTION_SAVE_BRAND_NOTE": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.SECTION_SAVE_BRAND_NOTE" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.SECTION_SAVE_BRAND_NOTE"
                },
                "PUSH": {
                    "INPUT_LABELS": {
                        "LINK": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.PUSH.INPUT_LABELS.LINK" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.PUSH.INPUT_LABELS.LINK",
                        "MESSAGE": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.PUSH.INPUT_LABELS.MESSAGE" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.PUSH.INPUT_LABELS.MESSAGE",
                        "OPTIONAL": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.PUSH.INPUT_LABELS.OPTIONAL" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.PUSH.INPUT_LABELS.OPTIONAL",
                        "SUBJECT": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.PUSH.INPUT_LABELS.SUBJECT" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.PUSH.INPUT_LABELS.SUBJECT"
                    },
                    "PREVIEW": {
                        "NOTIFICATION": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.PUSH.PREVIEW.NOTIFICATION" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.PUSH.PREVIEW.NOTIFICATION",
                        "OPEN_LINK": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.PUSH.PREVIEW.OPEN_LINK" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.PUSH.PREVIEW.OPEN_LINK"
                    }
                }
            },
            "CONFIRM_FORM": {
                "CONFIRM_COPY": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.CONFIRM_COPY" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.CONFIRM_COPY",
                "DESCRIPTION": {
                    "LINE_ONE": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.DESCRIPTION.LINE_ONE" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.DESCRIPTION.LINE_ONE",
                    "LINE_TWO": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.DESCRIPTION.LINE_TWO" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.DESCRIPTION.LINE_TWO"
                },
                "FORM_LABELS": {
                    "CLIENT_COUNT_TEXT_LOCATION": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.FORM_LABELS.CLIENT_COUNT_TEXT_LOCATION" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.FORM_LABELS.CLIENT_COUNT_TEXT_LOCATION",
                    "CLIENT_COUNT_TEXT_LOCATIONS": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.FORM_LABELS.CLIENT_COUNT_TEXT_LOCATIONS" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.FORM_LABELS.CLIENT_COUNT_TEXT_LOCATIONS",
                    "IMMEDIATELY": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.FORM_LABELS.IMMEDIATELY" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.FORM_LABELS.IMMEDIATELY",
                    "NOTIFICATION_TYPE": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.FORM_LABELS.NOTIFICATION_TYPE" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.FORM_LABELS.NOTIFICATION_TYPE",
                    "TOTAL_RECIPIENTS": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.FORM_LABELS.TOTAL_RECIPIENTS" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.FORM_LABELS.TOTAL_RECIPIENTS",
                    "USER_FILTER": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.FORM_LABELS.USER_FILTER" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.FORM_LABELS.USER_FILTER"
                },
                "SEND_NOTIFICATION": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.SEND_NOTIFICATION" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.SEND_NOTIFICATION",
                "SEND_TEST_EMAIL": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.SEND_TEST_EMAIL" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.SEND_TEST_EMAIL"
            },
            "NOTIFICATION_ERROR": {
                "EMAIL_MESSAGE": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_ERROR.EMAIL_MESSAGE" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_ERROR.EMAIL_MESSAGE",
                "EMAIL_PREVIEW_MESSAGE": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_ERROR.EMAIL_PREVIEW_MESSAGE" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_ERROR.EMAIL_PREVIEW_MESSAGE"
            },
            "NOTIFICATION_SUCCESS": {
                "EMAIL_DESCRIPTION": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_SUCCESS.EMAIL_DESCRIPTION" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_SUCCESS.EMAIL_DESCRIPTION",
                "EMAIL_MESSAGE": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_SUCCESS.EMAIL_MESSAGE" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_SUCCESS.EMAIL_MESSAGE",
                "EMAIL_PREVIEW_MESSAGE": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_SUCCESS.EMAIL_PREVIEW_MESSAGE" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_SUCCESS.EMAIL_PREVIEW_MESSAGE",
                "PUSH_DESCRIPTION": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_SUCCESS.PUSH_DESCRIPTION" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_SUCCESS.PUSH_DESCRIPTION",
                "PUSH_MESSAGE": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_SUCCESS.PUSH_MESSAGE" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_SUCCESS.PUSH_MESSAGE",
                "SEND_ANOTHER": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_SUCCESS.SEND_ANOTHER" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_SUCCESS.SEND_ANOTHER"
            },
            "NOTIFICATION_TYPE_SELECTOR": {
                "BUTTONS": {
                    "EMAIL": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_TYPE_SELECTOR.BUTTONS.EMAIL" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_TYPE_SELECTOR.BUTTONS.EMAIL",
                    "PUSH": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_TYPE_SELECTOR.BUTTONS.PUSH" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_TYPE_SELECTOR.BUTTONS.PUSH"
                }
            },
            "PICK_LOCATIONS": {
                "CURRENTLY_SELECTED": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.CURRENTLY_SELECTED" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.CURRENTLY_SELECTED",
                "DESCRIPTION": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.DESCRIPTION" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.DESCRIPTION",
                "ERRORS": {
                    "TITLE_FILTER_INVALID_ENTRIES": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.ERRORS.TITLE_FILTER_INVALID_ENTRIES" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.ERRORS.TITLE_FILTER_INVALID_ENTRIES"
                },
                "HEADERS": {
                    "FILTER_BY_TITLE": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.HEADERS.FILTER_BY_TITLE" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.HEADERS.FILTER_BY_TITLE"
                },
                "LABELS": {
                    "FILTER_BY_TITLES": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.LABELS.FILTER_BY_TITLES" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.LABELS.FILTER_BY_TITLES",
                    "FILTER_SWITCH_ALL_USERS": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.LABELS.FILTER_SWITCH_ALL_USERS" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.LABELS.FILTER_SWITCH_ALL_USERS",
                    "FILTER_SWITCH_FILTER_BY_TITLE": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.LABELS.FILTER_SWITCH_FILTER_BY_TITLE" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.LABELS.FILTER_SWITCH_FILTER_BY_TITLE",
                    "TOTAL_RECIPIENTS": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.LABELS.TOTAL_RECIPIENTS" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.LABELS.TOTAL_RECIPIENTS"
                }
            },
            "STEPS": {
                "COMPOSE": {
                    "HEADING_TEXT": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.COMPOSE.HEADING_TEXT" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.COMPOSE.HEADING_TEXT",
                    "STEPPER_TEXT": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.COMPOSE.STEPPER_TEXT" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.COMPOSE.STEPPER_TEXT"
                },
                "NOTIFICATION_TYPE": {
                    "HEADING_TEXT": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.NOTIFICATION_TYPE.HEADING_TEXT" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.NOTIFICATION_TYPE.HEADING_TEXT",
                    "STEPPER_TEXT": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.NOTIFICATION_TYPE.STEPPER_TEXT" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.NOTIFICATION_TYPE.STEPPER_TEXT"
                },
                "REVIEW": {
                    "HEADING_TEXT": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.REVIEW.HEADING_TEXT" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.REVIEW.HEADING_TEXT",
                    "STEPPER_TEXT": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.REVIEW.STEPPER_TEXT" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.REVIEW.STEPPER_TEXT"
                },
                "SELECT_LOCATIONS": {
                    "HEADING_TEXT": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.SELECT_LOCATIONS.HEADING_TEXT" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.SELECT_LOCATIONS.HEADING_TEXT",
                    "STEPPER_TEXT": "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.SELECT_LOCATIONS.STEPPER_TEXT" as "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.SELECT_LOCATIONS.STEPPER_TEXT"
                }
            }
        },
        "SUBJECTS": {
            "CUSTOM_AGENCY_MESSAGE": "NOTIFICATIONS.SUBJECTS.CUSTOM_AGENCY_MESSAGE" as "NOTIFICATIONS.SUBJECTS.CUSTOM_AGENCY_MESSAGE"
        }
    },
    "OVERVIEW": {
        "ALL_EVENTS": "OVERVIEW.ALL_EVENTS" as "OVERVIEW.ALL_EVENTS",
        "BULK_ACTIONS": "OVERVIEW.BULK_ACTIONS" as "OVERVIEW.BULK_ACTIONS",
        "CONFIRM_PLANNER_EVENTS": "OVERVIEW.CONFIRM_PLANNER_EVENTS" as "OVERVIEW.CONFIRM_PLANNER_EVENTS",
        "DELETED_PLANNER_EVENTS": "OVERVIEW.DELETED_PLANNER_EVENTS" as "OVERVIEW.DELETED_PLANNER_EVENTS",
        "DELETED_SOME_PLANNER_EVENTS": "OVERVIEW.DELETED_SOME_PLANNER_EVENTS" as "OVERVIEW.DELETED_SOME_PLANNER_EVENTS",
        "DELETE_ALL_PLANNER_EVENTS": "OVERVIEW.DELETE_ALL_PLANNER_EVENTS" as "OVERVIEW.DELETE_ALL_PLANNER_EVENTS",
        "DELETE_RECURRING_EVENT": "OVERVIEW.DELETE_RECURRING_EVENT" as "OVERVIEW.DELETE_RECURRING_EVENT",
        "DELETING_PLANNER_EVENTS": "OVERVIEW.DELETING_PLANNER_EVENTS" as "OVERVIEW.DELETING_PLANNER_EVENTS",
        "DELETING_THESE_PLANNER_EVENTS": "OVERVIEW.DELETING_THESE_PLANNER_EVENTS" as "OVERVIEW.DELETING_THESE_PLANNER_EVENTS",
        "DELETING_TITLE": "OVERVIEW.DELETING_TITLE" as "OVERVIEW.DELETING_TITLE",
        "DONE": "OVERVIEW.DONE" as "OVERVIEW.DONE",
        "DUE_BY": "OVERVIEW.DUE_BY" as "OVERVIEW.DUE_BY",
        "FAILED_DELETE_PLANNER_EVENTS": "OVERVIEW.FAILED_DELETE_PLANNER_EVENTS" as "OVERVIEW.FAILED_DELETE_PLANNER_EVENTS",
        "FILTER": {
            "CHANNELS": "OVERVIEW.FILTER.CHANNELS" as "OVERVIEW.FILTER.CHANNELS",
            "CLIENT": "OVERVIEW.FILTER.CLIENT" as "OVERVIEW.FILTER.CLIENT",
            "ITEM": "OVERVIEW.FILTER.ITEM" as "OVERVIEW.FILTER.ITEM",
            "LOCATION": "OVERVIEW.FILTER.LOCATION" as "OVERVIEW.FILTER.LOCATION",
            "STATUS": "OVERVIEW.FILTER.STATUS" as "OVERVIEW.FILTER.STATUS"
        },
        "FILTERED_AMOUNT": "OVERVIEW.FILTERED_AMOUNT" as "OVERVIEW.FILTERED_AMOUNT",
        "FUTURE_EVENTS": "OVERVIEW.FUTURE_EVENTS" as "OVERVIEW.FUTURE_EVENTS",
        "LOADED_LOCATIONS": "OVERVIEW.LOADED_LOCATIONS" as "OVERVIEW.LOADED_LOCATIONS",
        "LOCATION_EVENTS_FAILED_PUBLISH": "OVERVIEW.LOCATION_EVENTS_FAILED_PUBLISH" as "OVERVIEW.LOCATION_EVENTS_FAILED_PUBLISH",
        "LOCATION_EVENTS_FAILED_SAVE": "OVERVIEW.LOCATION_EVENTS_FAILED_SAVE" as "OVERVIEW.LOCATION_EVENTS_FAILED_SAVE",
        "MAX_SPEND": "OVERVIEW.MAX_SPEND" as "OVERVIEW.MAX_SPEND",
        "NO_CONTENT": "OVERVIEW.NO_CONTENT" as "OVERVIEW.NO_CONTENT",
        "SAVING_FOR_TITLE": "OVERVIEW.SAVING_FOR_TITLE" as "OVERVIEW.SAVING_FOR_TITLE",
        "SAVING_PLANNER_EVENT": "OVERVIEW.SAVING_PLANNER_EVENT" as "OVERVIEW.SAVING_PLANNER_EVENT",
        "SELECTED_PLANNER_EVENTS": "OVERVIEW.SELECTED_PLANNER_EVENTS" as "OVERVIEW.SELECTED_PLANNER_EVENTS",
        "SOME_PLANNER_SERIES": "OVERVIEW.SOME_PLANNER_SERIES" as "OVERVIEW.SOME_PLANNER_SERIES",
        "THIS_EVENT": "OVERVIEW.THIS_EVENT" as "OVERVIEW.THIS_EVENT"
    },
    "PAYMENTS": {
        "ASK_AGENCY_TO_SEND_ANOTHER": "PAYMENTS.ASK_AGENCY_TO_SEND_ANOTHER" as "PAYMENTS.ASK_AGENCY_TO_SEND_ANOTHER",
        "AUTHORITY_CONFIRMATION": "PAYMENTS.AUTHORITY_CONFIRMATION" as "PAYMENTS.AUTHORITY_CONFIRMATION",
        "BUSINESS_NAME": "PAYMENTS.BUSINESS_NAME" as "PAYMENTS.BUSINESS_NAME",
        "COULD_NOT_FIND_INVITATION": "PAYMENTS.COULD_NOT_FIND_INVITATION" as "PAYMENTS.COULD_NOT_FIND_INVITATION",
        "CUSTOMER_DETAILS": "PAYMENTS.CUSTOMER_DETAILS" as "PAYMENTS.CUSTOMER_DETAILS",
        "EMAILS": {
            "AMOUNT_DUE": "PAYMENTS.EMAILS.AMOUNT_DUE" as "PAYMENTS.EMAILS.AMOUNT_DUE",
            "ATTEMPTED_PAYMENT_DATE": "PAYMENTS.EMAILS.ATTEMPTED_PAYMENT_DATE" as "PAYMENTS.EMAILS.ATTEMPTED_PAYMENT_DATE",
            "DUE_DATE": "PAYMENTS.EMAILS.DUE_DATE" as "PAYMENTS.EMAILS.DUE_DATE",
            "FAILED_SUBJECT_LINE": "PAYMENTS.EMAILS.FAILED_SUBJECT_LINE" as "PAYMENTS.EMAILS.FAILED_SUBJECT_LINE",
            "FAILED_TO_TAKE_PAYMENT": "PAYMENTS.EMAILS.FAILED_TO_TAKE_PAYMENT" as "PAYMENTS.EMAILS.FAILED_TO_TAKE_PAYMENT",
            "IF_YOU_NEED_TO_UPDATE_CREDIT_CARD": "PAYMENTS.EMAILS.IF_YOU_NEED_TO_UPDATE_CREDIT_CARD" as "PAYMENTS.EMAILS.IF_YOU_NEED_TO_UPDATE_CREDIT_CARD",
            "INVOICE_DESCRIPTION": "PAYMENTS.EMAILS.INVOICE_DESCRIPTION" as "PAYMENTS.EMAILS.INVOICE_DESCRIPTION",
            "INVOICE_NUMBER": "PAYMENTS.EMAILS.INVOICE_NUMBER" as "PAYMENTS.EMAILS.INVOICE_NUMBER",
            "PAYMENT_FAILED_FOR_LOCATION": "PAYMENTS.EMAILS.PAYMENT_FAILED_FOR_LOCATION" as "PAYMENTS.EMAILS.PAYMENT_FAILED_FOR_LOCATION",
            "REPORT": {
                "FAILED_SUBJECT_LINE": "PAYMENTS.EMAILS.REPORT.FAILED_SUBJECT_LINE" as "PAYMENTS.EMAILS.REPORT.FAILED_SUBJECT_LINE",
                "FAILED_SUBJECT_LINE_plural": "PAYMENTS.EMAILS.REPORT.FAILED_SUBJECT_LINE_plural" as "PAYMENTS.EMAILS.REPORT.FAILED_SUBJECT_LINE_plural",
                "FAILED_TO_TAKE_PAYMENTS": "PAYMENTS.EMAILS.REPORT.FAILED_TO_TAKE_PAYMENTS" as "PAYMENTS.EMAILS.REPORT.FAILED_TO_TAKE_PAYMENTS",
                "PAYMENT_FAILED_FOR_LOCATIONS": "PAYMENTS.EMAILS.REPORT.PAYMENT_FAILED_FOR_LOCATIONS" as "PAYMENTS.EMAILS.REPORT.PAYMENT_FAILED_FOR_LOCATIONS",
                "PAYMENT_FAILED_FOR_LOCATIONS_plural": "PAYMENTS.EMAILS.REPORT.PAYMENT_FAILED_FOR_LOCATIONS_plural" as "PAYMENTS.EMAILS.REPORT.PAYMENT_FAILED_FOR_LOCATIONS_plural",
                "PAYMENT_FAILURE_REASON": "PAYMENTS.EMAILS.REPORT.PAYMENT_FAILURE_REASON" as "PAYMENTS.EMAILS.REPORT.PAYMENT_FAILURE_REASON",
                "TECHNICAL_ISSUES": "PAYMENTS.EMAILS.REPORT.TECHNICAL_ISSUES" as "PAYMENTS.EMAILS.REPORT.TECHNICAL_ISSUES",
                "TECHNICAL_ISSUES_NOTE": "PAYMENTS.EMAILS.REPORT.TECHNICAL_ISSUES_NOTE" as "PAYMENTS.EMAILS.REPORT.TECHNICAL_ISSUES_NOTE"
            },
            "RETRY": {
                "WE_WILL_ATTEMPT_TO_CHARGE_AGAIN": "PAYMENTS.EMAILS.RETRY.WE_WILL_ATTEMPT_TO_CHARGE_AGAIN" as "PAYMENTS.EMAILS.RETRY.WE_WILL_ATTEMPT_TO_CHARGE_AGAIN"
            },
            "ROLLOVER": {
                "WE_WILL_ADD_OUTSTANDING_AMOUNT_TO_NEXT_PAYMENT": "PAYMENTS.EMAILS.ROLLOVER.WE_WILL_ADD_OUTSTANDING_AMOUNT_TO_NEXT_PAYMENT" as "PAYMENTS.EMAILS.ROLLOVER.WE_WILL_ADD_OUTSTANDING_AMOUNT_TO_NEXT_PAYMENT"
            },
            "SUBSCRIPTION_AMOUNT": "PAYMENTS.EMAILS.SUBSCRIPTION_AMOUNT" as "PAYMENTS.EMAILS.SUBSCRIPTION_AMOUNT",
            "YOU_MAY_NEED_TO_CONTACT_YOUR_FINANCIAL_INSTITUTION": "PAYMENTS.EMAILS.YOU_MAY_NEED_TO_CONTACT_YOUR_FINANCIAL_INSTITUTION" as "PAYMENTS.EMAILS.YOU_MAY_NEED_TO_CONTACT_YOUR_FINANCIAL_INSTITUTION"
        },
        "EMAIL_ADDRESS": "PAYMENTS.EMAIL_ADDRESS" as "PAYMENTS.EMAIL_ADDRESS",
        "FINALISING_PAYMENT": "PAYMENTS.FINALISING_PAYMENT" as "PAYMENTS.FINALISING_PAYMENT",
        "GO_BACK": "PAYMENTS.GO_BACK" as "PAYMENTS.GO_BACK",
        "INVOICE_DESCRIPTION": "PAYMENTS.INVOICE_DESCRIPTION" as "PAYMENTS.INVOICE_DESCRIPTION",
        "INVOICE_NUMBER": "PAYMENTS.INVOICE_NUMBER" as "PAYMENTS.INVOICE_NUMBER",
        "MASTERCARD": "PAYMENTS.MASTERCARD" as "PAYMENTS.MASTERCARD",
        "NO_PAYMENT": "PAYMENTS.NO_PAYMENT" as "PAYMENTS.NO_PAYMENT",
        "NO_PAYMENT_INFORMATION": "PAYMENTS.NO_PAYMENT_INFORMATION" as "PAYMENTS.NO_PAYMENT_INFORMATION",
        "PAYMENT_AMOUNT": "PAYMENTS.PAYMENT_AMOUNT" as "PAYMENTS.PAYMENT_AMOUNT",
        "PAYMENT_CURRENCY": "PAYMENTS.PAYMENT_CURRENCY" as "PAYMENTS.PAYMENT_CURRENCY",
        "PAYMENT_FAILED": "PAYMENTS.PAYMENT_FAILED" as "PAYMENTS.PAYMENT_FAILED",
        "PAYMENT_SUCCESSFUL": "PAYMENTS.PAYMENT_SUCCESSFUL" as "PAYMENTS.PAYMENT_SUCCESSFUL",
        "PAY_NOW": "PAYMENTS.PAY_NOW" as "PAYMENTS.PAY_NOW",
        "PHONE_NUMBER": "PAYMENTS.PHONE_NUMBER" as "PAYMENTS.PHONE_NUMBER",
        "PLEASE_CONFIRM": "PAYMENTS.PLEASE_CONFIRM" as "PAYMENTS.PLEASE_CONFIRM",
        "RECEIPT_NUMBER": "PAYMENTS.RECEIPT_NUMBER" as "PAYMENTS.RECEIPT_NUMBER",
        "REDIRECTING": "PAYMENTS.REDIRECTING" as "PAYMENTS.REDIRECTING",
        "REDIRECT_CONTINUE": "PAYMENTS.REDIRECT_CONTINUE" as "PAYMENTS.REDIRECT_CONTINUE",
        "REDIRECT_NOTE": "PAYMENTS.REDIRECT_NOTE" as "PAYMENTS.REDIRECT_NOTE",
        "SIGN_UP": {
            "AGENCY_WELCOMES_YOU": "PAYMENTS.SIGN_UP.AGENCY_WELCOMES_YOU" as "PAYMENTS.SIGN_UP.AGENCY_WELCOMES_YOU",
            "AMOUNT_PER_MONTH": "PAYMENTS.SIGN_UP.AMOUNT_PER_MONTH" as "PAYMENTS.SIGN_UP.AMOUNT_PER_MONTH",
            "FINALISING_SIGN_UP": "PAYMENTS.SIGN_UP.FINALISING_SIGN_UP" as "PAYMENTS.SIGN_UP.FINALISING_SIGN_UP",
            "FIRST_BILLING_DATE": "PAYMENTS.SIGN_UP.FIRST_BILLING_DATE" as "PAYMENTS.SIGN_UP.FIRST_BILLING_DATE",
            "FIRST_BILLING_DATE_IS": "PAYMENTS.SIGN_UP.FIRST_BILLING_DATE_IS" as "PAYMENTS.SIGN_UP.FIRST_BILLING_DATE_IS",
            "I_AGREE_TO_THE": "PAYMENTS.SIGN_UP.I_AGREE_TO_THE" as "PAYMENTS.SIGN_UP.I_AGREE_TO_THE",
            "SIGN_UP": "PAYMENTS.SIGN_UP.SIGN_UP" as "PAYMENTS.SIGN_UP.SIGN_UP",
            "SIGN_UP_FAILED": "PAYMENTS.SIGN_UP.SIGN_UP_FAILED" as "PAYMENTS.SIGN_UP.SIGN_UP_FAILED",
            "SIGN_UP_SUCCESSFUL": "PAYMENTS.SIGN_UP.SIGN_UP_SUCCESSFUL" as "PAYMENTS.SIGN_UP.SIGN_UP_SUCCESSFUL",
            "YOU_WILL_BE_PROMPTED_FOR_CREDIT_CARD": "PAYMENTS.SIGN_UP.YOU_WILL_BE_PROMPTED_FOR_CREDIT_CARD" as "PAYMENTS.SIGN_UP.YOU_WILL_BE_PROMPTED_FOR_CREDIT_CARD"
        },
        "STARTING": "PAYMENTS.STARTING" as "PAYMENTS.STARTING",
        "STRIPE": {
            "AUTH_REQUEST": {
                "AUTHORISE_YOUR_ACCOUNT": "PAYMENTS.STRIPE.AUTH_REQUEST.AUTHORISE_YOUR_ACCOUNT" as "PAYMENTS.STRIPE.AUTH_REQUEST.AUTHORISE_YOUR_ACCOUNT",
                "BY_AUTHORISING": "PAYMENTS.STRIPE.AUTH_REQUEST.BY_AUTHORISING" as "PAYMENTS.STRIPE.AUTH_REQUEST.BY_AUTHORISING",
                "CLICK_BUTTON_BELOW": "PAYMENTS.STRIPE.AUTH_REQUEST.CLICK_BUTTON_BELOW" as "PAYMENTS.STRIPE.AUTH_REQUEST.CLICK_BUTTON_BELOW",
                "EXPIRED": "PAYMENTS.STRIPE.AUTH_REQUEST.EXPIRED" as "PAYMENTS.STRIPE.AUTH_REQUEST.EXPIRED",
                "REQUEST_INVALID": "PAYMENTS.STRIPE.AUTH_REQUEST.REQUEST_INVALID" as "PAYMENTS.STRIPE.AUTH_REQUEST.REQUEST_INVALID"
            },
            "AUTH_RESPONSE": {
                "ACCESS_DENIED": "PAYMENTS.STRIPE.AUTH_RESPONSE.ACCESS_DENIED" as "PAYMENTS.STRIPE.AUTH_RESPONSE.ACCESS_DENIED",
                "ERROR": "PAYMENTS.STRIPE.AUTH_RESPONSE.ERROR" as "PAYMENTS.STRIPE.AUTH_RESPONSE.ERROR",
                "FAILED": "PAYMENTS.STRIPE.AUTH_RESPONSE.FAILED" as "PAYMENTS.STRIPE.AUTH_RESPONSE.FAILED",
                "LOOKS_LIKE_SOMETHING_WENT_WRONG": "PAYMENTS.STRIPE.AUTH_RESPONSE.LOOKS_LIKE_SOMETHING_WENT_WRONG" as "PAYMENTS.STRIPE.AUTH_RESPONSE.LOOKS_LIKE_SOMETHING_WENT_WRONG",
                "LOOKS_LIKE_YOU_DENIED_ACCESS": "PAYMENTS.STRIPE.AUTH_RESPONSE.LOOKS_LIKE_YOU_DENIED_ACCESS" as "PAYMENTS.STRIPE.AUTH_RESPONSE.LOOKS_LIKE_YOU_DENIED_ACCESS",
                "SUCCESS": "PAYMENTS.STRIPE.AUTH_RESPONSE.SUCCESS" as "PAYMENTS.STRIPE.AUTH_RESPONSE.SUCCESS",
                "UNKNOWN_ERROR": "PAYMENTS.STRIPE.AUTH_RESPONSE.UNKNOWN_ERROR" as "PAYMENTS.STRIPE.AUTH_RESPONSE.UNKNOWN_ERROR",
                "YOUR_STRIPE_ACCOUNT_IS_CONNECTED": "PAYMENTS.STRIPE.AUTH_RESPONSE.YOUR_STRIPE_ACCOUNT_IS_CONNECTED" as "PAYMENTS.STRIPE.AUTH_RESPONSE.YOUR_STRIPE_ACCOUNT_IS_CONNECTED"
            },
            "CREATE_STRIPE_CHARGE": "PAYMENTS.STRIPE.CREATE_STRIPE_CHARGE" as "PAYMENTS.STRIPE.CREATE_STRIPE_CHARGE",
            "EMAILS": {
                "AUTH_REQUEST": {
                    "AUTH_MY_ACCOUNT": "PAYMENTS.STRIPE.EMAILS.AUTH_REQUEST.AUTH_MY_ACCOUNT" as "PAYMENTS.STRIPE.EMAILS.AUTH_REQUEST.AUTH_MY_ACCOUNT",
                    "SUBJECT_LINE": "PAYMENTS.STRIPE.EMAILS.AUTH_REQUEST.SUBJECT_LINE" as "PAYMENTS.STRIPE.EMAILS.AUTH_REQUEST.SUBJECT_LINE",
                    "TO_AUTH_CLICK_LINK": "PAYMENTS.STRIPE.EMAILS.AUTH_REQUEST.TO_AUTH_CLICK_LINK" as "PAYMENTS.STRIPE.EMAILS.AUTH_REQUEST.TO_AUTH_CLICK_LINK",
                    "USER_REQUESTED_YOU_TO_AUTH": "PAYMENTS.STRIPE.EMAILS.AUTH_REQUEST.USER_REQUESTED_YOU_TO_AUTH" as "PAYMENTS.STRIPE.EMAILS.AUTH_REQUEST.USER_REQUESTED_YOU_TO_AUTH"
                }
            },
            "FETCH_STRIPE_AUTH_REQUEST": "PAYMENTS.STRIPE.FETCH_STRIPE_AUTH_REQUEST" as "PAYMENTS.STRIPE.FETCH_STRIPE_AUTH_REQUEST",
            "FETCH_STRIPE_AUTH_URL": "PAYMENTS.STRIPE.FETCH_STRIPE_AUTH_URL" as "PAYMENTS.STRIPE.FETCH_STRIPE_AUTH_URL",
            "FETCH_STRIPE_PUBLISHABLE_KEY": "PAYMENTS.STRIPE.FETCH_STRIPE_PUBLISHABLE_KEY" as "PAYMENTS.STRIPE.FETCH_STRIPE_PUBLISHABLE_KEY",
            "SUBMIT_AUTH_CODE_TO_STRIPE": "PAYMENTS.STRIPE.SUBMIT_AUTH_CODE_TO_STRIPE" as "PAYMENTS.STRIPE.SUBMIT_AUTH_CODE_TO_STRIPE"
        },
        "THANK_YOU": "PAYMENTS.THANK_YOU" as "PAYMENTS.THANK_YOU",
        "UPDATE_BILLING_DETAILS": {
            "BILLING_DETAILS_UPDATED": "PAYMENTS.UPDATE_BILLING_DETAILS.BILLING_DETAILS_UPDATED" as "PAYMENTS.UPDATE_BILLING_DETAILS.BILLING_DETAILS_UPDATED",
            "FINALISING_CHANGES": "PAYMENTS.UPDATE_BILLING_DETAILS.FINALISING_CHANGES" as "PAYMENTS.UPDATE_BILLING_DETAILS.FINALISING_CHANGES",
            "LOADING_BILLING_DETAILS": "PAYMENTS.UPDATE_BILLING_DETAILS.LOADING_BILLING_DETAILS" as "PAYMENTS.UPDATE_BILLING_DETAILS.LOADING_BILLING_DETAILS",
            "UPDATE_BILLING_DETAILS": "PAYMENTS.UPDATE_BILLING_DETAILS.UPDATE_BILLING_DETAILS" as "PAYMENTS.UPDATE_BILLING_DETAILS.UPDATE_BILLING_DETAILS",
            "UPDATE_BILLING_DETAILS_IN_DIGITAL_STACK": "PAYMENTS.UPDATE_BILLING_DETAILS.UPDATE_BILLING_DETAILS_IN_DIGITAL_STACK" as "PAYMENTS.UPDATE_BILLING_DETAILS.UPDATE_BILLING_DETAILS_IN_DIGITAL_STACK",
            "UPDATE_FAILED": "PAYMENTS.UPDATE_BILLING_DETAILS.UPDATE_FAILED" as "PAYMENTS.UPDATE_BILLING_DETAILS.UPDATE_FAILED",
            "UPDATE_SUCCESSFUL": "PAYMENTS.UPDATE_BILLING_DETAILS.UPDATE_SUCCESSFUL" as "PAYMENTS.UPDATE_BILLING_DETAILS.UPDATE_SUCCESSFUL"
        },
        "VISA": "PAYMENTS.VISA" as "PAYMENTS.VISA",
        "WE_ONLY_ACCEPT": "PAYMENTS.WE_ONLY_ACCEPT" as "PAYMENTS.WE_ONLY_ACCEPT",
        "YOUR_BUSINESS": "PAYMENTS.YOUR_BUSINESS" as "PAYMENTS.YOUR_BUSINESS"
    },
    "PLAN": {
        "ACTIVITIES": {
            "ACTIONS": {
                "ADD_ACTIVITY": "PLAN.ACTIVITIES.ACTIONS.ADD_ACTIVITY" as "PLAN.ACTIVITIES.ACTIONS.ADD_ACTIVITY"
            },
            "CHANNELS": {
                "CHANNEL_FOR_ACTIVITY": "PLAN.ACTIVITIES.CHANNELS.CHANNEL_FOR_ACTIVITY" as "PLAN.ACTIVITIES.CHANNELS.CHANNEL_FOR_ACTIVITY",
                "CHANNEL_TYPE": {
                    "GENERAL": "PLAN.ACTIVITIES.CHANNELS.CHANNEL_TYPE.GENERAL" as "PLAN.ACTIVITIES.CHANNELS.CHANNEL_TYPE.GENERAL",
                    "SELF_SERVICE": "PLAN.ACTIVITIES.CHANNELS.CHANNEL_TYPE.SELF_SERVICE" as "PLAN.ACTIVITIES.CHANNELS.CHANNEL_TYPE.SELF_SERVICE",
                    "SUPPORTED": "PLAN.ACTIVITIES.CHANNELS.CHANNEL_TYPE.SUPPORTED" as "PLAN.ACTIVITIES.CHANNELS.CHANNEL_TYPE.SUPPORTED"
                }
            }
        },
        "AGENCY_TO_BUILD": "PLAN.AGENCY_TO_BUILD" as "PLAN.AGENCY_TO_BUILD",
        "AGENCY_TO_BUILD_SPECIFIC": "PLAN.AGENCY_TO_BUILD_SPECIFIC" as "PLAN.AGENCY_TO_BUILD_SPECIFIC",
        "AGENCY_TO_BUILD_TOOLTIP": "PLAN.AGENCY_TO_BUILD_TOOLTIP" as "PLAN.AGENCY_TO_BUILD_TOOLTIP",
        "ASSOCIATED_BUILDER_RESOURCES": {
            "ADD_TEMPLATE": "PLAN.ASSOCIATED_BUILDER_RESOURCES.ADD_TEMPLATE" as "PLAN.ASSOCIATED_BUILDER_RESOURCES.ADD_TEMPLATE",
            "ASSOCIATE_TEMPLATE_OR_CATEGORY": "PLAN.ASSOCIATED_BUILDER_RESOURCES.ASSOCIATE_TEMPLATE_OR_CATEGORY" as "PLAN.ASSOCIATED_BUILDER_RESOURCES.ASSOCIATE_TEMPLATE_OR_CATEGORY",
            "INVALID_SINGLE_TEMPLATE_EXPLANATION": "PLAN.ASSOCIATED_BUILDER_RESOURCES.INVALID_SINGLE_TEMPLATE_EXPLANATION" as "PLAN.ASSOCIATED_BUILDER_RESOURCES.INVALID_SINGLE_TEMPLATE_EXPLANATION",
            "PASTE_A_TEMPLATE_URL": "PLAN.ASSOCIATED_BUILDER_RESOURCES.PASTE_A_TEMPLATE_URL" as "PLAN.ASSOCIATED_BUILDER_RESOURCES.PASTE_A_TEMPLATE_URL",
            "SELECT_A_COLLECTION": "PLAN.ASSOCIATED_BUILDER_RESOURCES.SELECT_A_COLLECTION" as "PLAN.ASSOCIATED_BUILDER_RESOURCES.SELECT_A_COLLECTION",
            "SELECT_A_TEMPLATE_CATEGORY": "PLAN.ASSOCIATED_BUILDER_RESOURCES.SELECT_A_TEMPLATE_CATEGORY" as "PLAN.ASSOCIATED_BUILDER_RESOURCES.SELECT_A_TEMPLATE_CATEGORY",
            "SINGLE_TEMPLATE": "PLAN.ASSOCIATED_BUILDER_RESOURCES.SINGLE_TEMPLATE" as "PLAN.ASSOCIATED_BUILDER_RESOURCES.SINGLE_TEMPLATE",
            "TEMPLATE_URL": "PLAN.ASSOCIATED_BUILDER_RESOURCES.TEMPLATE_URL" as "PLAN.ASSOCIATED_BUILDER_RESOURCES.TEMPLATE_URL"
        },
        "BUILD_AND_SCHEDULE": "PLAN.BUILD_AND_SCHEDULE" as "PLAN.BUILD_AND_SCHEDULE",
        "BUILD_AND_SCHEDULE_TOOLTIP": "PLAN.BUILD_AND_SCHEDULE_TOOLTIP" as "PLAN.BUILD_AND_SCHEDULE_TOOLTIP",
        "CAMPAIGNS": {
            "ACTIONS": {
                "ARCHIVE_MESSAGE": "PLAN.CAMPAIGNS.ACTIONS.ARCHIVE_MESSAGE" as "PLAN.CAMPAIGNS.ACTIONS.ARCHIVE_MESSAGE",
                "ARCHIVE_THIS_CAMPAIGN": "PLAN.CAMPAIGNS.ACTIONS.ARCHIVE_THIS_CAMPAIGN" as "PLAN.CAMPAIGNS.ACTIONS.ARCHIVE_THIS_CAMPAIGN",
                "DEPLOY_THIS_CAMPAIGN": "PLAN.CAMPAIGNS.ACTIONS.DEPLOY_THIS_CAMPAIGN" as "PLAN.CAMPAIGNS.ACTIONS.DEPLOY_THIS_CAMPAIGN",
                "RENAME_CAMPAIGN": "PLAN.CAMPAIGNS.ACTIONS.RENAME_CAMPAIGN" as "PLAN.CAMPAIGNS.ACTIONS.RENAME_CAMPAIGN",
                "UNARCHIVE_MESSAGE": "PLAN.CAMPAIGNS.ACTIONS.UNARCHIVE_MESSAGE" as "PLAN.CAMPAIGNS.ACTIONS.UNARCHIVE_MESSAGE",
                "UNARCHIVE_THIS_CAMPAIGN": "PLAN.CAMPAIGNS.ACTIONS.UNARCHIVE_THIS_CAMPAIGN" as "PLAN.CAMPAIGNS.ACTIONS.UNARCHIVE_THIS_CAMPAIGN"
            },
            "ADD_ITEM": "PLAN.CAMPAIGNS.ADD_ITEM" as "PLAN.CAMPAIGNS.ADD_ITEM",
            "ADD_NEW_CAMPAIGN": "PLAN.CAMPAIGNS.ADD_NEW_CAMPAIGN" as "PLAN.CAMPAIGNS.ADD_NEW_CAMPAIGN",
            "CAMPAIGNS": "PLAN.CAMPAIGNS.CAMPAIGNS" as "PLAN.CAMPAIGNS.CAMPAIGNS",
            "CAMPAIGNS_LIST": {
                "HEADERS": {
                    "DURATION": "PLAN.CAMPAIGNS.CAMPAIGNS_LIST.HEADERS.DURATION" as "PLAN.CAMPAIGNS.CAMPAIGNS_LIST.HEADERS.DURATION",
                    "NAME": "PLAN.CAMPAIGNS.CAMPAIGNS_LIST.HEADERS.NAME" as "PLAN.CAMPAIGNS.CAMPAIGNS_LIST.HEADERS.NAME",
                    "TOTAL_ITEMS": "PLAN.CAMPAIGNS.CAMPAIGNS_LIST.HEADERS.TOTAL_ITEMS" as "PLAN.CAMPAIGNS.CAMPAIGNS_LIST.HEADERS.TOTAL_ITEMS"
                },
                "NO_CAMPAIGNS_FOUND": "PLAN.CAMPAIGNS.CAMPAIGNS_LIST.NO_CAMPAIGNS_FOUND" as "PLAN.CAMPAIGNS.CAMPAIGNS_LIST.NO_CAMPAIGNS_FOUND",
                "NUM_DAYS": "PLAN.CAMPAIGNS.CAMPAIGNS_LIST.NUM_DAYS" as "PLAN.CAMPAIGNS.CAMPAIGNS_LIST.NUM_DAYS"
            },
            "CAMPAIGN_NAME_FILTER_LABEL": "PLAN.CAMPAIGNS.CAMPAIGN_NAME_FILTER_LABEL" as "PLAN.CAMPAIGNS.CAMPAIGN_NAME_FILTER_LABEL",
            "CAMPAIGN_NOT_FOUND": "PLAN.CAMPAIGNS.CAMPAIGN_NOT_FOUND" as "PLAN.CAMPAIGNS.CAMPAIGN_NOT_FOUND",
            "CAMPAIGN_RENAMED_TO": "PLAN.CAMPAIGNS.CAMPAIGN_RENAMED_TO" as "PLAN.CAMPAIGNS.CAMPAIGN_RENAMED_TO",
            "CREATED_NEW_CAMPAIGN": "PLAN.CAMPAIGNS.CREATED_NEW_CAMPAIGN" as "PLAN.CAMPAIGNS.CREATED_NEW_CAMPAIGN",
            "DEPLOYS": {
                "ADJUST_EVENT_DATES_TITLE": "PLAN.CAMPAIGNS.DEPLOYS.ADJUST_EVENT_DATES_TITLE" as "PLAN.CAMPAIGNS.DEPLOYS.ADJUST_EVENT_DATES_TITLE",
                "CAMPAIGN_DEPLOYED": "PLAN.CAMPAIGNS.DEPLOYS.CAMPAIGN_DEPLOYED" as "PLAN.CAMPAIGNS.DEPLOYS.CAMPAIGN_DEPLOYED",
                "DEPLOY": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY",
                "DEPLOYMENT_HISTORY": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY",
                "DEPLOYMENT_HISTORY_LIST": {
                    "CAMPAIGN_NOT_FOUND": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.CAMPAIGN_NOT_FOUND" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.CAMPAIGN_NOT_FOUND",
                    "FILTERS": {
                        "LOCATION_PLACEHOLDER": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.FILTERS.LOCATION_PLACEHOLDER" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.FILTERS.LOCATION_PLACEHOLDER",
                        "STATUS_LABEL": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.FILTERS.STATUS_LABEL" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.FILTERS.STATUS_LABEL",
                        "STATUS_PLACEHOLDER": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.FILTERS.STATUS_PLACEHOLDER" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.FILTERS.STATUS_PLACEHOLDER"
                    },
                    "HEADERS": {
                        "CREATE_DATE": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.HEADERS.CREATE_DATE" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.HEADERS.CREATE_DATE",
                        "LOCATION": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.HEADERS.LOCATION" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.HEADERS.LOCATION",
                        "START_DATE": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.HEADERS.START_DATE" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.HEADERS.START_DATE",
                        "STATUS": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.HEADERS.STATUS" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.HEADERS.STATUS"
                    },
                    "NO_DEPLOYMENTS": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.NO_DEPLOYMENTS" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.NO_DEPLOYMENTS"
                },
                "DEPLOYMENT_HISTORY_STATUS": {
                    "ACTIVE": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.ACTIVE" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.ACTIVE",
                    "ACTIVE_HELP": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.ACTIVE_HELP" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.ACTIVE_HELP",
                    "COMPLETED": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.COMPLETED" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.COMPLETED",
                    "COMPLETED_HELP": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.COMPLETED_HELP" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.COMPLETED_HELP",
                    "FAILED": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.FAILED" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.FAILED",
                    "FAILED_HELP": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.FAILED_HELP" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.FAILED_HELP",
                    "ROLLINGOUT": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.ROLLINGOUT" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.ROLLINGOUT",
                    "ROLLINGOUT_HELP": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.ROLLINGOUT_HELP" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.ROLLINGOUT_HELP",
                    "SCHEDULED": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.SCHEDULED" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.SCHEDULED",
                    "SCHEDULED_HELP": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.SCHEDULED_HELP" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.SCHEDULED_HELP"
                },
                "DEPLOY_CAMPAIGN": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_CAMPAIGN" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_CAMPAIGN",
                "DEPLOY_CAMPAIGN_TO_LOCATION": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_CAMPAIGN_TO_LOCATION" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_CAMPAIGN_TO_LOCATION",
                "DEPLOY_FORM_COPY": {
                    "ADJUST_DATES": {
                        "EXPLAIN_STEP": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.ADJUST_DATES.EXPLAIN_STEP" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.ADJUST_DATES.EXPLAIN_STEP",
                        "EXPLAIN_STEP_ADJUST_DETAIL": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.ADJUST_DATES.EXPLAIN_STEP_ADJUST_DETAIL" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.ADJUST_DATES.EXPLAIN_STEP_ADJUST_DETAIL",
                        "EXPLAIN_STEP_REMOVE_DETAIL": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.ADJUST_DATES.EXPLAIN_STEP_REMOVE_DETAIL" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.ADJUST_DATES.EXPLAIN_STEP_REMOVE_DETAIL"
                    },
                    "CONFIRM": {
                        "CONFIRM_COPY": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.CONFIRM_COPY" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.CONFIRM_COPY",
                        "DEPLOYMENT_EXPLANATION_COPY": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.DEPLOYMENT_EXPLANATION_COPY" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.DEPLOYMENT_EXPLANATION_COPY",
                        "END_DATE": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.END_DATE" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.END_DATE",
                        "EVENTS": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.EVENTS" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.EVENTS",
                        "EVENTS_PER_LOCATION": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.EVENTS_PER_LOCATION" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.EVENTS_PER_LOCATION",
                        "HEADER": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.HEADER" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.HEADER",
                        "LOCATIONS": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.LOCATIONS" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.LOCATIONS",
                        "LOCATIONS_WITH_CLIENT": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.LOCATIONS_WITH_CLIENT" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.LOCATIONS_WITH_CLIENT",
                        "LOCATIONS_WITH_CLIENT_SINGULAR": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.LOCATIONS_WITH_CLIENT_SINGULAR" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.LOCATIONS_WITH_CLIENT_SINGULAR",
                        "PLEASE_CONFIRM": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.PLEASE_CONFIRM" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.PLEASE_CONFIRM",
                        "START_DATE": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.START_DATE" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.START_DATE",
                        "START_DEPLOYMENT": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.START_DEPLOYMENT" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.START_DEPLOYMENT"
                    },
                    "PICK_LOCATIONS": {
                        "EXPLAIN_STEP": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.PICK_LOCATIONS.EXPLAIN_STEP" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.PICK_LOCATIONS.EXPLAIN_STEP",
                        "EXPLAIN_STEP_DETAIL": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.PICK_LOCATIONS.EXPLAIN_STEP_DETAIL" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.PICK_LOCATIONS.EXPLAIN_STEP_DETAIL"
                    },
                    "STARTING_DATE": {
                        "EXPLAIN_STEP": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.STARTING_DATE.EXPLAIN_STEP" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.STARTING_DATE.EXPLAIN_STEP",
                        "EXPLAIN_STEP_DETAIL": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.STARTING_DATE.EXPLAIN_STEP_DETAIL" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.STARTING_DATE.EXPLAIN_STEP_DETAIL"
                    },
                    "STEPS": {
                        "ADJUST_DATES": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.STEPS.ADJUST_DATES" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.STEPS.ADJUST_DATES",
                        "PICK_LOCATIONS": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.STEPS.PICK_LOCATIONS" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.STEPS.PICK_LOCATIONS",
                        "REVIEW": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.STEPS.REVIEW" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.STEPS.REVIEW",
                        "SET_STARTING_DATE": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.STEPS.SET_STARTING_DATE" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.STEPS.SET_STARTING_DATE"
                    }
                },
                "DEPLOY_TO": "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_TO" as "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_TO",
                "ERRORS": {
                    "DEPLOYMENT_FAILED": "PLAN.CAMPAIGNS.DEPLOYS.ERRORS.DEPLOYMENT_FAILED" as "PLAN.CAMPAIGNS.DEPLOYS.ERRORS.DEPLOYMENT_FAILED",
                    "MUST_INCLUDE_ONE_EVENT": "PLAN.CAMPAIGNS.DEPLOYS.ERRORS.MUST_INCLUDE_ONE_EVENT" as "PLAN.CAMPAIGNS.DEPLOYS.ERRORS.MUST_INCLUDE_ONE_EVENT",
                    "MUST_INCLUDE_ONE_LOCATION": "PLAN.CAMPAIGNS.DEPLOYS.ERRORS.MUST_INCLUDE_ONE_LOCATION" as "PLAN.CAMPAIGNS.DEPLOYS.ERRORS.MUST_INCLUDE_ONE_LOCATION"
                },
                "PICK_LOCATIONS": "PLAN.CAMPAIGNS.DEPLOYS.PICK_LOCATIONS" as "PLAN.CAMPAIGNS.DEPLOYS.PICK_LOCATIONS",
                "SELECT_STARTING_DATE": "PLAN.CAMPAIGNS.DEPLOYS.SELECT_STARTING_DATE" as "PLAN.CAMPAIGNS.DEPLOYS.SELECT_STARTING_DATE",
                "STARTING_DATE": "PLAN.CAMPAIGNS.DEPLOYS.STARTING_DATE" as "PLAN.CAMPAIGNS.DEPLOYS.STARTING_DATE",
                "SUCCESSFUL_DEPLOY_COPY": "PLAN.CAMPAIGNS.DEPLOYS.SUCCESSFUL_DEPLOY_COPY" as "PLAN.CAMPAIGNS.DEPLOYS.SUCCESSFUL_DEPLOY_COPY"
            },
            "ERRORS": {
                "UPLOAD_FAILED": "PLAN.CAMPAIGNS.ERRORS.UPLOAD_FAILED" as "PLAN.CAMPAIGNS.ERRORS.UPLOAD_FAILED"
            },
            "EVENTS_LIST": {
                "HEADERS": {
                    "ACTIONS": "PLAN.CAMPAIGNS.EVENTS_LIST.HEADERS.ACTIONS" as "PLAN.CAMPAIGNS.EVENTS_LIST.HEADERS.ACTIONS",
                    "CHANNEL": "PLAN.CAMPAIGNS.EVENTS_LIST.HEADERS.CHANNEL" as "PLAN.CAMPAIGNS.EVENTS_LIST.HEADERS.CHANNEL",
                    "DAY": "PLAN.CAMPAIGNS.EVENTS_LIST.HEADERS.DAY" as "PLAN.CAMPAIGNS.EVENTS_LIST.HEADERS.DAY",
                    "INSTRUCTIONS_DESCRIPTION": "PLAN.CAMPAIGNS.EVENTS_LIST.HEADERS.INSTRUCTIONS_DESCRIPTION" as "PLAN.CAMPAIGNS.EVENTS_LIST.HEADERS.INSTRUCTIONS_DESCRIPTION",
                    "TITLE": "PLAN.CAMPAIGNS.EVENTS_LIST.HEADERS.TITLE" as "PLAN.CAMPAIGNS.EVENTS_LIST.HEADERS.TITLE"
                }
            },
            "IS_ARCHIVED": "PLAN.CAMPAIGNS.IS_ARCHIVED" as "PLAN.CAMPAIGNS.IS_ARCHIVED",
            "OVERVIEW": "PLAN.CAMPAIGNS.OVERVIEW" as "PLAN.CAMPAIGNS.OVERVIEW",
            "PLANNER_EVENTS": {
                "ARE_YOU_SURE_DELETE_PLANNER_EVENT": "PLAN.CAMPAIGNS.PLANNER_EVENTS.ARE_YOU_SURE_DELETE_PLANNER_EVENT" as "PLAN.CAMPAIGNS.PLANNER_EVENTS.ARE_YOU_SURE_DELETE_PLANNER_EVENT",
                "ERRORS": {
                    "ISSUE_CREATING_PLANNER_EVENT": "PLAN.CAMPAIGNS.PLANNER_EVENTS.ERRORS.ISSUE_CREATING_PLANNER_EVENT" as "PLAN.CAMPAIGNS.PLANNER_EVENTS.ERRORS.ISSUE_CREATING_PLANNER_EVENT",
                    "ISSUE_DELETING_PLANNER_EVENT": "PLAN.CAMPAIGNS.PLANNER_EVENTS.ERRORS.ISSUE_DELETING_PLANNER_EVENT" as "PLAN.CAMPAIGNS.PLANNER_EVENTS.ERRORS.ISSUE_DELETING_PLANNER_EVENT",
                    "ISSUE_UPDATING_PLANNER_EVENT": "PLAN.CAMPAIGNS.PLANNER_EVENTS.ERRORS.ISSUE_UPDATING_PLANNER_EVENT" as "PLAN.CAMPAIGNS.PLANNER_EVENTS.ERRORS.ISSUE_UPDATING_PLANNER_EVENT"
                },
                "NEW_PLANNER_EVENT": "PLAN.CAMPAIGNS.PLANNER_EVENTS.NEW_PLANNER_EVENT" as "PLAN.CAMPAIGNS.PLANNER_EVENTS.NEW_PLANNER_EVENT",
                "PLANNER_EVENTS": "PLAN.CAMPAIGNS.PLANNER_EVENTS.PLANNER_EVENTS" as "PLAN.CAMPAIGNS.PLANNER_EVENTS.PLANNER_EVENTS",
                "PLANNER_EVENT_CREATED": "PLAN.CAMPAIGNS.PLANNER_EVENTS.PLANNER_EVENT_CREATED" as "PLAN.CAMPAIGNS.PLANNER_EVENTS.PLANNER_EVENT_CREATED",
                "PLANNER_EVENT_DELETED": "PLAN.CAMPAIGNS.PLANNER_EVENTS.PLANNER_EVENT_DELETED" as "PLAN.CAMPAIGNS.PLANNER_EVENTS.PLANNER_EVENT_DELETED",
                "PLANNER_EVENT_NOT_FOUND": "PLAN.CAMPAIGNS.PLANNER_EVENTS.PLANNER_EVENT_NOT_FOUND" as "PLAN.CAMPAIGNS.PLANNER_EVENTS.PLANNER_EVENT_NOT_FOUND",
                "PLANNER_EVENT_UPDATED": "PLAN.CAMPAIGNS.PLANNER_EVENTS.PLANNER_EVENT_UPDATED" as "PLAN.CAMPAIGNS.PLANNER_EVENTS.PLANNER_EVENT_UPDATED",
                "READY_TO_ACTION": "PLAN.CAMPAIGNS.PLANNER_EVENTS.READY_TO_ACTION" as "PLAN.CAMPAIGNS.PLANNER_EVENTS.READY_TO_ACTION"
            },
            "RETURN_TO_CAMPAIGNS_PAGE": "PLAN.CAMPAIGNS.RETURN_TO_CAMPAIGNS_PAGE" as "PLAN.CAMPAIGNS.RETURN_TO_CAMPAIGNS_PAGE"
        },
        "CONTENT_REQUIRED": "PLAN.CONTENT_REQUIRED" as "PLAN.CONTENT_REQUIRED",
        "CONTENT_REQUIRED_TOOLTIP": "PLAN.CONTENT_REQUIRED_TOOLTIP" as "PLAN.CONTENT_REQUIRED_TOOLTIP",
        "DANGEROUS_DATE_HEADING": "PLAN.DANGEROUS_DATE_HEADING" as "PLAN.DANGEROUS_DATE_HEADING",
        "DANGEROUS_DATE_NOTE": "PLAN.DANGEROUS_DATE_NOTE" as "PLAN.DANGEROUS_DATE_NOTE",
        "EVENT": {
            "ACTIVITY": "PLAN.EVENT.ACTIVITY" as "PLAN.EVENT.ACTIVITY",
            "ADDITIONAL_LOCATIONS": "PLAN.EVENT.ADDITIONAL_LOCATIONS" as "PLAN.EVENT.ADDITIONAL_LOCATIONS",
            "ADD_REMOVE_LOCATIONS": "PLAN.EVENT.ADD_REMOVE_LOCATIONS" as "PLAN.EVENT.ADD_REMOVE_LOCATIONS",
            "ADD_TO_PLANNER": "PLAN.EVENT.ADD_TO_PLANNER" as "PLAN.EVENT.ADD_TO_PLANNER",
            "BACK_TO_CALENDAR": "PLAN.EVENT.BACK_TO_CALENDAR" as "PLAN.EVENT.BACK_TO_CALENDAR",
            "BUILD_NOW": "PLAN.EVENT.BUILD_NOW" as "PLAN.EVENT.BUILD_NOW",
            "CONFIRM_DELETE": "PLAN.EVENT.CONFIRM_DELETE" as "PLAN.EVENT.CONFIRM_DELETE",
            "DAILY": "PLAN.EVENT.DAILY" as "PLAN.EVENT.DAILY",
            "DATE_OF_MONTH_EXAMPLE": "PLAN.EVENT.DATE_OF_MONTH_EXAMPLE" as "PLAN.EVENT.DATE_OF_MONTH_EXAMPLE",
            "DATE_OF_MONTH_IN_YEAR_EXAMPLE": "PLAN.EVENT.DATE_OF_MONTH_IN_YEAR_EXAMPLE" as "PLAN.EVENT.DATE_OF_MONTH_IN_YEAR_EXAMPLE",
            "DATE_OF_WEEK_EXAMPLE": "PLAN.EVENT.DATE_OF_WEEK_EXAMPLE" as "PLAN.EVENT.DATE_OF_WEEK_EXAMPLE",
            "DATE_OF_WEEK_IN_YEAR_EXAMPLE": "PLAN.EVENT.DATE_OF_WEEK_IN_YEAR_EXAMPLE" as "PLAN.EVENT.DATE_OF_WEEK_IN_YEAR_EXAMPLE",
            "DATE_SUBMITTED": "PLAN.EVENT.DATE_SUBMITTED" as "PLAN.EVENT.DATE_SUBMITTED",
            "DATE_UPDATED": "PLAN.EVENT.DATE_UPDATED" as "PLAN.EVENT.DATE_UPDATED",
            "DELETE_PLANNER_EVENT": "PLAN.EVENT.DELETE_PLANNER_EVENT" as "PLAN.EVENT.DELETE_PLANNER_EVENT",
            "DELETE_RECURRING": "PLAN.EVENT.DELETE_RECURRING" as "PLAN.EVENT.DELETE_RECURRING",
            "DELETION_ALERT": "PLAN.EVENT.DELETION_ALERT" as "PLAN.EVENT.DELETION_ALERT",
            "EDIT_PLANNER": "PLAN.EVENT.EDIT_PLANNER" as "PLAN.EVENT.EDIT_PLANNER",
            "ENDS": "PLAN.EVENT.ENDS" as "PLAN.EVENT.ENDS",
            "EVENT_SERIES": "PLAN.EVENT.EVENT_SERIES" as "PLAN.EVENT.EVENT_SERIES",
            "EVENT_SERIES_CHOOSE_ALL": "PLAN.EVENT.EVENT_SERIES_CHOOSE_ALL" as "PLAN.EVENT.EVENT_SERIES_CHOOSE_ALL",
            "EVENT_SERIES_CHOOSE_CURRENT": "PLAN.EVENT.EVENT_SERIES_CHOOSE_CURRENT" as "PLAN.EVENT.EVENT_SERIES_CHOOSE_CURRENT",
            "EVENT_SERIES_CHOOSE_FUTURE": "PLAN.EVENT.EVENT_SERIES_CHOOSE_FUTURE" as "PLAN.EVENT.EVENT_SERIES_CHOOSE_FUTURE",
            "EVENT_SERIES_OPTIONS_DELETE": "PLAN.EVENT.EVENT_SERIES_OPTIONS_DELETE" as "PLAN.EVENT.EVENT_SERIES_OPTIONS_DELETE",
            "EVENT_SERIES_OPTIONS_UPDATE": "PLAN.EVENT.EVENT_SERIES_OPTIONS_UPDATE" as "PLAN.EVENT.EVENT_SERIES_OPTIONS_UPDATE",
            "FAILED_TO_CREATE_UPDATE_PLANNER": "PLAN.EVENT.FAILED_TO_CREATE_UPDATE_PLANNER" as "PLAN.EVENT.FAILED_TO_CREATE_UPDATE_PLANNER",
            "FAILED_TO_DELETE_PLANNER": "PLAN.EVENT.FAILED_TO_DELETE_PLANNER" as "PLAN.EVENT.FAILED_TO_DELETE_PLANNER",
            "FAILED_TO_RETRIEVE_PLANNER": "PLAN.EVENT.FAILED_TO_RETRIEVE_PLANNER" as "PLAN.EVENT.FAILED_TO_RETRIEVE_PLANNER",
            "FAILED_TO_RETRIEVE_PLANNER_INFO": "PLAN.EVENT.FAILED_TO_RETRIEVE_PLANNER_INFO" as "PLAN.EVENT.FAILED_TO_RETRIEVE_PLANNER_INFO",
            "FIFTH": "PLAN.EVENT.FIFTH" as "PLAN.EVENT.FIFTH",
            "FIRST": "PLAN.EVENT.FIRST" as "PLAN.EVENT.FIRST",
            "FORTNIGHTLY": "PLAN.EVENT.FORTNIGHTLY" as "PLAN.EVENT.FORTNIGHTLY",
            "FOURTH": "PLAN.EVENT.FOURTH" as "PLAN.EVENT.FOURTH",
            "FRIDAY": "PLAN.EVENT.FRIDAY" as "PLAN.EVENT.FRIDAY",
            "INSTRUCTIONS_TO_MANAGER": "PLAN.EVENT.INSTRUCTIONS_TO_MANAGER" as "PLAN.EVENT.INSTRUCTIONS_TO_MANAGER",
            "MONDAY": "PLAN.EVENT.MONDAY" as "PLAN.EVENT.MONDAY",
            "NO_ARTWORK": "PLAN.EVENT.NO_ARTWORK" as "PLAN.EVENT.NO_ARTWORK",
            "OCCURRENCES": "PLAN.EVENT.OCCURRENCES" as "PLAN.EVENT.OCCURRENCES",
            "OLD_ACTIVITIES": "PLAN.EVENT.OLD_ACTIVITIES" as "PLAN.EVENT.OLD_ACTIVITIES",
            "PLANNER_EVENT_DELETED": "PLAN.EVENT.PLANNER_EVENT_DELETED" as "PLAN.EVENT.PLANNER_EVENT_DELETED",
            "PLEASE_DELETE_ITEM_VIA": "PLAN.EVENT.PLEASE_DELETE_ITEM_VIA" as "PLAN.EVENT.PLEASE_DELETE_ITEM_VIA",
            "READY_TO_ACTION": "PLAN.EVENT.READY_TO_ACTION" as "PLAN.EVENT.READY_TO_ACTION",
            "RECURRING_EVENT_QUESTION": "PLAN.EVENT.RECURRING_EVENT_QUESTION" as "PLAN.EVENT.RECURRING_EVENT_QUESTION",
            "REPEAT_BY": "PLAN.EVENT.REPEAT_BY" as "PLAN.EVENT.REPEAT_BY",
            "REQUIRED_INFO": "PLAN.EVENT.REQUIRED_INFO" as "PLAN.EVENT.REQUIRED_INFO",
            "SATURDAY": "PLAN.EVENT.SATURDAY" as "PLAN.EVENT.SATURDAY",
            "SAVE_BUILD_LATER": "PLAN.EVENT.SAVE_BUILD_LATER" as "PLAN.EVENT.SAVE_BUILD_LATER",
            "SAVE_BUILD_NOW": "PLAN.EVENT.SAVE_BUILD_NOW" as "PLAN.EVENT.SAVE_BUILD_NOW",
            "SAVE_MORE_CONTENT_REQUIRED": "PLAN.EVENT.SAVE_MORE_CONTENT_REQUIRED" as "PLAN.EVENT.SAVE_MORE_CONTENT_REQUIRED",
            "SCHEDULED_PAGE": "PLAN.EVENT.SCHEDULED_PAGE" as "PLAN.EVENT.SCHEDULED_PAGE",
            "SECOND": "PLAN.EVENT.SECOND" as "PLAN.EVENT.SECOND",
            "SELF_SERVICE": "PLAN.EVENT.SELF_SERVICE" as "PLAN.EVENT.SELF_SERVICE",
            "STARTS_ON": "PLAN.EVENT.STARTS_ON" as "PLAN.EVENT.STARTS_ON",
            "SUBMITTED_BY": "PLAN.EVENT.SUBMITTED_BY" as "PLAN.EVENT.SUBMITTED_BY",
            "SUNDAY": "PLAN.EVENT.SUNDAY" as "PLAN.EVENT.SUNDAY",
            "SUPPORT_ACTIONS": "PLAN.EVENT.SUPPORT_ACTIONS" as "PLAN.EVENT.SUPPORT_ACTIONS",
            "SUPPORT_ACTION_ONE": "PLAN.EVENT.SUPPORT_ACTION_ONE" as "PLAN.EVENT.SUPPORT_ACTION_ONE",
            "SUPPORT_ACTION_THREE": "PLAN.EVENT.SUPPORT_ACTION_THREE" as "PLAN.EVENT.SUPPORT_ACTION_THREE",
            "SUPPORT_ACTION_TWO": "PLAN.EVENT.SUPPORT_ACTION_TWO" as "PLAN.EVENT.SUPPORT_ACTION_TWO",
            "SUPPORT_HEADING": "PLAN.EVENT.SUPPORT_HEADING" as "PLAN.EVENT.SUPPORT_HEADING",
            "SUPPORT_NOTE": "PLAN.EVENT.SUPPORT_NOTE" as "PLAN.EVENT.SUPPORT_NOTE",
            "SUPPORT_OVERPLANNED": "PLAN.EVENT.SUPPORT_OVERPLANNED" as "PLAN.EVENT.SUPPORT_OVERPLANNED",
            "SUPPORT_REQUESTED": "PLAN.EVENT.SUPPORT_REQUESTED" as "PLAN.EVENT.SUPPORT_REQUESTED",
            "TEMPLATE_CATEGORY_EXPIRED": "PLAN.EVENT.TEMPLATE_CATEGORY_EXPIRED" as "PLAN.EVENT.TEMPLATE_CATEGORY_EXPIRED",
            "THIRD": "PLAN.EVENT.THIRD" as "PLAN.EVENT.THIRD",
            "THURSDAY": "PLAN.EVENT.THURSDAY" as "PLAN.EVENT.THURSDAY",
            "TUESDAY": "PLAN.EVENT.TUESDAY" as "PLAN.EVENT.TUESDAY",
            "UPDATED_BY": "PLAN.EVENT.UPDATED_BY" as "PLAN.EVENT.UPDATED_BY",
            "UPDATE_RECURRING": "PLAN.EVENT.UPDATE_RECURRING" as "PLAN.EVENT.UPDATE_RECURRING",
            "WEDNESDAY": "PLAN.EVENT.WEDNESDAY" as "PLAN.EVENT.WEDNESDAY",
            "WEEKLY": "PLAN.EVENT.WEEKLY" as "PLAN.EVENT.WEEKLY"
        },
        "GENERAL_ITEM": "PLAN.GENERAL_ITEM" as "PLAN.GENERAL_ITEM",
        "GENERAL_ITEM_TOOLTIP": "PLAN.GENERAL_ITEM_TOOLTIP" as "PLAN.GENERAL_ITEM_TOOLTIP",
        "INTRO_DUMMY_ACTIVITY": "PLAN.INTRO_DUMMY_ACTIVITY" as "PLAN.INTRO_DUMMY_ACTIVITY",
        "INTRO_DUMMY_CHANNEL": "PLAN.INTRO_DUMMY_CHANNEL" as "PLAN.INTRO_DUMMY_CHANNEL",
        "MULTIPLE_LOCATIONS": {
            "SAVING_FOR_THESE_LOCATIONS": "PLAN.MULTIPLE_LOCATIONS.SAVING_FOR_THESE_LOCATIONS" as "PLAN.MULTIPLE_LOCATIONS.SAVING_FOR_THESE_LOCATIONS",
            "SAVING_FOR_TITLE": "PLAN.MULTIPLE_LOCATIONS.SAVING_FOR_TITLE" as "PLAN.MULTIPLE_LOCATIONS.SAVING_FOR_TITLE",
            "SOME_LOCATIONS_FAILED_TO_SAVE": "PLAN.MULTIPLE_LOCATIONS.SOME_LOCATIONS_FAILED_TO_SAVE" as "PLAN.MULTIPLE_LOCATIONS.SOME_LOCATIONS_FAILED_TO_SAVE",
            "TOTAL_SAVING_PROGRESS": "PLAN.MULTIPLE_LOCATIONS.TOTAL_SAVING_PROGRESS" as "PLAN.MULTIPLE_LOCATIONS.TOTAL_SAVING_PROGRESS",
            "WOULD_YOU_LIKE_TO_RETRY_FOR_FAILED_LOCATIONS": "PLAN.MULTIPLE_LOCATIONS.WOULD_YOU_LIKE_TO_RETRY_FOR_FAILED_LOCATIONS" as "PLAN.MULTIPLE_LOCATIONS.WOULD_YOU_LIKE_TO_RETRY_FOR_FAILED_LOCATIONS"
        },
        "NEXT_MONTH": "PLAN.NEXT_MONTH" as "PLAN.NEXT_MONTH",
        "NEXT_WEEK": "PLAN.NEXT_WEEK" as "PLAN.NEXT_WEEK",
        "NOTIFY_PLANNER_CREATED": "PLAN.NOTIFY_PLANNER_CREATED" as "PLAN.NOTIFY_PLANNER_CREATED",
        "NOTIFY_PLANNER_CREATED_PARTIAL": "PLAN.NOTIFY_PLANNER_CREATED_PARTIAL" as "PLAN.NOTIFY_PLANNER_CREATED_PARTIAL",
        "NOTIFY_PLANNER_CREATE_ERROR": "PLAN.NOTIFY_PLANNER_CREATE_ERROR" as "PLAN.NOTIFY_PLANNER_CREATE_ERROR",
        "NOTIFY_PLANNER_EVENT_DELETED": "PLAN.NOTIFY_PLANNER_EVENT_DELETED" as "PLAN.NOTIFY_PLANNER_EVENT_DELETED",
        "NOTIFY_PLANNER_UPDATED": "PLAN.NOTIFY_PLANNER_UPDATED" as "PLAN.NOTIFY_PLANNER_UPDATED",
        "PAST_DATE_CANT_PLAN": "PLAN.PAST_DATE_CANT_PLAN" as "PLAN.PAST_DATE_CANT_PLAN",
        "PAST_DATE_HEADING": "PLAN.PAST_DATE_HEADING" as "PLAN.PAST_DATE_HEADING",
        "PAST_DATE_RECURRING": "PLAN.PAST_DATE_RECURRING" as "PLAN.PAST_DATE_RECURRING",
        "PLAN": "PLAN.PLAN" as "PLAN.PLAN",
        "PLANNER": "PLAN.PLANNER" as "PLAN.PLANNER",
        "PREVIOUS_MONTH": "PLAN.PREVIOUS_MONTH" as "PLAN.PREVIOUS_MONTH",
        "PREVIOUS_WEEK": "PLAN.PREVIOUS_WEEK" as "PLAN.PREVIOUS_WEEK",
        "READY_TO_BUILD": "PLAN.READY_TO_BUILD" as "PLAN.READY_TO_BUILD",
        "READY_TO_BUILD_TOOLTIP": "PLAN.READY_TO_BUILD_TOOLTIP" as "PLAN.READY_TO_BUILD_TOOLTIP",
        "SAVING_PLANNER_EVENT": "PLAN.SAVING_PLANNER_EVENT" as "PLAN.SAVING_PLANNER_EVENT",
        "SPECIAL_REQUEST": "PLAN.SPECIAL_REQUEST" as "PLAN.SPECIAL_REQUEST",
        "UPDATE_RECURRING_DATE": "PLAN.UPDATE_RECURRING_DATE" as "PLAN.UPDATE_RECURRING_DATE",
        "VIEW_BY_MONTH": "PLAN.VIEW_BY_MONTH" as "PLAN.VIEW_BY_MONTH",
        "VIEW_BY_WEEK": "PLAN.VIEW_BY_WEEK" as "PLAN.VIEW_BY_WEEK"
    },
    "PROFILE": {
        "CHANGE_IMAGE": "PROFILE.CHANGE_IMAGE" as "PROFILE.CHANGE_IMAGE",
        "CHANGE_PROFILE_PICTURE": "PROFILE.CHANGE_PROFILE_PICTURE" as "PROFILE.CHANGE_PROFILE_PICTURE",
        "CONFIRM_REMOVE_PROFILE_PICTURE": "PROFILE.CONFIRM_REMOVE_PROFILE_PICTURE" as "PROFILE.CONFIRM_REMOVE_PROFILE_PICTURE",
        "EMAIL": "PROFILE.EMAIL" as "PROFILE.EMAIL",
        "EMAIL_REQUIRED": "PROFILE.EMAIL_REQUIRED" as "PROFILE.EMAIL_REQUIRED",
        "FIRST_NAME": "PROFILE.FIRST_NAME" as "PROFILE.FIRST_NAME",
        "FIRST_NAME_REQUIRED": "PROFILE.FIRST_NAME_REQUIRED" as "PROFILE.FIRST_NAME_REQUIRED",
        "INVITE_SENT": "PROFILE.INVITE_SENT" as "PROFILE.INVITE_SENT",
        "LAST_NAME": "PROFILE.LAST_NAME" as "PROFILE.LAST_NAME",
        "LAST_NAME_REQUIRED": "PROFILE.LAST_NAME_REQUIRED" as "PROFILE.LAST_NAME_REQUIRED",
        "MARKETING_UPDATES": "PROFILE.MARKETING_UPDATES" as "PROFILE.MARKETING_UPDATES",
        "MINIMUM_IMAGE_DIMENSION_REQUIREMENT": "PROFILE.MINIMUM_IMAGE_DIMENSION_REQUIREMENT" as "PROFILE.MINIMUM_IMAGE_DIMENSION_REQUIREMENT",
        "NOTIFICATIONS": "PROFILE.NOTIFICATIONS" as "PROFILE.NOTIFICATIONS",
        "PASSWORD": "PROFILE.PASSWORD" as "PROFILE.PASSWORD",
        "PROFILE": "PROFILE.PROFILE" as "PROFILE.PROFILE",
        "PROFILE_PICTURE": "PROFILE.PROFILE_PICTURE" as "PROFILE.PROFILE_PICTURE",
        "REMOVE_IMAGE": "PROFILE.REMOVE_IMAGE" as "PROFILE.REMOVE_IMAGE",
        "RESEND_INVITE": "PROFILE.RESEND_INVITE" as "PROFILE.RESEND_INVITE",
        "SENDING_INVITE": "PROFILE.SENDING_INVITE" as "PROFILE.SENDING_INVITE",
        "SPECIAL_REQUESTS": "PROFILE.SPECIAL_REQUESTS" as "PROFILE.SPECIAL_REQUESTS",
        "TIMEZONE": "PROFILE.TIMEZONE" as "PROFILE.TIMEZONE",
        "UNITS": "PROFILE.UNITS" as "PROFILE.UNITS",
        "UNSUPPORTED_IMAGE_FORMAT": "PROFILE.UNSUPPORTED_IMAGE_FORMAT" as "PROFILE.UNSUPPORTED_IMAGE_FORMAT",
        "USER_ACCOUNT_UPDATED": "PROFILE.USER_ACCOUNT_UPDATED" as "PROFILE.USER_ACCOUNT_UPDATED",
        "USER_LOCALE_CHANGED_PAGE_WILL_RELOAD": "PROFILE.USER_LOCALE_CHANGED_PAGE_WILL_RELOAD" as "PROFILE.USER_LOCALE_CHANGED_PAGE_WILL_RELOAD",
        "USER_PROFILE": "PROFILE.USER_PROFILE" as "PROFILE.USER_PROFILE"
    },
    "REPORT": {
        "ADD_REMOVE_LOCATIONS": "REPORT.ADD_REMOVE_LOCATIONS" as "REPORT.ADD_REMOVE_LOCATIONS",
        "ADJUSTED_DAILY_BUDGET": "REPORT.ADJUSTED_DAILY_BUDGET" as "REPORT.ADJUSTED_DAILY_BUDGET",
        "ADJUST_SPEND": "REPORT.ADJUST_SPEND" as "REPORT.ADJUST_SPEND",
        "ADVERTISING": "REPORT.ADVERTISING" as "REPORT.ADVERTISING",
        "AD_NAME": "REPORT.AD_NAME" as "REPORT.AD_NAME",
        "ALL_MONETARY_FIGURES_ARE_IN_CURRENCY": "REPORT.ALL_MONETARY_FIGURES_ARE_IN_CURRENCY" as "REPORT.ALL_MONETARY_FIGURES_ARE_IN_CURRENCY",
        "AVERAGE_POSITION": "REPORT.AVERAGE_POSITION" as "REPORT.AVERAGE_POSITION",
        "BOUNCED": "REPORT.BOUNCED" as "REPORT.BOUNCED",
        "BRAND_AWARENESS": "REPORT.BRAND_AWARENESS" as "REPORT.BRAND_AWARENESS",
        "BRAND_AWARENESS_BY_AD": "REPORT.BRAND_AWARENESS_BY_AD" as "REPORT.BRAND_AWARENESS_BY_AD",
        "BRAND_AWARENESS_BY_KEYWORD": "REPORT.BRAND_AWARENESS_BY_KEYWORD" as "REPORT.BRAND_AWARENESS_BY_KEYWORD",
        "BUDGET": "REPORT.BUDGET" as "REPORT.BUDGET",
        "BY_AD": "REPORT.BY_AD" as "REPORT.BY_AD",
        "BY_KEYWORD": "REPORT.BY_KEYWORD" as "REPORT.BY_KEYWORD",
        "CAMPAIGN": "REPORT.CAMPAIGN" as "REPORT.CAMPAIGN",
        "CAMPAIGN_MONITOR": {
            "TITLE": "REPORT.CAMPAIGN_MONITOR.TITLE" as "REPORT.CAMPAIGN_MONITOR.TITLE"
        },
        "CANT_REPORT_MORE_THAN_THREE_MONTHS": "REPORT.CANT_REPORT_MORE_THAN_THREE_MONTHS" as "REPORT.CANT_REPORT_MORE_THAN_THREE_MONTHS",
        "CLICKED": "REPORT.CLICKED" as "REPORT.CLICKED",
        "CLICKS": "REPORT.CLICKS" as "REPORT.CLICKS",
        "CLICK_RATE": "REPORT.CLICK_RATE" as "REPORT.CLICK_RATE",
        "CLICK_THROUGH_RATE": "REPORT.CLICK_THROUGH_RATE" as "REPORT.CLICK_THROUGH_RATE",
        "CLICK_THROUGH_RATE_HINT": "REPORT.CLICK_THROUGH_RATE_HINT" as "REPORT.CLICK_THROUGH_RATE_HINT",
        "CLIENT_OR_LOCATION": "REPORT.CLIENT_OR_LOCATION" as "REPORT.CLIENT_OR_LOCATION",
        "COLLAPSE_POSTS": "REPORT.COLLAPSE_POSTS" as "REPORT.COLLAPSE_POSTS",
        "COLLAPSE_ROWS": "REPORT.COLLAPSE_ROWS" as "REPORT.COLLAPSE_ROWS",
        "CONFIRM_DELETE_REPORT_SUMMARY": "REPORT.CONFIRM_DELETE_REPORT_SUMMARY" as "REPORT.CONFIRM_DELETE_REPORT_SUMMARY",
        "CONSUMED": "REPORT.CONSUMED" as "REPORT.CONSUMED",
        "CONSUMPTION": "REPORT.CONSUMPTION" as "REPORT.CONSUMPTION",
        "CONVERSIONS": "REPORT.CONVERSIONS" as "REPORT.CONVERSIONS",
        "CONVERSIONS_BY_AD": "REPORT.CONVERSIONS_BY_AD" as "REPORT.CONVERSIONS_BY_AD",
        "CONVERSIONS_BY_KEYWORD": "REPORT.CONVERSIONS_BY_KEYWORD" as "REPORT.CONVERSIONS_BY_KEYWORD",
        "CONVERSIONS_PLATFORM_NOT_CONFIGURED_FOR_LOCATION": "REPORT.CONVERSIONS_PLATFORM_NOT_CONFIGURED_FOR_LOCATION" as "REPORT.CONVERSIONS_PLATFORM_NOT_CONFIGURED_FOR_LOCATION",
        "CONVERSION_VALUE": "REPORT.CONVERSION_VALUE" as "REPORT.CONVERSION_VALUE",
        "CONVERSION_VALUE_HINT": "REPORT.CONVERSION_VALUE_HINT" as "REPORT.CONVERSION_VALUE_HINT",
        "COST_PER_CLICK": "REPORT.COST_PER_CLICK" as "REPORT.COST_PER_CLICK",
        "COST_PER_CONVERSION": "REPORT.COST_PER_CONVERSION" as "REPORT.COST_PER_CONVERSION",
        "COST_PER_LEAD": "REPORT.COST_PER_LEAD" as "REPORT.COST_PER_LEAD",
        "COST_PER_UNIQUE_CLICK": "REPORT.COST_PER_UNIQUE_CLICK" as "REPORT.COST_PER_UNIQUE_CLICK",
        "CURRENCY": "REPORT.CURRENCY" as "REPORT.CURRENCY",
        "CURRENT_SPEND": "REPORT.CURRENT_SPEND" as "REPORT.CURRENT_SPEND",
        "DEVICES": {
            "DESKTOP": "REPORT.DEVICES.DESKTOP" as "REPORT.DEVICES.DESKTOP",
            "MOBILE": "REPORT.DEVICES.MOBILE" as "REPORT.DEVICES.MOBILE",
            "TABLET": "REPORT.DEVICES.TABLET" as "REPORT.DEVICES.TABLET",
            "UNKNOWN": "REPORT.DEVICES.UNKNOWN" as "REPORT.DEVICES.UNKNOWN"
        },
        "DEVICE_SELECTION": "REPORT.DEVICE_SELECTION" as "REPORT.DEVICE_SELECTION",
        "DEVICE_SELECTION_HINT": "REPORT.DEVICE_SELECTION_HINT" as "REPORT.DEVICE_SELECTION_HINT",
        "EMAIL_CAMPAIGNS": {
            "BOUNCES": "REPORT.EMAIL_CAMPAIGNS.BOUNCES" as "REPORT.EMAIL_CAMPAIGNS.BOUNCES",
            "BUTTONS": {
                "DOWNLOAD_CSV": "REPORT.EMAIL_CAMPAIGNS.BUTTONS.DOWNLOAD_CSV" as "REPORT.EMAIL_CAMPAIGNS.BUTTONS.DOWNLOAD_CSV",
                "EXPORT_CSV": "REPORT.EMAIL_CAMPAIGNS.BUTTONS.EXPORT_CSV" as "REPORT.EMAIL_CAMPAIGNS.BUTTONS.EXPORT_CSV"
            },
            "CLICKS": "REPORT.EMAIL_CAMPAIGNS.CLICKS" as "REPORT.EMAIL_CAMPAIGNS.CLICKS",
            "CLICK_RATE": "REPORT.EMAIL_CAMPAIGNS.CLICK_RATE" as "REPORT.EMAIL_CAMPAIGNS.CLICK_RATE",
            "DELIVERED": "REPORT.EMAIL_CAMPAIGNS.DELIVERED" as "REPORT.EMAIL_CAMPAIGNS.DELIVERED",
            "ERROR_COULD_NOT_BE_RETRIEVED": "REPORT.EMAIL_CAMPAIGNS.ERROR_COULD_NOT_BE_RETRIEVED" as "REPORT.EMAIL_CAMPAIGNS.ERROR_COULD_NOT_BE_RETRIEVED",
            "ERROR_EXPORTING_CSV": "REPORT.EMAIL_CAMPAIGNS.ERROR_EXPORTING_CSV" as "REPORT.EMAIL_CAMPAIGNS.ERROR_EXPORTING_CSV",
            "EXPORTING_PLEASE_WAIT": "REPORT.EMAIL_CAMPAIGNS.EXPORTING_PLEASE_WAIT" as "REPORT.EMAIL_CAMPAIGNS.EXPORTING_PLEASE_WAIT",
            "HTML_PREVIEW_DIALOG_TITLE": "REPORT.EMAIL_CAMPAIGNS.HTML_PREVIEW_DIALOG_TITLE" as "REPORT.EMAIL_CAMPAIGNS.HTML_PREVIEW_DIALOG_TITLE",
            "INVALID_EMAILS": "REPORT.EMAIL_CAMPAIGNS.INVALID_EMAILS" as "REPORT.EMAIL_CAMPAIGNS.INVALID_EMAILS",
            "NOTIFICATIONS": {
                "EXPORTING_ERROR": "REPORT.EMAIL_CAMPAIGNS.NOTIFICATIONS.EXPORTING_ERROR" as "REPORT.EMAIL_CAMPAIGNS.NOTIFICATIONS.EXPORTING_ERROR",
                "EXPORTING_SUCCESS": "REPORT.EMAIL_CAMPAIGNS.NOTIFICATIONS.EXPORTING_SUCCESS" as "REPORT.EMAIL_CAMPAIGNS.NOTIFICATIONS.EXPORTING_SUCCESS"
            },
            "NOT_CONNECTED": "REPORT.EMAIL_CAMPAIGNS.NOT_CONNECTED" as "REPORT.EMAIL_CAMPAIGNS.NOT_CONNECTED",
            "NUMBER_RECIPIENTS": "REPORT.EMAIL_CAMPAIGNS.NUMBER_RECIPIENTS" as "REPORT.EMAIL_CAMPAIGNS.NUMBER_RECIPIENTS",
            "OPENS": "REPORT.EMAIL_CAMPAIGNS.OPENS" as "REPORT.EMAIL_CAMPAIGNS.OPENS",
            "OPEN_RATE": "REPORT.EMAIL_CAMPAIGNS.OPEN_RATE" as "REPORT.EMAIL_CAMPAIGNS.OPEN_RATE",
            "PLEASE_SELECT_EMAIL_PLATFORM": "REPORT.EMAIL_CAMPAIGNS.PLEASE_SELECT_EMAIL_PLATFORM" as "REPORT.EMAIL_CAMPAIGNS.PLEASE_SELECT_EMAIL_PLATFORM",
            "RECIPIENTS": "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS" as "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS",
            "RECIPIENTS_TABLE": {
                "CLICKED_LINK": "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.CLICKED_LINK" as "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.CLICKED_LINK",
                "DELIVERED": "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.DELIVERED" as "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.DELIVERED",
                "MARKED_AS_SPAM": "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.MARKED_AS_SPAM" as "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.MARKED_AS_SPAM",
                "NO_RECIPIENTS_FOUND": "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.NO_RECIPIENTS_FOUND" as "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.NO_RECIPIENTS_FOUND",
                "OPENED": "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.OPENED" as "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.OPENED",
                "RECIPIENT_EMAIL": "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.RECIPIENT_EMAIL" as "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.RECIPIENT_EMAIL",
                "RECIPIENT_EMAIL_FILTER_LABEL": "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.RECIPIENT_EMAIL_FILTER_LABEL" as "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.RECIPIENT_EMAIL_FILTER_LABEL",
                "RECIPIENT_EMAIL_FILTER_PLACEHOLDER": "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.RECIPIENT_EMAIL_FILTER_PLACEHOLDER" as "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.RECIPIENT_EMAIL_FILTER_PLACEHOLDER",
                "RECIPIENT_NAME": "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.RECIPIENT_NAME" as "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.RECIPIENT_NAME",
                "RECIPIENT_NAME_FILTER_LABEL": "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.RECIPIENT_NAME_FILTER_LABEL" as "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.RECIPIENT_NAME_FILTER_LABEL",
                "RECIPIENT_NAME_FILTER_PLACEHOLDER": "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.RECIPIENT_NAME_FILTER_PLACEHOLDER" as "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.RECIPIENT_NAME_FILTER_PLACEHOLDER",
                "UNSUBSCRIBED": "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.UNSUBSCRIBED" as "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.UNSUBSCRIBED"
            },
            "SENDING_ON": "REPORT.EMAIL_CAMPAIGNS.SENDING_ON" as "REPORT.EMAIL_CAMPAIGNS.SENDING_ON",
            "SENT_TO": "REPORT.EMAIL_CAMPAIGNS.SENT_TO" as "REPORT.EMAIL_CAMPAIGNS.SENT_TO",
            "SPAM_REPORTS": "REPORT.EMAIL_CAMPAIGNS.SPAM_REPORTS" as "REPORT.EMAIL_CAMPAIGNS.SPAM_REPORTS"
        },
        "END_DATE": "REPORT.END_DATE" as "REPORT.END_DATE",
        "END_DATE_BEFORE_START_DATE": "REPORT.END_DATE_BEFORE_START_DATE" as "REPORT.END_DATE_BEFORE_START_DATE",
        "ENGAGED_USERS": "REPORT.ENGAGED_USERS" as "REPORT.ENGAGED_USERS",
        "ENGAGEMENT": "REPORT.ENGAGEMENT" as "REPORT.ENGAGEMENT",
        "ENGAGEMENT_CLICKS": "REPORT.ENGAGEMENT_CLICKS" as "REPORT.ENGAGEMENT_CLICKS",
        "ENGAGEMENT_REACH": "REPORT.ENGAGEMENT_REACH" as "REPORT.ENGAGEMENT_REACH",
        "FACEBOOK": {
            "AUDIENCE_INSIGHTS": {
                "AGE_RANGE": "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.AGE_RANGE" as "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.AGE_RANGE",
                "AGE_RANGE_ALL": "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.AGE_RANGE_ALL" as "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.AGE_RANGE_ALL",
                "AGE_RANGE_MEN": "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.AGE_RANGE_MEN" as "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.AGE_RANGE_MEN",
                "AGE_RANGE_OTHER": "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.AGE_RANGE_OTHER" as "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.AGE_RANGE_OTHER",
                "AGE_RANGE_WOMEN": "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.AGE_RANGE_WOMEN" as "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.AGE_RANGE_WOMEN",
                "DAYS": "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.DAYS" as "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.DAYS",
                "GENDER": "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.GENDER" as "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.GENDER",
                "GENDER_MEN": "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.GENDER_MEN" as "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.GENDER_MEN",
                "GENDER_OTHER": "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.GENDER_OTHER" as "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.GENDER_OTHER",
                "GENDER_WOMEN": "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.GENDER_WOMEN" as "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.GENDER_WOMEN",
                "HOURS": "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.HOURS" as "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.HOURS",
                "ONLINE_FOLLOWERS": "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.ONLINE_FOLLOWERS" as "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.ONLINE_FOLLOWERS",
                "ONLINE_FOLLOWERS_HELP_DAYS": "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.ONLINE_FOLLOWERS_HELP_DAYS" as "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.ONLINE_FOLLOWERS_HELP_DAYS",
                "ONLINE_FOLLOWERS_HELP_HOURS": "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.ONLINE_FOLLOWERS_HELP_HOURS" as "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.ONLINE_FOLLOWERS_HELP_HOURS",
                "TITLE": "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.TITLE" as "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.TITLE",
                "TOP_LOCATIONS": "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.TOP_LOCATIONS" as "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.TOP_LOCATIONS",
                "TOP_LOCATIONS_HELP": "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.TOP_LOCATIONS_HELP" as "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.TOP_LOCATIONS_HELP",
                "TOP_POST_TIMES": "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.TOP_POST_TIMES" as "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.TOP_POST_TIMES"
            },
            "INCORRECT_DATA_POPOVER_TEXT": "REPORT.FACEBOOK.INCORRECT_DATA_POPOVER_TEXT" as "REPORT.FACEBOOK.INCORRECT_DATA_POPOVER_TEXT",
            "LIKES_REPORT": {
                "NEW_PAGE_LIKES": "REPORT.FACEBOOK.LIKES_REPORT.NEW_PAGE_LIKES" as "REPORT.FACEBOOK.LIKES_REPORT.NEW_PAGE_LIKES",
                "NEW_POSTS": "REPORT.FACEBOOK.LIKES_REPORT.NEW_POSTS" as "REPORT.FACEBOOK.LIKES_REPORT.NEW_POSTS",
                "NOW": "REPORT.FACEBOOK.LIKES_REPORT.NOW" as "REPORT.FACEBOOK.LIKES_REPORT.NOW",
                "PAGE_LIKES": "REPORT.FACEBOOK.LIKES_REPORT.PAGE_LIKES" as "REPORT.FACEBOOK.LIKES_REPORT.PAGE_LIKES",
                "PAGE_LIKES_GROWTH": "REPORT.FACEBOOK.LIKES_REPORT.PAGE_LIKES_GROWTH" as "REPORT.FACEBOOK.LIKES_REPORT.PAGE_LIKES_GROWTH",
                "PERIOD_AGO": "REPORT.FACEBOOK.LIKES_REPORT.PERIOD_AGO" as "REPORT.FACEBOOK.LIKES_REPORT.PERIOD_AGO",
                "TITLE": "REPORT.FACEBOOK.LIKES_REPORT.TITLE" as "REPORT.FACEBOOK.LIKES_REPORT.TITLE",
                "TOTAL_PAGE_LIKES": "REPORT.FACEBOOK.LIKES_REPORT.TOTAL_PAGE_LIKES" as "REPORT.FACEBOOK.LIKES_REPORT.TOTAL_PAGE_LIKES"
            },
            "NOT_CONNECTED": "REPORT.FACEBOOK.NOT_CONNECTED" as "REPORT.FACEBOOK.NOT_CONNECTED",
            "POSTS_REPORT": {
                "ENGAGEMENT": "REPORT.FACEBOOK.POSTS_REPORT.ENGAGEMENT" as "REPORT.FACEBOOK.POSTS_REPORT.ENGAGEMENT",
                "TIME": "REPORT.FACEBOOK.POSTS_REPORT.TIME" as "REPORT.FACEBOOK.POSTS_REPORT.TIME",
                "TITLE": "REPORT.FACEBOOK.POSTS_REPORT.TITLE" as "REPORT.FACEBOOK.POSTS_REPORT.TITLE",
                "VIEW_MORE": "REPORT.FACEBOOK.POSTS_REPORT.VIEW_MORE" as "REPORT.FACEBOOK.POSTS_REPORT.VIEW_MORE",
                "VIEW_POST": "REPORT.FACEBOOK.POSTS_REPORT.VIEW_POST" as "REPORT.FACEBOOK.POSTS_REPORT.VIEW_POST"
            }
        },
        "FACEBOOK_ADVERTISING": "REPORT.FACEBOOK_ADVERTISING" as "REPORT.FACEBOOK_ADVERTISING",
        "FACEBOOK_TOP_POSTS": "REPORT.FACEBOOK_TOP_POSTS" as "REPORT.FACEBOOK_TOP_POSTS",
        "FITWARE_MEMBER_ENGAGER": {
            "BOUNCES": "REPORT.FITWARE_MEMBER_ENGAGER.BOUNCES" as "REPORT.FITWARE_MEMBER_ENGAGER.BOUNCES",
            "LOCATION_EMAIL": "REPORT.FITWARE_MEMBER_ENGAGER.LOCATION_EMAIL" as "REPORT.FITWARE_MEMBER_ENGAGER.LOCATION_EMAIL",
            "OPENS": "REPORT.FITWARE_MEMBER_ENGAGER.OPENS" as "REPORT.FITWARE_MEMBER_ENGAGER.OPENS",
            "REPORT_LIMITATIONS": {
                "MESSAGE": "REPORT.FITWARE_MEMBER_ENGAGER.REPORT_LIMITATIONS.MESSAGE" as "REPORT.FITWARE_MEMBER_ENGAGER.REPORT_LIMITATIONS.MESSAGE",
                "TITLE": "REPORT.FITWARE_MEMBER_ENGAGER.REPORT_LIMITATIONS.TITLE" as "REPORT.FITWARE_MEMBER_ENGAGER.REPORT_LIMITATIONS.TITLE"
            },
            "SPAM_REPORTS": "REPORT.FITWARE_MEMBER_ENGAGER.SPAM_REPORTS" as "REPORT.FITWARE_MEMBER_ENGAGER.SPAM_REPORTS",
            "TITLE": "REPORT.FITWARE_MEMBER_ENGAGER.TITLE" as "REPORT.FITWARE_MEMBER_ENGAGER.TITLE",
            "UNSUBSCRIBES": "REPORT.FITWARE_MEMBER_ENGAGER.UNSUBSCRIBES" as "REPORT.FITWARE_MEMBER_ENGAGER.UNSUBSCRIBES"
        },
        "FOLLOWERS_FROM": "REPORT.FOLLOWERS_FROM" as "REPORT.FOLLOWERS_FROM",
        "FOLLOWERS_GROWTH": "REPORT.FOLLOWERS_GROWTH" as "REPORT.FOLLOWERS_GROWTH",
        "FOLLOWERS_TO": "REPORT.FOLLOWERS_TO" as "REPORT.FOLLOWERS_TO",
        "FOLLOWING_REQUEST_WILL_BE_SENT_TO_AGENCY": "REPORT.FOLLOWING_REQUEST_WILL_BE_SENT_TO_AGENCY" as "REPORT.FOLLOWING_REQUEST_WILL_BE_SENT_TO_AGENCY",
        "GENERAL_EVENTS": "REPORT.GENERAL_EVENTS" as "REPORT.GENERAL_EVENTS",
        "GENERAL_TEMPLATE_TYPES": {
            "ALL": "REPORT.GENERAL_TEMPLATE_TYPES.ALL" as "REPORT.GENERAL_TEMPLATE_TYPES.ALL",
            "DIGITAL": "REPORT.GENERAL_TEMPLATE_TYPES.DIGITAL" as "REPORT.GENERAL_TEMPLATE_TYPES.DIGITAL",
            "EMAIL": "REPORT.GENERAL_TEMPLATE_TYPES.EMAIL" as "REPORT.GENERAL_TEMPLATE_TYPES.EMAIL",
            "PRINT": "REPORT.GENERAL_TEMPLATE_TYPES.PRINT" as "REPORT.GENERAL_TEMPLATE_TYPES.PRINT"
        },
        "GENERATED_REPORT_PRINT_FOOTER": "REPORT.GENERATED_REPORT_PRINT_FOOTER" as "REPORT.GENERATED_REPORT_PRINT_FOOTER",
        "GENERATING_REPORT": "REPORT.GENERATING_REPORT" as "REPORT.GENERATING_REPORT",
        "GO": "REPORT.GO" as "REPORT.GO",
        "GOOGLE_ADS": {
            "AD_NAME_TOOLTIP_NUM_DESCRIPTION": "REPORT.GOOGLE_ADS.AD_NAME_TOOLTIP_NUM_DESCRIPTION" as "REPORT.GOOGLE_ADS.AD_NAME_TOOLTIP_NUM_DESCRIPTION",
            "AD_NAME_TOOLTIP_NUM_DESCRIPTION_plural": "REPORT.GOOGLE_ADS.AD_NAME_TOOLTIP_NUM_DESCRIPTION_plural" as "REPORT.GOOGLE_ADS.AD_NAME_TOOLTIP_NUM_DESCRIPTION_plural",
            "AD_NAME_TOOLTIP_NUM_HEADLINE": "REPORT.GOOGLE_ADS.AD_NAME_TOOLTIP_NUM_HEADLINE" as "REPORT.GOOGLE_ADS.AD_NAME_TOOLTIP_NUM_HEADLINE",
            "AD_NAME_TOOLTIP_NUM_HEADLINE_plural": "REPORT.GOOGLE_ADS.AD_NAME_TOOLTIP_NUM_HEADLINE_plural" as "REPORT.GOOGLE_ADS.AD_NAME_TOOLTIP_NUM_HEADLINE_plural",
            "AD_NAME_TOOLTIP_NUM_URL": "REPORT.GOOGLE_ADS.AD_NAME_TOOLTIP_NUM_URL" as "REPORT.GOOGLE_ADS.AD_NAME_TOOLTIP_NUM_URL",
            "AD_NAME_TOOLTIP_NUM_URL_plural": "REPORT.GOOGLE_ADS.AD_NAME_TOOLTIP_NUM_URL_plural" as "REPORT.GOOGLE_ADS.AD_NAME_TOOLTIP_NUM_URL_plural",
            "COLUMNS": {
                "AD_NAME": "REPORT.GOOGLE_ADS.COLUMNS.AD_NAME" as "REPORT.GOOGLE_ADS.COLUMNS.AD_NAME",
                "AVERAGE_CPC": "REPORT.GOOGLE_ADS.COLUMNS.AVERAGE_CPC" as "REPORT.GOOGLE_ADS.COLUMNS.AVERAGE_CPC",
                "AVERAGE_CPC_TOOLTIP": "REPORT.GOOGLE_ADS.COLUMNS.AVERAGE_CPC_TOOLTIP" as "REPORT.GOOGLE_ADS.COLUMNS.AVERAGE_CPC_TOOLTIP",
                "CONVERSIONS": "REPORT.GOOGLE_ADS.COLUMNS.CONVERSIONS" as "REPORT.GOOGLE_ADS.COLUMNS.CONVERSIONS",
                "CONVERSIONS_TOOLTIP": "REPORT.GOOGLE_ADS.COLUMNS.CONVERSIONS_TOOLTIP" as "REPORT.GOOGLE_ADS.COLUMNS.CONVERSIONS_TOOLTIP",
                "COST": "REPORT.GOOGLE_ADS.COLUMNS.COST" as "REPORT.GOOGLE_ADS.COLUMNS.COST",
                "COST_PER_CONVERSION": "REPORT.GOOGLE_ADS.COLUMNS.COST_PER_CONVERSION" as "REPORT.GOOGLE_ADS.COLUMNS.COST_PER_CONVERSION",
                "COST_PER_CONVERSION_TOOLTIP": "REPORT.GOOGLE_ADS.COLUMNS.COST_PER_CONVERSION_TOOLTIP" as "REPORT.GOOGLE_ADS.COLUMNS.COST_PER_CONVERSION_TOOLTIP",
                "COST_TOOLTIP": "REPORT.GOOGLE_ADS.COLUMNS.COST_TOOLTIP" as "REPORT.GOOGLE_ADS.COLUMNS.COST_TOOLTIP",
                "CURRENCY": "REPORT.GOOGLE_ADS.COLUMNS.CURRENCY" as "REPORT.GOOGLE_ADS.COLUMNS.CURRENCY",
                "CURRENCY_TOOLTIP": "REPORT.GOOGLE_ADS.COLUMNS.CURRENCY_TOOLTIP" as "REPORT.GOOGLE_ADS.COLUMNS.CURRENCY_TOOLTIP",
                "IMPRESSIONS": "REPORT.GOOGLE_ADS.COLUMNS.IMPRESSIONS" as "REPORT.GOOGLE_ADS.COLUMNS.IMPRESSIONS",
                "IMPRESSIONS_TOOLTIP": "REPORT.GOOGLE_ADS.COLUMNS.IMPRESSIONS_TOOLTIP" as "REPORT.GOOGLE_ADS.COLUMNS.IMPRESSIONS_TOOLTIP",
                "INTERACTIONS": "REPORT.GOOGLE_ADS.COLUMNS.INTERACTIONS" as "REPORT.GOOGLE_ADS.COLUMNS.INTERACTIONS",
                "INTERACTIONS_TOOLTIP": "REPORT.GOOGLE_ADS.COLUMNS.INTERACTIONS_TOOLTIP" as "REPORT.GOOGLE_ADS.COLUMNS.INTERACTIONS_TOOLTIP",
                "INTERACTION_RATE": "REPORT.GOOGLE_ADS.COLUMNS.INTERACTION_RATE" as "REPORT.GOOGLE_ADS.COLUMNS.INTERACTION_RATE",
                "INTERACTION_RATE_TOOLTIP": "REPORT.GOOGLE_ADS.COLUMNS.INTERACTION_RATE_TOOLTIP" as "REPORT.GOOGLE_ADS.COLUMNS.INTERACTION_RATE_TOOLTIP",
                "KEYWORD": "REPORT.GOOGLE_ADS.COLUMNS.KEYWORD" as "REPORT.GOOGLE_ADS.COLUMNS.KEYWORD"
            },
            "KEYWORD_BROAD_MATCH_TOOLTIP": "REPORT.GOOGLE_ADS.KEYWORD_BROAD_MATCH_TOOLTIP" as "REPORT.GOOGLE_ADS.KEYWORD_BROAD_MATCH_TOOLTIP",
            "KEYWORD_EXACT_MATCH_TOOLTIP": "REPORT.GOOGLE_ADS.KEYWORD_EXACT_MATCH_TOOLTIP" as "REPORT.GOOGLE_ADS.KEYWORD_EXACT_MATCH_TOOLTIP",
            "KEYWORD_PHRASE_MATCH_TOOLTIP": "REPORT.GOOGLE_ADS.KEYWORD_PHRASE_MATCH_TOOLTIP" as "REPORT.GOOGLE_ADS.KEYWORD_PHRASE_MATCH_TOOLTIP",
            "KEYWORD_UNKNOWN_MATCH_TOOLTIP": "REPORT.GOOGLE_ADS.KEYWORD_UNKNOWN_MATCH_TOOLTIP" as "REPORT.GOOGLE_ADS.KEYWORD_UNKNOWN_MATCH_TOOLTIP"
        },
        "GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST": {
            "ADDITIONAL_NOTES": "REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.ADDITIONAL_NOTES" as "REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.ADDITIONAL_NOTES",
            "EXTRA_STEPS_MAY_BE_REQUIRED": "REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.EXTRA_STEPS_MAY_BE_REQUIRED" as "REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.EXTRA_STEPS_MAY_BE_REQUIRED",
            "FAILED_TO_REQUEST_SPEND_ADJUSTMENT": "REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.FAILED_TO_REQUEST_SPEND_ADJUSTMENT" as "REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.FAILED_TO_REQUEST_SPEND_ADJUSTMENT",
            "INCREASE_MY_GOOGLE_ADWORDS_BUDGET": "REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.INCREASE_MY_GOOGLE_ADWORDS_BUDGET" as "REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.INCREASE_MY_GOOGLE_ADWORDS_BUDGET",
            "REQUEST_HAS_BEEN_SENT": "REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.REQUEST_HAS_BEEN_SENT" as "REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.REQUEST_HAS_BEEN_SENT",
            "REQUEST_TO_ADJUST_SPEND": "REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.REQUEST_TO_ADJUST_SPEND" as "REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.REQUEST_TO_ADJUST_SPEND",
            "SEND_REQUEST": "REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.SEND_REQUEST" as "REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.SEND_REQUEST",
            "USER_HAS_REQUESTED_AN_ADJUSTMENT_TO_ADWORDS_SPEND": "REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.USER_HAS_REQUESTED_AN_ADJUSTMENT_TO_ADWORDS_SPEND" as "REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.USER_HAS_REQUESTED_AN_ADJUSTMENT_TO_ADWORDS_SPEND"
        },
        "GOOGLE_MY_BUSINESS": {
            "CONFIRM_DELETE_MESSAGE": "REPORT.GOOGLE_MY_BUSINESS.CONFIRM_DELETE_MESSAGE" as "REPORT.GOOGLE_MY_BUSINESS.CONFIRM_DELETE_MESSAGE",
            "CUSTOMER_FEEDBACK": {
                "TITLE": "REPORT.GOOGLE_MY_BUSINESS.CUSTOMER_FEEDBACK.TITLE" as "REPORT.GOOGLE_MY_BUSINESS.CUSTOMER_FEEDBACK.TITLE"
            },
            "DIRECTIONS_REPORT": {
                "TITLE": "REPORT.GOOGLE_MY_BUSINESS.DIRECTIONS_REPORT.TITLE" as "REPORT.GOOGLE_MY_BUSINESS.DIRECTIONS_REPORT.TITLE"
            },
            "METRICS_NO_LONGER_AVALIABLE_BANNER": "REPORT.GOOGLE_MY_BUSINESS.METRICS_NO_LONGER_AVALIABLE_BANNER" as "REPORT.GOOGLE_MY_BUSINESS.METRICS_NO_LONGER_AVALIABLE_BANNER",
            "NOT_CONNECTED_PART_1": "REPORT.GOOGLE_MY_BUSINESS.NOT_CONNECTED_PART_1" as "REPORT.GOOGLE_MY_BUSINESS.NOT_CONNECTED_PART_1",
            "NOT_CONNECTED_PART_2": "REPORT.GOOGLE_MY_BUSINESS.NOT_CONNECTED_PART_2" as "REPORT.GOOGLE_MY_BUSINESS.NOT_CONNECTED_PART_2",
            "PHOTO_QUANTITY_REPORT": {
                "MERCHANT_TITLE": "REPORT.GOOGLE_MY_BUSINESS.PHOTO_QUANTITY_REPORT.MERCHANT_TITLE" as "REPORT.GOOGLE_MY_BUSINESS.PHOTO_QUANTITY_REPORT.MERCHANT_TITLE",
                "OTHERS_TITLE": "REPORT.GOOGLE_MY_BUSINESS.PHOTO_QUANTITY_REPORT.OTHERS_TITLE" as "REPORT.GOOGLE_MY_BUSINESS.PHOTO_QUANTITY_REPORT.OTHERS_TITLE",
                "TITLE": "REPORT.GOOGLE_MY_BUSINESS.PHOTO_QUANTITY_REPORT.TITLE" as "REPORT.GOOGLE_MY_BUSINESS.PHOTO_QUANTITY_REPORT.TITLE"
            },
            "PHOTO_VIEWS_REPORT": {
                "MERCHANT_TITLE": "REPORT.GOOGLE_MY_BUSINESS.PHOTO_VIEWS_REPORT.MERCHANT_TITLE" as "REPORT.GOOGLE_MY_BUSINESS.PHOTO_VIEWS_REPORT.MERCHANT_TITLE",
                "OTHERS_TITLE": "REPORT.GOOGLE_MY_BUSINESS.PHOTO_VIEWS_REPORT.OTHERS_TITLE" as "REPORT.GOOGLE_MY_BUSINESS.PHOTO_VIEWS_REPORT.OTHERS_TITLE",
                "TITLE": "REPORT.GOOGLE_MY_BUSINESS.PHOTO_VIEWS_REPORT.TITLE" as "REPORT.GOOGLE_MY_BUSINESS.PHOTO_VIEWS_REPORT.TITLE"
            },
            "RECENT_POSTS": {
                "POST_CLICKS": "REPORT.GOOGLE_MY_BUSINESS.RECENT_POSTS.POST_CLICKS" as "REPORT.GOOGLE_MY_BUSINESS.RECENT_POSTS.POST_CLICKS",
                "POST_VIEWS": "REPORT.GOOGLE_MY_BUSINESS.RECENT_POSTS.POST_VIEWS" as "REPORT.GOOGLE_MY_BUSINESS.RECENT_POSTS.POST_VIEWS",
                "TITLE": "REPORT.GOOGLE_MY_BUSINESS.RECENT_POSTS.TITLE" as "REPORT.GOOGLE_MY_BUSINESS.RECENT_POSTS.TITLE",
                "VIEW_POST": "REPORT.GOOGLE_MY_BUSINESS.RECENT_POSTS.VIEW_POST" as "REPORT.GOOGLE_MY_BUSINESS.RECENT_POSTS.VIEW_POST"
            },
            "REPLY": "REPORT.GOOGLE_MY_BUSINESS.REPLY" as "REPORT.GOOGLE_MY_BUSINESS.REPLY",
            "REPLYING_PUBLICLY": "REPORT.GOOGLE_MY_BUSINESS.REPLYING_PUBLICLY" as "REPORT.GOOGLE_MY_BUSINESS.REPLYING_PUBLICLY",
            "REPLY_LENGTH_ERROR": "REPORT.GOOGLE_MY_BUSINESS.REPLY_LENGTH_ERROR" as "REPORT.GOOGLE_MY_BUSINESS.REPLY_LENGTH_ERROR",
            "SEARCH_REPORT": {
                "BRANDED_DESCRIPTION": "REPORT.GOOGLE_MY_BUSINESS.SEARCH_REPORT.BRANDED_DESCRIPTION" as "REPORT.GOOGLE_MY_BUSINESS.SEARCH_REPORT.BRANDED_DESCRIPTION",
                "BRANDED_TITLE": "REPORT.GOOGLE_MY_BUSINESS.SEARCH_REPORT.BRANDED_TITLE" as "REPORT.GOOGLE_MY_BUSINESS.SEARCH_REPORT.BRANDED_TITLE",
                "DIRECT_DESCRIPTION": "REPORT.GOOGLE_MY_BUSINESS.SEARCH_REPORT.DIRECT_DESCRIPTION" as "REPORT.GOOGLE_MY_BUSINESS.SEARCH_REPORT.DIRECT_DESCRIPTION",
                "DIRECT_TITLE": "REPORT.GOOGLE_MY_BUSINESS.SEARCH_REPORT.DIRECT_TITLE" as "REPORT.GOOGLE_MY_BUSINESS.SEARCH_REPORT.DIRECT_TITLE",
                "DISCOVERY_DESCRIPTION": "REPORT.GOOGLE_MY_BUSINESS.SEARCH_REPORT.DISCOVERY_DESCRIPTION" as "REPORT.GOOGLE_MY_BUSINESS.SEARCH_REPORT.DISCOVERY_DESCRIPTION",
                "DISCOVERY_TITLE": "REPORT.GOOGLE_MY_BUSINESS.SEARCH_REPORT.DISCOVERY_TITLE" as "REPORT.GOOGLE_MY_BUSINESS.SEARCH_REPORT.DISCOVERY_TITLE",
                "TITLE": "REPORT.GOOGLE_MY_BUSINESS.SEARCH_REPORT.TITLE" as "REPORT.GOOGLE_MY_BUSINESS.SEARCH_REPORT.TITLE"
            },
            "TOOLBAR": {
                "DAYS_30": "REPORT.GOOGLE_MY_BUSINESS.TOOLBAR.DAYS_30" as "REPORT.GOOGLE_MY_BUSINESS.TOOLBAR.DAYS_30",
                "DAYS_7": "REPORT.GOOGLE_MY_BUSINESS.TOOLBAR.DAYS_7" as "REPORT.GOOGLE_MY_BUSINESS.TOOLBAR.DAYS_7",
                "DAYS_90": "REPORT.GOOGLE_MY_BUSINESS.TOOLBAR.DAYS_90" as "REPORT.GOOGLE_MY_BUSINESS.TOOLBAR.DAYS_90"
            },
            "TOP_QUESTIONS": {
                "ANONYMOUS_AUTHOR_NAME": "REPORT.GOOGLE_MY_BUSINESS.TOP_QUESTIONS.ANONYMOUS_AUTHOR_NAME" as "REPORT.GOOGLE_MY_BUSINESS.TOP_QUESTIONS.ANONYMOUS_AUTHOR_NAME",
                "ANSWERS": "REPORT.GOOGLE_MY_BUSINESS.TOP_QUESTIONS.ANSWERS" as "REPORT.GOOGLE_MY_BUSINESS.TOP_QUESTIONS.ANSWERS",
                "ANSWER_LIST_TITLE": "REPORT.GOOGLE_MY_BUSINESS.TOP_QUESTIONS.ANSWER_LIST_TITLE" as "REPORT.GOOGLE_MY_BUSINESS.TOP_QUESTIONS.ANSWER_LIST_TITLE",
                "QUESTIONS": "REPORT.GOOGLE_MY_BUSINESS.TOP_QUESTIONS.QUESTIONS" as "REPORT.GOOGLE_MY_BUSINESS.TOP_QUESTIONS.QUESTIONS",
                "TITLE": "REPORT.GOOGLE_MY_BUSINESS.TOP_QUESTIONS.TITLE" as "REPORT.GOOGLE_MY_BUSINESS.TOP_QUESTIONS.TITLE",
                "UPVOTES": "REPORT.GOOGLE_MY_BUSINESS.TOP_QUESTIONS.UPVOTES" as "REPORT.GOOGLE_MY_BUSINESS.TOP_QUESTIONS.UPVOTES"
            },
            "TOP_REVIEWS": {
                "ANONYMOUS_REVIEWER_NAME": "REPORT.GOOGLE_MY_BUSINESS.TOP_REVIEWS.ANONYMOUS_REVIEWER_NAME" as "REPORT.GOOGLE_MY_BUSINESS.TOP_REVIEWS.ANONYMOUS_REVIEWER_NAME",
                "REPLIED_AT": "REPORT.GOOGLE_MY_BUSINESS.TOP_REVIEWS.REPLIED_AT" as "REPORT.GOOGLE_MY_BUSINESS.TOP_REVIEWS.REPLIED_AT",
                "REVIEWS": "REPORT.GOOGLE_MY_BUSINESS.TOP_REVIEWS.REVIEWS" as "REPORT.GOOGLE_MY_BUSINESS.TOP_REVIEWS.REVIEWS",
                "SUB_TITLE": "REPORT.GOOGLE_MY_BUSINESS.TOP_REVIEWS.SUB_TITLE" as "REPORT.GOOGLE_MY_BUSINESS.TOP_REVIEWS.SUB_TITLE",
                "TITLE": "REPORT.GOOGLE_MY_BUSINESS.TOP_REVIEWS.TITLE" as "REPORT.GOOGLE_MY_BUSINESS.TOP_REVIEWS.TITLE"
            },
            "VIEW_FULL_REPLY": "REPORT.GOOGLE_MY_BUSINESS.VIEW_FULL_REPLY" as "REPORT.GOOGLE_MY_BUSINESS.VIEW_FULL_REPLY",
            "VIEW_FULL_REVIEW": "REPORT.GOOGLE_MY_BUSINESS.VIEW_FULL_REVIEW" as "REPORT.GOOGLE_MY_BUSINESS.VIEW_FULL_REVIEW",
            "VIEW_REPORT": {
                "CALLS_CHART_LABEL": "REPORT.GOOGLE_MY_BUSINESS.VIEW_REPORT.CALLS_CHART_LABEL" as "REPORT.GOOGLE_MY_BUSINESS.VIEW_REPORT.CALLS_CHART_LABEL",
                "CALLS_TITLE": "REPORT.GOOGLE_MY_BUSINESS.VIEW_REPORT.CALLS_TITLE" as "REPORT.GOOGLE_MY_BUSINESS.VIEW_REPORT.CALLS_TITLE",
                "DIRECTIONS_CHART_LABEL": "REPORT.GOOGLE_MY_BUSINESS.VIEW_REPORT.DIRECTIONS_CHART_LABEL" as "REPORT.GOOGLE_MY_BUSINESS.VIEW_REPORT.DIRECTIONS_CHART_LABEL",
                "DIRECTIONS_TITLE": "REPORT.GOOGLE_MY_BUSINESS.VIEW_REPORT.DIRECTIONS_TITLE" as "REPORT.GOOGLE_MY_BUSINESS.VIEW_REPORT.DIRECTIONS_TITLE",
                "TITLE": "REPORT.GOOGLE_MY_BUSINESS.VIEW_REPORT.TITLE" as "REPORT.GOOGLE_MY_BUSINESS.VIEW_REPORT.TITLE",
                "WEBSITES_CHART_LABEL": "REPORT.GOOGLE_MY_BUSINESS.VIEW_REPORT.WEBSITES_CHART_LABEL" as "REPORT.GOOGLE_MY_BUSINESS.VIEW_REPORT.WEBSITES_CHART_LABEL",
                "WEBSITES_TITLE": "REPORT.GOOGLE_MY_BUSINESS.VIEW_REPORT.WEBSITES_TITLE" as "REPORT.GOOGLE_MY_BUSINESS.VIEW_REPORT.WEBSITES_TITLE"
            }
        },
        "GROWTH": "REPORT.GROWTH" as "REPORT.GROWTH",
        "HIDE_SUMMARY": "REPORT.HIDE_SUMMARY" as "REPORT.HIDE_SUMMARY",
        "IMPRESSIONS": "REPORT.IMPRESSIONS" as "REPORT.IMPRESSIONS",
        "INSTAGRAM": {
            "AUDIENCE_INSIGHTS": {
                "AGE_RANGE_ALL": "REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.AGE_RANGE_ALL" as "REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.AGE_RANGE_ALL",
                "AGE_RANGE_MEN": "REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.AGE_RANGE_MEN" as "REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.AGE_RANGE_MEN",
                "AGE_RANGE_OTHER": "REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.AGE_RANGE_OTHER" as "REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.AGE_RANGE_OTHER",
                "AGE_RANGE_WOMEN": "REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.AGE_RANGE_WOMEN" as "REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.AGE_RANGE_WOMEN",
                "DAYS": "REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.DAYS" as "REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.DAYS",
                "HOURS": "REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.HOURS" as "REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.HOURS",
                "ONLINE_FOLLOWERS": "REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.ONLINE_FOLLOWERS" as "REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.ONLINE_FOLLOWERS",
                "ONLINE_FOLLOWERS_HELP_DAYS": "REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.ONLINE_FOLLOWERS_HELP_DAYS" as "REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.ONLINE_FOLLOWERS_HELP_DAYS",
                "ONLINE_FOLLOWERS_HELP_HOURS": "REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.ONLINE_FOLLOWERS_HELP_HOURS" as "REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.ONLINE_FOLLOWERS_HELP_HOURS"
            },
            "BUSINESS_ACCOUNT_REPORT": {
                "FOLLOWERS_CHART_LABEL": "REPORT.INSTAGRAM.BUSINESS_ACCOUNT_REPORT.FOLLOWERS_CHART_LABEL" as "REPORT.INSTAGRAM.BUSINESS_ACCOUNT_REPORT.FOLLOWERS_CHART_LABEL"
            },
            "NOT_CONNECTED_PART_1": "REPORT.INSTAGRAM.NOT_CONNECTED_PART_1" as "REPORT.INSTAGRAM.NOT_CONNECTED_PART_1",
            "NOT_CONNECTED_PART_2": "REPORT.INSTAGRAM.NOT_CONNECTED_PART_2" as "REPORT.INSTAGRAM.NOT_CONNECTED_PART_2",
            "NOT_CONNECTED_SCOPES_PART_1": "REPORT.INSTAGRAM.NOT_CONNECTED_SCOPES_PART_1" as "REPORT.INSTAGRAM.NOT_CONNECTED_SCOPES_PART_1",
            "NOT_CONNECTED_SCOPES_PART_2": "REPORT.INSTAGRAM.NOT_CONNECTED_SCOPES_PART_2" as "REPORT.INSTAGRAM.NOT_CONNECTED_SCOPES_PART_2",
            "POSTS_REPORT": {
                "CURRENT_POSTS": "REPORT.INSTAGRAM.POSTS_REPORT.CURRENT_POSTS" as "REPORT.INSTAGRAM.POSTS_REPORT.CURRENT_POSTS",
                "TITLE": "REPORT.INSTAGRAM.POSTS_REPORT.TITLE" as "REPORT.INSTAGRAM.POSTS_REPORT.TITLE",
                "VIEW_MORE": "REPORT.INSTAGRAM.POSTS_REPORT.VIEW_MORE" as "REPORT.INSTAGRAM.POSTS_REPORT.VIEW_MORE",
                "VIEW_POST": "REPORT.INSTAGRAM.POSTS_REPORT.VIEW_POST" as "REPORT.INSTAGRAM.POSTS_REPORT.VIEW_POST"
            },
            "STORIES_REPORT": {
                "ACTIVE_STORIES": "REPORT.INSTAGRAM.STORIES_REPORT.ACTIVE_STORIES" as "REPORT.INSTAGRAM.STORIES_REPORT.ACTIVE_STORIES",
                "NO_ACTIVE_STORIES_MESSAGE": "REPORT.INSTAGRAM.STORIES_REPORT.NO_ACTIVE_STORIES_MESSAGE" as "REPORT.INSTAGRAM.STORIES_REPORT.NO_ACTIVE_STORIES_MESSAGE",
                "NO_PAST_STORIES_MESSAGE": "REPORT.INSTAGRAM.STORIES_REPORT.NO_PAST_STORIES_MESSAGE" as "REPORT.INSTAGRAM.STORIES_REPORT.NO_PAST_STORIES_MESSAGE",
                "PAST_STORIES": "REPORT.INSTAGRAM.STORIES_REPORT.PAST_STORIES" as "REPORT.INSTAGRAM.STORIES_REPORT.PAST_STORIES",
                "TITLE": "REPORT.INSTAGRAM.STORIES_REPORT.TITLE" as "REPORT.INSTAGRAM.STORIES_REPORT.TITLE",
                "VIEW_MORE": "REPORT.INSTAGRAM.STORIES_REPORT.VIEW_MORE" as "REPORT.INSTAGRAM.STORIES_REPORT.VIEW_MORE",
                "VIEW_POST": "REPORT.INSTAGRAM.STORIES_REPORT.VIEW_POST" as "REPORT.INSTAGRAM.STORIES_REPORT.VIEW_POST"
            }
        },
        "INVALID_END_DATE": "REPORT.INVALID_END_DATE" as "REPORT.INVALID_END_DATE",
        "INVALID_START_DATE": "REPORT.INVALID_START_DATE" as "REPORT.INVALID_START_DATE",
        "KEYWORD": "REPORT.KEYWORD" as "REPORT.KEYWORD",
        "LAST_LOGIN": "REPORT.LAST_LOGIN" as "REPORT.LAST_LOGIN",
        "LEADS": "REPORT.LEADS" as "REPORT.LEADS",
        "LIKES_COMMENTS_SHARES": "REPORT.LIKES_COMMENTS_SHARES" as "REPORT.LIKES_COMMENTS_SHARES",
        "LIMITED": "REPORT.LIMITED" as "REPORT.LIMITED",
        "LOCATION": "REPORT.LOCATION" as "REPORT.LOCATION",
        "LOCATION_AD": "REPORT.LOCATION_AD" as "REPORT.LOCATION_AD",
        "LOCATION_CONVERSION_TYPE_AD": "REPORT.LOCATION_CONVERSION_TYPE_AD" as "REPORT.LOCATION_CONVERSION_TYPE_AD",
        "LOCATION_CONVERSION_TYPE_KEYWORD": "REPORT.LOCATION_CONVERSION_TYPE_KEYWORD" as "REPORT.LOCATION_CONVERSION_TYPE_KEYWORD",
        "LOCATION_KEYWORD": "REPORT.LOCATION_KEYWORD" as "REPORT.LOCATION_KEYWORD",
        "LOGIN_DATE": "REPORT.LOGIN_DATE" as "REPORT.LOGIN_DATE",
        "MAILCHIMP": {
            "TITLE": "REPORT.MAILCHIMP.TITLE" as "REPORT.MAILCHIMP.TITLE"
        },
        "MAXIMUM_SPEND": "REPORT.MAXIMUM_SPEND" as "REPORT.MAXIMUM_SPEND",
        "MAXIMUM_SPEND_HINT": "REPORT.MAXIMUM_SPEND_HINT" as "REPORT.MAXIMUM_SPEND_HINT",
        "MORE_ROWS": "REPORT.MORE_ROWS" as "REPORT.MORE_ROWS",
        "MORE_ROWS_plural": "REPORT.MORE_ROWS_plural" as "REPORT.MORE_ROWS_plural",
        "MOST_USED_ACTIVITIES": "REPORT.MOST_USED_ACTIVITIES" as "REPORT.MOST_USED_ACTIVITIES",
        "MULTIPLE_LOCATION_REPORT": "REPORT.MULTIPLE_LOCATION_REPORT" as "REPORT.MULTIPLE_LOCATION_REPORT",
        "NEW_FOLLOWERS": "REPORT.NEW_FOLLOWERS" as "REPORT.NEW_FOLLOWERS",
        "NEW_LIKES": "REPORT.NEW_LIKES" as "REPORT.NEW_LIKES",
        "NEW_POSTS": "REPORT.NEW_POSTS" as "REPORT.NEW_POSTS",
        "NEW_REPORT_SUMMARY": "REPORT.NEW_REPORT_SUMMARY" as "REPORT.NEW_REPORT_SUMMARY",
        "NEW_VISITORS": "REPORT.NEW_VISITORS" as "REPORT.NEW_VISITORS",
        "NOT_CONNECTED_PART_1": "REPORT.NOT_CONNECTED_PART_1" as "REPORT.NOT_CONNECTED_PART_1",
        "NOT_CONNECTED_PART_2": "REPORT.NOT_CONNECTED_PART_2" as "REPORT.NOT_CONNECTED_PART_2",
        "NOT_ENOUGH_DATA": "REPORT.NOT_ENOUGH_DATA" as "REPORT.NOT_ENOUGH_DATA",
        "NO_ADWORD_STATS_FOUND": "REPORT.NO_ADWORD_STATS_FOUND" as "REPORT.NO_ADWORD_STATS_FOUND",
        "NO_CAMPAIGNS_FOUND": "REPORT.NO_CAMPAIGNS_FOUND" as "REPORT.NO_CAMPAIGNS_FOUND",
        "NO_UNREACHED_MARKET_FOR_PERIOD": "REPORT.NO_UNREACHED_MARKET_FOR_PERIOD" as "REPORT.NO_UNREACHED_MARKET_FOR_PERIOD",
        "NO_VISITORS_FOUND": "REPORT.NO_VISITORS_FOUND" as "REPORT.NO_VISITORS_FOUND",
        "NUMBER_OF_TEMPLATES_BUILT": "REPORT.NUMBER_OF_TEMPLATES_BUILT" as "REPORT.NUMBER_OF_TEMPLATES_BUILT",
        "ORGANIC": "REPORT.ORGANIC" as "REPORT.ORGANIC",
        "OVERVIEW": {
            "EMAIL_CAMPAIGNS": {
                "CAMPAIGN_MONITOR_CHECK_BACK_SOON": "REPORT.OVERVIEW.EMAIL_CAMPAIGNS.CAMPAIGN_MONITOR_CHECK_BACK_SOON" as "REPORT.OVERVIEW.EMAIL_CAMPAIGNS.CAMPAIGN_MONITOR_CHECK_BACK_SOON",
                "CAMPAIGN_MONITOR_TOOLTIP": "REPORT.OVERVIEW.EMAIL_CAMPAIGNS.CAMPAIGN_MONITOR_TOOLTIP" as "REPORT.OVERVIEW.EMAIL_CAMPAIGNS.CAMPAIGN_MONITOR_TOOLTIP",
                "TITLE": "REPORT.OVERVIEW.EMAIL_CAMPAIGNS.TITLE" as "REPORT.OVERVIEW.EMAIL_CAMPAIGNS.TITLE"
            },
            "FACEBOOK": {
                "ENGAGEMENT": "REPORT.OVERVIEW.FACEBOOK.ENGAGEMENT" as "REPORT.OVERVIEW.FACEBOOK.ENGAGEMENT",
                "ENGAGEMENT_HINT": "REPORT.OVERVIEW.FACEBOOK.ENGAGEMENT_HINT" as "REPORT.OVERVIEW.FACEBOOK.ENGAGEMENT_HINT",
                "ENGAGEMENT_RATE": "REPORT.OVERVIEW.FACEBOOK.ENGAGEMENT_RATE" as "REPORT.OVERVIEW.FACEBOOK.ENGAGEMENT_RATE",
                "TITLE": "REPORT.OVERVIEW.FACEBOOK.TITLE" as "REPORT.OVERVIEW.FACEBOOK.TITLE"
            }
        },
        "PAID": "REPORT.PAID" as "REPORT.PAID",
        "PAID_IMPRESSIONS": "REPORT.PAID_IMPRESSIONS" as "REPORT.PAID_IMPRESSIONS",
        "PAID_UNIQUE_VIEWS": "REPORT.PAID_UNIQUE_VIEWS" as "REPORT.PAID_UNIQUE_VIEWS",
        "PAID_VIEWS_DEPRECATION": "REPORT.PAID_VIEWS_DEPRECATION" as "REPORT.PAID_VIEWS_DEPRECATION",
        "PEOPLE_REACHED": "REPORT.PEOPLE_REACHED" as "REPORT.PEOPLE_REACHED",
        "PLANNED_VS_ADHOC": {
            "BUILT_FROM_GALLERY": "REPORT.PLANNED_VS_ADHOC.BUILT_FROM_GALLERY" as "REPORT.PLANNED_VS_ADHOC.BUILT_FROM_GALLERY",
            "BUILT_FROM_PLANNER": "REPORT.PLANNED_VS_ADHOC.BUILT_FROM_PLANNER" as "REPORT.PLANNED_VS_ADHOC.BUILT_FROM_PLANNER",
            "PLANNED_VS_ADHOC": "REPORT.PLANNED_VS_ADHOC.PLANNED_VS_ADHOC" as "REPORT.PLANNED_VS_ADHOC.PLANNED_VS_ADHOC"
        },
        "PLANNING_AND_EXECUTION": "REPORT.PLANNING_AND_EXECUTION" as "REPORT.PLANNING_AND_EXECUTION",
        "PLATFORM": "REPORT.PLATFORM" as "REPORT.PLATFORM",
        "POPULAR_BUILDER_TEMPLATE_DETAILS": {
            "BUTTONS": {
                "DOWNLOAD_CSV": "REPORT.POPULAR_BUILDER_TEMPLATE_DETAILS.BUTTONS.DOWNLOAD_CSV" as "REPORT.POPULAR_BUILDER_TEMPLATE_DETAILS.BUTTONS.DOWNLOAD_CSV",
                "EXPORT_CSV": "REPORT.POPULAR_BUILDER_TEMPLATE_DETAILS.BUTTONS.EXPORT_CSV" as "REPORT.POPULAR_BUILDER_TEMPLATE_DETAILS.BUTTONS.EXPORT_CSV"
            },
            "ERROR_EXPORTING_CSV": "REPORT.POPULAR_BUILDER_TEMPLATE_DETAILS.ERROR_EXPORTING_CSV" as "REPORT.POPULAR_BUILDER_TEMPLATE_DETAILS.ERROR_EXPORTING_CSV",
            "EXPORTING_PLEASE_WAIT": "REPORT.POPULAR_BUILDER_TEMPLATE_DETAILS.EXPORTING_PLEASE_WAIT" as "REPORT.POPULAR_BUILDER_TEMPLATE_DETAILS.EXPORTING_PLEASE_WAIT",
            "NOTIFICATIONS": {
                "EXPORTING_ERROR": "REPORT.POPULAR_BUILDER_TEMPLATE_DETAILS.NOTIFICATIONS.EXPORTING_ERROR" as "REPORT.POPULAR_BUILDER_TEMPLATE_DETAILS.NOTIFICATIONS.EXPORTING_ERROR",
                "EXPORTING_SUCCESS": "REPORT.POPULAR_BUILDER_TEMPLATE_DETAILS.NOTIFICATIONS.EXPORTING_SUCCESS" as "REPORT.POPULAR_BUILDER_TEMPLATE_DETAILS.NOTIFICATIONS.EXPORTING_SUCCESS"
            }
        },
        "POPULAR_CATEGORIES": {
            "BY_PLATFORM": "REPORT.POPULAR_CATEGORIES.BY_PLATFORM" as "REPORT.POPULAR_CATEGORIES.BY_PLATFORM",
            "CATEGORY": "REPORT.POPULAR_CATEGORIES.CATEGORY" as "REPORT.POPULAR_CATEGORIES.CATEGORY",
            "ORDER_IN_GALLERY": "REPORT.POPULAR_CATEGORIES.ORDER_IN_GALLERY" as "REPORT.POPULAR_CATEGORIES.ORDER_IN_GALLERY",
            "TEMPLATE_CATEGORY_POPULARITY": "REPORT.POPULAR_CATEGORIES.TEMPLATE_CATEGORY_POPULARITY" as "REPORT.POPULAR_CATEGORIES.TEMPLATE_CATEGORY_POPULARITY",
            "TIMES_USED": "REPORT.POPULAR_CATEGORIES.TIMES_USED" as "REPORT.POPULAR_CATEGORIES.TIMES_USED",
            "TOTAL_USES": "REPORT.POPULAR_CATEGORIES.TOTAL_USES" as "REPORT.POPULAR_CATEGORIES.TOTAL_USES"
        },
        "POSITIVE_FEEDBACK": "REPORT.POSITIVE_FEEDBACK" as "REPORT.POSITIVE_FEEDBACK",
        "POTENTIAL_ROI": "REPORT.POTENTIAL_ROI" as "REPORT.POTENTIAL_ROI",
        "POTENTIAL_ROI_HINT": "REPORT.POTENTIAL_ROI_HINT" as "REPORT.POTENTIAL_ROI_HINT",
        "PRINT_THIS_PAGE": "REPORT.PRINT_THIS_PAGE" as "REPORT.PRINT_THIS_PAGE",
        "REACH": "REPORT.REACH" as "REPORT.REACH",
        "REACHED": "REPORT.REACHED" as "REPORT.REACHED",
        "RECIPIENTS": "REPORT.RECIPIENTS" as "REPORT.RECIPIENTS",
        "RECOMMENDATIONS": "REPORT.RECOMMENDATIONS" as "REPORT.RECOMMENDATIONS",
        "RECOMMENDED_SPEND": "REPORT.RECOMMENDED_SPEND" as "REPORT.RECOMMENDED_SPEND",
        "RECOMMENDED_SPEND_HINT": "REPORT.RECOMMENDED_SPEND_HINT" as "REPORT.RECOMMENDED_SPEND_HINT",
        "REPORTS": "REPORT.REPORTS" as "REPORT.REPORTS",
        "REPORTS_ARCHIVED": "REPORT.REPORTS_ARCHIVED" as "REPORT.REPORTS_ARCHIVED",
        "REPORT_LOADED_LOCATIONS": "REPORT.REPORT_LOADED_LOCATIONS" as "REPORT.REPORT_LOADED_LOCATIONS",
        "REPORT_LOADED_LOCATIONS_plural": "REPORT.REPORT_LOADED_LOCATIONS_plural" as "REPORT.REPORT_LOADED_LOCATIONS_plural",
        "REPORT_SUMMARY": "REPORT.REPORT_SUMMARY" as "REPORT.REPORT_SUMMARY",
        "REPORT_SUMMARY_TEXT": {
            "DELETED": "REPORT.REPORT_SUMMARY_TEXT.DELETED" as "REPORT.REPORT_SUMMARY_TEXT.DELETED",
            "INVALID_DATE_RANGE": "REPORT.REPORT_SUMMARY_TEXT.INVALID_DATE_RANGE" as "REPORT.REPORT_SUMMARY_TEXT.INVALID_DATE_RANGE",
            "SAVED": "REPORT.REPORT_SUMMARY_TEXT.SAVED" as "REPORT.REPORT_SUMMARY_TEXT.SAVED"
        },
        "REQUEST_SPEND_ADJUSTMENT": "REPORT.REQUEST_SPEND_ADJUSTMENT" as "REPORT.REQUEST_SPEND_ADJUSTMENT",
        "RETURNING_VISITORS": "REPORT.RETURNING_VISITORS" as "REPORT.RETURNING_VISITORS",
        "RETURN_ON_INVESTMENT": "REPORT.RETURN_ON_INVESTMENT" as "REPORT.RETURN_ON_INVESTMENT",
        "RETURN_ON_INVESTMENT_HINT": "REPORT.RETURN_ON_INVESTMENT_HINT" as "REPORT.RETURN_ON_INVESTMENT_HINT",
        "ROI": "REPORT.ROI" as "REPORT.ROI",
        "ROI_HINT": "REPORT.ROI_HINT" as "REPORT.ROI_HINT",
        "ROI_PERCENT": "REPORT.ROI_PERCENT" as "REPORT.ROI_PERCENT",
        "SALES": "REPORT.SALES" as "REPORT.SALES",
        "SCHEDULED_DATE": "REPORT.SCHEDULED_DATE" as "REPORT.SCHEDULED_DATE",
        "SELECTED_LOCATIONS": "REPORT.SELECTED_LOCATIONS" as "REPORT.SELECTED_LOCATIONS",
        "SELECT_AT_LEAST_ONE_LOCATION": "REPORT.SELECT_AT_LEAST_ONE_LOCATION" as "REPORT.SELECT_AT_LEAST_ONE_LOCATION",
        "SELF_SERVICE_EVENTS": "REPORT.SELF_SERVICE_EVENTS" as "REPORT.SELF_SERVICE_EVENTS",
        "SELF_SERVICE_OR_GENERAL_EVENTS": "REPORT.SELF_SERVICE_OR_GENERAL_EVENTS" as "REPORT.SELF_SERVICE_OR_GENERAL_EVENTS",
        "SENT_DATE": "REPORT.SENT_DATE" as "REPORT.SENT_DATE",
        "SHOW_ALL_ROWS": "REPORT.SHOW_ALL_ROWS" as "REPORT.SHOW_ALL_ROWS",
        "SHOW_SUMMARY": "REPORT.SHOW_SUMMARY" as "REPORT.SHOW_SUMMARY",
        "SHOW_TOP_N": "REPORT.SHOW_TOP_N" as "REPORT.SHOW_TOP_N",
        "SPECIAL_REQUESTS": "REPORT.SPECIAL_REQUESTS" as "REPORT.SPECIAL_REQUESTS",
        "SPEND": "REPORT.SPEND" as "REPORT.SPEND",
        "START_DATE": "REPORT.START_DATE" as "REPORT.START_DATE",
        "START_DATE_BEFORE_TODAY": "REPORT.START_DATE_BEFORE_TODAY" as "REPORT.START_DATE_BEFORE_TODAY",
        "STATUS": "REPORT.STATUS" as "REPORT.STATUS",
        "SUMMARY": "REPORT.SUMMARY" as "REPORT.SUMMARY",
        "SUPPORTED_EVENTS": "REPORT.SUPPORTED_EVENTS" as "REPORT.SUPPORTED_EVENTS",
        "TEMPLATES_BUILT_BY_TIME": "REPORT.TEMPLATES_BUILT_BY_TIME" as "REPORT.TEMPLATES_BUILT_BY_TIME",
        "TEMPLATE_USAGE": "REPORT.TEMPLATE_USAGE" as "REPORT.TEMPLATE_USAGE",
        "TEMPLATE_USES": "REPORT.TEMPLATE_USES" as "REPORT.TEMPLATE_USES",
        "TEMPLATE_USES_plural": "REPORT.TEMPLATE_USES_plural" as "REPORT.TEMPLATE_USES_plural",
        "TEMPLATE_USE_BY_LOCATION": "REPORT.TEMPLATE_USE_BY_LOCATION" as "REPORT.TEMPLATE_USE_BY_LOCATION",
        "TOTAL": "REPORT.TOTAL" as "REPORT.TOTAL",
        "TOTAL_CLOSE_RATIO": "REPORT.TOTAL_CLOSE_RATIO" as "REPORT.TOTAL_CLOSE_RATIO",
        "TOTAL_CONVERSIONS": "REPORT.TOTAL_CONVERSIONS" as "REPORT.TOTAL_CONVERSIONS",
        "TOTAL_CONVERSION_WORTH": "REPORT.TOTAL_CONVERSION_WORTH" as "REPORT.TOTAL_CONVERSION_WORTH",
        "TOTAL_EVENTS": "REPORT.TOTAL_EVENTS" as "REPORT.TOTAL_EVENTS",
        "TOTAL_IMPRESSIONS": "REPORT.TOTAL_IMPRESSIONS" as "REPORT.TOTAL_IMPRESSIONS",
        "TOTAL_LEADS": "REPORT.TOTAL_LEADS" as "REPORT.TOTAL_LEADS",
        "TOTAL_POSTS": "REPORT.TOTAL_POSTS" as "REPORT.TOTAL_POSTS",
        "TOTAL_REACH_VS_TOTAL_PAID": "REPORT.TOTAL_REACH_VS_TOTAL_PAID" as "REPORT.TOTAL_REACH_VS_TOTAL_PAID",
        "TOTAL_SALES": "REPORT.TOTAL_SALES" as "REPORT.TOTAL_SALES",
        "TOTAL_SPEND": "REPORT.TOTAL_SPEND" as "REPORT.TOTAL_SPEND",
        "TOTAL_UNIQUE_VIEWS": "REPORT.TOTAL_UNIQUE_VIEWS" as "REPORT.TOTAL_UNIQUE_VIEWS",
        "TOTAL_VISITORS": "REPORT.TOTAL_VISITORS" as "REPORT.TOTAL_VISITORS",
        "TOUR_CLOSE_RATIO": "REPORT.TOUR_CLOSE_RATIO" as "REPORT.TOUR_CLOSE_RATIO",
        "TOUR_SALE": "REPORT.TOUR_SALE" as "REPORT.TOUR_SALE",
        "TOUR_SHOW_UPS": "REPORT.TOUR_SHOW_UPS" as "REPORT.TOUR_SHOW_UPS",
        "TYPES": {
            "EMAIL_CAMPAIGNS": {
                "NAME": "REPORT.TYPES.EMAIL_CAMPAIGNS.NAME" as "REPORT.TYPES.EMAIL_CAMPAIGNS.NAME",
                "TITLE": "REPORT.TYPES.EMAIL_CAMPAIGNS.TITLE" as "REPORT.TYPES.EMAIL_CAMPAIGNS.TITLE"
            },
            "FACEBOOK": {
                "NAME": "REPORT.TYPES.FACEBOOK.NAME" as "REPORT.TYPES.FACEBOOK.NAME",
                "TITLE": "REPORT.TYPES.FACEBOOK.TITLE" as "REPORT.TYPES.FACEBOOK.TITLE"
            },
            "GOOGLE_MY_BUSINESS": {
                "NAME": "REPORT.TYPES.GOOGLE_MY_BUSINESS.NAME" as "REPORT.TYPES.GOOGLE_MY_BUSINESS.NAME",
                "TITLE": "REPORT.TYPES.GOOGLE_MY_BUSINESS.TITLE" as "REPORT.TYPES.GOOGLE_MY_BUSINESS.TITLE"
            },
            "INSTAGRAM": {
                "NAME": "REPORT.TYPES.INSTAGRAM.NAME" as "REPORT.TYPES.INSTAGRAM.NAME",
                "TITLE": "REPORT.TYPES.INSTAGRAM.TITLE" as "REPORT.TYPES.INSTAGRAM.TITLE"
            },
            "OVERVIEW": {
                "NAME": "REPORT.TYPES.OVERVIEW.NAME" as "REPORT.TYPES.OVERVIEW.NAME",
                "TITLE": "REPORT.TYPES.OVERVIEW.TITLE" as "REPORT.TYPES.OVERVIEW.TITLE"
            },
            "PAID_MEDIA": {
                "NAME": "REPORT.TYPES.PAID_MEDIA.NAME" as "REPORT.TYPES.PAID_MEDIA.NAME",
                "TITLE": "REPORT.TYPES.PAID_MEDIA.TITLE" as "REPORT.TYPES.PAID_MEDIA.TITLE"
            },
            "TITLE": "REPORT.TYPES.TITLE" as "REPORT.TYPES.TITLE"
        },
        "UNIQUE_CLICKS": "REPORT.UNIQUE_CLICKS" as "REPORT.UNIQUE_CLICKS",
        "UNIQUE_OPENED": "REPORT.UNIQUE_OPENED" as "REPORT.UNIQUE_OPENED",
        "UNREACHED_MARKET": "REPORT.UNREACHED_MARKET" as "REPORT.UNREACHED_MARKET",
        "UNREACHED_MARKET_HINT": "REPORT.UNREACHED_MARKET_HINT" as "REPORT.UNREACHED_MARKET_HINT",
        "VALUE_PER_CONVERSION": "REPORT.VALUE_PER_CONVERSION" as "REPORT.VALUE_PER_CONVERSION",
        "VISITORS": "REPORT.VISITORS" as "REPORT.VISITORS",
        "WAIT_FOR_LOCATIONS": "REPORT.WAIT_FOR_LOCATIONS" as "REPORT.WAIT_FOR_LOCATIONS",
        "WALK_IN_CLOSE_RATIO": "REPORT.WALK_IN_CLOSE_RATIO" as "REPORT.WALK_IN_CLOSE_RATIO",
        "WALK_IN_SALE": "REPORT.WALK_IN_SALE" as "REPORT.WALK_IN_SALE",
        "WALK_IN_TOTAL": "REPORT.WALK_IN_TOTAL" as "REPORT.WALK_IN_TOTAL",
        "WEBSITE": "REPORT.WEBSITE" as "REPORT.WEBSITE"
    },
    "REQUESTS": {
        "ALREADY_PAID_DIFFERENCE": "REQUESTS.ALREADY_PAID_DIFFERENCE" as "REQUESTS.ALREADY_PAID_DIFFERENCE",
        "AMENDMENTS_REQUESTED": "REQUESTS.AMENDMENTS_REQUESTED" as "REQUESTS.AMENDMENTS_REQUESTED",
        "AWAITING_APPROVAL": "REQUESTS.AWAITING_APPROVAL" as "REQUESTS.AWAITING_APPROVAL",
        "AWAITING_HEAD_OFFICE_APPROVAL": "REQUESTS.AWAITING_HEAD_OFFICE_APPROVAL" as "REQUESTS.AWAITING_HEAD_OFFICE_APPROVAL",
        "BEGIN_PAYMENT": "REQUESTS.BEGIN_PAYMENT" as "REQUESTS.BEGIN_PAYMENT",
        "BRIEF": "REQUESTS.BRIEF" as "REQUESTS.BRIEF",
        "CLICK_TO_LOAD_CLOSED_REQUESTS": "REQUESTS.CLICK_TO_LOAD_CLOSED_REQUESTS" as "REQUESTS.CLICK_TO_LOAD_CLOSED_REQUESTS",
        "CLIENT_LOCATION": "REQUESTS.CLIENT_LOCATION" as "REQUESTS.CLIENT_LOCATION",
        "CLOSED": "REQUESTS.CLOSED" as "REQUESTS.CLOSED",
        "DATE_REQUESTED_BY": "REQUESTS.DATE_REQUESTED_BY" as "REQUESTS.DATE_REQUESTED_BY",
        "DATE_REQUIRED_BY": "REQUESTS.DATE_REQUIRED_BY" as "REQUESTS.DATE_REQUIRED_BY",
        "DATE_SUBMITTED": "REQUESTS.DATE_SUBMITTED" as "REQUESTS.DATE_SUBMITTED",
        "DELIVERABLES": "REQUESTS.DELIVERABLES" as "REQUESTS.DELIVERABLES",
        "EMAILS": {
            "ADDED": {
                "NEW_SPECIAL_REQUEST": "REQUESTS.EMAILS.ADDED.NEW_SPECIAL_REQUEST" as "REQUESTS.EMAILS.ADDED.NEW_SPECIAL_REQUEST",
                "REQUEST_IS_DUE_BY": "REQUESTS.EMAILS.ADDED.REQUEST_IS_DUE_BY" as "REQUESTS.EMAILS.ADDED.REQUEST_IS_DUE_BY"
            },
            "COMMENT_ADDED": {
                "SPECIAL_REQUEST_HAS_BEEN_UPDATED": "REQUESTS.EMAILS.COMMENT_ADDED.SPECIAL_REQUEST_HAS_BEEN_UPDATED" as "REQUESTS.EMAILS.COMMENT_ADDED.SPECIAL_REQUEST_HAS_BEEN_UPDATED",
                "SUBJECT_LINE": "REQUESTS.EMAILS.COMMENT_ADDED.SUBJECT_LINE" as "REQUESTS.EMAILS.COMMENT_ADDED.SUBJECT_LINE"
            },
            "VIEW_SPECIAL_REQUEST": "REQUESTS.EMAILS.VIEW_SPECIAL_REQUEST" as "REQUESTS.EMAILS.VIEW_SPECIAL_REQUEST"
        },
        "ESCALATED": "REQUESTS.ESCALATED" as "REQUESTS.ESCALATED",
        "FAILED_TO_GET_SPECIAL_REQUEST": "REQUESTS.FAILED_TO_GET_SPECIAL_REQUEST" as "REQUESTS.FAILED_TO_GET_SPECIAL_REQUEST",
        "FAILED_TO_GET_SPECIAL_REQUESTS": "REQUESTS.FAILED_TO_GET_SPECIAL_REQUESTS" as "REQUESTS.FAILED_TO_GET_SPECIAL_REQUESTS",
        "FILTER": {
            "CLIENT": "REQUESTS.FILTER.CLIENT" as "REQUESTS.FILTER.CLIENT",
            "DATE": "REQUESTS.FILTER.DATE" as "REQUESTS.FILTER.DATE",
            "STATUS": "REQUESTS.FILTER.STATUS" as "REQUESTS.FILTER.STATUS",
            "TITLE": "REQUESTS.FILTER.TITLE" as "REQUESTS.FILTER.TITLE"
        },
        "ID": "REQUESTS.ID" as "REQUESTS.ID",
        "INVALID_DATE_REQUIRED_BY": "REQUESTS.INVALID_DATE_REQUIRED_BY" as "REQUESTS.INVALID_DATE_REQUIRED_BY",
        "IN_PROGRESS": "REQUESTS.IN_PROGRESS" as "REQUESTS.IN_PROGRESS",
        "LOAD_MANAGERS_FAILED": "REQUESTS.LOAD_MANAGERS_FAILED" as "REQUESTS.LOAD_MANAGERS_FAILED",
        "MORE_INFO_REQUIRED": "REQUESTS.MORE_INFO_REQUIRED" as "REQUESTS.MORE_INFO_REQUIRED",
        "NEW_REQUEST": "REQUESTS.NEW_REQUEST" as "REQUESTS.NEW_REQUEST",
        "PAYMENT": "REQUESTS.PAYMENT" as "REQUESTS.PAYMENT",
        "PAYMENT_OVERPAID": "REQUESTS.PAYMENT_OVERPAID" as "REQUESTS.PAYMENT_OVERPAID",
        "PAYMENT_REQUIRED": "REQUESTS.PAYMENT_REQUIRED" as "REQUESTS.PAYMENT_REQUIRED",
        "PLEASE_ENTER_DELIVERABLES": "REQUESTS.PLEASE_ENTER_DELIVERABLES" as "REQUESTS.PLEASE_ENTER_DELIVERABLES",
        "PREVIOUS_QUOTE_DIFFERENCE": "REQUESTS.PREVIOUS_QUOTE_DIFFERENCE" as "REQUESTS.PREVIOUS_QUOTE_DIFFERENCE",
        "QUOTE": "REQUESTS.QUOTE" as "REQUESTS.QUOTE",
        "QUOTED": "REQUESTS.QUOTED" as "REQUESTS.QUOTED",
        "QUOTE_APPROVED": "REQUESTS.QUOTE_APPROVED" as "REQUESTS.QUOTE_APPROVED",
        "QUOTE_REJECTED": "REQUESTS.QUOTE_REJECTED" as "REQUESTS.QUOTE_REJECTED",
        "QUOTE_SENT": "REQUESTS.QUOTE_SENT" as "REQUESTS.QUOTE_SENT",
        "REQUEST_SAVED": "REQUESTS.REQUEST_SAVED" as "REQUESTS.REQUEST_SAVED",
        "RETRIEVE_SPECIAL_REQUEST": "REQUESTS.RETRIEVE_SPECIAL_REQUEST" as "REQUESTS.RETRIEVE_SPECIAL_REQUEST",
        "SAVE_SPECIAL_REQUEST": "REQUESTS.SAVE_SPECIAL_REQUEST" as "REQUESTS.SAVE_SPECIAL_REQUEST",
        "SELECTED_DELIVERABLES": "REQUESTS.SELECTED_DELIVERABLES" as "REQUESTS.SELECTED_DELIVERABLES",
        "SEND_QUOTE": "REQUESTS.SEND_QUOTE" as "REQUESTS.SEND_QUOTE",
        "STATUS": "REQUESTS.STATUS" as "REQUESTS.STATUS",
        "SUBMITTED": "REQUESTS.SUBMITTED" as "REQUESTS.SUBMITTED",
        "UPDATED": "REQUESTS.UPDATED" as "REQUESTS.UPDATED"
    },
    "ROADMAP": {
        "LATER": {
            "HEADING": "ROADMAP.LATER.HEADING" as "ROADMAP.LATER.HEADING",
            "ITEMS": {
                "ITEM_1": "ROADMAP.LATER.ITEMS.ITEM_1" as "ROADMAP.LATER.ITEMS.ITEM_1",
                "ITEM_2": "ROADMAP.LATER.ITEMS.ITEM_2" as "ROADMAP.LATER.ITEMS.ITEM_2",
                "ITEM_3": "ROADMAP.LATER.ITEMS.ITEM_3" as "ROADMAP.LATER.ITEMS.ITEM_3",
                "ITEM_4": "ROADMAP.LATER.ITEMS.ITEM_4" as "ROADMAP.LATER.ITEMS.ITEM_4",
                "ITEM_5": "ROADMAP.LATER.ITEMS.ITEM_5" as "ROADMAP.LATER.ITEMS.ITEM_5"
            }
        },
        "NEXT": {
            "HEADING": "ROADMAP.NEXT.HEADING" as "ROADMAP.NEXT.HEADING",
            "ITEMS": {
                "ITEM_1": "ROADMAP.NEXT.ITEMS.ITEM_1" as "ROADMAP.NEXT.ITEMS.ITEM_1",
                "ITEM_2": "ROADMAP.NEXT.ITEMS.ITEM_2" as "ROADMAP.NEXT.ITEMS.ITEM_2",
                "ITEM_3": "ROADMAP.NEXT.ITEMS.ITEM_3" as "ROADMAP.NEXT.ITEMS.ITEM_3",
                "ITEM_4": "ROADMAP.NEXT.ITEMS.ITEM_4" as "ROADMAP.NEXT.ITEMS.ITEM_4",
                "ITEM_5": "ROADMAP.NEXT.ITEMS.ITEM_5" as "ROADMAP.NEXT.ITEMS.ITEM_5",
                "ITEM_6": "ROADMAP.NEXT.ITEMS.ITEM_6" as "ROADMAP.NEXT.ITEMS.ITEM_6",
                "ITEM_7": "ROADMAP.NEXT.ITEMS.ITEM_7" as "ROADMAP.NEXT.ITEMS.ITEM_7",
                "ITEM_8": "ROADMAP.NEXT.ITEMS.ITEM_8" as "ROADMAP.NEXT.ITEMS.ITEM_8"
            }
        },
        "NOW": {
            "HEADING": "ROADMAP.NOW.HEADING" as "ROADMAP.NOW.HEADING",
            "ITEMS": {
                "ITEM_1": "ROADMAP.NOW.ITEMS.ITEM_1" as "ROADMAP.NOW.ITEMS.ITEM_1",
                "ITEM_2": "ROADMAP.NOW.ITEMS.ITEM_2" as "ROADMAP.NOW.ITEMS.ITEM_2",
                "ITEM_3": "ROADMAP.NOW.ITEMS.ITEM_3" as "ROADMAP.NOW.ITEMS.ITEM_3",
                "ITEM_4": "ROADMAP.NOW.ITEMS.ITEM_4" as "ROADMAP.NOW.ITEMS.ITEM_4",
                "ITEM_5": "ROADMAP.NOW.ITEMS.ITEM_5" as "ROADMAP.NOW.ITEMS.ITEM_5",
                "ITEM_6": "ROADMAP.NOW.ITEMS.ITEM_6" as "ROADMAP.NOW.ITEMS.ITEM_6",
                "ITEM_7": "ROADMAP.NOW.ITEMS.ITEM_7" as "ROADMAP.NOW.ITEMS.ITEM_7",
                "ITEM_8": "ROADMAP.NOW.ITEMS.ITEM_8" as "ROADMAP.NOW.ITEMS.ITEM_8"
            }
        },
        "RECENTLY_DELIVERED": {
            "HEADING": "ROADMAP.RECENTLY_DELIVERED.HEADING" as "ROADMAP.RECENTLY_DELIVERED.HEADING",
            "ITEMS": {
                "ITEM_1": "ROADMAP.RECENTLY_DELIVERED.ITEMS.ITEM_1" as "ROADMAP.RECENTLY_DELIVERED.ITEMS.ITEM_1",
                "ITEM_2": "ROADMAP.RECENTLY_DELIVERED.ITEMS.ITEM_2" as "ROADMAP.RECENTLY_DELIVERED.ITEMS.ITEM_2",
                "ITEM_3": "ROADMAP.RECENTLY_DELIVERED.ITEMS.ITEM_3" as "ROADMAP.RECENTLY_DELIVERED.ITEMS.ITEM_3",
                "ITEM_4": "ROADMAP.RECENTLY_DELIVERED.ITEMS.ITEM_4" as "ROADMAP.RECENTLY_DELIVERED.ITEMS.ITEM_4",
                "ITEM_5": "ROADMAP.RECENTLY_DELIVERED.ITEMS.ITEM_5" as "ROADMAP.RECENTLY_DELIVERED.ITEMS.ITEM_5",
                "ITEM_6": "ROADMAP.RECENTLY_DELIVERED.ITEMS.ITEM_6" as "ROADMAP.RECENTLY_DELIVERED.ITEMS.ITEM_6"
            }
        }
    },
    "SCHEDULE": {
        "EMAILS": {
            "DOWNLOAD_THE_APP": "SCHEDULE.EMAILS.DOWNLOAD_THE_APP" as "SCHEDULE.EMAILS.DOWNLOAD_THE_APP",
            "FAILED_TO_NOTIFY": {
                "CONTENT": "SCHEDULE.EMAILS.FAILED_TO_NOTIFY.CONTENT" as "SCHEDULE.EMAILS.FAILED_TO_NOTIFY.CONTENT",
                "HEADING_1": "SCHEDULE.EMAILS.FAILED_TO_NOTIFY.HEADING_1" as "SCHEDULE.EMAILS.FAILED_TO_NOTIFY.HEADING_1",
                "SUBJECT_LINE": "SCHEDULE.EMAILS.FAILED_TO_NOTIFY.SUBJECT_LINE" as "SCHEDULE.EMAILS.FAILED_TO_NOTIFY.SUBJECT_LINE"
            },
            "NO_DEVICES": {
                "CONTENT_1": "SCHEDULE.EMAILS.NO_DEVICES.CONTENT_1" as "SCHEDULE.EMAILS.NO_DEVICES.CONTENT_1",
                "CONTENT_2": "SCHEDULE.EMAILS.NO_DEVICES.CONTENT_2" as "SCHEDULE.EMAILS.NO_DEVICES.CONTENT_2",
                "CONTENT_3": "SCHEDULE.EMAILS.NO_DEVICES.CONTENT_3" as "SCHEDULE.EMAILS.NO_DEVICES.CONTENT_3",
                "HEADING_1": "SCHEDULE.EMAILS.NO_DEVICES.HEADING_1" as "SCHEDULE.EMAILS.NO_DEVICES.HEADING_1",
                "SUBJECT_LINE": "SCHEDULE.EMAILS.NO_DEVICES.SUBJECT_LINE" as "SCHEDULE.EMAILS.NO_DEVICES.SUBJECT_LINE"
            }
        },
        "PAGE": {
            "DIALOGS": {
                "DELETE": {
                    "CONFIRM": "SCHEDULE.PAGE.DIALOGS.DELETE.CONFIRM" as "SCHEDULE.PAGE.DIALOGS.DELETE.CONFIRM",
                    "DISABLED_LEGACY": "SCHEDULE.PAGE.DIALOGS.DELETE.DISABLED_LEGACY" as "SCHEDULE.PAGE.DIALOGS.DELETE.DISABLED_LEGACY",
                    "DISABLED_SCHEDULING": "SCHEDULE.PAGE.DIALOGS.DELETE.DISABLED_SCHEDULING" as "SCHEDULE.PAGE.DIALOGS.DELETE.DISABLED_SCHEDULING",
                    "FAILED_TO_DELETE": "SCHEDULE.PAGE.DIALOGS.DELETE.FAILED_TO_DELETE" as "SCHEDULE.PAGE.DIALOGS.DELETE.FAILED_TO_DELETE",
                    "OPTION_FOR_MULTIPLE": "SCHEDULE.PAGE.DIALOGS.DELETE.OPTION_FOR_MULTIPLE" as "SCHEDULE.PAGE.DIALOGS.DELETE.OPTION_FOR_MULTIPLE",
                    "OPTION_FOR_SINGLE": "SCHEDULE.PAGE.DIALOGS.DELETE.OPTION_FOR_SINGLE" as "SCHEDULE.PAGE.DIALOGS.DELETE.OPTION_FOR_SINGLE",
                    "SUCCESSFULLY_DELETED_POST": "SCHEDULE.PAGE.DIALOGS.DELETE.SUCCESSFULLY_DELETED_POST" as "SCHEDULE.PAGE.DIALOGS.DELETE.SUCCESSFULLY_DELETED_POST",
                    "TITLE": "SCHEDULE.PAGE.DIALOGS.DELETE.TITLE" as "SCHEDULE.PAGE.DIALOGS.DELETE.TITLE"
                },
                "EDIT_CAPTION": {
                    "CONTACTING_PLATFORM": "SCHEDULE.PAGE.DIALOGS.EDIT_CAPTION.CONTACTING_PLATFORM" as "SCHEDULE.PAGE.DIALOGS.EDIT_CAPTION.CONTACTING_PLATFORM",
                    "FAILED_TO_EDIT": "SCHEDULE.PAGE.DIALOGS.EDIT_CAPTION.FAILED_TO_EDIT" as "SCHEDULE.PAGE.DIALOGS.EDIT_CAPTION.FAILED_TO_EDIT",
                    "OPTION_FOR_MULTIPLE": "SCHEDULE.PAGE.DIALOGS.EDIT_CAPTION.OPTION_FOR_MULTIPLE" as "SCHEDULE.PAGE.DIALOGS.EDIT_CAPTION.OPTION_FOR_MULTIPLE",
                    "OPTION_FOR_SINGLE": "SCHEDULE.PAGE.DIALOGS.EDIT_CAPTION.OPTION_FOR_SINGLE" as "SCHEDULE.PAGE.DIALOGS.EDIT_CAPTION.OPTION_FOR_SINGLE",
                    "SUCCESSFULLY_EDITED_CAPTION": "SCHEDULE.PAGE.DIALOGS.EDIT_CAPTION.SUCCESSFULLY_EDITED_CAPTION" as "SCHEDULE.PAGE.DIALOGS.EDIT_CAPTION.SUCCESSFULLY_EDITED_CAPTION",
                    "TITLE": "SCHEDULE.PAGE.DIALOGS.EDIT_CAPTION.TITLE" as "SCHEDULE.PAGE.DIALOGS.EDIT_CAPTION.TITLE"
                },
                "RESCHEDULE": {
                    "CONFIRM": "SCHEDULE.PAGE.DIALOGS.RESCHEDULE.CONFIRM" as "SCHEDULE.PAGE.DIALOGS.RESCHEDULE.CONFIRM",
                    "DELETED": "SCHEDULE.PAGE.DIALOGS.RESCHEDULE.DELETED" as "SCHEDULE.PAGE.DIALOGS.RESCHEDULE.DELETED",
                    "DISABLED_LEGACY": "SCHEDULE.PAGE.DIALOGS.RESCHEDULE.DISABLED_LEGACY" as "SCHEDULE.PAGE.DIALOGS.RESCHEDULE.DISABLED_LEGACY",
                    "DISABLED_SCHEDULING": "SCHEDULE.PAGE.DIALOGS.RESCHEDULE.DISABLED_SCHEDULING" as "SCHEDULE.PAGE.DIALOGS.RESCHEDULE.DISABLED_SCHEDULING",
                    "FAILED_TO_RESCHEDULE": "SCHEDULE.PAGE.DIALOGS.RESCHEDULE.FAILED_TO_RESCHEDULE" as "SCHEDULE.PAGE.DIALOGS.RESCHEDULE.FAILED_TO_RESCHEDULE",
                    "OPTION_FOR_MULTIPLE": "SCHEDULE.PAGE.DIALOGS.RESCHEDULE.OPTION_FOR_MULTIPLE" as "SCHEDULE.PAGE.DIALOGS.RESCHEDULE.OPTION_FOR_MULTIPLE",
                    "OPTION_FOR_SINGLE": "SCHEDULE.PAGE.DIALOGS.RESCHEDULE.OPTION_FOR_SINGLE" as "SCHEDULE.PAGE.DIALOGS.RESCHEDULE.OPTION_FOR_SINGLE",
                    "SUCCESSFULLY_RESCHEDULED_POST": "SCHEDULE.PAGE.DIALOGS.RESCHEDULE.SUCCESSFULLY_RESCHEDULED_POST" as "SCHEDULE.PAGE.DIALOGS.RESCHEDULE.SUCCESSFULLY_RESCHEDULED_POST",
                    "TITLE": "SCHEDULE.PAGE.DIALOGS.RESCHEDULE.TITLE" as "SCHEDULE.PAGE.DIALOGS.RESCHEDULE.TITLE"
                }
            },
            "HEADER_TITLE": "SCHEDULE.PAGE.HEADER_TITLE" as "SCHEDULE.PAGE.HEADER_TITLE",
            "RESCHEDULE": "SCHEDULE.PAGE.RESCHEDULE" as "SCHEDULE.PAGE.RESCHEDULE",
            "TABLE": {
                "HEADERS": {
                    "ACTION": "SCHEDULE.PAGE.TABLE.HEADERS.ACTION" as "SCHEDULE.PAGE.TABLE.HEADERS.ACTION",
                    "CAPTION": "SCHEDULE.PAGE.TABLE.HEADERS.CAPTION" as "SCHEDULE.PAGE.TABLE.HEADERS.CAPTION",
                    "LOCATIONS": "SCHEDULE.PAGE.TABLE.HEADERS.LOCATIONS" as "SCHEDULE.PAGE.TABLE.HEADERS.LOCATIONS",
                    "POST": "SCHEDULE.PAGE.TABLE.HEADERS.POST" as "SCHEDULE.PAGE.TABLE.HEADERS.POST",
                    "TIME": "SCHEDULE.PAGE.TABLE.HEADERS.TIME" as "SCHEDULE.PAGE.TABLE.HEADERS.TIME"
                },
                "LOAD_NEWER_POSTS": "SCHEDULE.PAGE.TABLE.LOAD_NEWER_POSTS" as "SCHEDULE.PAGE.TABLE.LOAD_NEWER_POSTS",
                "LOAD_OLDER_POSTS": "SCHEDULE.PAGE.TABLE.LOAD_OLDER_POSTS" as "SCHEDULE.PAGE.TABLE.LOAD_OLDER_POSTS",
                "NO_SCHEDULED_POSTS_FOUND_FOR_PLATFORM": "SCHEDULE.PAGE.TABLE.NO_SCHEDULED_POSTS_FOUND_FOR_PLATFORM" as "SCHEDULE.PAGE.TABLE.NO_SCHEDULED_POSTS_FOUND_FOR_PLATFORM"
            }
        },
        "POSTS": {
            "CAPTION": "SCHEDULE.POSTS.CAPTION" as "SCHEDULE.POSTS.CAPTION",
            "COPIED_TO_CLIPBOARD": "SCHEDULE.POSTS.COPIED_TO_CLIPBOARD" as "SCHEDULE.POSTS.COPIED_TO_CLIPBOARD",
            "COPIED_TO_CLIPBOARD_FAILED": "SCHEDULE.POSTS.COPIED_TO_CLIPBOARD_FAILED" as "SCHEDULE.POSTS.COPIED_TO_CLIPBOARD_FAILED",
            "COPY_CAPTION": "SCHEDULE.POSTS.COPY_CAPTION" as "SCHEDULE.POSTS.COPY_CAPTION",
            "DOWNLOAD_IMAGE": "SCHEDULE.POSTS.DOWNLOAD_IMAGE" as "SCHEDULE.POSTS.DOWNLOAD_IMAGE",
            "GET_SCHEDULED_DETAILS": "SCHEDULE.POSTS.GET_SCHEDULED_DETAILS" as "SCHEDULE.POSTS.GET_SCHEDULED_DETAILS",
            "POST_DETAILS_SMS": "SCHEDULE.POSTS.POST_DETAILS_SMS" as "SCHEDULE.POSTS.POST_DETAILS_SMS",
            "POST_IMMEDIATELY": "SCHEDULE.POSTS.POST_IMMEDIATELY" as "SCHEDULE.POSTS.POST_IMMEDIATELY",
            "POST_SCHEDULED_FOR": "SCHEDULE.POSTS.POST_SCHEDULED_FOR" as "SCHEDULE.POSTS.POST_SCHEDULED_FOR",
            "SMS_DOWNLOAD_MESSAGE": "SCHEDULE.POSTS.SMS_DOWNLOAD_MESSAGE" as "SCHEDULE.POSTS.SMS_DOWNLOAD_MESSAGE",
            "UNABLE_TO_FIND_POST": "SCHEDULE.POSTS.UNABLE_TO_FIND_POST" as "SCHEDULE.POSTS.UNABLE_TO_FIND_POST",
            "UNABLE_TO_FIND_POST_HEADING": "SCHEDULE.POSTS.UNABLE_TO_FIND_POST_HEADING" as "SCHEDULE.POSTS.UNABLE_TO_FIND_POST_HEADING"
        },
        "PUSH_NOTIFICATIONS": {
            "TIME_TO_POST": "SCHEDULE.PUSH_NOTIFICATIONS.TIME_TO_POST" as "SCHEDULE.PUSH_NOTIFICATIONS.TIME_TO_POST"
        },
        "SCHEDULED_WITH_MOBILE_APP": "SCHEDULE.SCHEDULED_WITH_MOBILE_APP" as "SCHEDULE.SCHEDULED_WITH_MOBILE_APP"
    },
    "SHOPPING_CART": {
        "ADD_TO_CART": "SHOPPING_CART.ADD_TO_CART" as "SHOPPING_CART.ADD_TO_CART",
        "CHECKOUT": {
            "ADDRESS": "SHOPPING_CART.CHECKOUT.ADDRESS" as "SHOPPING_CART.CHECKOUT.ADDRESS",
            "CARD_DETAILS": "SHOPPING_CART.CHECKOUT.CARD_DETAILS" as "SHOPPING_CART.CHECKOUT.CARD_DETAILS",
            "CHECKOUT": "SHOPPING_CART.CHECKOUT.CHECKOUT" as "SHOPPING_CART.CHECKOUT.CHECKOUT",
            "COMPLETE_PAYMENT": "SHOPPING_CART.CHECKOUT.COMPLETE_PAYMENT" as "SHOPPING_CART.CHECKOUT.COMPLETE_PAYMENT",
            "DELETE_ITEM": "SHOPPING_CART.CHECKOUT.DELETE_ITEM" as "SHOPPING_CART.CHECKOUT.DELETE_ITEM",
            "DELETE_ITEM_CONFIRMATION": "SHOPPING_CART.CHECKOUT.DELETE_ITEM_CONFIRMATION" as "SHOPPING_CART.CHECKOUT.DELETE_ITEM_CONFIRMATION",
            "INC_TAX": "SHOPPING_CART.CHECKOUT.INC_TAX" as "SHOPPING_CART.CHECKOUT.INC_TAX",
            "LOCATIONS": "SHOPPING_CART.CHECKOUT.LOCATIONS" as "SHOPPING_CART.CHECKOUT.LOCATIONS",
            "PAYMENT_PENDING": "SHOPPING_CART.CHECKOUT.PAYMENT_PENDING" as "SHOPPING_CART.CHECKOUT.PAYMENT_PENDING",
            "PAYMENT_SUCCESSFUL": "SHOPPING_CART.CHECKOUT.PAYMENT_SUCCESSFUL" as "SHOPPING_CART.CHECKOUT.PAYMENT_SUCCESSFUL",
            "PAY_AMOUNT": "SHOPPING_CART.CHECKOUT.PAY_AMOUNT" as "SHOPPING_CART.CHECKOUT.PAY_AMOUNT",
            "PRINT_ORDER": "SHOPPING_CART.CHECKOUT.PRINT_ORDER" as "SHOPPING_CART.CHECKOUT.PRINT_ORDER",
            "PRINT_PROVIDER_NOT_CONFIGURED_PROPERLY": "SHOPPING_CART.CHECKOUT.PRINT_PROVIDER_NOT_CONFIGURED_PROPERLY" as "SHOPPING_CART.CHECKOUT.PRINT_PROVIDER_NOT_CONFIGURED_PROPERLY",
            "PURCHASE_COMPLETE": "SHOPPING_CART.CHECKOUT.PURCHASE_COMPLETE" as "SHOPPING_CART.CHECKOUT.PURCHASE_COMPLETE",
            "QUANTITY": "SHOPPING_CART.CHECKOUT.QUANTITY" as "SHOPPING_CART.CHECKOUT.QUANTITY",
            "SHIPPING": "SHOPPING_CART.CHECKOUT.SHIPPING" as "SHOPPING_CART.CHECKOUT.SHIPPING",
            "SHIPPING_DETAILS_INVALID": "SHOPPING_CART.CHECKOUT.SHIPPING_DETAILS_INVALID" as "SHOPPING_CART.CHECKOUT.SHIPPING_DETAILS_INVALID",
            "UPDATE_ITEM_QUANTITY": "SHOPPING_CART.CHECKOUT.UPDATE_ITEM_QUANTITY" as "SHOPPING_CART.CHECKOUT.UPDATE_ITEM_QUANTITY",
            "VIEW_RECEIPT": "SHOPPING_CART.CHECKOUT.VIEW_RECEIPT" as "SHOPPING_CART.CHECKOUT.VIEW_RECEIPT",
            "YOUR_RECEIPT_CAN_BE_VIEWED_BELOW": "SHOPPING_CART.CHECKOUT.YOUR_RECEIPT_CAN_BE_VIEWED_BELOW" as "SHOPPING_CART.CHECKOUT.YOUR_RECEIPT_CAN_BE_VIEWED_BELOW"
        },
        "CHECKOUT_NOW": "SHOPPING_CART.CHECKOUT_NOW" as "SHOPPING_CART.CHECKOUT_NOW",
        "CHECKOUT_YOUR_PRINT_ITEMS": "SHOPPING_CART.CHECKOUT_YOUR_PRINT_ITEMS" as "SHOPPING_CART.CHECKOUT_YOUR_PRINT_ITEMS",
        "EMAILS": {
            "DATE": "SHOPPING_CART.EMAILS.DATE" as "SHOPPING_CART.EMAILS.DATE",
            "ORDER_NUMBER": "SHOPPING_CART.EMAILS.ORDER_NUMBER" as "SHOPPING_CART.EMAILS.ORDER_NUMBER",
            "PRINT_ORDER_FOR_PROVIDER": {
                "AGENCY": "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_PROVIDER.AGENCY" as "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_PROVIDER.AGENCY",
                "CLIENT": "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_PROVIDER.CLIENT" as "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_PROVIDER.CLIENT",
                "CONTACT_EMAIL": "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_PROVIDER.CONTACT_EMAIL" as "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_PROVIDER.CONTACT_EMAIL",
                "ORDER_RECEIVED": "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_PROVIDER.ORDER_RECEIVED" as "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_PROVIDER.ORDER_RECEIVED",
                "SUBJECT_LINE": "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_PROVIDER.SUBJECT_LINE" as "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_PROVIDER.SUBJECT_LINE"
            },
            "PRINT_ORDER_FOR_USER": {
                "ORDER_RECEIVED": "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_USER.ORDER_RECEIVED" as "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_USER.ORDER_RECEIVED",
                "PRINT_PROVIDER": "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_USER.PRINT_PROVIDER" as "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_USER.PRINT_PROVIDER",
                "PRINT_PROVIDER_EMAIL": "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_USER.PRINT_PROVIDER_EMAIL" as "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_USER.PRINT_PROVIDER_EMAIL",
                "SUBJECT_LINE": "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_USER.SUBJECT_LINE" as "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_USER.SUBJECT_LINE"
            }
        },
        "FETCH_ITEM_COUNT": "SHOPPING_CART.FETCH_ITEM_COUNT" as "SHOPPING_CART.FETCH_ITEM_COUNT",
        "FETCH_ORDERS": "SHOPPING_CART.FETCH_ORDERS" as "SHOPPING_CART.FETCH_ORDERS",
        "PRINT_REQUEST_ADDED_TO_CART": "SHOPPING_CART.PRINT_REQUEST_ADDED_TO_CART" as "SHOPPING_CART.PRINT_REQUEST_ADDED_TO_CART"
    },
    "STATS": {
        "EMAILS": {
            "ACCESS_TOKEN_ERROR": {
                "ACCESS_ERROR_FOR": "STATS.EMAILS.ACCESS_TOKEN_ERROR.ACCESS_ERROR_FOR" as "STATS.EMAILS.ACCESS_TOKEN_ERROR.ACCESS_ERROR_FOR",
                "AUTHORIZE_SERVICE": "STATS.EMAILS.ACCESS_TOKEN_ERROR.AUTHORIZE_SERVICE" as "STATS.EMAILS.ACCESS_TOKEN_ERROR.AUTHORIZE_SERVICE",
                "IF_ACCESS_TO_IS_NO_LONGER_REQUIRED": "STATS.EMAILS.ACCESS_TOKEN_ERROR.IF_ACCESS_TO_IS_NO_LONGER_REQUIRED" as "STATS.EMAILS.ACCESS_TOKEN_ERROR.IF_ACCESS_TO_IS_NO_LONGER_REQUIRED",
                "IF_NOT_RESOLVED_CONTACT_SUPPORT": "STATS.EMAILS.ACCESS_TOKEN_ERROR.IF_NOT_RESOLVED_CONTACT_SUPPORT" as "STATS.EMAILS.ACCESS_TOKEN_ERROR.IF_NOT_RESOLVED_CONTACT_SUPPORT",
                "SUBJECT_LINE": "STATS.EMAILS.ACCESS_TOKEN_ERROR.SUBJECT_LINE" as "STATS.EMAILS.ACCESS_TOKEN_ERROR.SUBJECT_LINE",
                "TRY_LOGGING_IN_AND_RE_AUTHORIZING": "STATS.EMAILS.ACCESS_TOKEN_ERROR.TRY_LOGGING_IN_AND_RE_AUTHORIZING" as "STATS.EMAILS.ACCESS_TOKEN_ERROR.TRY_LOGGING_IN_AND_RE_AUTHORIZING",
                "WE_HAD_A_PROBLEM_TRYING_TO_ACCESS": "STATS.EMAILS.ACCESS_TOKEN_ERROR.WE_HAD_A_PROBLEM_TRYING_TO_ACCESS" as "STATS.EMAILS.ACCESS_TOKEN_ERROR.WE_HAD_A_PROBLEM_TRYING_TO_ACCESS"
            }
        }
    },
    "TERMS": {
        "HEADING": "TERMS.HEADING" as "TERMS.HEADING",
        "SECTION_01": {
            "DESCRIPTION": "TERMS.SECTION_01.DESCRIPTION" as "TERMS.SECTION_01.DESCRIPTION",
            "HEADING": "TERMS.SECTION_01.HEADING" as "TERMS.SECTION_01.HEADING",
            "PART_A": "TERMS.SECTION_01.PART_A" as "TERMS.SECTION_01.PART_A",
            "PART_B": "TERMS.SECTION_01.PART_B" as "TERMS.SECTION_01.PART_B"
        },
        "SECTION_02": {
            "DESCRIPTION": "TERMS.SECTION_02.DESCRIPTION" as "TERMS.SECTION_02.DESCRIPTION",
            "HEADING": "TERMS.SECTION_02.HEADING" as "TERMS.SECTION_02.HEADING"
        },
        "SECTION_03": {
            "DESCRIPTION": "TERMS.SECTION_03.DESCRIPTION" as "TERMS.SECTION_03.DESCRIPTION",
            "HEADING": "TERMS.SECTION_03.HEADING" as "TERMS.SECTION_03.HEADING"
        },
        "SECTION_04": {
            "HEADING": "TERMS.SECTION_04.HEADING" as "TERMS.SECTION_04.HEADING",
            "PART_01": "TERMS.SECTION_04.PART_01" as "TERMS.SECTION_04.PART_01",
            "PART_02": "TERMS.SECTION_04.PART_02" as "TERMS.SECTION_04.PART_02"
        },
        "SECTION_05": {
            "HEADING": "TERMS.SECTION_05.HEADING" as "TERMS.SECTION_05.HEADING",
            "PART_01": {
                "HEADING": "TERMS.SECTION_05.PART_01.HEADING" as "TERMS.SECTION_05.PART_01.HEADING",
                "PART_A": "TERMS.SECTION_05.PART_01.PART_A" as "TERMS.SECTION_05.PART_01.PART_A",
                "PART_B": "TERMS.SECTION_05.PART_01.PART_B" as "TERMS.SECTION_05.PART_01.PART_B",
                "PART_C": "TERMS.SECTION_05.PART_01.PART_C" as "TERMS.SECTION_05.PART_01.PART_C",
                "PART_D": "TERMS.SECTION_05.PART_01.PART_D" as "TERMS.SECTION_05.PART_01.PART_D"
            }
        },
        "SECTION_06": {
            "HEADING": "TERMS.SECTION_06.HEADING" as "TERMS.SECTION_06.HEADING",
            "PART_01": {
                "HEADING": "TERMS.SECTION_06.PART_01.HEADING" as "TERMS.SECTION_06.PART_01.HEADING",
                "PART_A": "TERMS.SECTION_06.PART_01.PART_A" as "TERMS.SECTION_06.PART_01.PART_A",
                "PART_B": "TERMS.SECTION_06.PART_01.PART_B" as "TERMS.SECTION_06.PART_01.PART_B",
                "PART_C": "TERMS.SECTION_06.PART_01.PART_C" as "TERMS.SECTION_06.PART_01.PART_C",
                "PART_D": "TERMS.SECTION_06.PART_01.PART_D" as "TERMS.SECTION_06.PART_01.PART_D",
                "PART_E": "TERMS.SECTION_06.PART_01.PART_E" as "TERMS.SECTION_06.PART_01.PART_E",
                "PART_F": "TERMS.SECTION_06.PART_01.PART_F" as "TERMS.SECTION_06.PART_01.PART_F",
                "PART_G": "TERMS.SECTION_06.PART_01.PART_G" as "TERMS.SECTION_06.PART_01.PART_G"
            },
            "PART_02": {
                "HEADING": "TERMS.SECTION_06.PART_02.HEADING" as "TERMS.SECTION_06.PART_02.HEADING"
            }
        },
        "SECTION_07": {
            "HEADING": "TERMS.SECTION_07.HEADING" as "TERMS.SECTION_07.HEADING",
            "PART_01": {
                "HEADING": "TERMS.SECTION_07.PART_01.HEADING" as "TERMS.SECTION_07.PART_01.HEADING",
                "PART_A": "TERMS.SECTION_07.PART_01.PART_A" as "TERMS.SECTION_07.PART_01.PART_A",
                "PART_B": "TERMS.SECTION_07.PART_01.PART_B" as "TERMS.SECTION_07.PART_01.PART_B"
            },
            "PART_02": {
                "HEADING": "TERMS.SECTION_07.PART_02.HEADING" as "TERMS.SECTION_07.PART_02.HEADING"
            },
            "PART_03": {
                "HEADING": "TERMS.SECTION_07.PART_03.HEADING" as "TERMS.SECTION_07.PART_03.HEADING"
            },
            "PART_04": {
                "HEADING": "TERMS.SECTION_07.PART_04.HEADING" as "TERMS.SECTION_07.PART_04.HEADING",
                "PART_A": "TERMS.SECTION_07.PART_04.PART_A" as "TERMS.SECTION_07.PART_04.PART_A",
                "PART_B": "TERMS.SECTION_07.PART_04.PART_B" as "TERMS.SECTION_07.PART_04.PART_B"
            },
            "PART_05": {
                "HEADING": "TERMS.SECTION_07.PART_05.HEADING" as "TERMS.SECTION_07.PART_05.HEADING"
            }
        },
        "SECTION_08": {
            "DESCRIPTION": "TERMS.SECTION_08.DESCRIPTION" as "TERMS.SECTION_08.DESCRIPTION",
            "HEADING": "TERMS.SECTION_08.HEADING" as "TERMS.SECTION_08.HEADING",
            "PART_A": "TERMS.SECTION_08.PART_A" as "TERMS.SECTION_08.PART_A",
            "PART_B": "TERMS.SECTION_08.PART_B" as "TERMS.SECTION_08.PART_B"
        },
        "SECTION_09": {
            "HEADING": "TERMS.SECTION_09.HEADING" as "TERMS.SECTION_09.HEADING",
            "PART_01": "TERMS.SECTION_09.PART_01" as "TERMS.SECTION_09.PART_01",
            "PART_02": "TERMS.SECTION_09.PART_02" as "TERMS.SECTION_09.PART_02"
        },
        "SECTION_10": {
            "HEADING": "TERMS.SECTION_10.HEADING" as "TERMS.SECTION_10.HEADING",
            "PART_A": {
                "HEADING": "TERMS.SECTION_10.PART_A.HEADING" as "TERMS.SECTION_10.PART_A.HEADING",
                "PART_01": "TERMS.SECTION_10.PART_A.PART_01" as "TERMS.SECTION_10.PART_A.PART_01",
                "PART_02": "TERMS.SECTION_10.PART_A.PART_02" as "TERMS.SECTION_10.PART_A.PART_02",
                "PART_03": "TERMS.SECTION_10.PART_A.PART_03" as "TERMS.SECTION_10.PART_A.PART_03",
                "PART_04": "TERMS.SECTION_10.PART_A.PART_04" as "TERMS.SECTION_10.PART_A.PART_04",
                "PART_05": "TERMS.SECTION_10.PART_A.PART_05" as "TERMS.SECTION_10.PART_A.PART_05"
            },
            "PART_B": {
                "HEADING": "TERMS.SECTION_10.PART_B.HEADING" as "TERMS.SECTION_10.PART_B.HEADING",
                "PART_01": "TERMS.SECTION_10.PART_B.PART_01" as "TERMS.SECTION_10.PART_B.PART_01",
                "PART_02": "TERMS.SECTION_10.PART_B.PART_02" as "TERMS.SECTION_10.PART_B.PART_02",
                "PART_03": "TERMS.SECTION_10.PART_B.PART_03" as "TERMS.SECTION_10.PART_B.PART_03",
                "PART_04": "TERMS.SECTION_10.PART_B.PART_04" as "TERMS.SECTION_10.PART_B.PART_04"
            }
        },
        "SECTION_11": {
            "HEADING": "TERMS.SECTION_11.HEADING" as "TERMS.SECTION_11.HEADING",
            "PART_A": {
                "HEADING": "TERMS.SECTION_11.PART_A.HEADING" as "TERMS.SECTION_11.PART_A.HEADING",
                "PART_01": "TERMS.SECTION_11.PART_A.PART_01" as "TERMS.SECTION_11.PART_A.PART_01",
                "PART_02": "TERMS.SECTION_11.PART_A.PART_02" as "TERMS.SECTION_11.PART_A.PART_02",
                "PART_03": "TERMS.SECTION_11.PART_A.PART_03" as "TERMS.SECTION_11.PART_A.PART_03",
                "PART_04": "TERMS.SECTION_11.PART_A.PART_04" as "TERMS.SECTION_11.PART_A.PART_04",
                "PART_05": "TERMS.SECTION_11.PART_A.PART_05" as "TERMS.SECTION_11.PART_A.PART_05",
                "PART_06": "TERMS.SECTION_11.PART_A.PART_06" as "TERMS.SECTION_11.PART_A.PART_06"
            },
            "PART_B": {
                "HEADING": "TERMS.SECTION_11.PART_B.HEADING" as "TERMS.SECTION_11.PART_B.HEADING"
            }
        },
        "SECTION_12": {
            "HEADING": "TERMS.SECTION_12.HEADING" as "TERMS.SECTION_12.HEADING",
            "PART_01": {
                "HEADING": "TERMS.SECTION_12.PART_01.HEADING" as "TERMS.SECTION_12.PART_01.HEADING",
                "PART_A": "TERMS.SECTION_12.PART_01.PART_A" as "TERMS.SECTION_12.PART_01.PART_A",
                "PART_B": "TERMS.SECTION_12.PART_01.PART_B" as "TERMS.SECTION_12.PART_01.PART_B"
            },
            "PART_02": "TERMS.SECTION_12.PART_02" as "TERMS.SECTION_12.PART_02",
            "PART_03": "TERMS.SECTION_12.PART_03" as "TERMS.SECTION_12.PART_03"
        },
        "SECTION_13": {
            "HEADING": "TERMS.SECTION_13.HEADING" as "TERMS.SECTION_13.HEADING",
            "PART_01": "TERMS.SECTION_13.PART_01" as "TERMS.SECTION_13.PART_01",
            "PART_02": "TERMS.SECTION_13.PART_02" as "TERMS.SECTION_13.PART_02"
        },
        "SECTION_14": {
            "DESCRIPTION": "TERMS.SECTION_14.DESCRIPTION" as "TERMS.SECTION_14.DESCRIPTION",
            "HEADING": "TERMS.SECTION_14.HEADING" as "TERMS.SECTION_14.HEADING"
        },
        "SECTION_15": {
            "HEADING": "TERMS.SECTION_15.HEADING" as "TERMS.SECTION_15.HEADING",
            "PART_01": "TERMS.SECTION_15.PART_01" as "TERMS.SECTION_15.PART_01",
            "PART_02": {
                "HEADING": "TERMS.SECTION_15.PART_02.HEADING" as "TERMS.SECTION_15.PART_02.HEADING",
                "PART_A": "TERMS.SECTION_15.PART_02.PART_A" as "TERMS.SECTION_15.PART_02.PART_A",
                "PART_B": {
                    "HEADING": "TERMS.SECTION_15.PART_02.PART_B.HEADING" as "TERMS.SECTION_15.PART_02.PART_B.HEADING",
                    "PART_01": "TERMS.SECTION_15.PART_02.PART_B.PART_01" as "TERMS.SECTION_15.PART_02.PART_B.PART_01",
                    "PART_02": "TERMS.SECTION_15.PART_02.PART_B.PART_02" as "TERMS.SECTION_15.PART_02.PART_B.PART_02"
                },
                "PART_C": "TERMS.SECTION_15.PART_02.PART_C" as "TERMS.SECTION_15.PART_02.PART_C"
            }
        },
        "SECTION_16": {
            "DESCRIPTION": "TERMS.SECTION_16.DESCRIPTION" as "TERMS.SECTION_16.DESCRIPTION",
            "HEADING": "TERMS.SECTION_16.HEADING" as "TERMS.SECTION_16.HEADING",
            "PART_01": {
                "HEADING": "TERMS.SECTION_16.PART_01.HEADING" as "TERMS.SECTION_16.PART_01.HEADING",
                "PART_A": "TERMS.SECTION_16.PART_01.PART_A" as "TERMS.SECTION_16.PART_01.PART_A",
                "PART_B": "TERMS.SECTION_16.PART_01.PART_B" as "TERMS.SECTION_16.PART_01.PART_B",
                "PART_C": "TERMS.SECTION_16.PART_01.PART_C" as "TERMS.SECTION_16.PART_01.PART_C",
                "PART_D": {
                    "HEADING": "TERMS.SECTION_16.PART_01.PART_D.HEADING" as "TERMS.SECTION_16.PART_01.PART_D.HEADING",
                    "PART_01": "TERMS.SECTION_16.PART_01.PART_D.PART_01" as "TERMS.SECTION_16.PART_01.PART_D.PART_01",
                    "PART_02": "TERMS.SECTION_16.PART_01.PART_D.PART_02" as "TERMS.SECTION_16.PART_01.PART_D.PART_02",
                    "PART_03": "TERMS.SECTION_16.PART_01.PART_D.PART_03" as "TERMS.SECTION_16.PART_01.PART_D.PART_03",
                    "PART_04": "TERMS.SECTION_16.PART_01.PART_D.PART_04" as "TERMS.SECTION_16.PART_01.PART_D.PART_04",
                    "PART_05": "TERMS.SECTION_16.PART_01.PART_D.PART_05" as "TERMS.SECTION_16.PART_01.PART_D.PART_05",
                    "PART_06": "TERMS.SECTION_16.PART_01.PART_D.PART_06" as "TERMS.SECTION_16.PART_01.PART_D.PART_06",
                    "PART_07": "TERMS.SECTION_16.PART_01.PART_D.PART_07" as "TERMS.SECTION_16.PART_01.PART_D.PART_07",
                    "PART_08": "TERMS.SECTION_16.PART_01.PART_D.PART_08" as "TERMS.SECTION_16.PART_01.PART_D.PART_08",
                    "PART_09": "TERMS.SECTION_16.PART_01.PART_D.PART_09" as "TERMS.SECTION_16.PART_01.PART_D.PART_09"
                }
            }
        },
        "SECTION_17": {
            "HEADING": "TERMS.SECTION_17.HEADING" as "TERMS.SECTION_17.HEADING",
            "PART_01": {
                "HEADING": "TERMS.SECTION_17.PART_01.HEADING" as "TERMS.SECTION_17.PART_01.HEADING",
                "PART_A": "TERMS.SECTION_17.PART_01.PART_A" as "TERMS.SECTION_17.PART_01.PART_A",
                "PART_B": "TERMS.SECTION_17.PART_01.PART_B" as "TERMS.SECTION_17.PART_01.PART_B",
                "PART_C": "TERMS.SECTION_17.PART_01.PART_C" as "TERMS.SECTION_17.PART_01.PART_C",
                "PART_D": "TERMS.SECTION_17.PART_01.PART_D" as "TERMS.SECTION_17.PART_01.PART_D",
                "PART_E": "TERMS.SECTION_17.PART_01.PART_E" as "TERMS.SECTION_17.PART_01.PART_E"
            },
            "PART_02": {
                "HEADING": "TERMS.SECTION_17.PART_02.HEADING" as "TERMS.SECTION_17.PART_02.HEADING",
                "PART_A": "TERMS.SECTION_17.PART_02.PART_A" as "TERMS.SECTION_17.PART_02.PART_A",
                "PART_B": "TERMS.SECTION_17.PART_02.PART_B" as "TERMS.SECTION_17.PART_02.PART_B",
                "PART_C": "TERMS.SECTION_17.PART_02.PART_C" as "TERMS.SECTION_17.PART_02.PART_C",
                "PART_D": "TERMS.SECTION_17.PART_02.PART_D" as "TERMS.SECTION_17.PART_02.PART_D"
            },
            "PART_03": {
                "HEADING": "TERMS.SECTION_17.PART_03.HEADING" as "TERMS.SECTION_17.PART_03.HEADING",
                "PART_A": "TERMS.SECTION_17.PART_03.PART_A" as "TERMS.SECTION_17.PART_03.PART_A",
                "PART_B": "TERMS.SECTION_17.PART_03.PART_B" as "TERMS.SECTION_17.PART_03.PART_B"
            }
        },
        "SECTION_18": {
            "DESCRIPTION": "TERMS.SECTION_18.DESCRIPTION" as "TERMS.SECTION_18.DESCRIPTION",
            "HEADING": "TERMS.SECTION_18.HEADING" as "TERMS.SECTION_18.HEADING"
        },
        "SECTION_19": {
            "HEADING": "TERMS.SECTION_19.HEADING" as "TERMS.SECTION_19.HEADING",
            "PART_A": "TERMS.SECTION_19.PART_A" as "TERMS.SECTION_19.PART_A",
            "PART_B": "TERMS.SECTION_19.PART_B" as "TERMS.SECTION_19.PART_B",
            "PART_C": "TERMS.SECTION_19.PART_C" as "TERMS.SECTION_19.PART_C",
            "PART_D": "TERMS.SECTION_19.PART_D" as "TERMS.SECTION_19.PART_D",
            "PART_E": "TERMS.SECTION_19.PART_E" as "TERMS.SECTION_19.PART_E",
            "PART_F": "TERMS.SECTION_19.PART_F" as "TERMS.SECTION_19.PART_F",
            "PART_G": "TERMS.SECTION_19.PART_G" as "TERMS.SECTION_19.PART_G",
            "PART_H": "TERMS.SECTION_19.PART_H" as "TERMS.SECTION_19.PART_H"
        }
    },
    "TIMEZONES": {
        "ADAK": "TIMEZONES.ADAK" as "TIMEZONES.ADAK",
        "ADELAIDE": "TIMEZONES.ADELAIDE" as "TIMEZONES.ADELAIDE",
        "ALMATY": "TIMEZONES.ALMATY" as "TIMEZONES.ALMATY",
        "AMMAN": "TIMEZONES.AMMAN" as "TIMEZONES.AMMAN",
        "ANCHORAGE": "TIMEZONES.ANCHORAGE" as "TIMEZONES.ANCHORAGE",
        "APIA": "TIMEZONES.APIA" as "TIMEZONES.APIA",
        "ARAGUAINA": "TIMEZONES.ARAGUAINA" as "TIMEZONES.ARAGUAINA",
        "ASTRAKHAN": "TIMEZONES.ASTRAKHAN" as "TIMEZONES.ASTRAKHAN",
        "ASUNCION": "TIMEZONES.ASUNCION" as "TIMEZONES.ASUNCION",
        "AUCKLAND": "TIMEZONES.AUCKLAND" as "TIMEZONES.AUCKLAND",
        "AZORES": "TIMEZONES.AZORES" as "TIMEZONES.AZORES",
        "BAGHDAD": "TIMEZONES.BAGHDAD" as "TIMEZONES.BAGHDAD",
        "BAHIA": "TIMEZONES.BAHIA" as "TIMEZONES.BAHIA",
        "BAKU": "TIMEZONES.BAKU" as "TIMEZONES.BAKU",
        "BANGKOK": "TIMEZONES.BANGKOK" as "TIMEZONES.BANGKOK",
        "BARNAUL": "TIMEZONES.BARNAUL" as "TIMEZONES.BARNAUL",
        "BEIRUT": "TIMEZONES.BEIRUT" as "TIMEZONES.BEIRUT",
        "BERLIN": "TIMEZONES.BERLIN" as "TIMEZONES.BERLIN",
        "BOGOTA": "TIMEZONES.BOGOTA" as "TIMEZONES.BOGOTA",
        "BOUGAINVILLE": "TIMEZONES.BOUGAINVILLE" as "TIMEZONES.BOUGAINVILLE",
        "BRISBANE": "TIMEZONES.BRISBANE" as "TIMEZONES.BRISBANE",
        "BUCHAREST": "TIMEZONES.BUCHAREST" as "TIMEZONES.BUCHAREST",
        "BUDAPEST": "TIMEZONES.BUDAPEST" as "TIMEZONES.BUDAPEST",
        "BUENOS_AIRES": "TIMEZONES.BUENOS_AIRES" as "TIMEZONES.BUENOS_AIRES",
        "CAIRO": "TIMEZONES.CAIRO" as "TIMEZONES.CAIRO",
        "CALCUTTA": "TIMEZONES.CALCUTTA" as "TIMEZONES.CALCUTTA",
        "CANCUN": "TIMEZONES.CANCUN" as "TIMEZONES.CANCUN",
        "CAPE_VERDE": "TIMEZONES.CAPE_VERDE" as "TIMEZONES.CAPE_VERDE",
        "CARACAS": "TIMEZONES.CARACAS" as "TIMEZONES.CARACAS",
        "CASABLANCA": "TIMEZONES.CASABLANCA" as "TIMEZONES.CASABLANCA",
        "CAYENNE": "TIMEZONES.CAYENNE" as "TIMEZONES.CAYENNE",
        "CHATHAM": "TIMEZONES.CHATHAM" as "TIMEZONES.CHATHAM",
        "CHICAGO": "TIMEZONES.CHICAGO" as "TIMEZONES.CHICAGO",
        "CHIHUAHUA": "TIMEZONES.CHIHUAHUA" as "TIMEZONES.CHIHUAHUA",
        "CHISINAU": "TIMEZONES.CHISINAU" as "TIMEZONES.CHISINAU",
        "CHITA": "TIMEZONES.CHITA" as "TIMEZONES.CHITA",
        "COLOMBO": "TIMEZONES.COLOMBO" as "TIMEZONES.COLOMBO",
        "CUIABA": "TIMEZONES.CUIABA" as "TIMEZONES.CUIABA",
        "DAMASCUS": "TIMEZONES.DAMASCUS" as "TIMEZONES.DAMASCUS",
        "DARWIN": "TIMEZONES.DARWIN" as "TIMEZONES.DARWIN",
        "DENVER": "TIMEZONES.DENVER" as "TIMEZONES.DENVER",
        "DHAKA": "TIMEZONES.DHAKA" as "TIMEZONES.DHAKA",
        "DUBAI": "TIMEZONES.DUBAI" as "TIMEZONES.DUBAI",
        "EASTER": "TIMEZONES.EASTER" as "TIMEZONES.EASTER",
        "EDMONTON": "TIMEZONES.EDMONTON" as "TIMEZONES.EDMONTON",
        "ENDERBURY": "TIMEZONES.ENDERBURY" as "TIMEZONES.ENDERBURY",
        "EUCLA": "TIMEZONES.EUCLA" as "TIMEZONES.EUCLA",
        "FIJI": "TIMEZONES.FIJI" as "TIMEZONES.FIJI",
        "GAMBIER": "TIMEZONES.GAMBIER" as "TIMEZONES.GAMBIER",
        "GODTHAB": "TIMEZONES.GODTHAB" as "TIMEZONES.GODTHAB",
        "GRAND_TURK": "TIMEZONES.GRAND_TURK" as "TIMEZONES.GRAND_TURK",
        "GUADALCANAL": "TIMEZONES.GUADALCANAL" as "TIMEZONES.GUADALCANAL",
        "GUATEMALA": "TIMEZONES.GUATEMALA" as "TIMEZONES.GUATEMALA",
        "HALIFAX": "TIMEZONES.HALIFAX" as "TIMEZONES.HALIFAX",
        "HAVANA": "TIMEZONES.HAVANA" as "TIMEZONES.HAVANA",
        "HEBRON": "TIMEZONES.HEBRON" as "TIMEZONES.HEBRON",
        "HOBART": "TIMEZONES.HOBART" as "TIMEZONES.HOBART",
        "HONOLULU": "TIMEZONES.HONOLULU" as "TIMEZONES.HONOLULU",
        "HOVD": "TIMEZONES.HOVD" as "TIMEZONES.HOVD",
        "HO_CHI_MINH": "TIMEZONES.HO_CHI_MINH" as "TIMEZONES.HO_CHI_MINH",
        "INDIANAPOLIS": "TIMEZONES.INDIANAPOLIS" as "TIMEZONES.INDIANAPOLIS",
        "IRKUTSK": "TIMEZONES.IRKUTSK" as "TIMEZONES.IRKUTSK",
        "ISTANBUL": "TIMEZONES.ISTANBUL" as "TIMEZONES.ISTANBUL",
        "JERUSALEM": "TIMEZONES.JERUSALEM" as "TIMEZONES.JERUSALEM",
        "JOHANNESBURG": "TIMEZONES.JOHANNESBURG" as "TIMEZONES.JOHANNESBURG",
        "JUBA": "TIMEZONES.JUBA" as "TIMEZONES.JUBA",
        "KABUL": "TIMEZONES.KABUL" as "TIMEZONES.KABUL",
        "KALININGRAD": "TIMEZONES.KALININGRAD" as "TIMEZONES.KALININGRAD",
        "KAMCHATKA": "TIMEZONES.KAMCHATKA" as "TIMEZONES.KAMCHATKA",
        "KARACHI": "TIMEZONES.KARACHI" as "TIMEZONES.KARACHI",
        "KATMANDU": "TIMEZONES.KATMANDU" as "TIMEZONES.KATMANDU",
        "KHARTOUM": "TIMEZONES.KHARTOUM" as "TIMEZONES.KHARTOUM",
        "KIEV": "TIMEZONES.KIEV" as "TIMEZONES.KIEV",
        "KIRITIMATI": "TIMEZONES.KIRITIMATI" as "TIMEZONES.KIRITIMATI",
        "KRASNOYARSK": "TIMEZONES.KRASNOYARSK" as "TIMEZONES.KRASNOYARSK",
        "KUALA_LUMPUR": "TIMEZONES.KUALA_LUMPUR" as "TIMEZONES.KUALA_LUMPUR",
        "LAGOS": "TIMEZONES.LAGOS" as "TIMEZONES.LAGOS",
        "LA_PAZ": "TIMEZONES.LA_PAZ" as "TIMEZONES.LA_PAZ",
        "LONDON": "TIMEZONES.LONDON" as "TIMEZONES.LONDON",
        "LORD_HOWE": "TIMEZONES.LORD_HOWE" as "TIMEZONES.LORD_HOWE",
        "LOS_ANGELES": "TIMEZONES.LOS_ANGELES" as "TIMEZONES.LOS_ANGELES",
        "MAGADAN": "TIMEZONES.MAGADAN" as "TIMEZONES.MAGADAN",
        "MANILA": "TIMEZONES.MANILA" as "TIMEZONES.MANILA",
        "MARQUESAS": "TIMEZONES.MARQUESAS" as "TIMEZONES.MARQUESAS",
        "MAURITIUS": "TIMEZONES.MAURITIUS" as "TIMEZONES.MAURITIUS",
        "MELBOURNE": "TIMEZONES.MELBOURNE" as "TIMEZONES.MELBOURNE",
        "MEXICO_CITY": "TIMEZONES.MEXICO_CITY" as "TIMEZONES.MEXICO_CITY",
        "MINSK": "TIMEZONES.MINSK" as "TIMEZONES.MINSK",
        "MIQUELON": "TIMEZONES.MIQUELON" as "TIMEZONES.MIQUELON",
        "MONTEVIDEO": "TIMEZONES.MONTEVIDEO" as "TIMEZONES.MONTEVIDEO",
        "MOSCOW": "TIMEZONES.MOSCOW" as "TIMEZONES.MOSCOW",
        "NAIROBI": "TIMEZONES.NAIROBI" as "TIMEZONES.NAIROBI",
        "NEWFOUNDLAND": "TIMEZONES.NEWFOUNDLAND" as "TIMEZONES.NEWFOUNDLAND",
        "NEW_YORK": "TIMEZONES.NEW_YORK" as "TIMEZONES.NEW_YORK",
        "NORFOLK": "TIMEZONES.NORFOLK" as "TIMEZONES.NORFOLK",
        "NORONHA": "TIMEZONES.NORONHA" as "TIMEZONES.NORONHA",
        "NOVOSIBIRSK": "TIMEZONES.NOVOSIBIRSK" as "TIMEZONES.NOVOSIBIRSK",
        "OMSK": "TIMEZONES.OMSK" as "TIMEZONES.OMSK",
        "PAGO_PAGO": "TIMEZONES.PAGO_PAGO" as "TIMEZONES.PAGO_PAGO",
        "PARIS": "TIMEZONES.PARIS" as "TIMEZONES.PARIS",
        "PERTH": "TIMEZONES.PERTH" as "TIMEZONES.PERTH",
        "PHOENIX": "TIMEZONES.PHOENIX" as "TIMEZONES.PHOENIX",
        "PITCAIRN": "TIMEZONES.PITCAIRN" as "TIMEZONES.PITCAIRN",
        "PORT_AU_PRINCE": "TIMEZONES.PORT_AU_PRINCE" as "TIMEZONES.PORT_AU_PRINCE",
        "PORT_MORESBY": "TIMEZONES.PORT_MORESBY" as "TIMEZONES.PORT_MORESBY",
        "PUNTA_ARENAS": "TIMEZONES.PUNTA_ARENAS" as "TIMEZONES.PUNTA_ARENAS",
        "PYONGYANG": "TIMEZONES.PYONGYANG" as "TIMEZONES.PYONGYANG",
        "QYZYLORDA": "TIMEZONES.QYZYLORDA" as "TIMEZONES.QYZYLORDA",
        "RANGOON": "TIMEZONES.RANGOON" as "TIMEZONES.RANGOON",
        "REGINA": "TIMEZONES.REGINA" as "TIMEZONES.REGINA",
        "REYKJAVIK": "TIMEZONES.REYKJAVIK" as "TIMEZONES.REYKJAVIK",
        "RIYADH": "TIMEZONES.RIYADH" as "TIMEZONES.RIYADH",
        "SAKHALIN": "TIMEZONES.SAKHALIN" as "TIMEZONES.SAKHALIN",
        "SAMARA": "TIMEZONES.SAMARA" as "TIMEZONES.SAMARA",
        "SANTIAGO": "TIMEZONES.SANTIAGO" as "TIMEZONES.SANTIAGO",
        "SAO_PAULO": "TIMEZONES.SAO_PAULO" as "TIMEZONES.SAO_PAULO",
        "SAO_TOME": "TIMEZONES.SAO_TOME" as "TIMEZONES.SAO_TOME",
        "SARATOV": "TIMEZONES.SARATOV" as "TIMEZONES.SARATOV",
        "SEOUL": "TIMEZONES.SEOUL" as "TIMEZONES.SEOUL",
        "SHANGHAI": "TIMEZONES.SHANGHAI" as "TIMEZONES.SHANGHAI",
        "SINGAPORE": "TIMEZONES.SINGAPORE" as "TIMEZONES.SINGAPORE",
        "SREDNEKOLYMSK": "TIMEZONES.SREDNEKOLYMSK" as "TIMEZONES.SREDNEKOLYMSK",
        "ST_JOHNS": "TIMEZONES.ST_JOHNS" as "TIMEZONES.ST_JOHNS",
        "SYDNEY": "TIMEZONES.SYDNEY" as "TIMEZONES.SYDNEY",
        "TAIPEI": "TIMEZONES.TAIPEI" as "TIMEZONES.TAIPEI",
        "TARAWA": "TIMEZONES.TARAWA" as "TIMEZONES.TARAWA",
        "TASHKENT": "TIMEZONES.TASHKENT" as "TIMEZONES.TASHKENT",
        "TBILISI": "TIMEZONES.TBILISI" as "TIMEZONES.TBILISI",
        "TEHRAN": "TIMEZONES.TEHRAN" as "TIMEZONES.TEHRAN",
        "TIJUANA": "TIMEZONES.TIJUANA" as "TIMEZONES.TIJUANA",
        "TOKYO": "TIMEZONES.TOKYO" as "TIMEZONES.TOKYO",
        "TOMSK": "TIMEZONES.TOMSK" as "TIMEZONES.TOMSK",
        "TONGATAPU": "TIMEZONES.TONGATAPU" as "TIMEZONES.TONGATAPU",
        "TORONTO": "TIMEZONES.TORONTO" as "TIMEZONES.TORONTO",
        "TRIPOLI": "TIMEZONES.TRIPOLI" as "TIMEZONES.TRIPOLI",
        "ULAANBAATAR": "TIMEZONES.ULAANBAATAR" as "TIMEZONES.ULAANBAATAR",
        "VANCOUVER": "TIMEZONES.VANCOUVER" as "TIMEZONES.VANCOUVER",
        "VLADIVOSTOK": "TIMEZONES.VLADIVOSTOK" as "TIMEZONES.VLADIVOSTOK",
        "VOLGOGRAD": "TIMEZONES.VOLGOGRAD" as "TIMEZONES.VOLGOGRAD",
        "WARSAW": "TIMEZONES.WARSAW" as "TIMEZONES.WARSAW",
        "WHITEHORSE": "TIMEZONES.WHITEHORSE" as "TIMEZONES.WHITEHORSE",
        "WINDHOEK": "TIMEZONES.WINDHOEK" as "TIMEZONES.WINDHOEK",
        "WINNIPEG": "TIMEZONES.WINNIPEG" as "TIMEZONES.WINNIPEG",
        "YAKUTSK": "TIMEZONES.YAKUTSK" as "TIMEZONES.YAKUTSK",
        "YEKATERINBURG": "TIMEZONES.YEKATERINBURG" as "TIMEZONES.YEKATERINBURG",
        "YEREVAN": "TIMEZONES.YEREVAN" as "TIMEZONES.YEREVAN"
    },
    "USER": {
        "BULK_DELETE_MODAL": {
            "CONFIRM_TEXT": "USER.BULK_DELETE_MODAL.CONFIRM_TEXT" as "USER.BULK_DELETE_MODAL.CONFIRM_TEXT",
            "HAS_ERRORS_MESSAGE": "USER.BULK_DELETE_MODAL.HAS_ERRORS_MESSAGE" as "USER.BULK_DELETE_MODAL.HAS_ERRORS_MESSAGE",
            "MESSAGE": "USER.BULK_DELETE_MODAL.MESSAGE" as "USER.BULK_DELETE_MODAL.MESSAGE",
            "MESSAGE_plural": "USER.BULK_DELETE_MODAL.MESSAGE_plural" as "USER.BULK_DELETE_MODAL.MESSAGE_plural",
            "SUBMIT_BUTTON": "USER.BULK_DELETE_MODAL.SUBMIT_BUTTON" as "USER.BULK_DELETE_MODAL.SUBMIT_BUTTON",
            "SUBMIT_BUTTON_plural": "USER.BULK_DELETE_MODAL.SUBMIT_BUTTON_plural" as "USER.BULK_DELETE_MODAL.SUBMIT_BUTTON_plural",
            "TITLE": "USER.BULK_DELETE_MODAL.TITLE" as "USER.BULK_DELETE_MODAL.TITLE",
            "TITLE_plural": "USER.BULK_DELETE_MODAL.TITLE_plural" as "USER.BULK_DELETE_MODAL.TITLE_plural",
            "TOASTS": {
                "ERROR": "USER.BULK_DELETE_MODAL.TOASTS.ERROR" as "USER.BULK_DELETE_MODAL.TOASTS.ERROR",
                "SUCCESS": "USER.BULK_DELETE_MODAL.TOASTS.SUCCESS" as "USER.BULK_DELETE_MODAL.TOASTS.SUCCESS"
            }
        },
        "BULK_RESET_PASSWORDS_MODAL": {
            "BUTTON_SEND_BOTH": "USER.BULK_RESET_PASSWORDS_MODAL.BUTTON_SEND_BOTH" as "USER.BULK_RESET_PASSWORDS_MODAL.BUTTON_SEND_BOTH",
            "BUTTON_SEND_PASSWORD_RESETS": "USER.BULK_RESET_PASSWORDS_MODAL.BUTTON_SEND_PASSWORD_RESETS" as "USER.BULK_RESET_PASSWORDS_MODAL.BUTTON_SEND_PASSWORD_RESETS",
            "BUTTON_SEND_USER_INVITES": "USER.BULK_RESET_PASSWORDS_MODAL.BUTTON_SEND_USER_INVITES" as "USER.BULK_RESET_PASSWORDS_MODAL.BUTTON_SEND_USER_INVITES",
            "CONFIRM_RESEND_INVITE": "USER.BULK_RESET_PASSWORDS_MODAL.CONFIRM_RESEND_INVITE" as "USER.BULK_RESET_PASSWORDS_MODAL.CONFIRM_RESEND_INVITE",
            "CONFIRM_SEND_PASSWORD_RESET": "USER.BULK_RESET_PASSWORDS_MODAL.CONFIRM_SEND_PASSWORD_RESET" as "USER.BULK_RESET_PASSWORDS_MODAL.CONFIRM_SEND_PASSWORD_RESET",
            "DESCRIPTION": "USER.BULK_RESET_PASSWORDS_MODAL.DESCRIPTION" as "USER.BULK_RESET_PASSWORDS_MODAL.DESCRIPTION",
            "FETCH_USER_ERROR_MESSAGE": "USER.BULK_RESET_PASSWORDS_MODAL.FETCH_USER_ERROR_MESSAGE" as "USER.BULK_RESET_PASSWORDS_MODAL.FETCH_USER_ERROR_MESSAGE",
            "NOTIFY_PARTIAL_ERROR": "USER.BULK_RESET_PASSWORDS_MODAL.NOTIFY_PARTIAL_ERROR" as "USER.BULK_RESET_PASSWORDS_MODAL.NOTIFY_PARTIAL_ERROR",
            "NOTIFY_SEND_BOTH_SUCCESS": "USER.BULK_RESET_PASSWORDS_MODAL.NOTIFY_SEND_BOTH_SUCCESS" as "USER.BULK_RESET_PASSWORDS_MODAL.NOTIFY_SEND_BOTH_SUCCESS",
            "NOTIFY_SEND_PASSWORD_RESETS_SUCCESS": "USER.BULK_RESET_PASSWORDS_MODAL.NOTIFY_SEND_PASSWORD_RESETS_SUCCESS" as "USER.BULK_RESET_PASSWORDS_MODAL.NOTIFY_SEND_PASSWORD_RESETS_SUCCESS",
            "NOTIFY_SEND_USER_INVITES_SUCCESS": "USER.BULK_RESET_PASSWORDS_MODAL.NOTIFY_SEND_USER_INVITES_SUCCESS" as "USER.BULK_RESET_PASSWORDS_MODAL.NOTIFY_SEND_USER_INVITES_SUCCESS",
            "RESEND_USER_INVITES_TITLE": "USER.BULK_RESET_PASSWORDS_MODAL.RESEND_USER_INVITES_TITLE" as "USER.BULK_RESET_PASSWORDS_MODAL.RESEND_USER_INVITES_TITLE",
            "TITLE": "USER.BULK_RESET_PASSWORDS_MODAL.TITLE" as "USER.BULK_RESET_PASSWORDS_MODAL.TITLE",
            "USERS_WITHOUT_ACCEPTED_INVITE_MESSAGE": "USER.BULK_RESET_PASSWORDS_MODAL.USERS_WITHOUT_ACCEPTED_INVITE_MESSAGE" as "USER.BULK_RESET_PASSWORDS_MODAL.USERS_WITHOUT_ACCEPTED_INVITE_MESSAGE"
        },
        "BULK_UPDATE_LOCATIONS_MODAL": {
            "ADD_LOCATIONS_COUNT_TEXT": "USER.BULK_UPDATE_LOCATIONS_MODAL.ADD_LOCATIONS_COUNT_TEXT" as "USER.BULK_UPDATE_LOCATIONS_MODAL.ADD_LOCATIONS_COUNT_TEXT",
            "ADD_LOCATIONS_COUNT_TOOLTIP": "USER.BULK_UPDATE_LOCATIONS_MODAL.ADD_LOCATIONS_COUNT_TOOLTIP" as "USER.BULK_UPDATE_LOCATIONS_MODAL.ADD_LOCATIONS_COUNT_TOOLTIP",
            "CONFIRM_TEXT": "USER.BULK_UPDATE_LOCATIONS_MODAL.CONFIRM_TEXT" as "USER.BULK_UPDATE_LOCATIONS_MODAL.CONFIRM_TEXT",
            "CONFIRM_TITLE": "USER.BULK_UPDATE_LOCATIONS_MODAL.CONFIRM_TITLE" as "USER.BULK_UPDATE_LOCATIONS_MODAL.CONFIRM_TITLE",
            "HAS_ERRORS_MESSAGE": "USER.BULK_UPDATE_LOCATIONS_MODAL.HAS_ERRORS_MESSAGE" as "USER.BULK_UPDATE_LOCATIONS_MODAL.HAS_ERRORS_MESSAGE",
            "MESSAGE": "USER.BULK_UPDATE_LOCATIONS_MODAL.MESSAGE" as "USER.BULK_UPDATE_LOCATIONS_MODAL.MESSAGE",
            "REMOVE_LOCATIONS_COUNT_TEXT": "USER.BULK_UPDATE_LOCATIONS_MODAL.REMOVE_LOCATIONS_COUNT_TEXT" as "USER.BULK_UPDATE_LOCATIONS_MODAL.REMOVE_LOCATIONS_COUNT_TEXT",
            "REMOVE_LOCATIONS_COUNT_TOOLTIP": "USER.BULK_UPDATE_LOCATIONS_MODAL.REMOVE_LOCATIONS_COUNT_TOOLTIP" as "USER.BULK_UPDATE_LOCATIONS_MODAL.REMOVE_LOCATIONS_COUNT_TOOLTIP",
            "SUBMIT_BUTTON": "USER.BULK_UPDATE_LOCATIONS_MODAL.SUBMIT_BUTTON" as "USER.BULK_UPDATE_LOCATIONS_MODAL.SUBMIT_BUTTON",
            "TITLE": "USER.BULK_UPDATE_LOCATIONS_MODAL.TITLE" as "USER.BULK_UPDATE_LOCATIONS_MODAL.TITLE",
            "TOASTS": {
                "ERROR": "USER.BULK_UPDATE_LOCATIONS_MODAL.TOASTS.ERROR" as "USER.BULK_UPDATE_LOCATIONS_MODAL.TOASTS.ERROR",
                "SUCCESS": "USER.BULK_UPDATE_LOCATIONS_MODAL.TOASTS.SUCCESS" as "USER.BULK_UPDATE_LOCATIONS_MODAL.TOASTS.SUCCESS"
            }
        },
        "BULK_UPDATE_ROLES_MODAL": {
            "ADD_ROLES_COUNT_TEXT": "USER.BULK_UPDATE_ROLES_MODAL.ADD_ROLES_COUNT_TEXT" as "USER.BULK_UPDATE_ROLES_MODAL.ADD_ROLES_COUNT_TEXT",
            "ADD_ROLES_COUNT_TEXT_plural": "USER.BULK_UPDATE_ROLES_MODAL.ADD_ROLES_COUNT_TEXT_plural" as "USER.BULK_UPDATE_ROLES_MODAL.ADD_ROLES_COUNT_TEXT_plural",
            "ADD_ROLES_COUNT_TOOLTIP": "USER.BULK_UPDATE_ROLES_MODAL.ADD_ROLES_COUNT_TOOLTIP" as "USER.BULK_UPDATE_ROLES_MODAL.ADD_ROLES_COUNT_TOOLTIP",
            "ADD_ROLES_COUNT_TOOLTIP_plural": "USER.BULK_UPDATE_ROLES_MODAL.ADD_ROLES_COUNT_TOOLTIP_plural" as "USER.BULK_UPDATE_ROLES_MODAL.ADD_ROLES_COUNT_TOOLTIP_plural",
            "CONFIRM_TEXT": "USER.BULK_UPDATE_ROLES_MODAL.CONFIRM_TEXT" as "USER.BULK_UPDATE_ROLES_MODAL.CONFIRM_TEXT",
            "CONFIRM_TITLE": "USER.BULK_UPDATE_ROLES_MODAL.CONFIRM_TITLE" as "USER.BULK_UPDATE_ROLES_MODAL.CONFIRM_TITLE",
            "EXISTING_TITLE": "USER.BULK_UPDATE_ROLES_MODAL.EXISTING_TITLE" as "USER.BULK_UPDATE_ROLES_MODAL.EXISTING_TITLE",
            "HAS_ERRORS_MESSAGE": "USER.BULK_UPDATE_ROLES_MODAL.HAS_ERRORS_MESSAGE" as "USER.BULK_UPDATE_ROLES_MODAL.HAS_ERRORS_MESSAGE",
            "MESSAGE": "USER.BULK_UPDATE_ROLES_MODAL.MESSAGE" as "USER.BULK_UPDATE_ROLES_MODAL.MESSAGE",
            "NEW_ROLE_TOOLTIP": "USER.BULK_UPDATE_ROLES_MODAL.NEW_ROLE_TOOLTIP" as "USER.BULK_UPDATE_ROLES_MODAL.NEW_ROLE_TOOLTIP",
            "NEW_TITLE": "USER.BULK_UPDATE_ROLES_MODAL.NEW_TITLE" as "USER.BULK_UPDATE_ROLES_MODAL.NEW_TITLE",
            "PARTIAL_EXISTING_ROLE_TOOLTIP": "USER.BULK_UPDATE_ROLES_MODAL.PARTIAL_EXISTING_ROLE_TOOLTIP" as "USER.BULK_UPDATE_ROLES_MODAL.PARTIAL_EXISTING_ROLE_TOOLTIP",
            "REMOVED_TITLE": "USER.BULK_UPDATE_ROLES_MODAL.REMOVED_TITLE" as "USER.BULK_UPDATE_ROLES_MODAL.REMOVED_TITLE",
            "REMOVE_ROLES_COUNT_TEXT": "USER.BULK_UPDATE_ROLES_MODAL.REMOVE_ROLES_COUNT_TEXT" as "USER.BULK_UPDATE_ROLES_MODAL.REMOVE_ROLES_COUNT_TEXT",
            "REMOVE_ROLES_COUNT_TEXT_plural": "USER.BULK_UPDATE_ROLES_MODAL.REMOVE_ROLES_COUNT_TEXT_plural" as "USER.BULK_UPDATE_ROLES_MODAL.REMOVE_ROLES_COUNT_TEXT_plural",
            "REMOVE_ROLES_COUNT_TOOLTIP": "USER.BULK_UPDATE_ROLES_MODAL.REMOVE_ROLES_COUNT_TOOLTIP" as "USER.BULK_UPDATE_ROLES_MODAL.REMOVE_ROLES_COUNT_TOOLTIP",
            "REMOVE_ROLES_COUNT_TOOLTIP_plural": "USER.BULK_UPDATE_ROLES_MODAL.REMOVE_ROLES_COUNT_TOOLTIP_plural" as "USER.BULK_UPDATE_ROLES_MODAL.REMOVE_ROLES_COUNT_TOOLTIP_plural",
            "ROLE_LIST_TITLE": "USER.BULK_UPDATE_ROLES_MODAL.ROLE_LIST_TITLE" as "USER.BULK_UPDATE_ROLES_MODAL.ROLE_LIST_TITLE",
            "SELECTED_ROLES_LIST_TITLE": "USER.BULK_UPDATE_ROLES_MODAL.SELECTED_ROLES_LIST_TITLE" as "USER.BULK_UPDATE_ROLES_MODAL.SELECTED_ROLES_LIST_TITLE",
            "SUBMIT_BUTTON": "USER.BULK_UPDATE_ROLES_MODAL.SUBMIT_BUTTON" as "USER.BULK_UPDATE_ROLES_MODAL.SUBMIT_BUTTON",
            "TITLE": "USER.BULK_UPDATE_ROLES_MODAL.TITLE" as "USER.BULK_UPDATE_ROLES_MODAL.TITLE",
            "TOASTS": {
                "ERROR": "USER.BULK_UPDATE_ROLES_MODAL.TOASTS.ERROR" as "USER.BULK_UPDATE_ROLES_MODAL.TOASTS.ERROR",
                "SUCCESS": "USER.BULK_UPDATE_ROLES_MODAL.TOASTS.SUCCESS" as "USER.BULK_UPDATE_ROLES_MODAL.TOASTS.SUCCESS"
            }
        },
        "EDIT_USER_DETAILS": {
            "ADD_NOTIFICATIONS": "USER.EDIT_USER_DETAILS.ADD_NOTIFICATIONS" as "USER.EDIT_USER_DETAILS.ADD_NOTIFICATIONS",
            "ADD_ROLE": "USER.EDIT_USER_DETAILS.ADD_ROLE" as "USER.EDIT_USER_DETAILS.ADD_ROLE",
            "CONFIRM_DELETE_USER": "USER.EDIT_USER_DETAILS.CONFIRM_DELETE_USER" as "USER.EDIT_USER_DETAILS.CONFIRM_DELETE_USER",
            "HEADERS": {
                "ASSIGNED_LOCATIONS": "USER.EDIT_USER_DETAILS.HEADERS.ASSIGNED_LOCATIONS" as "USER.EDIT_USER_DETAILS.HEADERS.ASSIGNED_LOCATIONS",
                "GUIDED_TOUR": "USER.EDIT_USER_DETAILS.HEADERS.GUIDED_TOUR" as "USER.EDIT_USER_DETAILS.HEADERS.GUIDED_TOUR",
                "NOTIFICATIONS": "USER.EDIT_USER_DETAILS.HEADERS.NOTIFICATIONS" as "USER.EDIT_USER_DETAILS.HEADERS.NOTIFICATIONS",
                "ROLES": "USER.EDIT_USER_DETAILS.HEADERS.ROLES" as "USER.EDIT_USER_DETAILS.HEADERS.ROLES",
                "USER_DETAILS": "USER.EDIT_USER_DETAILS.HEADERS.USER_DETAILS" as "USER.EDIT_USER_DETAILS.HEADERS.USER_DETAILS"
            },
            "NOTIFY_DELETE_USER_SUCCESS": "USER.EDIT_USER_DETAILS.NOTIFY_DELETE_USER_SUCCESS" as "USER.EDIT_USER_DETAILS.NOTIFY_DELETE_USER_SUCCESS",
            "NOTIFY_SEND_PASSWORD_RESET_SUCCESS": "USER.EDIT_USER_DETAILS.NOTIFY_SEND_PASSWORD_RESET_SUCCESS" as "USER.EDIT_USER_DETAILS.NOTIFY_SEND_PASSWORD_RESET_SUCCESS",
            "NOTIFY_UPDATE_USER_DETAILS_SUCCESS": "USER.EDIT_USER_DETAILS.NOTIFY_UPDATE_USER_DETAILS_SUCCESS" as "USER.EDIT_USER_DETAILS.NOTIFY_UPDATE_USER_DETAILS_SUCCESS",
            "SAVE_ASSIGNED_LOCATIONS": "USER.EDIT_USER_DETAILS.SAVE_ASSIGNED_LOCATIONS" as "USER.EDIT_USER_DETAILS.SAVE_ASSIGNED_LOCATIONS",
            "SAVE_USER_DETAILS": "USER.EDIT_USER_DETAILS.SAVE_USER_DETAILS" as "USER.EDIT_USER_DETAILS.SAVE_USER_DETAILS",
            "SELECT_OPTIONS": {
                "DELETE_USER": "USER.EDIT_USER_DETAILS.SELECT_OPTIONS.DELETE_USER" as "USER.EDIT_USER_DETAILS.SELECT_OPTIONS.DELETE_USER",
                "PLACEHOLDER": "USER.EDIT_USER_DETAILS.SELECT_OPTIONS.PLACEHOLDER" as "USER.EDIT_USER_DETAILS.SELECT_OPTIONS.PLACEHOLDER",
                "SEND_PASSWORD_RESET_EMAIL": "USER.EDIT_USER_DETAILS.SELECT_OPTIONS.SEND_PASSWORD_RESET_EMAIL" as "USER.EDIT_USER_DETAILS.SELECT_OPTIONS.SEND_PASSWORD_RESET_EMAIL"
            }
        },
        "USERS_LOCATIONS_BOX": {
            "EXISTING_LOCATIONS_TITLE": "USER.USERS_LOCATIONS_BOX.EXISTING_LOCATIONS_TITLE" as "USER.USERS_LOCATIONS_BOX.EXISTING_LOCATIONS_TITLE",
            "NEW_LOCATIONS_TITLE": "USER.USERS_LOCATIONS_BOX.NEW_LOCATIONS_TITLE" as "USER.USERS_LOCATIONS_BOX.NEW_LOCATIONS_TITLE",
            "REMOVED_LOCATIONS_TITLE": "USER.USERS_LOCATIONS_BOX.REMOVED_LOCATIONS_TITLE" as "USER.USERS_LOCATIONS_BOX.REMOVED_LOCATIONS_TITLE",
            "RIGHT_TITLE": "USER.USERS_LOCATIONS_BOX.RIGHT_TITLE" as "USER.USERS_LOCATIONS_BOX.RIGHT_TITLE"
        }
    }
};

export type SegmentKeys = typeof KEYS;

export type SegmentKey =
    'ACCOUNT.ACCOUNT_ALREADY_EXISTS' |
    'ACCOUNT.CREATE_ACCOUNT' |
    'ACCOUNT.DETAILS.ACCOUNT_DETAILS_UPDATED' |
    'ACCOUNT.DETAILS.ADDRESS_LINE_ONE' |
    'ACCOUNT.DETAILS.ADDRESS_LINE_THREE' |
    'ACCOUNT.DETAILS.ADDRESS_LINE_TWO' |
    'ACCOUNT.DETAILS.ATTENTION_TO' |
    'ACCOUNT.DETAILS.BILLING_DETAILS' |
    'ACCOUNT.DETAILS.COMPANY_NAME' |
    'ACCOUNT.DETAILS.CONTACT_DETAILS' |
    'ACCOUNT.DETAILS.COUNTRY' |
    'ACCOUNT.DETAILS.DISPLAY_ADDRESS' |
    'ACCOUNT.DETAILS.FAILED_TO_UPDATE_ACCOUNT_DETAILS' |
    'ACCOUNT.DETAILS.IMAGE_MUST_BE_SQUARE_AND_AT_LEAST_MINIMUM_SIZE' |
    'ACCOUNT.DETAILS.LOCATION_DETAILS' |
    'ACCOUNT.DETAILS.LOCATION_DETAILS_SAVED' |
    'ACCOUNT.DETAILS.LOCATION_EMAIL' |
    'ACCOUNT.DETAILS.LOCATION_LOGO' |
    'ACCOUNT.DETAILS.LOCATION_PHONE_NUMBER' |
    'ACCOUNT.DETAILS.MINIMUM_IMAGE_DIMENSION_REQUIREMENT' |
    'ACCOUNT.DETAILS.NOTES' |
    'ACCOUNT.DETAILS.PHONE' |
    'ACCOUNT.DETAILS.POSTCODE' |
    'ACCOUNT.DETAILS.PREFERRED_MEETING_TIMES' |
    'ACCOUNT.DETAILS.SAME_AS_CONTACT_DETAILS' |
    'ACCOUNT.DETAILS.SHIPPING_ADDRESS' |
    'ACCOUNT.DETAILS.SQUARE_ASPECT_RATIO_REQUIRED' |
    'ACCOUNT.DETAILS.STATE' |
    'ACCOUNT.DETAILS.SUBURB' |
    'ACCOUNT.DETAILS.WEBSITE_URL' |
    'ACCOUNT.LOCATION_DETAILS.CREATE_MAP_LOCATION' |
    'ACCOUNT.LOCATION_DETAILS.GET_LOCATION_DETAILS' |
    'ACCOUNT.LOCATION_DETAILS.REMOVE_LOCATION_MAP' |
    'ACCOUNT.LOCATION_DETAILS.SHIPPING_DETAILS_UPDATED' |
    'ACCOUNT.LOCATION_DETAILS.START_MAP_PAYMENT' |
    'ACCOUNT.LOCATION_DETAILS.UPDATE_LOCATION_DETAILS' |
    'ACCOUNT.LOCATION_DETAILS.UPDATE_SHIPPING_DETAILS' |
    'ACCOUNT.MAP.CONFIRM_PAYMENT_DETAILS' |
    'ACCOUNT.MAP.CREATE_NEW_MAP' |
    'ACCOUNT.MAP.CREATE_NEW_MAP_FOR' |
    'ACCOUNT.MAP.EDIT_MAP' |
    'ACCOUNT.MAP.GET_MAP_SERVICE_COST' |
    'ACCOUNT.MAP.MAP_GENERATION_FAILED' |
    'ACCOUNT.MAP.MAP_GENERATION_INPROGRESS' |
    'ACCOUNT.MAP.PAYMENT_INFORMATION.PART_1' |
    'ACCOUNT.MAP.PAYMENT_INFORMATION.PART_2' |
    'ACCOUNT.MAP.PROBLEM_RETRIEVING_COST' |
    'ACCOUNT.MAP.SEARCH_FOR_ADDRESS' |
    'ACCOUNT.MAP.UNSUPPORTED_CURRENCY' |
    'ACCOUNT.NOTIFY_UNAUTHENTICATED' |
    'ACCOUNT.NOTIFY_UNAUTHORIZED' |
    'ADMIN.BANNER.BANNER_MESSAGE' |
    'ADMIN.BANNER.BANNER_NOTIFICATION' |
    'ADMIN.BANNER.CREATE_BANNER_NOTIFICATION' |
    'ADMIN.BANNER.DELETE_CURRENT_BANNER_NOTIFICATION' |
    'ADMIN.BANNER.DISMISSABLE' |
    'ADMIN.BANNER.GET_CURRENT_BANNER_NOTIFICATION' |
    'ADMIN.BANNER.NOTIFICATION_TYPE' |
    'ADMIN.BANNER.NOTIFY_CREATED' |
    'ADMIN.BANNER.NOTIFY_DELETED' |
    'ADMIN.BANNER.TIP' |
    'ADMIN.BRANDS.ASSIGN' |
    'ADMIN.BRANDS.ASSIGN_BRAND' |
    'ADMIN.BRANDS.ASSIGN_CLIENTS' |
    'ADMIN.BRANDS.ASSIGN_CLIENTS_TO' |
    'ADMIN.BRANDS.BRAND' |
    'ADMIN.BRANDS.BRANDS' |
    'ADMIN.BRANDS.BRAND_COLOR' |
    'ADMIN.BRANDS.BRAND_NAME' |
    'ADMIN.BRANDS.CANNOT_ASSIGN_CLIENT_IF' |
    'ADMIN.BRANDS.CHECK_CLIENTS_TO_ASSIGN_TO' |
    'ADMIN.BRANDS.FILTER_BRANDS' |
    'ADMIN.BRANDS.FILTER_CLIENTS' |
    'ADMIN.BRANDS.NEW_BRAND' |
    'ADMIN.BRANDS.PLEASE_ENTER_NAME_COLOR_LOGO' |
    'ADMIN.BRANDS.THIS_WILL_PERMANENTLY_DELETE' |
    'ADMIN.BRANDS.UPDATE_BRAND' |
    'ADMIN.BRANDS.UPLOAD_LOGO' |
    'ADMIN.BRANDS.YOU_CAN_ASSIGN_CLIENTS_FROM' |
    'ADMIN.CLUBREADY_CONNECT.ACTION' |
    'ADMIN.CLUBREADY_CONNECT.CHAIN_ID_CONFIGURATION_TITLE' |
    'ADMIN.CLUBREADY_CONNECT.CLIENT_TITLE' |
    'ADMIN.CLUBREADY_CONNECT.CLUBREADY_DISABLED_FOR_CLIENT_HELP_TEXT' |
    'ADMIN.CLUBREADY_CONNECT.FILTER_CLIENTS' |
    'ADMIN.CLUBREADY_CONNECT.NO_INTEGRATION_FOUND_FOR_CLIENT' |
    'ADMIN.EXTERNAL_AUTH_APPS.API_KEY' |
    'ADMIN.EXTERNAL_AUTH_APPS.APP_NAME' |
    'ADMIN.EXTERNAL_AUTH_APPS.CONFIRM_DELETE' |
    'ADMIN.EXTERNAL_AUTH_APPS.CONNECTIONS' |
    'ADMIN.EXTERNAL_AUTH_APPS.CONTACT_EMAIL' |
    'ADMIN.EXTERNAL_AUTH_APPS.CREATE_AUTH_APP' |
    'ADMIN.EXTERNAL_AUTH_APPS.DELETE_APP' |
    'ADMIN.EXTERNAL_AUTH_APPS.DELETE_APP_DISCLAIMER' |
    'ADMIN.EXTERNAL_AUTH_APPS.DELETE_CONNECTION' |
    'ADMIN.EXTERNAL_AUTH_APPS.DETAILS.DS_USER' |
    'ADMIN.EXTERNAL_AUTH_APPS.DETAILS.EXTERNAL_USER_IDENTIFIER' |
    'ADMIN.EXTERNAL_AUTH_APPS.DETAILS.NO_APP_CONNECTIONS' |
    'ADMIN.EXTERNAL_AUTH_APPS.SECRET' |
    'ADMIN.EXTERNAL_AUTH_APPS.SECRET_EDIT_WARNING' |
    'ADMIN.EXTERNAL_AUTH_APPS.SECRET_TOOLTIP' |
    'ADMIN.EXTERNAL_AUTH_APPS.TITLE' |
    'ADMIN.EXTERNAL_AUTH_APPS.TOKEN_ENDPOINT' |
    'ADMIN.EXTERNAL_AUTH_APPS.TOKEN_ENDPOINT_TOOLTIP' |
    'ADMIN.EXTERNAL_AUTH_APPS.UPDATE_AUTH_APP' |
    'ADMIN.MAINTENANCE.DATE' |
    'ADMIN.MAINTENANCE.EXPECTED_DOWNTIME' |
    'ADMIN.MAINTENANCE.EXPECTED_DOWNTIME_MUST_BE_AT_LEAST_ZERO' |
    'ADMIN.MAINTENANCE.MAINTENANCE_WINDOW' |
    'ADMIN.MAINTENANCE.MINUTES' |
    'ADMIN.MAINTENANCE.NOTIFY_MAINTENANCE_REMOVED' |
    'ADMIN.MAINTENANCE.NOTIFY_MAINTENANCE_UPDATED' |
    'ADMIN.MAINTENANCE.REMOVE_MAINTENANCE_CONFIRM' |
    'ADMIN.MAINTENANCE.START_DATE_IS_REQUIRED' |
    'ADMIN.MAINTENANCE.START_DATE_MUST_BE_IN_THE_FUTURE' |
    'ADMIN.MAINTENANCE.START_TIME' |
    'ADMIN.MAINTENANCE.START_TIME_MUST_BE_IN_THE_FUTURE' |
    'ADMIN.MAPS_REPORT.AMOUNT_PAID' |
    'ADMIN.MAPS_REPORT.CLIENT_NAME' |
    'ADMIN.MAPS_REPORT.HEADING' |
    'ADMIN.MAPS_REPORT.LOCATION_NAME' |
    'ADMIN.MAPS_REPORT.PURCHASED_DATE' |
    'ADMIN.NAV.AGENCIES' |
    'ADMIN.NAV.AUTHENTICATION_APPS' |
    'ADMIN.NAV.BANNER_NOTIFICATION' |
    'ADMIN.NAV.BRANDS' |
    'ADMIN.NAV.CALENDAR_ITEMS' |
    'ADMIN.NAV.CLUBREADY_CONNECT' |
    'ADMIN.NAV.MAPS_REPORT' |
    'ADMIN.NAV.PAYABLE_SERVICES' |
    'ADMIN.NAV.PLATFORMS' |
    'ADMIN.NAV.SERVICING' |
    'ADMIN.NAV.SITE_MAINTENANCE' |
    'ADMIN.NAV.SUBSCRIPTIONS' |
    'ADMIN.NAV.TASKS' |
    'ADMIN.NAV.TEMPLATE_PREVIEWS' |
    'ADMIN.NOTIFY_GENERATE_LOCATION_MAP_STARTED' |
    'ADMIN.NOTIFY_PURGE_SESSIONS_STARTED' |
    'ADMIN.NOTIFY_TEST_IN_APP_NOTIFICATIONS_STARTED' |
    'ADMIN.NOTIFY_THUMBNAIL_GENERATION_STARTED' |
    'ADMIN.PAYABLE_SERVICE.CONFIRM_DELETE_COST' |
    'ADMIN.PAYABLE_SERVICE.COST_INVALID_PRECISION' |
    'ADMIN.PAYABLE_SERVICE.COST_MUST_BE_POSITIVE' |
    'ADMIN.PAYABLE_SERVICE.CREATE_SERVICE_COST' |
    'ADMIN.PAYABLE_SERVICE.DELETE_SERVICE_COST' |
    'ADMIN.PAYABLE_SERVICE.NOTIFY_SERVICE_COSTS_UPDATED' |
    'ADMIN.PAYABLE_SERVICE.UPDATE_SERVICE_COST' |
    'ADMIN.SERVICING.BLOCKED_PUBLISHES.SUBTITLE' |
    'ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.ACTIONS.MARK_FAILED' |
    'ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.ACTIONS.MARK_SUCCESSFUL' |
    'ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.ACTIONS.RETRY_NOW' |
    'ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.CONTENT_LABELS.EMAIL_HTML' |
    'ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.CONTENT_LABELS.RECIPIENTS' |
    'ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.CONTENT_LABELS.SUBJECT' |
    'ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.CONTENT_LABELS.TEMPLATE' |
    'ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.HEADERS.CONTENT' |
    'ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.HEADERS.SCHEDULED_FOR' |
    'ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.HEADERS.UPDATED_AT' |
    'ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.NOT_FOUND_MESSAGE' |
    'ADMIN.SERVICING.BLOCKED_PUBLISHES.TITLE' |
    'ADMIN.SERVICING.FAILED_PUBLISHES.SUBTITLE' |
    'ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.CONTENT_LABELS.EMAIL_HTML' |
    'ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.CONTENT_LABELS.RECIPIENTS' |
    'ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.CONTENT_LABELS.SUBJECT' |
    'ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.CONTENT_LABELS.TEMPLATE' |
    'ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.HEADERS.CONTENT' |
    'ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.HEADERS.FAILED_AT' |
    'ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.HEADERS.SCHEDULED_FOR' |
    'ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.NOT_FOUND_MESSAGE' |
    'ADMIN.SERVICING.FAILED_PUBLISHES.TITLE' |
    'ADMIN.SUBSCRIPTIONS.CLIENT_SUBSCRIPTION' |
    'ADMIN.SUBSCRIPTIONS.DEFAULT_SUBSCRIPTION' |
    'ADMIN.SUBSCRIPTIONS.DEFAULT_SUBSCRIPTION_UPDATED' |
    'ADMIN.SUBSCRIPTIONS.DEFAULT_SUB_FOR' |
    'ADMIN.SUBSCRIPTIONS.DELETE_RECURRING_CONFIRM' |
    'ADMIN.SUBSCRIPTIONS.LOCATION.CAN_BE_USED_TO_CANCEL' |
    'ADMIN.SUBSCRIPTIONS.LOCATION.DATE_GAP' |
    'ADMIN.SUBSCRIPTIONS.LOCATION.END_DATE_IS_EXCLUSIVE' |
    'ADMIN.SUBSCRIPTIONS.LOCATION.FUTURE' |
    'ADMIN.SUBSCRIPTIONS.LOCATION.INACTIVE' |
    'ADMIN.SUBSCRIPTIONS.LOCATION.INACTIVE_SUBSCRIPTION' |
    'ADMIN.SUBSCRIPTIONS.LOCATION.INITIAL_SUBSCRIPTION_FOR' |
    'ADMIN.SUBSCRIPTIONS.LOCATION.LEAVE_IT_BLANK' |
    'ADMIN.SUBSCRIPTIONS.LOCATION.LEGEND' |
    'ADMIN.SUBSCRIPTIONS.LOCATION.LOCATION_SUBSCRIPTION' |
    'ADMIN.SUBSCRIPTIONS.LOCATION.LOCATION_SUBSCRIPTION_RECURRING' |
    'ADMIN.SUBSCRIPTIONS.LOCATION.NEXT' |
    'ADMIN.SUBSCRIPTIONS.LOCATION.NOTIFY_RECURRING_PAYMENT_DELETED' |
    'ADMIN.SUBSCRIPTIONS.LOCATION.NO_RECURRING_PAYMENTS' |
    'ADMIN.SUBSCRIPTIONS.LOCATION.RECURRING_PAYMENT' |
    'ADMIN.SUBSCRIPTIONS.LOCATION.RECURRING_PAYMENT_SCHEDULE' |
    'ADMIN.SUBSCRIPTIONS.LOCATION.SAVE_RECURRING_PAYMENT' |
    'ADMIN.SUBSCRIPTIONS.LOCATION.SUBSCRIPTION_UPDATED' |
    'ADMIN.SUBSCRIPTIONS.LOCATION.THE_NEXT_DATE_IS_AFTER' |
    'ADMIN.SUBSCRIPTIONS.LOCATION.THIS_CAN_BE_USED_TEMP_DISCOUNT' |
    'ADMIN.SUBSCRIPTIONS.LOCATION.THIS_CAN_BE_USED_TO_SKIP_PAYMENT' |
    'ADMIN.SUBSCRIPTIONS.LOCATION.UPDATE_SUBSCRIPTION' |
    'ADMIN.SUBSCRIPTIONS.NOTIFY_RECURRING_PAYMENT_DELETED' |
    'ADMIN.SUBSCRIPTIONS.NOTIFY_RECURRING_PAYMENT_SAVED' |
    'ADMIN.SUBSCRIPTIONS.NOTIFY_SUBSCRIPTION_UPDATED' |
    'ADMIN.SUBSCRIPTIONS.NO_CLIENTS' |
    'ADMIN.SUBSCRIPTIONS.NO_LOCATIONS' |
    'ADMIN.SUBSCRIPTIONS.SUBSCRIPTION' |
    'ADMIN.SUBSCRIPTIONS.UPDATE_DEFAULT_SUBSCRIPTION' |
    'ADMIN.USERS.ADD_NEW_USER' |
    'AGENCIES.ADD_NEW_AGENCY' |
    'AGENCIES.AGENCY.CONFIRM_DELETE' |
    'AGENCIES.AGENCY.DELETED_CONFIRMATION_MESSAGE' |
    'AGENCIES.AGENCY.DELETE_AGENCY' |
    'AGENCIES.AGENCY.EDIT_AGENCY' |
    'AGENCIES.AGENCY.WHITELABEL_LOGO' |
    'AGENCIES.AGENCY_CREATED' |
    'AGENCIES.AGENCY_NAME' |
    'AGENCIES.AGENCY_NAME_REQUIRED' |
    'AGENCIES.AGENCY_UPDATED' |
    'AGENCIES.USER.ADD_AGENCY_USER' |
    'AGENCIES.USER.ADD_NEW_USER_TO' |
    'AGENCIES.USER.ADMIN' |
    'AGENCIES.USER.EDIT_AGENCY_USER' |
    'AGENCIES.USER.EDIT_USER' |
    'AGENCIES.USER.NO_USERS_ASSIGNED' |
    'AGENCIES.USER.REMOVE_USER' |
    'AGENCIES.USER.USER_ADDED_SUCCESS_MESSAGE' |
    'AGENCIES.USER.USER_REMOVED_SUCCESS_MESSAGE' |
    'AGENCIES.USER.USER_UPDATED_SUCCESS_MESSAGE' |
    'AGENCY.ASSIGN_TO_AGENCY_MANAGER.WARNING_BUTTON_LABEL' |
    'AGENCY.ASSIGN_TO_AGENCY_MANAGER.WARNING_MESSAGE' |
    'AGENCY.CLIENT.ACTIVITIES.ACTIVITY_ADDED' |
    'AGENCY.CLIENT.ACTIVITIES.ACTIVITY_ADDED_ERROR' |
    'AGENCY.CLIENT.ACTIVITIES.ACTIVITY_NAME_MUST_BE_UNIQUE' |
    'AGENCY.CLIENT.ACTIVITIES.ADD_ACTIVITY' |
    'AGENCY.CLIENT.ACTIVITIES.ADD_CHANNEL' |
    'AGENCY.CLIENT.ACTIVITIES.ADD_CHANNEL_ERROR' |
    'AGENCY.CLIENT.ACTIVITIES.ADD_PLATFORM' |
    'AGENCY.CLIENT.ACTIVITIES.ADD_PLATFORM_ERROR' |
    'AGENCY.CLIENT.ACTIVITIES.CHANNEL_NAME' |
    'AGENCY.CLIENT.ACTIVITIES.CHANNEL_NAME_MUST_BE_UNIQUE' |
    'AGENCY.CLIENT.ACTIVITIES.CHANNEL_TYPE' |
    'AGENCY.CLIENT.ACTIVITIES.DELETE_ACTIVITY' |
    'AGENCY.CLIENT.ACTIVITIES.DELETE_ACTIVITY_DESCRIPTION' |
    'AGENCY.CLIENT.ACTIVITIES.DELETE_ACTIVITY_ERROR' |
    'AGENCY.CLIENT.ACTIVITIES.DELETE_ACTIVITY_SUCCESS' |
    'AGENCY.CLIENT.ACTIVITIES.DELETE_CHANNEL' |
    'AGENCY.CLIENT.ACTIVITIES.DELETE_CHANNEL_DESCRIPTION' |
    'AGENCY.CLIENT.ACTIVITIES.DELETE_CHANNEL_ERROR' |
    'AGENCY.CLIENT.ACTIVITIES.DELETE_PLATFORM_DESCRIPTION' |
    'AGENCY.CLIENT.ACTIVITIES.LINKED_PLATFORM_OPTIONAL' |
    'AGENCY.CLIENT.ACTIVITIES.PLATFORM_NAME' |
    'AGENCY.CLIENT.ACTIVITIES.PLATFORM_TYPE' |
    'AGENCY.CLIENT.ACTIVITIES.REFRESH_DATA' |
    'AGENCY.CLIENT.ACTIVITIES.RETRIEVE_ACTIVITIES' |
    'AGENCY.CLIENT.ACTIVITIES.RETRIEVE_BUILDING_PLATFORMS' |
    'AGENCY.CLIENT.ACTIVITIES.SAVE_NEW_CHANNEL' |
    'AGENCY.CLIENT.ACTIVITIES.UPDATE_ACTIVITY_ORDER' |
    'AGENCY.CLIENT.BRAND_COLORS' |
    'AGENCY.CLIENT.BRAND_COLOURS.ADD_NEW_BRAND_COLOUR' |
    'AGENCY.CLIENT.BRAND_COLOURS.COLOUR' |
    'AGENCY.CLIENT.BRAND_COLOURS.CREATED_BRAND_COLOUR' |
    'AGENCY.CLIENT.BRAND_COLOURS.CREATE_NEW_BRAND_COLOUR' |
    'AGENCY.CLIENT.BRAND_COLOURS.DELETED_BRAND_COLOUR' |
    'AGENCY.CLIENT.BRAND_COLOURS.DELETE_BRAND_COLOUR' |
    'AGENCY.CLIENT.BRAND_COLOURS.DELETE_CONFIRMATION' |
    'AGENCY.CLIENT.BRAND_COLOURS.SUCCESSFULLY_ADDED_BRAND_COLOUR' |
    'AGENCY.CLIENT.BRAND_COLOURS.SUCCESSFULLY_RENAMED_BRAND_COLOUR' |
    'AGENCY.CLIENT.BRAND_COLOURS.SUCCESSFULLY_UPDATED_BRAND_COLOUR' |
    'AGENCY.CLIENT.BRAND_COLOURS.UPDATED_BRAND_COLOUR' |
    'AGENCY.CLIENT.BRAND_COLOURS.UPDATED_BRAND_COLOUR_ORDER' |
    'AGENCY.CLIENT.BRAND_COLOURS.UPDATE_BRAND_COLOUR' |
    'AGENCY.CLIENT.BRAND_COLOURS.UPDATE_COLOUR' |
    'AGENCY.CLIENT.BRAND_COLOURS.UPDATE_ORDER' |
    'AGENCY.CLIENT.BUILDER_TEMPLATE_CATEGORIES.CONFIRM_DELETE' |
    'AGENCY.CLIENT.BUILDER_TEMPLATE_CATEGORIES.EDIT_CATEGORY' |
    'AGENCY.CLIENT.BUILDER_TEMPLATE_CATEGORIES.END_DATE_MUST_BE_AFTER_START_DATE_OR_ABSENT' |
    'AGENCY.CLIENT.BUILDER_TEMPLATE_CATEGORIES.NEW_CATEGORY' |
    'AGENCY.CLIENT.CONVERSION_AMOUNT' |
    'AGENCY.CLIENT.CONVERSION_AMOUNT_UPDATED' |
    'AGENCY.CLIENT.CONVERSION_WORTH' |
    'AGENCY.CLIENT.FILTER_CLIENTS' |
    'AGENCY.CLIENT.LINKS.ADD_NEW_LINK' |
    'AGENCY.CLIENT.LINKS.CREATE_NEW_LINK' |
    'AGENCY.CLIENT.LINKS.DELETE_CONFIRMATION' |
    'AGENCY.CLIENT.LINKS.DELETE_LINK' |
    'AGENCY.CLIENT.LINKS.GET_LINKS' |
    'AGENCY.CLIENT.LINKS.LINK_PATTERN_REQUIREMENT' |
    'AGENCY.CLIENT.LINKS.TITLE' |
    'AGENCY.CLIENT.LINKS.UPDATE_ORDER' |
    'AGENCY.CLIENT.LINKS.URL' |
    'AGENCY.CLIENT.LOCATION.ACTIVITIES.ACTIVITY_ADDED' |
    'AGENCY.CLIENT.LOCATION.ACTIVITIES.ACTIVITY_NAME' |
    'AGENCY.CLIENT.LOCATION.ACTIVITIES.ACTIVITY_REMOVED' |
    'AGENCY.CLIENT.LOCATION.ACTIVITIES.ADD_NEW_ACTIVITY' |
    'AGENCY.CLIENT.LOCATION.ACTIVITIES.CHANNELS' |
    'AGENCY.CLIENT.LOCATION.ACTIVITIES.DELETE_ACTIVITY' |
    'AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.CHANNEL' |
    'AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.CHANNEL_ADDED' |
    'AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.CHANNEL_DELETED' |
    'AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.CONFIRM_CLICK_DELETE_CHANNEL' |
    'AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.DELETE_CHANNEL' |
    'AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.MIGRATE' |
    'AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.REPLACE_ALL' |
    'AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_PLATFORM.PLATFORM_ADDED' |
    'AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_PLATFORM.PLATFORM_DELETED' |
    'AGENCY.CLIENT.LOCATION.ACTIVITIES.PLATFORM_LINK' |
    'AGENCY.CLIENT.LOCATION.ACTIVITIES.TYPE' |
    'AGENCY.CLIENT.LOCATION.BILLING_UPDATE.SEND_BILLING_DETAILS_UPDATE_REQUEST' |
    'AGENCY.CLIENT.LOCATION.BILLING_UPDATE.SEND_REQUEST' |
    'AGENCY.CLIENT.LOCATION.BILLING_UPDATE.SIGNATORYS_EMAIL_ADDRESS' |
    'AGENCY.CLIENT.LOCATION.CATEGORIES.NOTIFY_UPDATED' |
    'AGENCY.CLIENT.LOCATION.FEATURED_TEMPLATE_SETS.ACTIONS' |
    'AGENCY.CLIENT.LOCATION.FEATURED_TEMPLATE_SETS.DELETE_TEMPLATE_TAG' |
    'AGENCY.CLIENT.LOCATION.FEATURED_TEMPLATE_SETS.EDIT_FEATURED_TEMPLATE_SET' |
    'AGENCY.CLIENT.LOCATION.FEATURED_TEMPLATE_SETS.END_DATE' |
    'AGENCY.CLIENT.LOCATION.FEATURED_TEMPLATE_SETS.NEW_FEATURED_TEMPLATE_SET' |
    'AGENCY.CLIENT.LOCATION.FEATURED_TEMPLATE_SETS.START_DATE' |
    'AGENCY.CLIENT.LOCATION.FONTS.BOLD' |
    'AGENCY.CLIENT.LOCATION.FONTS.BY_CHOOSING_A_FONT' |
    'AGENCY.CLIENT.LOCATION.FONTS.CHOOSE_FONT' |
    'AGENCY.CLIENT.LOCATION.FONTS.CONDENSED' |
    'AGENCY.CLIENT.LOCATION.FONTS.CUSTOM' |
    'AGENCY.CLIENT.LOCATION.FONTS.DO_YOU_HAVE_PERMISSION' |
    'AGENCY.CLIENT.LOCATION.FONTS.EXPANDED' |
    'AGENCY.CLIENT.LOCATION.FONTS.EXTRA_CONDENSED' |
    'AGENCY.CLIENT.LOCATION.FONTS.EXTRA_EXPANDED' |
    'AGENCY.CLIENT.LOCATION.FONTS.FONTS_SAVED' |
    'AGENCY.CLIENT.LOCATION.FONTS.FONT_FAMILY' |
    'AGENCY.CLIENT.LOCATION.FONTS.ITALIC' |
    'AGENCY.CLIENT.LOCATION.FONTS.I_CONFIRM_I_HAVE_PERMISSION' |
    'AGENCY.CLIENT.LOCATION.FONTS.LOCAL_FILE' |
    'AGENCY.CLIENT.LOCATION.FONTS.NORMAL' |
    'AGENCY.CLIENT.LOCATION.FONTS.NO_FONTS' |
    'AGENCY.CLIENT.LOCATION.FONTS.OBLIQUE' |
    'AGENCY.CLIENT.LOCATION.FONTS.SELECT_FONT' |
    'AGENCY.CLIENT.LOCATION.FONTS.SEMI_CONDENSED' |
    'AGENCY.CLIENT.LOCATION.FONTS.SEMI_EXPANDED' |
    'AGENCY.CLIENT.LOCATION.FONTS.STRETCH' |
    'AGENCY.CLIENT.LOCATION.FONTS.STYLE' |
    'AGENCY.CLIENT.LOCATION.FONTS.ULTRA_CONDENSED' |
    'AGENCY.CLIENT.LOCATION.FONTS.ULTRA_EXPANDED' |
    'AGENCY.CLIENT.LOCATION.FONTS.WEIGHT' |
    'AGENCY.CLIENT.LOCATION.FONTS.YOU_HAVE_CONFIRMED' |
    'AGENCY.CLIENT.LOCATION.LEARN_MENU.ADD_SECTION' |
    'AGENCY.CLIENT.LOCATION.LEARN_MENU.ADD_SUB_SECTION' |
    'AGENCY.CLIENT.LOCATION.LEARN_MENU.ADD_SUB_SECTION_TO_SECTION' |
    'AGENCY.CLIENT.LOCATION.LEARN_MENU.COULD_NOT_SAVE_LEARN_MENU' |
    'AGENCY.CLIENT.LOCATION.LEARN_MENU.DELETE_SECTION' |
    'AGENCY.CLIENT.LOCATION.LEARN_MENU.DELETE_SUB_SECTION' |
    'AGENCY.CLIENT.LOCATION.LEARN_MENU.LEARN_MENU_SAVED' |
    'AGENCY.CLIENT.LOCATION.LEARN_MENU.NEW_SUB_SECTION' |
    'AGENCY.CLIENT.LOCATION.LEARN_MENU.SUB_SECTIONS' |
    'AGENCY.CLIENT.LOCATION.LEARN_MENU.SUB_SECTIONS_FOR' |
    'AGENCY.CLIENT.LOCATION.LOCATION_DETAILS.DELETE_CONFIRMATION' |
    'AGENCY.CLIENT.LOCATION.LOCATION_DETAILS.DISPLAY_NAME_TOO_LONG' |
    'AGENCY.CLIENT.LOCATION.LOCATION_DETAILS.LOCATION_DETAILS' |
    'AGENCY.CLIENT.LOCATION.LOCATION_DETAILS.SUPPORTED_PLANNER_LIMIT' |
    'AGENCY.CLIENT.LOCATION.MANAGE.ADD_LOCATION' |
    'AGENCY.CLIENT.LOCATION.MANAGE.CREATED_LOCATION_ERROR' |
    'AGENCY.CLIENT.LOCATION.MANAGE.CREATED_LOCATION_SUCCESS' |
    'AGENCY.CLIENT.LOCATION.MANAGE.DELETE_LOCATION_DESCRIPTION' |
    'AGENCY.CLIENT.LOCATION.MANAGE.DELETE_LOCATION_ERROR' |
    'AGENCY.CLIENT.LOCATION.MANAGE.DELETE_LOCATION_LABEL' |
    'AGENCY.CLIENT.LOCATION.MANAGE.DELETE_LOCATION_SUCCESS' |
    'AGENCY.CLIENT.LOCATION.MANAGE.EDIT_DETAILS' |
    'AGENCY.CLIENT.LOCATION.MANAGE.ERRORS.ERROR_UPDATING_LOCATION' |
    'AGENCY.CLIENT.LOCATION.MANAGE.ERRORS.NO_CLIENT_ID' |
    'AGENCY.CLIENT.LOCATION.MANAGE.ERRORS.NO_LOCATION_OR_ACCESS_FORBIDDEN' |
    'AGENCY.CLIENT.LOCATION.MANAGE.FILTER_LOCATIONS' |
    'AGENCY.CLIENT.LOCATION.MANAGE.LOCATION_NAME' |
    'AGENCY.CLIENT.LOCATION.MANAGE.LOCATION_UPDATE_SUCCESS' |
    'AGENCY.CLIENT.LOCATION.MANAGE.NO_FIELD_VALUE' |
    'AGENCY.CLIENT.LOCATION.MANAGE.PROPERTIES' |
    'AGENCY.CLIENT.LOCATION.MANAGE.PUBLIC_DETAILS' |
    'AGENCY.CLIENT.LOCATION.NAV.ACTIVITIES' |
    'AGENCY.CLIENT.LOCATION.NAV.AGENCY' |
    'AGENCY.CLIENT.LOCATION.NAV.BRAND_COLOURS' |
    'AGENCY.CLIENT.LOCATION.NAV.BUILDER_TEMPLATE_CATEGORIES' |
    'AGENCY.CLIENT.LOCATION.NAV.CLIENTS' |
    'AGENCY.CLIENT.LOCATION.NAV.FEATURED_TEMPLATE_SETS' |
    'AGENCY.CLIENT.LOCATION.NAV.FONTS' |
    'AGENCY.CLIENT.LOCATION.NAV.LEARN_MENU' |
    'AGENCY.CLIENT.LOCATION.NAV.LINKS' |
    'AGENCY.CLIENT.LOCATION.NAV.LOCATIONS' |
    'AGENCY.CLIENT.LOCATION.NAV.LOCATION_CATEGORIES' |
    'AGENCY.CLIENT.LOCATION.NAV.PLATFORMS' |
    'AGENCY.CLIENT.LOCATION.NAV.USERS' |
    'AGENCY.CLIENT.LOCATION.NOTIFY_LOCATION_DELETED' |
    'AGENCY.CLIENT.LOCATION.NOTIFY_LOCATION_DELETE_ERROR' |
    'AGENCY.CLIENT.LOCATION.NOTIFY_LOCATION_UPDATED' |
    'AGENCY.CLIENT.LOCATION.NOTIFY_LOCATION_UPDATE_ERROR' |
    'AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.ADD_NEW_FIELD_GROUP' |
    'AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.DELETE_FIELD' |
    'AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.DELETE_FIELD_CONFIRM' |
    'AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.DELETE_GROUP' |
    'AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.FIELD_LABEL' |
    'AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.GROUP_NAME' |
    'AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.NEW_FIELD' |
    'AGENCY.CLIENT.LOCATION.USERS.ADD_EXISTING_USER' |
    'AGENCY.CLIENT.LOCATION.USERS.ADD_EXISTING_USER_HELP_TEXT' |
    'AGENCY.CLIENT.LOCATION.USERS.ADD_EXISTING_USER_LABEL' |
    'AGENCY.CLIENT.LOCATION.USERS.ADD_EXISTING_USER_NO_MATCHES' |
    'AGENCY.CLIENT.LOCATION.USERS.ADD_EXISTING_USER_PLACEHOLDER' |
    'AGENCY.CLIENT.LOCATION.USERS.ADD_EXISTING_USER_SELECTED' |
    'AGENCY.CLIENT.LOCATION.USERS.ADD_NEW_USER_TO' |
    'AGENCY.CLIENT.LOCATION.USERS.ASSIGN_USER_TO_LOCATIONS' |
    'AGENCY.CLIENT.LOCATION.USERS.CURRENTLY_SELECTED' |
    'AGENCY.CLIENT.LOCATION.USERS.DELETE_CONFIRMATION' |
    'AGENCY.CLIENT.LOCATION.USERS.DELETE_USER' |
    'AGENCY.CLIENT.LOCATION.USERS.FAILED_TO_ADD_EXISTING_USER' |
    'AGENCY.CLIENT.LOCATION.USERS.FILTER_FIRST_NAME' |
    'AGENCY.CLIENT.LOCATION.USERS.FILTER_LAST_NAME' |
    'AGENCY.CLIENT.LOCATION.USERS.FILTER_USERNAME' |
    'AGENCY.CLIENT.LOCATION.USERS.FIRST_NAME' |
    'AGENCY.CLIENT.LOCATION.USERS.LAST_NAME' |
    'AGENCY.CLIENT.LOCATION.USERS.LOCATIONS_UPDATED' |
    'AGENCY.CLIENT.LOCATION.USERS.NO_USERS_ASSIGNED_TO_COMPANY' |
    'AGENCY.CLIENT.LOCATION.USERS.NO_USERS_FOUND' |
    'AGENCY.CLIENT.LOCATION.USERS.REMOVE_USER_MODAL.DELETE_USER' |
    'AGENCY.CLIENT.LOCATION.USERS.REMOVE_USER_MODAL.REMOVE_FROM_LOCATION' |
    'AGENCY.CLIENT.LOCATION.USERS.REMOVE_USER_MODAL.REMOVE_OR_DELETE_USER_MESSAGE' |
    'AGENCY.CLIENT.LOCATION.USERS.REMOVE_USER_MODAL.REMOVE_OR_DELETE_USER_TITLE' |
    'AGENCY.CLIENT.LOCATION.USERS.ROLES' |
    'AGENCY.CLIENT.LOCATION.USERS.SELECT_USER' |
    'AGENCY.CLIENT.LOCATION.USERS.USERNAME_EMAIL' |
    'AGENCY.CLIENT.LOCATION.USERS.USERS' |
    'AGENCY.CLIENT.LOCATION.USERS.USERS_EXISTING_LOCATIONS' |
    'AGENCY.CLIENT.LOCATION.USERS.USER_ADDED' |
    'AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.ANALYST' |
    'AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.ANALYST_TOOLTIP' |
    'AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.BUILDER' |
    'AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.BUILDER_TOOLTIP' |
    'AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.CLIENTS' |
    'AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.CONNECT_TO_ACCESS' |
    'AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.EDIT_CLIENT_USER' |
    'AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.EDIT_USER' |
    'AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.EMAIL' |
    'AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.FIRST_NAME' |
    'AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.LAST_NAME' |
    'AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.MARKETING_UPDATES' |
    'AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.NOTIFICATIONS' |
    'AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.PASSWORD' |
    'AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.PLANNER' |
    'AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.PLANNER_TOOLTIP' |
    'AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.PUBLISHER' |
    'AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.PUBLISHER_TOOLTIP' |
    'AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.ROLES' |
    'AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.SPECIAL_REQUESTER' |
    'AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.SPECIAL_REQUESTER_TOOLTIP' |
    'AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.SPECIAL_REQUESTS' |
    'AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.TIMEZONE' |
    'AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.UPDATE' |
    'AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.USER_DELETED' |
    'AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.USER_UPDATED' |
    'AGENCY.CLIENT.LOCATION.USERS.USER_REMOVED' |
    'AGENCY.CLIENT.LOCATION.USERS.YOUR_INVITE_HAS_BEEN_SENT' |
    'AGENCY.CLIENT.LOCATIONS.ADD_NEW_LOCATION' |
    'AGENCY.CLIENT.LOCATIONS.COUNTRY' |
    'AGENCY.CLIENT.LOCATIONS.COUNTRY_UPDATED' |
    'AGENCY.CLIENT.LOCATIONS.CURRENCY' |
    'AGENCY.CLIENT.LOCATIONS.CURRENCY_UPDATED' |
    'AGENCY.CLIENT.LOCATIONS.DEFAULT_SUPPORTED_PLANNER_LIMIT' |
    'AGENCY.CLIENT.LOCATIONS.DEFAULT_SUPPORTED_PLANNER_LIMIT_UPDATED' |
    'AGENCY.CLIENT.LOCATIONS.DELETE_CLIENT' |
    'AGENCY.CLIENT.LOCATIONS.DELETE_PERMANENTLY' |
    'AGENCY.CLIENT.LOCATIONS.EMAILS.SIGNED_UP.LOCATION_SIGNED_UP' |
    'AGENCY.CLIENT.LOCATIONS.EMAILS.SIGNED_UP.NEW_LOCATION_SIGNED_UP' |
    'AGENCY.CLIENT.LOCATIONS.EMAILS.SIGNED_UP.VISIT_DIGITAL_STACK' |
    'AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.ACTIVATE_YOUR_ENHANCED_PACKAGE' |
    'AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.AGENCY_INVITED_YOU' |
    'AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.CLICK_BELOW_TO_UPDATE_DETAILS' |
    'AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.CLICK_BUTTON_TO_COMPLETE_SIGN_UP' |
    'AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.DEFAULT_EMAIL_SUBJECT' |
    'AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.INCLUSIONS_CHANGED_TO_OFFER_BETTER_VALUE' |
    'AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.SIGN_UP' |
    'AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.THESE_DETAILS_ALLOW_SPECIFIC_SERVICES' |
    'AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.WELCOME_TO_DIGITAL_STACK' |
    'AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.WE_REQUIRE_CONFIRMATION_OF_DETAILS' |
    'AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.YOURE_INVITED' |
    'AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.YOU_NEED_TO_FILL_OUT_DETAILS' |
    'AGENCY.CLIENT.LOCATIONS.EMAILS.UPDATE_BILLING_DETAILS.CLICK_TO_UPDATE_BILLING_DETAILS' |
    'AGENCY.CLIENT.LOCATIONS.EMAILS.UPDATE_BILLING_DETAILS.REQUEST_TO_UPDATE_BILLING_DETAILS' |
    'AGENCY.CLIENT.LOCATIONS.EMAILS.UPDATE_BILLING_DETAILS.SUBJECT_LINE' |
    'AGENCY.CLIENT.LOCATIONS.EMAILS.UPDATE_BILLING_DETAILS.UPDATE_YOUR_BILLING_DETAILS' |
    'AGENCY.CLIENT.LOCATIONS.EMAILS.UPDATE_BILLING_DETAILS.WE_REQUIRE_YOU_TO_UPDATE_BILLING_DETAILS' |
    'AGENCY.CLIENT.LOCATIONS.ERROR_DELETING_CLIENT' |
    'AGENCY.CLIENT.LOCATIONS.HEADERS.YOUR_BRANDS' |
    'AGENCY.CLIENT.LOCATIONS.INVITATION_SENT' |
    'AGENCY.CLIENT.LOCATIONS.INVITE' |
    'AGENCY.CLIENT.LOCATIONS.LOCATION' |
    'AGENCY.CLIENT.LOCATIONS.LOCATIONS' |
    'AGENCY.CLIENT.LOCATIONS.LOCATION_ADDED' |
    'AGENCY.CLIENT.LOCATIONS.LOCATION_GROUPS_NO_CATEGORIES_TOOLTIP' |
    'AGENCY.CLIENT.LOCATIONS.NO_LOCATIONS_ASSIGNED' |
    'AGENCY.CLIENT.LOCATIONS.NO_LOCATION_GROUPS' |
    'AGENCY.CLIENT.LOCATIONS.PERMANENTLY_DELETED_CLIENT' |
    'AGENCY.CLIENT.LOCATIONS.REQUEST_UPDATE_BILLING_DETAILS_SENT' |
    'AGENCY.CLIENT.LOCATIONS.RESEND' |
    'AGENCY.CLIENT.LOCATIONS.SIGNED_UP' |
    'AGENCY.CLIENT.LOCATIONS.SUBSCRIPTION_ACTIVE' |
    'AGENCY.CLIENT.LOCATIONS.SUBSCRIPTION_AMOUNT' |
    'AGENCY.CLIENT.LOCATIONS.TIMEZONE' |
    'AGENCY.CLIENT.LOCATIONS.UPDATE_BILLING_DETAILS' |
    'AGENCY.CLIENT.LOCATION_CATEGORIES.ADD_REGION_OR_GROUP' |
    'AGENCY.CLIENT.LOCATION_CATEGORIES.ADD_TO_GROUP' |
    'AGENCY.CLIENT.LOCATION_CATEGORIES.ASSOCIATE_COLLECTION_PLACEHOLDER' |
    'AGENCY.CLIENT.LOCATION_CATEGORIES.ASSOCIATE_TEMPLATE_CATEGORY_PLACEHOLDER' |
    'AGENCY.CLIENT.LOCATION_CATEGORIES.DELETED_LOCATION_CATEGORY' |
    'AGENCY.CLIENT.LOCATION_CATEGORIES.DELETE_CONFIRMATION' |
    'AGENCY.CLIENT.LOCATION_CATEGORIES.DELETE_GROUP' |
    'AGENCY.CLIENT.LOCATION_CATEGORIES.DELETE_LOCATION_CATEGORY_CONFIRM' |
    'AGENCY.CLIENT.LOCATION_CATEGORIES.ERRORS.FAILED_ASSOCIATE_COLLECTIONS' |
    'AGENCY.CLIENT.LOCATION_CATEGORIES.ERRORS.FAILED_ASSOCIATE_TEMPLATE_CATEGORIES' |
    'AGENCY.CLIENT.LOCATION_CATEGORIES.ERRORS.MISSING_COLLECTIONS_OR_CATEGORIES' |
    'AGENCY.CLIENT.LOCATION_CATEGORIES.FOLLOWING_LOCATIONS_ALREADY_ASSOCIATED_WITH_REGION' |
    'AGENCY.CLIENT.LOCATION_CATEGORIES.GROUP' |
    'AGENCY.CLIENT.LOCATION_CATEGORIES.LABELS.COLLECTIONS' |
    'AGENCY.CLIENT.LOCATION_CATEGORIES.LABELS.LINK_TEMPLATE_CATEGORIES_AND_COLLECTIONS' |
    'AGENCY.CLIENT.LOCATION_CATEGORIES.LABELS.NAME' |
    'AGENCY.CLIENT.LOCATION_CATEGORIES.LABELS.TYPE' |
    'AGENCY.CLIENT.LOCATION_CATEGORIES.LOCATION_CATEGORIES' |
    'AGENCY.CLIENT.LOCATION_CATEGORIES.LOCATION_GROUP' |
    'AGENCY.CLIENT.LOCATION_CATEGORIES.LOCATION_REGION' |
    'AGENCY.CLIENT.LOCATION_CATEGORIES.NEW_OPTION' |
    'AGENCY.CLIENT.LOCATION_CATEGORIES.NOTIFY_ENTER_LABEL_FOR_CATEGORY' |
    'AGENCY.CLIENT.LOCATION_CATEGORIES.OPTION_ADDED' |
    'AGENCY.CLIENT.LOCATION_CATEGORIES.OPTION_DELETED' |
    'AGENCY.CLIENT.LOCATION_CATEGORIES.PARTIALLY_ADDED_LOCATION_CATEGORY' |
    'AGENCY.CLIENT.LOCATION_CATEGORIES.PARTIALLY_EDITED_LOCATION_CATEGORY' |
    'AGENCY.CLIENT.LOCATION_CATEGORIES.RADIO_DISABLED_MESSAGE' |
    'AGENCY.CLIENT.LOCATION_CATEGORIES.REGION' |
    'AGENCY.CLIENT.LOCATION_CATEGORIES.SELECTED_LOCATIONS' |
    'AGENCY.CLIENT.LOCATION_CATEGORIES.SUCCESSFULLY_ADDED_LOCATION_CATEGORY' |
    'AGENCY.CLIENT.LOCATION_CATEGORIES.SUCCESSFULLY_EDITED_LOCATION_CATEGORY' |
    'AGENCY.CLIENT.LOCATION_CATEGORIES.TOOLTIPS.GROUP_MESSAGE' |
    'AGENCY.CLIENT.LOCATION_CATEGORIES.TOOLTIPS.LINK_TEMPLATE_CATEGORIES_AND_COLLECTIONS' |
    'AGENCY.CLIENT.LOCATION_CATEGORIES.TOOLTIPS.REGION_MESSAGE' |
    'AGENCY.CLIENT.LOCATION_CATEGORIES.UPDATED_LOCATIONS_FOR_CATEGORY' |
    'AGENCY.CLIENT.NOTIFICATION_EMAIL_ADDRESSES_UPDATED' |
    'AGENCY.CLIENT.NUMBER_OF_LOCATIONS' |
    'AGENCY.CLIENT.PLATFORMS.ALL' |
    'AGENCY.CLIENT.PLATFORMS.CANNOT_REMOVE_PLATFORM_LINKED_CHANNELS' |
    'AGENCY.CLIENT.PLATFORMS.CANNOT_REMOVE_PLATFORM_LINKED_TEMPLATES' |
    'AGENCY.CLIENT.PLATFORMS.CONFIGURE' |
    'AGENCY.CLIENT.PLATFORMS.CONFIRM_REMOVE_PLATFORM' |
    'AGENCY.CLIENT.PLATFORMS.CONFIRM_REMOVE_PLATFORM_TITLE' |
    'AGENCY.CLIENT.PLATFORMS.DISABLE_PLATFORM' |
    'AGENCY.CLIENT.PLATFORMS.ENABLED' |
    'AGENCY.CLIENT.PLATFORMS.ENABLE_PLATFORM' |
    'AGENCY.CLIENT.PLATFORMS.FETCH_CLIENT_PLATFORMS' |
    'AGENCY.CLIENT.PLATFORMS.FILTER_BY_STATUS' |
    'AGENCY.CLIENT.PLATFORMS.FILTER_PLATFORMS' |
    'AGENCY.CLIENT.PLATFORMS.PLATFORM' |
    'AGENCY.CLIENT.PLATFORMS.REQUIRED' |
    'AGENCY.CLIENT.UPDATE_CONVERSION_DETAILS' |
    'AGENCY.CLIENT.UPDATE_NOTIFICATION_EMAIL_ADDRESSES' |
    'AGENCY.CLIENT.USERS.COUNT_SELECTED' |
    'AGENCY.CLIENT.USERS.SEARCH_FOR_USERS_OR_EMAIL_ADDRESSES' |
    'AGENCY.CLIENT.USERS.SORT_DIRECTION_TIP' |
    'AGENCY.CLIENT.USERS.TITLE' |
    'AGENCY.CLIENTS.ADD_CLIENT.CHANNEL_LABEL' |
    'AGENCY.CLIENTS.ADD_CLIENT.CLIENT_ADDED' |
    'AGENCY.CLIENTS.ADD_CLIENT.GENERAL' |
    'AGENCY.CLIENTS.ADD_CLIENT.NEW_CHANNEL' |
    'AGENCY.CLIENTS.ADD_CLIENT.SELECT_A_PLATFORM_TO_LINK_THIS_CHANNEL_TO_OPTIONAL' |
    'AGENCY.CLIENTS.ADD_CLIENT.SELF_SERVICE' |
    'AGENCY.CLIENTS.ADD_CLIENT.SUPPORTED' |
    'AGENCY.CLIENTS.ADD_NEW_CLIENT' |
    'AGENCY.CLIENTS.CLIENT_NAME' |
    'AGENCY.CLIENTS.CLIENT_TABLE.ACTIONS.CLIENT_ACTIONS' |
    'AGENCY.CLIENTS.CLIENT_TABLE.ACTIONS.DELETE_CLIENT_DESCRIPTION' |
    'AGENCY.CLIENTS.CLIENT_TABLE.ACTIONS.DELETE_CLIENT_LABEL' |
    'AGENCY.CLIENTS.CLIENT_TABLE.ACTIONS.ENTER_NEW_NAME' |
    'AGENCY.CLIENTS.CLIENT_TABLE.ACTIONS.RENAME' |
    'AGENCY.CLIENTS.CLIENT_TABLE.HEADERS.ACTIONS' |
    'AGENCY.CLIENTS.CLIENT_TABLE.HEADERS.AVG_BUILDS' |
    'AGENCY.CLIENTS.CLIENT_TABLE.HEADERS.NUM_LOCATIONS' |
    'AGENCY.CLIENTS.CLIENT_TABLE.HEADERS.PERCENTAGE_CONNECTED' |
    'AGENCY.CLIENTS.CLIENT_TABLE.HEADERS.TITLE' |
    'AGENCY.CLIENTS.YOU_HAVE_NOT_ADDED_ANY' |
    'AGENCY.CONTACT_DETAILS.ADWORDS_MARKETING' |
    'AGENCY.CONTACT_DETAILS.AGENCY_CONTACT_DETAILS' |
    'AGENCY.CONTACT_DETAILS.CONTACT_DETAILS' |
    'AGENCY.CONTACT_DETAILS.SPECIAL_REQUEST_DISCLAIMER' |
    'AGENCY.CONTACT_DETAILS.UPDATE_CONTACTS' |
    'AGENCY.HASHTAG_SETS.ACTIONS.ADD_HASHTAG_SET' |
    'AGENCY.HASHTAG_SETS.ACTIONS.MESSAGES.COULD_NOT_CREATE_SET' |
    'AGENCY.HASHTAG_SETS.ACTIONS.MESSAGES.COULD_NOT_DELETE_SET' |
    'AGENCY.HASHTAG_SETS.ACTIONS.MESSAGES.COULD_NOT_UPDATE_SET' |
    'AGENCY.HASHTAG_SETS.ACTIONS.MESSAGES.CREATED_SET' |
    'AGENCY.HASHTAG_SETS.ACTIONS.MESSAGES.DELETED_SET' |
    'AGENCY.HASHTAG_SETS.ACTIONS.MESSAGES.UPDATED_SET' |
    'AGENCY.HASHTAG_SETS.ACTIONS.UPDATE_HASHTAG_SET' |
    'AGENCY.HASHTAG_SETS.DIALOG.MINIMUM_ONE' |
    'AGENCY.HASHTAG_SETS.DIALOG.REQUIRED_FOR_ALL_POSTS' |
    'AGENCY.HASHTAG_SETS.DIALOG.START_BY_TYPING_YOUR_HASHTAGS' |
    'AGENCY.HASHTAG_SETS.HASHTAGS' |
    'AGENCY.HASHTAG_SETS.HASHTAG_SETS' |
    'AGENCY.HASHTAG_SETS.TABLE_HEADERS.DESCRIPTION' |
    'AGENCY.HASHTAG_SETS.TABLE_HEADERS.NUMBER_HASHTAGS' |
    'AGENCY.HASHTAG_SETS.TABLE_HEADERS.TITLE' |
    'AGENCY.NOTIFICATIONS.AGENCY_EMAIL_NOTIFICATIONS' |
    'AGENCY.NOTIFICATIONS.AGENCY_NOTIFICATIONS' |
    'AGENCY.NOTIFICATIONS.CLICKS' |
    'AGENCY.NOTIFICATIONS.CLICK_RATE' |
    'AGENCY.NOTIFICATIONS.EMAIL_ADDRESS' |
    'AGENCY.NOTIFICATIONS.FAILED_TO_LOAD' |
    'AGENCY.NOTIFICATIONS.HELP_TEXT.CLICKS' |
    'AGENCY.NOTIFICATIONS.HELP_TEXT.SENT' |
    'AGENCY.NOTIFICATIONS.NEW_COMMENTS' |
    'AGENCY.NOTIFICATIONS.NEW_SPECIAL_REQUESTS' |
    'AGENCY.NOTIFICATIONS.NOTIFICATIONS_WILL_BE_SENT' |
    'AGENCY.NOTIFICATIONS.NO_LINK_PROVIDED' |
    'AGENCY.NOTIFICATIONS.NO_NOTIFICATIONS_FOUND' |
    'AGENCY.NOTIFICATIONS.OPEN_LINK' |
    'AGENCY.NOTIFICATIONS.SENDING_INFO.MOBILE' |
    'AGENCY.NOTIFICATIONS.SENDING_INFO.TITLE' |
    'AGENCY.NOTIFICATIONS.SENDING_INFO.WEBSITE' |
    'AGENCY.NOTIFICATIONS.SEND_CONFIRM.MESSAGE' |
    'AGENCY.NOTIFICATIONS.SEND_CONFIRM.MESSAGE_plural' |
    'AGENCY.NOTIFICATIONS.SEND_CONFIRM.TITLE' |
    'AGENCY.NOTIFICATIONS.SEND_NOTIFICATION' |
    'AGENCY.NOTIFICATIONS.SENT' |
    'AGENCY.NOTIFICATIONS.SENT_BY' |
    'AGENCY.NOTIFICATIONS.SENT_NOTIFICATIONS' |
    'AGENCY.NOTIFICATIONS.SUBJECT' |
    'AGENCY.PRINT_SKU_GROUPS.AGENCY_PRINT_PRODUCTS' |
    'AGENCY.PRINT_SKU_GROUPS.ATTACHED_PROVIDERS' |
    'AGENCY.PRINT_SKU_GROUPS.DEFAULT_CURRENCY' |
    'AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.ADD_NEW_PRINT_PROVIDER' |
    'AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.ATTACH_TO_SKU_GROUP' |
    'AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.AUTH_REQUEST_CONFIRMATION' |
    'AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.NO_AVAILABLE_CLIENTS' |
    'AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.PAYMENT_AUTH' |
    'AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.PRINT_PROVIDER_ADDED' |
    'AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.PRINT_PROVIDER_ATTACHED' |
    'AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.PRINT_PROVIDER_DETACHED' |
    'AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.SEND_AUTH_REQUEST' |
    'AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDERS' |
    'AGENCY.PRINT_SKU_GROUPS.PRINT_SKU_GROUPS' |
    'AGENCY.PRINT_SKU_GROUPS.QUANTITY_OPTION.ADD_NEW_QUANTITY_OPTION' |
    'AGENCY.PRINT_SKU_GROUPS.QUANTITY_OPTION.QUANTITY_ALREADY_EXISTS' |
    'AGENCY.PRINT_SKU_GROUPS.QUANTITY_OPTION.QUANTITY_OPTION_ADDED' |
    'AGENCY.PRINT_SKU_GROUPS.QUANTITY_OPTIONS' |
    'AGENCY.PRINT_SKU_GROUPS.SKU.ADD_NEW_SKU' |
    'AGENCY.PRINT_SKU_GROUPS.SKU.CREATE_SKU' |
    'AGENCY.PRINT_SKU_GROUPS.SKU.DELETE_SKU' |
    'AGENCY.PRINT_SKU_GROUPS.SKU.EDIT_SKU' |
    'AGENCY.PRINT_SKU_GROUPS.SKU.EXCLUSIVE' |
    'AGENCY.PRINT_SKU_GROUPS.SKU.FORMATS_APPLIED_TO' |
    'AGENCY.PRINT_SKU_GROUPS.SKU.LINEAR_PRICING' |
    'AGENCY.PRINT_SKU_GROUPS.SKU.SKU' |
    'AGENCY.PRINT_SKU_GROUPS.SKU.SKU_ADDED' |
    'AGENCY.PRINT_SKU_GROUPS.SKU.SKU_DELETED' |
    'AGENCY.PRINT_SKU_GROUPS.SKU.SKU_DELETE_CONFIRMATION' |
    'AGENCY.PRINT_SKU_GROUPS.SKU.SKU_GROUP_MISSING' |
    'AGENCY.PRINT_SKU_GROUPS.SKU.SKU_UPDATED' |
    'AGENCY.PRINT_SKU_GROUPS.SKUS' |
    'AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.ADD_NEW_SKU_GROUP' |
    'AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.DELETE_SKU_GROUP' |
    'AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.EDIT_SKU_GROUP' |
    'AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.EDIT_SKU_GROUP_TITLE' |
    'AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.ORDER_INFORMATION' |
    'AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.PAYMENT_GATEWAY' |
    'AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.PAYMENT_URL' |
    'AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.SKU_GROUP' |
    'AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.SKU_GROUP_ADDED' |
    'AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.SKU_GROUP_DELETED' |
    'AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.SKU_GROUP_DELETE_CONFIRMATION' |
    'AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.SKU_GROUP_DETAILS' |
    'AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.SKU_GROUP_UPDATED' |
    'AGENCY.SEND_REPORTS.ACTIONS.OPEN_REPORT' |
    'AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.CLICKED' |
    'AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.READ' |
    'AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.RECIPIENT_EMAIL' |
    'AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.RECIPIENT_EMAIL_FILTER_LABEL' |
    'AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.RECIPIENT_EMAIL_FILTER_PLACEHOLDER' |
    'AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.RECIPIENT_NAME' |
    'AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.RECIPIENT_NAME_FILTER_LABEL' |
    'AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.RECIPIENT_NAME_FILTER_PLACEHOLDER' |
    'AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.SENT' |
    'AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.NO_RECIPIENTS_FOUND' |
    'AGENCY.SEND_REPORTS.REPORT.CLICKED_SUBTITLE' |
    'AGENCY.SEND_REPORTS.REPORT.CLICKED_TITLE' |
    'AGENCY.SEND_REPORTS.REPORT.READ_SUBTITLE' |
    'AGENCY.SEND_REPORTS.REPORT.READ_TITLE' |
    'AGENCY.SEND_REPORTS.REPORT.SENT_FROM' |
    'AGENCY.SEND_REPORTS.REPORT.SENT_SUBTITLE' |
    'AGENCY.SEND_REPORTS.REPORT.SENT_TITLE' |
    'AGENCY.SEND_REPORTS.REPORT.SENT_TO_PART_1' |
    'AGENCY.SEND_REPORTS.REPORT.SENT_TO_PART_2' |
    'AGENCY.SEND_REPORTS.REPORT.SENT_TO_PART_2_plural' |
    'AGENCY.SEND_REPORTS.REPORT.SENT_TO_PART_3' |
    'AGENCY.SEND_REPORTS.REPORT.SENT_TO_USERS_FILTERED_BY_TITLES' |
    'AGENCY.SEND_REPORTS.REPORT.SUBTITLE_NOT_SENT' |
    'AGENCY.SEND_REPORTS.REPORT.SUBTITLE_SENT_BY' |
    'AGENCY.SEND_REPORTS.REPORT.TYPE_EMAIL_TOOLTIP' |
    'AGENCY.SEND_REPORTS.REPORT.TYPE_IN_APP_TOOLTIP' |
    'AGENCY.SEND_REPORTS.TITLE' |
    'AGENCY.USERS.CLIENT_USERS' |
    'AGENCY.USERS.INTERACTION_DELETE_USER' |
    'AGENCY.USERS.INTERACTION_GET_CLIENT_USERS' |
    'AGENCY.USERS.ONLY_SHOW_ORPHANS' |
    'APPS.ACCESS_TOKEN_CONFIG_NOT_FOUND_OR_PERMISSION_ERROR' |
    'APPS.ACCOUNT_SUCCESSFULLY_CONNECTED.MESSAGE' |
    'APPS.ACCOUNT_SUCCESSFULLY_CONNECTED.TITLE' |
    'APPS.ADWORDS_CUSTOMER' |
    'APPS.ANALYTICS_PROFILE' |
    'APPS.AUTHORISE' |
    'APPS.AUTHORIZED_ACCOUNT' |
    'APPS.BUSINESS' |
    'APPS.CAMPAIGNS_FOUND_IN_ADWORDS_THAT_MATCH_NAME' |
    'APPS.CAMPAIGNS_FOUND_IN_ADWORDS_THAT_MATCH_NAME_plural' |
    'APPS.CHECK_ACCESS_TO_GOOGLE_ADWORDS' |
    'APPS.CHECK_MATCHED_CAMPAIGNS_RELATE_TO_LOCATION' |
    'APPS.COMPANY' |
    'APPS.CONNECTING_VIA_ACCOUNT' |
    'APPS.CONNECT_TO_ACCESS_WELCOME_MESSAGE.CLUB_PILATES.HEADING' |
    'APPS.CONNECT_TO_ACCESS_WELCOME_MESSAGE.CLUB_PILATES.MESSAGE' |
    'APPS.CONNECT_TO_ACCESS_WELCOME_MESSAGE.CLUB_PILATES.SUBHEADING' |
    'APPS.CONNECT_TO_ACCESS_WELCOME_MESSAGE.DEFAULT.HEADING' |
    'APPS.CONNECT_TO_ACCESS_WELCOME_MESSAGE.DEFAULT.MESSAGE' |
    'APPS.CONNECT_TO_ACCESS_WELCOME_MESSAGE.DEFAULT.SUBHEADING' |
    'APPS.CONNECT_TO_ACCOUNT' |
    'APPS.CONNECT_TO_NEW_ACCOUNT' |
    'APPS.CUSTOMER_ID' |
    'APPS.DEAUTHORISE' |
    'APPS.DISCONNECT_ACCOUNT' |
    'APPS.DISCONNECT_FROM_ACCOUNT' |
    'APPS.EDIT_CONFIGURATION' |
    'APPS.ERRORS.DEBUG_MESSAGE_WRAP' |
    'APPS.ERRORS.FACEBOOK_ACCESS_TOKEN_ISSUE.EXPLAIN_ISSUE' |
    'APPS.ERRORS.FACEBOOK_ACCESS_TOKEN_ISSUE.PROVIDE_RESOLUTION_CANT_CONFIGURE' |
    'APPS.ERRORS.FACEBOOK_ACCESS_TOKEN_ISSUE.PROVIDE_RESOLUTION_CAN_CONFIGURE' |
    'APPS.ERRORS.FACEBOOK_INVALID_SESSION.EXPLAIN_ISSUE' |
    'APPS.ERRORS.FACEBOOK_INVALID_SESSION.PROVIDE_RESOLUTION_CANT_CONFIGURE' |
    'APPS.ERRORS.FACEBOOK_INVALID_SESSION.PROVIDE_RESOLUTION_CAN_CONFIGURE' |
    'APPS.ERRORS.FACEBOOK_PASSWORD_CHANGED.EXPLAIN_ISSUE' |
    'APPS.ERRORS.FACEBOOK_PASSWORD_CHANGED.PROVIDE_RESOLUTION_CANT_CONFIGURE' |
    'APPS.ERRORS.FACEBOOK_PASSWORD_CHANGED.PROVIDE_RESOLUTION_CAN_CONFIGURE' |
    'APPS.ERRORS.INVALID_CONFIGURATION.EXPLAIN_ISSUE' |
    'APPS.ERRORS.INVALID_CONFIGURATION.PROVIDE_RESOLUTION_CANT_CONFIGURE' |
    'APPS.ERRORS.INVALID_CONFIGURATION.PROVIDE_RESOLUTION_CAN_CONFIGURE' |
    'APPS.ERRORS.MISSING_CONFIGURATION.EXPLAIN_ISSUE' |
    'APPS.ERRORS.MISSING_CONFIGURATION.PROVIDE_RESOLUTION_CANT_CONFIGURE' |
    'APPS.ERRORS.MISSING_CONFIGURATION.PROVIDE_RESOLUTION_CAN_CONFIGURE' |
    'APPS.ERRORS.MISSING_PERMISSIONS.EXPLAIN_ISSUE' |
    'APPS.ERRORS.MISSING_PERMISSIONS.PROVIDE_RESOLUTION_CANT_CONFIGURE' |
    'APPS.ERRORS.MISSING_PERMISSIONS.PROVIDE_RESOLUTION_CANT_CONFIGURE_ALTERNATE' |
    'APPS.ERRORS.MISSING_PERMISSIONS.PROVIDE_RESOLUTION_CAN_CONFIGURE' |
    'APPS.ERRORS.WEVE_ENCOUNTERED_ISSUES' |
    'APPS.FACEBOOK.PAGE_ID_AND_NAME_REQUIRED' |
    'APPS.FACEBOOK.PAGE_UPDATED' |
    'APPS.FACEBOOK_MARKETING.ACCOUNT_NAME' |
    'APPS.FACEBOOK_MARKETING.AD_ACCOUNT_CLEARED' |
    'APPS.FACEBOOK_MARKETING.AD_ACCOUNT_SET' |
    'APPS.FACEBOOK_MARKETING.CHECK_AUTHORISATION' |
    'APPS.FACEBOOK_MARKETING.CHECK_CONFIG_ACCESS' |
    'APPS.FACEBOOK_MARKETING.FACEBOOK_AD_ACCOUNT' |
    'APPS.FACEBOOK_MARKETING.RETRIEVE_AD_ACCOUNTS' |
    'APPS.FACEBOOK_MARKETING.RETRIEVE_CONFIG' |
    'APPS.FACEBOOK_MARKETING.TITLE' |
    'APPS.FACEBOOK_MARKETING.UPDATE_AD_ACCOUNT' |
    'APPS.FACEBOOK_PAGE' |
    'APPS.FACEBOOK_PAGE_HELP' |
    'APPS.FACEBOOK_PAGE_NOT_AVAILABLE' |
    'APPS.FETCH_SERVICE_CONFIG' |
    'APPS.FITWARE' |
    'APPS.FITWARE_CLUB' |
    'APPS.FITWARE_NOTE' |
    'APPS.FOUR51.COMPANY' |
    'APPS.FOUR51.COMPANY_UPDATED' |
    'APPS.FOUR51.CREDENTIALS_DELETED' |
    'APPS.FOUR51.CREDENTIALS_UPDATED' |
    'APPS.FOUR51.DELETE_CREDENTIALS_WARNING' |
    'APPS.FOUR51.INVALID_NEW_CREDENTIALS' |
    'APPS.FOUR51.SSO_KEY' |
    'APPS.FOUR51.STORE' |
    'APPS.GOOGLE_ADWORDS.CAMPAIGN_NAME' |
    'APPS.GOOGLE_ADWORDS.CAMPAIGN_NAME_DOESNT_MATCH_CONTINUE' |
    'APPS.GOOGLE_ADWORDS.CAMPAIGN_NAME_MATCHES_COUNT_CONTINUE' |
    'APPS.GOOGLE_ADWORDS.CUSTOMER' |
    'APPS.GOOGLE_ADWORDS.MULTIPLE_CAMPAIGNS_FOUND' |
    'APPS.GOOGLE_ADWORDS.NO_CAMPAIGNS_FOUND' |
    'APPS.GOOGLE_ADWORDS_CAMPAIGN_NAME' |
    'APPS.GOOGLE_ADWORDS_CUSTOMER_CLEARED' |
    'APPS.GOOGLE_ADWORDS_CUSTOMER_SET' |
    'APPS.GOOGLE_ANALYTICS.PAGE_PATH' |
    'APPS.GOOGLE_ANALYTICS_PAGE_PATH' |
    'APPS.GOOGLE_MY_BUSINESS.ACCOUNT_NAME' |
    'APPS.GOOGLE_MY_BUSINESS.ASYNC_DESCRIPTIONS.FETCHING_ACCOUNT_NAMES' |
    'APPS.GOOGLE_MY_BUSINESS.ASYNC_DESCRIPTIONS.FETCHING_CAN_CONFIGURE' |
    'APPS.GOOGLE_MY_BUSINESS.ASYNC_DESCRIPTIONS.FETCHING_LOCATION_NAMES' |
    'APPS.GOOGLE_MY_BUSINESS.ASYNC_DESCRIPTIONS.UPDATING_CONFIG' |
    'APPS.GOOGLE_MY_BUSINESS.CONFIG_UPDATED' |
    'APPS.GOOGLE_MY_BUSINESS.LOCATION_NAME' |
    'APPS.GOOGLE_MY_BUSINESS.LOCATION_NOT_ENABLED_HELP_TEXT_EXPLANATION' |
    'APPS.GOOGLE_MY_BUSINESS.LOCATION_NOT_ENABLED_HELP_TEXT_TITLE' |
    'APPS.GOOGLE_MY_BUSINESS.NO_ADDRESS' |
    'APPS.GOOGLE_MY_BUSINESS.STATES.DISABLED' |
    'APPS.GOOGLE_MY_BUSINESS.STATES.DISCONNECTED' |
    'APPS.GOOGLE_MY_BUSINESS.STATES.LOCAL_POST_API_DISABLED' |
    'APPS.GOOGLE_MY_BUSINESS.STATES.NEEDS_REVERIFICATION' |
    'APPS.GOOGLE_MY_BUSINESS.STATES.NOT_PUBLISHED' |
    'APPS.GOOGLE_MY_BUSINESS.STATES.NOT_VERIFIED' |
    'APPS.GOOGLE_MY_BUSINESS.STATES.PENDING_REVIEW' |
    'APPS.GOOGLE_MY_BUSINESS.STATES.PENDING_VERIFICATION' |
    'APPS.GOOGLE_MY_BUSINESS.STATES.SUSPENDED' |
    'APPS.GOOGLE_MY_BUSINESS.STATES.TEMPORARILY_ENABLED' |
    'APPS.GOOGLE_MY_BUSINESS.STATES.VERIFIED' |
    'APPS.INSTAGRAM.ACCOUNT_NOT_LISTED' |
    'APPS.INSTAGRAM.ACCOUNT_NOT_LISTED_EXPLANATION' |
    'APPS.INSTAGRAM.CONFIG_UPDATED_SUCCESS_MESSAGE' |
    'APPS.INSTAGRAM.CONNECTED_ACCOUNT' |
    'APPS.INSTAGRAM.CONNECTED_ACCOUNT_INFO' |
    'APPS.INSTAGRAM.FETCHING_CAN_CONFIGURE' |
    'APPS.INSTAGRAM.FETCH_AVAILABLE_INSTAGRAM_ACCOUNTS' |
    'APPS.INSTAGRAM.UPDATE_CONFIG' |
    'APPS.LINKEDIN.ASYNC_DESCRIPTIONS.FETCHING_CAN_CONFIGURE' |
    'APPS.LINKEDIN.ASYNC_DESCRIPTIONS.FETCHING_PAGE_NAMES' |
    'APPS.LINKEDIN.ASYNC_DESCRIPTIONS.UPDATING_CONFIG' |
    'APPS.LINKEDIN.CONFIG_UPDATED' |
    'APPS.LINKEDIN.PAGE_NAME' |
    'APPS.LINKEDIN.PAGE_NOT_LISTED' |
    'APPS.LINKEDIN.PAGE_NOT_LISTED_EXPLANATION' |
    'APPS.LINK_TO_GOOGLE_ADWORDS' |
    'APPS.MANUAL_ENTRY' |
    'APPS.NO_CAMPAIGNS_FOUND_IN_ADWORDS_THAT_MATCH_NAME' |
    'APPS.NO_FACEBOOK_PAGE_ACCESS_HEADING' |
    'APPS.PAGE_ID' |
    'APPS.PAGE_NAME' |
    'APPS.PLEASE_SELECT_AN_ADWORDS_CUSTOMER' |
    'APPS.PRINT_PROVIDER' |
    'APPS.PRINT_PROVIDER_SKU_GROUP_ATTACHED' |
    'APPS.PROPERTY_ID' |
    'APPS.REFRESH_MATCHING_CAMPAIGNS' |
    'APPS.THIS_WILL_MATCH_CAMPAIGNS_WITH_NAME_CONTAINING_TEXT' |
    'APPS.UPDATED_GOOGLE_ADWORDS_CAMPAIGN_NAME' |
    'APPS.UPDATE_GOOGLE_ADWORDS_CUSTOMER' |
    'ASSET_LIBRARY.AUTOMATICALLY_EXPIRE_THESE_ASSETS' |
    'ASSET_LIBRARY.BIN' |
    'ASSET_LIBRARY.BIN_ASSETS' |
    'ASSET_LIBRARY.CHOOSE_COLLECTION' |
    'ASSET_LIBRARY.CHOOSE_COLLECTION_REQUEST' |
    'ASSET_LIBRARY.COLLECTION_LIMIT_REACHED' |
    'ASSET_LIBRARY.COPY_ASSET_URL' |
    'ASSET_LIBRARY.CREATE_FOLDER_MODAL_TITLE' |
    'ASSET_LIBRARY.DELETE_COLLECTION_NOTE' |
    'ASSET_LIBRARY.DIFFERENT_EXPIRY_DATE_ALERT' |
    'ASSET_LIBRARY.DIFFERENT_EXPIRY_DATE_INFO' |
    'ASSET_LIBRARY.EDIT_FOLDER' |
    'ASSET_LIBRARY.EXPIRED_ASSETS' |
    'ASSET_LIBRARY.EXPLAIN' |
    'ASSET_LIBRARY.HIDE_BIN' |
    'ASSET_LIBRARY.LIST' |
    'ASSET_LIBRARY.MOVE_ASSETS_TO_FOLDER' |
    'ASSET_LIBRARY.MOVING_ASSETS' |
    'ASSET_LIBRARY.NEW_FOLDER' |
    'ASSET_LIBRARY.NO_ASSETS_IN_FOLDER' |
    'ASSET_LIBRARY.NO_COLLECTIONS_FOUND' |
    'ASSET_LIBRARY.PLEASE_SELECT_COLLECTION' |
    'ASSET_LIBRARY.REMOVE_EXPIRATION_DATE' |
    'ASSET_LIBRARY.RESTORE' |
    'ASSET_LIBRARY.SAVING_ASSETS' |
    'ASSET_LIBRARY.SEARCH_COLLECTIONS' |
    'ASSET_LIBRARY.SECURITY_WARNING' |
    'ASSET_LIBRARY.SECURITY_WARNING_DESCRIPTION' |
    'ASSET_LIBRARY.SELECTED_CLIENTS' |
    'ASSET_LIBRARY.SELECTED_LOCATIONS' |
    'ASSET_LIBRARY.SHARED_WITH' |
    'ASSET_LIBRARY.SHOW_BIN' |
    'ASSET_LIBRARY.THUMBNAIL' |
    'ASSET_LIBRARY.UNABLE_TO_LOAD' |
    'ASSET_LIBRARY.UPLOADING_ASSETS' |
    'ASSET_LIBRARY.UPLOAD_ASSET' |
    'BUILD.ACTUAL' |
    'BUILD.ADDRESS_NOT_SET' |
    'BUILD.AGENCY_FILTERS.HIDE_MOBILE' |
    'BUILD.AGENCY_FILTERS.HIDE_PUBLISHED' |
    'BUILD.AGENCY_FILTERS.HIDE_UNPUBLISHED' |
    'BUILD.AGENCY_FILTERS.IS_MULTI_IMAGE' |
    'BUILD.AGENCY_FILTERS.ONLY_LOCATION_DRAFTS' |
    'BUILD.AGENCY_FILTERS.ONLY_LOCATION_DRAFTS_BUTTON' |
    'BUILD.AGENCY_FILTERS.ONLY_MOBILE' |
    'BUILD.AGENCY_FILTERS.TITLE' |
    'BUILD.ALL_CLIENTS' |
    'BUILD.ALL_EDITABLE_ELEMENTS' |
    'BUILD.ALL_FORMATS' |
    'BUILD.ANIMATION.ADD_FRAME_AFTER' |
    'BUILD.ANIMATION.ADD_FRAME_BEFORE' |
    'BUILD.ANIMATION.ANIMATION' |
    'BUILD.ANIMATION.CONFIRM_DELETE_FRAME' |
    'BUILD.ANIMATION.DELETE_FRAME' |
    'BUILD.ANIMATION.DURATION' |
    'BUILD.ANIMATION.FRAME_NUMBER_OF_COUNT' |
    'BUILD.ANIMATION.PLAY' |
    'BUILD.ANIMATION.STOP' |
    'BUILD.ANIMATION.TOGGLE_ANIMATION_CONFIRM' |
    'BUILD.AT_LEAST_ONE_FORMAT_REQUIRED' |
    'BUILD.BACKGROUND' |
    'BUILD.BACK_TO_GALLERY' |
    'BUILD.BLEND_MODE.COLOR' |
    'BUILD.BLEND_MODE.DIFFERENCE' |
    'BUILD.BLEND_MODE.HARD_LIGHT' |
    'BUILD.BLEND_MODE.HUE' |
    'BUILD.BLEND_MODE.MULTIPLY' |
    'BUILD.BLEND_MODE.NORMAL' |
    'BUILD.BLEND_MODE.OVERLAY' |
    'BUILD.BLEND_MODE.SATURATION' |
    'BUILD.BLEND_MODE.SCREEN' |
    'BUILD.BLEND_MODE.SOFT_LIGHT' |
    'BUILD.BUILDER_MODE.ADVANCED' |
    'BUILD.BUILDER_MODE.SIMPLE' |
    'BUILD.BUILDER_TEMPLATE_DELETE_CONFIRMATION_MODAL.CONFIRMATION_MESSAGE' |
    'BUILD.BUILDER_TEMPLATE_DELETE_CONFIRMATION_MODAL.CONFIRMATION_MESSAGE_plural' |
    'BUILD.BUILDER_TEMPLATE_DELETE_CONFIRMATION_MODAL.TITLE' |
    'BUILD.BUILDER_TEMPLATE_UPDATE_CONFIRMATION_MODAL.AFFECTED_LOCATIONS' |
    'BUILD.BUILDER_TEMPLATE_UPDATE_CONFIRMATION_MODAL.CONFIRMATION_MESSAGE' |
    'BUILD.BUILDER_TEMPLATE_UPDATE_CONFIRMATION_MODAL.CONFIRMATION_MESSAGE_plural' |
    'BUILD.BUILDER_TEMPLATE_UPDATE_CONFIRMATION_MODAL.DELETE_LOCATION_DRAFTS' |
    'BUILD.BUILDER_TEMPLATE_UPDATE_CONFIRMATION_MODAL.KEEP_LOCATION_DRAFTS' |
    'BUILD.BUILDER_TEMPLATE_UPDATE_CONFIRMATION_MODAL.TITLE' |
    'BUILD.CANT_FIND_WHAT_YOU_ARE_LOOKING_FOR' |
    'BUILD.CHANNEL_DATA' |
    'BUILD.CMYK_COLOR_DISCLAIMER' |
    'BUILD.COLOR_PICKER.BLACK' |
    'BUILD.COLOR_PICKER.BLUE' |
    'BUILD.COLOR_PICKER.CMYK' |
    'BUILD.COLOR_PICKER.CMYK_HEADER' |
    'BUILD.COLOR_PICKER.CYAN' |
    'BUILD.COLOR_PICKER.GREEN' |
    'BUILD.COLOR_PICKER.HSL' |
    'BUILD.COLOR_PICKER.HUE' |
    'BUILD.COLOR_PICKER.LUM' |
    'BUILD.COLOR_PICKER.MAGENTA' |
    'BUILD.COLOR_PICKER.NAME' |
    'BUILD.COLOR_PICKER.OPACITY' |
    'BUILD.COLOR_PICKER.RED' |
    'BUILD.COLOR_PICKER.RGB' |
    'BUILD.COLOR_PICKER.RGB_HEADER' |
    'BUILD.COLOR_PICKER.SAT' |
    'BUILD.COLOR_PICKER.YELLOW' |
    'BUILD.COMPLETE' |
    'BUILD.CONFIRM_BUILDER_TEMPLATE_UPDATE' |
    'BUILD.CONFIRM_BUILDER_TEMPLATE_UPDATE_MESSAGE' |
    'BUILD.CONFIRM_DELETE_ALL_CHANNEL_DATA' |
    'BUILD.CUSTOM_IMAGE_REQUIRED' |
    'BUILD.CUSTOM_TEXT_REQUIRED' |
    'BUILD.DELETE_CONFIRMATION' |
    'BUILD.DELETE_TEMPLATE' |
    'BUILD.DESKTOP_VIEW' |
    'BUILD.DIMENSIONS' |
    'BUILD.DUPLICATE' |
    'BUILD.DUPLICATE_LAYER' |
    'BUILD.EDITABLE_ELEMENTS' |
    'BUILD.ELLIPSE' |
    'BUILD.EMAIL.AUTHORIZE_ON_APPS_PAGE' |
    'BUILD.EMAIL.BLACK_TEXT_EDITOR_BACKGROUND' |
    'BUILD.EMAIL.CANT_ADD_IMAGE_ELEMENT' |
    'BUILD.EMAIL.DEFAULT_INSTRUCTIONS' |
    'BUILD.EMAIL.EDIT_SOURCE' |
    'BUILD.EMAIL.EDIT_SOURCE_WARNING' |
    'BUILD.EMAIL.EMAIL_BUILDER' |
    'BUILD.EMAIL.EMAIL_PREVIEW' |
    'BUILD.EMAIL.FAILED_TO_PARSE_HTML' |
    'BUILD.EMAIL.FAILED_TO_PROCESS_ZIP_FILE' |
    'BUILD.EMAIL.FAILED_TO_READ_ZIP_FILE' |
    'BUILD.EMAIL.FAILED_TO_VALIDATE_ZIP_FILE' |
    'BUILD.EMAIL.IMAGE_EXCEEDS_RECOMMENDED_SIZE_WARNING' |
    'BUILD.EMAIL.IMAGE_TIMEOUT' |
    'BUILD.EMAIL.LOCATION_NOT_AUTHORIZED' |
    'BUILD.EMAIL.MAIL_MERGE' |
    'BUILD.EMAIL.NO_CAMPAGIN_MONITOR_SETUP_FOR_LOCATION' |
    'BUILD.EMAIL.PLEASE_ADDRESS_ISSUES_WITH_ZIP_FILE' |
    'BUILD.EMAIL.SELECT_ZIP_FILE' |
    'BUILD.EMAIL.UPDATE_PLANNER_STATUS' |
    'BUILD.EMAIL.UPLOAD_ONLY_ONE_PREVIEW' |
    'BUILD.EMAIL.UPLOAD_ONLY_ONE_ZIP_FILE' |
    'BUILD.EMAIL.VISIBILITY' |
    'BUILD.EMAIL.VISIBLE' |
    'BUILD.EMAIL.ZIP_FILE' |
    'BUILD.EMAIL.ZIP_VALIDATION.HTML_MISSING' |
    'BUILD.EMAIL.ZIP_VALIDATION.HTML_MULTIPLE' |
    'BUILD.EMAIL.ZIP_VALIDATION.IMAGE_MISSING' |
    'BUILD.EMAIL.ZIP_VALIDATION.IMAGE_UNREFERENCED' |
    'BUILD.EMAIL.ZIP_VALIDATION.PREVIEW_IMAGE_MISSING' |
    'BUILD.EMAIL.ZIP_VALIDATION.PREVIEW_IMAGE_MULTIPLE' |
    'BUILD.ERROR.DIMENSIONS_FOR_PNG_IN_PRINT_TEMPLATES_LIMITED' |
    'BUILD.ERROR.FAILED_TO_CREATE_TAG' |
    'BUILD.ERROR.FAILED_TO_DELETE_TEMPLATE' |
    'BUILD.ERROR.FAILED_TO_GET_CLIENTS' |
    'BUILD.ERROR.FAILED_TO_GET_LOCATION' |
    'BUILD.ERROR.FAILED_TO_RETRIEVE_BUILDER_TEMPLATE_FORMATS' |
    'BUILD.ERROR.FAILED_TO_RETRIEVE_TEMPLATE' |
    'BUILD.ERROR.FAILED_TO_SAVE_TEMPLATE' |
    'BUILD.ERROR.FAILED_TO_UPLOAD_IMAGES' |
    'BUILD.ERROR.FAILED_TO_UPLOAD_THUMBNAIL' |
    'BUILD.FEATURED_TEMPLATE_SETS' |
    'BUILD.FETCHING_BUILDER_TEMPLATE_INFO' |
    'BUILD.FIRST_COMMENT' |
    'BUILD.FIT' |
    'BUILD.FONTS.ADD_FONT' |
    'BUILD.FONTS.ADD_FONT_FOR_CLIENT' |
    'BUILD.FONTS.ARE_YOU_SURE_DELETE_FAMILY' |
    'BUILD.FONTS.CHECK_YOU_ARE_VIEWING_CORRECT_CLIENT' |
    'BUILD.FONTS.CONTEXT_ACTIONS' |
    'BUILD.FONTS.CREATE_FONT_INSTRUCTIONS' |
    'BUILD.FONTS.DELETE_FONT_FAMILY' |
    'BUILD.FONTS.ENTER_NEW_FONT_FAMILY' |
    'BUILD.FONTS.ERRORS.COULD_NOT_DELETE_FONT' |
    'BUILD.FONTS.ERRORS.ERROR_RENAMING' |
    'BUILD.FONTS.ERRORS.ISSUE_UPLOADING_FONT' |
    'BUILD.FONTS.ERROR_LOADING_FONTS' |
    'BUILD.FONTS.FILTER_FONTS' |
    'BUILD.FONTS.FONTS_MISSING' |
    'BUILD.FONTS.FONT_ACTIONS' |
    'BUILD.FONTS.FONT_DELETED' |
    'BUILD.FONTS.FONT_FAMILY' |
    'BUILD.FONTS.FONT_TYPE' |
    'BUILD.FONTS.FONT_UPLOADED' |
    'BUILD.FONTS.PLEASE_CONTACT_AGENCY_TO_FIX' |
    'BUILD.FONTS.RENAMED_FONT' |
    'BUILD.FONTS.SOME_FONTS_COULD_NOT_BE_LOADED' |
    'BUILD.FONTS.TEMPLATE_USES_MISSING_FONTS' |
    'BUILD.FORMATS_SELECTED' |
    'BUILD.FORMATS_SELECTED_plural' |
    'BUILD.FOUR51.NO_ACCESS_MODAL_MESSAGE' |
    'BUILD.FOUR51.NO_ACCESS_MODAL_TITLE' |
    'BUILD.GALLERY' |
    'BUILD.HIDE_DETAILS' |
    'BUILD.IMAGE.UNSUPPORTED_FORMAT' |
    'BUILD.IMAGE_CHOOSER.CONFIRM_ACKNOWLEDGED' |
    'BUILD.IMAGE_CHOOSER.CONFIRM_PERMISSION' |
    'BUILD.IMAGE_CHOOSER.IMAGE_SOURCE' |
    'BUILD.IMAGE_CHOOSER.LOCAL_FILE' |
    'BUILD.IMAGE_CHOOSER.LOCATION_LOGO' |
    'BUILD.IMAGE_CHOOSER.MAX_UPLOAD_ERROR' |
    'BUILD.IMAGE_CHOOSER.PERMISSION_DISCLAIMER' |
    'BUILD.IMAGE_CHOOSER.PERMISSION_DISCLAIMER_STRONG' |
    'BUILD.IMAGE_CHOOSER.PERMISSION_ERROR' |
    'BUILD.IMAGE_CHOOSER.SELECT_IMAGE' |
    'BUILD.IMAGE_CHOOSER.SELECT_IMAGE_FROM_YOUR_LIBRARY' |
    'BUILD.IMAGE_CHOOSER.SUGGESTED_COLLECTION' |
    'BUILD.IMAGE_CHOOSER.UPLOADED_ASSET_IMAGE' |
    'BUILD.IMAGE_CHOOSER.UPLOADED_PLANNER_IMAGE' |
    'BUILD.IMAGE_CHOOSER.UPLOAD_IMAGE_FROM_YOUR_DEVICE' |
    'BUILD.IMAGE_CROPPER.CLEAR' |
    'BUILD.IMAGE_CROPPER.CROP_IMAGE' |
    'BUILD.IMAGE_CROPPER.ROTATE' |
    'BUILD.IMAGE_CROPPER_PROMPT_MESSAGE' |
    'BUILD.IMAGE_FORMAT_NAME.JPG_LIMITED_FILE_SIZE' |
    'BUILD.IMAGE_MUST_BE_EDITABLE' |
    'BUILD.IMAGE_RESOLUTION_PICKER.CONFIRM_DPI' |
    'BUILD.IMAGE_RESOLUTION_PICKER.DPI' |
    'BUILD.IMAGE_RESOLUTION_PICKER.DPI_IS_REQUIRED' |
    'BUILD.IMAGE_RESOLUTION_PICKER.IMAGE_RESOLUTION' |
    'BUILD.IMAGE_SELECTED' |
    'BUILD.KEYBOARD_SHORTCUTS_REFERENCE' |
    'BUILD.KEYWORD_SEARCH' |
    'BUILD.LANDSCAPE' |
    'BUILD.LAYERS' |
    'BUILD.LEAVE_PAGE_PROMPT.CONFIRM' |
    'BUILD.LEAVE_PAGE_PROMPT.TITLE' |
    'BUILD.LOCATION_DETAILS_MISSING_MESSAGE' |
    'BUILD.LOCATION_DRAFT.ARE_YOU_SURE_YOU_WANT_TO_OVERRIDE_TEMPLATE_REVISION_WITH_TITLE' |
    'BUILD.LOCATION_DRAFT.CONFIRM_DELETE' |
    'BUILD.LOCATION_DRAFT.CONFIRM_DELETE_TITLE' |
    'BUILD.LOCATION_DRAFT.CREATED_LOCATION_DRAFT' |
    'BUILD.LOCATION_DRAFT.ENTER_NAME_FOR_NEW_TEMPLATE_REVISION' |
    'BUILD.LOCATION_DRAFT.LOAD_A_PREVIOUS_REVISION' |
    'BUILD.LOCATION_DRAFT.LOAD_A_PREVIOUS_TEMPLATE_REVISION' |
    'BUILD.LOCATION_DRAFT.PLEASE_CONFIRM_LOCATION_REVISION_SAVE' |
    'BUILD.LOCATION_DRAFT.SAVE_AS_A_NEW_REVISION' |
    'BUILD.LOCATION_DRAFT.SAVE_LOCATION_REVISION' |
    'BUILD.LOCATION_DRAFT.SAVE_LOCATION_REVISION_WITH_TITLE' |
    'BUILD.LOCATION_DRAFT.SAVE_OVER_CURRENT_REVISION_WITH_TITLE' |
    'BUILD.LOCATION_DRAFT.TEMPLATE_HAS_DRAFT_TOOLTIP' |
    'BUILD.LOCATION_DRAFT.UPDATED_AT' |
    'BUILD.LOCATION_DRAFT.UPDATED_LOCATION_DRAFT' |
    'BUILD.LOCATION_EMAIL_NOT_SET' |
    'BUILD.LOCATION_LOGO_NOT_SET' |
    'BUILD.LOCATION_MAP_NOT_CREATED' |
    'BUILD.LOOPING' |
    'BUILD.LOOP_FOREVER' |
    'BUILD.LOWERCASE' |
    'BUILD.MAKE_TEMPLATE_ONLY_AVAILABLE_FOR_MOBILE_APP' |
    'BUILD.MAP.PIN' |
    'BUILD.MAXIMUM_FILE_SIZE_KB' |
    'BUILD.MEMBER_ENGAGER.ASSIGN_TO_MULTIPLE_LOCATIONS' |
    'BUILD.MEMBER_ENGAGER.AUTOMATED_EMAIL' |
    'BUILD.MEMBER_ENGAGER.AUTOMATED_EMAILS' |
    'BUILD.MEMBER_ENGAGER.DIRECT_EMAIL_TITLE' |
    'BUILD.MEMBER_ENGAGER.EDIT_CONTENT' |
    'BUILD.MEMBER_ENGAGER.EDIT_SUBJECT' |
    'BUILD.MEMBER_ENGAGER.FAILED_TO_LOAD_AUTOMATED_EMAIL' |
    'BUILD.MEMBER_ENGAGER.FAILED_TO_LOAD_AUTOMATED_EMAILS' |
    'BUILD.MEMBER_ENGAGER.FIND_NEW_TEMPLATE' |
    'BUILD.MEMBER_ENGAGER.NO_DIRECT_EMAIL_TEMPLATES_FOUND' |
    'BUILD.MEMBER_ENGAGER.SCHEDULED_EMAIL' |
    'BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS' |
    'BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.DELETE_MESSAGE_LINE_1' |
    'BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.DELETE_MESSAGE_LINE_2' |
    'BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.DELETE_SCHEDULED_EMAIL_API_ERROR' |
    'BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.NO_SCHEDULED_EMAILS' |
    'BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.PREVIEW' |
    'BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.SCHEDULED_EMAIL_ALREADY_DELETED' |
    'BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.SCHEDULED_EMAIL_DELETED' |
    'BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.SCHEDULED_EMAIL_NOT_FOUND' |
    'BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.TABLE.LISTS' |
    'BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.TABLE.SCHEDULED' |
    'BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.TABLE.SUBJECT' |
    'BUILD.MEMBER_ENGAGER.TITLE' |
    'BUILD.METRICS.EM' |
    'BUILD.METRICS.POINTS' |
    'BUILD.METRICS.POINTS_SHORT' |
    'BUILD.MILLISECONDS_SHORT' |
    'BUILD.MOBILE_APP_TEMPLATE' |
    'BUILD.MOBILE_APP_TEMPLATE_VALIDATION.ANIMATION_PRESENT' |
    'BUILD.MOBILE_APP_TEMPLATE_VALIDATION.MAP_LAYER_PRESENT' |
    'BUILD.MOBILE_APP_TEMPLATE_VALIDATION.NOT_MOBILE_COMPATIBLE' |
    'BUILD.MOBILE_APP_TEMPLATE_VALIDATION.UNSUPPORTED_BUILDER_TEMPLATE_FORMAT' |
    'BUILD.MOBILE_APP_TEMPLATE_VALIDATION.UNSUPPORTED_DOCUMENT_FORMAT' |
    'BUILD.MOBILE_APP_TEMPLATE_VALIDATION.UNSUPPORTED_EDITABLE_FIELDS' |
    'BUILD.MOBILE_INFO' |
    'BUILD.MOBILE_VIEW' |
    'BUILD.MOVE_DOWN' |
    'BUILD.MOVE_UP' |
    'BUILD.MULTI_IMAGE.MULI_IMAGE_COUNTER_TOOLTIP' |
    'BUILD.MULTI_IMAGE.MULI_IMAGE_COUNTER_TOOLTIP_plural' |
    'BUILD.MULTI_IMAGE.MULTI_IMAGE' |
    'BUILD.MULTI_IMAGE.MULTI_IMAGE_TEMPLATE' |
    'BUILD.MULTI_IMAGE.NOTIFIER_EXPLANATION' |
    'BUILD.MULTI_IMAGE.REMOVE_IMAGE.MESSAGE' |
    'BUILD.MULTI_IMAGE.REMOVE_IMAGE.TITLE' |
    'BUILD.MUST_VIEW_ALL_FRAMES' |
    'BUILD.MUST_VIEW_ALL_IMAGES' |
    'BUILD.MUST_VIEW_ALL_PAGES' |
    'BUILD.NEW_TEMPLATE' |
    'BUILD.NEW_TEMPLATE_EMAIL' |
    'BUILD.NEW_TEMPLATE_IMAGE' |
    'BUILD.NEW_TEMPLATE_PRINT' |
    'BUILD.NEW_TEMPLATE_VIDEO' |
    'BUILD.NOTIFY_TEXT_PLACEHOLDER_EXISTS' |
    'BUILD.NO_CONTENT' |
    'BUILD.OPTIMIZING_IMAGE' |
    'BUILD.ORIGINAL_TEMPLATE' |
    'BUILD.OVERLAYS.IMAGE_LAYER' |
    'BUILD.OVERLAYS.MAP_LAYER' |
    'BUILD.OVERLAYS.VIDEO_LAYER' |
    'BUILD.PHONE_NUMBER_NOT_SET' |
    'BUILD.PLACEHOLDER' |
    'BUILD.PLACEHOLDERS' |
    'BUILD.PLANNER_DETAILS' |
    'BUILD.PLATFORM' |
    'BUILD.PORTRAIT' |
    'BUILD.POSITION_X' |
    'BUILD.POSITION_Y' |
    'BUILD.PREVIEW_IMAGE' |
    'BUILD.PRINT.ADD_PAGE_AFTER' |
    'BUILD.PRINT.ADD_PAGE_BEFORE' |
    'BUILD.PRINT.BLEED' |
    'BUILD.PRINT.CONFIRM_DELETE_PAGE' |
    'BUILD.PRINT.DELETE_PAGE' |
    'BUILD.PRINT.EXTRA_INFO' |
    'BUILD.PRINT.PAGE_NUMBER' |
    'BUILD.PRINT.PAGE_NUMBER_OF_COUNT' |
    'BUILD.PRINT.PLEASE_ENTER_PAGE_NUMBER_BETWEEN' |
    'BUILD.PRINT.SELECT_AT_LEAST_ONE_FORMAT' |
    'BUILD.PRINT.WHICH_PAGE_TO_COPY_LAYER_TO' |
    'BUILD.PROPERTIES' |
    'BUILD.PUBLISH.ALREADY_SCHEDULED' |
    'BUILD.PUBLISH.CAMPAIGN_MONITOR.CAMPAIGN_NAME' |
    'BUILD.PUBLISH.CAMPAIGN_MONITOR.CONFIRMATION_EMAIL_ADDRESS' |
    'BUILD.PUBLISH.CAMPAIGN_MONITOR.FROM_EMAIL' |
    'BUILD.PUBLISH.CAMPAIGN_MONITOR.FROM_NAME' |
    'BUILD.PUBLISH.CAMPAIGN_MONITOR.IN_CAMPAIGN_MONITOR_ACCOUNTS_TIMEZONE' |
    'BUILD.PUBLISH.CAMPAIGN_MONITOR.LISTS' |
    'BUILD.PUBLISH.CAMPAIGN_MONITOR.NOTIFY_PUBLISH_SUCCESS' |
    'BUILD.PUBLISH.CAMPAIGN_MONITOR.NO_LISTS_FOUND_SET_UP_YOUR_MAILING_LISTS' |
    'BUILD.PUBLISH.CAMPAIGN_MONITOR.NO_SEGMENTS_FOUND' |
    'BUILD.PUBLISH.CAMPAIGN_MONITOR.PREVIEW' |
    'BUILD.PUBLISH.CAMPAIGN_MONITOR.PREVIEW_SEND' |
    'BUILD.PUBLISH.CAMPAIGN_MONITOR.PREVIEW_SKIP' |
    'BUILD.PUBLISH.CAMPAIGN_MONITOR.PUBLISH_TO_CAMPAIGN_MONITOR' |
    'BUILD.PUBLISH.CAMPAIGN_MONITOR.RECIPIENTS' |
    'BUILD.PUBLISH.CAMPAIGN_MONITOR.REPLY_TO' |
    'BUILD.PUBLISH.CAMPAIGN_MONITOR.SAVE_DRAFT' |
    'BUILD.PUBLISH.CAMPAIGN_MONITOR.SEGMENTS' |
    'BUILD.PUBLISH.CAMPAIGN_MONITOR.SEND' |
    'BUILD.PUBLISH.CAMPAIGN_MONITOR.SUBJECT' |
    'BUILD.PUBLISH.CLUB_READY.ACTIVE' |
    'BUILD.PUBLISH.CLUB_READY.ACTIVE_MEMBERS' |
    'BUILD.PUBLISH.CLUB_READY.ADDED_AT_ANY_TIME' |
    'BUILD.PUBLISH.CLUB_READY.ADDED_BETWEEN' |
    'BUILD.PUBLISH.CLUB_READY.AFTER' |
    'BUILD.PUBLISH.CLUB_READY.ALL_ACTIVE_MEMBERS' |
    'BUILD.PUBLISH.CLUB_READY.ALL_INACTIVE_MEMBERS' |
    'BUILD.PUBLISH.CLUB_READY.AT_LEAST_ONE_LIST_MUST_BE_SELECTED' |
    'BUILD.PUBLISH.CLUB_READY.BEFORE' |
    'BUILD.PUBLISH.CLUB_READY.CLUB' |
    'BUILD.PUBLISH.CLUB_READY.COOLED_OFF_PROSPECTS' |
    'BUILD.PUBLISH.CLUB_READY.CUSTOM' |
    'BUILD.PUBLISH.CLUB_READY.CUSTOM_LIST_DESCRIPTION_PLACEHOLDER' |
    'BUILD.PUBLISH.CLUB_READY.CUSTOM_LIST_DESCRIPTION_WARNING' |
    'BUILD.PUBLISH.CLUB_READY.CUSTOM_LIST_MATCHES' |
    'BUILD.PUBLISH.CLUB_READY.CUSTOM_LIST_OF_EMAIL_ADDRESSES' |
    'BUILD.PUBLISH.CLUB_READY.CUSTOM_LIST_OF_EMAIL_ADDRESSES_WARNING' |
    'BUILD.PUBLISH.CLUB_READY.DISABLED_PUBLISH_HELP_TEXT' |
    'BUILD.PUBLISH.CLUB_READY.DUPLICATE_EMAILS' |
    'BUILD.PUBLISH.CLUB_READY.EMAIL_LIST_MUST_HAVE_VALUES' |
    'BUILD.PUBLISH.CLUB_READY.EMAIL_SUBJECT_AND_SCHEDULE' |
    'BUILD.PUBLISH.CLUB_READY.EXPORT_INFO' |
    'BUILD.PUBLISH.CLUB_READY.EXPORT_TITLE' |
    'BUILD.PUBLISH.CLUB_READY.FILTERED' |
    'BUILD.PUBLISH.CLUB_READY.INACTIVE' |
    'BUILD.PUBLISH.CLUB_READY.INACTIVE_MEMBERS' |
    'BUILD.PUBLISH.CLUB_READY.INVALID' |
    'BUILD.PUBLISH.CLUB_READY.I_CONFIRM_THAT_THE_ABOVE_DETAILS_ARE_CORRECT' |
    'BUILD.PUBLISH.CLUB_READY.MATCHED_OUT_OF' |
    'BUILD.PUBLISH.CLUB_READY.MEMBER_LIST_NOTICE' |
    'BUILD.PUBLISH.CLUB_READY.MORE_CLUB_COUNT' |
    'BUILD.PUBLISH.CLUB_READY.MORE_CLUB_COUNT_plural' |
    'BUILD.PUBLISH.CLUB_READY.NOT_INTERESTED' |
    'BUILD.PUBLISH.CLUB_READY.NO_SENDER_INFO_FOR_ONE_OR_MORE_LOCATIONS' |
    'BUILD.PUBLISH.CLUB_READY.NO_SENDER_INFO_HAS_BEEN_SET_FOR_LOCATION' |
    'BUILD.PUBLISH.CLUB_READY.ONE_OR_MORE_LISTS_DISABLED_MESSAGE' |
    'BUILD.PUBLISH.CLUB_READY.OPTOUT' |
    'BUILD.PUBLISH.CLUB_READY.PASTE_EMAIL_ADDRESSES_BELOW' |
    'BUILD.PUBLISH.CLUB_READY.PREVIEW_EMAIL_FAILED' |
    'BUILD.PUBLISH.CLUB_READY.PREVIEW_EMAIL_SENT' |
    'BUILD.PUBLISH.CLUB_READY.PROSPECTS' |
    'BUILD.PUBLISH.CLUB_READY.PROSPECTS_PAST_30_DAYS' |
    'BUILD.PUBLISH.CLUB_READY.PUBLISH_DELAY_WARNING_MESSAGE' |
    'BUILD.PUBLISH.CLUB_READY.REFETCH_VERIFY' |
    'BUILD.PUBLISH.CLUB_READY.SELECTED_LISTS_DOES_NOT_CONTAIN_ENOUGH_USERS_TO_SEND_TO' |
    'BUILD.PUBLISH.CLUB_READY.SELECTED_LISTS_DOES_NOT_CONTAIN_ENOUGH_USERS_TO_SEND_TO_plural' |
    'BUILD.PUBLISH.CLUB_READY.SELECTED_LISTS_SUMMARY' |
    'BUILD.PUBLISH.CLUB_READY.SELECTED_MEMBERS_AND_OR_PROSPECTS' |
    'BUILD.PUBLISH.CLUB_READY.SELECT_YOUR_CLUB_READY_LISTS' |
    'BUILD.PUBLISH.CLUB_READY.SENDER' |
    'BUILD.PUBLISH.CLUB_READY.SENDER_NOT_VERIFIED_MESSAGE' |
    'BUILD.PUBLISH.CLUB_READY.SENDER_NOT_VERIFIED_TOOLTIP' |
    'BUILD.PUBLISH.CLUB_READY.SENDER_VERIFIED_TOOLTIP' |
    'BUILD.PUBLISH.CLUB_READY.SEND_A_TEST_EMAIL' |
    'BUILD.PUBLISH.CLUB_READY.SEND_TO' |
    'BUILD.PUBLISH.CLUB_READY.SEND_TO_CLUB_READY_LIST' |
    'BUILD.PUBLISH.CLUB_READY.SEND_TO_INFO' |
    'BUILD.PUBLISH.CLUB_READY.SUBJECT' |
    'BUILD.PUBLISH.CLUB_READY.SUPPRESSED_LIST_INFO' |
    'BUILD.PUBLISH.CLUB_READY.TOTAL' |
    'BUILD.PUBLISH.CLUB_READY.VALID_DATE_REQUIRED_ACTIVITY_AFTER_OPTION' |
    'BUILD.PUBLISH.CLUB_READY.VALID_DATE_REQUIRED_ACTIVITY_BEFORE_OPTION' |
    'BUILD.PUBLISH.CLUB_READY.VALID_DATE_REQUIRED_ACTIVITY_BETWEEN_OPTION' |
    'BUILD.PUBLISH.CLUB_READY.WARN_PUBLISH_TOO_LARGE' |
    'BUILD.PUBLISH.CLUB_READY.WHEN_WOULD_YOU_LIKE_TO_SEND_THIS_EMAIL' |
    'BUILD.PUBLISH.CLUB_READY.WITH_ACTIVITY_AFTER' |
    'BUILD.PUBLISH.CLUB_READY.WITH_ACTIVITY_BEFORE' |
    'BUILD.PUBLISH.CONGRATULATIONS' |
    'BUILD.PUBLISH.CURRENTLY_SELECTED' |
    'BUILD.PUBLISH.DOWNLOAD_TO_YOUR_COMPUTER' |
    'BUILD.PUBLISH.EXPORT_OPTIONS' |
    'BUILD.PUBLISH.FACEBOOK.ACCESS_CHECK_FAILURE' |
    'BUILD.PUBLISH.FACEBOOK.CAPTION' |
    'BUILD.PUBLISH.FACEBOOK.CAPTION_HELP_TEXT' |
    'BUILD.PUBLISH.FACEBOOK.FACEBOOK_PAGE' |
    'BUILD.PUBLISH.FACEBOOK.HASHTAGS_HELP_TEXT_CAPTION' |
    'BUILD.PUBLISH.FACEBOOK.HASHTAGS_HELP_TEXT_FIRST_COMMENT' |
    'BUILD.PUBLISH.FACEBOOK.HEADERS.POST_DETAILS' |
    'BUILD.PUBLISH.FACEBOOK.HEADERS.POST_SCHEDULE' |
    'BUILD.PUBLISH.FACEBOOK.INPUT_LABELS.DISPLAY_HASHTAGS_IN' |
    'BUILD.PUBLISH.FACEBOOK.INPUT_LABELS.DISPLAY_HASHTAGS_IN_CAPTION' |
    'BUILD.PUBLISH.FACEBOOK.INPUT_LABELS.DISPLAY_HASHTAGS_IN_FIRST_COMMENT' |
    'BUILD.PUBLISH.FACEBOOK.INPUT_LABELS.HASHTAGS' |
    'BUILD.PUBLISH.FACEBOOK.PAGES_COUNT' |
    'BUILD.PUBLISH.FACEBOOK.PAGES_COUNT_plural' |
    'BUILD.PUBLISH.FACEBOOK.PAGE_LIST_REMAINING' |
    'BUILD.PUBLISH.FACEBOOK.PAGE_LIST_REMAINING_plural' |
    'BUILD.PUBLISH.FACEBOOK.PUBLISH_TO_FACEBOOK' |
    'BUILD.PUBLISH.FACEBOOK.PUBLISH_VIDEO_TO_FACEBOOK' |
    'BUILD.PUBLISH.FACEBOOK.SCHEDULED_FACEBOOK_POST_MUST_BE_NO_MORE_THAN_28_DAYS_IN_FUTURE' |
    'BUILD.PUBLISH.FACEBOOK.SUGGESTED_CAPTION' |
    'BUILD.PUBLISH.FETCH_FILE_SIZE_OPTIONS' |
    'BUILD.PUBLISH.FINAL_CONFIRMATION' |
    'BUILD.PUBLISH.FITWARE.AUTOMATED_EMAIL_CATEGORIES_FAILED_TO_LOAD' |
    'BUILD.PUBLISH.FITWARE.AUTOMATED_EMAIL_CATEGORY' |
    'BUILD.PUBLISH.FITWARE.AUTOMATED_EMAIL_CATEGORY_MISSING_IN_SOME_LOCATIONS_HELP_TEXT' |
    'BUILD.PUBLISH.FITWARE.AUTOMATED_EMAIL_UPDATED_DESCRIPTION' |
    'BUILD.PUBLISH.FITWARE.AUTOMATED_EMAIL_UPDATED_TITLE' |
    'BUILD.PUBLISH.FITWARE.CONFIRM_DECLARATION' |
    'BUILD.PUBLISH.FITWARE.DIRECT_EMAIL_PLATFORM_HELP_TEXT' |
    'BUILD.PUBLISH.FITWARE.DIRECT_EMAIL_PLATFORM_LABEL' |
    'BUILD.PUBLISH.FITWARE.FITWARE_AUTOMATED_EMAIL' |
    'BUILD.PUBLISH.FITWARE.FITWARE_AUTOMATED_EMAIL_HELP_TEXT' |
    'BUILD.PUBLISH.FITWARE.MEMBER_LISTS' |
    'BUILD.PUBLISH.FITWARE.MEMBER_LISTS_FAILED_TO_LOAD' |
    'BUILD.PUBLISH.FITWARE.NO_MEMBER_LISTS_FOUND' |
    'BUILD.PUBLISH.FITWARE.PLATFORMS_HEADING' |
    'BUILD.PUBLISH.FITWARE.PREVIEW' |
    'BUILD.PUBLISH.FITWARE.PREVIEW_EMAIL_ADDRESS' |
    'BUILD.PUBLISH.FITWARE.PREVIEW_SEND' |
    'BUILD.PUBLISH.FITWARE.PREVIEW_SKIP' |
    'BUILD.PUBLISH.FITWARE.PUBLISH_TO_FITWARE' |
    'BUILD.PUBLISH.FITWARE.RETURN_TO_MEMBER_ENGAGER' |
    'BUILD.PUBLISH.FITWARE.SCHEDULED_TIME' |
    'BUILD.PUBLISH.FITWARE.SEND' |
    'BUILD.PUBLISH.FITWARE.SENDER' |
    'BUILD.PUBLISH.FITWARE.SENDER_plural' |
    'BUILD.PUBLISH.FITWARE.STEP_TITLES.AUTOMATED_EMAIL_CATEGORY' |
    'BUILD.PUBLISH.FITWARE.STEP_TITLES.MEMBER_LISTS' |
    'BUILD.PUBLISH.FITWARE.STEP_TITLES.PUBLISHING' |
    'BUILD.PUBLISH.FITWARE.STEP_TITLES.SCHEDULED_TIME' |
    'BUILD.PUBLISH.FITWARE.STEP_TITLES.SEND_PREVIEW' |
    'BUILD.PUBLISH.FITWARE.STEP_TITLES.SUBJECT' |
    'BUILD.PUBLISH.FITWARE.STEP_TITLES.SUMMARY' |
    'BUILD.PUBLISH.FITWARE.SUBJECT' |
    'BUILD.PUBLISH.GOOGLE_MY_BUSINESS.ACCESS_CHECK_FAILURE' |
    'BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUSINESS_LOCATION' |
    'BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_LINK' |
    'BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_TYPE' |
    'BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_TYPES.BOOK' |
    'BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_TYPES.CALL' |
    'BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_TYPES.LEARN_MORE' |
    'BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_TYPES.ORDER' |
    'BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_TYPES.SHOP' |
    'BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_TYPES.SIGN_UP' |
    'BUILD.PUBLISH.GOOGLE_MY_BUSINESS.CALL_TO_ACTION' |
    'BUILD.PUBLISH.GOOGLE_MY_BUSINESS.CANNOT_START_EVENT_BEFORE_SCHEDULED_TIME' |
    'BUILD.PUBLISH.GOOGLE_MY_BUSINESS.CANNOT_START_OFFER_BEFORE_SCHEDULED_TIME' |
    'BUILD.PUBLISH.GOOGLE_MY_BUSINESS.CHARACTER_LIMIT_REACHED' |
    'BUILD.PUBLISH.GOOGLE_MY_BUSINESS.EVENT_DESCRIPTION' |
    'BUILD.PUBLISH.GOOGLE_MY_BUSINESS.EVENT_TITLE' |
    'BUILD.PUBLISH.GOOGLE_MY_BUSINESS.OFFER_CODE' |
    'BUILD.PUBLISH.GOOGLE_MY_BUSINESS.OFFER_DESCRIPTION' |
    'BUILD.PUBLISH.GOOGLE_MY_BUSINESS.OFFER_LINK' |
    'BUILD.PUBLISH.GOOGLE_MY_BUSINESS.OFFER_TITLE' |
    'BUILD.PUBLISH.GOOGLE_MY_BUSINESS.POST_BODY' |
    'BUILD.PUBLISH.GOOGLE_MY_BUSINESS.POST_TYPE' |
    'BUILD.PUBLISH.GOOGLE_MY_BUSINESS.POST_TYPES.EVENT' |
    'BUILD.PUBLISH.GOOGLE_MY_BUSINESS.POST_TYPES.OFFER' |
    'BUILD.PUBLISH.GOOGLE_MY_BUSINESS.POST_TYPES.PRODUCT' |
    'BUILD.PUBLISH.GOOGLE_MY_BUSINESS.POST_TYPES.STANDARD' |
    'BUILD.PUBLISH.GOOGLE_MY_BUSINESS.PUBLISH_TO_GOOGLE_MY_BUSINESS' |
    'BUILD.PUBLISH.GOOGLE_MY_BUSINESS.TERMS_AND_CONDITIONS' |
    'BUILD.PUBLISH.GO_BACK_CONFIRM_MESSAGE' |
    'BUILD.PUBLISH.GO_BACK_CONFIRM_TITLE' |
    'BUILD.PUBLISH.HASHTAGS.CLIENT_HASHTAGS' |
    'BUILD.PUBLISH.HASHTAGS.ERROR_LIMIT_HASHTAG_COUNT' |
    'BUILD.PUBLISH.HASHTAGS.ERROR_LIMIT_HASHTAG_COUNT_plural' |
    'BUILD.PUBLISH.HASHTAGS.ERROR_LIMIT_HASHTAG_LENGTH' |
    'BUILD.PUBLISH.HASHTAGS.ERROR_LIMIT_HASHTAG_SET' |
    'BUILD.PUBLISH.HASHTAGS.HASHTAG_CHARACTER_COUNT' |
    'BUILD.PUBLISH.HASHTAGS.HASHTAG_SET_ALREADY_ADDED' |
    'BUILD.PUBLISH.HASHTAGS.HASHTAG_TAG_COUNT' |
    'BUILD.PUBLISH.HASHTAGS.LOCATION_HASHTAGS' |
    'BUILD.PUBLISH.HASHTAGS.NO_HASHTAG_SETS' |
    'BUILD.PUBLISH.HASHTAGS.USE_HASHTAG_SETS' |
    'BUILD.PUBLISH.IMAGE_FORMAT' |
    'BUILD.PUBLISH.INCLUDE_BLEED_AND_TRIM_MARKS' |
    'BUILD.PUBLISH.INCLUDE_BLEED_AND_TRIM_MARKS_DISCLAIMER' |
    'BUILD.PUBLISH.INCLUDE_BLEED_AND_TRIM_MARKS_HELP' |
    'BUILD.PUBLISH.INSTAGRAM.ACCESS_CHECK_FAILURE' |
    'BUILD.PUBLISH.INSTAGRAM.APP_NOTIFICATIONS_DISABLED' |
    'BUILD.PUBLISH.INSTAGRAM.APP_NOT_INSTALLED' |
    'BUILD.PUBLISH.INSTAGRAM.APP_SETUP_PROPERLY' |
    'BUILD.PUBLISH.INSTAGRAM.APP_USER_REQUIRED' |
    'BUILD.PUBLISH.INSTAGRAM.ASPECT_RATIO_HELP_TEXT' |
    'BUILD.PUBLISH.INSTAGRAM.ASPECT_RATIO_STORY_HELP_TEXT' |
    'BUILD.PUBLISH.INSTAGRAM.ASPECT_RATIO_VIDEO_HELP_TEXT' |
    'BUILD.PUBLISH.INSTAGRAM.ASSIGN_USER_TO_POST' |
    'BUILD.PUBLISH.INSTAGRAM.AS_THE_FIRST_COMMENT_ON_THE_POST' |
    'BUILD.PUBLISH.INSTAGRAM.AT_THE_BOTTOM_ON_THE_POST_CAPTION' |
    'BUILD.PUBLISH.INSTAGRAM.CAPTION' |
    'BUILD.PUBLISH.INSTAGRAM.CAPTION_HELP_TEXT' |
    'BUILD.PUBLISH.INSTAGRAM.ENTER_VALID_MOBILE_NUMBER' |
    'BUILD.PUBLISH.INSTAGRAM.EXCEEDED_MAX_IMAGE_COUNT_HELP_TEXT' |
    'BUILD.PUBLISH.INSTAGRAM.HASHTAGS_HELP_TEXT_CAPTION' |
    'BUILD.PUBLISH.INSTAGRAM.HASHTAGS_HELP_TEXT_FIRST_COMMENT' |
    'BUILD.PUBLISH.INSTAGRAM.HEADERS.POST_DETAILS' |
    'BUILD.PUBLISH.INSTAGRAM.HEADERS.POST_SCHEDULE' |
    'BUILD.PUBLISH.INSTAGRAM.INPUT_LABELS.DISPLAY_HASHTAGS_IN' |
    'BUILD.PUBLISH.INSTAGRAM.INPUT_LABELS.DISPLAY_HASHTAGS_IN_CAPTION' |
    'BUILD.PUBLISH.INSTAGRAM.INPUT_LABELS.DISPLAY_HASHTAGS_IN_FIRST_COMMENT' |
    'BUILD.PUBLISH.INSTAGRAM.INPUT_LABELS.HASHTAGS' |
    'BUILD.PUBLISH.INSTAGRAM.INSTAGRAM_PAGE' |
    'BUILD.PUBLISH.INSTAGRAM.INVALID_DIMENSIONS_HEIGHT_HELP_TEXT' |
    'BUILD.PUBLISH.INSTAGRAM.INVALID_DIMENSIONS_WIDTH_HELP_TEXT' |
    'BUILD.PUBLISH.INSTAGRAM.MISSING_PERMISSIONS_HELP_TEXT' |
    'BUILD.PUBLISH.INSTAGRAM.MOBILE_NUMBER' |
    'BUILD.PUBLISH.INSTAGRAM.MOBILE_NUMBER_INFO' |
    'BUILD.PUBLISH.INSTAGRAM.NOTIFICATION_FOR_INSTAGRAM' |
    'BUILD.PUBLISH.INSTAGRAM.NOTIFICATION_SCHEDULE' |
    'BUILD.PUBLISH.INSTAGRAM.POSTS_FROM_MOBILE_HINT' |
    'BUILD.PUBLISH.INSTAGRAM.POSTS_WILL_EXPIRE' |
    'BUILD.PUBLISH.INSTAGRAM.POSTS_WILL_EXPIRE_plural' |
    'BUILD.PUBLISH.INSTAGRAM.PUBLISH_IMAGE_TO_INSTAGRAM' |
    'BUILD.PUBLISH.INSTAGRAM.PUBLISH_STORY_TO_INSTAGRAM' |
    'BUILD.PUBLISH.INSTAGRAM.PUBLISH_VIDEO_TO_INSTAGRAM' |
    'BUILD.PUBLISH.INSTAGRAM.SCHEDULED_INSTAGRAM_POST_MUST_BE_NO_MORE_THAN_75_DAYS_IN_FUTURE' |
    'BUILD.PUBLISH.INSTAGRAM.SCHEDULED_POST_MUST_BE_AT_LEAST_MINS_IN_FUTURE' |
    'BUILD.PUBLISH.INSTAGRAM.SCHEDULE_FOR_INSTAGRAM' |
    'BUILD.PUBLISH.INSTAGRAM.SCHEDULE_FOR_INSTAGRAM_STORY' |
    'BUILD.PUBLISH.INSTAGRAM.SCHEDULE_IMAGE_VIA_API' |
    'BUILD.PUBLISH.INSTAGRAM.SCHEDULE_NOTIFICATION_FOR_INSTAGRAM' |
    'BUILD.PUBLISH.INSTAGRAM.SCHEDULE_STORY_VIA_API' |
    'BUILD.PUBLISH.INSTAGRAM.SCHEDULE_VIA_MOBILE_APP' |
    'BUILD.PUBLISH.INSTAGRAM.SCHEDULE_VIDEO_VIA_API' |
    'BUILD.PUBLISH.INSTAGRAM.SEARCH_FOR_USER' |
    'BUILD.PUBLISH.INSTAGRAM.SELECT_RELEVANT_COUNTRY_CODE' |
    'BUILD.PUBLISH.INSTAGRAM.SEND_POST_DETAILS' |
    'BUILD.PUBLISH.INSTAGRAM.SEND_SMS_AS_WELL' |
    'BUILD.PUBLISH.INSTAGRAM.STORY_MULTI_IMAGE_HELP_TEXT' |
    'BUILD.PUBLISH.INSTAGRAM.STORY_VIDEO_DURATION_HELP_TEXT' |
    'BUILD.PUBLISH.INSTAGRAM.SUGGESTED_CAPTION' |
    'BUILD.PUBLISH.INSTAGRAM.VIDEO_DURATION_HELP_TEXT' |
    'BUILD.PUBLISH.LINKEDIN.ACCESS_CHECK_FAILURE' |
    'BUILD.PUBLISH.LINKEDIN.CAPTION' |
    'BUILD.PUBLISH.LINKEDIN.CAPTION_HELP_TEXT' |
    'BUILD.PUBLISH.LINKEDIN.LINKEDIN_PAGE' |
    'BUILD.PUBLISH.LINKEDIN.PUBLISH_TO_LINKEDIN' |
    'BUILD.PUBLISH.LOCAL.PUBLISH_VIDEO_TO_LOCAL' |
    'BUILD.PUBLISH.MAILCHIMP.CAMPAIGN_NAME' |
    'BUILD.PUBLISH.MAILCHIMP.CONFIRMATION_EMAIL_ADDRESS' |
    'BUILD.PUBLISH.MAILCHIMP.FROM_EMAIL' |
    'BUILD.PUBLISH.MAILCHIMP.FROM_NAME' |
    'BUILD.PUBLISH.MAILCHIMP.LISTS' |
    'BUILD.PUBLISH.MAILCHIMP.NO_LISTS_FOUND_SET_UP_YOUR_MAILING_LISTS' |
    'BUILD.PUBLISH.MAILCHIMP.NO_SEGMENTS_FOUND' |
    'BUILD.PUBLISH.MAILCHIMP.PREVIEW' |
    'BUILD.PUBLISH.MAILCHIMP.PREVIEW_SEND' |
    'BUILD.PUBLISH.MAILCHIMP.PREVIEW_SKIP' |
    'BUILD.PUBLISH.MAILCHIMP.PUBLISH_TO_MAILCHIMP' |
    'BUILD.PUBLISH.MAILCHIMP.RECIPIENT' |
    'BUILD.PUBLISH.MAILCHIMP.REPLY_TO' |
    'BUILD.PUBLISH.MAILCHIMP.SAVE_DRAFT' |
    'BUILD.PUBLISH.MAILCHIMP.SCHEDULING_UNAVAILABLE' |
    'BUILD.PUBLISH.MAILCHIMP.SEGMENTS' |
    'BUILD.PUBLISH.MAILCHIMP.SEND' |
    'BUILD.PUBLISH.MAILCHIMP.SUBJECT' |
    'BUILD.PUBLISH.MULTIPLE_LOCATIONS.CURRENTLY_PUBLISHING' |
    'BUILD.PUBLISH.MULTIPLE_LOCATIONS.EDIT_UNDO_ALERT_MESSAGE.PART_1' |
    'BUILD.PUBLISH.MULTIPLE_LOCATIONS.EDIT_UNDO_ALERT_MESSAGE.PART_2' |
    'BUILD.PUBLISH.MULTIPLE_LOCATIONS.EDIT_UNDO_ALERT_MESSAGE.PART_3' |
    'BUILD.PUBLISH.MULTIPLE_LOCATIONS.NO_ACCESS_HELP' |
    'BUILD.PUBLISH.MULTIPLE_LOCATIONS.PUBLISHED_VIDEOS_SUCCESSFULLY' |
    'BUILD.PUBLISH.MULTIPLE_LOCATIONS.PUBLISHING_TO_THESE_LOCATIONS' |
    'BUILD.PUBLISH.MULTIPLE_LOCATIONS.REFRESH_LOCATIONS' |
    'BUILD.PUBLISH.MULTIPLE_LOCATIONS.SCHEDULED_VIDEOS_SUCCESSFULLY' |
    'BUILD.PUBLISH.MULTIPLE_LOCATIONS.SOME_LOCATIONS_FAILED_TO_PUBLISH' |
    'BUILD.PUBLISH.MULTIPLE_LOCATIONS.TOTAL_PUBLISHING_PROGRESS' |
    'BUILD.PUBLISH.MULTIPLE_LOCATIONS.WOULD_YOU_LIKE_TO_RETRY_FOR_FAILED_LOCATIONS' |
    'BUILD.PUBLISH.MULTIPLE_PLATFORMS.FACEBOOK_AND_INSTAGRAM_IMAGE' |
    'BUILD.PUBLISH.MULTIPLE_PLATFORMS.FACEBOOK_AND_INSTAGRAM_VIDEO' |
    'BUILD.PUBLISH.MULTIPLE_PLATFORMS.HASHTAGS_HELP_TEXT_CAPTION' |
    'BUILD.PUBLISH.MULTIPLE_PLATFORMS.HASHTAGS_HELP_TEXT_FIRST_COMMENT' |
    'BUILD.PUBLISH.MULTIPLE_PLATFORMS.HEADERS.POST_DETAILS' |
    'BUILD.PUBLISH.MULTIPLE_PLATFORMS.HEADERS.POST_SCHEDULE' |
    'BUILD.PUBLISH.MULTIPLE_PLATFORMS.INPUT_LABELS.DISPLAY_HASHTAGS_IN' |
    'BUILD.PUBLISH.MULTIPLE_PLATFORMS.INPUT_LABELS.DISPLAY_HASHTAGS_IN_CAPTION' |
    'BUILD.PUBLISH.MULTIPLE_PLATFORMS.INPUT_LABELS.DISPLAY_HASHTAGS_IN_FIRST_COMMENT' |
    'BUILD.PUBLISH.MULTIPLE_PLATFORMS.INPUT_LABELS.HASHTAGS' |
    'BUILD.PUBLISH.MULTIPLE_PLATFORMS.PUBLISHED_TO_PLATFORM' |
    'BUILD.PUBLISH.MULTIPLE_PLATFORMS.PUBLISHING_TO_PLATFORM' |
    'BUILD.PUBLISH.MULTIPLE_PLATFORMS.PUBLISH_IMAGE_TO_FACEBOOK_AND_INSTAGRAM' |
    'BUILD.PUBLISH.MULTIPLE_PLATFORMS.PUBLISH_VIDEO_TO_FACEBOOK_AND_INSTAGRAM' |
    'BUILD.PUBLISH.NO_ACCESS_HELP' |
    'BUILD.PUBLISH.NO_PLATFORMS_AVAILABLE' |
    'BUILD.PUBLISH.NO_PLATFORM_SELECTED' |
    'BUILD.PUBLISH.NO_THANKS' |
    'BUILD.PUBLISH.NO_THANKS_IM_DONE' |
    'BUILD.PUBLISH.ONCE_AUTHORIZED_HELP' |
    'BUILD.PUBLISH.ORIGINAL_SIZE' |
    'BUILD.PUBLISH.PRINT.ARTWORK_REVIEW_SUGGESTED' |
    'BUILD.PUBLISH.PRINT.BEGIN_PAYMENT' |
    'BUILD.PUBLISH.PRINT.CAN_ONLY_SEND_TO_PRINT_PROVIDER' |
    'BUILD.PUBLISH.PRINT.CONFIRM_ARTWORK_REVIEW' |
    'BUILD.PUBLISH.PRINT.HOLD_UP' |
    'BUILD.PUBLISH.PRINT.INCLUDES_FALLBACK_FONT_MESSAGE' |
    'BUILD.PUBLISH.PRINT.INCLUDES_FALLBACK_FONT_MESSAGE_SOLUTION' |
    'BUILD.PUBLISH.PRINT.INSTRUCTIONS_PLACEHOLDER' |
    'BUILD.PUBLISH.PRINT.INSTRUCTIONS_PLACEHOLDER_FOR_SKU' |
    'BUILD.PUBLISH.PRINT.PAYMENT' |
    'BUILD.PUBLISH.PRINT.PAYMENT_DUE' |
    'BUILD.PUBLISH.PRINT.PRINT_PROVIDER' |
    'BUILD.PUBLISH.PRINT.PRINT_REQUEST_DETAILS' |
    'BUILD.PUBLISH.PRINT.REPLY_EMAIL' |
    'BUILD.PUBLISH.PRINT.REPLY_EMAIL_SUBHEADING' |
    'BUILD.PUBLISH.PRINT.REQUEST_DETAILS_IS_MISSING_DATA' |
    'BUILD.PUBLISH.PRINT.REVIEW_ARTWORK_BEFORE_SENDING' |
    'BUILD.PUBLISH.PRINT.REVIEW_CONFIRMATION' |
    'BUILD.PUBLISH.PRINT.REVIEW_DOCUMENT' |
    'BUILD.PUBLISH.PRINT.SAVE_AS_LOCATION_PRINT_PROVIDER' |
    'BUILD.PUBLISH.PRINT.SELECT_PRINT_PROVIDER' |
    'BUILD.PUBLISH.PRINT.SENDING_ARTWORK' |
    'BUILD.PUBLISH.PRINT.SEND_AND_COMPLETE_PAYMENT' |
    'BUILD.PUBLISH.PRINT.SEND_ORDER' |
    'BUILD.PUBLISH.PRINT.SEND_TO_PRINT_PROVIDER' |
    'BUILD.PUBLISH.PRINT.SUCCESSFULLY_SENT' |
    'BUILD.PUBLISH.PRINT.YOUR_PRINT_PROVIDER' |
    'BUILD.PUBLISH.PUBLISH' |
    'BUILD.PUBLISH.PUBLISHED' |
    'BUILD.PUBLISH.PUBLISHED_SUCCESSFULLY' |
    'BUILD.PUBLISH.PUBLISHED_TO_SOME_LOCATIONS' |
    'BUILD.PUBLISH.PUBLISHING_FAILED' |
    'BUILD.PUBLISH.PUBLISH_IMMEDIATELY' |
    'BUILD.PUBLISH.PUBLISH_VIDEO_ACTION' |
    'BUILD.PUBLISH.REFRESH_PLATFORMS' |
    'BUILD.PUBLISH.RELATIVE_TO_LOCATION' |
    'BUILD.PUBLISH.RESCHEDULE.NEW_TIME' |
    'BUILD.PUBLISH.RESCHEDULE.RESCHEDULE_ITEM' |
    'BUILD.PUBLISH.SAVED_SUCCESSFULLY' |
    'BUILD.PUBLISH.SCHEDULED_POST_MUST_BE_AT_LEAST_10_MINS_IN_FUTURE' |
    'BUILD.PUBLISH.SCHEDULED_POST_TIME_PICKER_WARNING' |
    'BUILD.PUBLISH.SCHEDULED_SUCCESSFULLY' |
    'BUILD.PUBLISH.SCHEDULE_FOR_LATER' |
    'BUILD.PUBLISH.SEND_IMMEDIATELY' |
    'BUILD.PUBLISH.TERMS_AND_CONDITIONS_HELP_TEXT' |
    'BUILD.PUBLISH.TWITTER.ACCESS_CHECK_FAILURE' |
    'BUILD.PUBLISH.TWITTER.CANNOT_PUBLISH_MULTI_IMAGE_HELP_TEXT' |
    'BUILD.PUBLISH.TWITTER.CANNOT_STOP_SCHEDULED_POST' |
    'BUILD.PUBLISH.TWITTER.PUBLISH_TO_TWITTER' |
    'BUILD.PUBLISH.TWITTER.TWEET' |
    'BUILD.PUBLISH.UPLOADING' |
    'BUILD.PUBLISH.WILL_RECEIVE_NOTIFICATION' |
    'BUILD.PUBLISH.WILL_RECEIVE_SCHEDULED_NOTIFICATION' |
    'BUILD.PUBLISH.WILL_RECIEVE_SMS_DETAILS' |
    'BUILD.PUBLISH.WILL_RECIEVE_SMS_REMINDER' |
    'BUILD.PUBLISH.WOULD_YOU_LIKE_TO_SCHEDULE_POST_ON_ANOTHER_PLATFORM' |
    'BUILD.PUBLISH.WOULD_YOU_LIKE_TO_SCHEDULE_THIS_POST_AGAIN' |
    'BUILD.PUBLISH.YES_PLEASE' |
    'BUILD.PUBLISH.YES_PLEASE_BUT_DIFFERENT_TEMPLATE' |
    'BUILD.PUBLISH.YES_PLEASE_BUT_LATER' |
    'BUILD.PUBLISHING_FAILED' |
    'BUILD.PUBLISH_TO_MULTIPLE_LOCATIONS' |
    'BUILD.RECENTLY_ADDED' |
    'BUILD.RECTANGLE' |
    'BUILD.REPETITIONS' |
    'BUILD.REQUEST_SUPPORT' |
    'BUILD.RESOURCES_LOADED' |
    'BUILD.RESOURCES_LOADED_plural' |
    'BUILD.RETURN_TO_BUILDER' |
    'BUILD.SAVING_TEMPLATE' |
    'BUILD.SCHEDULED_TIME' |
    'BUILD.SELECT_PREVIEW_IMAGE' |
    'BUILD.SEPARATE_TAGS_WITH_SPACES' |
    'BUILD.SHOW_DETAILS' |
    'BUILD.SHOW_OLD_EMAIL_TEMPLATES' |
    'BUILD.SUMMARY_HIDDEN_MESSAGE' |
    'BUILD.TEMPLATE' |
    'BUILD.TEMPLATE_ADMIN.COPY_AS_UNPUBLISHED' |
    'BUILD.TEMPLATE_ADMIN.COPY_AS_UNPUBLISHED_TOOLTIP' |
    'BUILD.TEMPLATE_ADMIN.COPY_ERROR' |
    'BUILD.TEMPLATE_ADMIN.COPY_NO_CLIENTS' |
    'BUILD.TEMPLATE_ADMIN.COPY_SUCCESS' |
    'BUILD.TEMPLATE_ADMIN.COPY_SUCCESS_EXTENDED' |
    'BUILD.TEMPLATE_ADMIN.COPY_TO' |
    'BUILD.TEMPLATE_ADMIN.DELETE_TEMPLATE' |
    'BUILD.TEMPLATE_ADMIN.DELETE_TEMPLATE_SUCCESS' |
    'BUILD.TEMPLATE_ADMIN.DUPLICATE_TEMPLATE' |
    'BUILD.TEMPLATE_ADMIN.DUPLICATE_TEMPLATE_SUCCESS' |
    'BUILD.TEMPLATE_ADMIN.EDIT_ATTRIBUTES' |
    'BUILD.TEMPLATE_ADMIN.INCLUDE_ASSIGNED_CATEGORIES' |
    'BUILD.TEMPLATE_ADMIN.INCLUDE_ASSIGNED_CATEGORIES_TOOLTIP' |
    'BUILD.TEMPLATE_ADMIN.MANAGE_BUILDABLE_TEMPLATE' |
    'BUILD.TEMPLATE_ADMIN.TEMPLATE_UPDATED' |
    'BUILD.TEMPLATE_ADMIN.TOGGLE_TEMPLATE_STATUS_PUBLISHED' |
    'BUILD.TEMPLATE_ADMIN.TOGGLE_TEMPLATE_STATUS_PUBLISHED_SUCCESS' |
    'BUILD.TEMPLATE_ADMIN.TOGGLE_TEMPLATE_STATUS_UNPUBLISHED' |
    'BUILD.TEMPLATE_ADMIN.TOGGLE_TEMPLATE_STATUS_UNPUBLISHED_SUCCESS' |
    'BUILD.TEMPLATE_COULD_NOT_BE_EXPORTED_UNDER_THE_FILE_SIZE_LIMIT' |
    'BUILD.TEMPLATE_DELETED' |
    'BUILD.TEMPLATE_GALLERY' |
    'BUILD.TEMPLATE_NOT_FOUND_OR_UNAUTHORIZED' |
    'BUILD.TEMPLATE_SAVED' |
    'BUILD.TEXT_ALIGNMENT_HORIZONTAL.CENTER' |
    'BUILD.TEXT_ALIGNMENT_HORIZONTAL.JUSTIFY' |
    'BUILD.TEXT_ALIGNMENT_HORIZONTAL.LEFT' |
    'BUILD.TEXT_ALIGNMENT_HORIZONTAL.RIGHT' |
    'BUILD.TEXT_ALIGNMENT_VERTICAL.BOTTOM' |
    'BUILD.TEXT_ALIGNMENT_VERTICAL.CENTER' |
    'BUILD.TEXT_ALIGNMENT_VERTICAL.TOP' |
    'BUILD.TEXT_CLIPPING' |
    'BUILD.TEXT_FORMATTING_WORKAROUND' |
    'BUILD.TEXT_LINE_HEIGHT_FIX' |
    'BUILD.TEXT_MUST_BE_EDITABLE' |
    'BUILD.TIME_UNITS_AGO.DAY_AGO' |
    'BUILD.TIME_UNITS_AGO.DAY_AGO_plural' |
    'BUILD.TIME_UNITS_AGO.HOUR_AGO' |
    'BUILD.TIME_UNITS_AGO.HOUR_AGO_plural' |
    'BUILD.TIME_UNITS_AGO.MINUTE_AGO' |
    'BUILD.TIME_UNITS_AGO.MINUTE_AGO_plural' |
    'BUILD.TIME_UNITS_AGO.MONTH_AGO' |
    'BUILD.TIME_UNITS_AGO.MONTH_AGO_plural' |
    'BUILD.TIME_UNITS_AGO.SECOND_AGO' |
    'BUILD.TIME_UNITS_AGO.SECOND_AGO_plural' |
    'BUILD.TIME_UNITS_AGO.WEEK_AGO' |
    'BUILD.TIME_UNITS_AGO.WEEK_AGO_plural' |
    'BUILD.TIME_UNITS_AGO.YEAR_AGO' |
    'BUILD.TIME_UNITS_AGO.YEAR_AGO_plural' |
    'BUILD.TOGGLE_UNPUBLISHED' |
    'BUILD.TRANSFORM' |
    'BUILD.UNPUBLISHED_INFO' |
    'BUILD.UNPUBLISHED_TEMPLATE' |
    'BUILD.UNPUBLISHED_TEMPLATE_PUBLISH_WARNING' |
    'BUILD.UPDATE_TEMPLATE' |
    'BUILD.UPPERCASE' |
    'BUILD.VIDEO.CHECKING_ACCESS' |
    'BUILD.VIDEO.DOWNLOAD_VIDEO' |
    'BUILD.VIDEO.FAILED_TO_PUBLISH_VIDEO' |
    'BUILD.VIDEO.FINALIZING_VIDEO' |
    'BUILD.VIDEO.NETWORK_ERROR' |
    'BUILD.VIDEO.NO_VIDEO_LAYERS' |
    'BUILD.VIDEO.NO_VIDEO_UPLOADED' |
    'BUILD.VIDEO.PLEASE_WAIT' |
    'BUILD.VIDEO.PREPARING_VIDEO' |
    'BUILD.VIDEO.PROCESSING_TIME_DISCLAIMER' |
    'BUILD.VIDEO.PROCESSING_VIDEO' |
    'BUILD.VIDEO.PUBLISHING_FAILED_MESSAGE' |
    'BUILD.VIDEO.READY_TO_DOWNLOAD' |
    'BUILD.VIDEO.REMOVE_AUDIO' |
    'BUILD.VIDEO.RENDERING_VIDEO' |
    'BUILD.VIDEO.RETY_WITHOUT_AUDIO' |
    'BUILD.VIDEO.UNSUPPORTED_FORMAT' |
    'BUILD.VIDEO.UPLOADING' |
    'BUILD.VIDEO.VIDEO_IS_READY' |
    'BUILD.VIDEO.VIDEO_IS_READY_TO_DOWNLOAD' |
    'BUILD.VIDEO_CHOOSER.CONFIRM_ACKNOWLEDGED' |
    'BUILD.VIDEO_CHOOSER.CONFIRM_PERMISSION' |
    'BUILD.VIDEO_CHOOSER.LOCAL_FILE' |
    'BUILD.VIDEO_CHOOSER.MAX_UPLOAD_ERROR' |
    'BUILD.VIDEO_CHOOSER.PERMISSION_DISCLAIMER' |
    'BUILD.VIDEO_CHOOSER.PERMISSION_DISCLAIMER_STRONG' |
    'BUILD.VIDEO_CHOOSER.PERMISSION_ERROR' |
    'BUILD.VIDEO_CHOOSER.SELECT_VIDEO' |
    'BUILD.VIDEO_CHOOSER.SELECT_VIDEO_FROM_YOUR_LIBRARY' |
    'BUILD.VIDEO_CHOOSER.SUGGESTED_COLLECTION' |
    'BUILD.VIDEO_CHOOSER.UPLOADED_ASSET_VIDEO' |
    'BUILD.VIDEO_CHOOSER.UPLOADED_PLANNER_VIDEO' |
    'BUILD.VIDEO_CHOOSER.UPLOAD_VIDEO_FROM_YOUR_DEVICE' |
    'BUILD.VIDEO_CHOOSER.VIDEO_SOURCE' |
    'BUILD.WEBSITE_URL_NOT_SET' |
    'BUILD.YOU_ARE_CURRENTLY_BUILDING' |
    'BUILD.YOU_HAVE_N_ITEMS_TO_BUILD_AND_SCHEDULE' |
    'BUILD.YOU_HAVE_N_ITEMS_TO_BUILD_AND_SCHEDULE_plural' |
    'BUILD.YOU_HAVE_N_ITEMS_TO_CHECKOUT' |
    'BUILD.YOU_HAVE_N_ITEMS_TO_CHECKOUT_plural' |
    'CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.HEADERS.BUILT_ITEMS' |
    'CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.HEADERS.FACEBOOK_ADS' |
    'CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.HEADERS.GOOGLE_ADS' |
    'CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.HEADERS.GROUPS' |
    'CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.HEADERS.LEADS' |
    'CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.HEADERS.LOCATION' |
    'CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.HEADERS.REGION' |
    'CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.LABEL_FILTER_LOCATIONS' |
    'CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.NO_GROUPS' |
    'CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.NO_LOCATIONS_FOUND' |
    'CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.NO_REGION' |
    'CLIENT.CLIENT_TEMPLATE_CATEGORIES.ADD_TEMPLATE_CATEGORY' |
    'CLIENT.CLIENT_TEMPLATE_CATEGORIES.DELETE_TEMPLATE_CATEGORY' |
    'CLIENT.CLIENT_TEMPLATE_CATEGORIES.DELETE_TEXT' |
    'CLIENT.CLIENT_TEMPLATE_CATEGORIES.EDIT_TEMPLATE_CATEGORY' |
    'CLIENT.CLIENT_TEMPLATE_CATEGORIES.ERROR.CREATE' |
    'CLIENT.CLIENT_TEMPLATE_CATEGORIES.ERROR.EMPTY_CATEGORY_LABEL' |
    'CLIENT.CLIENT_TEMPLATE_CATEGORIES.ERROR.END_DATE_BEFORE_START_DATE' |
    'CLIENT.CLIENT_TEMPLATE_CATEGORIES.ERROR.INVALID_END_DATE' |
    'CLIENT.CLIENT_TEMPLATE_CATEGORIES.ERROR.INVALID_START_DATE' |
    'CLIENT.CLIENT_TEMPLATE_CATEGORIES.ERROR.MODIFY' |
    'CLIENT.CLIENT_TEMPLATE_CATEGORIES.FORM_LABELS.END_DATE_OPTIONAL' |
    'CLIENT.CLIENT_TEMPLATE_CATEGORIES.FORM_LABELS.START_DATE' |
    'CLIENT.CLIENT_TEMPLATE_CATEGORIES.LABEL' |
    'CLIENT.CLIENT_TEMPLATE_CATEGORIES.SUCCESS.CREATE' |
    'CLIENT.CLIENT_TEMPLATE_CATEGORIES.SUCCESS.MODIFY' |
    'CLIENT.CLIENT_TEMPLATE_CATEGORIES.TITLE' |
    'CLIENT.CLIENT_USERS_LOCATION.ADD_USER' |
    'CLIENT.CLIENT_USERS_LOCATION.ASSIGN_USER_TO_LOCATIONS' |
    'CLIENT.CLIENT_USERS_LOCATION.BUTTONS.SEND_INVITE' |
    'CLIENT.CLIENT_USERS_LOCATION.CREATE_NEW_USER' |
    'CLIENT.CLIENT_USERS_LOCATION.DELETE_ORPHANED_USER' |
    'CLIENT.CLIENT_USERS_LOCATION.FILTER_USER_PLACEHOLDER' |
    'CLIENT.CLIENT_USERS_LOCATION.INVALID_EMAIL_HELPER_TEXT' |
    'CLIENT.CLIENT_USERS_LOCATION.INVITE_NEW_USER' |
    'CLIENT.CLIENT_USERS_LOCATION.INVITE_USER' |
    'CLIENT.CLIENT_USERS_LOCATION.LABELS.EMAIL_ADDRESS' |
    'CLIENT.CLIENT_USERS_LOCATION.LABELS.GIVE_ACCESS_TO' |
    'CLIENT.CLIENT_USERS_LOCATION.LABELS.USER_DETAILS' |
    'CLIENT.CLIENT_USERS_LOCATION.LABELS.USER_ROLES' |
    'CLIENT.CLIENT_USERS_LOCATION.LOCATION_ACCESS' |
    'CLIENT.CLIENT_USERS_LOCATION.MATCHING_USERS_FOUND' |
    'CLIENT.CLIENT_USERS_LOCATION.MATCHING_USER_FOUND' |
    'CLIENT.CLIENT_USERS_LOCATION.MODAL_TITLE' |
    'CLIENT.CLIENT_USERS_LOCATION.PLACEHOLDERS.EMAIL_ADDRESS' |
    'CLIENT.CLIENT_USERS_LOCATION.PLACEHOLDERS.SELECT_ROLES' |
    'CLIENT.CLIENT_USERS_LOCATION.UPDATE_LOCATIONS' |
    'CLIENT.CLIENT_USERS_TABLE.BULK_ACTIONS.DELETE' |
    'CLIENT.CLIENT_USERS_TABLE.BULK_ACTIONS.RESEND_USER_INVITES' |
    'CLIENT.CLIENT_USERS_TABLE.BULK_ACTIONS.RESET_PASSWORD' |
    'CLIENT.CLIENT_USERS_TABLE.BULK_ACTIONS.UPDATE_LOCATIONS' |
    'CLIENT.CLIENT_USERS_TABLE.BULK_ACTIONS.UPDATE_ROLES' |
    'CLIENT.CLIENT_USERS_TABLE.BUTTON_BULK_ACTIONS_PRIMARY' |
    'CLIENT.CLIENT_USERS_TABLE.BUTTON_BULK_ACTIONS_SECONDARY' |
    'CLIENT.CLIENT_USERS_TABLE.MOBILE_TOOLTIP' |
    'CLIENT.CLIENT_USERS_TABLE.TITLE' |
    'CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.EMAIL_ADDRESS' |
    'CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.FIRST_NAME' |
    'CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.GENERAL_DETAILS' |
    'CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.GUIDED_TOUR' |
    'CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.LAST_NAME' |
    'CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.LOCATIONS_ACCESS' |
    'CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.PREFERENCES' |
    'CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.TITLE' |
    'CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.USER_ROLES' |
    'CLIENT.ENGAGEMENT_HELP_TEXT.ACTIVITY' |
    'CLIENT.ENGAGEMENT_HELP_TEXT.BUILT_ITEMS' |
    'CLIENT.ENGAGEMENT_HELP_TEXT.CONNECTIONS.CURRENTLY_REQUIRED_PLATFORMS' |
    'CLIENT.ENGAGEMENT_HELP_TEXT.CONNECTIONS.DATA_NOT_IMPACTED_BY_DATE_SELECTION' |
    'CLIENT.ENGAGEMENT_HELP_TEXT.CONNECTIONS.HOW_TO_SET_REQUIRED_PLATFORMS' |
    'CLIENT.ENGAGEMENT_HELP_TEXT.CONNECTIONS.REQUIRED_CONNECTIONS_EXPLANATION' |
    'CLIENT.ENGAGEMENT_HELP_TEXT.CONNECTIONS.TOTAL_CONNECTIONS_EXPLANATION' |
    'CLIENT.ERRORS.NO_CLIENT_ID' |
    'CLIENT.ERRORS.NO_CLIENT_SELECTED' |
    'CLIENT.ERRORS.NO_DATE_RANGE' |
    'CLIENT.ERRORS.UNEXPECTED_ERROR' |
    'CLIENT.ERROR_STYLE_GUIDE_DELETE' |
    'CLIENT.ERROR_STYLE_GUIDE_REPLACE' |
    'CLIENT.ERROR_STYLE_GUIDE_UPLOAD' |
    'CLIENT.LOCATION_ACTIVITY.BUILT_ITEMS_COUNT' |
    'CLIENT.LOCATION_ACTIVITY.HEADERS.ACTIVITY' |
    'CLIENT.LOCATION_ACTIVITY.HEADERS.BUILT_ITEMS' |
    'CLIENT.LOCATION_ACTIVITY.HEADERS.CONNECTIONS' |
    'CLIENT.LOCATION_ACTIVITY.HEADERS.MOST_ENGAGED_LOCATIONS' |
    'CLIENT.LOCATION_ACTIVITY.LABEL_BUILT_ITEMS_CUMULATIVE' |
    'CLIENT.LOCATION_ACTIVITY.LOCATIONS_ACTIVE' |
    'CLIENT.LOCATION_ACTIVITY.LOCATIONS_USING_MOBILE_APP' |
    'CLIENT.LOCATION_ACTIVITY.REQUIRED_PLATFORMS_CONNECTED' |
    'CLIENT.LOCATION_ACTIVITY.SORT_BUILT_ITEMS' |
    'CLIENT.LOCATION_ACTIVITY.SORT_LOCATION' |
    'CLIENT.LOCATION_ACTIVITY.SORT_TITLE' |
    'CLIENT.LOCATION_ACTIVITY.TEMPLATES_BUILT' |
    'CLIENT.LOCATION_ACTIVITY.TOTAL_PLATFORMS_CONNECTED' |
    'CLIENT.OVERVIEW.ERRORS.FAIL_TO_LOAD' |
    'CLIENT.OVERVIEW.HEADERS.TEMPLATES_BUILT' |
    'CLIENT.OVERVIEW.HEADERS.TEMPLATE_CATEGORIES' |
    'CLIENT.OVERVIEW.SOCIAL_TEMPLATE_REPORTING.BODY' |
    'CLIENT.OVERVIEW.SOCIAL_TEMPLATE_REPORTING.BUTTON' |
    'CLIENT.OVERVIEW.SOCIAL_TEMPLATE_REPORTING.TITLE' |
    'CLIENT.OVERVIEW.TEMPLATES_BUILT_BY_LOCATION_CATEGORY' |
    'CLIENT.OVERVIEW.TEMPLATE_CATEGORIES.ASSETS_USED' |
    'CLIENT.OVERVIEW.TEMPLATE_CATEGORIES.ASSETS_USED_plural' |
    'CLIENT.OVERVIEW.TEMPLATE_CATEGORIES.DIGITAL' |
    'CLIENT.OVERVIEW.TEMPLATE_CATEGORIES.EMAIL' |
    'CLIENT.OVERVIEW.TEMPLATE_CATEGORIES.PRINT' |
    'CLIENT.REGION_ACTIVITY.CATEGORIES_TABLE.AVERAGE_BUILT_ITEMS_PER_LOCATION' |
    'CLIENT.REGION_ACTIVITY.CATEGORIES_TABLE.ERRORS.FAIL_TO_LOAD' |
    'CLIENT.REGION_ACTIVITY.FILTER_NAME' |
    'CLIENT.REGION_ACTIVITY.HEADERS.BUILT_ITEMS' |
    'CLIENT.STYLE_GUIDE_PAGE_TITLE' |
    'CLIENT.SUCCESS_STYLE_GUIDE_DELETE' |
    'CLIENT.SUCCESS_STYLE_GUIDE_REPLACE' |
    'CLIENT.SUCCESS_STYLE_GUIDE_UPLOAD' |
    'COMMON.ACTIONS' |
    'COMMON.ACTIVE' |
    'COMMON.ADD' |
    'COMMON.ADDRESS' |
    'COMMON.ADD_NEW_TAG' |
    'COMMON.ADD_TAG' |
    'COMMON.ADMIN' |
    'COMMON.AFTER' |
    'COMMON.AGENCIES' |
    'COMMON.AGENCY' |
    'COMMON.ALL' |
    'COMMON.ALL_ASSETS' |
    'COMMON.ALL_LOCATIONS' |
    'COMMON.AMOUNT' |
    'COMMON.AND' |
    'COMMON.AND_X_OTHER_LOCATIONS' |
    'COMMON.AND_X_OTHER_LOCATIONS_plural' |
    'COMMON.ANYBODY' |
    'COMMON.APPS' |
    'COMMON.ARE_YOU_SURE' |
    'COMMON.ARE_YOU_SURE_YOU_WANT_TO_DELETE_NUM_ASSETS' |
    'COMMON.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ASSET' |
    'COMMON.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_COLLECTION' |
    'COMMON.ASSET_COLLECTION' |
    'COMMON.ASSET_LIBRARY' |
    'COMMON.ASSIGNED_TO' |
    'COMMON.ATTACH' |
    'COMMON.ATTACHMENTS' |
    'COMMON.ATTACH_FILE' |
    'COMMON.BACK' |
    'COMMON.BETA' |
    'COMMON.BROWSE' |
    'COMMON.BUILD' |
    'COMMON.BUILT' |
    'COMMON.BUSINESS_NAME' |
    'COMMON.CANCEL' |
    'COMMON.CANCELLED_WHILE_IN_QUEUE' |
    'COMMON.CANCELLED_WHILE_PROCESSING' |
    'COMMON.CANNOT_FIND_ASSET' |
    'COMMON.CATEGORIES' |
    'COMMON.CATEGORY' |
    'COMMON.CHANGE' |
    'COMMON.CHANGES_SAVED' |
    'COMMON.CHANNEL' |
    'COMMON.CHANNELS' |
    'COMMON.CHECK_CONNECTION' |
    'COMMON.CLEAR' |
    'COMMON.CLIENT' |
    'COMMON.CLIENTS' |
    'COMMON.CLIENT_USED_MAX_COLLECTIONS' |
    'COMMON.CLIENT_WITH_LOCATION' |
    'COMMON.CLOSE' |
    'COMMON.COLLECTION' |
    'COMMON.COLOUR' |
    'COMMON.COLUMNS' |
    'COMMON.COMMENTS.ADD_COMMENT' |
    'COMMON.COMMENTS.ARE_YOU_SURE_DELETE_COMMENT' |
    'COMMON.COMMENTS.CANNOT_DELETE_COMMENTS' |
    'COMMON.COMMENTS.COMMENT' |
    'COMMON.COMMENTS.COMMENTS' |
    'COMMON.COMMENTS.COMMENTS_HEADING_DEFAULT' |
    'COMMON.COMMENTS.DELETE_COMMENT' |
    'COMMON.COMMENTS.ENTER_COMMENT' |
    'COMMON.COMMENTS.UNKNOWN_PARENT' |
    'COMMON.COMPANIES.LT_NETWORK' |
    'COMMON.CONFIRM' |
    'COMMON.CONFIRMATION' |
    'COMMON.CONFIRM_MODAL_INPUT' |
    'COMMON.CONNECTION_ISSUES' |
    'COMMON.CONNECT_PAGE.CONNECT_PAGE' |
    'COMMON.CONNECT_PAGE.FILTER.ACCOUNT_NAME' |
    'COMMON.CONNECT_PAGE.FILTER.CLEAR_LOCATION_ID' |
    'COMMON.CONNECT_PAGE.FILTER.CLIENT' |
    'COMMON.CONNECT_PAGE.FILTER.LOCATION' |
    'COMMON.CONNECT_PAGE.FILTER.PAGE_NAME' |
    'COMMON.CONNECT_PAGE.FILTER.STATUS' |
    'COMMON.CONNECT_PAGE.STATUS_DROPDOWN.CONNECT' |
    'COMMON.CONNECT_PAGE.STATUS_DROPDOWN.CONNECTED' |
    'COMMON.CONNECT_PAGE.STATUS_DROPDOWN.ERROR' |
    'COMMON.CONNECT_PAGE.STATUS_DROPDOWN.EXPIRED' |
    'COMMON.CONNECT_PAGE.STATUS_DROPDOWN.INCOMPLETE' |
    'COMMON.CONNECT_PAGE.TABLE_HEADERS.ACCOUNT_MAPPING' |
    'COMMON.CONNECT_PAGE.TABLE_HEADERS.ACCOUNT_NAME' |
    'COMMON.CONTINUE' |
    'COMMON.COPIED_TO_CLIPBOARD' |
    'COMMON.COPIED_TO_CLIPBOARD_FAILED' |
    'COMMON.COPY' |
    'COMMON.COSTS' |
    'COMMON.COULD_NOT_DETERMINE_BOOTSTRAP_BREAKPOINT' |
    'COMMON.COUNTRIES.AUSTRALIA' |
    'COMMON.COUNTRIES.AUSTRIA' |
    'COMMON.COUNTRIES.BELGIUM' |
    'COMMON.COUNTRIES.CANADA' |
    'COMMON.COUNTRIES.CZECHIA' |
    'COMMON.COUNTRIES.DENMARK' |
    'COMMON.COUNTRIES.DOMINICAN_REPUBLIC' |
    'COMMON.COUNTRIES.EGYPT' |
    'COMMON.COUNTRIES.FINLAND' |
    'COMMON.COUNTRIES.FRANCE' |
    'COMMON.COUNTRIES.GEORGIA' |
    'COMMON.COUNTRIES.GERMANY' |
    'COMMON.COUNTRIES.HONG_KONG' |
    'COMMON.COUNTRIES.HUNGARY' |
    'COMMON.COUNTRIES.INDIA' |
    'COMMON.COUNTRIES.INDONESIA' |
    'COMMON.COUNTRIES.IRELAND' |
    'COMMON.COUNTRIES.ITALY' |
    'COMMON.COUNTRIES.JAPAN' |
    'COMMON.COUNTRIES.LATVIA' |
    'COMMON.COUNTRIES.LITHUANIA' |
    'COMMON.COUNTRIES.MALAYSIA' |
    'COMMON.COUNTRIES.MAURITIUS' |
    'COMMON.COUNTRIES.MEXICO' |
    'COMMON.COUNTRIES.MYANMAR' |
    'COMMON.COUNTRIES.NETHERLANDS' |
    'COMMON.COUNTRIES.NEW_ZEALAND' |
    'COMMON.COUNTRIES.NORWAY' |
    'COMMON.COUNTRIES.PERU' |
    'COMMON.COUNTRIES.PHILIPPINES' |
    'COMMON.COUNTRIES.PORTUGAL' |
    'COMMON.COUNTRIES.SAUDI_ARABIA' |
    'COMMON.COUNTRIES.SINGAPORE' |
    'COMMON.COUNTRIES.SOUTH_AFRICA' |
    'COMMON.COUNTRIES.SOUTH_KOREA' |
    'COMMON.COUNTRIES.SPAIN' |
    'COMMON.COUNTRIES.SWEDEN' |
    'COMMON.COUNTRIES.SWITZERLAND' |
    'COMMON.COUNTRIES.TAIWAN' |
    'COMMON.COUNTRIES.THAILAND' |
    'COMMON.COUNTRIES.TURKEY' |
    'COMMON.COUNTRIES.UNITED_ARAB_EMIRATES' |
    'COMMON.COUNTRIES.UNITED_KINGDOM' |
    'COMMON.COUNTRIES.UNITED_STATES_OF_AMERICA' |
    'COMMON.COUNTRIES.VIETNAM' |
    'COMMON.COUNTRY' |
    'COMMON.CREATE' |
    'COMMON.CREATED' |
    'COMMON.CREATED_AT' |
    'COMMON.CURRENCY' |
    'COMMON.CURRENTLY_SELECTED_COUNT' |
    'COMMON.CURRENT_LOCATION_USED_MAX_COLLECTIONS' |
    'COMMON.CUSTOMIZE' |
    'COMMON.DATE' |
    'COMMON.DATE_ADDED' |
    'COMMON.DAY' |
    'COMMON.DAYS' |
    'COMMON.DAYS_OF_THE_WEEK_LONG.FRIDAY' |
    'COMMON.DAYS_OF_THE_WEEK_LONG.MONDAY' |
    'COMMON.DAYS_OF_THE_WEEK_LONG.SATURDAY' |
    'COMMON.DAYS_OF_THE_WEEK_LONG.SUNDAY' |
    'COMMON.DAYS_OF_THE_WEEK_LONG.THURSDAY' |
    'COMMON.DAYS_OF_THE_WEEK_LONG.TUESDAY' |
    'COMMON.DAYS_OF_THE_WEEK_LONG.WEDNESDAY' |
    'COMMON.DELETE' |
    'COMMON.DELETED' |
    'COMMON.DELETE_ASSET' |
    'COMMON.DELETE_CHECKED_TAGS' |
    'COMMON.DELETE_CHECKED_TAGS_CONFIRM' |
    'COMMON.DELETE_PERMANENTLY' |
    'COMMON.DELETE_SOMETHING' |
    'COMMON.DESCRIPTION' |
    'COMMON.DESELECT_ALL' |
    'COMMON.DESKTOP' |
    'COMMON.DETACH' |
    'COMMON.DETAILS' |
    'COMMON.DISABLE' |
    'COMMON.DISABLED' |
    'COMMON.DISMISS' |
    'COMMON.DISPLAY_NAME' |
    'COMMON.DONE' |
    'COMMON.DOWNLOAD' |
    'COMMON.EDIT' |
    'COMMON.EDIT_ASSET' |
    'COMMON.EDIT_ASSETS' |
    'COMMON.EDIT_COLLECTION' |
    'COMMON.EDIT_MULTIPLE_ASSETS' |
    'COMMON.EMAIL' |
    'COMMON.EMAIL_ADDRESS' |
    'COMMON.ENABLE' |
    'COMMON.ENABLED' |
    'COMMON.END_DATE' |
    'COMMON.ENTER_NEW_NAME' |
    'COMMON.ERROR' |
    'COMMON.EXAMPLE' |
    'COMMON.EXCEEDED_SIZE_LIMIT_COLLECTION' |
    'COMMON.EXPIRED' |
    'COMMON.EXPIRE_ON_DATE' |
    'COMMON.EXPIRY' |
    'COMMON.FAILED_TO' |
    'COMMON.FAILED_TO_LOAD_IMAGE' |
    'COMMON.FAILED_TO_RETRIEVE_LOCATIONS' |
    'COMMON.FETCH_DATA' |
    'COMMON.FILE' |
    'COMMON.FILES' |
    'COMMON.FILE_SIZE' |
    'COMMON.FILE_UPLOADED' |
    'COMMON.FILTER' |
    'COMMON.FILTERS' |
    'COMMON.FILTER_COLLECTIONS' |
    'COMMON.FINISH' |
    'COMMON.FIRST_NAME' |
    'COMMON.FORMAT' |
    'COMMON.FORMATS' |
    'COMMON.FROM' |
    'COMMON.FULL_SCREEN' |
    'COMMON.GMT' |
    'COMMON.GOOGLE_ADS_DISCLAIMER' |
    'COMMON.GOOGLE_ADS_DISCLAIMER_CONVERSION_DATA' |
    'COMMON.GROUPS' |
    'COMMON.HEIGHT' |
    'COMMON.HIDE' |
    'COMMON.IMAGE' |
    'COMMON.INFO' |
    'COMMON.INSTRUCTIONS' |
    'COMMON.INVITE' |
    'COMMON.ITEM' |
    'COMMON.JOB_TITLE' |
    'COMMON.LABEL' |
    'COMMON.LAST_ACTIVITY' |
    'COMMON.LAST_MONTH' |
    'COMMON.LAST_NAME' |
    'COMMON.LAST_UPDATED' |
    'COMMON.LEARN_MORE' |
    'COMMON.LEAVE_PAGE_CONFIRMATION' |
    'COMMON.LEAVE_PAGE_CONFIRMATION_LONG' |
    'COMMON.LEAVE_PAGE_PROMPT.CONFIRM' |
    'COMMON.LEAVE_PAGE_PROMPT.TITLE' |
    'COMMON.LEGEND' |
    'COMMON.LESS' |
    'COMMON.LINK' |
    'COMMON.LOADING' |
    'COMMON.LOAD_MORE' |
    'COMMON.LOCALE' |
    'COMMON.LOCALE_REQUIRED' |
    'COMMON.LOCATION' |
    'COMMON.LOCATIONS' |
    'COMMON.LOCATION_USED_MAX_COLLECTIONS' |
    'COMMON.LOGIN' |
    'COMMON.MANAGER' |
    'COMMON.MAP' |
    'COMMON.MARKETING' |
    'COMMON.MESSAGE' |
    'COMMON.MOBILE' |
    'COMMON.MORE' |
    'COMMON.MORE_CHARS_FOR_SEARCH' |
    'COMMON.MOST' |
    'COMMON.MOVE_TO_FOLDER' |
    'COMMON.MUST_BE_X_OR_MORE' |
    'COMMON.NAME' |
    'COMMON.NEVER' |
    'COMMON.NEW' |
    'COMMON.NEW_COLLECTION' |
    'COMMON.NEXT' |
    'COMMON.NEXT_AMOUNT' |
    'COMMON.NEXT_DATE' |
    'COMMON.NO' |
    'COMMON.NOBODY' |
    'COMMON.NONE' |
    'COMMON.NOTE' |
    'COMMON.NOTHING_FOUND' |
    'COMMON.NOTIFICATION' |
    'COMMON.NOTIFICATIONS' |
    'COMMON.NOT_LOGGED_IN' |
    'COMMON.NOT_SEEING_WHAT_EXPECTED' |
    'COMMON.NO_ASSETS_ARE_CURRENTLY_AVALIABLE_FOR' |
    'COMMON.NO_ASSETS_FOUND' |
    'COMMON.NO_ASSET_COLLECTIONS_FOUND' |
    'COMMON.NO_MATCHING_COLLECTIONS_FOUND' |
    'COMMON.NO_RESULTS' |
    'COMMON.NO_THANKS' |
    'COMMON.NUM_OF_TOTAL' |
    'COMMON.OK' |
    'COMMON.ON' |
    'COMMON.OPEN' |
    'COMMON.OPEN_CALENDAR' |
    'COMMON.OPEN_YOUR_FILE' |
    'COMMON.OPTIONAL' |
    'COMMON.OPTIONS' |
    'COMMON.OP_ADD_ASSET' |
    'COMMON.OP_CREATE_COLLECTION' |
    'COMMON.OP_DELETE_ASSETS' |
    'COMMON.OP_DELETE_COLLECTION' |
    'COMMON.OP_EDIT_ASSETS' |
    'COMMON.OP_EDIT_COLLECTION' |
    'COMMON.OP_GET_ASSETS' |
    'COMMON.OP_GET_COLLECTION' |
    'COMMON.OP_GET_COLLECTIONS' |
    'COMMON.OP_GET_LOCATIONS' |
    'COMMON.OP_GET_NUM_COLLECTIONS' |
    'COMMON.OP_GET_PERMISSIONS' |
    'COMMON.OR' |
    'COMMON.OTHER' |
    'COMMON.OUT_OF_RANGE' |
    'COMMON.PASSWORD' |
    'COMMON.PAY' |
    'COMMON.PER_PAGE' |
    'COMMON.PHONE_NUMBER' |
    'COMMON.PLANNED' |
    'COMMON.PLATFORM' |
    'COMMON.PLATFORMS' |
    'COMMON.PLEASE_CONTACT_YOUR_AGENCY_FOR_FURTHER_INFORMATION' |
    'COMMON.PREVIEW' |
    'COMMON.PREVIOUS' |
    'COMMON.PRICE' |
    'COMMON.PRIMARY' |
    'COMMON.PRINT' |
    'COMMON.PRIVATE' |
    'COMMON.PROCESSING' |
    'COMMON.PRODUCTS.CAMPAIGN_MONITOR' |
    'COMMON.PRODUCTS.CLUBREADY' |
    'COMMON.PRODUCTS.DIGITAL_STACK' |
    'COMMON.PRODUCTS.FACEBOOK' |
    'COMMON.PRODUCTS.FACEBOOK_ADS' |
    'COMMON.PRODUCTS.FACEBOOK_AND_INSTAGRAM_ADS' |
    'COMMON.PRODUCTS.FITWARE' |
    'COMMON.PRODUCTS.FOUR51' |
    'COMMON.PRODUCTS.GLOFOX' |
    'COMMON.PRODUCTS.GOOGLE' |
    'COMMON.PRODUCTS.GOOGLE_ADWORDS' |
    'COMMON.PRODUCTS.GOOGLE_ANALYTICS' |
    'COMMON.PRODUCTS.GOOGLE_MY_BUSINESS' |
    'COMMON.PRODUCTS.INSTAGRAM' |
    'COMMON.PRODUCTS.INSTAGRAM_VIA_FACEBOOK' |
    'COMMON.PRODUCTS.LINKEDIN' |
    'COMMON.PRODUCTS.MAILCHIMP' |
    'COMMON.PRODUCTS.SENDGRID' |
    'COMMON.PRODUCTS.TWITTER' |
    'COMMON.PROGRESS_MODAL.STATUS_MESSAGE' |
    'COMMON.PUBLIC' |
    'COMMON.QUANTITY' |
    'COMMON.REFRESH' |
    'COMMON.REGION' |
    'COMMON.RELOAD' |
    'COMMON.REMOVE' |
    'COMMON.RENAME' |
    'COMMON.RENAME_SOMETHING' |
    'COMMON.REPLACE_PDF' |
    'COMMON.REQUIRED' |
    'COMMON.REQUIRED_FIELD_HELP' |
    'COMMON.REQUIRED_FIELD_MESSAGE' |
    'COMMON.RETRY' |
    'COMMON.REVIEW' |
    'COMMON.ROLE' |
    'COMMON.SAVE' |
    'COMMON.SAVE_NEW' |
    'COMMON.SCHEDULE' |
    'COMMON.SCHEDULED' |
    'COMMON.SEARCH' |
    'COMMON.SEARCH_ASSETS' |
    'COMMON.SEARCH_COLLECTIONS' |
    'COMMON.SEARCH_EVERYTHING' |
    'COMMON.SEARCH_RESULTS' |
    'COMMON.SEARCH_WITHIN' |
    'COMMON.SELECTED' |
    'COMMON.SELECTED_CLIENTS' |
    'COMMON.SELECT_ALL' |
    'COMMON.SELECT_AN_OPTION' |
    'COMMON.SELECT_A_CLIENT' |
    'COMMON.SELECT_START_AND_END_DATES' |
    'COMMON.SEND' |
    'COMMON.SENDING' |
    'COMMON.SEND_QUOTE' |
    'COMMON.SETTINGS' |
    'COMMON.SHIPPING' |
    'COMMON.SHIPPING_FEE' |
    'COMMON.SHOW_ALL' |
    'COMMON.SHOW_LESS' |
    'COMMON.SKIP' |
    'COMMON.SOME_ASSETS' |
    'COMMON.SORT' |
    'COMMON.SORT_BY' |
    'COMMON.SORT_DIRECTION_TIP' |
    'COMMON.SORT_DIRECTION_TIP_ASC' |
    'COMMON.SORT_DIRECTION_TIP_DESC' |
    'COMMON.START_DATE' |
    'COMMON.STATUS' |
    'COMMON.STEP_N_OF_COUNT' |
    'COMMON.SUBJECT' |
    'COMMON.SUBMIT' |
    'COMMON.TAG' |
    'COMMON.TAGS' |
    'COMMON.TEMPLATE_CATEGORY' |
    'COMMON.TERMS_AND_CONDITIONS' |
    'COMMON.TERMS_AND_CONDITIONS_WITH_SYMBOL' |
    'COMMON.TEXT' |
    'COMMON.THIS_DOCUMENT_CANNOT_BE_PREVIEWED' |
    'COMMON.THIS_MONTH' |
    'COMMON.TIMEZONE' |
    'COMMON.TIME_PERIOD.AFTERNOON' |
    'COMMON.TIME_PERIOD.MORNING' |
    'COMMON.TITLE' |
    'COMMON.TITLES.DR' |
    'COMMON.TITLES.MISS' |
    'COMMON.TITLES.MR' |
    'COMMON.TITLES.MRS' |
    'COMMON.TITLES.MS' |
    'COMMON.TITLES.PROF' |
    'COMMON.TITLES.SIR' |
    'COMMON.TODAY' |
    'COMMON.TOGGLE_NAVIGATION' |
    'COMMON.TOMORROW' |
    'COMMON.TOOLTIPS.SELECT_ALL' |
    'COMMON.TOTAL' |
    'COMMON.TYPE' |
    'COMMON.UNITS.INCHES' |
    'COMMON.UNITS.MILLIMETERS' |
    'COMMON.UNKNOWN' |
    'COMMON.UNPUBLISHED' |
    'COMMON.UNSUPPORTED_IMAGE_FILE_TYPE' |
    'COMMON.UPDATE' |
    'COMMON.UPDATING' |
    'COMMON.UPLOAD' |
    'COMMON.UPLOAD_A_FILE' |
    'COMMON.UPLOAD_A_LOGO' |
    'COMMON.UPLOAD_A_PDF' |
    'COMMON.UPLOAD_DELETE_CONFIRM' |
    'COMMON.UPLOAD_FILES' |
    'COMMON.URL' |
    'COMMON.USER' |
    'COMMON.USERNAME' |
    'COMMON.USERS' |
    'COMMON.USE_DISPLAY_NAME' |
    'COMMON.VALIDATION.INVALID_DATE' |
    'COMMON.VALIDATION.INVALID_EMAIL' |
    'COMMON.VALIDATION.MUST_CONFIRM_DETAILS_TO_CONTINUE' |
    'COMMON.VALIDATION.REQUIRED' |
    'COMMON.VALIDATION.STRING_TOO_LONG' |
    'COMMON.VIDEO' |
    'COMMON.VIEW' |
    'COMMON.VIEW_MORE' |
    'COMMON.VISIBLE_TO_WHICH' |
    'COMMON.WEB' |
    'COMMON.WIDTH' |
    'COMMON.YEP' |
    'COMMON.YES' |
    'COMMON.YESTERDAY' |
    'COMMON.YOUR_BROWSER_DOES_NOT_SUPPORT_EMBEDDED_VIDEOS' |
    'COMMON.YOU_CURRENTLY_HAVE_NO_COLLECTIONS' |
    'COMPONENTS.TOGGLE_COLLAPSE_CHECKBOX' |
    'DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.ACTIVITIES' |
    'DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.AGENCY' |
    'DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.AGENCY_BRANDS' |
    'DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.COMMUNICATE' |
    'DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.COMMUNICATE_SEND' |
    'DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.COMMUNICATE_SEND_REPORTS' |
    'DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.CONNECTIONS' |
    'DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.CONNECTIONS_PLATFORMS' |
    'DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.DASHBOARD' |
    'DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.ENGAGEMENT' |
    'DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.ENGAGEMENT_LOCATION_ACTIVITY' |
    'DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.ENGAGEMENT_OVERVIEW' |
    'DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.ENGAGEMENT_REGION_GROUP_ACTIVITY' |
    'DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.ENGAGEMENT_TEMPLATE_USE' |
    'DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.LEARN_MENU' |
    'DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.MANAGE' |
    'DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.MANAGE_HASHTAG_SETS' |
    'DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.MANAGE_LEARN_MENU' |
    'DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.MANAGE_LOCATIONS' |
    'DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.MANAGE_REGIONS_GROUPS' |
    'DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.MANAGE_USERS' |
    'DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.ROADMAP' |
    'DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.STYLE' |
    'DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.STYLE_COLORS' |
    'DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.STYLE_FONTS' |
    'DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.STYLE_STYLE_GUIDE' |
    'DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.TEMPLATES' |
    'DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.TEMPLATE_CATEGORIES' |
    'DASHBOARD.BUILT_POSTS' |
    'DASHBOARD.DUE_IN_N_DAYS' |
    'DASHBOARD.DUE_IN_N_DAYS_plural' |
    'DASHBOARD.DUE_IN_N_WEEKS' |
    'DASHBOARD.DUE_IN_N_WEEKS_plural' |
    'DASHBOARD.DUE_TODAY' |
    'DASHBOARD.DUE_TOMORROW' |
    'DASHBOARD.FAILED_TO_SET_YOUR_LOCATION' |
    'DASHBOARD.FETCH_DASHBOARD_DETAILS' |
    'DASHBOARD.FETCH_LATEST_WEBINAR' |
    'DASHBOARD.FETCH_UPCOMING_EVENTS' |
    'DASHBOARD.HERO_MESSAGE' |
    'DASHBOARD.HOW_ARE_YOU_TRACKING' |
    'DASHBOARD.IN_N_WEEKS' |
    'DASHBOARD.IN_N_WEEKS_plural' |
    'DASHBOARD.LATEST_WEBINAR.AGENCY_ADVICE_FOR_SHOWING_WEBINAR' |
    'DASHBOARD.LATEST_WEBINAR.MORE_WEBINARS' |
    'DASHBOARD.LATEST_WEBINAR.WEBINAR' |
    'DASHBOARD.LEARN_MORE' |
    'DASHBOARD.LOCATION' |
    'DASHBOARD.NO_UPCOMING_EVENTS' |
    'DASHBOARD.PERFORMANCE_SUMMARY.AVERAGE_SHORT' |
    'DASHBOARD.PERFORMANCE_SUMMARY.CONNECT_APPS_TO_SEE_PERFORMANCE' |
    'DASHBOARD.PERFORMANCE_SUMMARY.DIFFERENCE' |
    'DASHBOARD.PERFORMANCE_SUMMARY.FAILED_TO_GET_PERFORMANCE_METRIC' |
    'DASHBOARD.PERFORMANCE_SUMMARY.FETCH_PERFORMANCE_METRICS' |
    'DASHBOARD.PERFORMANCE_SUMMARY.FULL_PERFORMANCE_REPORT' |
    'DASHBOARD.PERFORMANCE_SUMMARY.INSUFFICIENT_DATA_RECORDED' |
    'DASHBOARD.PERFORMANCE_SUMMARY.INSUFFICIENT_DATA_RECORDED_plural' |
    'DASHBOARD.PERFORMANCE_SUMMARY.METRICS.ADWORDS_CONVERSIONS' |
    'DASHBOARD.PERFORMANCE_SUMMARY.METRICS.ADWORDS_CONVERSION_VALUE' |
    'DASHBOARD.PERFORMANCE_SUMMARY.METRICS.FACEBOOK_ENGAGEMENT_CLICKS' |
    'DASHBOARD.PERFORMANCE_SUMMARY.METRICS.FACEBOOK_ENGAGEMENT_REACH' |
    'DASHBOARD.PERFORMANCE_SUMMARY.METRICS.INSTAGRAM_FOLLOWERS' |
    'DASHBOARD.PERFORMANCE_SUMMARY.METRICS.SPEND' |
    'DASHBOARD.PERFORMANCE_SUMMARY.METRICS.TWITTER_LIKES' |
    'DASHBOARD.PERFORMANCE_SUMMARY.PERFORMANCE_HEADING' |
    'DASHBOARD.PERFORMANCE_SUMMARY.SERVICE_NOT_AUTHORISED' |
    'DASHBOARD.READY_TO_BUILD_THESE' |
    'DASHBOARD.SUGGESTED_TEMPLATES.AGENCY_ADVICE_FOR_FEATURING_TEMPLATES' |
    'DASHBOARD.SUGGESTED_TEMPLATES.BUILD_AND_SCHEDULE_GALLERY' |
    'DASHBOARD.SUGGESTED_TEMPLATES.FETCH_SUGGESTED_TEMPLATES' |
    'DASHBOARD.SUGGESTED_TEMPLATES.SUGGESTED_TEMPLATES' |
    'DASHBOARD.UPCOMING_EVENTS.PLAN_CALENDAR' |
    'DASHBOARD.UPCOMING_EVENTS.UPCOMING' |
    'DASHBOARD.UPCOMING_GENERAL_EVENTS' |
    'DASHBOARD.WATCH_VIDEO' |
    'DASHBOARD.WELCOME_MESSAGE' |
    'DASHBOARD.WELCOME_PAGE.DID_YOU_KNOW' |
    'DASHBOARD.WELCOME_PAGE.NUM_COUNTRIES' |
    'DASHBOARD.WELCOME_PAGE.NUM_LOCATIONS' |
    'DASHBOARD.WELCOME_PAGE.WELCOME_BACK' |
    'DASHBOARD.WELCOME_PAGE.WHATS_NEW' |
    'EMAIL.AUTOMATED_EMAIL_DO_NOT_REPLY' |
    'EMAIL.IF_YOU_WISH_TO_UNSUBSCRIBE' |
    'EMAIL.INVITE_EMAIL.BUTTON_TEXT' |
    'EMAIL.INVITE_EMAIL.DOWNLOAD_THE_APP' |
    'EMAIL.INVITE_EMAIL.IF_THIS_EMAIL_SHOULD_NOT_HAVE_BEEN_SENT_TO_YOU' |
    'EMAIL.INVITE_EMAIL.INSTRUCTIONS' |
    'EMAIL.INVITE_EMAIL.SUBJECT' |
    'EMAIL.INVITE_EMAIL.WELCOME' |
    'EMAIL.INVITE_EMAIL.WHERE_TO_GET_HELP' |
    'EMAIL.LINK_WILL_EXPIRE' |
    'EMAIL.LINK_WILL_EXPIRE_HOUR' |
    'EMAIL.LINK_WILL_EXPIRE_HOUR_plural' |
    'EMAIL.LINK_WILL_EXPIRE_plural' |
    'EMAIL.LOG_IN_TO_CHANGE_PROFILE_SETTINGS' |
    'EMAIL.LOG_IN_TO_RESPOND' |
    'EMAIL.LOG_IN_TO_RESPOND_OR_VIEW_ATTACHMENTS' |
    'EMAIL.SEND_TO_PRINT.ARTWORK_HAS_BEEN_SENT_TO' |
    'EMAIL.SEND_TO_PRINT.DOWNLOAD_ARTWORK' |
    'EMAIL.SEND_TO_PRINT.INSTRUCTIONS' |
    'EMAIL.SEND_TO_PRINT.ORDER_NUMBER' |
    'EMAIL.SEND_TO_PRINT.PRINT_PROVIDER_DETAILS' |
    'EMAIL.SEND_TO_PRINT.PROVIDER_WILL_BE_IN_TOUCH' |
    'EMAIL.SEND_TO_PRINT.QUANTITY' |
    'EMAIL.SEND_TO_PRINT.SKU' |
    'EMAIL.SEND_TO_PRINT.SKUNAME' |
    'EMAIL.SEND_TO_PRINT.SUBJECT' |
    'EMAIL.SEND_TO_PRINT.SUBJECT_ORDER_NUMBER' |
    'EMAIL.SEND_TO_PRINT.USER_INVOICE_SUBJECT' |
    'ERRORS.ASSET_LIBRARY.ASSETS.FETCH_FAILED' |
    'ERRORS.ASSET_LIBRARY.COLLECTIONS.FETCH_FAILED' |
    'ERRORS.BAD_REQUEST_ERRORS.BILLING_DETAILS_UPDATE_ALREADY_FINALISED' |
    'ERRORS.BAD_REQUEST_ERRORS.BILLING_DETAILS_UPDATE_ALREADY_RECEIVED' |
    'ERRORS.BAD_REQUEST_ERRORS.CANNOT_CHANGE_COLLECTION_TYPE' |
    'ERRORS.BAD_REQUEST_ERRORS.CANNOT_CREATE_PRIVATE_COMMENT' |
    'ERRORS.BAD_REQUEST_ERRORS.CANNOT_LINK_ACCESS_TOKEN' |
    'ERRORS.BAD_REQUEST_ERRORS.CANNOT_OVERRIDE_CUSTOM_FONT_FILE' |
    'ERRORS.BAD_REQUEST_ERRORS.CLIENT_DOES_NOT_EXIST' |
    'ERRORS.BAD_REQUEST_ERRORS.CLIENT_IDS_DO_NOT_MATCH' |
    'ERRORS.BAD_REQUEST_ERRORS.END_DATE_MUST_BE_BEFORE_START_DATE_OR_ABSENT' |
    'ERRORS.BAD_REQUEST_ERRORS.FACEBOOK_MARKETING_AD_ACCOUNT_INVALID_CRITERIA' |
    'ERRORS.BAD_REQUEST_ERRORS.FILE_NAME_CANNOT_START_WITH_PIPE' |
    'ERRORS.BAD_REQUEST_ERRORS.INVALID_DOCUMENT' |
    'ERRORS.BAD_REQUEST_ERRORS.INVALID_ID' |
    'ERRORS.BAD_REQUEST_ERRORS.INVALID_SESSION' |
    'ERRORS.BAD_REQUEST_ERRORS.INVALID_URL_TO_SIGN' |
    'ERRORS.BAD_REQUEST_ERRORS.LOCATION_ALREADY_SIGNED_UP' |
    'ERRORS.BAD_REQUEST_ERRORS.LOCATION_SUBSCRIPTION_EXPIRED' |
    'ERRORS.BAD_REQUEST_ERRORS.OPERATION_RESTRICTED_TO_SELF' |
    'ERRORS.BAD_REQUEST_ERRORS.PAYMENT_ALREADY_FINALISED' |
    'ERRORS.BAD_REQUEST_ERRORS.PLANNER_ACTION_DATE_BELOW_THRESHOLD' |
    'ERRORS.BAD_REQUEST_ERRORS.PLANNER_ACTION_DATE_BELOW_THRESHOLD_plural' |
    'ERRORS.BAD_REQUEST_ERRORS.PLANNER_CANNOT_SPECIFY_ALL_OR_FUTURE' |
    'ERRORS.BAD_REQUEST_ERRORS.RECURRING_PAYMENT_CANNOT_BE_DELETED' |
    'ERRORS.BAD_REQUEST_ERRORS.RECURRING_PAYMENT_DATES_OVERLAP_WITH_EXISTING' |
    'ERRORS.BAD_REQUEST_ERRORS.RECURRING_PAYMENT_LAST_CANNOT_BE_DELETED' |
    'ERRORS.BAD_REQUEST_ERRORS.REPORT_SUMMARY_ID_INVALID' |
    'ERRORS.BAD_REQUEST_ERRORS.REQUEST_RETURNED_NO_RESPONSE_DATA' |
    'ERRORS.BAD_REQUEST_ERRORS.SCHEDULED_DATE_CANNOT_BE_MORE_THAN_ONE_YEAR_IN_THE_FUTURE' |
    'ERRORS.BAD_REQUEST_ERRORS.SEND_TO_FOUR51_MISSING_DATA' |
    'ERRORS.BAD_REQUEST_ERRORS.SKU_HAS_BOTH_PRICE_AND_QUANTITY_OPTIONS' |
    'ERRORS.BAD_REQUEST_ERRORS.SKU_HAS_NO_PRICING_DATA' |
    'ERRORS.BAD_REQUEST_ERRORS.SPECIAL_REQUEST_INVALID_DATE' |
    'ERRORS.BAD_REQUEST_ERRORS.USER_BELONGS_TO_MULTIPLE_AGENCIES' |
    'ERRORS.BAD_REQUEST_ERRORS.USER_NOT_FOUND' |
    'ERRORS.BAD_REQUEST_ERRORS.VALIDATION_ERROR' |
    'ERRORS.BAD_REQUEST_ERRORS.VIDEO_ID_NOT_FOUND' |
    'ERRORS.BRAND.BRAND_COLOURS.ERROR_ADDING_BRAND_COLOUR' |
    'ERRORS.BRAND.BRAND_COLOURS.ERROR_DELETING_BRAND_COLOUR' |
    'ERRORS.BRAND.BRAND_COLOURS.ERROR_RENAMING_BRAND_COLOUR' |
    'ERRORS.BRAND.BRAND_COLOURS.ERROR_UPDATING_BRAND_COLOUR' |
    'ERRORS.BRAND.BRAND_COLOURS.ERROR_UPDATING_BRAND_COLOUR_ORDER' |
    'ERRORS.BRAND.LOCATION_CATEGORIES.CATEGORY_LABEL_REQUIRED' |
    'ERRORS.BRAND.LOCATION_CATEGORIES.ERROR_ADDING_LOCATION_CATEGORY' |
    'ERRORS.BRAND.LOCATION_CATEGORIES.ERROR_DELETING_LOCATION_CATEGORY' |
    'ERRORS.BRAND.LOCATION_CATEGORIES.ERROR_RENAMING_LOCATION_CATEGORY' |
    'ERRORS.BRAND.LOCATION_CATEGORIES.ERROR_UPDATING_LOCATIONS_FOR_CATEGORY' |
    'ERRORS.BRAND.NO_CLIENT_SELECTED' |
    'ERRORS.EXCEPTION_ID' |
    'ERRORS.EXTERNAL_SERVICE_ERRORS.ACR_CLOUD' |
    'ERRORS.EXTERNAL_SERVICE_ERRORS.ACR_CLOUD_EMPTY_RESPONSE' |
    'ERRORS.EXTERNAL_SERVICE_ERRORS.EMAIL_FAILURE' |
    'ERRORS.EXTERNAL_SERVICE_ERRORS.EWAY_ERROR' |
    'ERRORS.EXTERNAL_SERVICE_ERRORS.FITWARE_ERROR' |
    'ERRORS.EXTERNAL_SERVICE_ERRORS.FITWARE_UNRECOGNISED_RESPONSE' |
    'ERRORS.EXTERNAL_SERVICE_ERRORS.PASSTHROUGH' |
    'ERRORS.EXTERNAL_SERVICE_ERRORS.TWITTER_ERROR' |
    'ERRORS.EXTERNAL_SERVICE_ERRORS.TWITTER_UNKNOWN_ERROR' |
    'ERRORS.FACEBOOK_ERRORS.MAX_CHARACTER_LIMIT_FOR_CAPTION_REACHED' |
    'ERRORS.FACEBOOK_ERRORS.MISSING_FIRST_COMMENT_HASHTAGS_PERMISSION' |
    'ERRORS.FACEBOOK_ERRORS.SOME_LOCATIONS_ARE_MISSING_FIRST_COMMENT_HASHTAGS_PERMISSION' |
    'ERRORS.FACEBOOK_ERRORS.UNTRANSLATED_ERROR_MESSAGE' |
    'ERRORS.FACEBOOK_MARKETING_ERRORS.PERMISSIONS_NOT_GRANTED' |
    'ERRORS.FINALISE_BILLING_DETAILS_UPDATE_ERROR' |
    'ERRORS.FITWARE_MEMBER_ENGAGER.UNRECOGNISED_RESPONSE' |
    'ERRORS.FITWARE_MEMBER_ENGAGER.UNTRANSLATED_ERROR_MESSAGE' |
    'ERRORS.FORBIDDEN_ERRORS.ACCESS_FORBIDDEN' |
    'ERRORS.FORBIDDEN_ERRORS.CANNOT_ACCESS_CLIENT' |
    'ERRORS.FORBIDDEN_ERRORS.CANNOT_ACCESS_LOCATION' |
    'ERRORS.FORBIDDEN_ERRORS.NO_PERMISSION_TO_VIEW_CLIENT' |
    'ERRORS.FORBIDDEN_ERRORS.TRY_THIS_MUST_BE_ASSIGNED_TO_A_CLIENT' |
    'ERRORS.FOUR51.INVALID_QUANTITY' |
    'ERRORS.FOUR51.INVALID_USERNAME_OR_PASSWORD' |
    'ERRORS.FOUR51.PRODUCT_MISCONFIGURED' |
    'ERRORS.FOUR51.UNRECOGNISED_RESPONSE' |
    'ERRORS.FOUR51.UNTRANSLATED_ERROR_MESSAGE' |
    'ERRORS.GENERATE_MAP_ERRORS.FAILED' |
    'ERRORS.GENERATE_MAP_ERRORS.MAP_ALREADY_EXISTS' |
    'ERRORS.GENERATE_MAP_ERRORS.NO_MAP_FOR_LOCATION' |
    'ERRORS.GENERATE_MAP_ERRORS.PAYMENT_FAILED' |
    'ERRORS.GENERIC' |
    'ERRORS.GOOGLE_ADS.PERMISSIONS' |
    'ERRORS.GOOGLE_ADS.PERMISSIONS_LOCATION_REPORT' |
    'ERRORS.GOOGLE_ADS.UNKNOWN' |
    'ERRORS.GOOGLE_ANALYTICS.DATA_PARSE_ERROR' |
    'ERRORS.GOOGLE_ANALYTICS.DATA_RESPONSE_ERROR' |
    'ERRORS.GOOGLE_ANALYTICS.PERMISSIONS' |
    'ERRORS.GOOGLE_MY_BUSINESS.FAILED_TO_POST' |
    'ERRORS.GOOGLE_MY_BUSINESS.FAILED_TO_RETRIEVE_LOCATION_NAME' |
    'ERRORS.GOOGLE_MY_BUSINESS.SERVICE_NOT_CONFIGURED' |
    'ERRORS.GOOGLE_OAUTH_ERRORS.INVALID_GRANT' |
    'ERRORS.INSTAGRAM_ERRORS.API_RATE_LIMITED' |
    'ERRORS.INSTAGRAM_ERRORS.API_RATE_LIMITED_CONTINUE_POSTING' |
    'ERRORS.INSTAGRAM_ERRORS.API_RATE_LIMIT_NOT_FOUND' |
    'ERRORS.INSTAGRAM_ERRORS.FAILED_TO_POST' |
    'ERRORS.INSTAGRAM_ERRORS.MAX_CHARACTER_LIMIT_FOR_CAPTION_REACHED' |
    'ERRORS.INSTAGRAM_ERRORS.MISSING_FIRST_COMMENT_HASHTAGS_PERMISSION' |
    'ERRORS.INSTAGRAM_ERRORS.SOME_LOCATIONS_ARE_MISSING_FIRST_COMMENT_HASHTAGS_PERMISSION' |
    'ERRORS.INSTAGRAM_ERRORS.UNTRANSLATED_ERROR_MESSAGE' |
    'ERRORS.INVALID_INPUT_ERRORS.BASE64_STRING_MISSING_MIME_TYPE' |
    'ERRORS.INVALID_INPUT_ERRORS.COLOUR' |
    'ERRORS.INVALID_INPUT_ERRORS.EWAY_MULTIPLE_PAYMENT_TRANSACTIONS' |
    'ERRORS.INVALID_INPUT_ERRORS.EWAY_MULTIPLE_TOKENISATION_TRANSACTIONS' |
    'ERRORS.INVALID_INPUT_ERRORS.EWAY_MULTIPLE_TRANSACTIONS' |
    'ERRORS.INVALID_INPUT_ERRORS.EWAY_ZERO_PAYMENT_TRANSACTIONS' |
    'ERRORS.INVALID_INPUT_ERRORS.EWAY_ZERO_TRANSACTIONS' |
    'ERRORS.INVALID_INPUT_ERRORS.FACEBOOK_PAGE_ID_MIGRATION' |
    'ERRORS.INVALID_INPUT_ERRORS.FILE_TOO_LARGE' |
    'ERRORS.INVALID_INPUT_ERRORS.GRAPHQL_INPUT' |
    'ERRORS.INVALID_INPUT_ERRORS.INVALID_URL' |
    'ERRORS.INVALID_INPUT_ERRORS.MISSING_FILE' |
    'ERRORS.INVALID_INPUT_ERRORS.REPOSITORY_HAS_NULL_MODEL' |
    'ERRORS.INVALID_INPUT_ERRORS.UPLOAD_ID_MISSING' |
    'ERRORS.INVALID_INPUT_ERRORS.ZERO_WIDTH_OR_HEIGHT_VIDEO' |
    'ERRORS.LINKEDIN.FAILED_TO_POST' |
    'ERRORS.LINKEDIN.INVALID_GRANT' |
    'ERRORS.LINKEDIN.SERVICE_NOT_CONFIGURED' |
    'ERRORS.LOCATION_DRAFT.CANNOT_SAVE_LOCATION_REVISION_WITHOUT_A_TITLE' |
    'ERRORS.LOCATION_DRAFT.FAILED_TO_SAVE' |
    'ERRORS.LOGIN_TOKEN_ERRORS.API_KEY_INVALID' |
    'ERRORS.LOGIN_TOKEN_ERRORS.API_KEY_MISSING' |
    'ERRORS.LOGIN_TOKEN_ERRORS.TOKEN_KEYS_MISMATCH' |
    'ERRORS.LOGIN_TOKEN_ERRORS.TOKEN_REFERENCE_NOT_FOUND' |
    'ERRORS.LOGIN_TOKEN_ERRORS.USERNAME_NOT_SPECIFIED' |
    'ERRORS.LOGIN_TOKEN_ERRORS.USER_NOT_FOUND' |
    'ERRORS.MISSING_VALUE_ERRORS.FACEBOOK_AD_SET_MISSING_END_DATE' |
    'ERRORS.MISSING_VALUE_ERRORS.FACEBOOK_AD_SET_MISSING_START_DATE' |
    'ERRORS.MISSING_VALUE_ERRORS.GATHER_STATS_ERROR_HANDLER_MISSING_LOCATION_ID' |
    'ERRORS.MISSING_VALUE_ERRORS.REPLACEMENT_VALUE_FOR_LOCAL_RESOURCE' |
    'ERRORS.MULTIPLE_ERRORS' |
    'ERRORS.NOT_FOUND_ERRORS.AGENCY_LOCALE_NOT_FOUND_WITH_ID' |
    'ERRORS.NOT_FOUND_ERRORS.ENTITY_NOT_FOUND' |
    'ERRORS.NOT_FOUND_ERRORS.ENTITY_NOT_FOUND_WITH_ID' |
    'ERRORS.NOT_FOUND_ERRORS.ENTITY_NOT_FOUND_WITH_TOKEN' |
    'ERRORS.NOT_FOUND_ERRORS.ENTITY_TO_DELETE_NOT_FOUND' |
    'ERRORS.NOT_FOUND_ERRORS.ENTITY_TO_UPDATE_NOT_FOUND' |
    'ERRORS.NOT_FOUND_ERRORS.GOOGLE_ADWORDS_GET_REPORT_DEFINITION_NO_ACCESS_TOKEN' |
    'ERRORS.NOT_FOUND_ERRORS.NO_FACEBOOK_ACCESS_TOKEN_FOR_LOCATION' |
    'ERRORS.NOT_FOUND_ERRORS.NO_MATCHING_EMAIL' |
    'ERRORS.NOT_FOUND_ERRORS.RESOURCE_NOT_FOUND' |
    'ERRORS.NOT_FOUND_ERRORS.USER_DOES_NOT_BELONG_TO_ANY_AGENCIES' |
    'ERRORS.NOT_FOUND_ERRORS.USER_NOT_FOUND' |
    'ERRORS.NOT_FOUND_ERRORS.USER_NOT_FOUND_WITH_ID' |
    'ERRORS.NO_NETWORK_CONNECTION_ERROR' |
    'ERRORS.NO_STATS_DATA_ERRORS.GOOGLE_ADWORDS_ZERO_VALUES' |
    'ERRORS.NO_STATS_DATA_ERRORS.NO_STATS_FOR_DATE_RANGE' |
    'ERRORS.NO_STATS_DATA_ERRORS.NO_STATS_FOR_GIVEN_PERIOD' |
    'ERRORS.OAUTH_ERRORS.AUTHORISATION_DENIED' |
    'ERRORS.OAUTH_ERRORS.CALLBACK_CONFIRMATION_FAILED' |
    'ERRORS.OAUTH_ERRORS.NO_OAUTH_TOKEN' |
    'ERRORS.OAUTH_ERRORS.TOKEN_DOES_NOT_MATCH' |
    'ERRORS.OAUTH_ERRORS.UNKNOWN_GRANT_TYPE' |
    'ERRORS.PARSING_ERRORS.FOUR51_AUTH_TOKEN' |
    'ERRORS.PARSING_ERRORS.PARSING_ERROR' |
    'ERRORS.PUBLISH.ERRORS.ACCESS_TOKEN_HAS_EXPIRED' |
    'ERRORS.PUBLISH.ERRORS.DUPLICATE_POSTS_DETECTED' |
    'ERRORS.PUBLISH.ERRORS.FAILED_TO_PUBLISH_TO_LOCATION' |
    'ERRORS.PUBLISH.ERRORS.GENERIC_ERROR_MESSAGE' |
    'ERRORS.PUBLISH.ERRORS.INSTAGRAM_CAROUSEL_POST_REQUIREMENTS_NOT_MET' |
    'ERRORS.PUBLISH.ERRORS.INSTAGRAM_MEDIA_DOWNLOAD_TIMEOUT' |
    'ERRORS.PUBLISH.ERRORS.INSTAGRAM_SUSPECTED_SPAM' |
    'ERRORS.PUBLISH.ERRORS.INSTAGRAM_TAG_COUNT_REACHED' |
    'ERRORS.PUBLISH.ERRORS.NOT_SHOWN_MISSING_FROM_LIST' |
    'ERRORS.PUBLISH.ERRORS.PERMISSIONS_NOT_GRANTED' |
    'ERRORS.PUBLISH.ERRORS.SERVICE_INVALID_ASPECT_RATIO' |
    'ERRORS.PUBLISH.ERRORS.SERVICE_INVALID_SCHEDULE_DATE' |
    'ERRORS.PUBLISH.ERRORS.SERVICE_MAXIMUM_CAPTION_LENGTH_EXCEEDED' |
    'ERRORS.PUBLISH.ERRORS.SERVICE_MAXIMUM_MEDIA_SIZE_EXCEEDED' |
    'ERRORS.PUBLISH.ERRORS.SERVICE_MAXIMUM_PUBLISH_COUNT_REACHED' |
    'ERRORS.PUBLISH.ERRORS.UNSUPPORTED_FILE_FORMAT' |
    'ERRORS.PUBLISH.ERRORS.USER_CREDENTIALS_CHANGED' |
    'ERRORS.PUBLISH.ERRORS.USER_INTERVENTION_REQUIRED' |
    'ERRORS.PUBLISH.INVALID_LOCATION_NODE_ID' |
    'ERRORS.PUBLISH.ONE_OR_MORE_ARTIFACT_IDS_ARE_INVALID' |
    'ERRORS.PUBLISH.SCHEDULING_STATUS_ERRORS.UNKNOWN' |
    'ERRORS.REQUEST_TOKEN_ERRORS.API_KEY_INVALID' |
    'ERRORS.REQUEST_TOKEN_ERRORS.API_KEY_NOT_SPECIFIED' |
    'ERRORS.REQUEST_TOKEN_ERRORS.ISSUER_NOT_SPECIFIED' |
    'ERRORS.REQUEST_TOKEN_ERRORS.TOKEN_INVALID' |
    'ERRORS.SCHEDULING.DELETE.TOO_CLOSE_TO_SCHEDULED_TIME' |
    'ERRORS.SCHEDULING.DELETE.UNKNOWN' |
    'ERRORS.SCHEDULING.RESCHEDULE.TOO_CLOSE_TO_SCHEDULED_TIME' |
    'ERRORS.SCHEDULING.RESCHEDULE.UNKNOWN' |
    'ERRORS.SENDGRID.COULD_NOT_FIND_UNSUB_GROUP' |
    'ERRORS.SENDGRID.DELETE_EMAIL_ERROR' |
    'ERRORS.SENDGRID.RESCHEDULE_EMAIL_ERROR' |
    'ERRORS.SENDGRID.SINGLE_SEND_FAILED' |
    'ERRORS.SENDGRID.SINGLE_SEND_FAILED_NO_ID' |
    'ERRORS.SENDGRID.WAIT_30_MINS' |
    'ERRORS.SERVICE_ACCESS_ERRORS.ACCESS_EXPIRED_OR_FORBIDDEN' |
    'ERRORS.SERVICE_ACCESS_ERRORS.ACCESS_EXPIRED_OR_FORBIDDEN_WITH_DETAILS' |
    'ERRORS.SERVICE_ACCESS_ERRORS.FACEBOOK_ACCOUNT_CANNOT_ACCESS_PAGE' |
    'ERRORS.SERVICE_ACCESS_ERRORS.FACEBOOK_PAGE_TOKEN_NOT_RETURNED' |
    'ERRORS.SERVICE_AUTHENTICATION_ERRORS.FAILED_TO_AUTHORISE' |
    'ERRORS.SERVICE_CONFIGURATION_ERRORS.CLIENT_MISSING_FITWARE_BUSINESS' |
    'ERRORS.SERVICE_CONFIGURATION_ERRORS.FACEBOOK_PAGE_NOT_CONFIGURED' |
    'ERRORS.SERVICE_CONFIGURATION_ERRORS.FITWARE_CLIENT_CONFIG_MISSING' |
    'ERRORS.SERVICE_CONFIGURATION_ERRORS.FITWARE_MEMBER_ENGAGER_CLUB_MISSING' |
    'ERRORS.SERVICE_CONFIGURATION_ERRORS.FITWARE_MISSING_DATA' |
    'ERRORS.SERVICE_CONFIGURATION_ERRORS.FOUR51_CREDENTIALS_MISSING' |
    'ERRORS.SERVICE_CONFIGURATION_ERRORS.FOUR51_STORE_COMPANY_OR_SSO_KEY_MISSING' |
    'ERRORS.SERVICE_CONFIGURATION_ERRORS.GOOGLE_ADWORDS_CAMPAIGN_NAME_NOT_CONFIGURED' |
    'ERRORS.SERVICE_CONFIGURATION_ERRORS.GOOGLE_ADWORDS_CUSTOMER_NOT_CONFIGURED' |
    'ERRORS.SERVICE_CONFIGURATION_ERRORS.GOOGLE_ADWORDS_NOT_CONNECTED' |
    'ERRORS.SERVICE_CONFIGURATION_ERRORS.GOOGLE_ANALYTICS_PAGE_PATH_MISSING' |
    'ERRORS.SERVICE_CONFIGURATION_ERRORS.GOOGLE_ANALYTICS_VIEW_ID_MISSING' |
    'ERRORS.SERVICE_CONFIGURATION_ERRORS.LOCATION_MISSING_FACEBOOK_PAGE_ID' |
    'ERRORS.SERVICE_CONFIGURATION_ERRORS.LOCATION_MISSING_FITWARE_CLUB_NUMBER' |
    'ERRORS.SERVICE_CONFIGURATION_ERRORS.LOCATION_MISSING_INSTAGRAM_PAGE_ID' |
    'ERRORS.SERVICE_CONFIGURATION_ERRORS.SERVICE_NOT_CONFIGURED' |
    'ERRORS.SERVICE_CREDENTIALS_MISSING_ERRORS.NO_AUTHENTICATION_FOR_SERVICE' |
    'ERRORS.SERVICE_DISABLED_FOR_CLIENT' |
    'ERRORS.SERVICE_RATE_LIMIT_ERROR' |
    'ERRORS.STRIPE.UNRECOGNISED_RESPONSE' |
    'ERRORS.STRIPE.UNTRANSLATED_ERROR_MESSAGE' |
    'ERRORS.TEMPLATE_CANNOT_BE_DOWNLOADED_NO_PERMISSION' |
    'ERRORS.UNAUTHORIZED_ERRORS.PLEASE_LOGIN' |
    'ERRORS.UNAUTHORIZED_ERRORS.RESOURCE' |
    'ERRORS.UNEXPECTED_ERROR' |
    'ERRORS.UNEXPECTED_INPUT_ERRORS.FACEBOOK_PAGE_MIGRATION_IDS_NOT_FOUND' |
    'ERRORS.UNSUPPORTED_CURRENCY' |
    'ERRORS.UNSUPPORTED_OPERATION_ERRORS.ACCESS_TOKEN_CANNOT_DETERMINE_AFFECTED_TARGET_NAME' |
    'ERRORS.UNSUPPORTED_OPERATION_ERRORS.ASSIGNED_LOCATION_MAPPER_GIVEN_MULTIPLE_LOCATIONS' |
    'ERRORS.UNSUPPORTED_OPERATION_ERRORS.BANNER_NOTIFICATION_ALREADY_EXISTS' |
    'ERRORS.UNSUPPORTED_OPERATION_ERRORS.CONTROLLER_MISSING_VALIDATION' |
    'ERRORS.UNSUPPORTED_OPERATION_ERRORS.FACEBOOK_API_CLIENT_INSTANITATED_WITHOUT_A_FACEBOOK_PAGE_ID' |
    'ERRORS.UNSUPPORTED_OPERATION_ERRORS.FACEBOOK_MARKETING_API_CLIENT_INSTANITATED_WITHOUT_A_FACEBOOK_PAGE_ID' |
    'ERRORS.UNSUPPORTED_OPERATION_ERRORS.IMAGE_FORMAT_CONVERSION' |
    'ERRORS.UNSUPPORTED_OPERATION_ERRORS.MONTHLY_RECURRING_EVENTS_ONLY' |
    'ERRORS.UNSUPPORTED_OPERATION_ERRORS.PLANNER_OPERATION_NOT_SUPPORTED' |
    'ERRORS.UNSUPPORTED_OPERATION_ERRORS.PRINT_PROVIDER_SKU_MISSING_QUANTITY_OPTIONS' |
    'ERRORS.UNSUPPORTED_OPERATION_ERRORS.SOCKET_SERVER_ALREADY_READY' |
    'ERRORS.UNSUPPORTED_OPERATION_ERRORS.UNSUPPORTED_WINDOWS_TIMEZONE' |
    'ERRORS.VIDEO_IMPORT.NETWORK_ERROR' |
    'ERRORS.VIDEO_IMPORT.UNKNOWN_ERROR' |
    'ERRORS.VIDEO_IMPORT.UNSUPPORTED_FILE_TYPE' |
    'ERRORS.VIDEO_IMPORT.UNSUPPORTED_VIDEO_TYPE' |
    'ERRORS.VIDEO_PREVIEW_UNSUPPORTED' |
    'FOOTER.PRIVACY_POLICY' |
    'FOOTER.TERMS_AND_CONDITIONS' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_CENTER_HORIZONTAL.DESCRIPTION' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_CENTER_HORIZONTAL.MAC' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_CENTER_HORIZONTAL.WINDOWS' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_CENTER_VERTICAL.DESCRIPTION' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_CENTER_VERTICAL.MAC' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_CENTER_VERTICAL.WINDOWS' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_LEFT_RIGHT.DESCRIPTION' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_LEFT_RIGHT.MAC' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_LEFT_RIGHT.WINDOWS' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_TOP_BOTTOM.DESCRIPTION' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_TOP_BOTTOM.MAC' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_TOP_BOTTOM.WINDOWS' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_CENTER_HORIZONTAL.DESCRIPTION' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_CENTER_HORIZONTAL.MAC' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_CENTER_HORIZONTAL.WINDOWS' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_CENTER_VERTICAL.DESCRIPTION' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_CENTER_VERTICAL.MAC' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_CENTER_VERTICAL.WINDOWS' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_LEFT_RIGHT.DESCRIPTION' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_LEFT_RIGHT.MAC' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_LEFT_RIGHT.WINDOWS' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_TOP_BOTTOM.DESCRIPTION' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_TOP_BOTTOM.MAC' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_TOP_BOTTOM.WINDOWS' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.TITLE' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.DELETE.DESCRIPTION' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.DELETE.MAC' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.DELETE.WINDOWS' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.DUPLICATE.DESCRIPTION' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.DUPLICATE.MAC' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.DUPLICATE.WINDOWS' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.MULTI_SELECT.DESCRIPTION' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.MULTI_SELECT.MAC' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.MULTI_SELECT.WINDOWS' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.REDO.DESCRIPTION' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.REDO.MAC' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.REDO.WINDOWS' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.TITLE' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.UNDO.DESCRIPTION' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.UNDO.MAC' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.UNDO.WINDOWS' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_LEFT_RIGHT.DESCRIPTION' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_LEFT_RIGHT.MAC' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_LEFT_RIGHT.WINDOWS' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_LEFT_RIGHT_MODIFIER.DESCRIPTION' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_LEFT_RIGHT_MODIFIER.MAC' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_LEFT_RIGHT_MODIFIER.WINDOWS' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_UP_DOWN.DESCRIPTION' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_UP_DOWN.MAC' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_UP_DOWN.WINDOWS' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_UP_DOWN_MODIFIER.DESCRIPTION' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_UP_DOWN_MODIFIER.MAC' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_UP_DOWN_MODIFIER.WINDOWS' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.HORIZONTAL_LOCK.DESCRIPTION' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.HORIZONTAL_LOCK.MAC' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.HORIZONTAL_LOCK.WINDOWS' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.TITLE' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.VERTICAL_LOCK.DESCRIPTION' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.VERTICAL_LOCK.MAC' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.VERTICAL_LOCK.WINDOWS' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.MULTIPLE_LAYERS_SELECTED' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.SHORTCUT_MAC' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.SHORTCUT_WINDOWS' |
    'HELP.BUILDER_KEYBOARD_SHORTCUTS.TITLE' |
    'HELP.COMMON.WHAT_CAN_I_DO' |
    'HELP.COMMON.WHAT_DOES_THIS_MEAN' |
    'HELP.COMMON.WHY_AM_I_SEEING_THIS' |
    'HELP.HELP' |
    'HELP.NO_ASSIGNED_LOCATIONS.CANT_USE_DIGITAL_STACK' |
    'HELP.NO_ASSIGNED_LOCATIONS.CONTACT_YOUR_AGENCY' |
    'HELP.NO_ASSIGNED_LOCATIONS.DONT_HAVE_LOCATIONS_ASSIGNED' |
    'HELP.NO_ASSIGNED_LOCATIONS.TITLE' |
    'INTEGRATION.AUTH.API_KEY.API_KEY' |
    'INTEGRATION.AUTH.API_KEY.API_KEY_REQUIRED' |
    'INTEGRATION.AUTH.API_KEY.API_KEY_REQUIRED_EXPLAIN' |
    'INTEGRATION.AUTH.API_KEY.PREVIOUS_KEY' |
    'INTEGRATION.AUTH.API_KEY.PREVIOUS_KEY_EXPLAIN' |
    'INTEGRATION.CLIENT.CLUB_READY.CHAIN_ID' |
    'INTEGRATION.CLIENT.CLUB_READY.ENTER_CHAIN_ID' |
    'INTEGRATION.CLIENT.CLUB_READY.ENTER_CHAIN_ID_EXPLAIN' |
    'INTEGRATION.CLIENT.CLUB_READY.ENTER_CHAIN_ID_WITH_CLIENT_TITLE' |
    'INTEGRATION.CLIENT.CLUB_READY.MULTIPLE_CHAIN_EXPLAIN' |
    'INTEGRATION.CLIENT.NOTIFIER.ISSUE_WITH_ACCOUNT' |
    'INTEGRATION.CLIENT.NOTIFIER.RESOLUTION_1' |
    'INTEGRATION.CLIENT.NOTIFIER.RESOLUTION_2' |
    'INTEGRATION.CLIENT.STATUS_TIP.DISABLE' |
    'INTEGRATION.CLIENT.STATUS_TIP.EDIT' |
    'INTEGRATION.CLIENT.STATUS_TIP.ENABLE' |
    'INTEGRATION.CONFIGURE_INTEGRATION' |
    'INTEGRATION.DISABLED_INTEGRATION' |
    'INTEGRATION.DISABLE_FOR' |
    'INTEGRATION.EDIT_ACCOUNT_CONFIGURATION' |
    'INTEGRATION.ENABLED_INTEGRATION' |
    'INTEGRATION.ENABLE_FOR' |
    'INTEGRATION.ERRORS.GENERIC_ENABLE_ERROR' |
    'INTEGRATION.FITWARE.NOTIFY_BUSINESS_CLEARED' |
    'INTEGRATION.FITWARE.NOTIFY_BUSINESS_SET' |
    'INTEGRATION.FITWARE.NOTIFY_CLUB_UPDATED' |
    'INTEGRATION.INTEGRATIONS' |
    'INTEGRATION.INTEGRATION_CONFIGURATION' |
    'INTEGRATION.LOCATION.CLUB_READY.CLUB_ID' |
    'INTEGRATION.LOCATION.CLUB_READY.CLUB_READY_CONFIGURATION' |
    'INTEGRATION.LOCATION.CLUB_READY.CONFIGURE_SUCCESS' |
    'INTEGRATION.LOCATION.CLUB_READY.ENTER_CLUB_ID' |
    'INTEGRATION.LOCATION.NO_INTEGRATIONS_TO_CONFIGURE.EXPLAIN' |
    'INTEGRATION.LOCATION.NO_INTEGRATIONS_TO_CONFIGURE.RESOLVE' |
    'INTEGRATION.NOTIFY_ACCESS_CHECK_FAILED' |
    'INTEGRATION.NOTIFY_COULD_NOT_AUTHORIZE_SERVICE' |
    'INTEGRATION.NOTIFY_COULD_NOT_DEAUTHORIZE_SERVICE' |
    'INTEGRATION.NOTIFY_SERVICE_DEAUTHORIZED' |
    'INTEGRATION.PROMPT_CONNECT_TO_GOOGLE_ADS_DIALOG.PROMPT_TEXT' |
    'INTEGRATION.PROMPT_CONNECT_TO_GOOGLE_ADS_DIALOG.SIGN_IN_TEXT' |
    'INTEGRATION.PROMPT_CONNECT_TO_GOOGLE_ADS_DIALOG.TITLE' |
    'INTEGRATION.SETUP_INTEGRATIONS_FOR' |
    'INTRO.ACCOUNT.COMPLETE.HEADING' |
    'INTRO.ACCOUNT.COMPLETE.SUBHEADING' |
    'INTRO.ACCOUNT.COMPLETE.TIP' |
    'INTRO.ACCOUNT.PAGE.ONE.DONE_LABEL' |
    'INTRO.ACCOUNT.PAGE.ONE.STEP.ONE' |
    'INTRO.ACCOUNT.PAGE.TWO.DONE_LABEL' |
    'INTRO.ACCOUNT.PAGE.TWO.STEP.ONE' |
    'INTRO.ACCOUNT.TITLE' |
    'INTRO.ALREADY_KNOW_HOW_THIS_WORKS' |
    'INTRO.APPS.COMPLETE.HEADING' |
    'INTRO.APPS.COMPLETE.SUBHEADING' |
    'INTRO.APPS.COMPLETE.TIP' |
    'INTRO.APPS.PAGE.ONE.DONE_LABEL' |
    'INTRO.APPS.PAGE.ONE.STEP.ONE' |
    'INTRO.APPS.PAGE.TWO.DONE_LABEL' |
    'INTRO.APPS.PAGE.TWO.STEP.ONE' |
    'INTRO.APPS.PAGE.TWO.STEP.TWO' |
    'INTRO.APPS.TITLE' |
    'INTRO.BUILD.COMPLETE.HEADING' |
    'INTRO.BUILD.COMPLETE.SUBHEADING' |
    'INTRO.BUILD.COMPLETE.TIP' |
    'INTRO.BUILD.PAGE.FIVE.DONE_LABEL' |
    'INTRO.BUILD.PAGE.FIVE.STEP.ONE' |
    'INTRO.BUILD.PAGE.FIVE.STEP.THREE' |
    'INTRO.BUILD.PAGE.FIVE.STEP.TWO' |
    'INTRO.BUILD.PAGE.FOUR.DONE_LABEL' |
    'INTRO.BUILD.PAGE.FOUR.STEP.ONE' |
    'INTRO.BUILD.PAGE.FOUR.STEP.THREE' |
    'INTRO.BUILD.PAGE.FOUR.STEP.TWO' |
    'INTRO.BUILD.PAGE.ONE.DONE_LABEL' |
    'INTRO.BUILD.PAGE.ONE.STEP.ONE' |
    'INTRO.BUILD.PAGE.ONE.STEP.TWO' |
    'INTRO.BUILD.PAGE.THREE.DONE_LABEL' |
    'INTRO.BUILD.PAGE.THREE.STEP.ONE' |
    'INTRO.BUILD.PAGE.TWO.DONE_LABEL' |
    'INTRO.BUILD.PAGE.TWO.STEP.ONE' |
    'INTRO.BUILD.PAGE.TWO.STEP.TWO' |
    'INTRO.BUILD.TITLE' |
    'INTRO.CANCEL_TOUR_MESSAGE' |
    'INTRO.CANCEL_TOUR_TITLE' |
    'INTRO.COMPLETED_ALL_THE_ITEMS' |
    'INTRO.COMPLETE_THESE_ITEMS_LATER' |
    'INTRO.COMPLETE_THE_TOUR' |
    'INTRO.CONGRATULATIONS' |
    'INTRO.DONE_LABEL' |
    'INTRO.EXAMPLE_PLANNER_TITLE' |
    'INTRO.EXAMPLE_TEMPLATE_TITLE' |
    'INTRO.FIND_OUT_WHAT' |
    'INTRO.HELP_US_MAKE' |
    'INTRO.IM_READY' |
    'INTRO.IT_LOOKS_LIKE_YOURE_NEW' |
    'INTRO.LEARN.COMPLETE.HEADING' |
    'INTRO.LEARN.COMPLETE.SUBHEADING' |
    'INTRO.LEARN.COMPLETE.TIP' |
    'INTRO.LEARN.PAGE.ONE.DONE_LABEL' |
    'INTRO.LEARN.PAGE.ONE.STEP.ONE' |
    'INTRO.LEARN.PAGE.TWO.DONE_LABEL' |
    'INTRO.LEARN.PAGE.TWO.STEP.ONE' |
    'INTRO.LEARN.PAGE.TWO.STEP.TWO' |
    'INTRO.LEARN.TITLE' |
    'INTRO.LETS_CONTINUE' |
    'INTRO.LET_ME_DO_IT_SOME_MORE' |
    'INTRO.MOST_PEOPLE_ARE_SURPRISED' |
    'INTRO.NOTIFY_POSTPONE_TOUR' |
    'INTRO.NOTIFY_STOP_TOUR' |
    'INTRO.OK_THAT_MAKES_SENSE' |
    'INTRO.PLAN.COMPLETE.HEADING' |
    'INTRO.PLAN.COMPLETE.SUBHEADING' |
    'INTRO.PLAN.COMPLETE.TIP' |
    'INTRO.PLAN.PAGE.ONE.DONE_LABEL' |
    'INTRO.PLAN.PAGE.ONE.STEP.ONE' |
    'INTRO.PLAN.PAGE.THREE.DONE_LABEL' |
    'INTRO.PLAN.PAGE.THREE.STEP.FIVE' |
    'INTRO.PLAN.PAGE.THREE.STEP.FOUR' |
    'INTRO.PLAN.PAGE.THREE.STEP.ONE' |
    'INTRO.PLAN.PAGE.THREE.STEP.SEVEN' |
    'INTRO.PLAN.PAGE.THREE.STEP.SIX' |
    'INTRO.PLAN.PAGE.THREE.STEP.THREE' |
    'INTRO.PLAN.PAGE.THREE.STEP.TWO' |
    'INTRO.PLAN.PAGE.TWO.DONE_LABEL' |
    'INTRO.PLAN.PAGE.TWO.STEP.EIGHT' |
    'INTRO.PLAN.PAGE.TWO.STEP.FIVE' |
    'INTRO.PLAN.PAGE.TWO.STEP.FOUR' |
    'INTRO.PLAN.PAGE.TWO.STEP.ONE' |
    'INTRO.PLAN.PAGE.TWO.STEP.SEVEN' |
    'INTRO.PLAN.PAGE.TWO.STEP.SIX' |
    'INTRO.PLAN.PAGE.TWO.STEP.THREE' |
    'INTRO.PLAN.PAGE.TWO.STEP.TWO' |
    'INTRO.PLAN.TITLE' |
    'INTRO.PLEASE_ACCEPT_THIS' |
    'INTRO.QUICK_TIP' |
    'INTRO.REPORT.COMPLETE.HEADING' |
    'INTRO.REPORT.COMPLETE.SUBHEADING' |
    'INTRO.REPORT.COMPLETE.TIP' |
    'INTRO.REPORT.PAGE.ONE.DONE_LABEL' |
    'INTRO.REPORT.PAGE.ONE.STEP.ONE' |
    'INTRO.REPORT.PAGE.TWO.DONE_LABEL' |
    'INTRO.REPORT.PAGE.TWO.STEP.FOUR' |
    'INTRO.REPORT.PAGE.TWO.STEP.ONE' |
    'INTRO.REPORT.PAGE.TWO.STEP.THREE' |
    'INTRO.REPORT.PAGE.TWO.STEP.TWO' |
    'INTRO.REPORT.TITLE' |
    'INTRO.RESET_ALL' |
    'INTRO.SHOW_ME' |
    'INTRO.SHOW_ME_COMPLETED' |
    'INTRO.SKIP_LABEL' |
    'INTRO.TICK_OFF_THE_ITEMS_BELOW' |
    'INTRO.VIDEO.TITLE' |
    'INTRO.WELCOME_TO_DIGITAL_STACK' |
    'INTRO.YOURE_READY_FOR_THE_STACK' |
    'INTRO.YOUVE_GOT_THROUGH_THEM_ALL' |
    'LEARN.ADD_NEW_ITEM' |
    'LEARN.ADD_NEW_LEARN_ITEM' |
    'LEARN.APPLICATION_WIDE' |
    'LEARN.DELETE_CONFIRM' |
    'LEARN.EDIT_ITEM' |
    'LEARN.EDIT_LEARN_ITEM' |
    'LEARN.EMAIL.COMMENT_ADDED_TO_LEARN_ARTICLE' |
    'LEARN.EMAIL.VIEW_LEARN_ARTICLE' |
    'LEARN.HELPFUL' |
    'LEARN.LOADING' |
    'LEARN.MAX_UPLOAD_ERROR' |
    'LEARN.NOTIFY_LEARN_CREATED' |
    'LEARN.NOTIFY_LEARN_UPDATED' |
    'LEARN.NO_ARTICLES' |
    'LEARN.NO_LEARN_AVAILABLE' |
    'LEARN.RECENT_ARTICLES' |
    'LEARN.RETRIEVE_ALL_LEARN_ARTICLES' |
    'LEARN.RETRIEVE_MORE_LEARN_ARTICLES' |
    'LEARN.TAG_NAME' |
    'LEARN.THANKS_FEEDBACK' |
    'LEARN.THUMBNAIL.CREATE_VIDEO_THUMBNAIL' |
    'LEARN.THUMBNAIL.GENERATE_FROM_VIDEO' |
    'LEARN.THUMBNAIL.SLIDER_HELP' |
    'LEARN.THUMBNAIL.UPLOAD_CUSTOM' |
    'LEARN.THUMBNAIL.UPLOAD_NEW_THUMBNAIL' |
    'LEARN.TRY_THIS_DELETED' |
    'LOGIN.EMAIL.INVITE.CLICK_BUTTON_TO_LOG_IN' |
    'LOGIN.EMAIL.INVITE.LOG_INTO_DIGITAL_STACK' |
    'LOGIN.EMAIL.INVITE.YOU_HAVE_BEEN_INVITED' |
    'LOGIN.EMAIL.RESET_PASSWORD.IF_YOU_DID_NOT_REQUEST_THIS' |
    'LOGIN.EMAIL.RESET_PASSWORD.PASSWORD_RESET_INSTRUCTIONS' |
    'LOGIN.EMAIL.RESET_PASSWORD.RESET_MY_PASSWORD' |
    'LOGIN.EMAIL.RESET_PASSWORD.SOMEONE_REQUESTED_TO_RESET_PASSWORD' |
    'LOGIN.EMAIL.RESET_PASSWORD.TO_RESET_CLICK_LINK' |
    'LOGIN.EMAIL.WELCOME_TO_DIGITAL_STACK' |
    'LOGIN.ERROR_SENDING_PASSWORD_RESET_INSTRUCTIONS' |
    'LOGIN.FORGOTTEN_PASSWORD' |
    'LOGIN.FORGOT_PASSWORD' |
    'LOGIN.INVALID_EMAIL_ADDRESS' |
    'LOGIN.LOGIN' |
    'LOGIN.LOGIN_CONFIRM_IDENTITY' |
    'LOGIN.LOGIN_TO_LINK_ACCOUNTS' |
    'LOGIN.PASSWORD' |
    'LOGIN.PASSWORDS_DONT_MATCH' |
    'LOGIN.PASSWORD_AGAIN' |
    'LOGIN.PASSWORD_RESET_FAILED' |
    'LOGIN.PASSWORD_RESET_INSTRUCTIONS' |
    'LOGIN.PASSWORD_RESET_INSTRUCTIONS_SENT' |
    'LOGIN.PASSWORD_RESET_PLEASE_LOGIN' |
    'LOGIN.PASSWORD_TOO_SHORT' |
    'LOGIN.PASSWORD_TOO_SHORT_plural' |
    'LOGIN.PROBLEM_WITH_INVITE_LINK' |
    'LOGIN.PROBLEM_WITH_LINK' |
    'LOGIN.REQUEST_PASSWORD_RESET' |
    'LOGIN.RESET_PASSWORD' |
    'LOGIN.SEND_PASSWORD_RESET' |
    'LOGIN.SEND_PASSWORD_RESET_EMAIL_CONFIRMATION_MODAL.BODY' |
    'LOGIN.SIGNED_IN_AS' |
    'LOGIN.SIGNED_OUT' |
    'LOGIN.USERNAME' |
    'LOGIN.USERNAME_PASSWORD_INCORRECT_ERROR' |
    'LOGIN.WELCOME_TO_DIGITAL_STACK' |
    'LOGIN.YOU_WILL_RECEIVE_PASSWORD_RESET_INSTRUCTIONS_SHORTLY' |
    'MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.COMPLETE_MY_MONTH_PLANNER' |
    'MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.COUNT_ACTIVITIES_AWAITING_CONTENT' |
    'MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.COUNT_ACTIVITIES_AWAITING_CONTENT_plural' |
    'MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.COUNT_ACTIVITIES_PLANNED' |
    'MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.COUNT_ACTIVITIES_PLANNED_plural' |
    'MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.FIND_YOUR_UPDATE_BELOW' |
    'MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.FIND_YOUR_UPDATE_BELOW_MULTIPLE_LOCATIONS' |
    'MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.GET_ON_TOP_OF_YOUR_PLANNING_FOR_MONTH' |
    'MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.LOCATION_FOR_MONTH' |
    'MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.NO_ACTIVITIES_PLANNED' |
    'MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.VIEW_MY_MONTH_PLANNER' |
    'MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.WEEKLY_MARKETING_UPDATE' |
    'MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.WHATS_ON_THIS_WEEK_AT_LOCATION' |
    'MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.YOUR_WEEKLY_UPDATE' |
    'MENU.ACCOUNT' |
    'MENU.ADMIN' |
    'MENU.AGENCIES' |
    'MENU.AGENCY' |
    'MENU.ASSETS' |
    'MENU.BRAND' |
    'MENU.BRANDS' |
    'MENU.BRAND_SETTINGS' |
    'MENU.BUILD' |
    'MENU.CALENDAR' |
    'MENU.CALENDAR_ACTIVITIES' |
    'MENU.CLIENTS' |
    'MENU.CLOSE_NAVIGATION' |
    'MENU.COLORS' |
    'MENU.COMMUNICATE' |
    'MENU.CONNECT' |
    'MENU.CONNECTIONS' |
    'MENU.FONTS' |
    'MENU.HASHTAG_SETS' |
    'MENU.HELP' |
    'MENU.INTEGRATIONS' |
    'MENU.LEARN' |
    'MENU.LEARN_MENU' |
    'MENU.LOCATION' |
    'MENU.LOCATIONS' |
    'MENU.LOCATION_ACTIVITY' |
    'MENU.LOCATION_DETAILS' |
    'MENU.LOCATION_USERS' |
    'MENU.MAIN_NAVIGATION' |
    'MENU.MARK_ALL_AS_READ' |
    'MENU.MORE' |
    'MENU.NOTIFICATIONS' |
    'MENU.NOTIFICATION_COULD_NOT_BE_MARKED_AS_READ' |
    'MENU.OPEN_NAVIGATION' |
    'MENU.OVERVIEW' |
    'MENU.PAYMENTS' |
    'MENU.PERFORMANCE' |
    'MENU.PLAN' |
    'MENU.PLATFORMS' |
    'MENU.PROFILE' |
    'MENU.REGIONS_GROUPS' |
    'MENU.REGION_GROUP_ACTIVITY' |
    'MENU.REPORT' |
    'MENU.REPORTING' |
    'MENU.REQUESTS' |
    'MENU.ROADMAP' |
    'MENU.SCHEDULED' |
    'MENU.SEND' |
    'MENU.SIGN_OUT' |
    'MENU.SPECIAL_REQUESTS' |
    'MENU.STYLES' |
    'MENU.STYLE_GUIDE' |
    'MENU.TEMPLATES' |
    'MENU.TEMPLATE_CATEGORIES' |
    'MENU.TEMPLATE_USE' |
    'MENU.VIEW_ALL_NOTIFICATIONS' |
    'MENU.YOU_HAVE_NO_UNREAD_NOTIFICATIONS' |
    'NOTIFICATIONS.BADGER.MARK_ALL_AS_READ' |
    'NOTIFICATIONS.BADGER.NO_UNREAD_NOTIFICATIONS' |
    'NOTIFICATIONS.BADGER.VIEW_ALL' |
    'NOTIFICATIONS.CALL_TO_ACTION_BUTTON_LABELS.OPEN_LINK' |
    'NOTIFICATIONS.LIST.NO_NOTIFICATIONS' |
    'NOTIFICATIONS.MESSAGES.CUSTOM_AGENCY_MESSAGE' |
    'NOTIFICATIONS.MESSAGES.EMAIL_SCHEDULED' |
    'NOTIFICATIONS.MESSAGES.EMAIL_SCHEDULE_FAILED' |
    'NOTIFICATIONS.MESSAGES.IMAGE_PUBLISH_FAILED' |
    'NOTIFICATIONS.MESSAGES.IMAGE_PUBLISH_FAILED_NO_ERROR' |
    'NOTIFICATIONS.MESSAGES.INTEGRATION_CONFIGURATION_MISCONFIGURED' |
    'NOTIFICATIONS.MESSAGES.INTEGRATION_CONNECTIVITY_FAILURE' |
    'NOTIFICATIONS.MESSAGES.LOCATION_MAP_GENERATED' |
    'NOTIFICATIONS.MESSAGES.LOCATION_MAP_GENERATION_FAILED' |
    'NOTIFICATIONS.MESSAGES.MEDIA_TEMPLATE_READY_FOR_DOWNLOAD' |
    'NOTIFICATIONS.MESSAGES.MEDIA_TEMPLATE_TIME_TO_SCHEDULE' |
    'NOTIFICATIONS.MESSAGES.SCHEDULED_POSTS.NO_NOTIFIABLE_DEVICES' |
    'NOTIFICATIONS.MESSAGES.TEST' |
    'NOTIFICATIONS.MESSAGES.VIDEO_PUBLISHED_EXTERNALLY' |
    'NOTIFICATIONS.MESSAGES.VIDEO_PUBLISHED_EXTERNALLY_V2' |
    'NOTIFICATIONS.MESSAGES.VIDEO_PUBLISHED_LOCALLY' |
    'NOTIFICATIONS.MESSAGES.VIDEO_PUBLISH_FAILED' |
    'NOTIFICATIONS.MESSAGES.VIDEO_SCHEDULED_EXTERNALLY' |
    'NOTIFICATIONS.MESSAGES.VIDEO_SCHEDULED_EXTERNALLY_V2' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMMON.EMAIL_NOTIFICATION' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMMON.NOTIFICATION_TYPE' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMMON.PUSH_NOTIFICATION' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.CTA_BUTTON.LABEL' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.CTA_BUTTON.LINK' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.ALIGN_CENTER' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.ALIGN_LEFT' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.ALIGN_RIGHT' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.BOLD' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.BULLETED_LIST' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.HEADING_NUM' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.IMAGE' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.ITALICS' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.NUMBERED_LIST' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EMAIL_CONTENT' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.BANNER_IMAGE_REQUIRED' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.CTA_LABEL_REQUIRED' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.CTA_LINK_REQUIRED' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.FROM_EMAIL_ADDRESS_REQUIRED' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.FROM_NAME_REQUIRED' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.SHOULD_SAVE_BANNER_SECTION_NAME_REQUIRED' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.SHOULD_SAVE_FOOTER_SECTION_NAME_REQUIRED' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.SUBJECT_REQUIRED' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.BANNER_IMAGE_SWITCH' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.BANNER_IMAGE_SWITCH_IMAGE' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.BANNER_IMAGE_SWITCH_LOGO' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.BANNER_IMAGE_SWITCH_NONE' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.BANNER_IMAGE_SWITCH_SAVED' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FOOTER_CONTENT' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FOOTER_SWITCH' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FOOTER_SWITCH_EXISTING' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FOOTER_SWITCH_NEW' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FOOTER_SWITCH_NONE' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FROM_ADDRESS' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FROM_ADDRESS_SWITCH_CUSTOM' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FROM_ADDRESS_SWITCH_DEFAULT' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FROM_EMAIL_ADDRESS' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FROM_NAME' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.LOGO' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.SAVED_EMAIL_PART_BANNER_SELECT' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.SAVED_EMAIL_PART_FOOTER_SELECT' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.SHOULD_SAVE_BANNER_SECTION' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.SHOULD_SAVE_BANNER_SECTION_NAME' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.SHOULD_SAVE_FOOTER_SECTION' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.SHOULD_SAVE_FOOTER_SECTION_NAME' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.PLACEHOLDERS.SHOULD_SAVE_BANNER_SECTION_NAME' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.PLACEHOLDERS.SHOULD_SAVE_FOOTER_SECTION_NAME' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.SECTION_SAVE_AGENCY_NOTE' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.SECTION_SAVE_BRAND_NOTE' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.PUSH.INPUT_LABELS.LINK' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.PUSH.INPUT_LABELS.MESSAGE' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.PUSH.INPUT_LABELS.OPTIONAL' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.PUSH.INPUT_LABELS.SUBJECT' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.PUSH.PREVIEW.NOTIFICATION' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.PUSH.PREVIEW.OPEN_LINK' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.CONFIRM_COPY' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.DESCRIPTION.LINE_ONE' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.DESCRIPTION.LINE_TWO' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.FORM_LABELS.CLIENT_COUNT_TEXT_LOCATION' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.FORM_LABELS.CLIENT_COUNT_TEXT_LOCATIONS' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.FORM_LABELS.IMMEDIATELY' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.FORM_LABELS.NOTIFICATION_TYPE' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.FORM_LABELS.TOTAL_RECIPIENTS' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.FORM_LABELS.USER_FILTER' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.SEND_NOTIFICATION' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.SEND_TEST_EMAIL' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_ERROR.EMAIL_MESSAGE' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_ERROR.EMAIL_PREVIEW_MESSAGE' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_SUCCESS.EMAIL_DESCRIPTION' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_SUCCESS.EMAIL_MESSAGE' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_SUCCESS.EMAIL_PREVIEW_MESSAGE' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_SUCCESS.PUSH_DESCRIPTION' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_SUCCESS.PUSH_MESSAGE' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_SUCCESS.SEND_ANOTHER' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_TYPE_SELECTOR.BUTTONS.EMAIL' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_TYPE_SELECTOR.BUTTONS.PUSH' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.CURRENTLY_SELECTED' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.DESCRIPTION' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.ERRORS.TITLE_FILTER_INVALID_ENTRIES' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.HEADERS.FILTER_BY_TITLE' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.LABELS.FILTER_BY_TITLES' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.LABELS.FILTER_SWITCH_ALL_USERS' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.LABELS.FILTER_SWITCH_FILTER_BY_TITLE' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.LABELS.TOTAL_RECIPIENTS' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.COMPOSE.HEADING_TEXT' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.COMPOSE.STEPPER_TEXT' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.NOTIFICATION_TYPE.HEADING_TEXT' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.NOTIFICATION_TYPE.STEPPER_TEXT' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.REVIEW.HEADING_TEXT' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.REVIEW.STEPPER_TEXT' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.SELECT_LOCATIONS.HEADING_TEXT' |
    'NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.SELECT_LOCATIONS.STEPPER_TEXT' |
    'NOTIFICATIONS.SUBJECTS.CUSTOM_AGENCY_MESSAGE' |
    'OVERVIEW.ALL_EVENTS' |
    'OVERVIEW.BULK_ACTIONS' |
    'OVERVIEW.CONFIRM_PLANNER_EVENTS' |
    'OVERVIEW.DELETED_PLANNER_EVENTS' |
    'OVERVIEW.DELETED_SOME_PLANNER_EVENTS' |
    'OVERVIEW.DELETE_ALL_PLANNER_EVENTS' |
    'OVERVIEW.DELETE_RECURRING_EVENT' |
    'OVERVIEW.DELETING_PLANNER_EVENTS' |
    'OVERVIEW.DELETING_THESE_PLANNER_EVENTS' |
    'OVERVIEW.DELETING_TITLE' |
    'OVERVIEW.DONE' |
    'OVERVIEW.DUE_BY' |
    'OVERVIEW.FAILED_DELETE_PLANNER_EVENTS' |
    'OVERVIEW.FILTER.CHANNELS' |
    'OVERVIEW.FILTER.CLIENT' |
    'OVERVIEW.FILTER.ITEM' |
    'OVERVIEW.FILTER.LOCATION' |
    'OVERVIEW.FILTER.STATUS' |
    'OVERVIEW.FILTERED_AMOUNT' |
    'OVERVIEW.FUTURE_EVENTS' |
    'OVERVIEW.LOADED_LOCATIONS' |
    'OVERVIEW.LOCATION_EVENTS_FAILED_PUBLISH' |
    'OVERVIEW.LOCATION_EVENTS_FAILED_SAVE' |
    'OVERVIEW.MAX_SPEND' |
    'OVERVIEW.NO_CONTENT' |
    'OVERVIEW.SAVING_FOR_TITLE' |
    'OVERVIEW.SAVING_PLANNER_EVENT' |
    'OVERVIEW.SELECTED_PLANNER_EVENTS' |
    'OVERVIEW.SOME_PLANNER_SERIES' |
    'OVERVIEW.THIS_EVENT' |
    'PAYMENTS.ASK_AGENCY_TO_SEND_ANOTHER' |
    'PAYMENTS.AUTHORITY_CONFIRMATION' |
    'PAYMENTS.BUSINESS_NAME' |
    'PAYMENTS.COULD_NOT_FIND_INVITATION' |
    'PAYMENTS.CUSTOMER_DETAILS' |
    'PAYMENTS.EMAILS.AMOUNT_DUE' |
    'PAYMENTS.EMAILS.ATTEMPTED_PAYMENT_DATE' |
    'PAYMENTS.EMAILS.DUE_DATE' |
    'PAYMENTS.EMAILS.FAILED_SUBJECT_LINE' |
    'PAYMENTS.EMAILS.FAILED_TO_TAKE_PAYMENT' |
    'PAYMENTS.EMAILS.IF_YOU_NEED_TO_UPDATE_CREDIT_CARD' |
    'PAYMENTS.EMAILS.INVOICE_DESCRIPTION' |
    'PAYMENTS.EMAILS.INVOICE_NUMBER' |
    'PAYMENTS.EMAILS.PAYMENT_FAILED_FOR_LOCATION' |
    'PAYMENTS.EMAILS.REPORT.FAILED_SUBJECT_LINE' |
    'PAYMENTS.EMAILS.REPORT.FAILED_SUBJECT_LINE_plural' |
    'PAYMENTS.EMAILS.REPORT.FAILED_TO_TAKE_PAYMENTS' |
    'PAYMENTS.EMAILS.REPORT.PAYMENT_FAILED_FOR_LOCATIONS' |
    'PAYMENTS.EMAILS.REPORT.PAYMENT_FAILED_FOR_LOCATIONS_plural' |
    'PAYMENTS.EMAILS.REPORT.PAYMENT_FAILURE_REASON' |
    'PAYMENTS.EMAILS.REPORT.TECHNICAL_ISSUES' |
    'PAYMENTS.EMAILS.REPORT.TECHNICAL_ISSUES_NOTE' |
    'PAYMENTS.EMAILS.RETRY.WE_WILL_ATTEMPT_TO_CHARGE_AGAIN' |
    'PAYMENTS.EMAILS.ROLLOVER.WE_WILL_ADD_OUTSTANDING_AMOUNT_TO_NEXT_PAYMENT' |
    'PAYMENTS.EMAILS.SUBSCRIPTION_AMOUNT' |
    'PAYMENTS.EMAILS.YOU_MAY_NEED_TO_CONTACT_YOUR_FINANCIAL_INSTITUTION' |
    'PAYMENTS.EMAIL_ADDRESS' |
    'PAYMENTS.FINALISING_PAYMENT' |
    'PAYMENTS.GO_BACK' |
    'PAYMENTS.INVOICE_DESCRIPTION' |
    'PAYMENTS.INVOICE_NUMBER' |
    'PAYMENTS.MASTERCARD' |
    'PAYMENTS.NO_PAYMENT' |
    'PAYMENTS.NO_PAYMENT_INFORMATION' |
    'PAYMENTS.PAYMENT_AMOUNT' |
    'PAYMENTS.PAYMENT_CURRENCY' |
    'PAYMENTS.PAYMENT_FAILED' |
    'PAYMENTS.PAYMENT_SUCCESSFUL' |
    'PAYMENTS.PAY_NOW' |
    'PAYMENTS.PHONE_NUMBER' |
    'PAYMENTS.PLEASE_CONFIRM' |
    'PAYMENTS.RECEIPT_NUMBER' |
    'PAYMENTS.REDIRECTING' |
    'PAYMENTS.REDIRECT_CONTINUE' |
    'PAYMENTS.REDIRECT_NOTE' |
    'PAYMENTS.SIGN_UP.AGENCY_WELCOMES_YOU' |
    'PAYMENTS.SIGN_UP.AMOUNT_PER_MONTH' |
    'PAYMENTS.SIGN_UP.FINALISING_SIGN_UP' |
    'PAYMENTS.SIGN_UP.FIRST_BILLING_DATE' |
    'PAYMENTS.SIGN_UP.FIRST_BILLING_DATE_IS' |
    'PAYMENTS.SIGN_UP.I_AGREE_TO_THE' |
    'PAYMENTS.SIGN_UP.SIGN_UP' |
    'PAYMENTS.SIGN_UP.SIGN_UP_FAILED' |
    'PAYMENTS.SIGN_UP.SIGN_UP_SUCCESSFUL' |
    'PAYMENTS.SIGN_UP.YOU_WILL_BE_PROMPTED_FOR_CREDIT_CARD' |
    'PAYMENTS.STARTING' |
    'PAYMENTS.STRIPE.AUTH_REQUEST.AUTHORISE_YOUR_ACCOUNT' |
    'PAYMENTS.STRIPE.AUTH_REQUEST.BY_AUTHORISING' |
    'PAYMENTS.STRIPE.AUTH_REQUEST.CLICK_BUTTON_BELOW' |
    'PAYMENTS.STRIPE.AUTH_REQUEST.EXPIRED' |
    'PAYMENTS.STRIPE.AUTH_REQUEST.REQUEST_INVALID' |
    'PAYMENTS.STRIPE.AUTH_RESPONSE.ACCESS_DENIED' |
    'PAYMENTS.STRIPE.AUTH_RESPONSE.ERROR' |
    'PAYMENTS.STRIPE.AUTH_RESPONSE.FAILED' |
    'PAYMENTS.STRIPE.AUTH_RESPONSE.LOOKS_LIKE_SOMETHING_WENT_WRONG' |
    'PAYMENTS.STRIPE.AUTH_RESPONSE.LOOKS_LIKE_YOU_DENIED_ACCESS' |
    'PAYMENTS.STRIPE.AUTH_RESPONSE.SUCCESS' |
    'PAYMENTS.STRIPE.AUTH_RESPONSE.UNKNOWN_ERROR' |
    'PAYMENTS.STRIPE.AUTH_RESPONSE.YOUR_STRIPE_ACCOUNT_IS_CONNECTED' |
    'PAYMENTS.STRIPE.CREATE_STRIPE_CHARGE' |
    'PAYMENTS.STRIPE.EMAILS.AUTH_REQUEST.AUTH_MY_ACCOUNT' |
    'PAYMENTS.STRIPE.EMAILS.AUTH_REQUEST.SUBJECT_LINE' |
    'PAYMENTS.STRIPE.EMAILS.AUTH_REQUEST.TO_AUTH_CLICK_LINK' |
    'PAYMENTS.STRIPE.EMAILS.AUTH_REQUEST.USER_REQUESTED_YOU_TO_AUTH' |
    'PAYMENTS.STRIPE.FETCH_STRIPE_AUTH_REQUEST' |
    'PAYMENTS.STRIPE.FETCH_STRIPE_AUTH_URL' |
    'PAYMENTS.STRIPE.FETCH_STRIPE_PUBLISHABLE_KEY' |
    'PAYMENTS.STRIPE.SUBMIT_AUTH_CODE_TO_STRIPE' |
    'PAYMENTS.THANK_YOU' |
    'PAYMENTS.UPDATE_BILLING_DETAILS.BILLING_DETAILS_UPDATED' |
    'PAYMENTS.UPDATE_BILLING_DETAILS.FINALISING_CHANGES' |
    'PAYMENTS.UPDATE_BILLING_DETAILS.LOADING_BILLING_DETAILS' |
    'PAYMENTS.UPDATE_BILLING_DETAILS.UPDATE_BILLING_DETAILS' |
    'PAYMENTS.UPDATE_BILLING_DETAILS.UPDATE_BILLING_DETAILS_IN_DIGITAL_STACK' |
    'PAYMENTS.UPDATE_BILLING_DETAILS.UPDATE_FAILED' |
    'PAYMENTS.UPDATE_BILLING_DETAILS.UPDATE_SUCCESSFUL' |
    'PAYMENTS.VISA' |
    'PAYMENTS.WE_ONLY_ACCEPT' |
    'PAYMENTS.YOUR_BUSINESS' |
    'PLAN.ACTIVITIES.ACTIONS.ADD_ACTIVITY' |
    'PLAN.ACTIVITIES.CHANNELS.CHANNEL_FOR_ACTIVITY' |
    'PLAN.ACTIVITIES.CHANNELS.CHANNEL_TYPE.GENERAL' |
    'PLAN.ACTIVITIES.CHANNELS.CHANNEL_TYPE.SELF_SERVICE' |
    'PLAN.ACTIVITIES.CHANNELS.CHANNEL_TYPE.SUPPORTED' |
    'PLAN.AGENCY_TO_BUILD' |
    'PLAN.AGENCY_TO_BUILD_SPECIFIC' |
    'PLAN.AGENCY_TO_BUILD_TOOLTIP' |
    'PLAN.ASSOCIATED_BUILDER_RESOURCES.ADD_TEMPLATE' |
    'PLAN.ASSOCIATED_BUILDER_RESOURCES.ASSOCIATE_TEMPLATE_OR_CATEGORY' |
    'PLAN.ASSOCIATED_BUILDER_RESOURCES.INVALID_SINGLE_TEMPLATE_EXPLANATION' |
    'PLAN.ASSOCIATED_BUILDER_RESOURCES.PASTE_A_TEMPLATE_URL' |
    'PLAN.ASSOCIATED_BUILDER_RESOURCES.SELECT_A_COLLECTION' |
    'PLAN.ASSOCIATED_BUILDER_RESOURCES.SELECT_A_TEMPLATE_CATEGORY' |
    'PLAN.ASSOCIATED_BUILDER_RESOURCES.SINGLE_TEMPLATE' |
    'PLAN.ASSOCIATED_BUILDER_RESOURCES.TEMPLATE_URL' |
    'PLAN.BUILD_AND_SCHEDULE' |
    'PLAN.BUILD_AND_SCHEDULE_TOOLTIP' |
    'PLAN.CAMPAIGNS.ACTIONS.ARCHIVE_MESSAGE' |
    'PLAN.CAMPAIGNS.ACTIONS.ARCHIVE_THIS_CAMPAIGN' |
    'PLAN.CAMPAIGNS.ACTIONS.DEPLOY_THIS_CAMPAIGN' |
    'PLAN.CAMPAIGNS.ACTIONS.RENAME_CAMPAIGN' |
    'PLAN.CAMPAIGNS.ACTIONS.UNARCHIVE_MESSAGE' |
    'PLAN.CAMPAIGNS.ACTIONS.UNARCHIVE_THIS_CAMPAIGN' |
    'PLAN.CAMPAIGNS.ADD_ITEM' |
    'PLAN.CAMPAIGNS.ADD_NEW_CAMPAIGN' |
    'PLAN.CAMPAIGNS.CAMPAIGNS' |
    'PLAN.CAMPAIGNS.CAMPAIGNS_LIST.HEADERS.DURATION' |
    'PLAN.CAMPAIGNS.CAMPAIGNS_LIST.HEADERS.NAME' |
    'PLAN.CAMPAIGNS.CAMPAIGNS_LIST.HEADERS.TOTAL_ITEMS' |
    'PLAN.CAMPAIGNS.CAMPAIGNS_LIST.NO_CAMPAIGNS_FOUND' |
    'PLAN.CAMPAIGNS.CAMPAIGNS_LIST.NUM_DAYS' |
    'PLAN.CAMPAIGNS.CAMPAIGN_NAME_FILTER_LABEL' |
    'PLAN.CAMPAIGNS.CAMPAIGN_NOT_FOUND' |
    'PLAN.CAMPAIGNS.CAMPAIGN_RENAMED_TO' |
    'PLAN.CAMPAIGNS.CREATED_NEW_CAMPAIGN' |
    'PLAN.CAMPAIGNS.DEPLOYS.ADJUST_EVENT_DATES_TITLE' |
    'PLAN.CAMPAIGNS.DEPLOYS.CAMPAIGN_DEPLOYED' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOY' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.CAMPAIGN_NOT_FOUND' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.FILTERS.LOCATION_PLACEHOLDER' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.FILTERS.STATUS_LABEL' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.FILTERS.STATUS_PLACEHOLDER' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.HEADERS.CREATE_DATE' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.HEADERS.LOCATION' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.HEADERS.START_DATE' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.HEADERS.STATUS' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.NO_DEPLOYMENTS' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.ACTIVE' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.ACTIVE_HELP' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.COMPLETED' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.COMPLETED_HELP' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.FAILED' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.FAILED_HELP' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.ROLLINGOUT' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.ROLLINGOUT_HELP' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.SCHEDULED' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.SCHEDULED_HELP' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_CAMPAIGN' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_CAMPAIGN_TO_LOCATION' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.ADJUST_DATES.EXPLAIN_STEP' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.ADJUST_DATES.EXPLAIN_STEP_ADJUST_DETAIL' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.ADJUST_DATES.EXPLAIN_STEP_REMOVE_DETAIL' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.CONFIRM_COPY' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.DEPLOYMENT_EXPLANATION_COPY' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.END_DATE' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.EVENTS' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.EVENTS_PER_LOCATION' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.HEADER' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.LOCATIONS' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.LOCATIONS_WITH_CLIENT' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.LOCATIONS_WITH_CLIENT_SINGULAR' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.PLEASE_CONFIRM' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.START_DATE' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.START_DEPLOYMENT' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.PICK_LOCATIONS.EXPLAIN_STEP' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.PICK_LOCATIONS.EXPLAIN_STEP_DETAIL' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.STARTING_DATE.EXPLAIN_STEP' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.STARTING_DATE.EXPLAIN_STEP_DETAIL' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.STEPS.ADJUST_DATES' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.STEPS.PICK_LOCATIONS' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.STEPS.REVIEW' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.STEPS.SET_STARTING_DATE' |
    'PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_TO' |
    'PLAN.CAMPAIGNS.DEPLOYS.ERRORS.DEPLOYMENT_FAILED' |
    'PLAN.CAMPAIGNS.DEPLOYS.ERRORS.MUST_INCLUDE_ONE_EVENT' |
    'PLAN.CAMPAIGNS.DEPLOYS.ERRORS.MUST_INCLUDE_ONE_LOCATION' |
    'PLAN.CAMPAIGNS.DEPLOYS.PICK_LOCATIONS' |
    'PLAN.CAMPAIGNS.DEPLOYS.SELECT_STARTING_DATE' |
    'PLAN.CAMPAIGNS.DEPLOYS.STARTING_DATE' |
    'PLAN.CAMPAIGNS.DEPLOYS.SUCCESSFUL_DEPLOY_COPY' |
    'PLAN.CAMPAIGNS.ERRORS.UPLOAD_FAILED' |
    'PLAN.CAMPAIGNS.EVENTS_LIST.HEADERS.ACTIONS' |
    'PLAN.CAMPAIGNS.EVENTS_LIST.HEADERS.CHANNEL' |
    'PLAN.CAMPAIGNS.EVENTS_LIST.HEADERS.DAY' |
    'PLAN.CAMPAIGNS.EVENTS_LIST.HEADERS.INSTRUCTIONS_DESCRIPTION' |
    'PLAN.CAMPAIGNS.EVENTS_LIST.HEADERS.TITLE' |
    'PLAN.CAMPAIGNS.IS_ARCHIVED' |
    'PLAN.CAMPAIGNS.OVERVIEW' |
    'PLAN.CAMPAIGNS.PLANNER_EVENTS.ARE_YOU_SURE_DELETE_PLANNER_EVENT' |
    'PLAN.CAMPAIGNS.PLANNER_EVENTS.ERRORS.ISSUE_CREATING_PLANNER_EVENT' |
    'PLAN.CAMPAIGNS.PLANNER_EVENTS.ERRORS.ISSUE_DELETING_PLANNER_EVENT' |
    'PLAN.CAMPAIGNS.PLANNER_EVENTS.ERRORS.ISSUE_UPDATING_PLANNER_EVENT' |
    'PLAN.CAMPAIGNS.PLANNER_EVENTS.NEW_PLANNER_EVENT' |
    'PLAN.CAMPAIGNS.PLANNER_EVENTS.PLANNER_EVENTS' |
    'PLAN.CAMPAIGNS.PLANNER_EVENTS.PLANNER_EVENT_CREATED' |
    'PLAN.CAMPAIGNS.PLANNER_EVENTS.PLANNER_EVENT_DELETED' |
    'PLAN.CAMPAIGNS.PLANNER_EVENTS.PLANNER_EVENT_NOT_FOUND' |
    'PLAN.CAMPAIGNS.PLANNER_EVENTS.PLANNER_EVENT_UPDATED' |
    'PLAN.CAMPAIGNS.PLANNER_EVENTS.READY_TO_ACTION' |
    'PLAN.CAMPAIGNS.RETURN_TO_CAMPAIGNS_PAGE' |
    'PLAN.CONTENT_REQUIRED' |
    'PLAN.CONTENT_REQUIRED_TOOLTIP' |
    'PLAN.DANGEROUS_DATE_HEADING' |
    'PLAN.DANGEROUS_DATE_NOTE' |
    'PLAN.EVENT.ACTIVITY' |
    'PLAN.EVENT.ADDITIONAL_LOCATIONS' |
    'PLAN.EVENT.ADD_REMOVE_LOCATIONS' |
    'PLAN.EVENT.ADD_TO_PLANNER' |
    'PLAN.EVENT.BACK_TO_CALENDAR' |
    'PLAN.EVENT.BUILD_NOW' |
    'PLAN.EVENT.CONFIRM_DELETE' |
    'PLAN.EVENT.DAILY' |
    'PLAN.EVENT.DATE_OF_MONTH_EXAMPLE' |
    'PLAN.EVENT.DATE_OF_MONTH_IN_YEAR_EXAMPLE' |
    'PLAN.EVENT.DATE_OF_WEEK_EXAMPLE' |
    'PLAN.EVENT.DATE_OF_WEEK_IN_YEAR_EXAMPLE' |
    'PLAN.EVENT.DATE_SUBMITTED' |
    'PLAN.EVENT.DATE_UPDATED' |
    'PLAN.EVENT.DELETE_PLANNER_EVENT' |
    'PLAN.EVENT.DELETE_RECURRING' |
    'PLAN.EVENT.DELETION_ALERT' |
    'PLAN.EVENT.EDIT_PLANNER' |
    'PLAN.EVENT.ENDS' |
    'PLAN.EVENT.EVENT_SERIES' |
    'PLAN.EVENT.EVENT_SERIES_CHOOSE_ALL' |
    'PLAN.EVENT.EVENT_SERIES_CHOOSE_CURRENT' |
    'PLAN.EVENT.EVENT_SERIES_CHOOSE_FUTURE' |
    'PLAN.EVENT.EVENT_SERIES_OPTIONS_DELETE' |
    'PLAN.EVENT.EVENT_SERIES_OPTIONS_UPDATE' |
    'PLAN.EVENT.FAILED_TO_CREATE_UPDATE_PLANNER' |
    'PLAN.EVENT.FAILED_TO_DELETE_PLANNER' |
    'PLAN.EVENT.FAILED_TO_RETRIEVE_PLANNER' |
    'PLAN.EVENT.FAILED_TO_RETRIEVE_PLANNER_INFO' |
    'PLAN.EVENT.FIFTH' |
    'PLAN.EVENT.FIRST' |
    'PLAN.EVENT.FORTNIGHTLY' |
    'PLAN.EVENT.FOURTH' |
    'PLAN.EVENT.FRIDAY' |
    'PLAN.EVENT.INSTRUCTIONS_TO_MANAGER' |
    'PLAN.EVENT.MONDAY' |
    'PLAN.EVENT.NO_ARTWORK' |
    'PLAN.EVENT.OCCURRENCES' |
    'PLAN.EVENT.OLD_ACTIVITIES' |
    'PLAN.EVENT.PLANNER_EVENT_DELETED' |
    'PLAN.EVENT.PLEASE_DELETE_ITEM_VIA' |
    'PLAN.EVENT.READY_TO_ACTION' |
    'PLAN.EVENT.RECURRING_EVENT_QUESTION' |
    'PLAN.EVENT.REPEAT_BY' |
    'PLAN.EVENT.REQUIRED_INFO' |
    'PLAN.EVENT.SATURDAY' |
    'PLAN.EVENT.SAVE_BUILD_LATER' |
    'PLAN.EVENT.SAVE_BUILD_NOW' |
    'PLAN.EVENT.SAVE_MORE_CONTENT_REQUIRED' |
    'PLAN.EVENT.SCHEDULED_PAGE' |
    'PLAN.EVENT.SECOND' |
    'PLAN.EVENT.SELF_SERVICE' |
    'PLAN.EVENT.STARTS_ON' |
    'PLAN.EVENT.SUBMITTED_BY' |
    'PLAN.EVENT.SUNDAY' |
    'PLAN.EVENT.SUPPORT_ACTIONS' |
    'PLAN.EVENT.SUPPORT_ACTION_ONE' |
    'PLAN.EVENT.SUPPORT_ACTION_THREE' |
    'PLAN.EVENT.SUPPORT_ACTION_TWO' |
    'PLAN.EVENT.SUPPORT_HEADING' |
    'PLAN.EVENT.SUPPORT_NOTE' |
    'PLAN.EVENT.SUPPORT_OVERPLANNED' |
    'PLAN.EVENT.SUPPORT_REQUESTED' |
    'PLAN.EVENT.TEMPLATE_CATEGORY_EXPIRED' |
    'PLAN.EVENT.THIRD' |
    'PLAN.EVENT.THURSDAY' |
    'PLAN.EVENT.TUESDAY' |
    'PLAN.EVENT.UPDATED_BY' |
    'PLAN.EVENT.UPDATE_RECURRING' |
    'PLAN.EVENT.WEDNESDAY' |
    'PLAN.EVENT.WEEKLY' |
    'PLAN.GENERAL_ITEM' |
    'PLAN.GENERAL_ITEM_TOOLTIP' |
    'PLAN.INTRO_DUMMY_ACTIVITY' |
    'PLAN.INTRO_DUMMY_CHANNEL' |
    'PLAN.MULTIPLE_LOCATIONS.SAVING_FOR_THESE_LOCATIONS' |
    'PLAN.MULTIPLE_LOCATIONS.SAVING_FOR_TITLE' |
    'PLAN.MULTIPLE_LOCATIONS.SOME_LOCATIONS_FAILED_TO_SAVE' |
    'PLAN.MULTIPLE_LOCATIONS.TOTAL_SAVING_PROGRESS' |
    'PLAN.MULTIPLE_LOCATIONS.WOULD_YOU_LIKE_TO_RETRY_FOR_FAILED_LOCATIONS' |
    'PLAN.NEXT_MONTH' |
    'PLAN.NEXT_WEEK' |
    'PLAN.NOTIFY_PLANNER_CREATED' |
    'PLAN.NOTIFY_PLANNER_CREATED_PARTIAL' |
    'PLAN.NOTIFY_PLANNER_CREATE_ERROR' |
    'PLAN.NOTIFY_PLANNER_EVENT_DELETED' |
    'PLAN.NOTIFY_PLANNER_UPDATED' |
    'PLAN.PAST_DATE_CANT_PLAN' |
    'PLAN.PAST_DATE_HEADING' |
    'PLAN.PAST_DATE_RECURRING' |
    'PLAN.PLAN' |
    'PLAN.PLANNER' |
    'PLAN.PREVIOUS_MONTH' |
    'PLAN.PREVIOUS_WEEK' |
    'PLAN.READY_TO_BUILD' |
    'PLAN.READY_TO_BUILD_TOOLTIP' |
    'PLAN.SAVING_PLANNER_EVENT' |
    'PLAN.SPECIAL_REQUEST' |
    'PLAN.UPDATE_RECURRING_DATE' |
    'PLAN.VIEW_BY_MONTH' |
    'PLAN.VIEW_BY_WEEK' |
    'PROFILE.CHANGE_IMAGE' |
    'PROFILE.CHANGE_PROFILE_PICTURE' |
    'PROFILE.CONFIRM_REMOVE_PROFILE_PICTURE' |
    'PROFILE.EMAIL' |
    'PROFILE.EMAIL_REQUIRED' |
    'PROFILE.FIRST_NAME' |
    'PROFILE.FIRST_NAME_REQUIRED' |
    'PROFILE.INVITE_SENT' |
    'PROFILE.LAST_NAME' |
    'PROFILE.LAST_NAME_REQUIRED' |
    'PROFILE.MARKETING_UPDATES' |
    'PROFILE.MINIMUM_IMAGE_DIMENSION_REQUIREMENT' |
    'PROFILE.NOTIFICATIONS' |
    'PROFILE.PASSWORD' |
    'PROFILE.PROFILE' |
    'PROFILE.PROFILE_PICTURE' |
    'PROFILE.REMOVE_IMAGE' |
    'PROFILE.RESEND_INVITE' |
    'PROFILE.SENDING_INVITE' |
    'PROFILE.SPECIAL_REQUESTS' |
    'PROFILE.TIMEZONE' |
    'PROFILE.UNITS' |
    'PROFILE.UNSUPPORTED_IMAGE_FORMAT' |
    'PROFILE.USER_ACCOUNT_UPDATED' |
    'PROFILE.USER_LOCALE_CHANGED_PAGE_WILL_RELOAD' |
    'PROFILE.USER_PROFILE' |
    'REPORT.ADD_REMOVE_LOCATIONS' |
    'REPORT.ADJUSTED_DAILY_BUDGET' |
    'REPORT.ADJUST_SPEND' |
    'REPORT.ADVERTISING' |
    'REPORT.AD_NAME' |
    'REPORT.ALL_MONETARY_FIGURES_ARE_IN_CURRENCY' |
    'REPORT.AVERAGE_POSITION' |
    'REPORT.BOUNCED' |
    'REPORT.BRAND_AWARENESS' |
    'REPORT.BRAND_AWARENESS_BY_AD' |
    'REPORT.BRAND_AWARENESS_BY_KEYWORD' |
    'REPORT.BUDGET' |
    'REPORT.BY_AD' |
    'REPORT.BY_KEYWORD' |
    'REPORT.CAMPAIGN' |
    'REPORT.CAMPAIGN_MONITOR.TITLE' |
    'REPORT.CANT_REPORT_MORE_THAN_THREE_MONTHS' |
    'REPORT.CLICKED' |
    'REPORT.CLICKS' |
    'REPORT.CLICK_RATE' |
    'REPORT.CLICK_THROUGH_RATE' |
    'REPORT.CLICK_THROUGH_RATE_HINT' |
    'REPORT.CLIENT_OR_LOCATION' |
    'REPORT.COLLAPSE_POSTS' |
    'REPORT.COLLAPSE_ROWS' |
    'REPORT.CONFIRM_DELETE_REPORT_SUMMARY' |
    'REPORT.CONSUMED' |
    'REPORT.CONSUMPTION' |
    'REPORT.CONVERSIONS' |
    'REPORT.CONVERSIONS_BY_AD' |
    'REPORT.CONVERSIONS_BY_KEYWORD' |
    'REPORT.CONVERSIONS_PLATFORM_NOT_CONFIGURED_FOR_LOCATION' |
    'REPORT.CONVERSION_VALUE' |
    'REPORT.CONVERSION_VALUE_HINT' |
    'REPORT.COST_PER_CLICK' |
    'REPORT.COST_PER_CONVERSION' |
    'REPORT.COST_PER_LEAD' |
    'REPORT.COST_PER_UNIQUE_CLICK' |
    'REPORT.CURRENCY' |
    'REPORT.CURRENT_SPEND' |
    'REPORT.DEVICES.DESKTOP' |
    'REPORT.DEVICES.MOBILE' |
    'REPORT.DEVICES.TABLET' |
    'REPORT.DEVICES.UNKNOWN' |
    'REPORT.DEVICE_SELECTION' |
    'REPORT.DEVICE_SELECTION_HINT' |
    'REPORT.EMAIL_CAMPAIGNS.BOUNCES' |
    'REPORT.EMAIL_CAMPAIGNS.BUTTONS.DOWNLOAD_CSV' |
    'REPORT.EMAIL_CAMPAIGNS.BUTTONS.EXPORT_CSV' |
    'REPORT.EMAIL_CAMPAIGNS.CLICKS' |
    'REPORT.EMAIL_CAMPAIGNS.CLICK_RATE' |
    'REPORT.EMAIL_CAMPAIGNS.DELIVERED' |
    'REPORT.EMAIL_CAMPAIGNS.ERROR_COULD_NOT_BE_RETRIEVED' |
    'REPORT.EMAIL_CAMPAIGNS.ERROR_EXPORTING_CSV' |
    'REPORT.EMAIL_CAMPAIGNS.EXPORTING_PLEASE_WAIT' |
    'REPORT.EMAIL_CAMPAIGNS.HTML_PREVIEW_DIALOG_TITLE' |
    'REPORT.EMAIL_CAMPAIGNS.INVALID_EMAILS' |
    'REPORT.EMAIL_CAMPAIGNS.NOTIFICATIONS.EXPORTING_ERROR' |
    'REPORT.EMAIL_CAMPAIGNS.NOTIFICATIONS.EXPORTING_SUCCESS' |
    'REPORT.EMAIL_CAMPAIGNS.NOT_CONNECTED' |
    'REPORT.EMAIL_CAMPAIGNS.NUMBER_RECIPIENTS' |
    'REPORT.EMAIL_CAMPAIGNS.OPENS' |
    'REPORT.EMAIL_CAMPAIGNS.OPEN_RATE' |
    'REPORT.EMAIL_CAMPAIGNS.PLEASE_SELECT_EMAIL_PLATFORM' |
    'REPORT.EMAIL_CAMPAIGNS.RECIPIENTS' |
    'REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.CLICKED_LINK' |
    'REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.DELIVERED' |
    'REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.MARKED_AS_SPAM' |
    'REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.NO_RECIPIENTS_FOUND' |
    'REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.OPENED' |
    'REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.RECIPIENT_EMAIL' |
    'REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.RECIPIENT_EMAIL_FILTER_LABEL' |
    'REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.RECIPIENT_EMAIL_FILTER_PLACEHOLDER' |
    'REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.RECIPIENT_NAME' |
    'REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.RECIPIENT_NAME_FILTER_LABEL' |
    'REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.RECIPIENT_NAME_FILTER_PLACEHOLDER' |
    'REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.UNSUBSCRIBED' |
    'REPORT.EMAIL_CAMPAIGNS.SENDING_ON' |
    'REPORT.EMAIL_CAMPAIGNS.SENT_TO' |
    'REPORT.EMAIL_CAMPAIGNS.SPAM_REPORTS' |
    'REPORT.END_DATE' |
    'REPORT.END_DATE_BEFORE_START_DATE' |
    'REPORT.ENGAGED_USERS' |
    'REPORT.ENGAGEMENT' |
    'REPORT.ENGAGEMENT_CLICKS' |
    'REPORT.ENGAGEMENT_REACH' |
    'REPORT.FACEBOOK.AUDIENCE_INSIGHTS.AGE_RANGE' |
    'REPORT.FACEBOOK.AUDIENCE_INSIGHTS.AGE_RANGE_ALL' |
    'REPORT.FACEBOOK.AUDIENCE_INSIGHTS.AGE_RANGE_MEN' |
    'REPORT.FACEBOOK.AUDIENCE_INSIGHTS.AGE_RANGE_OTHER' |
    'REPORT.FACEBOOK.AUDIENCE_INSIGHTS.AGE_RANGE_WOMEN' |
    'REPORT.FACEBOOK.AUDIENCE_INSIGHTS.DAYS' |
    'REPORT.FACEBOOK.AUDIENCE_INSIGHTS.GENDER' |
    'REPORT.FACEBOOK.AUDIENCE_INSIGHTS.GENDER_MEN' |
    'REPORT.FACEBOOK.AUDIENCE_INSIGHTS.GENDER_OTHER' |
    'REPORT.FACEBOOK.AUDIENCE_INSIGHTS.GENDER_WOMEN' |
    'REPORT.FACEBOOK.AUDIENCE_INSIGHTS.HOURS' |
    'REPORT.FACEBOOK.AUDIENCE_INSIGHTS.ONLINE_FOLLOWERS' |
    'REPORT.FACEBOOK.AUDIENCE_INSIGHTS.ONLINE_FOLLOWERS_HELP_DAYS' |
    'REPORT.FACEBOOK.AUDIENCE_INSIGHTS.ONLINE_FOLLOWERS_HELP_HOURS' |
    'REPORT.FACEBOOK.AUDIENCE_INSIGHTS.TITLE' |
    'REPORT.FACEBOOK.AUDIENCE_INSIGHTS.TOP_LOCATIONS' |
    'REPORT.FACEBOOK.AUDIENCE_INSIGHTS.TOP_LOCATIONS_HELP' |
    'REPORT.FACEBOOK.AUDIENCE_INSIGHTS.TOP_POST_TIMES' |
    'REPORT.FACEBOOK.INCORRECT_DATA_POPOVER_TEXT' |
    'REPORT.FACEBOOK.LIKES_REPORT.NEW_PAGE_LIKES' |
    'REPORT.FACEBOOK.LIKES_REPORT.NEW_POSTS' |
    'REPORT.FACEBOOK.LIKES_REPORT.NOW' |
    'REPORT.FACEBOOK.LIKES_REPORT.PAGE_LIKES' |
    'REPORT.FACEBOOK.LIKES_REPORT.PAGE_LIKES_GROWTH' |
    'REPORT.FACEBOOK.LIKES_REPORT.PERIOD_AGO' |
    'REPORT.FACEBOOK.LIKES_REPORT.TITLE' |
    'REPORT.FACEBOOK.LIKES_REPORT.TOTAL_PAGE_LIKES' |
    'REPORT.FACEBOOK.NOT_CONNECTED' |
    'REPORT.FACEBOOK.POSTS_REPORT.ENGAGEMENT' |
    'REPORT.FACEBOOK.POSTS_REPORT.TIME' |
    'REPORT.FACEBOOK.POSTS_REPORT.TITLE' |
    'REPORT.FACEBOOK.POSTS_REPORT.VIEW_MORE' |
    'REPORT.FACEBOOK.POSTS_REPORT.VIEW_POST' |
    'REPORT.FACEBOOK_ADVERTISING' |
    'REPORT.FACEBOOK_TOP_POSTS' |
    'REPORT.FITWARE_MEMBER_ENGAGER.BOUNCES' |
    'REPORT.FITWARE_MEMBER_ENGAGER.LOCATION_EMAIL' |
    'REPORT.FITWARE_MEMBER_ENGAGER.OPENS' |
    'REPORT.FITWARE_MEMBER_ENGAGER.REPORT_LIMITATIONS.MESSAGE' |
    'REPORT.FITWARE_MEMBER_ENGAGER.REPORT_LIMITATIONS.TITLE' |
    'REPORT.FITWARE_MEMBER_ENGAGER.SPAM_REPORTS' |
    'REPORT.FITWARE_MEMBER_ENGAGER.TITLE' |
    'REPORT.FITWARE_MEMBER_ENGAGER.UNSUBSCRIBES' |
    'REPORT.FOLLOWERS_FROM' |
    'REPORT.FOLLOWERS_GROWTH' |
    'REPORT.FOLLOWERS_TO' |
    'REPORT.FOLLOWING_REQUEST_WILL_BE_SENT_TO_AGENCY' |
    'REPORT.GENERAL_EVENTS' |
    'REPORT.GENERAL_TEMPLATE_TYPES.ALL' |
    'REPORT.GENERAL_TEMPLATE_TYPES.DIGITAL' |
    'REPORT.GENERAL_TEMPLATE_TYPES.EMAIL' |
    'REPORT.GENERAL_TEMPLATE_TYPES.PRINT' |
    'REPORT.GENERATED_REPORT_PRINT_FOOTER' |
    'REPORT.GENERATING_REPORT' |
    'REPORT.GO' |
    'REPORT.GOOGLE_ADS.AD_NAME_TOOLTIP_NUM_DESCRIPTION' |
    'REPORT.GOOGLE_ADS.AD_NAME_TOOLTIP_NUM_DESCRIPTION_plural' |
    'REPORT.GOOGLE_ADS.AD_NAME_TOOLTIP_NUM_HEADLINE' |
    'REPORT.GOOGLE_ADS.AD_NAME_TOOLTIP_NUM_HEADLINE_plural' |
    'REPORT.GOOGLE_ADS.AD_NAME_TOOLTIP_NUM_URL' |
    'REPORT.GOOGLE_ADS.AD_NAME_TOOLTIP_NUM_URL_plural' |
    'REPORT.GOOGLE_ADS.COLUMNS.AD_NAME' |
    'REPORT.GOOGLE_ADS.COLUMNS.AVERAGE_CPC' |
    'REPORT.GOOGLE_ADS.COLUMNS.AVERAGE_CPC_TOOLTIP' |
    'REPORT.GOOGLE_ADS.COLUMNS.CONVERSIONS' |
    'REPORT.GOOGLE_ADS.COLUMNS.CONVERSIONS_TOOLTIP' |
    'REPORT.GOOGLE_ADS.COLUMNS.COST' |
    'REPORT.GOOGLE_ADS.COLUMNS.COST_PER_CONVERSION' |
    'REPORT.GOOGLE_ADS.COLUMNS.COST_PER_CONVERSION_TOOLTIP' |
    'REPORT.GOOGLE_ADS.COLUMNS.COST_TOOLTIP' |
    'REPORT.GOOGLE_ADS.COLUMNS.CURRENCY' |
    'REPORT.GOOGLE_ADS.COLUMNS.CURRENCY_TOOLTIP' |
    'REPORT.GOOGLE_ADS.COLUMNS.IMPRESSIONS' |
    'REPORT.GOOGLE_ADS.COLUMNS.IMPRESSIONS_TOOLTIP' |
    'REPORT.GOOGLE_ADS.COLUMNS.INTERACTIONS' |
    'REPORT.GOOGLE_ADS.COLUMNS.INTERACTIONS_TOOLTIP' |
    'REPORT.GOOGLE_ADS.COLUMNS.INTERACTION_RATE' |
    'REPORT.GOOGLE_ADS.COLUMNS.INTERACTION_RATE_TOOLTIP' |
    'REPORT.GOOGLE_ADS.COLUMNS.KEYWORD' |
    'REPORT.GOOGLE_ADS.KEYWORD_BROAD_MATCH_TOOLTIP' |
    'REPORT.GOOGLE_ADS.KEYWORD_EXACT_MATCH_TOOLTIP' |
    'REPORT.GOOGLE_ADS.KEYWORD_PHRASE_MATCH_TOOLTIP' |
    'REPORT.GOOGLE_ADS.KEYWORD_UNKNOWN_MATCH_TOOLTIP' |
    'REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.ADDITIONAL_NOTES' |
    'REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.EXTRA_STEPS_MAY_BE_REQUIRED' |
    'REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.FAILED_TO_REQUEST_SPEND_ADJUSTMENT' |
    'REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.INCREASE_MY_GOOGLE_ADWORDS_BUDGET' |
    'REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.REQUEST_HAS_BEEN_SENT' |
    'REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.REQUEST_TO_ADJUST_SPEND' |
    'REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.SEND_REQUEST' |
    'REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.USER_HAS_REQUESTED_AN_ADJUSTMENT_TO_ADWORDS_SPEND' |
    'REPORT.GOOGLE_MY_BUSINESS.CONFIRM_DELETE_MESSAGE' |
    'REPORT.GOOGLE_MY_BUSINESS.CUSTOMER_FEEDBACK.TITLE' |
    'REPORT.GOOGLE_MY_BUSINESS.DIRECTIONS_REPORT.TITLE' |
    'REPORT.GOOGLE_MY_BUSINESS.METRICS_NO_LONGER_AVALIABLE_BANNER' |
    'REPORT.GOOGLE_MY_BUSINESS.NOT_CONNECTED_PART_1' |
    'REPORT.GOOGLE_MY_BUSINESS.NOT_CONNECTED_PART_2' |
    'REPORT.GOOGLE_MY_BUSINESS.PHOTO_QUANTITY_REPORT.MERCHANT_TITLE' |
    'REPORT.GOOGLE_MY_BUSINESS.PHOTO_QUANTITY_REPORT.OTHERS_TITLE' |
    'REPORT.GOOGLE_MY_BUSINESS.PHOTO_QUANTITY_REPORT.TITLE' |
    'REPORT.GOOGLE_MY_BUSINESS.PHOTO_VIEWS_REPORT.MERCHANT_TITLE' |
    'REPORT.GOOGLE_MY_BUSINESS.PHOTO_VIEWS_REPORT.OTHERS_TITLE' |
    'REPORT.GOOGLE_MY_BUSINESS.PHOTO_VIEWS_REPORT.TITLE' |
    'REPORT.GOOGLE_MY_BUSINESS.RECENT_POSTS.POST_CLICKS' |
    'REPORT.GOOGLE_MY_BUSINESS.RECENT_POSTS.POST_VIEWS' |
    'REPORT.GOOGLE_MY_BUSINESS.RECENT_POSTS.TITLE' |
    'REPORT.GOOGLE_MY_BUSINESS.RECENT_POSTS.VIEW_POST' |
    'REPORT.GOOGLE_MY_BUSINESS.REPLY' |
    'REPORT.GOOGLE_MY_BUSINESS.REPLYING_PUBLICLY' |
    'REPORT.GOOGLE_MY_BUSINESS.REPLY_LENGTH_ERROR' |
    'REPORT.GOOGLE_MY_BUSINESS.SEARCH_REPORT.BRANDED_DESCRIPTION' |
    'REPORT.GOOGLE_MY_BUSINESS.SEARCH_REPORT.BRANDED_TITLE' |
    'REPORT.GOOGLE_MY_BUSINESS.SEARCH_REPORT.DIRECT_DESCRIPTION' |
    'REPORT.GOOGLE_MY_BUSINESS.SEARCH_REPORT.DIRECT_TITLE' |
    'REPORT.GOOGLE_MY_BUSINESS.SEARCH_REPORT.DISCOVERY_DESCRIPTION' |
    'REPORT.GOOGLE_MY_BUSINESS.SEARCH_REPORT.DISCOVERY_TITLE' |
    'REPORT.GOOGLE_MY_BUSINESS.SEARCH_REPORT.TITLE' |
    'REPORT.GOOGLE_MY_BUSINESS.TOOLBAR.DAYS_30' |
    'REPORT.GOOGLE_MY_BUSINESS.TOOLBAR.DAYS_7' |
    'REPORT.GOOGLE_MY_BUSINESS.TOOLBAR.DAYS_90' |
    'REPORT.GOOGLE_MY_BUSINESS.TOP_QUESTIONS.ANONYMOUS_AUTHOR_NAME' |
    'REPORT.GOOGLE_MY_BUSINESS.TOP_QUESTIONS.ANSWERS' |
    'REPORT.GOOGLE_MY_BUSINESS.TOP_QUESTIONS.ANSWER_LIST_TITLE' |
    'REPORT.GOOGLE_MY_BUSINESS.TOP_QUESTIONS.QUESTIONS' |
    'REPORT.GOOGLE_MY_BUSINESS.TOP_QUESTIONS.TITLE' |
    'REPORT.GOOGLE_MY_BUSINESS.TOP_QUESTIONS.UPVOTES' |
    'REPORT.GOOGLE_MY_BUSINESS.TOP_REVIEWS.ANONYMOUS_REVIEWER_NAME' |
    'REPORT.GOOGLE_MY_BUSINESS.TOP_REVIEWS.REPLIED_AT' |
    'REPORT.GOOGLE_MY_BUSINESS.TOP_REVIEWS.REVIEWS' |
    'REPORT.GOOGLE_MY_BUSINESS.TOP_REVIEWS.SUB_TITLE' |
    'REPORT.GOOGLE_MY_BUSINESS.TOP_REVIEWS.TITLE' |
    'REPORT.GOOGLE_MY_BUSINESS.VIEW_FULL_REPLY' |
    'REPORT.GOOGLE_MY_BUSINESS.VIEW_FULL_REVIEW' |
    'REPORT.GOOGLE_MY_BUSINESS.VIEW_REPORT.CALLS_CHART_LABEL' |
    'REPORT.GOOGLE_MY_BUSINESS.VIEW_REPORT.CALLS_TITLE' |
    'REPORT.GOOGLE_MY_BUSINESS.VIEW_REPORT.DIRECTIONS_CHART_LABEL' |
    'REPORT.GOOGLE_MY_BUSINESS.VIEW_REPORT.DIRECTIONS_TITLE' |
    'REPORT.GOOGLE_MY_BUSINESS.VIEW_REPORT.TITLE' |
    'REPORT.GOOGLE_MY_BUSINESS.VIEW_REPORT.WEBSITES_CHART_LABEL' |
    'REPORT.GOOGLE_MY_BUSINESS.VIEW_REPORT.WEBSITES_TITLE' |
    'REPORT.GROWTH' |
    'REPORT.HIDE_SUMMARY' |
    'REPORT.IMPRESSIONS' |
    'REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.AGE_RANGE_ALL' |
    'REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.AGE_RANGE_MEN' |
    'REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.AGE_RANGE_OTHER' |
    'REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.AGE_RANGE_WOMEN' |
    'REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.DAYS' |
    'REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.HOURS' |
    'REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.ONLINE_FOLLOWERS' |
    'REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.ONLINE_FOLLOWERS_HELP_DAYS' |
    'REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.ONLINE_FOLLOWERS_HELP_HOURS' |
    'REPORT.INSTAGRAM.BUSINESS_ACCOUNT_REPORT.FOLLOWERS_CHART_LABEL' |
    'REPORT.INSTAGRAM.NOT_CONNECTED_PART_1' |
    'REPORT.INSTAGRAM.NOT_CONNECTED_PART_2' |
    'REPORT.INSTAGRAM.NOT_CONNECTED_SCOPES_PART_1' |
    'REPORT.INSTAGRAM.NOT_CONNECTED_SCOPES_PART_2' |
    'REPORT.INSTAGRAM.POSTS_REPORT.CURRENT_POSTS' |
    'REPORT.INSTAGRAM.POSTS_REPORT.TITLE' |
    'REPORT.INSTAGRAM.POSTS_REPORT.VIEW_MORE' |
    'REPORT.INSTAGRAM.POSTS_REPORT.VIEW_POST' |
    'REPORT.INSTAGRAM.STORIES_REPORT.ACTIVE_STORIES' |
    'REPORT.INSTAGRAM.STORIES_REPORT.NO_ACTIVE_STORIES_MESSAGE' |
    'REPORT.INSTAGRAM.STORIES_REPORT.NO_PAST_STORIES_MESSAGE' |
    'REPORT.INSTAGRAM.STORIES_REPORT.PAST_STORIES' |
    'REPORT.INSTAGRAM.STORIES_REPORT.TITLE' |
    'REPORT.INSTAGRAM.STORIES_REPORT.VIEW_MORE' |
    'REPORT.INSTAGRAM.STORIES_REPORT.VIEW_POST' |
    'REPORT.INVALID_END_DATE' |
    'REPORT.INVALID_START_DATE' |
    'REPORT.KEYWORD' |
    'REPORT.LAST_LOGIN' |
    'REPORT.LEADS' |
    'REPORT.LIKES_COMMENTS_SHARES' |
    'REPORT.LIMITED' |
    'REPORT.LOCATION' |
    'REPORT.LOCATION_AD' |
    'REPORT.LOCATION_CONVERSION_TYPE_AD' |
    'REPORT.LOCATION_CONVERSION_TYPE_KEYWORD' |
    'REPORT.LOCATION_KEYWORD' |
    'REPORT.LOGIN_DATE' |
    'REPORT.MAILCHIMP.TITLE' |
    'REPORT.MAXIMUM_SPEND' |
    'REPORT.MAXIMUM_SPEND_HINT' |
    'REPORT.MORE_ROWS' |
    'REPORT.MORE_ROWS_plural' |
    'REPORT.MOST_USED_ACTIVITIES' |
    'REPORT.MULTIPLE_LOCATION_REPORT' |
    'REPORT.NEW_FOLLOWERS' |
    'REPORT.NEW_LIKES' |
    'REPORT.NEW_POSTS' |
    'REPORT.NEW_REPORT_SUMMARY' |
    'REPORT.NEW_VISITORS' |
    'REPORT.NOT_CONNECTED_PART_1' |
    'REPORT.NOT_CONNECTED_PART_2' |
    'REPORT.NOT_ENOUGH_DATA' |
    'REPORT.NO_ADWORD_STATS_FOUND' |
    'REPORT.NO_CAMPAIGNS_FOUND' |
    'REPORT.NO_UNREACHED_MARKET_FOR_PERIOD' |
    'REPORT.NO_VISITORS_FOUND' |
    'REPORT.NUMBER_OF_TEMPLATES_BUILT' |
    'REPORT.ORGANIC' |
    'REPORT.OVERVIEW.EMAIL_CAMPAIGNS.CAMPAIGN_MONITOR_CHECK_BACK_SOON' |
    'REPORT.OVERVIEW.EMAIL_CAMPAIGNS.CAMPAIGN_MONITOR_TOOLTIP' |
    'REPORT.OVERVIEW.EMAIL_CAMPAIGNS.TITLE' |
    'REPORT.OVERVIEW.FACEBOOK.ENGAGEMENT' |
    'REPORT.OVERVIEW.FACEBOOK.ENGAGEMENT_HINT' |
    'REPORT.OVERVIEW.FACEBOOK.ENGAGEMENT_RATE' |
    'REPORT.OVERVIEW.FACEBOOK.TITLE' |
    'REPORT.PAID' |
    'REPORT.PAID_IMPRESSIONS' |
    'REPORT.PAID_UNIQUE_VIEWS' |
    'REPORT.PAID_VIEWS_DEPRECATION' |
    'REPORT.PEOPLE_REACHED' |
    'REPORT.PLANNED_VS_ADHOC.BUILT_FROM_GALLERY' |
    'REPORT.PLANNED_VS_ADHOC.BUILT_FROM_PLANNER' |
    'REPORT.PLANNED_VS_ADHOC.PLANNED_VS_ADHOC' |
    'REPORT.PLANNING_AND_EXECUTION' |
    'REPORT.PLATFORM' |
    'REPORT.POPULAR_BUILDER_TEMPLATE_DETAILS.BUTTONS.DOWNLOAD_CSV' |
    'REPORT.POPULAR_BUILDER_TEMPLATE_DETAILS.BUTTONS.EXPORT_CSV' |
    'REPORT.POPULAR_BUILDER_TEMPLATE_DETAILS.ERROR_EXPORTING_CSV' |
    'REPORT.POPULAR_BUILDER_TEMPLATE_DETAILS.EXPORTING_PLEASE_WAIT' |
    'REPORT.POPULAR_BUILDER_TEMPLATE_DETAILS.NOTIFICATIONS.EXPORTING_ERROR' |
    'REPORT.POPULAR_BUILDER_TEMPLATE_DETAILS.NOTIFICATIONS.EXPORTING_SUCCESS' |
    'REPORT.POPULAR_CATEGORIES.BY_PLATFORM' |
    'REPORT.POPULAR_CATEGORIES.CATEGORY' |
    'REPORT.POPULAR_CATEGORIES.ORDER_IN_GALLERY' |
    'REPORT.POPULAR_CATEGORIES.TEMPLATE_CATEGORY_POPULARITY' |
    'REPORT.POPULAR_CATEGORIES.TIMES_USED' |
    'REPORT.POPULAR_CATEGORIES.TOTAL_USES' |
    'REPORT.POSITIVE_FEEDBACK' |
    'REPORT.POTENTIAL_ROI' |
    'REPORT.POTENTIAL_ROI_HINT' |
    'REPORT.PRINT_THIS_PAGE' |
    'REPORT.REACH' |
    'REPORT.REACHED' |
    'REPORT.RECIPIENTS' |
    'REPORT.RECOMMENDATIONS' |
    'REPORT.RECOMMENDED_SPEND' |
    'REPORT.RECOMMENDED_SPEND_HINT' |
    'REPORT.REPORTS' |
    'REPORT.REPORTS_ARCHIVED' |
    'REPORT.REPORT_LOADED_LOCATIONS' |
    'REPORT.REPORT_LOADED_LOCATIONS_plural' |
    'REPORT.REPORT_SUMMARY' |
    'REPORT.REPORT_SUMMARY_TEXT.DELETED' |
    'REPORT.REPORT_SUMMARY_TEXT.INVALID_DATE_RANGE' |
    'REPORT.REPORT_SUMMARY_TEXT.SAVED' |
    'REPORT.REQUEST_SPEND_ADJUSTMENT' |
    'REPORT.RETURNING_VISITORS' |
    'REPORT.RETURN_ON_INVESTMENT' |
    'REPORT.RETURN_ON_INVESTMENT_HINT' |
    'REPORT.ROI' |
    'REPORT.ROI_HINT' |
    'REPORT.ROI_PERCENT' |
    'REPORT.SALES' |
    'REPORT.SCHEDULED_DATE' |
    'REPORT.SELECTED_LOCATIONS' |
    'REPORT.SELECT_AT_LEAST_ONE_LOCATION' |
    'REPORT.SELF_SERVICE_EVENTS' |
    'REPORT.SELF_SERVICE_OR_GENERAL_EVENTS' |
    'REPORT.SENT_DATE' |
    'REPORT.SHOW_ALL_ROWS' |
    'REPORT.SHOW_SUMMARY' |
    'REPORT.SHOW_TOP_N' |
    'REPORT.SPECIAL_REQUESTS' |
    'REPORT.SPEND' |
    'REPORT.START_DATE' |
    'REPORT.START_DATE_BEFORE_TODAY' |
    'REPORT.STATUS' |
    'REPORT.SUMMARY' |
    'REPORT.SUPPORTED_EVENTS' |
    'REPORT.TEMPLATES_BUILT_BY_TIME' |
    'REPORT.TEMPLATE_USAGE' |
    'REPORT.TEMPLATE_USES' |
    'REPORT.TEMPLATE_USES_plural' |
    'REPORT.TEMPLATE_USE_BY_LOCATION' |
    'REPORT.TOTAL' |
    'REPORT.TOTAL_CLOSE_RATIO' |
    'REPORT.TOTAL_CONVERSIONS' |
    'REPORT.TOTAL_CONVERSION_WORTH' |
    'REPORT.TOTAL_EVENTS' |
    'REPORT.TOTAL_IMPRESSIONS' |
    'REPORT.TOTAL_LEADS' |
    'REPORT.TOTAL_POSTS' |
    'REPORT.TOTAL_REACH_VS_TOTAL_PAID' |
    'REPORT.TOTAL_SALES' |
    'REPORT.TOTAL_SPEND' |
    'REPORT.TOTAL_UNIQUE_VIEWS' |
    'REPORT.TOTAL_VISITORS' |
    'REPORT.TOUR_CLOSE_RATIO' |
    'REPORT.TOUR_SALE' |
    'REPORT.TOUR_SHOW_UPS' |
    'REPORT.TYPES.EMAIL_CAMPAIGNS.NAME' |
    'REPORT.TYPES.EMAIL_CAMPAIGNS.TITLE' |
    'REPORT.TYPES.FACEBOOK.NAME' |
    'REPORT.TYPES.FACEBOOK.TITLE' |
    'REPORT.TYPES.GOOGLE_MY_BUSINESS.NAME' |
    'REPORT.TYPES.GOOGLE_MY_BUSINESS.TITLE' |
    'REPORT.TYPES.INSTAGRAM.NAME' |
    'REPORT.TYPES.INSTAGRAM.TITLE' |
    'REPORT.TYPES.OVERVIEW.NAME' |
    'REPORT.TYPES.OVERVIEW.TITLE' |
    'REPORT.TYPES.PAID_MEDIA.NAME' |
    'REPORT.TYPES.PAID_MEDIA.TITLE' |
    'REPORT.TYPES.TITLE' |
    'REPORT.UNIQUE_CLICKS' |
    'REPORT.UNIQUE_OPENED' |
    'REPORT.UNREACHED_MARKET' |
    'REPORT.UNREACHED_MARKET_HINT' |
    'REPORT.VALUE_PER_CONVERSION' |
    'REPORT.VISITORS' |
    'REPORT.WAIT_FOR_LOCATIONS' |
    'REPORT.WALK_IN_CLOSE_RATIO' |
    'REPORT.WALK_IN_SALE' |
    'REPORT.WALK_IN_TOTAL' |
    'REPORT.WEBSITE' |
    'REQUESTS.ALREADY_PAID_DIFFERENCE' |
    'REQUESTS.AMENDMENTS_REQUESTED' |
    'REQUESTS.AWAITING_APPROVAL' |
    'REQUESTS.AWAITING_HEAD_OFFICE_APPROVAL' |
    'REQUESTS.BEGIN_PAYMENT' |
    'REQUESTS.BRIEF' |
    'REQUESTS.CLICK_TO_LOAD_CLOSED_REQUESTS' |
    'REQUESTS.CLIENT_LOCATION' |
    'REQUESTS.CLOSED' |
    'REQUESTS.DATE_REQUESTED_BY' |
    'REQUESTS.DATE_REQUIRED_BY' |
    'REQUESTS.DATE_SUBMITTED' |
    'REQUESTS.DELIVERABLES' |
    'REQUESTS.EMAILS.ADDED.NEW_SPECIAL_REQUEST' |
    'REQUESTS.EMAILS.ADDED.REQUEST_IS_DUE_BY' |
    'REQUESTS.EMAILS.COMMENT_ADDED.SPECIAL_REQUEST_HAS_BEEN_UPDATED' |
    'REQUESTS.EMAILS.COMMENT_ADDED.SUBJECT_LINE' |
    'REQUESTS.EMAILS.VIEW_SPECIAL_REQUEST' |
    'REQUESTS.ESCALATED' |
    'REQUESTS.FAILED_TO_GET_SPECIAL_REQUEST' |
    'REQUESTS.FAILED_TO_GET_SPECIAL_REQUESTS' |
    'REQUESTS.FILTER.CLIENT' |
    'REQUESTS.FILTER.DATE' |
    'REQUESTS.FILTER.STATUS' |
    'REQUESTS.FILTER.TITLE' |
    'REQUESTS.ID' |
    'REQUESTS.INVALID_DATE_REQUIRED_BY' |
    'REQUESTS.IN_PROGRESS' |
    'REQUESTS.LOAD_MANAGERS_FAILED' |
    'REQUESTS.MORE_INFO_REQUIRED' |
    'REQUESTS.NEW_REQUEST' |
    'REQUESTS.PAYMENT' |
    'REQUESTS.PAYMENT_OVERPAID' |
    'REQUESTS.PAYMENT_REQUIRED' |
    'REQUESTS.PLEASE_ENTER_DELIVERABLES' |
    'REQUESTS.PREVIOUS_QUOTE_DIFFERENCE' |
    'REQUESTS.QUOTE' |
    'REQUESTS.QUOTED' |
    'REQUESTS.QUOTE_APPROVED' |
    'REQUESTS.QUOTE_REJECTED' |
    'REQUESTS.QUOTE_SENT' |
    'REQUESTS.REQUEST_SAVED' |
    'REQUESTS.RETRIEVE_SPECIAL_REQUEST' |
    'REQUESTS.SAVE_SPECIAL_REQUEST' |
    'REQUESTS.SELECTED_DELIVERABLES' |
    'REQUESTS.SEND_QUOTE' |
    'REQUESTS.STATUS' |
    'REQUESTS.SUBMITTED' |
    'REQUESTS.UPDATED' |
    'ROADMAP.LATER.HEADING' |
    'ROADMAP.LATER.ITEMS.ITEM_1' |
    'ROADMAP.LATER.ITEMS.ITEM_2' |
    'ROADMAP.LATER.ITEMS.ITEM_3' |
    'ROADMAP.LATER.ITEMS.ITEM_4' |
    'ROADMAP.LATER.ITEMS.ITEM_5' |
    'ROADMAP.NEXT.HEADING' |
    'ROADMAP.NEXT.ITEMS.ITEM_1' |
    'ROADMAP.NEXT.ITEMS.ITEM_2' |
    'ROADMAP.NEXT.ITEMS.ITEM_3' |
    'ROADMAP.NEXT.ITEMS.ITEM_4' |
    'ROADMAP.NEXT.ITEMS.ITEM_5' |
    'ROADMAP.NEXT.ITEMS.ITEM_6' |
    'ROADMAP.NEXT.ITEMS.ITEM_7' |
    'ROADMAP.NEXT.ITEMS.ITEM_8' |
    'ROADMAP.NOW.HEADING' |
    'ROADMAP.NOW.ITEMS.ITEM_1' |
    'ROADMAP.NOW.ITEMS.ITEM_2' |
    'ROADMAP.NOW.ITEMS.ITEM_3' |
    'ROADMAP.NOW.ITEMS.ITEM_4' |
    'ROADMAP.NOW.ITEMS.ITEM_5' |
    'ROADMAP.NOW.ITEMS.ITEM_6' |
    'ROADMAP.NOW.ITEMS.ITEM_7' |
    'ROADMAP.NOW.ITEMS.ITEM_8' |
    'ROADMAP.RECENTLY_DELIVERED.HEADING' |
    'ROADMAP.RECENTLY_DELIVERED.ITEMS.ITEM_1' |
    'ROADMAP.RECENTLY_DELIVERED.ITEMS.ITEM_2' |
    'ROADMAP.RECENTLY_DELIVERED.ITEMS.ITEM_3' |
    'ROADMAP.RECENTLY_DELIVERED.ITEMS.ITEM_4' |
    'ROADMAP.RECENTLY_DELIVERED.ITEMS.ITEM_5' |
    'ROADMAP.RECENTLY_DELIVERED.ITEMS.ITEM_6' |
    'SCHEDULE.EMAILS.DOWNLOAD_THE_APP' |
    'SCHEDULE.EMAILS.FAILED_TO_NOTIFY.CONTENT' |
    'SCHEDULE.EMAILS.FAILED_TO_NOTIFY.HEADING_1' |
    'SCHEDULE.EMAILS.FAILED_TO_NOTIFY.SUBJECT_LINE' |
    'SCHEDULE.EMAILS.NO_DEVICES.CONTENT_1' |
    'SCHEDULE.EMAILS.NO_DEVICES.CONTENT_2' |
    'SCHEDULE.EMAILS.NO_DEVICES.CONTENT_3' |
    'SCHEDULE.EMAILS.NO_DEVICES.HEADING_1' |
    'SCHEDULE.EMAILS.NO_DEVICES.SUBJECT_LINE' |
    'SCHEDULE.PAGE.DIALOGS.DELETE.CONFIRM' |
    'SCHEDULE.PAGE.DIALOGS.DELETE.DISABLED_LEGACY' |
    'SCHEDULE.PAGE.DIALOGS.DELETE.DISABLED_SCHEDULING' |
    'SCHEDULE.PAGE.DIALOGS.DELETE.FAILED_TO_DELETE' |
    'SCHEDULE.PAGE.DIALOGS.DELETE.OPTION_FOR_MULTIPLE' |
    'SCHEDULE.PAGE.DIALOGS.DELETE.OPTION_FOR_SINGLE' |
    'SCHEDULE.PAGE.DIALOGS.DELETE.SUCCESSFULLY_DELETED_POST' |
    'SCHEDULE.PAGE.DIALOGS.DELETE.TITLE' |
    'SCHEDULE.PAGE.DIALOGS.EDIT_CAPTION.CONTACTING_PLATFORM' |
    'SCHEDULE.PAGE.DIALOGS.EDIT_CAPTION.FAILED_TO_EDIT' |
    'SCHEDULE.PAGE.DIALOGS.EDIT_CAPTION.OPTION_FOR_MULTIPLE' |
    'SCHEDULE.PAGE.DIALOGS.EDIT_CAPTION.OPTION_FOR_SINGLE' |
    'SCHEDULE.PAGE.DIALOGS.EDIT_CAPTION.SUCCESSFULLY_EDITED_CAPTION' |
    'SCHEDULE.PAGE.DIALOGS.EDIT_CAPTION.TITLE' |
    'SCHEDULE.PAGE.DIALOGS.RESCHEDULE.CONFIRM' |
    'SCHEDULE.PAGE.DIALOGS.RESCHEDULE.DELETED' |
    'SCHEDULE.PAGE.DIALOGS.RESCHEDULE.DISABLED_LEGACY' |
    'SCHEDULE.PAGE.DIALOGS.RESCHEDULE.DISABLED_SCHEDULING' |
    'SCHEDULE.PAGE.DIALOGS.RESCHEDULE.FAILED_TO_RESCHEDULE' |
    'SCHEDULE.PAGE.DIALOGS.RESCHEDULE.OPTION_FOR_MULTIPLE' |
    'SCHEDULE.PAGE.DIALOGS.RESCHEDULE.OPTION_FOR_SINGLE' |
    'SCHEDULE.PAGE.DIALOGS.RESCHEDULE.SUCCESSFULLY_RESCHEDULED_POST' |
    'SCHEDULE.PAGE.DIALOGS.RESCHEDULE.TITLE' |
    'SCHEDULE.PAGE.HEADER_TITLE' |
    'SCHEDULE.PAGE.RESCHEDULE' |
    'SCHEDULE.PAGE.TABLE.HEADERS.ACTION' |
    'SCHEDULE.PAGE.TABLE.HEADERS.CAPTION' |
    'SCHEDULE.PAGE.TABLE.HEADERS.LOCATIONS' |
    'SCHEDULE.PAGE.TABLE.HEADERS.POST' |
    'SCHEDULE.PAGE.TABLE.HEADERS.TIME' |
    'SCHEDULE.PAGE.TABLE.LOAD_NEWER_POSTS' |
    'SCHEDULE.PAGE.TABLE.LOAD_OLDER_POSTS' |
    'SCHEDULE.PAGE.TABLE.NO_SCHEDULED_POSTS_FOUND_FOR_PLATFORM' |
    'SCHEDULE.POSTS.CAPTION' |
    'SCHEDULE.POSTS.COPIED_TO_CLIPBOARD' |
    'SCHEDULE.POSTS.COPIED_TO_CLIPBOARD_FAILED' |
    'SCHEDULE.POSTS.COPY_CAPTION' |
    'SCHEDULE.POSTS.DOWNLOAD_IMAGE' |
    'SCHEDULE.POSTS.GET_SCHEDULED_DETAILS' |
    'SCHEDULE.POSTS.POST_DETAILS_SMS' |
    'SCHEDULE.POSTS.POST_IMMEDIATELY' |
    'SCHEDULE.POSTS.POST_SCHEDULED_FOR' |
    'SCHEDULE.POSTS.SMS_DOWNLOAD_MESSAGE' |
    'SCHEDULE.POSTS.UNABLE_TO_FIND_POST' |
    'SCHEDULE.POSTS.UNABLE_TO_FIND_POST_HEADING' |
    'SCHEDULE.PUSH_NOTIFICATIONS.TIME_TO_POST' |
    'SCHEDULE.SCHEDULED_WITH_MOBILE_APP' |
    'SHOPPING_CART.ADD_TO_CART' |
    'SHOPPING_CART.CHECKOUT.ADDRESS' |
    'SHOPPING_CART.CHECKOUT.CARD_DETAILS' |
    'SHOPPING_CART.CHECKOUT.CHECKOUT' |
    'SHOPPING_CART.CHECKOUT.COMPLETE_PAYMENT' |
    'SHOPPING_CART.CHECKOUT.DELETE_ITEM' |
    'SHOPPING_CART.CHECKOUT.DELETE_ITEM_CONFIRMATION' |
    'SHOPPING_CART.CHECKOUT.INC_TAX' |
    'SHOPPING_CART.CHECKOUT.LOCATIONS' |
    'SHOPPING_CART.CHECKOUT.PAYMENT_PENDING' |
    'SHOPPING_CART.CHECKOUT.PAYMENT_SUCCESSFUL' |
    'SHOPPING_CART.CHECKOUT.PAY_AMOUNT' |
    'SHOPPING_CART.CHECKOUT.PRINT_ORDER' |
    'SHOPPING_CART.CHECKOUT.PRINT_PROVIDER_NOT_CONFIGURED_PROPERLY' |
    'SHOPPING_CART.CHECKOUT.PURCHASE_COMPLETE' |
    'SHOPPING_CART.CHECKOUT.QUANTITY' |
    'SHOPPING_CART.CHECKOUT.SHIPPING' |
    'SHOPPING_CART.CHECKOUT.SHIPPING_DETAILS_INVALID' |
    'SHOPPING_CART.CHECKOUT.UPDATE_ITEM_QUANTITY' |
    'SHOPPING_CART.CHECKOUT.VIEW_RECEIPT' |
    'SHOPPING_CART.CHECKOUT.YOUR_RECEIPT_CAN_BE_VIEWED_BELOW' |
    'SHOPPING_CART.CHECKOUT_NOW' |
    'SHOPPING_CART.CHECKOUT_YOUR_PRINT_ITEMS' |
    'SHOPPING_CART.EMAILS.DATE' |
    'SHOPPING_CART.EMAILS.ORDER_NUMBER' |
    'SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_PROVIDER.AGENCY' |
    'SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_PROVIDER.CLIENT' |
    'SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_PROVIDER.CONTACT_EMAIL' |
    'SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_PROVIDER.ORDER_RECEIVED' |
    'SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_PROVIDER.SUBJECT_LINE' |
    'SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_USER.ORDER_RECEIVED' |
    'SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_USER.PRINT_PROVIDER' |
    'SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_USER.PRINT_PROVIDER_EMAIL' |
    'SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_USER.SUBJECT_LINE' |
    'SHOPPING_CART.FETCH_ITEM_COUNT' |
    'SHOPPING_CART.FETCH_ORDERS' |
    'SHOPPING_CART.PRINT_REQUEST_ADDED_TO_CART' |
    'STATS.EMAILS.ACCESS_TOKEN_ERROR.ACCESS_ERROR_FOR' |
    'STATS.EMAILS.ACCESS_TOKEN_ERROR.AUTHORIZE_SERVICE' |
    'STATS.EMAILS.ACCESS_TOKEN_ERROR.IF_ACCESS_TO_IS_NO_LONGER_REQUIRED' |
    'STATS.EMAILS.ACCESS_TOKEN_ERROR.IF_NOT_RESOLVED_CONTACT_SUPPORT' |
    'STATS.EMAILS.ACCESS_TOKEN_ERROR.SUBJECT_LINE' |
    'STATS.EMAILS.ACCESS_TOKEN_ERROR.TRY_LOGGING_IN_AND_RE_AUTHORIZING' |
    'STATS.EMAILS.ACCESS_TOKEN_ERROR.WE_HAD_A_PROBLEM_TRYING_TO_ACCESS' |
    'TERMS.HEADING' |
    'TERMS.SECTION_01.DESCRIPTION' |
    'TERMS.SECTION_01.HEADING' |
    'TERMS.SECTION_01.PART_A' |
    'TERMS.SECTION_01.PART_B' |
    'TERMS.SECTION_02.DESCRIPTION' |
    'TERMS.SECTION_02.HEADING' |
    'TERMS.SECTION_03.DESCRIPTION' |
    'TERMS.SECTION_03.HEADING' |
    'TERMS.SECTION_04.HEADING' |
    'TERMS.SECTION_04.PART_01' |
    'TERMS.SECTION_04.PART_02' |
    'TERMS.SECTION_05.HEADING' |
    'TERMS.SECTION_05.PART_01.HEADING' |
    'TERMS.SECTION_05.PART_01.PART_A' |
    'TERMS.SECTION_05.PART_01.PART_B' |
    'TERMS.SECTION_05.PART_01.PART_C' |
    'TERMS.SECTION_05.PART_01.PART_D' |
    'TERMS.SECTION_06.HEADING' |
    'TERMS.SECTION_06.PART_01.HEADING' |
    'TERMS.SECTION_06.PART_01.PART_A' |
    'TERMS.SECTION_06.PART_01.PART_B' |
    'TERMS.SECTION_06.PART_01.PART_C' |
    'TERMS.SECTION_06.PART_01.PART_D' |
    'TERMS.SECTION_06.PART_01.PART_E' |
    'TERMS.SECTION_06.PART_01.PART_F' |
    'TERMS.SECTION_06.PART_01.PART_G' |
    'TERMS.SECTION_06.PART_02.HEADING' |
    'TERMS.SECTION_07.HEADING' |
    'TERMS.SECTION_07.PART_01.HEADING' |
    'TERMS.SECTION_07.PART_01.PART_A' |
    'TERMS.SECTION_07.PART_01.PART_B' |
    'TERMS.SECTION_07.PART_02.HEADING' |
    'TERMS.SECTION_07.PART_03.HEADING' |
    'TERMS.SECTION_07.PART_04.HEADING' |
    'TERMS.SECTION_07.PART_04.PART_A' |
    'TERMS.SECTION_07.PART_04.PART_B' |
    'TERMS.SECTION_07.PART_05.HEADING' |
    'TERMS.SECTION_08.DESCRIPTION' |
    'TERMS.SECTION_08.HEADING' |
    'TERMS.SECTION_08.PART_A' |
    'TERMS.SECTION_08.PART_B' |
    'TERMS.SECTION_09.HEADING' |
    'TERMS.SECTION_09.PART_01' |
    'TERMS.SECTION_09.PART_02' |
    'TERMS.SECTION_10.HEADING' |
    'TERMS.SECTION_10.PART_A.HEADING' |
    'TERMS.SECTION_10.PART_A.PART_01' |
    'TERMS.SECTION_10.PART_A.PART_02' |
    'TERMS.SECTION_10.PART_A.PART_03' |
    'TERMS.SECTION_10.PART_A.PART_04' |
    'TERMS.SECTION_10.PART_A.PART_05' |
    'TERMS.SECTION_10.PART_B.HEADING' |
    'TERMS.SECTION_10.PART_B.PART_01' |
    'TERMS.SECTION_10.PART_B.PART_02' |
    'TERMS.SECTION_10.PART_B.PART_03' |
    'TERMS.SECTION_10.PART_B.PART_04' |
    'TERMS.SECTION_11.HEADING' |
    'TERMS.SECTION_11.PART_A.HEADING' |
    'TERMS.SECTION_11.PART_A.PART_01' |
    'TERMS.SECTION_11.PART_A.PART_02' |
    'TERMS.SECTION_11.PART_A.PART_03' |
    'TERMS.SECTION_11.PART_A.PART_04' |
    'TERMS.SECTION_11.PART_A.PART_05' |
    'TERMS.SECTION_11.PART_A.PART_06' |
    'TERMS.SECTION_11.PART_B.HEADING' |
    'TERMS.SECTION_12.HEADING' |
    'TERMS.SECTION_12.PART_01.HEADING' |
    'TERMS.SECTION_12.PART_01.PART_A' |
    'TERMS.SECTION_12.PART_01.PART_B' |
    'TERMS.SECTION_12.PART_02' |
    'TERMS.SECTION_12.PART_03' |
    'TERMS.SECTION_13.HEADING' |
    'TERMS.SECTION_13.PART_01' |
    'TERMS.SECTION_13.PART_02' |
    'TERMS.SECTION_14.DESCRIPTION' |
    'TERMS.SECTION_14.HEADING' |
    'TERMS.SECTION_15.HEADING' |
    'TERMS.SECTION_15.PART_01' |
    'TERMS.SECTION_15.PART_02.HEADING' |
    'TERMS.SECTION_15.PART_02.PART_A' |
    'TERMS.SECTION_15.PART_02.PART_B.HEADING' |
    'TERMS.SECTION_15.PART_02.PART_B.PART_01' |
    'TERMS.SECTION_15.PART_02.PART_B.PART_02' |
    'TERMS.SECTION_15.PART_02.PART_C' |
    'TERMS.SECTION_16.DESCRIPTION' |
    'TERMS.SECTION_16.HEADING' |
    'TERMS.SECTION_16.PART_01.HEADING' |
    'TERMS.SECTION_16.PART_01.PART_A' |
    'TERMS.SECTION_16.PART_01.PART_B' |
    'TERMS.SECTION_16.PART_01.PART_C' |
    'TERMS.SECTION_16.PART_01.PART_D.HEADING' |
    'TERMS.SECTION_16.PART_01.PART_D.PART_01' |
    'TERMS.SECTION_16.PART_01.PART_D.PART_02' |
    'TERMS.SECTION_16.PART_01.PART_D.PART_03' |
    'TERMS.SECTION_16.PART_01.PART_D.PART_04' |
    'TERMS.SECTION_16.PART_01.PART_D.PART_05' |
    'TERMS.SECTION_16.PART_01.PART_D.PART_06' |
    'TERMS.SECTION_16.PART_01.PART_D.PART_07' |
    'TERMS.SECTION_16.PART_01.PART_D.PART_08' |
    'TERMS.SECTION_16.PART_01.PART_D.PART_09' |
    'TERMS.SECTION_17.HEADING' |
    'TERMS.SECTION_17.PART_01.HEADING' |
    'TERMS.SECTION_17.PART_01.PART_A' |
    'TERMS.SECTION_17.PART_01.PART_B' |
    'TERMS.SECTION_17.PART_01.PART_C' |
    'TERMS.SECTION_17.PART_01.PART_D' |
    'TERMS.SECTION_17.PART_01.PART_E' |
    'TERMS.SECTION_17.PART_02.HEADING' |
    'TERMS.SECTION_17.PART_02.PART_A' |
    'TERMS.SECTION_17.PART_02.PART_B' |
    'TERMS.SECTION_17.PART_02.PART_C' |
    'TERMS.SECTION_17.PART_02.PART_D' |
    'TERMS.SECTION_17.PART_03.HEADING' |
    'TERMS.SECTION_17.PART_03.PART_A' |
    'TERMS.SECTION_17.PART_03.PART_B' |
    'TERMS.SECTION_18.DESCRIPTION' |
    'TERMS.SECTION_18.HEADING' |
    'TERMS.SECTION_19.HEADING' |
    'TERMS.SECTION_19.PART_A' |
    'TERMS.SECTION_19.PART_B' |
    'TERMS.SECTION_19.PART_C' |
    'TERMS.SECTION_19.PART_D' |
    'TERMS.SECTION_19.PART_E' |
    'TERMS.SECTION_19.PART_F' |
    'TERMS.SECTION_19.PART_G' |
    'TERMS.SECTION_19.PART_H' |
    'TIMEZONES.ADAK' |
    'TIMEZONES.ADELAIDE' |
    'TIMEZONES.ALMATY' |
    'TIMEZONES.AMMAN' |
    'TIMEZONES.ANCHORAGE' |
    'TIMEZONES.APIA' |
    'TIMEZONES.ARAGUAINA' |
    'TIMEZONES.ASTRAKHAN' |
    'TIMEZONES.ASUNCION' |
    'TIMEZONES.AUCKLAND' |
    'TIMEZONES.AZORES' |
    'TIMEZONES.BAGHDAD' |
    'TIMEZONES.BAHIA' |
    'TIMEZONES.BAKU' |
    'TIMEZONES.BANGKOK' |
    'TIMEZONES.BARNAUL' |
    'TIMEZONES.BEIRUT' |
    'TIMEZONES.BERLIN' |
    'TIMEZONES.BOGOTA' |
    'TIMEZONES.BOUGAINVILLE' |
    'TIMEZONES.BRISBANE' |
    'TIMEZONES.BUCHAREST' |
    'TIMEZONES.BUDAPEST' |
    'TIMEZONES.BUENOS_AIRES' |
    'TIMEZONES.CAIRO' |
    'TIMEZONES.CALCUTTA' |
    'TIMEZONES.CANCUN' |
    'TIMEZONES.CAPE_VERDE' |
    'TIMEZONES.CARACAS' |
    'TIMEZONES.CASABLANCA' |
    'TIMEZONES.CAYENNE' |
    'TIMEZONES.CHATHAM' |
    'TIMEZONES.CHICAGO' |
    'TIMEZONES.CHIHUAHUA' |
    'TIMEZONES.CHISINAU' |
    'TIMEZONES.CHITA' |
    'TIMEZONES.COLOMBO' |
    'TIMEZONES.CUIABA' |
    'TIMEZONES.DAMASCUS' |
    'TIMEZONES.DARWIN' |
    'TIMEZONES.DENVER' |
    'TIMEZONES.DHAKA' |
    'TIMEZONES.DUBAI' |
    'TIMEZONES.EASTER' |
    'TIMEZONES.EDMONTON' |
    'TIMEZONES.ENDERBURY' |
    'TIMEZONES.EUCLA' |
    'TIMEZONES.FIJI' |
    'TIMEZONES.GAMBIER' |
    'TIMEZONES.GODTHAB' |
    'TIMEZONES.GRAND_TURK' |
    'TIMEZONES.GUADALCANAL' |
    'TIMEZONES.GUATEMALA' |
    'TIMEZONES.HALIFAX' |
    'TIMEZONES.HAVANA' |
    'TIMEZONES.HEBRON' |
    'TIMEZONES.HOBART' |
    'TIMEZONES.HONOLULU' |
    'TIMEZONES.HOVD' |
    'TIMEZONES.HO_CHI_MINH' |
    'TIMEZONES.INDIANAPOLIS' |
    'TIMEZONES.IRKUTSK' |
    'TIMEZONES.ISTANBUL' |
    'TIMEZONES.JERUSALEM' |
    'TIMEZONES.JOHANNESBURG' |
    'TIMEZONES.JUBA' |
    'TIMEZONES.KABUL' |
    'TIMEZONES.KALININGRAD' |
    'TIMEZONES.KAMCHATKA' |
    'TIMEZONES.KARACHI' |
    'TIMEZONES.KATMANDU' |
    'TIMEZONES.KHARTOUM' |
    'TIMEZONES.KIEV' |
    'TIMEZONES.KIRITIMATI' |
    'TIMEZONES.KRASNOYARSK' |
    'TIMEZONES.KUALA_LUMPUR' |
    'TIMEZONES.LAGOS' |
    'TIMEZONES.LA_PAZ' |
    'TIMEZONES.LONDON' |
    'TIMEZONES.LORD_HOWE' |
    'TIMEZONES.LOS_ANGELES' |
    'TIMEZONES.MAGADAN' |
    'TIMEZONES.MANILA' |
    'TIMEZONES.MARQUESAS' |
    'TIMEZONES.MAURITIUS' |
    'TIMEZONES.MELBOURNE' |
    'TIMEZONES.MEXICO_CITY' |
    'TIMEZONES.MINSK' |
    'TIMEZONES.MIQUELON' |
    'TIMEZONES.MONTEVIDEO' |
    'TIMEZONES.MOSCOW' |
    'TIMEZONES.NAIROBI' |
    'TIMEZONES.NEWFOUNDLAND' |
    'TIMEZONES.NEW_YORK' |
    'TIMEZONES.NORFOLK' |
    'TIMEZONES.NORONHA' |
    'TIMEZONES.NOVOSIBIRSK' |
    'TIMEZONES.OMSK' |
    'TIMEZONES.PAGO_PAGO' |
    'TIMEZONES.PARIS' |
    'TIMEZONES.PERTH' |
    'TIMEZONES.PHOENIX' |
    'TIMEZONES.PITCAIRN' |
    'TIMEZONES.PORT_AU_PRINCE' |
    'TIMEZONES.PORT_MORESBY' |
    'TIMEZONES.PUNTA_ARENAS' |
    'TIMEZONES.PYONGYANG' |
    'TIMEZONES.QYZYLORDA' |
    'TIMEZONES.RANGOON' |
    'TIMEZONES.REGINA' |
    'TIMEZONES.REYKJAVIK' |
    'TIMEZONES.RIYADH' |
    'TIMEZONES.SAKHALIN' |
    'TIMEZONES.SAMARA' |
    'TIMEZONES.SANTIAGO' |
    'TIMEZONES.SAO_PAULO' |
    'TIMEZONES.SAO_TOME' |
    'TIMEZONES.SARATOV' |
    'TIMEZONES.SEOUL' |
    'TIMEZONES.SHANGHAI' |
    'TIMEZONES.SINGAPORE' |
    'TIMEZONES.SREDNEKOLYMSK' |
    'TIMEZONES.ST_JOHNS' |
    'TIMEZONES.SYDNEY' |
    'TIMEZONES.TAIPEI' |
    'TIMEZONES.TARAWA' |
    'TIMEZONES.TASHKENT' |
    'TIMEZONES.TBILISI' |
    'TIMEZONES.TEHRAN' |
    'TIMEZONES.TIJUANA' |
    'TIMEZONES.TOKYO' |
    'TIMEZONES.TOMSK' |
    'TIMEZONES.TONGATAPU' |
    'TIMEZONES.TORONTO' |
    'TIMEZONES.TRIPOLI' |
    'TIMEZONES.ULAANBAATAR' |
    'TIMEZONES.VANCOUVER' |
    'TIMEZONES.VLADIVOSTOK' |
    'TIMEZONES.VOLGOGRAD' |
    'TIMEZONES.WARSAW' |
    'TIMEZONES.WHITEHORSE' |
    'TIMEZONES.WINDHOEK' |
    'TIMEZONES.WINNIPEG' |
    'TIMEZONES.YAKUTSK' |
    'TIMEZONES.YEKATERINBURG' |
    'TIMEZONES.YEREVAN' |
    'USER.BULK_DELETE_MODAL.CONFIRM_TEXT' |
    'USER.BULK_DELETE_MODAL.HAS_ERRORS_MESSAGE' |
    'USER.BULK_DELETE_MODAL.MESSAGE' |
    'USER.BULK_DELETE_MODAL.MESSAGE_plural' |
    'USER.BULK_DELETE_MODAL.SUBMIT_BUTTON' |
    'USER.BULK_DELETE_MODAL.SUBMIT_BUTTON_plural' |
    'USER.BULK_DELETE_MODAL.TITLE' |
    'USER.BULK_DELETE_MODAL.TITLE_plural' |
    'USER.BULK_DELETE_MODAL.TOASTS.ERROR' |
    'USER.BULK_DELETE_MODAL.TOASTS.SUCCESS' |
    'USER.BULK_RESET_PASSWORDS_MODAL.BUTTON_SEND_BOTH' |
    'USER.BULK_RESET_PASSWORDS_MODAL.BUTTON_SEND_PASSWORD_RESETS' |
    'USER.BULK_RESET_PASSWORDS_MODAL.BUTTON_SEND_USER_INVITES' |
    'USER.BULK_RESET_PASSWORDS_MODAL.CONFIRM_RESEND_INVITE' |
    'USER.BULK_RESET_PASSWORDS_MODAL.CONFIRM_SEND_PASSWORD_RESET' |
    'USER.BULK_RESET_PASSWORDS_MODAL.DESCRIPTION' |
    'USER.BULK_RESET_PASSWORDS_MODAL.FETCH_USER_ERROR_MESSAGE' |
    'USER.BULK_RESET_PASSWORDS_MODAL.NOTIFY_PARTIAL_ERROR' |
    'USER.BULK_RESET_PASSWORDS_MODAL.NOTIFY_SEND_BOTH_SUCCESS' |
    'USER.BULK_RESET_PASSWORDS_MODAL.NOTIFY_SEND_PASSWORD_RESETS_SUCCESS' |
    'USER.BULK_RESET_PASSWORDS_MODAL.NOTIFY_SEND_USER_INVITES_SUCCESS' |
    'USER.BULK_RESET_PASSWORDS_MODAL.RESEND_USER_INVITES_TITLE' |
    'USER.BULK_RESET_PASSWORDS_MODAL.TITLE' |
    'USER.BULK_RESET_PASSWORDS_MODAL.USERS_WITHOUT_ACCEPTED_INVITE_MESSAGE' |
    'USER.BULK_UPDATE_LOCATIONS_MODAL.ADD_LOCATIONS_COUNT_TEXT' |
    'USER.BULK_UPDATE_LOCATIONS_MODAL.ADD_LOCATIONS_COUNT_TOOLTIP' |
    'USER.BULK_UPDATE_LOCATIONS_MODAL.CONFIRM_TEXT' |
    'USER.BULK_UPDATE_LOCATIONS_MODAL.CONFIRM_TITLE' |
    'USER.BULK_UPDATE_LOCATIONS_MODAL.HAS_ERRORS_MESSAGE' |
    'USER.BULK_UPDATE_LOCATIONS_MODAL.MESSAGE' |
    'USER.BULK_UPDATE_LOCATIONS_MODAL.REMOVE_LOCATIONS_COUNT_TEXT' |
    'USER.BULK_UPDATE_LOCATIONS_MODAL.REMOVE_LOCATIONS_COUNT_TOOLTIP' |
    'USER.BULK_UPDATE_LOCATIONS_MODAL.SUBMIT_BUTTON' |
    'USER.BULK_UPDATE_LOCATIONS_MODAL.TITLE' |
    'USER.BULK_UPDATE_LOCATIONS_MODAL.TOASTS.ERROR' |
    'USER.BULK_UPDATE_LOCATIONS_MODAL.TOASTS.SUCCESS' |
    'USER.BULK_UPDATE_ROLES_MODAL.ADD_ROLES_COUNT_TEXT' |
    'USER.BULK_UPDATE_ROLES_MODAL.ADD_ROLES_COUNT_TEXT_plural' |
    'USER.BULK_UPDATE_ROLES_MODAL.ADD_ROLES_COUNT_TOOLTIP' |
    'USER.BULK_UPDATE_ROLES_MODAL.ADD_ROLES_COUNT_TOOLTIP_plural' |
    'USER.BULK_UPDATE_ROLES_MODAL.CONFIRM_TEXT' |
    'USER.BULK_UPDATE_ROLES_MODAL.CONFIRM_TITLE' |
    'USER.BULK_UPDATE_ROLES_MODAL.EXISTING_TITLE' |
    'USER.BULK_UPDATE_ROLES_MODAL.HAS_ERRORS_MESSAGE' |
    'USER.BULK_UPDATE_ROLES_MODAL.MESSAGE' |
    'USER.BULK_UPDATE_ROLES_MODAL.NEW_ROLE_TOOLTIP' |
    'USER.BULK_UPDATE_ROLES_MODAL.NEW_TITLE' |
    'USER.BULK_UPDATE_ROLES_MODAL.PARTIAL_EXISTING_ROLE_TOOLTIP' |
    'USER.BULK_UPDATE_ROLES_MODAL.REMOVED_TITLE' |
    'USER.BULK_UPDATE_ROLES_MODAL.REMOVE_ROLES_COUNT_TEXT' |
    'USER.BULK_UPDATE_ROLES_MODAL.REMOVE_ROLES_COUNT_TEXT_plural' |
    'USER.BULK_UPDATE_ROLES_MODAL.REMOVE_ROLES_COUNT_TOOLTIP' |
    'USER.BULK_UPDATE_ROLES_MODAL.REMOVE_ROLES_COUNT_TOOLTIP_plural' |
    'USER.BULK_UPDATE_ROLES_MODAL.ROLE_LIST_TITLE' |
    'USER.BULK_UPDATE_ROLES_MODAL.SELECTED_ROLES_LIST_TITLE' |
    'USER.BULK_UPDATE_ROLES_MODAL.SUBMIT_BUTTON' |
    'USER.BULK_UPDATE_ROLES_MODAL.TITLE' |
    'USER.BULK_UPDATE_ROLES_MODAL.TOASTS.ERROR' |
    'USER.BULK_UPDATE_ROLES_MODAL.TOASTS.SUCCESS' |
    'USER.EDIT_USER_DETAILS.ADD_NOTIFICATIONS' |
    'USER.EDIT_USER_DETAILS.ADD_ROLE' |
    'USER.EDIT_USER_DETAILS.CONFIRM_DELETE_USER' |
    'USER.EDIT_USER_DETAILS.HEADERS.ASSIGNED_LOCATIONS' |
    'USER.EDIT_USER_DETAILS.HEADERS.GUIDED_TOUR' |
    'USER.EDIT_USER_DETAILS.HEADERS.NOTIFICATIONS' |
    'USER.EDIT_USER_DETAILS.HEADERS.ROLES' |
    'USER.EDIT_USER_DETAILS.HEADERS.USER_DETAILS' |
    'USER.EDIT_USER_DETAILS.NOTIFY_DELETE_USER_SUCCESS' |
    'USER.EDIT_USER_DETAILS.NOTIFY_SEND_PASSWORD_RESET_SUCCESS' |
    'USER.EDIT_USER_DETAILS.NOTIFY_UPDATE_USER_DETAILS_SUCCESS' |
    'USER.EDIT_USER_DETAILS.SAVE_ASSIGNED_LOCATIONS' |
    'USER.EDIT_USER_DETAILS.SAVE_USER_DETAILS' |
    'USER.EDIT_USER_DETAILS.SELECT_OPTIONS.DELETE_USER' |
    'USER.EDIT_USER_DETAILS.SELECT_OPTIONS.PLACEHOLDER' |
    'USER.EDIT_USER_DETAILS.SELECT_OPTIONS.SEND_PASSWORD_RESET_EMAIL' |
    'USER.USERS_LOCATIONS_BOX.EXISTING_LOCATIONS_TITLE' |
    'USER.USERS_LOCATIONS_BOX.NEW_LOCATIONS_TITLE' |
    'USER.USERS_LOCATIONS_BOX.REMOVED_LOCATIONS_TITLE' |
    'USER.USERS_LOCATIONS_BOX.RIGHT_TITLE';

export type GetSegmentKeyFunction = (keys: SegmentKeys) => SegmentKey;

export default KEYS;
